var CustomDataChart_WSJ_0_8_28 =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(140);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(168)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAX_4U_WIDTH = exports.MAX_4U_WIDTH = 359;
	var MAX_NARROW_WIDTH_PRINT = exports.MAX_NARROW_WIDTH_PRINT = 114;
	
	var LONG = exports.LONG = 'long';
	var SHORT = exports.SHORT = 'short';
	
	var REGEXP_QUARTER = exports.REGEXP_QUARTER = /^([1-4]Q|[1-2]H)?\s*(FY)?['|\u2019]?(\d{2,4})/i;
	var REGEXP_Q_ONLY = exports.REGEXP_Q_ONLY = /^([1-4]Q|[1-2]H)/i;
	
	var REGEXP_MDY = exports.REGEXP_MDY = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\b/;
	var REGEXP_MDY_FRED = exports.REGEXP_MDY_FRED = /^(\d{4})-(\d{2})-(\d{2})\b/;
	var REGEXP_MD = exports.REGEXP_MD = /^(\d{1,2})\/(\d{1,2})\b/;
	var REGEXP_MY = exports.REGEXP_MY = /^(\d{1,2})\/(\d{3,4})\b/;
	var REGEXP_Y = exports.REGEXP_Y = /^(\d{4})\b/;
	var REGEXP_TIME = exports.REGEXP_TIME = /\b(\d{1,2}):(\d{1,2})(:\d{1,2})?(\s?[a|p]\.+m\.+?)?(\s[a-z]{2,3})?$/i;
	
	var MONTHS = exports.MONTHS = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
	var MONTHS_SHORT = exports.MONTHS_SHORT = 'JFMAMJJASOND';
	
	var CATEGORY = exports.CATEGORY = /\{category\}/g;
	var SERIES = exports.SERIES = /\{series\}/g;
	var VALUE = exports.VALUE = /\{value\}/g;
	var POINT = exports.POINT = /\{point\}/g;
	
	// Because &nbsp; does not work inside SVG.
	var NBSP = exports.NBSP = '<span style="color: rgba(255,255,255,0);" class="space">.</span>';
	
	var APOSTROPHE = exports.APOSTROPHE = '’';
	
	var TRANSPARENT = exports.TRANSPARENT = 'rgba(0, 0, 0, 0)';
	
	var ANNOTATIONS_SPACE = exports.ANNOTATIONS_SPACE = 4;
	var ANNOTATIONS_SPACE_PRINT = exports.ANNOTATIONS_SPACE_PRINT = 2;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeChild = removeChild;
	exports.boldText = boldText;
	exports.replaceLineBreaks = replaceLineBreaks;
	function removeChild(el, parentEl) {
	  parentEl = parentEl || el.parentElement;
	  if (parentEl) {
	    parentEl.removeChild(el);
	  }
	}
	
	function boldText() {
	  var bold = false;
	  return function (str, openTag, closeTag) {
	    var startIdx = 0;
	    var asteriskIdx = void 0;
	    var newStr = bold ? openTag : '';
	    while ((asteriskIdx = str.indexOf('**', startIdx)) !== -1) {
	      newStr += str.substring(startIdx, asteriskIdx) + (bold ? closeTag : openTag);
	      bold = !bold;
	      startIdx = asteriskIdx + 2;
	    }
	    return newStr + str.substring(startIdx) + (bold ? closeTag : '');
	  };
	}
	
	function replaceLineBreaks(text) {
	  return text.replace(/[\n|\r|↵]/g, '<br>');
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.decimals = decimals;
	exports.commas = commas;
	exports.getDivisor = getDivisor;
	exports.applyFull = applyFull;
	function decimals(value, props) {
	  var skipZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var fd = getMaxDecimalValue(props.forceDecimals);
	  var md = getMaxDecimalValue(props.maxDecimals);
	  value = +value;
	  if (fd > -1) {
	    value = value.toFixed(fd);
	    if (md > -1 && md < fd) {
	      var fDotIndex = value.indexOf('.');
	      value = (+value).toFixed(md);
	    }
	    return value;
	  } else if (md > -1) {
	    value = (+value).toFixed(md);
	    while (value.substring(value.length - 1) === '0') {
	      value = value.substr(0, value.length - 1);
	      if (value.substring(value.length - 1) === '.') {
	        value = value.substr(0, value.length - 1);
	        break;
	      }
	    }
	  }
	  return value.toString();
	}
	
	function getMaxDecimalValue(value) {
	  if (typeof value === 'string' && value) {
	    return +value;
	  } else if (typeof value === 'number' && !isNaN(value)) {
	    return value;
	  }
	  return -1;
	}
	
	function applyMaxDecimals(value, md) {
	  var dotIndex = value.indexOf('.');
	  if (dotIndex !== -1) {
	    var decs = value.length - dotIndex - 1;
	    value = (+value).toFixed(md);
	  }
	  return value;
	}
	
	function commas(value) {
	  var commas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  value += '';
	  if (commas) {
	    var dotIndex = value.indexOf('.');
	    if (dotIndex === -1) {
	      dotIndex = value.length;
	    }
	    value = [value.substr(0, dotIndex).replace(/\B(?=(\d{3})+(?!\d))/g, ','), value.substr(dotIndex)].join('');
	  }
	  return value;
	}
	
	// Returns a useful number that corresponds to a divisor string.
	function getDivisor(unit) {
	  switch (unit) {
	    case 'hundreds':
	      return 100;
	    case 'thousands':
	      return 1000;
	    case 'millions':
	      return 1000000;
	    case 'billions':
	      return 1000000000;
	    case 'trillions':
	      return 1000000000000;
	  }
	  return 1;
	}
	
	function applyFull(value, props) {
	  var isPie = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var skipZero = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var tooltipOrAnnotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var newProps = Object.assign({}, props);
	  if (tooltipOrAnnotation) {
	    var splitDecimals = value.toString().split('.');
	    splitDecimals = splitDecimals.length > 1 ? splitDecimals[1].length : 0;
	    if (Number(splitDecimals) >= 3 && newProps.prefix === '') {
	      newProps.forceDecimals = '3';
	    }
	    if (newProps.prefix !== '') {
	      newProps.forceDecimals = splitDecimals > 0 ? '2' : '0';
	    } else {
	      newProps.forceDecimals = splitDecimals;
	    }
	    newProps.maxDecimals = '3';
	  }
	  value = decimals(value, newProps);
	  value = commas(value, newProps.commas);
	  if (isPie) {
	    value += '%';
	  } else {
	    if (value.charAt(0) === '-') {
	      value = newProps.prefix !== undefined ? '-' + newProps.prefix + value.substr(1) : '' + value.substr(1);
	    } else {
	      value = newProps.prefix !== undefined ? '' + newProps.prefix + value : '' + value;
	    }
	    value += newProps.suffix;
	  }
	  return value;
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.read = read;
	exports.write = write;
	var regExpD = /(M|L|(\-?\d+\.?\d*))/gi;
	var regExpTranslate = /(.*)(translate\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;
	var regExpScale = /(.*)(scale\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;
	
	function read(el, prop, value) {
	  var match = null;
	  switch (prop) {
	    case 'd':
	      match = (value || getD(el)).match(regExpD);
	      return match ? formatDMatch(match) : null;
	    case 'translate':
	      match = (value || getTransform(el)).match(regExpTranslate);
	      return match ? [+match[3], +match[4]] : null;
	    case 'scale':
	      match = (value || getTransform(el)).match(regExpScale);
	      return match ? [+match[3], +match[4]] : null;
	    default:
	      return el;
	  }
	}
	
	function write(el, prop) {
	  switch (prop) {
	    case 'd':
	      writeD.apply(this, arguments);
	      break;
	    case 'translate':
	      writeTranslate.apply(this, arguments);
	      break;
	    case 'scale':
	      writeScale.apply(this, arguments);
	      break;
	  }
	  return el;
	}
	
	function writeD(el) {
	  var d = [];
	  for (var i = 2; i < arguments.length; i++) {
	    d.push(i === 2 ? 'M' : 'L');
	    d.push(arguments[i][0]);
	    d.push(arguments[i][1]);
	  }
	  el.setAttribute('d', d.join(' '));
	}
	
	function writeTranslate(el) {
	  var oldTransform = el.getAttribute('transform');
	  var newTransform = null;
	  var match = oldTransform ? oldTransform.match(regExpTranslate) : null;
	  if (match) {
	    newTransform = [match[1], match[2], Math.round(typeof arguments[2] === 'number' ? arguments[2] : +match[3]), ',', Math.round(typeof arguments[3] === 'number' ? arguments[3] : +match[4]), match[5]].join('');
	  } else {
	    newTransform = [oldTransform ? oldTransform + ' ' : '', 'translate(', Math.round(typeof arguments[2] === 'number' ? arguments[2] : 0), ',', Math.round(typeof arguments[3] === 'number' ? arguments[3] : 0), ')'].join('');
	  }
	  setTimeout(function () {
	    // Firefox bug(?). This was not setting without this timeout.
	    el.setAttribute('transform', newTransform);
	  }, 1);
	  el.setAttribute('transform', newTransform);
	}
	
	function writeScale(el) {
	  var oldTransform = el.getAttribute('transform');
	  var newTransform = null;
	  var match = oldTransform ? oldTransform.match(regExpScale) : null;
	  if (match) {
	    newTransform = [match[1], match[2], typeof arguments[2] === 'number' ? arguments[2] : match[3], ',', typeof arguments[3] === 'number' ? arguments[3] : match[4], match[5]].join('');
	  } else {
	    newTransform = [oldTransform ? oldTransform + ' ' : '', 'scale(', typeof arguments[2] === 'number' ? arguments[2] : 0, ',', typeof arguments[3] === 'number' ? arguments[3] : 0, ')'].join('');
	  }
	  el.setAttribute('transform', newTransform);
	}
	
	function formatDMatch(match) {
	  var points = [];
	  var pt = [];
	  match.forEach(function (m) {
	    if (m !== 'M' && m !== 'L') {
	      pt.push(+m);
	      if (pt.length >= 2) {
	        points.push([pt[0], pt[1]]);
	        pt = [];
	      }
	    }
	  });
	  return points;
	}
	
	function getD(el) {
	  return el.getAttribute('d') || '';
	}
	
	function getTransform(el) {
	  return el.getAttribute('transform') || '';
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripZeroes = stripZeroes;
	exports.addZeroes = addZeroes;
	// Utility to transform '002' to '2'.
	function stripZeroes(value) {
	  value += '';
	  while (value[0] === '0') {
	    value = value.substr(1);
	  }
	  return value;
	}
	
	// Utility to transform '2' to '002'.
	function addZeroes(value, len) {
	  value += '';
	  while (value.length > len) {
	    if (value.charAt(0) === '0') {
	      value = value.substr(1);
	    } else {
	      break;
	    }
	  }
	  while (value.length < len) {
	    value = '0' + value;
	  }
	  return value;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderInvalidatedColors = renderInvalidatedColors;
	// TODO: Check if this can be re-enabled with newer version of Highcharts.
	function renderInvalidatedColors(rendered, invalidated) {
	  // This is no longer applied because of issues with hover states not being
	  // updated. Instead, on color change, entire chart is re-rendered.
	  if (false) {
	    // const colors = (function (invalidated) {
	    //   return invalidated.filter(item => {
	    //     return item.indexOf('chart/colors') === 0;
	    //   });
	    // })(invalidated);
	    //
	    // const updatePointColor = function (dataPoint, color) {
	    //   const el = (dataPoint && dataPoint.graphic) ? dataPoint.graphic.element : null;
	    //   if (el) {
	    //     el.setAttribute('fill', color);
	    //   }
	    // };
	    //
	    // const updateLegendColor = function (render, index, color) {
	    //   const items = render.container.querySelectorAll('.highcharts-legend-item');
	    //   if (items && items.length) {
	    //     const text = items[index].querySelector('text');
	    //     text.style.color = text.style.fill = color;
	    //   }
	    // }
	    //
	    // if (colors.length) {
	    //   colors.forEach(item => {
	    //     const bits = item.split('/');
	    //     const series = +bits[2];
	    //     const point = bits[3];
	    //     const color = bits[4];
	    //     const chartSeries = rendered.inner.series[series];
	    //     let dataPoint = null;
	    //     let el = null;
	    //
	    //     if (chartSeries) {
	    //       // if (point.indexOf('#') === 0) {
	    //         // updateLegendColor(rendered.inner, series, point);
	    //         // Color for entire series.
	    //         // chartSeries.color = point;
	    //         // Setting render to true re-renders *everything* while false makes
	    //         // the lines and legend vanish (if it supposedly does not re-render,
	    //         // then like wtf?).
	    //         // chartSeries.update({ color: point }, true);
	    //
	    //       if (chartSeries.graph) {
	    //         // Line charts.
	    //         chartSeries.graph.element.setAttribute('stroke', color);
	    //       } else {
	    //         // Bar, column, pie charts.
	    //         if (point === '*') {
	    //           chartSeries.data.forEach(dataPoint => {
	    //             updatePointColor(dataPoint, color);
	    //           });
	    //         } else {
	    //           //originalIndex
	    //           let ptIndex = +point;
	    //           if (rendered.inner.options.chart.type === 'pie') {
	    //             // Find the correct index if the data has been optimized.
	    //             for (let i = 0; i < chartSeries.data.length; i++) {
	    //               if (!chartSeries.data[i].hasOwnProperty('originalIndex')) {
	    //                 break;
	    //               }
	    //               if (chartSeries.data[i].originalIndex === ptIndex) {
	    //                 ptIndex = i;
	    //                 break;
	    //               }
	    //             }
	    //           }
	    //           dataPoint = chartSeries ? chartSeries.data[ptIndex] : null;
	    //           updatePointColor(dataPoint, color);
	    //         }
	    //       }
	    //     }
	    //   });
	    // }
	  }
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zero = __webpack_require__(6);
	
	var _constants = __webpack_require__(2);
	
	var _dateutils = __webpack_require__(11);
	
	var _quarterly = __webpack_require__(139);
	
	var quarterly = _interopRequireWildcard(_quarterly);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// let DEBUG = false;
	
	/**
	 * Converts/parses an array of category strings into objects with date and
	 * time properties.
	 * TODO: explains @params
	 * @returns {datetimeTemplate[]}
	 */
	function parse(categories, options) {
	  var dates = [];
	  var timezone = null;
	  var category0 = categories[0] + '';
	  var isQuarterlyString = !!category0.match(_constants.REGEXP_Q_ONLY);
	  categories.forEach(function (category, index) {
	    dates[index] = components(category, timezone, options, isQuarterlyString);
	    timezone = dates[index].z;
	  });
	
	  if (options) {
	    dates = options.fiscalYears ? quarterly.makeFiscalYears(dates) : quarterly.removeFiscalYears(dates);
	    dates = options.quarterlyResults ? quarterly.makeQuarterly(dates) : quarterly.removeQuarterly(dates);
	  }
	
	  dates = quarterly.normalize(dates);
	  dates = generateValues(dates);
	  // dates = sortDates(dates);
	  dates = removeExtraneousComponents(dates);
	  return dates;
	}
	
	/**
	 * Breaks a single category value into an object with date/time components.
	 */
	/**
	 * Datetime is a module with methods that parse date strings into discrete
	 * components (years, months, hours, etc).
	 * TODO: Write unit tests.
	 */
	function components(value, timezone, options, isQuarterlyString) {
	  value += '';
	  var result = datetimeTemplate();
	  result = componentsDate(value, result, options, isQuarterlyString);
	  result = componentsTime(value, result, timezone);
	  if (!result.hour) {
	    var newDate = new Date(result.year, result.month, result.date, 0, 0, 0, 0).getTime();
	    result.value = newDate;
	  }
	  // const milliseconds = new Date(value).getTime();
	  // result.value = milliseconds;
	  // console.log(result, value)
	  return result;
	}
	
	/**
	 * @private
	 * For use with components().
	 */
	function componentsDate(value, result, options) {
	  var isQuarterlyString = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var match = null;
	  if (isQuarterlyString) {
	    match = value.match(_constants.REGEXP_QUARTER);
	    match = match || value.match(_constants.REGEXP_Q_ONLY) || [];
	    result.quarter = (0, _dateutils.getQuarter)(match[1]);
	    result.half = (0, _dateutils.getHalf)(match[1]);
	    result.month = (0, _dateutils.quarterToMonth)(match[1]);
	    result.date = (0, _dateutils.quarterToDate)(result.month);
	    result.fiscalYear = !!match[2];
	    result.year = match[3] ? +match[3] : undefined;
	  } else if (match = value.match(_constants.REGEXP_MDY)) {
	    writeDateMonth(result, match, options.reverseDateMonth);
	    result.year = +(0, _dateutils.fullYear)(match[3]);
	  } else if (match = value.match(_constants.REGEXP_MDY_FRED)) {
	    result.year = +match[1];
	    result.month = Math.max(0, +match[2] - 1);
	    result.date = +match[3];
	  } else if (match = value.match(_constants.REGEXP_MD)) {
	    writeDateMonth(result, match, options.reverseDateMonth);
	  } else if (match = value.match(_constants.REGEXP_MY)) {
	    result.month = +match[1] - 1;
	    result.year = +(0, _dateutils.fullYear)(match[2]);
	  } else if (match = value.match(_constants.REGEXP_Y)) {
	    result.year = +(0, _dateutils.fullYear)(match[1]);
	  }
	  return result;
	}
	
	function writeDateMonth(result, match, reverseDateMonth) {
	  if (reverseDateMonth) {
	    result.month = +match[2] - 1;
	    result.date = +match[1];
	  } else {
	    result.month = +match[1] - 1;
	    result.date = +match[2];
	  }
	}
	
	/**
	 * @private
	 * For use with components().
	 */
	function componentsTime(value, result) {
	  var timezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	  var match = value.match(_constants.REGEXP_TIME);
	  if (match) {
	    // Capture time values.
	    result.hour = +match[1];
	    result.minute = +match[2];
	    result.second = match[3] ? +match[3].substr(1) : undefined;
	    result.a = match[4] ? match[4].replace(/^\s+/, '').substr(0, 1).toLowerCase() : undefined;
	    result.z = match[5] ? match[5].substr(1) : timezone;
	    // Convert to 24-hour clock.
	    if (!result.a) {
	      result.a = result.hour < 12 ? 'a' : 'p';
	    }
	    result.hour %= 12;
	    if (result.a === 'p') {
	      result.hour += 12;
	    }
	  }
	  return result;
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @param {string} prop
	 * @return {boolean} true if all dates have a value for prop.
	 */
	function allHave(dates, prop) {
	  return dates.length !== 0 && !dates.some(function (date) {
	    return prop === 'fiscalYear' && !date.fiscalYear || date[prop] === undefined;
	  });
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @returns {boolea} true if all date objects represent valid dates.
	 */
	function allValidDates(dates) {
	  return !dates.some(function (d) {
	    return d.second === undefined && d.minute === undefined && d.hour === undefined && d.date === undefined && d.month === undefined && d.year === undefined;
	  });
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @returns {object} with true/false for each date/time property depending
	 *   on whether all dates have a value for each property.
	 */
	function all(dates) {
	  var obj = datetimeTemplate();
	  Object.keys(obj).forEach(function (key) {
	    obj[key] = allHave(dates, key);
	  });
	  return obj;
	}
	
	/**
	 * @param {datetimeTemplate[]} dates
	 * @returns {boolean} true if all dates have a value for `quarter` or `half`.
	 */
	function allQuarterly(dates) {
	  return dates.every(function (item) {
	    return item.quarter || item.half;
	  });
	}
	
	/**
	 * @returns {object} with keys for all the properties useful in the charts
	 *   tool, each set to undefined or false.
	 */
	function datetimeTemplate() {
	  return {
	    z: undefined,
	    a: undefined,
	    second: undefined,
	    minute: undefined,
	    hour: undefined,
	    date: undefined,
	    month: undefined,
	    year: undefined,
	    value: undefined,
	    fiscalYear: false,
	    quarter: undefined,
	    half: undefined
	  };
	}
	
	/**
	 * Remove values that repeat for all dates and therefore are superfluous.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
	 *    unaltered.
	 */
	function removeExtraneousComponents(dates) {
	  var common = all(dates);
	  if (common.month && common.date) {
	    // && !common.year) {
	    dates = removeExtraneous(dates, 'date');
	  }
	  if (common.month && common.year) {
	    dates = removeExtraneousMD(dates);
	  }
	  if (common.hour && common.minute) {
	    dates = removeExtraneous(dates, 'minute');
	  }
	  if (common.minute && common.second) {
	    dates = removeExtraneous(dates, 'seconds');
	  }
	  return dates;
	}
	
	/**
	 * Often dates are in the format Jan 1 YYYY, where Jan 1 repeats for *all*
	 * rows but the years increment. In this special case, the month and date
	 * should be disregarded. Also works if months but no dates are specificed;
	 * e.g. 1/2000, 1/2001, etc.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
	 *    unaltered.
	 */
	function removeExtraneousMD(dates) {
	  var datesCopy = [];
	  var month = undefined;
	  var date = undefined;
	  var year = undefined;
	  for (var i = 0; i < dates.length; i++) {
	    var d = (0, _lodash2.default)({}, dates[i]);
	    if (i === 0) {
	      month = d.month;
	      date = d.date;
	      year = d.year;
	    } else if (d.month !== month || d.date !== date) {
	      return dates;
	    } else if (d.year <= year) {
	      return dates;
	    }
	    year = d.year;
	    d.month = d.date = undefined;
	    datesCopy[i] = d;
	  }
	  return datesCopy;
	}
	
	/**
	 * Removes values (such as seconds, minutes, or dates) when the values are the
	 * same for each and every date.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
	 *    unaltered.
	 */
	function removeExtraneous(dates, prop) {
	  var datesCopy = [];
	  var propVal = undefined;
	  var value = undefined;
	  var genericVal = (0, _dateutils.genericTimeValue)(prop);
	  for (var i = 0; i < dates.length; i++) {
	    var d = (0, _lodash2.default)({}, dates[i]);
	    if (i === 0) {
	      // Set initial values to compare to.
	      propVal = d[prop];
	      value = d.value;
	    } else if (Math.abs(d.value - value) < genericVal) {
	      // Values do not increment.
	      return dates;
	    } else if (d[prop] !== propVal) {
	      // Values are not all the same and therefor not extraneous.
	      return dates;
	    }
	    value = d.value;
	    d[prop] = undefined;
	    datesCopy[i] = d;
	  }
	  return datesCopy;
	}
	
	/**
	 * Sets a value in milliseconds for each datetime object.
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]}
	 */
	function generateValues(dates) {
	  dates.forEach(function (date) {
	    date.value = getValue(date);
	  });
	  return dates;
	}
	
	/**
	 * @private
	 * @param {datetimeTemplate}
	 * @returns {number} value in milliseconds
	 */
	function getValue(date) {
	  var d = new Date(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0);
	
	  if (isDef(date.year) && isDef(date.month) && isDef(date.date)) {
	    d.setUTCFullYear(date.year, date.month, date.date);
	  } else if (isDef(date.year) && isDef(date.month)) {
	    d.setUTCFullYear(date.year, date.month);
	  } else if (isDef(date.year)) {
	    d.setUTCFullYear(date.year, 0);
	  } else if (isDef(date.month) && isDef(date.date)) {
	    d.setUTCMonth(date.month, date.date);
	  } else if (isDef(date.month)) {
	    d.setUTCMonth(date.month);
	  } else if (isDef(date.date)) {
	    d.setUTCDate(date.date);
	  }
	
	  if (isDef(date.hour) && isDef(date.minute) && isDef(date.second)) {
	    d.setUTCHours(date.hour, date.minute, date.second);
	  } else if (isDef(date.hour) && isDef(date.minute)) {
	    d.setUTCHours(date.hour, date.minute);
	  } else if (isDef(date.hour)) {
	    d.setUTCHours(date.hour);
	  } else if (isDef(date.minute) && isDef(date.second)) {
	    d.setUTCMinutes(date.minute, date.second);
	  } else if (isDef(date.minute)) {
	    d.setUTCMinutes(date.minute);
	  } else if (isDef(date.second)) {
	    d.setUTCSeconds(date.second);
	  } else {
	    d.setUTCHours(0, 0, 0);
	  }
	
	  return d.valueOf();
	}
	
	function isDef(value) {
	  return value !== undefined;
	}
	
	/**
	 * @private
	 * @param {datetimeTemplate[]} dates
	 * @returns {datetimeTemplate[]} dates sorted by value
	 */
	// function sortDates(dates) {
	//   return dates.sort((a, b) => {
	//     if (a.value === undefined || b.value === undefined) {
	//       return 0;
	//     }
	//     return a.value - b.value;
	//   });
	// }
	
	
	// Not used in this module but is used by the app/client.
	// @returns {boolean} true is @param str is a quartlery date value.
	function isQuarterlyString(str) {
	  return _constants.REGEXP_Q_ONLY.test(str);
	}
	
	exports.default = {
	  parse: parse,
	  components: components,
	  allHave: allHave,
	  all: all,
	  allQuarterly: allQuarterly,
	  stripZeroes: _zero.stripZeroes,
	  addZeroes: _zero.addZeroes,
	  allValidDates: allValidDates,
	  datetimeTemplate: datetimeTemplate,
	  isQuarterlyString: isQuarterlyString
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isVerticalType = isVerticalType;
	exports.forAxisTicks = forAxisTicks;
	exports.forAxisTicksReverse = forAxisTicksReverse;
	// Returns true if the chart type has axes in the style of a column chart.
	function isVerticalType(type) {
	  return type === 'line' || type === 'column' || type === 'area';
	}
	
	// Convenience utility function for looping through the ticks on an axis,
	// which is necessary a million times in this module.
	function forAxisTicks(axis, callback) {
	  for (var i = 0; i < axis.tickPositions.length; i++) {
	    var tick = axis.ticks[axis.tickPositions[i]];
	    if (callback(tick, axis.tickPositions[i], i) === false) {
	      break;
	    }
	  }
	}
	
	// Like forAxisTicks() but runs in reverse (index high to low).
	function forAxisTicksReverse(axis, callback) {
	  for (var i = axis.tickPositions.length - 1; i >= 0; i--) {
	    var tick = axis.ticks[axis.tickPositions[i]];
	    if (callback(tick, axis.tickPositions[i], i) === false) {
	      break;
	    }
	  }
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullYear = fullYear;
	exports.abbrYear = abbrYear;
	exports.isSameCentury = isSameCentury;
	exports.getQuarter = getQuarter;
	exports.getHalf = getHalf;
	exports.quarterToMonth = quarterToMonth;
	exports.quarterToDate = quarterToDate;
	exports.genericTimeValue = genericTimeValue;
	
	var _zero = __webpack_require__(6);
	
	/**
	 * Transform a partial year value (84) into a full year value (1984)
	 * according to a formula agreed upon at WSJ.
	 * @param {number|string} value
	 * @returns {number}
	 */
	
	function fullYear(value) {
	  value = +value;
	  if (value < 100) {
	    if (value + 2000 > new Date().getUTCFullYear() + 15) {
	      value += 1900;
	    } else {
	      value += 2000;
	    }
	  }
	  return value;
	}
	
	/**
	 * Transforms a year value into 2-digit number: 1984 to 84.
	 * @param {number|string} value
	 * @returns {string} of length 2
	 */
	/**
	 * Bring addZeroes and stripZeroes function directly into dateutils to 
	 * expose for testing
	 */
	
	function abbrYear(value) {
	  value = (0, _zero.addZeroes)((0, _zero.stripZeroes)(value), 2);
	  return value.substr(-2, 2);
	}
	
	/**
	 * @param {number|string} year1
	 * @param {number|string} year2
	 * @returns {boolean} true if y1 and y2 represent years in the same century.
	 */
	function isSameCentury(year1, year2) {
	  var y1 = (0, _zero.addZeroes)(fullYear(year1), 4);
	  var y2 = (0, _zero.addZeroes)(fullYear(year2), 4);
	  return y1.substr(0, 2) === y2.substr(0, 2);
	}
	
	/**
	 * @private
	 * @param {string} str
	 * @returns {string|undefined} if str is a Quartar ("2Q") or else undefined.
	 */
	function getQuarter(str) {
	  if (typeof str === 'string') {
	    str = str.toUpperCase();
	    return str.indexOf('Q') !== -1 ? str : undefined;
	  }
	  return undefined;
	}
	
	/**
	 * @private
	 * @param {string} str
	 * @returns {string|undefined} if str is a Half ("2H") or else undefined.
	 */
	function getHalf(str) {
	  if (typeof str === 'string') {
	    str = str.toUpperCase();
	    return str.indexOf('H') !== -1 ? str : undefined;
	  }
	  return undefined;
	}
	
	/**
	 * For a given quarter, returns the index of the month that represents the end
	 * of that quarter.
	 * @private
	 * @param {number} q Index of a quarter, 0 to 3.
	 * @returns {number} Index of month, 2, 4, 8, or 11.
	 */
	function quarterToMonth(q) {
	  q = typeof q === 'string' ? q.toUpperCase() : null;
	  switch (q) {
	    case '1Q':
	      return 2;
	    case '2Q':
	    case '1H':
	      return 5;
	    case '3Q':
	      return 8;
	    case '4Q':
	    case '2H':
	      return 11;
	  }
	  return undefined;
	}
	
	/**
	 * For a given month that represents the end of a quarter, returns the date
	 * that represents the end of that quarter.
	 * @private
	 * @param {number} month Index of a month, 0 to 11.
	 * @returns {number} Date of the month, 1 to 31.
	 */
	function quarterToDate(month) {
	  switch (month) {
	    case undefined:
	    case null:
	      return undefined;
	    case 1:
	      return 28;
	    case 3:
	    case 5:
	    case 8:
	    case 10:
	      return 30;
	    default:
	      return 31;
	  }
	}
	
	/**
	 * For use with removeExtraneous().
	 * @private
	 * @param {string} prop 'second', 'minute', etc.
	 * @returns {number} in milliseconds
	 */
	function genericTimeValue(prop) {
	  switch (prop) {
	    case 'second':
	      return 1000 * 60;
	    case 'minute':
	      return 1000 * 60 * 60;
	    case 'hour':
	      return 1000 * 60 * 60 * 60;
	    case 'date':
	      return 1000 * 60 * 60 * 24;
	  }
	  return 0;
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPoint;
	
	// Returns a point by its original index, before sorting by date.
	function getPoint(series, index) {
	  var point = series.data[index];
	  series.data.some(function (item, i) {
	    if (item.index === index) {
	      point = item;
	      return true;
	    }
	  });
	  return point;
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processSeries;
	exports.truncateData = truncateData;
	
	var _constants = __webpack_require__(2);
	
	/**
	 * Processes and build the chart series data.
	 */
	function processSeries(options) {
	  // Prepare series for Highcharts.
	  options.originalSeries = options.series;
	  var data = options.series.map(function (item) {
	    var series = {
	      data: item.data,
	      name: item.name,
	      step: options.step ? 'left' : null,
	      markdown: item.markdown,
	      showInLegend: item.showInLegend,
	      animation: false,
	      color: item.color || options.defaults.colors[0],
	      negativeColor: options.colorMode === 'THRESHOLD' && (options.type === 'column' || options.type === 'bar') ? item.negativeColor || options.defaults.colors[1] : null,
	      events: {
	        legendItemClick: function legendItemClick() {
	          return false;
	        }
	      },
	      turboThreshold: 0,
	      states: {
	        hover: {
	          enabled: options.type === 'line'
	        }
	      }
	    };
	    return series;
	  });
	  if (options.categoriesAreMonthly && options.type === 'column') {
	    startOfMonth(data);
	  }
	  // Customize the data for the particular chart type.
	  switch (options.type) {
	    case 'pie':
	      data = data.slice(0, 1);
	      break;
	    case 'bar':
	      // Save data to do this later, when options.styles.lineHeight is known.
	      // return truncateData(options, data);
	      options.series = data; //sortData(data, options);
	      return options;
	    case 'column':
	      var forceLegendTop = options.print && options.width <= _constants.MAX_NARROW_WIDTH_PRINT || !options.print && options.width <= _constants.MAX_4U_WIDTH;
	      var rightLegend = options.legend.layout === 'right' && !forceLegendTop;
	      data = options.stacking ? reverseDataOrder(data, rightLegend) : data;
	      break;
	    case 'line':
	      data = reverseDataOrder(data);
	      break;
	  }
	
	  options.series = data; //sortData(data, options);
	  for (var i = 0; i < options.series.length; i++) {
	    var seriesData = options.series[i].data;
	    for (var z = 0; z < seriesData.length; z++) {
	      seriesData[z].index = z;
	    }
	  }
	  return options;
	}
	
	// For line charts, first column should be top layer. This also reverses the
	// legend items, so that must be fixed separately.
	function reverseDataOrder(data) {
	  var reverseLegend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var dataLen = data.length;
	  data.forEach(function (item, index) {
	    item.index = dataLen - index - 1;
	    item.legendIndex = reverseLegend ? dataLen - index - 1 : index;
	  });
	  return data;
	}
	
	function startOfMonth(data) {
	  // for column charts with one date per month, shift x value to first of month
	  data.forEach(function (series) {
	    series.data.forEach(function (position) {
	      var date = new Date(position.x);
	      date.setUTCDate(1);
	      position.x = date.valueOf();
	    });
	  });
	}
	
	// For horizontal bar charts, removes data to improve visual appearance.
	function truncateData(options, data) {
	  // Guestimate the maximum data rows that will fit.
	  var maxRows = Math.floor(options.height / (parseFloat(options.styles.lineHeight.large) * 1.5));
	  // Remove data so rows does not exceed maxRows.
	  var overflow = Math.ceil(data[0].data.length / maxRows);
	  var originalCategories = options.categories ? options.categories.slice() : null;
	  var categories = [];
	  if (overflow > 1) {
	    data.forEach(function (item, index) {
	      var items = [];
	      var n = 0;
	      while (n < item.data.length) {
	        if (index === 0 && options.categories) {
	          categories.push(originalCategories[n]);
	          options.categories = categories;
	        }
	        items.push(item.data[n]);
	        n += overflow;
	      }
	      item.data = items;
	    });
	  }
	  options.series = data;
	  return options;
	}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Functions and vars shared between axes-prerender and axes-postrender.
	 */
	var YEAR_MILLISECONDS = exports.YEAR_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBestRule = getBestRule;
	var TEXT_RULES = {
	  thumb: {
	    title: false,
	    dek: false,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  }
	};
	
	if (true) {
	  TEXT_RULES.E = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.D = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.G = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.top = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.soc = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.tab = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES.fon = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['4u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['8u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['12u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['16u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['appfeed'] = {
	    title: false,
	    dek: false,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	}
	
	if (false) {
	  TEXT_RULES['barrons-4col-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['barrons-8col-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['barrons-10col-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  }, TEXT_RULES['barrons-fullscreen-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['b4u'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['barrons-8col-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['barrons-10col-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  }, TEXT_RULES['barrons-fullscreen-inset'] = {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	}
	
	if (false) {
	  TEXT_RULES['fn-small-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['fn-medium-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: false,
	    thumb: false
	  };
	  TEXT_RULES['fn-large-image'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['fn4u'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['fn-medium-inset'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['fn-large-inset'] = {
	    title: true,
	    dek: true,
	    subdek: false,
	    note: true,
	    source: true,
	    tagline: true,
	    thumb: false
	  };
	  TEXT_RULES['print-fn'] = {
	    title: false,
	    dek: false,
	    subdek: false,
	    note: false,
	    source: false,
	    tagline: false,
	    thumb: false
	  };
	}
	
	if (false) {
	  TEXT_RULES['marketwatch-ZT'] = {
	    title: false,
	    dek: false,
	    subdek: false,
	    legend: false,
	    note: false,
	    source: false,
	    tagline: false
	  };
	  TEXT_RULES['marketwatch-ZR'] = {
	    title: false,
	    dek: false,
	    subdek: false,
	    legend: false,
	    note: false,
	    source: false,
	    tagline: false
	  };
	}
	
	function getBestRule(id) {
	  // If a rule for @param id is found, return it.
	  if (TEXT_RULES[id] !== undefined) {
	    return TEXT_RULES[id];
	  }
	  // If a rules that begins with @param id is found, return it. This is useful
	  // for example with any id that starts with "thumb".
	  for (var i = 0, keys = Object.keys(TEXT_RULES); i < keys.length; i++) {
	    var key = keys[i];
	    if (id.indexOf(key) === 0) {
	      return TEXT_RULES[key];
	    }
	  }
	  // Default:
	  return {
	    title: true,
	    dek: true,
	    subdek: true,
	    note: true,
	    source: true,
	    tagline: 'right'
	  };
	}
	
	exports.default = TEXT_RULES;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeEl = removeEl;
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function removeEl(item) {
	  if (item && item.el) {
	    element.removeChild(item.el.element);
	    item.el = null;
	  }
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(133)(module)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterOptionsForSize;
	
	/**
	 * Options passed to the renderer include options for multiple sizes. This
	 * function narrows down all those options to those relevant to the current
	 * size only.
	 */
	function filterOptionsForSize(options) {
	  var size = getSize(options);
	  var sizeObj = options.sizes[size.id];
	  options.interactive = size.interactive;
	  options.target = size.target;
	  options.size = size.id;
	  options.height = options.useContainerSize ? options.height : sizeObj.height || size.height;
	  options.headings = sizeObj.headings;
	  options.legend = sizeObj.legend;
	  options.stacking = sizeObj.stacking;
	  options.axes = sizeObj.axes;
	  options.xAxis = sizeObj.xAxis;
	  options.yAxis = sizeObj.yAxis;
	  options.annotations = writeAnnotations(sizeObj.annotations);
	  options.tooltips = sizeObj.tooltips.sameAsAxes ? sizeObj.axes.units : sizeObj.tooltips;
	  return options;
	}
	
	function getSize(options) {
	  var index = indexOfSize(options);
	  if (index !== -1) {
	    return options.defaults.sizes[index];
	  }
	  options.defaults.sizes.sort(function (a, b) {
	    if (a.hasOwnProperty('minWidth') && b.hasOwnProperty('minWidth')) {
	      return a.minWidth - b.minWidth;
	    }
	    return 1;
	  });
	  var size = options.defaults.sizes[0];
	  options.defaults.sizes.forEach(function (item, index) {
	    if (item.hasOwnProperty('minWidth') && Math.ceil(options.width) >= item.minWidth) {
	      size = options.defaults.sizes[index];
	    }
	  });
	  return size;
	}
	
	function indexOfSize(options) {
	  if (options.size) {
	    for (var i = 0; i < options.defaults.sizes.length; i++) {
	      if (options.size === options.defaults.sizes[i].id) {
	        return i;
	      }
	    }
	  }
	  return -1;
	}
	
	// set alignment
	function writeAnnotations(annotations) {
	  annotations.items.forEach(function (item) {
	    item.textAlign = item.textAlign || annotations.textAlign || 'left';
	    item.flushAlign = item.flushAlign || annotations.flushAlign || 'flush';
	  });
	  return annotations;
	}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = highchartsVersion;
	function highchartsVersion() {
	  var localHighcharts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  var parts = (localHighcharts || Highcharts).version.split(' ');
	  for (var i = 0; i < parts.length; i++) {
	    var n = parseFloat(parts[i]);
	    if (!isNaN(n)) {
	      return n;
	    }
	  }
	  return 0;
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processCategories;
	
	var _constants = __webpack_require__(2);
	
	var _datetime = __webpack_require__(8);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _zero = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes and builds the chart categories.
	 */
	function processCategories(options) {
	  if (Array.isArray(options.categories)) {
	    options.maxDataLength = getMaxDataLength(options);
	    options.originalCategories = options.categories.slice();
	    if (options.categoriesAreDates) {
	      return formatAsDates(options);
	    } else {
	      return formatAsCategories(options);
	    }
	  } else {
	    options = writeDefaultCategories(options);
	  }
	  return options;
	}
	
	function getMaxDataLength(options) {
	  var maxLen = 0;
	  options.series.forEach(function (series) {
	    maxLen = Math.max(maxLen, series.data.length);
	  });
	  return maxLen;
	}
	
	// Makes the index of each row into a default category value.
	function writeDefaultCategories(options) {
	  options.categories = [[]];
	  for (var i = 0; i < options.maxDataLength; i++) {
	    options.categories[0][i] = i;
	  }
	  options.originalCategories = options.categories[0].slice();
	  return options;
	}
	
	// Returns the categories as is, but wrapped in an array as the axes module needs.
	function formatAsCategories(options, altCategories) {
	  options.longCategories = options.originalCategories.slice(0);
	  options.categories = [options.categories];
	  return options;
	}
	
	// Casts the categories from strings into dates.
	function formatAsDates(options) {
	  options.fiscalYears = !!options.datesAll.fiscalYear;
	  options.quarterlyResults = _datetime2.default.allQuarterly(options.dates);
	  if (options.quarterlyResults || options.fiscalYears) {
	    options.longCategories = formatQLong(options);
	  } else {
	    options.longCategories = formatLong(options.dates);
	  }
	  options.categories = [options.quarterlyResults ? formatQ(options) : options.longCategories];
	  return options;
	}
	
	// For tooltips: standard dates/times.
	function formatLong(dates) {
	  return dates.map(function (date) {
	    var str = formatDateLong(date);
	    return formatTimeLong(date, str);
	  });
	}
	
	function formatDateLong(date) {
	  if (date.month !== undefined && date.date && date.year) {
	    return [_constants.MONTHS[date.month], date.date + ',', date.year].join(' ');
	  } else if (date.month !== undefined && date.date) {
	    return [_constants.MONTHS[date.month], date.date].join(' ');
	  } else if (date.month !== undefined && date.year) {
	    return [_constants.MONTHS[date.month], date.year].join(' ');
	  } else if (date.month !== undefined) {
	    return _constants.MONTHS[date.month];
	  } else if (date.year) {
	    return date.year + '';
	  }
	  return null;
	}
	
	function formatTimeLong(date, str) {
	  if (date.hour !== undefined) {
	    var h = '';
	    var a = '';
	    str = str ? str + ' ' : '';
	    if (date.a === 'a' || date.a === 'p') {
	      h = date.hour % 12 + '';
	      h = h === '0' ? '12' : h;
	      a = date.a;
	    } else {
	      if (date.hour === 0) {
	        h = '12';
	        a = 'a';
	      } else if (date.hour === 12) {
	        h = '12';
	        a = 'p';
	      } else if (date.hour > 12) {
	        h = date.hour % 12 + '';
	        a = 'p';
	      } else {
	        // same as: if (date.hour < 12) {
	        h = date.hour + '';
	        a = 'a';
	      }
	    }
	    str += h;
	    if (date.minute !== undefined) {
	      str += ':' + (0, _zero.addZeroes)(date.minute, 2);
	    }
	    if (date.second !== undefined) {
	      str += ':' + (0, _zero.addZeroes)(date.second, 2);
	    }
	    if (a) {
	      str += ' ' + (date.a === 'a' ? 'a.m.' : 'p.m.');
	    }
	    if (isNoon(str, date)) {
	      str = 'noon';
	    }
	    if (date.z) {
	      str += ' ' + date.z;
	    }
	  }
	  return str;
	}
	
	function isNoon(str, date) {
	  return date.minute === undefined && /^12/.test(str) || date.second === undefined && /^12:00/.test(str) || /^12:00:00/.test(str);
	}
	
	// Returns array of quarterly/half year categories.
	function formatQ(options, long) {
	  return options.dates.map(function (item, index) {
	    var str = '';
	    str += item.quarter || '';
	    str += item.half || '';
	    str += item.year !== undefined ? ' ' : '';
	    str += (index === 0 || long) && item.fiscalYear ? 'FY' : '';
	    str += item.year || '';
	    return str;
	  });
	}
	
	// For tooltips: quarterly results.
	function formatQLong(options) {
	  return formatQ(options, true);
	}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processData;
	
	var _format = __webpack_require__(4);
	
	var format = _interopRequireWildcard(_format);
	
	var _datetime = __webpack_require__(8);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Processes and optimizes the chart data before building categories and series.
	 */
	function processData(options) {
	  if (options.categoriesAreDates) {
	    options.dates = _datetime2.default.parse(options.categories, options);
	    options.datesAll = _datetime2.default.all(options.dates);
	    if ((!options.quarterlyResults || options.quarterlyResults && options.series[0].data.length > 44) && options.type !== 'bar') {
	      options.series = insertDates(options.series, options);
	    }
	  }
	  if (options.type === 'pie' && options.optimizeDataOrder) {
	    options = optimizePieData(options);
	  } else if (options.categoriesAreDates && (!options.quarterlyResults || options.quarterlyResults && options.series[0].data.length > 44)) {
	    options = sortDataByDate(options);
	  }
	  if (options.axes && options.axes.units && options.axes.units.divisor !== "none") {
	    options = divideYAxisValues(options);
	  }
	  return options;
	}
	
	// Insert date values into all data.
	function insertDates(data, options) {
	  var proxyYears = getProxyYears(options);
	  data.forEach(function (series) {
	    series.data.forEach(function (item, index) {
	      var dateObj = options.dates[index];
	      var date = new Date(dateObj.value);
	      if (dateObj.year === undefined && proxyYears[index] !== undefined) {
	        dateObj.yearIsProxy = true;
	        date.setUTCFullYear(proxyYears[index]);
	      }
	      item.x = date.valueOf();
	    });
	  });
	  return data;
	}
	
	// For data with dates with months but not years, create proxy years so the
	// dates can be sorted correctly.
	function getProxyYears(options) {
	  var proxyYears = [];
	  if (options.datesAll.month && !options.datesAll.year) {
	    var year = new Date().getUTCFullYear();
	    var month = undefined;
	    for (var i = options.dates.length - 1; i >= 0; i--) {
	      if (month !== undefined && month <= options.dates[i].month) {
	        year -= 1;
	      }
	      proxyYears[i] = year;
	      month = options.dates[i].month;
	    }
	  }
	  return proxyYears;
	}
	
	function sortDataByDate(options) {
	  options.series.forEach(function (item) {
	    item.data.forEach(function (pt, index) {
	      pt.index = index;
	    });
	    item.data.sort(function (a, b) {
	      if (a.x === undefined || b.x === undefined) {
	        return 0;
	      }
	      return a.x - b.x;
	    });
	    // item.data.forEach((pt, index) => {
	    // pt.index = index;
	    // });
	  });
	  return options;
	}
	
	// Data should be ordered like so:
	//      2 1
	//    3     10
	//  4         9
	//    5     8
	//      6 7
	// Also, category names get attached to points.
	function optimizePieData(options) {
	  if (Array.isArray(options.categories)) {
	    // Link each point to a category.
	    options.series[0].data.forEach(function (point, index) {
	      point.name = options.categories[index];
	      point.originalIndex = index;
	    });
	  }
	  // Sort the data smallest to largest.
	  options.series[0].data.sort(function (a, b) {
	    if (a.y > b.y) {
	      return 1;
	    } else if (a.y < b.y) {
	      return -1;
	    }
	    return 0;
	  });
	  // Take the largest data at the end and make it first.
	  options.series[0].data.unshift(options.series[0].data.pop());
	  return options;
	}
	
	function divideYAxisValues(options) {
	  var divisor = format.getDivisor(options.axes.units.divisor);
	  for (var i = 0; i < options.series.length; i++) {
	    var yAxisValue = options.series[i].data;
	    yAxisValue.forEach(function (value) {
	      value.y = value.y / divisor;
	    });
	  }
	  return options;
	}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processOptions;
	
	var _highchartsVersion = __webpack_require__(135);
	
	var _highchartsVersion2 = _interopRequireDefault(_highchartsVersion);
	
	var _filterOptionsForSize = __webpack_require__(134);
	
	var _filterOptionsForSize2 = _interopRequireDefault(_filterOptionsForSize);
	
	var _processData = __webpack_require__(137);
	
	var _processData2 = _interopRequireDefault(_processData);
	
	var _processCategories = __webpack_require__(136);
	
	var _processCategories2 = _interopRequireDefault(_processCategories);
	
	var _processSeries = __webpack_require__(13);
	
	var _processSeries2 = _interopRequireDefault(_processSeries);
	
	var _style = __webpack_require__(162);
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(167);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processOptions(options, Highcharts) {
	  options = copyOptions(options, Highcharts);
	  options = (0, _filterOptionsForSize2.default)(options);
	  options = (0, _processData2.default)(options);
	  options = (0, _processCategories2.default)(options);
	  options.styles = (0, _style.processStyles)(options);
	  options = (0, _processSeries2.default)(options);
	  options.el = containerElement(options.el);
	  return options;
	}
	
	function copyOptions(options, Highcharts) {
	  return (0, _lodash2.default)({}, {
	    HIGHCHARTS_VERSION: (0, _highchartsVersion2.default)(Highcharts),
	    id: options.el.getAttribute('id') || options.size
	  }, options);
	}
	
	// Prepares the container DOM element.
	function containerElement(el) {
	  el = typeof el === 'string' ? document.querySelector(el) : el;
	  if (!el.querySelector('div.dj-chart-container')) {
	    var divA = document.createElement('div');
	    var divB = document.createElement('div');
	    divA.className = 'dj-chart-container';
	    divB.className = 'dj-chart-inner';
	    el.appendChild(divA);
	    el.appendChild(divB);
	  }
	  return el;
	}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.normalize = normalize;
	exports.makeFiscalYears = makeFiscalYears;
	exports.removeFiscalYears = removeFiscalYears;
	exports.makeQuarterly = makeQuarterly;
	exports.removeQuarterly = removeQuarterly;
	exports.getQuarter = getQuarter;
	exports.getHalf = getHalf;
	
	var _dateutils = __webpack_require__(11);
	
	/**
	 * For quarterly data, fills in missing quarters, years, etc.
	 */
	function normalize(items) {
	  // Quarters, halves, years must be declared/set in first item of a year.
	  var hasQ = items[0].quarter !== undefined;
	  var hasH = items[0].half !== undefined;
	  var hasY = items[0].year !== undefined;
	  var FY = hasY && items[0].fiscalYear;
	
	  // Dates are neither quarterly, halves, or fiscal years, so just return.
	  if (!(hasQ || hasH || FY)) {
	    return items;
	  }
	
	  var quarter = undefined;
	  var half = undefined;
	  var year = undefined;
	  var currYear = undefined;
	  items.forEach(function (item) {
	    var prevQ = hasQ ? quarter : hasH ? half : null;
	    item.fiscalYear = FY;
	
	    if (hasQ) {
	      if (!item.quarter) {
	        if (item.hasOwnProperty('month')) {
	          // - 1 because getQuarter starts months from 0:
	          item.quarter = getQuarter(item.month - 1);
	        } else {
	          quarter += 1;
	          quarter %= 4;
	          quarter = quarter === 0 ? 4 : quarter;
	          item.quarter = quarter + 'Q';
	        }
	      }
	      quarter = +item.quarter.substring(0, 1);
	    } else {
	      item.quarter = undefined;
	    }
	
	    if (hasH) {
	      if (!item.half) {
	        half += 1;
	        half %= 2;
	        half = half === 0 ? 2 : half;
	        item.half = half + 'H';
	      }
	      half = +item.half.substring(0, 1);
	    } else {
	      item.half = undefined;
	    }
	
	    if (hasY) {
	      if (item.year === undefined) {
	        item.year = year;
	        if (hasQ && quarter <= prevQ || hasH && half <= prevQ) {
	          item.year += 1;
	        }
	      }
	      item.year = year = (0, _dateutils.fullYear)(item.year);
	
	      if (currYear !== year) {
	        currYear = year;
	        hasQ = item.quarter !== undefined;
	        hasH = item.half !== undefined;
	      }
	    }
	  });
	
	  return items;
	}
	
	/**
	 * Transforms items into a fiscal years by declaring fiscalYear to be true for
	 * first item. Assumes normalize() will be called subsequently.
	 */
	function makeFiscalYears(items) {
	  items[0].fiscalYear = items[0].year !== undefined;
	  return items;
	}
	
	function removeFiscalYears(items) {
	  items.forEach(function (item) {
	    item.fiscalYear = false;
	  });
	  return items;
	}
	
	function makeQuarterly(items) {
	  items.forEach(function (item) {
	    if (item.quarter === undefined && item.half === undefined && item.month !== undefined) {
	      item.quarter = getQuarter(item.month);
	    }
	  });
	  return makeHalves(items);
	}
	
	function makeHalves(items) {
	  var isHalf = false;
	  var yearBlocks = {};
	
	  // Separate dates into blocks of years.
	  items.forEach(function (item) {
	    if (item.quarter && item.year !== undefined) {
	      yearBlocks[item.year] = yearBlocks[item.year] || [];
	      if (item.month !== undefined) {
	        yearBlocks[item.year].push(item);
	      }
	    }
	  });
	
	  // Transform any year blocks with 2 dates 6 months or more apart into halves.
	  Object.keys(yearBlocks).forEach(function (key) {
	    var block = yearBlocks[key];
	    if (block.length === 2) {
	      if (block[1].month - block[0].month >= 6) {
	        isHalf = true;
	        block[0].quarter = block[1].quarter = undefined;
	        block[0].half = '1H';
	        block[1].half = '2H';
	      }
	    }
	  });
	
	  if (isHalf) {
	    // Data if halves, not quarters, so convert quarters in years with only
	    // one quarter to a half.
	    Object.keys(yearBlocks).forEach(function (key) {
	      block = yearBlocks[key];
	      if (block.length === 1) {
	        block[0].quarter = undefined;
	        block[0].half = getHalf(block[0].month);
	      }
	    });
	  }
	  return items;
	}
	
	function removeQuarterly(items) {
	  items.forEach(function (item) {
	    item.quarter = item.half = undefined;
	  });
	  return items;
	}
	
	/**
	 * Converts a month index to a quarterly string value.
	 * @private
	 */
	function getQuarter(month) {
	  if (month < 3) {
	    return '1Q';
	  } else if (month < 6) {
	    return '2Q';
	  } else if (month < 9) {
	    return '3Q';
	  } else {
	    return '4Q';
	  }
	}
	
	/**
	 * Converts a month index to a half year string value.
	 * @private
	 */
	function getHalf(month) {
	  return month < 6 ? '1H' : '2H';
	}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datetime = __webpack_require__(8);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _processOptions = __webpack_require__(138);
	
	var _processOptions2 = _interopRequireDefault(_processOptions);
	
	var _processSeries = __webpack_require__(13);
	
	var _preload = __webpack_require__(163);
	
	var preload = _interopRequireWildcard(_preload);
	
	var _outer = __webpack_require__(159);
	
	var OuterChart = _interopRequireWildcard(_outer);
	
	var _inner = __webpack_require__(152);
	
	var InnerChart = _interopRequireWildcard(_inner);
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	var _highchartsSrc = __webpack_require__(164);
	
	var _highchartsSrc2 = _interopRequireDefault(_highchartsSrc);
	
	var _highstock = __webpack_require__(165);
	
	var _highstock2 = _interopRequireDefault(_highstock);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Store charts so they can be destroyed as needed.
	
	
	// Highcharts source code must be updated to prevent writing window global and
	// throwing Error #16:
	var charts = [];
	
	/**
	 * Public API functions.
	 */
	function render(options, done) {
	  done = typeof done === 'function' ? done : function () {};
	  options = options.irregularDates ? (0, _processOptions2.default)(options, _highstock2.default) : (0, _processOptions2.default)(options, _highchartsSrc2.default);
	  var invalidated = options.invalidated && options.invalidated[options.size];
	  if (!!invalidated) {
	    var existChart = getExistChart(options.el).chart;
	    if (existChart && existChart.outer && existChart.inner) {
	      renderInvalidated(existChart, options, done);
	      return;
	    }
	  }
	  resetRender(options, done);
	}
	
	function resetRender(options, done) {
	  destroy(options.el);
	  // console.log(`CHART.${options.id}.fonts.START`);
	  preload.fonts(options, function () {
	    // console.log(`CHART.${options.id}.fonts.COMPLETE`);
	    renderChart(options, done);
	  });
	}
	
	// Instead of re-rendering the entirety of both inner and outer charts, only
	// the invalidate parts of re-rendered.
	// TODO: Create preview/editing views and get this working again.
	function renderInvalidated(rendered, options, done) {
	  if (false) {
	    var invalidated = options.invalidated[options.size] || [];
	
	    var invalidAll = ['chart/targets', 'chart/height', 'chart/annotations',
	    // ];
	    // const invalidChart = [
	    'chart/data', 'chart/type', 'chart/series-names', 'chart/hide-legend', 'chart/axis', 'chart/legend', 'chart/stacking', 'chart/height', 'chart/colors', 'headings/title'];
	    var invalidChart = [];
	
	    // Some changes require a full chart re-render while others can force a
	    // more limited re-render.
	    var mustRender = function mustRender(invalidated, renderItems) {
	      return true;
	      // return renderItems.some(item => {
	      //   return invalidated.indexOf(item) !== -1 || invalidated.some(invItem => {
	      //     return invItem.indexOf(item) === 0;
	      //   });
	      // });
	    };
	
	    if (mustRender(invalidated, invalidAll)) {
	      window.__charts_fonts_loaded__ = undefined;
	      resetRender(options, done);
	      return;
	    }
	
	    // Some items only force a re-render under specific conditions. For example,
	    // changes to series name should only trigger a re-render if the legend is
	    // enabled since that is the only place where series names appear.
	    invalidated = invalidated.filter(function (item) {
	      switch (item) {
	        case 'chart/series-names':
	          return options.legend.enabled;
	        default:
	          return true;
	      }
	    });
	
	    var outerHeight = rendered.outerInfo.height;
	    OuterChart.renderInvalidated(rendered, options, invalidated);
	
	    if (outerHeight !== rendered.outerInfo.height || mustRender(invalidated, invalidChart)) {
	      // mustRenderColor(invalidated)) {
	      destroyInner(rendered.inner);
	      setTimeout(function () {
	        renderInnerChart(options, rendered, rendered.outerInfo, done);
	      }, 1);
	    } else {
	      InnerChart.renderInvalidated(rendered, options, invalidated);
	      done(rendered.inner);
	    }
	  }
	}
	
	// The outer chart containers headlines and notes.
	function renderChart(options, done) {
	  if (options.type === 'bar') {
	    // options = truncateData(options, options.series);
	  }
	  var renderObj = { el: options.el, outer: null, inner: null, options: options };
	  var chartObj = OuterChart.preRender(options);
	  charts.push(renderObj);
	  renderObj.outer = renderHighchart(options, chartObj, function (highchart) {
	    var outer = OuterChart.postRender(highchart, options);
	    renderObj.outerInfo = outer;
	    if (outer.innerEl) {
	      renderInnerChart(options, renderObj, outer, done);
	    } else {
	      done(null);
	    }
	  });
	}
	
	// The inner charts contains the actual chart.
	function renderInnerChart(options, renderObj, outer, done) {
	  var outerY = outer.y;
	  options.width = outer.width;
	  options.annotations = outer.info ? outer.info.annotations.items || [] : [];
	  var fontSize = parseFloat(options.styles.normal.fontSize);
	  if (options.size.indexOf('thumb') !== 0) {
	    options.height = outer.height - (options.type === 'pie' || options.size === 'marketwatch-ZT' ? 0 : 16);
	  }
	  options.height += 8;
	  options.spacing = createInnerSpacing(options, outer.spacing);
	  var chartObj = InnerChart.preRender(options);
	  return renderObj.inner = renderHighchart(options, chartObj, function (highchart) {
	    InnerChart.postRender(highchart, options);
	    var hc = chartObj.chart.renderTo.querySelector('.highcharts-container');
	    if (hc) {
	      hc.style.position = 'absolute';
	      hc.style.left = outer.x + 'px';
	      hc.style.top = outerY + 'px';
	      hc.style.overflow = 'visible';
	
	      var svg = hc.querySelector('svg');
	      svg.setAttribute('x', outer.x);
	      svg.setAttribute('y', outerY);
	      svg.setAttribute('height', Math.max(0, options.height + fontSize));
	
	      if (options.size.indexOf('print') === 0) {
	        // This causes tooltip issues, but needs to be done (at the time) for
	        // image export and svg download:
	        outer.innerEl.appendChild(svg);
	        element.removeChild(hc);
	      }
	    }
	    done(highchart);
	  });
	}
	
	function createInnerSpacing(options, spacing) {
	  var inner = spacing ? spacing.map(function (n) {
	    return n;
	  }) : [0, 0, 0, 0];
	  if (options.annotations && options.annotations.length && (options.axes.units.suffix.length > 2 || options.axes.showRecessions)) {
	    inner[0] += options.product === 'wsj' ? 24 : parseFloat(options.styles.normal.lineHeight);
	    inner[0] = Math.max(0, inner[0]);
	  }
	  return inner;
	}
	
	// Render a Highcharts chart via either the standalone Highcharts adapter or
	// jQuery, depending on the environment.
	function renderHighchart(options, data, postRender) {
	  if (options.irregularDates) {
	    return new _highstock2.default.stockChart(data, postRender);
	  } else {
	    return new _highchartsSrc2.default.chart(data, postRender);
	  }
	}
	
	function destroy(el) {
	  if (el) {
	    var obj = getExistChart(el);
	    if (obj.chart) {
	      destroyOuter(obj.chart.outer, obj.chart.inner);
	    }
	    if (obj.index !== -1) {
	      charts.splice(obj.index, 1);
	    }
	  } else {
	    // charts.forEach(c => {
	    //   if (c.el) {
	    //     destroy(c.el);
	    //   }
	    // });
	    while (charts.length) {
	      destroy(charts[0].el);
	    }
	  }
	}
	
	function destroyOuter(outer, inner) {
	  destroyInner(inner);
	  if (outer) {
	    try {
	      destroyCommon(outer);
	      outer.destroy();
	    } catch (e) {
	      // Highcharts error.... because older version?
	      // console.warn(e);
	    }
	  }
	}
	
	function destroyInner(inner) {
	  if (inner) {
	    try {
	      destroyCommon(inner);
	      inner.destroy();
	    } catch (e) {
	      // Usually exception caused by no innerEl !?!
	      // console.warn(e);
	    }
	  }
	}
	
	// The version of Highcharts used at DJ does not do this automatically.
	function destroyCommon(chart) {
	  if (chart.series) {
	    chart.series.forEach(function (s) {
	      try {
	        s.update({
	          enableMouseTracking: false
	        });
	      } catch (e) {
	        //
	      }
	    });
	  }
	}
	
	function getExistChart(el) {
	  var existChartIndex = chartIndexOf(el);
	  return {
	    index: existChartIndex,
	    chart: existChartIndex !== -1 ? charts[existChartIndex] : null
	  };
	}
	
	function chartIndexOf(el) {
	  for (var i = 0; i < charts.length; i++) {
	    if (charts[i].el === el) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	exports.default = { render: render, destroy: destroy, datetime: _datetime2.default, chart: getExistChart };

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.postRender = postRender;
	
	var _getPoint = __webpack_require__(12);
	
	var _getPoint2 = _interopRequireDefault(_getPoint);
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARGIN_ONLINE = 16;
	var MARGIN_PRINT = 8;
	var COLOR = '#333';
	
	function postRender(highchart, options) {
	  if (options.annotations && options.annotations.length) {
	    // Get values used for positioning.
	    var suffix = options.axes.units.suffix;
	    var liftUp = options.axes.showRecessions || suffix && options.axes.units.suffix.length > 2;
	
	    var styleLH = parseFloat(options.annotations[0].element.style.lineHeight);
	    if (styleLH) {
	      options.annotations[0].element.style.lineHeight = styleLH + 'px';
	    }
	    var lineHeight = parseFloat(window.getComputedStyle(options.annotations[0].element, null).getPropertyValue('line-height')) || 16;
	    var xy = getStartXY(highchart, options, suffix, liftUp);
	    // Position and append items.
	    var g = highchart.renderer.g('annotations').add();
	    g.element.parentElement.appendChild(g.element);
	    writeIdealPositions(highchart, options);
	    spaceOutPositions(highchart, options, xy);
	    appendItems(highchart, options, g, xy, lineHeight);
	
	    // Make it crisp.
	    if (options.product === 'wsj' && !options.print) g.element.setAttribute('transform', 'translate(0.5, -7)');else g.element.setAttribute('transform', 'translate(0.5, -4)');
	
	    setStyles(g.element, options);
	  }
	}
	
	function setStyles(element, options) {
	  if (true) {
	    if (options.product === 'wsj') {
	      var text = element.childNodes;
	      for (var b = 0; b < text.length; b++) {
	        if (text[b].tagName === 'text') {
	          text[b].style.fontSize = options.styles.annotations.fontSize;
	          text[b].style.lineHeight = options.styles.annotations.lineHeight;
	        }
	      }
	    }
	  }
	}
	
	// Finds the X position for each annotation without regard to the other
	// annotations that it overlaps or the edges of the chart.
	function writeIdealPositions(highchart, options) {
	  options.annotations.forEach(function (item, index) {
	    var rect = item.element.getBoundingClientRect();
	    var xy = getGraphicXY(highchart, options, item);
	    item.position = {
	      gx: xy.x,
	      gy: xy.y,
	      tx: xy.x,
	      ty: 0,
	      width: rect.width * 1.154,
	      height: rect.height,
	      show: true
	    };
	  });
	}
	
	function spaceOutPositions(highchart, options, xy) {
	  var MARGIN = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
	  var hardLeft = Math.round(xy.x);
	  var hardRight = highchart.plotLeft + highchart.plotWidth;
	  var hardWidth = hardRight - hardLeft;
	  var sortedA = options.sortedAnnotations = getSortedAnnotations(options);
	  var recessionEl = highchart.container.querySelector('.label-recession');
	  var recession = recessionEl ? {
	    type: 'recession',
	    startX: getStartX(recessionEl),
	    endX: getStartX(recessionEl) + getWidth(recessionEl),
	    midpoint: getStartX(recessionEl) + getWidth(recessionEl) / 2
	  } : null;
	  var suffixEl = highchart.container.querySelector('.y-axis-suffix');
	  var suffix = suffixEl ? {
	    type: 'suffix',
	    endX: getStartX(suffixEl) + getWidth(suffixEl)
	  } : null;
	
	  // Hide annotations that are too wide to fit, even all by themselves.
	  sortedA.forEach(function (item) {
	    var pos = item.position;
	    pos.tx = Math.max(pos.tx, hardLeft);
	    if (pos.tx + pos.width > hardRight) {
	      pos.tx = hardRight - pos.width;
	      if (pos.tx < hardLeft) {
	        pos.show = false;
	      }
	    }
	  });
	
	  // Hide annotations for which the width of the entire chart will not
	  // accomodate them.
	  var accumWidth = 0;
	  options.annotations.forEach(function (item) {
	    if (item.position.show) {
	      accumWidth += item.position.width + MARGIN;
	      if (accumWidth > hardWidth) {
	        item.position.show = false;
	      }
	    }
	  });
	
	  var softPx = hardLeft;
	  var tx = void 0,
	      midpoint = void 0,
	      lineTopX = void 0,
	      overlap = void 0,
	      labelMidpoint = void 0;
	  // Shift items left to right.
	  sortedA.forEach(function (item) {
	    midpoint = item.position.width / 2;
	    if (item.position.show) {
	      item.position.tx = Math.max(item.position.tx, softPx);
	      if (recession || suffix) {
	        // does line overlap with recession or suffix label, and if recession, should it shift right
	        var _checkOverlap = checkOverlap(item.position, highchart.plotLeft, recession, suffix);
	
	        var _checkOverlap2 = _slicedToArray(_checkOverlap, 2);
	
	        lineTopX = _checkOverlap2[0];
	        overlap = _checkOverlap2[1];
	        if (overlap.type === 'suffix' || overlap.type === 'recession' && lineTopX >= recession.midpoint) {
	          // initially center annotation above label right edge (with 2px cushion)
	          tx = overlap.endX - midpoint + 2;
	          adjustPosition(item, highchart, tx, midpoint, 'right');
	        };
	      };
	      softPx = item.position.tx + item.position.width + MARGIN;
	    }
	  });
	  // Shift items right to left.
	  softPx = hardRight + MARGIN;
	  for (var i = sortedA.length - 1; i >= 0; i--) {
	    var item = sortedA[i];
	    midpoint = item.position.width / 2;
	    if (item.position.show) {
	      item.position.tx = Math.min(item.position.tx, softPx - item.position.width - MARGIN);
	      if (recession) {
	        // shift annotation left if line overlaps with recession label
	        var _checkOverlap3 = checkOverlap(item.position, highchart.plotLeft, recession, suffix);
	
	        var _checkOverlap4 = _slicedToArray(_checkOverlap3, 2);
	
	        lineTopX = _checkOverlap4[0];
	        overlap = _checkOverlap4[1];
	        if (overlap.type === 'recession') {
	          // initially center annotation above recession label left edge (with 2px cushion)
	          tx = recession.startX - midpoint - 2;
	          adjustPosition(item, highchart, tx, midpoint, 'left');
	        };
	        // hide item if pushed off left edge of chart
	        if (item.position.tx < highchart.plotLeft) item.position.show = false;
	      };
	      checkSuffix(item, highchart.plotLeft, recession, suffix);
	      softPx = item.position.tx;
	    }
	  }
	}
	
	function appendItems(highchart, options, g, xy, lineHeight) {
	  // Append and position.
	  options.annotations.forEach(function (item, index) {
	    var el = item.element;
	    if (item.position.show) {
	      var x = txShift(item.position);
	      var y = xy.y;
	      var textX = item.position.tx;
	      var textAnchor = 'start';
	
	      if (item.flushAlign === 'flush') {
	        if (x >= textX && textX <= Math.round(xy.x)) {
	          item.textAlign = 'left';
	        } else if (textX <= x && textX + item.position.width >= highchart.plotLeft + highchart.plotWidth) {
	          item.textAlign = 'right';
	        }
	      }
	      if (item.textAlign === 'right') {
	        textAnchor = 'end';
	        textX += item.position.width;
	      } else if (item.textAlign === 'center') {
	        textAnchor = 'middle';
	        textX += item.position.width / 2;
	      }
	      var tspanLen = writeTspanX(el.children, textX);
	      var offsetY = -lineHeight * tspanLen;
	      item.position.tx = x;
	      item.position.ty = y;
	      el.setAttribute('text-anchor', textAnchor);
	      el.setAttribute('x', textX);
	      el.setAttribute('y', y + offsetY);
	      g.element.appendChild(el);
	    } else {
	      element.removeChild(el);
	    }
	  });
	  drawItemLines(highchart, options, g, xy);
	}
	
	// Get x, y where an annotation connector should attached to a chart graphic.
	function getGraphicXY(highchart, options, item) {
	  var p = item.attach.point;
	  var c = item.attach.category;
	  var xy = { x: 0, y: 0 };
	  if (p.enabled) {
	    var sIndex = options.series[p.series].hasOwnProperty('index') ? options.series[p.series].index : p.series;
	    var pIndex = getPointIndex(options.series[sIndex].data, p.index);
	    var point = options.irregularDates ? highchart.series[sIndex].points[pIndex] : highchart.series[sIndex].data[pIndex];
	    if (options.type === 'column') {
	      var shape = point.shapeArgs;
	      xy.x = shape.x + Math.floor(shape.width / 2);
	      xy.y = shape.y;
	    } else if (options.type === 'area' || options.type === 'line') {
	      xy.x = point.plotX;
	      xy.y = point.plotY;
	    }
	  } else {
	    var cIndex = getPointIndex(options.series[0].data, c.index);
	    // xy.x = (cIndex / highchart.series[0].data.length) * highchart.plotWidth;
	    xy.x = Math.floor(highchart.series[0].data[cIndex].clientX);
	    xy.y = highchart.plotHeight;
	  }
	  return xy;
	}
	
	function getPointIndex(data, index) {
	  var pointIndex = 0;
	  data.some(function (item, i) {
	    if (item.index === index) {
	      pointIndex = i;
	      return true;
	    }
	  });
	  return pointIndex;
	}
	
	function writeTspanX(tspan, x) {
	  var tspanLen = 0;
	  for (var i = 0; i < tspan.length; i++) {
	    if (tspan[i].nodeName === 'tspan') {
	      tspanLen++;
	      tspan[i].setAttribute('x', x);
	    }
	  }
	  return tspanLen - 1;
	}
	
	function getStartXY(highchart, options, suffix, liftUp) {
	  if (!liftUp && highchart.axes[1].opposite) {
	    return { x: 0, y: highchart.plotTop - 7 };
	  }
	  var MARGIN = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
	  var suffixEl = suffix ? highchart.container.querySelector('.y-axis-suffix') : null;
	  var xy = getTopAxisLabelXY(highchart, options);
	  if (suffixEl && !liftUp) {
	    // To the right of the suffix.
	    return {
	      x: +suffixEl.getAttribute('x') + suffixEl.getBoundingClientRect().width + MARGIN,
	      y: +suffixEl.getAttribute('y')
	    };
	  } else if (suffixEl && liftUp) {
	    // Above the suffix but aligned left with it, but we also need to find out
	    // if the suffix starts with a space to get the alignment right.
	    var suffixClassName = false;
	    if (suffixEl.children.length) {
	      suffixClassName = suffixEl.children[0].getAttribute('class');
	    }
	    var offsetX = suffixClassName === 'space' ? 4 : 0;
	    return {
	      x: +suffixEl.getAttribute('x') + offsetX,
	      y: +suffixEl.getAttribute('y') - suffixEl.getBoundingClientRect().height
	    };
	  } else if (liftUp) {
	    var recessionEl = highchart.container.querySelector('.label-recession');
	    return {
	      x: highchart.axes[1].opposite ? 0 : xy.x + MARGIN,
	      y: +recessionEl.getAttribute('y') - recessionEl.getBoundingClientRect().height
	    };
	  } else {
	    // To the right of the y-axis label.
	    xy.x += MARGIN;
	    return xy;
	  }
	}
	
	function getTopAxisLabelXY(highchart, options) {
	  var axis = highchart.axes[1];
	  var tickPos = axis.tickPositions[options.axes.reversed ? 0 : axis.tickPositions.length - 1];
	  return axis.ticks[tickPos].label.xy;
	}
	
	function drawItemLines(highchart, options, g, xy) {
	  var MARGIN = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
	  var line = { x1: 0, x2: 0, y: xy.y + MARGIN };
	  options.sortedAnnotations.forEach(function (item) {
	    if (item.position.show) {
	      writePathPoints(highchart, item, MARGIN);
	    }
	  });
	
	  // Bump jointed lines down when overlapping to left.
	  var prevItem = null;
	  var addPx = MARGIN / 2;
	  options.sortedAnnotations.forEach(function (item) {
	    if (item.position.show) {
	      if (item.path.length > 4) {
	        if (prevItem && prevItem.position.gx < prevItem.position.tx && prevItem.pathRect.x + prevItem.pathRect.width + MARGIN >= item.pathRect.x) {
	          item.path[3] += addPx;
	          item.path[5] += addPx;
	          addPx += MARGIN / 2;
	        } else {
	          addPx = MARGIN / 2;
	        }
	        prevItem = item;
	      }
	    }
	  });
	
	  // Bump jointed lines down when overlapping to right.
	  prevItem = null;
	  options.sortedAnnotations.reverse().forEach(function (item) {
	    if (item.position.show) {
	      if (item.path.length > 4) {
	        if (prevItem && prevItem.position.gx > prevItem.position.tx && prevItem.pathRect.x <= item.pathRect.x + item.pathRect.width + MARGIN) {
	          item.path[3] += addPx;
	          item.path[5] += addPx;
	          addPx += MARGIN / 2;
	        } else {
	          addPx = MARGIN / 2;
	        }
	        prevItem = item;
	      }
	    }
	  });
	
	  options.sortedAnnotations.reverse().forEach(function (item) {
	    if (item.position.show) {
	      drawLine(highchart, options, item, g);
	    }
	  });
	}
	
	function drawLine(highchart, options, item, g) {
	  var p = item.attach.point;
	  var c = item.attach.category;
	  var lineEnd = item.lineEnd || options.defaults.annotations.lineEnd;
	  var path = item.path.slice(0);
	  var lineOffset = getOffsetLineEnd(lineEnd, options);
	  if (lineEnd === 'nothing' && (options.type === 'column' && c.enabled || options.type !== 'column')) {
	    lineOffset = 0;
	  } else if (path.length > 4 && path[path.length - 1] + lineOffset < path[path.length - 3]) {
	    lineOffset = 0;
	  }
	  path.splice(0, 0, 'M');
	  path.splice(3, 0, 'L');
	  var isWSJIncreaseOffset = options.product === 'wsj' ? 4 : 0;
	  path[path.length - 1] += lineOffset + isWSJIncreaseOffset;
	  if (options.product === 'wsj') path[2] += 2;
	  if (!(item.showLine === false)) {
	    highchart.renderer.path(path).attr({ 'stroke': COLOR, 'stroke-width': options.print ? 0.5 : 1 }).add(g);
	  }
	  drawLineEnd(highchart, g, path, lineEnd, options.print, options.product);
	}
	
	function drawLineEnd(highchart, g, path, lineEnd, isPrint, product) {
	  var isWSJ = product === 'wsj' ? -2 : -1;
	  isWSJ = isPrint ? -3 : isWSJ;
	  var endPt = {
	    x: path[path.length - 2],
	    y: Math.ceil(path[path.length - 1]) + isWSJ
	  };
	  if (lineEnd === 'arrow') {
	    drawLineEndArrow(highchart, g, endPt, isPrint);
	  } else if (lineEnd === 'dot') {
	    drawLineEndDot(highchart, g, endPt, isPrint);
	  } else if (lineEnd === 'circle') {
	    drawLineEndCircle(highchart, g, endPt, isPrint);
	  }
	}
	
	function drawLineEndArrow(highchart, g, endPt, isPrint) {
	  var size = isPrint ? 3.5 : 6.5;
	  var side = Math.sqrt(size * size - size / 2 * (size / 2));
	  var path = ['M', endPt.x - size * 0.5, endPt.y, 'L', endPt.x + size * 0.5, endPt.y, endPt.x, endPt.y + side];
	  highchart.renderer.path(path).attr({
	    fill: COLOR
	  }).add(g);
	}
	
	function drawLineEndDot(highchart, g, endPt, isPrint) {
	  var radius = isPrint ? 1.5 : 3;
	  highchart.renderer.circle(endPt.x, endPt.y + 4, radius).attr({
	    fill: COLOR
	  }).add(g);
	}
	
	function drawLineEndCircle(highchart, g, endPt, isPrint) {
	  var radius = isPrint ? 4 : 8;
	  highchart.renderer.circle(endPt.x, endPt.y + radius, radius).attr({
	    stroke: COLOR,
	    'stroke-width': isPrint ? 0.5 : 1,
	    fill: 'transparent'
	  }).add(g);
	}
	
	function writePathPoints(highchart, item, MARGIN) {
	  item.position.gx = gxShift(item.position.gx, highchart.plotLeft);
	  item.position.gy += highchart.plotTop;
	  item.position.gy = Math.round(item.position.gy);
	  var ty = item.position.ty + 4;
	  var jointY = Math.max(highchart.plotTop + MARGIN / 2, Math.min(ty + MARGIN, item.position.gy));
	  var isStraight = checkPositions(item.position);
	  var points = [isStraight ? item.position.gx : item.position.tx, ty];
	  if (isStraight) {
	    // Line descends straight from text to graphic.
	    points.push(item.position.gx, item.position.gy);
	  } else {
	    // Line is not straight.
	    points.push(item.position.tx, jointY);
	    points.push(item.position.gx, jointY);
	  }
	  if (item.position.gy > points[points.length - 1]) {
	    // Descend from top of line/break to graphic.
	    points.push(item.position.gx, Math.max(item.position.gy, jointY));
	  }
	  item.path = points;
	  item.pathRect = getPathRect(points);
	}
	
	function getPathRect(points) {
	  var x1 = Number.MAX_VALUE;
	  var x2 = Number.MIN_VALUE;
	  var y1 = Number.MAX_VALUE;
	  var y2 = Number.MIN_VALUE;
	  points.forEach(function (pt, index) {
	    if (index % 2 === 0) {
	      x1 = pt < x1 ? pt : x1;
	      x2 = pt > x2 ? pt : x2;
	    } else {
	      y1 = pt < y1 ? pt : y1;
	      y2 = pt > y2 ? pt : y2;
	    }
	  });
	  return {
	    x: x1,
	    y: y2,
	    width: x2 - x1,
	    height: y2 - y1
	  };
	}
	
	function getStartX(el) {
	  return +el.getAttribute('x');
	}
	
	function getWidth(el) {
	  return el.getBoundingClientRect().width;
	}
	
	function checkOverlap(position, margin, recession, suffix) {
	  var lineTopX = findLineTop(position, margin);
	  var overlap = void 0;
	  if (recession && lineTopX >= recession.startX && lineTopX <= recession.endX) {
	    overlap = recession;
	  } else if (suffix && lineTopX <= suffix.endX) {
	    overlap = suffix;
	  } else {
	    overlap = { type: 'none' };
	  }
	  return [lineTopX, overlap];
	}
	
	function findLineTop(position, margin) {
	  // determine which x value will be used for top of line
	  var gx = gxShift(position.gx, margin);
	  var tx = txShift(position);
	  var straightLine = checkPositions({ gx: gx, tx: tx, width: position.width });
	  return straightLine ? gx : tx;
	}
	
	function txShift(position) {
	  // shift top of line to middle of annotation
	  return Math.round(position.tx + position.width / 2);
	}
	
	function gxShift(gx, margin) {
	  // adjust for left edge of chart
	  return Math.round(gx + margin);
	}
	
	function adjustPosition(item, highchart, tx, midpoint, direction) {
	  // if needed, shift annotation so jointed line will wrap around recession label
	  var gxShifted = gxShift(item.position.gx, highchart.plotLeft);
	  var txShifted = txShift({ tx: tx, width: item.position.width });
	  var deltaX = findDelta(gxShifted, txShifted);
	  var straightLine = checkPositions({ gx: gxShifted, tx: txShifted, width: item.position.width });
	  if (straightLine) {
	    var multiplier = direction === 'left' ? -1 : 1;
	    tx += (midpoint - deltaX) * multiplier;
	  };
	  item.position.tx = tx;
	}
	
	function findDelta(gx, tx) {
	  return Math.abs(gx - tx);
	}
	
	function checkPositions(position) {
	  var deltaX = findDelta(position.gx, position.tx);
	  return deltaX <= position.width / 2;
	}
	
	function checkSuffix(item, margin, recession, suffix) {
	  // hide item if pushed into suffix label
	  var checkSuffix = checkOverlap(item.position, margin, recession, suffix);
	  if (checkSuffix[1].type === 'suffix') item.position.show = false;
	}
	
	// The pointer line/connector must be adjusted per lineEnd type.
	function getOffsetLineEnd(lineEnd, options) {
	  switch (lineEnd) {
	    case 'dot':
	      return 0;
	    case 'circle':
	      return options.print ? -4 : -8;
	    case 'arrow':
	      return options.print ? -4.25 : -8.5;
	    // case 'nothing':
	    default:
	      return options.print ? -1 : -2;
	  }
	}
	
	function getSortedAnnotations(options) {
	  return options.annotations.slice(0).sort(function (a, b) {
	    return sortOnPointIndex(a, b, options);
	  });
	}
	
	// Sort so that annotations go left to right (smallest index to highest).
	function sortOnPointIndex(a, b, options) {
	  return getItemIndex(a, options) - getItemIndex(b, options);
	}
	
	// Return index either of point or of category for sorting.
	function getItemIndex(annotation, options) {
	  for (var i = 0, keys = Object.keys(annotation.attach); i < keys.length; i++) {
	    if (annotation.attach[keys[i]].enabled) {
	      var index = getPointIndex(options.series[0].data, annotation.attach[keys[i]].index);
	      return index;
	      // return annotation.attach[keys[i]].index;
	    }
	  }
	}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = axesPostRenderXAxis;
	
	var _util = __webpack_require__(9);
	
	var _transform = __webpack_require__(5);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _axesCommon = __webpack_require__(14);
	
	var _constants = __webpack_require__(2);
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function axesPostRenderXAxis(highchart, options, style) {
	  if (options.product === 'wsj' && !options.print) {
	    highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0].setAttribute('style', 'font-variant-numeric: tabular-nums;');
	  }
	  if (options.type === 'bar') {
	    formatBarChartLabels(highchart, options);
	  } else {
	    if (options.categoriesAreDates) {
	      updateDateLabels(highchart, options, style);
	    } else {
	      updateCategoryLabels(highchart, options);
	      if (false) {
	        if (options.product === 'marketwatch' && options.type === 'line') {
	          adjustFirstXAxisTick(highchart.axes[0], false, false);
	        }
	      }
	      if (false) {
	        if (options.product === 'financialnews' && options.type === 'line') {
	          adjustFirstXAxisTick(highchart.axes[0], false, false);
	        }
	      }
	    }
	  }
	  updateForMW(highchart, options);
	}
	
	function updateForMW(highchart, options) {
	  if (false) {
	    if (options.product === 'marketwatch' && options.type === 'line') {
	      var xAxisTicks = highchart.xAxis[0].ticks;
	      var xAxisTicksAsArr = Object.keys(xAxisTicks);
	      var firstTick = xAxisTicksAsArr[0];
	      var lastTick = xAxisTicksAsArr[xAxisTicksAsArr.length - 1];
	      for (var x in xAxisTicks) {
	        var highchartXAxisGrid = highchart.container.getElementsByClassName('highcharts-xaxis-grid')[0];
	        var highchartXAxisGridFirstEl = highchartXAxisGrid.firstElementChild.getAttribute('class');
	        var highchartXAxisGridLastEl = highchartXAxisGrid.lastElementChild.getAttribute('class');
	        var hasFirstAddedVerticalGridline = highchartXAxisGridFirstEl === 'add-vertical-gridline';
	        var hasLastAddedVerticalGridline = highchartXAxisGridLastEl === 'add-vertical-gridline';
	        var evalBoth = hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline;
	        if (evalBoth) {
	          if (xAxisTicks[x].label.element.parentElement) {} else {
	            xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	          }
	        } else {
	          if (!hasFirstAddedVerticalGridline && !hasLastAddedVerticalGridline) {
	            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst || xAxisTicks[x].isLast) {} else {
	              if (!xAxisTicks[x].isFirst || !xAxisTicks[x].isLast) {
	                xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	              }
	            }
	          }
	          if (!hasFirstAddedVerticalGridline && hasLastAddedVerticalGridline) {
	            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst) {} else {
	              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	            }
	          }
	          if (!hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline) {
	
	            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isLast) {} else {
	              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function formatBarChartLabels(highchart, options) {
	  if (!options.allowCategoriesLinebreak) {
	    (0, _util.forAxisTicks)(highchart.xAxis[0], function (tick) {
	      var tspan = tick.label.element.querySelectorAll('tspan');
	      if (tspan.length > 1) {
	        // Move the top tspan down to center it vertically in its space:
	        var labelY = +tick.label.element.getAttribute('y');
	        var tspanY = +tspan[1].getAttribute('dy') / 2 * (tspan.length - 1);
	        tick.label.element.setAttribute('y', labelY + tspanY);
	
	        // Replace last 4 characters with an ellipsis (4 instead of 3 to be
	        // ensure nothing is cut off at left):
	        var textStr = tspan[0].textContent.substr(0, tspan[0].textContent.length - 4) + '...';
	        tspan[0].innerHTML = textStr;
	
	        // Remove the extra tspans:
	        for (var i = 1; i < tspan.length; i++) {
	          element.removeChild(tspan[i]);
	        }
	      }
	    });
	  }
	}
	
	// Remove category ticks and labels that are redudant or overlapping.
	function updateCategoryLabels(highchart, options) {
	  if (options.removeOverlappingCategories) {
	    var maxWidth = 0;
	    var ticksShown = [];
	    (0, _util.forAxisTicks)(highchart.xAxis[0], function (tick, index) {
	      if (tick.label.textStr === index) {
	        removeTick(tick);
	      } else {
	        maxWidth = Math.max(maxWidth, tick.labelLength);
	        ticksShown.push(tick);
	      }
	    });
	    var maxLabels = Math.floor(highchart.xAxis[0].width / maxWidth) || 0;
	    var skip = Math.ceil(ticksShown.length / maxLabels);
	    if (skip > 1) {
	      var removeNum = 0;
	      for (var i = 0; i < ticksShown.length; i++) {
	        if (removeNum > 0 && removeNum < skip) {
	          removeTick(ticksShown[i]);
	        }
	        if (++removeNum === skip) {
	          removeNum = 0;
	        }
	      }
	    }
	  }
	}
	
	// Remove date ticks and labels that are redudant or overlapping.
	function updateDateLabels(highchart, options, styles) {
	  var axis = highchart.axes[0];
	  if (options.type === 'column') {
	    var categoriesLen = options.categories[0].length;
	    if (options.quarterlyResults && categoriesLen > 9) {
	      // centerCategoriesBetweenBars(axis, options);
	    } else {
	      if (axis.tickInterval < _axesCommon.YEAR_MILLISECONDS) {
	        // TODO: Re-enable this but with long ticks, better rules.
	        // centerCategoriesBetweenBars(axis, options);
	        // centerLabelsBetweenBars(highchart, options);
	      }
	    }
	  }
	  if (options.quarterlyResults && options.series[0].data.length <= 44) {
	    //   ensureMultipleLinesForQuarterlyResults(highchart, styles);
	    removeOverlappingQuarterlyResults(axis, options, styles);
	  } else {
	    var skipNum = getDatesSkipNum(axis, styles.MARGIN);
	    var startNum = formatDateLabels(axis, options, skipNum);
	    removeAmPm(axis, options);
	    var isMwOrFn = options.product === 'marketwatch' || options.product === 'financialnews' ? true : false;
	    var tickArray = Object.keys(axis.ticks);
	    if (options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	      var isAnIntervalOfOne = options.xAxisInterval.split(' ')[0] === '1' && options.xAxisInterval !== '1 week' ? true : false;
	      if (isAnIntervalOfOne || options.xAxisInterval === 'auto') {
	        removeOverlappingDates(axis, options, skipNum, startNum, styles);
	        if (options.xAxisInterval === '1 day') {
	          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	        }
	      } else {
	        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
	          addMinorTick(axis, options, styles, highchart);
	        }
	        if (isMwOrFn) {
	          if (options.xAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.xAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && options.type === 'column') {
	          if (options.xAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.xAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && !options.showMinorTicks) {
	          if (options.xAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.xAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	      }
	    }
	
	    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== undefined) {
	      var isAnIntervalOfOneMob = options.mobileXAxisInterval.split(' ')[0] === '1' && options.mobileXAxisInterval !== '1 week' ? true : false;
	      if (isAnIntervalOfOneMob || options.mobileXAxisInterval === 'auto') {
	        removeOverlappingDates(axis, options, skipNum, startNum, styles);
	        if (options.mobileXAxisInterval === '1 day') {
	          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	        }
	      } else {
	        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
	          addMinorTick(axis, options, styles, highchart);
	        }
	        if (isMwOrFn) {
	          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && options.type === 'column') {
	          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	        if (!isMwOrFn && !options.showMinorTicks) {
	          if (options.mobileXAxisInterval === '1 week') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
	          }
	          if (options.mobileXAxisInterval === '3 months') {
	            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
	          }
	        }
	      }
	    }
	  }
	  if (options.fiscalYears && !options.quarterlyResults) {
	    addFY(axis);
	  }
	  replaceApostrophes(axis);
	  adjustLastXAxisTick(axis);
	  ensureTickSpacing(axis, options, styles);
	  if (false) {
	    if (options.product === 'marketwatch' && options.type === 'line') {
	      adjustFirstXAxisTick(axis, true, false);
	    }
	    if (options.product === 'marketwatch' && options.type === 'column' && options.quarterlyResults && options.size === 'marketwatch-4u-inset') {
	      adjustFirstXAxisTick(axis, false, true);
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews' && options.type === 'line') {
	      adjustFirstXAxisTick(axis, true, false);
	    }
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      if (!options.showMinorTicks) {
	        makeTickShorter(axis, options, styles, highchart);
	      }
	      var xGridTickGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
	      var xGridLabelGroup = highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0];
	      if (!options.print) {
	        if (options.showMinorTicks) {
	          xGridLabelGroup.setAttribute('transform', 'translate(0, -0.5)');
	        } else {
	          xGridLabelGroup.setAttribute('transform', 'translate(0, -2.5)');
	        }
	      }
	
	      if (xGridTickGroup.children.length - 1 === xGridLabelGroup.children.length && options.showMinorTicks) {
	        if (!options.print) xGridLabelGroup.setAttribute('transform', 'translate(0, -2.5)');
	        makeTickShorter(axis, options, styles, highchart);
	      }
	    }
	  }
	}
	
	// Moves ticks to between bars by shifting them to the left by half the space
	// between ticks. For use when x-axis date labels are categories and not actual
	// dates, such as quarterly data.
	function centerCategoriesBetweenBars(axis, options) {
	  var tickSpacing = Math.round(getTickSpacing(axis) * 0.5);
	  var x = [];
	  (0, _util.forAxisTicks)(axis, function (tick, tickPos, index) {
	    var markD = transform.read(tick.mark.element, 'd');
	    x[index] = markD[0][0] - tickSpacing; // + 0.5;
	  });
	  moveAxisLabels(axis, x);
	}
	
	// Move a series tick marks and labels to specific x positions.
	function moveAxisLabels(axis, x) {
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (x[index] !== null && x[index] !== undefined) {
	      var markD = transform.read(tick.mark.element, 'd');
	      markD[0][0] = markD[1][0] = Math.round(x[index]) + 0.5;
	      transform.write(tick.mark.element, 'd', markD[0], markD[1]);
	      tick.label.element.setAttribute('x', x[index]);
	      var tspan = tick.label.element.querySelectorAll('tspan');
	      for (var i = 0; i < tspan.length; i++) {
	        tspan[i].setAttribute('x', x[index]);
	      }
	    }
	  });
	}
	
	// Get number of x-axis date labels that overlap and therefore must be removed.
	function getDatesSkipNum(axis, margin) {
	  // At least 2 points are needed if one is to overlap another.
	  if (axis.tickPositions.length >= 2) {
	    var widest = 0;
	    var tickDistance = Math.max(2, getTickSpacing(axis) - margin);
	    (0, _util.forAxisTicks)(axis, function (tick) {
	      var width = tick.label.element.getBoundingClientRect().right + margin - tick.label.element.getBoundingClientRect().left;
	      widest = Math.max(widest, width);
	    });
	    var skipNum = normalizeSkipNumber(Math.ceil(widest / tickDistance));
	    var skipLabels = Math.floor(axis.tickPositions.length / skipNum);
	    var maxLabels = Math.floor(axis.width / widest);
	    while (skipLabels > maxLabels) {
	      skipNum = normalizeSkipNumber(Math.ceil(widest / --tickDistance));
	      skipLabels = Math.floor(axis.tickPositions.length / skipNum);
	    }
	    return skipNum;
	  }
	  return 0;
	}
	
	// When overlapping date labels are removed, this returns a number that is more
	// normal to skip over: 10 instead of 9 or 5 instead of 3.
	function normalizeSkipNumber(skip) {
	  if (skip > 2 && skip < 5) {
	    return 5;
	  } else if (skip > 5 && skip < 10) {
	    return 10;
	  } else if (skip > 10 && skip < 15) {
	    return 15;
	  } else if (skip > 15 && skip < 20) {
	    return 20;
	  } else if (skip > 20 && skip < 25) {
	    return 25;
	  } else if (skip > 25 && skip < 50) {
	    return 50;
	  } else if (skip > 50 && skip < 100) {
	    return 100;
	  }
	  return skip;
	}
	
	// Returns the distance/space between the first two ticks of an axis.
	function getTickSpacing(axis) {
	  var spacing = 0;
	  if (axis.tickPositions.length > 1) {
	    var t1 = axis.ticks[axis.tickPositions[0]];
	    var t2 = axis.ticks[axis.tickPositions[1]];
	    var d1 = transform.read(t1.mark.element, 'd');
	    var d2 = transform.read(t2.mark.element, 'd');
	    spacing = d2[0][0] - d1[0][0];
	  }
	  return spacing;
	}
	
	// Format x-axis dates that are not quarterly results nor fiscal years.
	function formatDateLabels(axis, options, skipNum) {
	  var dateType = null;
	  var startNum = 0;
	  skipNum = skipNum || 0;
	
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var str = tick.label.textStr;
	
	    if (/^(\d{4})\b/.test(str)) {
	      dateType = 'year';
	    } else if (options.dateTimeLabelFormat === '%e. %b') {
	      dateType = 'month-date';
	    } else if (options.dateTimeLabelFormat === '%b \'%y') {
	      dateType = 'month-year';
	    }
	    if (skipNum >= 2) {
	      if (+str % skipNum === 0) {
	        startNum = index;
	        return false;
	      }
	    } else {
	      return false;
	    }
	  });
	
	  if (dateType === 'year') {
	    formatYears(axis, startNum);
	  } else if (dateType === 'month-year') {
	    // This just removes duplicated years; we don't actually want to do this yet.
	    // formatMonthYear(axis, startNum);
	  } else if (dateType === 'month-date') {
	    formatMonthDate(axis, startNum);
	  }
	  return startNum;
	}
	
	// Called from formatXAxisDates().
	function formatYears(axis, startNum) {
	  var century = void 0;
	  var tmpCentury = void 0;
	  var abbrYear = void 0;
	  var prevStr = void 0;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (index >= startNum) {
	      var str = tick.label.textStr + '';
	      if (str === prevStr) {
	        prevStr = str;
	        removeTick(tick);
	      } else {
	        prevStr = str;
	        // Format: 1980 '90 2000 '10
	        tmpCentury = str.substr(0, 2);
	        if (tmpCentury === century) {
	          str = tick.label.textStr = _constants.APOSTROPHE + str.substr(2);
	          tick.label.element.innerHTML = str;
	        } else {
	          century = tmpCentury;
	        }
	        var apostMatch = str.match(/\u2019(\d\d)/);
	        if (apostMatch) {
	          if (abbrYear === undefined || abbrYear !== apostMatch[1]) {
	            abbrYear = apostMatch[1];
	          } else if (abbrYear === apostMatch[1]) {
	            var apostIndex = str.indexOf(_constants.APOSTROPHE);
	            if (apostIndex > 0) {
	              str = str.substr(0, apostIndex - 1);
	              tick.label.element.innerHTML = str;
	            }
	          }
	        }
	      }
	    }
	  });
	}
	
	// Called from formatXAxisDates().
	function formatMonthYear(axis, startNum) {
	  var year = undefined;
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    if (tick.label.element.parentElement) {
	      var label = tick.label.element.innerHTML.split(' ');
	      if (label.length === 2) {
	        if (label[1] === year) {
	          tick.label.textStr = tick.label.element.innerHTML = label[0];
	        } else {
	          year = label[1];
	        }
	      }
	    }
	  });
	}
	
	// Called from formatXAxisDates().
	function formatMonthDate(axis, startNum) {
	  var month = undefined;
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    if (tick.label.element.parentElement) {
	      var label = tick.label.element.innerHTML.split(' ');
	      if (label.length === 2 && _constants.MONTHS.indexOf(label[0]) !== -1) {
	        if (label[0] === month) {
	          tick.label.textStr = tick.label.element.innerHTML = label[1];
	        } else {
	          month = label[0];
	        }
	      }
	    }
	  });
	}
	
	// Remove superflous am/pm.
	function removeAmPm(axis, options) {
	  var am = void 0;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (tick.label.element.parentElement) {
	      var str = tick.label.textStr + '';
	      if (index === 0) {
	        if (str.indexOf(' a.m.') !== -1) {
	          am = 'a';
	        } else if (str.indexOf(' p.m.') !== -1) {
	          am = 'p';
	        } else if (str === 'noon') {
	          am = null;
	        } else {
	          // Timescale is not hours.
	          return;
	        }
	      } else if (str !== 'noon') {
	        var amIndex = str.indexOf(' a.m.');
	        var tmpAm = amIndex !== -1 ? 'a' : 'p';
	        if (amIndex === -1) {
	          amIndex = str.indexOf(' p.m.');
	        }
	        if (amIndex !== -1) {
	          if (tmpAm === am) {
	            tick.label.element.innerHTML = str.substr(0, amIndex);
	          } else {
	            am = tmpAm;
	          }
	        }
	      }
	    }
	  });
	}
	
	// For overlapping quarterly results, remove labels that do not mention years.
	function removeOverlappingQuarterlyResults(axis, options, styles) {
	  var tick0 = axis.ticks[axis.tickPositions[0]];
	  var rect0 = tick0.label.element.getBoundingClientRect();
	  var totalSkips = 0;
	  var skips = 1;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (index > 0) {
	      if (rect0 === null && totalSkips > 0) {
	        if (tick.label.element.innerHTML) {
	          if (skips > 0 && totalSkips > 1 && options.xAxisInterval === 'auto') {
	            removeDateTick(tick, options, styles);
	          }
	          if (++skips >= totalSkips) {
	            skips = 0;
	          }
	        }
	      } else {
	        if (tick.label.element.innerHTML) {
	          var rect = tick.label.element.getBoundingClientRect();
	          if (rect0.right + styles.MARGIN >= rect.left && options.xAxisInterval === 'auto') {
	            removeDateTick(tick, options, styles);
	          } else {
	            rect0 = null;
	          }
	          ++totalSkips;
	        }
	      }
	    }
	  });
	}
	
	// Removes overlapping datetime labels, accounting for context of datetime
	// labels before and after.
	function removeOverlappingDates(axis, options, skipNum, startNum, styles) {
	  var prevStr = null;
	  var label = null;
	  var isMY = options.dateTimeLabelFormat === '%b \'%y';
	  var isHM = /^\%H\:\%M/.test(options.dateTimeLabelFormat);
	  var axisTickLen = axis.tickPositions.length;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    if (axisTickLen >= 2 && skipNum >= 2) {
	      if (!(skipNum < 2 || (index - startNum) % skipNum === 0)) {
	        removeDateTick(tick, options, styles);
	      }
	    }
	    if (tick.label.element.parentElement) {
	      if (isMY) {
	        label = tick.label.textStr.split(' ');
	        if (label[1] === prevStr) {
	          tick.label.element.innerHTML = label[0];
	        }
	        prevStr = label[1];
	      } else if (isHM) {
	        label = tick.label.textStr;
	        if (label === prevStr) {
	          removeDateTick(tick, options, styles);
	        }
	        prevStr = label;
	      }
	    }
	  });
	}
	
	// If fiscalYears, add 'FY' to first label.
	function addFY(axis) {
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    if (tick.label.element.parentElement) {
	      tick.label.element.innerHTML = 'FY' + tick.label.textStr;
	      return false;
	    }
	  });
	}
	
	// Ensures curly apostrophes render correctly.
	function replaceApostrophes(axis) {
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    var str = tick.label.element.innerHTML + '';
	    tick.label.element.innerHTML = str.replace(_constants.APOSTROPHE, '&rsquo;');
	  });
	}
	
	function adjustLastXAxisTick(axis) {
	  var tick = axis.ticks[axis.tickPositions[axis.tickPositions.length - 1]];
	  var markX = transform.read(tick.mark.element, 'd')[0][0];
	  var labelWidth = tick.label.element.getBoundingClientRect().width;
	  var offset = axis.left + axis.width - (markX + labelWidth / 2);
	  tick.label.element.setAttribute('x', markX + Math.min(0, offset));
	  tick.label.element.setAttribute('text-anchor', 'middle');
	}
	
	function adjustFirstXAxisTick(axis, isDateTime, isColQuarterly) {
	  var tick = axis.ticks[axis.tickPositions[0]];
	  var markX = transform.read(tick.mark.element, 'd')[0][0];
	  var labelWidth = tick.label.element.getBoundingClientRect().width;
	  if (labelWidth / 2 > markX && !isColQuarterly) {
	    if (isDateTime) {
	      tick.label.element.setAttribute('x', labelWidth / 2);
	    } else {
	      tick.label.element.setAttribute('text-anchor', 'left');
	    }
	  } else {
	    tick.label.element.setAttribute('x', markX);
	  }
	  if (isColQuarterly) {
	    var barContainerX = axis.chart.container.getElementsByClassName('highcharts-series-0')[0].firstElementChild.getAttribute('x');
	    if (barContainerX <= 0) {
	      tick.label.element.setAttribute('text-anchor', 'left');
	      tick.label.element.setAttribute('x', 2);
	      tick.label.element.children[1].setAttribute('x', 2);
	    }
	  }
	}
	
	// Ensures ticks are spaced adequately apart by removing ticks that are too
	// close together.
	function ensureTickSpacing(axis, options, styles) {
	  var MIN = 4;
	  var longs = [];
	  var dx = void 0;
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var markEl = tick.mark.element;
	    if (markEl.parentElement && Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH) {
	      longs.push(index);
	    }
	  });
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var markEl = tick.mark.element;
	    if (markEl.parentElement) {
	      var d = transform.read(null, 'd', tick.mark.d);
	      if (dx === undefined) {
	        dx = d[0][0];
	      }
	      if (longs.indexOf(index) === -1) {
	        if (d[0][0] - dx <= MIN) {
	          element.removeChild(markEl);
	        } else {
	          var n = -1;
	          var longFwd = longs.some(function (longIndex) {
	            n = longIndex;
	            return longIndex > index;
	          });
	          if (longFwd) {
	            var longTickF = axis.ticks[axis.tickPositions[n]];
	            var dlf = transform.read(null, 'd', longTickF.mark.d);
	            if (dlf[0][0] - d[0][0] <= MIN) {
	              element.removeChild(markEl);
	            }
	          }
	          if (markEl.parentElement) {
	            var longBck = longs.some(function (longIndex) {
	              n = longIndex;
	              return longIndex < index;
	            });
	            if (longBck) {
	              var longTickB = axis.ticks[axis.tickPositions[n]];
	              var dlb = transform.read(null, 'd', longTickB.mark.d);
	              if (d[0][0] - dlb[0][0] <= MIN) {
	                element.removeChild(markEl);
	              }
	            }
	          }
	          dx = d[0][0];
	        }
	      } else {
	        dx = d[0][0];
	      }
	    }
	  });
	}
	
	// Removes a date tick and label or replaces it with a short tick depending
	// on the context.
	function removeDateTick(tick, options, styles) {
	  var labelEl = tick.label.element;
	  var markEl = tick.mark.element;
	  element.removeChild(labelEl);
	  if (!options.showMinorTicks) {
	    element.removeChild(markEl);
	  }
	  if (options.type === 'column') {
	    element.removeChild(markEl);
	  } else if (Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH && options.showMinorTicks) {
	    var d = transform.read(null, 'd', tick.mark.d);
	    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
	    transform.write(markEl, 'd', d);
	  }
	}
	
	function addMinorTick(axis, options, styles, highchart) {
	  var xAxisGridGroup = axis.chart.axes[0].gridGroup.element;
	  if (xAxisGridGroup.children.length > 1) {
	    var firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
	    var secondInGroupD = transform.read(null, 'd', xAxisGridGroup.children[1].getAttribute('d'));
	    var interval = void 0;
	    var unit = void 0;
	    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
	      interval = options.mobileXAxisInterval.split(' ')[0];
	      unit = options.mobileXAxisInterval.split(' ')[1];
	    }
	    if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	      interval = options.xAxisInterval.split(' ')[0];
	      unit = options.xAxisInterval.split(' ')[1];
	    }
	    interval = unit === 'week' ? 7 : interval;
	    var diff = (secondInGroupD[0][0] - firstInGroupD[0][0]) / parseInt(interval);
	    (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	      var labelEl = tick.label.element;
	      var markEl = tick.mark.element;
	      var d = transform.read(null, 'd', tick.mark.d);
	      if (options.dates[0].year % interval !== 0 && options.dates[0].month === 1 || unit === 'months' || unit === 'week') {
	        var backD = transform.read(null, 'd', tick.mark.d);
	        var firstTick = void 0;
	        if (unit === 'years') {
	          firstTick = index === 0 ? parseInt(tick.label.element.children[0].innerHTML) : firstTick;
	        }
	        if (unit === 'months') {
	          var label = tick.label.textStr.split(' ')[0];
	          var labelMonthValue = findMonthValue(label);
	          firstTick = index === 0 ? labelMonthValue : firstTick;
	        }
	        if (unit === 'week') {
	          firstTick = index === 0 ? parseInt(tick.label.textStr.split(' ')[1]) : firstTick;
	        }
	        var benchmark = void 0;
	        if (unit === 'years') {
	          benchmark = firstTick - options.dates[0].year;
	        }
	        if (unit === 'months') {
	          benchmark = firstTick - options.dates[0].month - 1;
	        }
	        if (unit === 'week') {
	          benchmark = options.dates[0].date > firstTick ? firstTick + 30 - options.dates[0].date : firstTick - options.dates[0].date;
	        }
	        for (var w = 0; w < benchmark; w++) {
	          appendToXGridGroup(highchart, diff, styles, backD, false);
	        }
	      }
	
	      var tickArray = Object.keys(tick.axis.ticks);
	      var lastTick = tickArray[tickArray.length - 1];
	      var isLastTick = tick.pos === tick.axis.ticks[lastTick].pos ? true : false;
	      if (!isLastTick) {
	        for (var i = 0; i < interval - 1; i++) {
	          appendToXGridGroup(highchart, diff, styles, d, true);
	        }
	      } else {
	        var lastBenchmark = void 0;
	        if (unit === 'years') {
	          lastBenchmark = options.dates[options.dates.length - 1].year - parseInt(tick.label.textCache.split(',')[0]);
	        }
	        if (unit === 'months') {
	          var _label = tick.label.textStr.split(' ')[0];
	          var _labelMonthValue = findMonthValue(_label);
	          lastBenchmark = options.dates[options.dates.length - 1].month - _labelMonthValue;
	        }
	        if (unit === 'week') {
	          lastBenchmark = options.dates[options.dates.length - 1].month.date - parseInt(tick.label.textStr.split(' ')[1]);
	        }
	        for (var _i = 0; _i < lastBenchmark; _i++) {
	          appendToXGridGroup(highchart, diff, styles, d, true);
	        }
	      }
	
	      var isMonth = unit === 'months' ? true : false;
	      if (unit === 'months' || unit === 'week') {
	        styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth);
	      }
	    });
	  }
	  // if (xAxisGridGroup.children.length === 1) {
	  //   const firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
	  //   let interval;
	  //   let unit;
	  //   if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
	  //     interval = options.mobileXAxisInterval.split(' ')[0];
	  //     unit = options.mobileXAxisInterval.split(' ')[1];
	  //   } 
	  //   if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	  //     interval = options.xAxisInterval.split(' ')[0];
	  //     unit = options.xAxisInterval.split(' ')[1];
	  //   }
	  //   let firstDate;
	  //   let lastDate;
	  //   if (unit === 'years') {
	  //     firstDate = options.dates[0].year;
	  //     lastDate = options.dates[options.dates.length - 1].year;
	  //   }
	  //   if (unit === 'months') {
	  //     firstDate = options.dates[0].month;
	  //     lastDate = options.dates[options.dates.length - 1].month;
	  //   }
	  //   if (unit === 'week') {
	  //     firstDate = options.dates[0].date;
	  //     lastDate = options.dates[options.dates.length - 1].date;
	  //   }
	  //   const axisTicksKey = Object.keys(axis.ticks);
	  //   const xAxisGridLine = highchart.container.getElementsByClassName('highcharts-axis-line')[0];
	  //   const xAxisGridLineD = xAxisGridLine.getAttribute('d');
	  //   const gridLineD = transform.read(null, 'd', xAxisGridLineD);
	  //   const d = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
	  //   const secD = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
	  //   const isWeekOrYear = unit === 'years' ? axis.ticks[axisTicksKey[0]].label.textStr : axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[1];
	  //   let diff = unit !== 'months' ? parseInt(isWeekOrYear) - firstDate : 
	  //     findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]) - firstDate;
	  //   let diffLast = unit !== 'months' ? lastDate - parseInt(isWeekOrYear) : 
	  //     lastDate - findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]);
	  //   const diffBetweenFirstDataPoint = Math.round(d[0][0] / diff);
	  //   for (let u = 0; u < diff; u++) {
	  //     if (d[0][0] - diffBetweenFirstDataPoint >= gridLineD[0][0]) {
	  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, d, false);
	  //     }
	  //   }
	  //   for (let y = 0; y < diffLast; y++) {
	  //     if (secD[1][0] + diffBetweenFirstDataPoint <= gridLineD[1][0]) {
	  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, secD, true);
	  //     }
	  //   }
	  // }
	}
	
	function appendToXGridGroup(highchart, diff, styles, d, isAfterFirstTick) {
	  var newPath = highchart.renderer.path().attr({
	    'opacity': 1
	  });
	  if (isAfterFirstTick) {
	    d[0][0] = d[0][0] + diff;
	    d[1][0] = d[1][0] + diff;
	  } else {
	    d[0][0] = d[0][0] - diff;
	    d[1][0] = d[1][0] - diff;
	  }
	  d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
	  newPath = transform.write(newPath.element, 'd', d);
	  newPath.setAttribute('stroke-width', 1);
	  newPath.setAttribute('stroke', '#333333');
	  var gridGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
	  gridGroup.appendChild(newPath);
	}
	
	// Removes a tick label and grid line.
	function removeTick(tick) {
	  element.removeChild(tick.label.element);
	  element.removeChild((tick['gridLine'] || tick['mark']).element);
	}
	
	function styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth) {
	  var firstTick = tickArray[0];
	  var firstTickVal = isMonth ? axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[1] : axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[0];
	  var landMarkTicks = [firstTickVal];
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    var tickVal = tick.label.textStr;
	    var tickValUnit = isMonth ? tickVal.split(' ')[1] : tickVal.split(' ')[0];
	    if (landMarkTicks.indexOf(tickValUnit) !== -1 && index !== 0) {
	      var arrayVal = isMonth ? 0 : 1;
	      if (tick.label.element.children.length > 0) {
	        tick.label.element.children[0].innerHTML = tickVal.split(' ')[arrayVal];
	      } else {
	        tick.label.element.innerHTML = tickVal.split(' ')[arrayVal];
	      }
	    } else {
	      landMarkTicks.push(tickValUnit);
	    }
	  });
	}
	
	function findMonthValue(label) {
	  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  return months.indexOf(label);
	}
	
	function makeTickShorter(axis, options, styles, highchart) {
	  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	    // const labelEl = tick.label.element;
	    var markEl = tick.mark.element;
	    var d = transform.read(null, 'd', tick.mark.d);
	    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
	    transform.write(markEl, 'd', d);
	  });
	}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = axesPostRenderYAxis;
	
	var _transform = __webpack_require__(5);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _util = __webpack_require__(9);
	
	var _constants = __webpack_require__(2);
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Manipulates the SVG drawn by Highcharts to update the scale (Y) axis.
	 */
	function axesPostRenderYAxis(highchart, options, styles) {
	  // The scale axis is always the Y axis, even on bar charts where the scale
	  // axis visually is the X axis:
	  // for wsj yaxis labels, set to tabular-nums
	  if (!options.print && options.product === 'wsj') {
	    highchart.container.getElementsByClassName('highcharts-yaxis-labels')[0].setAttribute('style', 'font-variant-numeric: tabular-nums;');
	  }
	
	  var axis = highchart.axes[1];
	  if ((0, _util.isVerticalType)(options.type)) {
	    makeDecimalsConsistent(axis);
	    extendTicks(axis, options);
	  } else {
	    shiftLastHorizontalBarLine(highchart, options);
	  }
	  setZeroLineToBlack(axis, options);
	
	  insertZeroesForEmptyBars(highchart.renderer, axis, options);
	  if (options.type === 'column' || options.type === 'bar') {
	    moveZeroLineToTop(highchart.container, axis, options);
	  }
	  ensureLabelsFit(axis, options, highchart);
	
	  if (true) {
	    if (options.product === 'wsj') {
	      moveTopLabel(axis, options);
	    }
	  }
	
	  addSuffix(highchart.renderer, axis, options, styles, highchart);
	}
	
	// Set line representing the zero value to black.
	function setZeroLineToBlack(axis, options) {
	  var zeroTick = axis.ticks[0];
	  if (false) {
	    if (options.product === 'marketwatch' && options.type === 'column') {
	      return;
	    }
	  }
	  if (zeroTick) {
	    zeroTick.gridLine.element.setAttribute('stroke', '#000');
	
	    if (true) {
	      if (options.product === 'wsj') {
	        zeroTick.gridLine.element.setAttribute('stroke', options.styles.axes.zeroGridLine.color);
	      }
	    }
	  }
	}
	
	function makeDecimalsConsistent(axis) {
	  var zeroIndex = axis.tickPositions.indexOf(0);
	  var maxDecimals = getMaxTicksDecimals(axis);
	  if (maxDecimals > 0) {
	    (0, _util.forAxisTicks)(axis, function (tick, key, index) {
	      var textStr = tick.label.textStr;
	      var indexDot = textStr.indexOf('.');
	      var decimals = indexDot === -1 ? 0 : textStr.length - indexDot - 1;
	      if (key === 0) {
	        textStr += '<tspan fill-opacity="0">';
	      }
	      if (indexDot === -1) {
	        indexDot = textStr.length;
	        textStr += '.';
	      }
	      while (decimals++ < maxDecimals) {
	        textStr += '0';
	      }
	      if (key === 0) {
	        textStr += '</tspan>';
	      }
	      tick.label.textStr = textStr;
	      tick.label.element.innerHTML = textStr;
	    });
	  }
	}
	
	// Extend grid lines under the label text on the y-axis (for "vertical" axes).
	function extendTicks(axis, options) {
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    var line = tick.gridLine.element;
	    if (line.hasAttribute('d')) {
	      var d = transform.read(line, 'd');
	      d[0][0] = 0;
	      if (options.spaceAddedForAnnotations) {
	        d[1][0] += options.print ? _constants.ANNOTATIONS_SPACE_PRINT : _constants.ANNOTATIONS_SPACE;
	      }
	      transform.write(line, 'd', d);
	      // const d = line.getAttribute('d').split(/\s/g);
	      // d[1] = 0;
	      // if (options.spaceAddedForAnnotations) {
	      //   console.log('???');
	      // }
	      // line.setAttribute('d', d.join(' '));
	    }
	  });
	}
	
	function getMaxTicksDecimals(axis) {
	  var maxDecimals = 0;
	  (0, _util.forAxisTicks)(axis, function (tick, pos) {
	    var decimal = tick.label.textStr.split('.')[1];
	    if (decimal !== undefined) {
	      maxDecimals = Math.max(decimal.length, maxDecimals);
	    }
	  });
	  return maxDecimals;
	}
	
	// Add units suffix string to the top tick label (`isLast`).
	function addSuffix(renderer, axis, options, styles, highchart) {
	  if (options.axes.units && (0, _util.isVerticalType)(options.type)) {
	    for (var key in axis.ticks) {
	      var ok1 = options.axes.reversed && axis.ticks[key].isFirst;
	      var ok2 = !options.axes.reversed && axis.ticks[key].isLast;
	      if (ok1 || ok2) {
	        var label = axis.ticks[key].label.element;
	
	        // To align the 0 properly with other labels without having
	        // decimals, the decimals are made inivisible. But this means
	        // any units suffix must be offset to not show up to the right
	        // of these invisible decimals but instead right next to the 0.
	        var tspan = label.querySelector('tspan');
	        var xOffset = 0;
	        if (tspan && tspan.getAttribute('opacity') === '0') {
	          var tspanInnerHTML = label.innerHTML + '';
	          var labelFullWidth = label.getBoundingClientRect().width;
	          label.innerHTML = '0';
	          var labelTmpWidth = label.getBoundingClientRect().width;
	          xOffset = labelTmpWidth - labelFullWidth;
	          label.innerHTML = tspanInnerHTML;
	        }
	
	        var unitStr = options.product === 'financialnews' ? options.axes.units.suffix : options.axes.units.suffix.replace(/^\s+/, _constants.NBSP);
	        if ((options.type === 'line' || options.type === 'column') && options.product === 'marketwatch') {
	          label.innerHTML = label.innerHTML + '<tspan>' + ' ' + unitStr + '</tspan>';
	          break;
	        }
	        if ((options.type === 'line' || options.type === 'column') && options.product === 'financialnews') {
	          if (options.axes.units.suffix !== "%") {
	            var labelYVal = label.getAttribute('y');
	            var highChartContainer = highchart.container;
	            var newLabelYVal = labelYVal - 7;
	            styles.NORMAL_STYLE.fontSize = 10;
	            styles.NORMAL_STYLE.color = '#555555';
	            var firstYAxisLabel = highChartContainer.getElementsByClassName('highcharts-yaxis-labels')[0].lastElementChild.getBoundingClientRect().right;
	            var suffix = renderer.text(unitStr, +label.getAttribute('x'), +newLabelYVal).css(styles.NORMAL_STYLE).add();
	            suffix.element.setAttribute('class', 'units y-axis-suffix');
	            var suffixRight = suffix.element.getBoundingClientRect().right;
	            var currentSuffX = suffix.element.getAttribute('x');
	            var diff = suffixRight - firstYAxisLabel;
	            suffix.element.setAttribute('x', currentSuffX - diff);
	
	            // suffix.element.setAttribute('x', currentSuffX - diff);
	            break;
	          } else {
	            label.innerHTML = label.innerHTML + '<tspan>' + unitStr + '</tspan>';
	            break;
	          }
	        } else {
	          var css = styles.NORMAL_STYLE;
	
	          if (true) {
	            if (options.product === 'wsj') {
	              css = Object.assign({}, css, {
	                fontSize: styles.AXES.label.fontSize,
	                color: styles.AXES.label.color,
	                fill: styles.AXES.label.color
	              });
	            }
	          }
	
	          var _suffix = renderer.text(unitStr, +label.getAttribute('x') + xOffset, +label.getAttribute('y')).css(css).add();
	          var currentY = _suffix.element.getAttribute('y');
	          _suffix.element.setAttribute('class', 'units y-axis-suffix');
	          // aligns the suffix with the label
	          if (!options.print) {
	            _suffix.element.setAttribute('y', +currentY + .5);
	          }
	          break;
	        }
	      }
	    }
	  }
	}
	
	// On vertical bar / column charts, insert a small '0' in place of bars that
	// have a zero value, so that it does not look like an error.
	function insertZeroesForEmptyBars(renderer, axis, options) {
	  var typeOk = options.type === 'column';
	  var stackOk = !options.stacking || axis.series.length === 1;
	  if (typeOk && stackOk) {
	    var series = axis.series;
	    var allLessThanZero = allValuesLessThanZero(axis);
	    var g = [];
	    axis.series.forEach(function (series) {
	      series.data.forEach(function (item) {
	        if (item.y === 0) {
	          var el = item.graphic.element;
	          var translate = transform.read(el.parentElement, 'translate');
	          var x = +el.attributes.x.value + translate[0];
	          var y = +el.attributes.y.value + translate[1];
	          var smallStyle = options.styles.get('small');
	          if (options.product === 'wsj') {
	            smallStyle.color = '#555555';
	          } else {
	            smallStyle.color = item.color;
	          }
	          x += +el.attributes.width.value / 2;
	          y += allLessThanZero ? parseFloat(options.styles.get('small').fontSize) : -4;
	          var text = renderer.text('0', x, y).attr({ 'text-anchor': 'middle' }).css(smallStyle).add();
	          g.push({ type: '0', el: text.element });
	        } else if (item.graphic) {
	          g.push({ type: 'bar', el: item.graphic.element });
	        }
	      });
	    });
	
	    // Sort by `left` position.
	    g.sort(function (a, b) {
	      return a.el.getBoundingClientRect().left - b.el.getBoundingClientRect().left;
	    });
	
	    // Check if 0s overlap bars or other 0s and, if so, remove.
	    for (var i = 0; i < g.length - 1; i++) {
	      if (g[i].type === '0') {
	        var r1 = g[i].el.getBoundingClientRect();
	        var r2 = g[i + 1].el.getBoundingClientRect();
	        if (r1.right + 2 > r2.left) {
	          element.removeChild(g[i].el);
	        }
	      }
	    }
	  }
	}
	
	// Returns true if all values are <= 0.
	function allValuesLessThanZero(axis) {
	  return axis.series.every(function (series) {
	    return series.data.every(function (item) {
	      return item.y <= 0;
	    });
	  });
	}
	
	// In Highcharts, grid lines ares places under lines and columns, which is
	// fine. But we want the 0 line to be above (as in z or depth).
	function moveZeroLineToTop(container, axis, options) {
	  var zero = axis.ticks[0];
	  if (zero) {
	    var el = zero.gridLine.element;
	    if (true) {
	      if (options.size === 'print-wsj') {
	        var d = transform.read(el, 'd');
	        if (options.type === 'bar') {
	          d[0][0] = Math.floor(d[0][0]) - 0.5;
	          d[1][0] = d[0][0];
	        } else {
	          d[0][1] = Math.ceil(d[0][1]);
	          d[1][1] = d[0][1];
	        }
	        transform.write(el, 'd', d);
	      }
	    }
	    container.querySelector('.highcharts-series-group').appendChild(el);
	  }
	}
	
	// Sometimes Highcharts lets labels slip off the edge of chart, as if it
	// measured the label width using a short label. Push the labels over so they
	// all fit.
	function ensureLabelsFit(axis, options, highchart) {
	  // ensureHorizontalLabelsFit(axis);
	  if (options.type === 'bar') {
	    if (!options.axes.reversed) {
	      ensureHorizontalLabelsFit(axis);
	    }
	  } else {
	    ensureVerticalLabelsFit(axis, options, highchart);
	  }
	}
	
	function ensureHorizontalLabelsFit(axis) {
	  var key = axis.tickPositions[axis.tickPositions.length - 1];
	  var tick = axis.ticks[key];
	  var el = tick.label.element;
	  var x2 = tick.label.xy.x + el.getBoundingClientRect().width / 2;
	  var dif = axis.left + axis.width - x2;
	  tick.label.xy.x += dif;
	  if (dif < 0) {
	    el.setAttribute('x', +el.getAttribute('x') + dif);
	  }
	}
	
	function ensureVerticalLabelsFit(axis, options, highchart) {
	  var maxWidth = 0;
	  (0, _util.forAxisTicks)(axis, function (tick) {
	    var width = tick.label.element.getBoundingClientRect().width;
	    maxWidth = Math.max(maxWidth, width);
	  });
	  maxWidth = Math.ceil(maxWidth);
	  if (options.product !== "marketwatch" && options.product !== 'financialnews') {
	    (0, _util.forAxisTicks)(axis, function (tick) {
	      tick.label.element.setAttribute('x', maxWidth);
	    });
	  } else {
	    if (false) {
	      if (options.product === 'financialnews') {
	        if (options.type === 'line' || options.type === 'column') {
	          var highChartContainer = highchart.container;
	          var labelsG = highChartContainer.getElementsByClassName('highcharts-yaxis-labels');
	          var translateValue = options.print === true ? 'translate(0, 5)' : 'translate(0, 6)';
	          labelsG[0].attributes.transform.nodeValue = translateValue;
	          var gElRectLabels = highChartContainer.getElementsByClassName('highcharts-yaxis-labels')[0];
	          var gElRectRightLabels = gElRectLabels.getBoundingClientRect().right;
	          var gElRectLabelsChildren = gElRectLabels.children;
	          var horizontalGridLineArr = highChartContainer.getElementsByClassName('highcharts-yaxis-grid')[0].children;
	          var gWidth = gElRectLabels.getBoundingClientRect().width;
	          if (options.type === 'line') {
	            // translate the yaxis labels to the right based on width of surround g element
	            gElRectLabels.setAttribute('transform', 'translate(' + gWidth + ',' + '6)');
	            for (var _i = 0; _i < gElRectLabelsChildren.length; _i++) {
	              gElRectLabelsChildren[_i].setAttribute('text-anchor', 'end');
	              // if there's a 0 in yaxis labels remove the extra space/zero
	              var hasZero = gElRectLabels.children[_i].innerHTML === '0' || gElRectLabels.children[_i].innerHTML[1] === '<' ? true : false;
	              if (hasZero) {
	                gElRectLabels.children[_i].children[0].innerHTML = '';
	              }
	              var currentXVal = Number(gElRectLabelsChildren[_i].getAttribute('x'));
	              var dValue = transform.read(horizontalGridLineArr[_i], 'd');
	              var lastHorizontalGridLineElD = horizontalGridLineArr[_i].getAttribute('d').split(' ');
	              var childWidth = gElRectLabelsChildren[_i].getBoundingClientRect().width;
	              // extend horizontal gridlines to match position of label, which is now right aligned. highcharts positions them to be left aligned and all horizontal gridlines end at some point, thereby having same length
	              lastHorizontalGridLineElD[3] = currentXVal + gWidth - childWidth - 2 + "," + dValue[1][1];
	              // if first yaxis label has a percentage sign, decrease length of horizontal gridline to account for extra space that % creates
	              lastHorizontalGridLineElD[3] = options.axes.units.suffix === '%' && _i === gElRectLabelsChildren.length - 1 ? currentXVal + gWidth - childWidth - 15 + "," + dValue[1][1] : lastHorizontalGridLineElD[3];
	              // make sure first gridline has proper length
	              lastHorizontalGridLineElD[3] = options.axes.units.prefix !== "" && _i === gElRectLabelsChildren.length - 1 ? currentXVal - gWidth * 0.125 + "," + dValue[1][1] : lastHorizontalGridLineElD[3];
	              lastHorizontalGridLineElD[2] = '';
	              lastHorizontalGridLineElD = lastHorizontalGridLineElD.join(' ');
	              horizontalGridLineArr[_i].setAttribute('d', lastHorizontalGridLineElD);
	            }
	          }
	        }
	        if (options.type !== 'line' && options.type !== 'column') {
	          (0, _util.forAxisTicks)(axis, function (tick) {
	            tick.label.element.setAttribute('x', maxWidth);
	          });
	        }
	      }
	    }
	    if (false) {
	      if (options.type === 'line' && options.product === 'marketwatch') {
	        var _highChartContainer = highchart.container;
	        var xAxisGrid = _highChartContainer.getElementsByClassName('highcharts-xaxis-grid')[0];
	        var lastVerticalGridLineEl = xAxisGrid.lastElementChild;
	        var firstVerticalGridLineEl = xAxisGrid.firstElementChild;
	        var _horizontalGridLineArr = _highChartContainer.getElementsByClassName('highcharts-yaxis-grid')[0].children;
	        // x value of last point
	        var lastPoint = !options.irregularDates ? highchart.xAxis[0].series[0].data[highchart.xAxis[0].series[0].data.length - 1].clientX : options.series[0].data[options.series[0].data.length - 1].x;
	        // x value of first point
	        var firstPoint = !options.irregularDates ? highchart.xAxis[0].series[0].data[0].clientX : options.series[0].data[0].x;
	        var borderCoord = document.getElementsByClassName('highcharts-plot-background')[1].getBoundingClientRect();
	        // get first D values of first and last vertical grid lines
	        var splitVerticalGridLineElCheck = lastVerticalGridLineEl.getAttribute('d').split(/(?=[LMC])/);
	        var splitVerticalGridLineElFirstCheck = firstVerticalGridLineEl.getAttribute('d').split(/(?=[LMC])/);
	        splitVerticalGridLineElFirstCheck = Math.round(splitVerticalGridLineElFirstCheck[0].split(' ')[1]);
	        splitVerticalGridLineElCheck = Math.round(splitVerticalGridLineElCheck[1].split(' ')[1]);
	        var roundFirstPoint = Math.round(firstPoint);
	        var roundLastPoint = Math.round(lastPoint);
	        // find the difference between first/last x point and d values
	        var diffBetweenFirstAndGridEl = roundFirstPoint - splitVerticalGridLineElFirstCheck;
	        var diffBetweenLastAndGridEl = roundLastPoint - splitVerticalGridLineElCheck;
	        var splitVerticalGridLineElFirst = transform.read(firstVerticalGridLineEl, 'd')[0][0];
	
	        // if first vertical gridline diff between first x point and first vertical grid line d value is negative AND
	        // if diff between last vertical gridline x point and d value is greater than one, draw a border around chart and extend
	        // horizontal gridlines to that border
	        var comparisonValue = -5;
	        if (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'marketwatch-4u-inset') {
	          comparisonValue = 0;
	        }
	        if (diffBetweenFirstAndGridEl < comparisonValue && diffBetweenLastAndGridEl >= 0) {
	
	          for (var i = 0; i < _horizontalGridLineArr.length; i++) {
	            var _dValue = transform.read(_horizontalGridLineArr[i], 'd');
	            var _lastHorizontalGridLineElD = _horizontalGridLineArr[i].getAttribute('d').split(' ');
	            if (firstPoint < splitVerticalGridLineElFirstCheck) {
	              _lastHorizontalGridLineElD[1] = (firstPoint - 1).toString() + ',' + _dValue[0][1].toString();
	            } else {
	              _lastHorizontalGridLineElD[1] = (splitVerticalGridLineElFirst - 0.5).toString() + ',' + _dValue[0][1].toString();
	            }
	            _lastHorizontalGridLineElD[3] = (lastPoint + 1).toString() + "," + _dValue[1][1];
	            _lastHorizontalGridLineElD[2] = '';
	            _lastHorizontalGridLineElD = _lastHorizontalGridLineElD.join(' ');
	            _horizontalGridLineArr[i].setAttribute('d', _lastHorizontalGridLineElD);
	            if (i === 0 || i === _horizontalGridLineArr.length - 1) {
	              _horizontalGridLineArr[i].setAttribute('stroke-width', 2);
	            }
	          }
	          addLastVerticalGridline(lastVerticalGridLineEl, firstVerticalGridLineEl, firstPoint, lastPoint, highchart, xAxisGrid, false);
	          addFirstVerticalGridline(firstVerticalGridLineEl, lastVerticalGridLineEl, lastPoint, firstPoint, highchart, xAxisGrid, false);
	        }
	        // extend horizontal gridlines to first and last x value
	        else {
	            for (var i = 0; i < _horizontalGridLineArr.length; i++) {
	              var _dValue2 = transform.read(_horizontalGridLineArr[i], 'd');
	              var _lastHorizontalGridLineElD2 = _horizontalGridLineArr[i].getAttribute('d').split(' ');
	              if (firstPoint < splitVerticalGridLineElFirstCheck) {
	                _lastHorizontalGridLineElD2[1] = (firstPoint - 1).toString() + ',' + _dValue2[0][1].toString();
	              } else {
	                _lastHorizontalGridLineElD2[1] = firstPoint - splitVerticalGridLineElFirstCheck >= 5 ? firstPoint.toString() + ',' + _dValue2[0][1].toString() : splitVerticalGridLineElFirst.toString() + ',' + _dValue2[0][1].toString();
	              }
	              _lastHorizontalGridLineElD2[3] = (lastPoint + 1).toString() + "," + _dValue2[1][1];
	              _lastHorizontalGridLineElD2[2] = '';
	              _lastHorizontalGridLineElD2 = _lastHorizontalGridLineElD2.join(' ');
	              _horizontalGridLineArr[i].setAttribute('d', _lastHorizontalGridLineElD2);
	              if (i === 0 || i === _horizontalGridLineArr.length - 1) {
	                _horizontalGridLineArr[i].setAttribute('stroke-width', 2);
	              }
	            }
	            // if diff between first x point and first d value is less than or equal to one AND
	            // diff between last x point and last d value is greater one, then add a vertical gridline to end of chart
	            if (diffBetweenLastAndGridEl > 1 || !options.categoriesAreDates) {
	              addLastVerticalGridline(lastVerticalGridLineEl, firstVerticalGridLineEl, firstPoint, lastPoint, highchart, xAxisGrid, true);
	            }
	            if (diffBetweenLastAndGridEl < 1 && diffBetweenLastAndGridEl > 0) {
	              // if diff between first x and first d value is greater than one, draw vertical gridline at beginning of chart
	              if (firstPoint < splitVerticalGridLineElFirstCheck) {
	                addFirstVerticalGridline(firstVerticalGridLineEl, lastVerticalGridLineEl, lastPoint, firstPoint, highchart, xAxisGrid, true);
	              }
	            }
	            if (diffBetweenLastAndGridEl === 0 || diffBetweenFirstAndGridEl === 0) {
	              if (Math.round(firstPoint) > splitVerticalGridLineElFirstCheck) {
	
	                thickenFirstLine(firstVerticalGridLineEl, splitVerticalGridLineElFirstCheck, true);
	                thickenLastLine(lastVerticalGridLineEl, lastPoint, true);
	              } else {
	                thickenLastLine(lastVerticalGridLineEl, lastPoint, false);
	                thickenFirstLine(firstVerticalGridLineEl, firstPoint, false);
	              }
	            }
	          }
	
	        var _labelsG = _highChartContainer.getElementsByClassName('highcharts-yaxis-labels');
	        var _translateValue = 'translate(0, 6)';
	        _labelsG[0].attributes.transform.nodeValue = _translateValue;
	      }
	      if (options.type === 'column' && options.product === 'marketwatch') {
	        var _highChartContainer2 = highchart.container;
	        var _labelsG2 = _highChartContainer2.getElementsByClassName('highcharts-yaxis-labels');
	        var _translateValue2 = 'translate(0, 6)';
	        _labelsG2[0].attributes.transform.nodeValue = _translateValue2;
	      }
	
	      if (options.type !== "line" && options.type !== 'column') {
	        (0, _util.forAxisTicks)(axis, function (tick) {
	          tick.label.element.setAttribute('x', maxWidth);
	        });
	      }
	    }
	  }
	}
	
	function shiftLastHorizontalBarLine(highchart, options) {
	  var axis = highchart.axes[1];
	  (0, _util.forAxisTicksReverse)(axis, function (tick) {
	    if (tick.isLast) {
	      var d = transform.read(tick.gridLine.element, 'd');
	      d[0][0] -= 1;
	      d[1][0] = d[0][0];
	      transform.write(tick.gridLine.element, 'd', d);
	      // break:
	      return false;
	    }
	  });
	}
	
	function addFirstVerticalGridline(firstVerticalGridLineEl, lastVerticalGridLineEl, lastPoint, firstPoint, highchart, xAxisGrid, thickenOpposite) {
	  var newFirstPath = firstVerticalGridLineEl;
	  var newFirstPathD = newFirstPath.getAttribute('d').split(' ');
	  newFirstPathD[1] = firstPoint.toString();
	  newFirstPathD[4] = firstPoint.toString();
	  var newFirstPathStroke = newFirstPath.getAttribute('stroke');
	  var newFirstPathOpacity = newFirstPath.getAttribute('opacity');
	  var elementPathFirst = highchart.renderer.path(newFirstPathD).attr({
	    stroke: newFirstPathStroke,
	    fill: 'none',
	    'stroke-width': 2,
	    class: 'add-vertical-gridline',
	    opacity: newFirstPathOpacity
	  });
	  xAxisGrid.insertBefore(elementPathFirst.element, firstVerticalGridLineEl);
	  if (thickenOpposite) {
	    thickenLastLine(lastVerticalGridLineEl, lastPoint);
	  }
	}
	
	function addLastVerticalGridline(lastVerticalGridLineEl, firstVerticalGridLineEl, firstPoint, lastPoint, highchart, xAxisGrid, thickenOpposite) {
	  var newLastPath = lastVerticalGridLineEl;
	  var newLastPathD = newLastPath.getAttribute('d').split(' ');
	  var newLastPathStroke = newLastPath.getAttribute('stroke');
	  var newLastPathOpacity = newLastPath.getAttribute('opacity');
	  newLastPathD[4] = lastPoint.toString();
	  newLastPathD[1] = lastPoint.toString();
	  var elementPath = highchart.renderer.path(newLastPathD).attr({
	    stroke: newLastPathStroke,
	    fill: 'none',
	    'stroke-width': 2,
	    class: 'add-vertical-gridline',
	    opacity: newLastPathOpacity
	  });
	  xAxisGrid.appendChild(elementPath.element);
	  if (thickenOpposite) {
	    thickenFirstLine(firstVerticalGridLineEl, firstPoint);
	  }
	}
	
	function thickenFirstLine(firstVerticalGridLineEl, firstPoint) {
	  var newFirstPath = firstVerticalGridLineEl;
	  var newFirstPathD = newFirstPath.getAttribute('d').split(' ');
	  var newFirstPathDSecond = Number(newFirstPathD[2]);
	  var newFirstPathLast = Number(newFirstPathD[newFirstPathD.length - 1]);
	  newFirstPathD[1] = firstPoint.toString();
	  newFirstPathD[4] = firstPoint.toString();
	  newFirstPathD = newFirstPathD.join(' ');
	  firstVerticalGridLineEl.setAttribute('d', newFirstPathD);
	  firstVerticalGridLineEl.setAttribute('stroke-width', 2);
	}
	
	function thickenLastLine(lastVerticalGridLineEl, lastPoint) {
	  var newLastPath = lastVerticalGridLineEl;
	  var newLastPathD = newLastPath.getAttribute('d').split(' ');
	  var newLastPathStroke = newLastPath.getAttribute('stroke');
	  var newLastPathOpacity = newLastPath.getAttribute('opacity');
	  var newLastPathDSecond = Number(newLastPathD[2]);
	  var newLastPathLast = Number(newLastPathD[newLastPathD.length - 1]);
	  newLastPathD[4] = lastPoint.toString();
	  newLastPathD[1] = lastPoint.toString();
	  newLastPathD = newLastPathD.join(' ');
	  lastVerticalGridLineEl.setAttribute('d', newLastPathD);
	  lastVerticalGridLineEl.setAttribute('stroke-width', 2);
	}
	
	function moveTopLabel(axis, options) {
	  var isColumn = options.type === 'column';
	  var isPrint = options.size === 'print-wsj';
	  var is8u = options.size === '8u';
	
	  for (var tick in axis.ticks) {
	    if (axis.ticks[tick].isLast) {
	      var topTick = axis.ticks[tick];
	      var label = axis.ticks[tick].label.element;
	      var position = +label.getAttribute('y');
	      var offset = -2;
	
	      if (is8u) {
	        offset = -1;
	      }
	
	      if (isColumn) {
	        offset = -1;
	      }
	
	      if (isPrint) {
	        offset = -.5;
	      }
	
	      var newPostition = position + offset;
	      label.setAttribute('y', newPostition);
	    }
	  }
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = axesPostRender;
	
	var _axesPostrenderYAxis = __webpack_require__(143);
	
	var _axesPostrenderYAxis2 = _interopRequireDefault(_axesPostrenderYAxis);
	
	var _axesPostrenderXAxis = __webpack_require__(142);
	
	var _axesPostrenderXAxis2 = _interopRequireDefault(_axesPostrenderXAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function axesPostRender(highchart, options, styles) {
	  makeLinesCrisp(highchart, options);
	  if (options.type !== 'pie') {
	    (0, _axesPostrenderYAxis2.default)(highchart, options, styles);
	    (0, _axesPostrenderXAxis2.default)(highchart, options, styles);
	  }
	
	  if (true) {
	    if (options.product === 'wsj' && options.print && options.type !== 'bar' && options.type !== 'pie') {
	      var suffix = highchart.container.getElementsByClassName('units y-axis-suffix')[0];
	      suffix.style.fill = 'rgb(0, 0, 0)';
	    }
	  }
	
	  if (options.print && options.type === 'bar') {
	    var barCont = highchart.container.getElementsByClassName('highcharts-bar-series');
	    for (var i = 0; i < barCont.length; i++) {
	      var highchartBarG = barCont[i];
	      var highchartBarGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartBarG.getAttribute('transform'));
	      var xValTranslate = parseInt(highchartBarGTransformVal[1]) - 1.5;
	      highchartBarG.transform.baseVal.getItem(0).setTranslate(xValTranslate, parseInt(highchartBarGTransformVal[2]));
	    }
	  }
	  if (options.print && options.type === 'column') {
	    if (options.product === 'wsj') {
	      var seriesGroup = highchart.container.getElementsByClassName('highcharts-series-group')[0];
	      var seriesGroupTransformVal = seriesGroup.transform.baseVal.getItem(0).matrix.f;
	      var seriesGroupYVal = seriesGroupTransformVal - 1;
	      seriesGroup.transform.baseVal.getItem(0).setTranslate(0, seriesGroupYVal);
	    }
	    var colCont = highchart.container.getElementsByClassName('highcharts-column-series');
	    for (var _i = 0; _i < colCont.length; _i++) {
	      var highchartColumnG = colCont[_i];
	      var highchartColumnGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartColumnG.getAttribute('transform'));
	      var yValTranslate = parseInt(highchartColumnGTransformVal[2]) + 1;
	      highchartColumnG.transform.baseVal.getItem(0).setTranslate(parseInt(highchartColumnGTransformVal[1]), yValTranslate);
	    }
	    if (options.product === 'wsj') {
	      var rectGroup = highchart.container.getElementsByClassName('highcharts-point');
	      for (var h = 0; h < rectGroup.length; h++) {
	        var rect = rectGroup[h];
	        var rectHeight = parseInt(rect.getAttribute('height'));
	        var rectY = parseInt(rect.getAttribute('y'));
	        rect.setAttribute('height', rectHeight + 1);
	        rect.setAttribute('y', rectY - 2);
	      }
	    }
	  }
	
	  if (true) {
	    if (options.product === 'wsj' && options.type === 'bar') {
	      var yAxis = highchart.container.getElementsByClassName('highcharts-yaxis-labels');
	      yAxis[0].setAttribute('transform', 'translate(0, 2)');
	
	      // align h-bar xAxis labels to the left
	      var xAxis = highchart.container.getElementsByClassName('highcharts-xaxis-labels');
	      var xLabels = xAxis[0].childNodes;
	
	      xLabels.forEach(function (label) {
	        label.setAttribute('x', '0');
	        label.setAttribute('text-anchor', 'start');
	
	        var tspans = label.childNodes;
	
	        tspans.forEach(function (tspan) {
	          tspan.setAttribute('x', '0');
	        });
	      });
	    }
	  }
	}
	
	// Ensures lines are offset by 0.5 to ensure crispness.
	// TODO: If ever combining inner and outer charts, revisit this function!
	function makeLinesCrisp(highchart, options) {
	  var g = highchart.container.querySelectorAll('svg > g');
	
	  for (var i = 0; i < g.length; i++) {
	    var list = g[i].classList;
	
	    if (!list.contains('highcharts-legend')) {
	      g[i].setAttribute('transform', 'translate(0, 0.5)');
	    }
	
	    if (true) {
	      if (options.product === 'wsj') {
	        if (list.contains('highcharts-xaxis')) {
	          g[i].setAttribute('transform', 'translate(0, ' + options.styles.tick.yOffset + ')');
	        }
	      }
	    }
	  }
	}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = axesPreRender;
	exports.formatterYAxisLabel = formatterYAxisLabel;
	
	var _format = __webpack_require__(4);
	
	var format = _interopRequireWildcard(_format);
	
	var _constants = __webpack_require__(2);
	
	var _axesCommon = __webpack_require__(14);
	
	var _zero = __webpack_require__(6);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isPrint = void 0;
	
	function axesPreRender(data, options, styles) {
	  data = writeCommonOptions(data, options);
	  switch (options.type) {
	    case 'pie':
	      return data;
	    case 'bar':
	      data = writeHorizontalOptions(data, options, styles);
	      break;
	    default:
	      data = writeVerticalOptions(data, options, styles);
	      break;
	  }
	  if (options.product !== 'financialnews') {
	    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#bfbfbf' : '#e6e6e6';
	  } else {
	    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#000000' : '#e6e6e6';
	  }
	
	  data.tooltip.enabled = options.showTooltips && !options.print ? true : false;
	
	  data = writeMinMax(data, options);
	  if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
	    tickIntervalCalc(options, data, true);
	  }
	  if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
	    tickIntervalCalc(options, data, false);
	  }
	
	  if (!options.yAxisMobileEnabled && options.yAxisMobileInterval !== '' && options.yAxisMobileInterval !== undefined && options.width < 620) {
	    setTickIntervalForYAxis(options, data, true);
	  }
	
	  if (options.yAxisInterval !== '' && options.yAxisInterval !== undefined && (options.width >= 620 || options.yAxisMobileEnabled)) {
	    setTickIntervalForYAxis(options, data, false);
	  }
	
	  return data;
	}
	
	function setTickIntervalForYAxis(options, data, isMobile) {
	  var typeOfInterval = isMobile ? 'yAxisMobileInterval' : 'yAxisInterval';
	  var interval = options[typeOfInterval];
	  if (interval !== '') {
	    data.yAxis.tickInterval = Number(interval);
	  }
	}
	
	function tickIntervalCalc(options, data, isMobile) {
	  var typeOfInterval = isMobile ? 'mobileXAxisInterval' : 'xAxisInterval';
	  var interval = options[typeOfInterval].split(' ')[0];
	  var unit = options[typeOfInterval].split(' ')[1];
	  if (unit === 'years' || unit === 'year') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000 * 365 * parseInt(interval);
	  }
	  if (unit === 'months' || unit === 'month') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000 * 30 * parseInt(interval);
	  }
	  if (unit === 'day') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000;
	  }
	  if (unit === 'week') {
	    data.xAxis.tickInterval = 24 * 3600 * 1000 * 7;
	  }
	}
	
	// Options common to all charts with axes.
	function writeCommonOptions(data, options) {
	  var offsetVal = 0;
	  var oppositeVal = false;
	  var horizontalGridLineStyle = 'solid';
	  if (options.type === 'line' || options.type === 'area') {
	    data.plotOptions.series.connectNulls = options.connectEmptyDataPoints;
	  }
	  if (false) {
	    if (options.product === "marketwatch" && options.type === 'line') {
	      offsetVal = 4;
	      oppositeVal = true;
	    }
	    if (options.product === 'marketwatch' && options.type === 'column') {
	      horizontalGridLineStyle = 'dash';
	      oppositeVal = true;
	      offsetVal = 8;
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
	      oppositeVal = true;
	      offsetVal = 4;
	    }
	  }
	
	  var endOnTick = options.axes.maxYAxisValue ? false : true;
	  var startOnTick = options.axes.minYAxisValue ? false : true;
	
	  data.xAxis = {
	    title: { text: '' },
	    tickColor: '#000000'
	  };
	  data.yAxis = {
	    title: { text: '' },
	    tickColor: '#000000',
	    offset: offsetVal,
	    opposite: oppositeVal,
	    gridLineDashStyle: horizontalGridLineStyle,
	    endOnTick: endOnTick,
	    startOnTick: startOnTick
	  };
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.xAxis.tickColor = options.styles.tick.color;
	    }
	  }
	  // data.yAxis.opposite = true;
	  // if (options.stacking === 'normal') {
	  // data.yAxis.max = 100;
	  // }
	  return data;
	}
	
	// Writes chart options for bar charts (i.e., horizontal bars).
	function writeHorizontalOptions(data, options, styles) {
	  if (Array.isArray(options.categories)) {
	    data.xAxis.categories = getCategoryLabels(options.categories[0]);
	  }
	  data.xAxis.tickLength = 0;
	  data.xAxis.offset = -2;
	  data.xAxis.lineWidth = 0;
	  data.yAxis.gridLineWidth = 1;
	
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.yAxis.gridLineWidth = 0.5;
	    }
	  }
	
	  var lineHeight = styles.BOLD_STYLE.fontSize;
	  data.xAxis.labels = {
	    style: (0, _lodash2.default)({}, styles.BOLD_STYLE, {
	      whiteSpace: 'wrap', textOverflow: 'visible', lineHeight: lineHeight
	    }),
	    // step: 1,
	    x: -7,
	    y: options.print ? 3 : undefined
	    // format: '{value}',
	  };
	
	  if (options.axes.shown) {
	    data.yAxis.reversedStacks = false;
	    data.yAxis.opposite = true;
	    data.yAxis.reversed = !!options.axes.reversed;
	    data.yAxis.labels = {
	      y: -5,
	      style: (0, _lodash2.default)({}, styles.NORMAL_STYLE, { whiteSpace: 'nowrap', textOverflow: 'visible`' }),
	      autoRotation: false,
	      formatter: function formatter() {
	
	        var special = options.axes.reversed && this.isLast || !options.axes.reversed && this.isFirst;
	        return formatterBarYAxisLabel(options.axes.units, this.value, special);
	      }
	    };
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
	        fontSize: options.styles.axes.label.bar.x.fontSize,
	        fontWeight: options.styles.axes.label.bar.x.fontWeight,
	        lineHeight: options.styles.axes.label.bar.x.lineHeight
	      });
	
	      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
	        fontSize: options.styles.axes.label.bar.y.fontSize,
	        fontWeight: options.styles.axes.label.bar.y.fontWeight,
	        lineHeight: options.styles.axes.label.bar.y.lineHeight
	      });
	    }
	  }
	
	  return data;
	}
	
	function formatterBarYAxisLabel(units, value, special) {
	  value = format.decimals(value, units);
	  value = format.commas(value, units);
	  var prefix = units.prefix || '';
	  var suffix = units.suffix || '';
	  if (prefix && value.charAt(0) === '-') {
	    // If value is negative, put the negative sign *before* the prefix.
	    value = '-' + prefix + value.substr(1);
	  } else {
	    value = '' + prefix + value;
	  }
	  if (special && suffix) {
	    value += suffix;
	  }
	  return value;
	}
	
	// Writes chart options for column charts (i.e, vertical bars) and charts for
	// which the axes are the same as for column charts (i.e., line charts).
	function writeVerticalOptions(data, options, styles) {
	  var Q = options.quarterlyResults && options.series[0].data.length <= 44;
	  isPrint = options.print;
	  var defaultXGridWidth = 0;
	  if (false) {
	    if (options.type === 'line' && options.product === 'marketwatch') {
	      data.xAxis.tickColor = '#fffff';
	      defaultXGridWidth = 1;
	    }
	    if (options.type === 'column' && options.product === 'marketwatch') {
	      data.xAxis.tickColor = '#fffff';
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
	      data.xAxis.tickColor = '#fffff';
	    }
	  }
	
	  data.xAxis.tickWidth = 1;
	  data.xAxis.lineWidth = 0;
	  data.xAxis.gridLineWidth = defaultXGridWidth;
	  data.xAxis.minorGridLineWidth = defaultXGridWidth;
	  data.yAxis.gridLineWidth = 1;
	  data.yAxis.tickPixelInterval = parseFloat(styles.NORMAL_STYLE.lineHeight) * 3;
	  data.yAxis.reversed = !!options.axes.reversed;
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.xAxis.tickWidth = 0.5;
	      data.yAxis.gridLineWidth = 0.5;
	    }
	  }
	  var alignYAxis = 'right';
	  var yAxisXVal = -10;
	  var yAxisYVal = -5;
	  if (false) {
	    if ((options.product === 'marketwatch' || options.product === 'financialnews') && (options.type === 'line' || options.type === 'column')) {
	      alignYAxis = 'left';
	      yAxisXVal = 0;
	      yAxisYVal = -2.5;
	    }
	  }
	  if (false) {
	    if (options.product === 'financialnews') {
	      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
	        styles.LIGHT_STYLE.fontSize = 7.75;
	      }
	    }
	  }
	  if (options.print === true && options.product === 'financialnews') {
	    styles.LIGHT_STYLE.color = '#000000';
	  }
	
	  data.yAxis.labels = {
	    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
	    autoRotation: false,
	    align: alignYAxis,
	    x: yAxisXVal,
	    y: calculateYAxesLabelY(options, yAxisYVal),
	    formatter: function formatter() {
	      var tp = this.axis.tickPositions;
	      var decimalsDelta = Math.abs(tp[0] - tp[1]);
	      var decimalPlaces = Number.isInteger(decimalsDelta) ? 0 : roundPlaces(decimalsDelta);
	      // special = should have prefix and/or suffix:
	      var special = options.axes.reversed && this.isFirst || !options.axes.reversed && this.isLast;
	      return formatterYAxisLabel(options.axes.units, this.value, decimalPlaces, special);
	    }
	  };
	
	  options.axes.tickStyle = options.axes.tickStyle || 'center';
	  data.xAxis.labels = {
	    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
	    autoRotation: false,
	    maxStaggerLines: 1
	  };
	  data.xAxis.labels.style.textOverflow = 'visible';
	  if (!options.allowCategoriesLinebreak) {
	    data.xAxis.labels.style.whiteSpace = 'nowrap';
	  }
	  data.xAxis.labels.align = 'center';
	  data.xAxis.labels.y = styles.FONT_SIZE + 7;
	  data.xAxis.tickLength = styles.MEDIUM_TICK_LENGTH;
	
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.xAxis.labels.y -= 4;
	    }
	  }
	
	  if (Array.isArray(options.categories) && (Q || !options.categoriesAreDates)) {
	    data.xAxis.type = 'category';
	    data.xAxis.categories = getCategoryLabels(options.categories[0]);
	    data.xAxis.tickmarkPlacement = 'on';
	    if (Q) {
	      data.xAxis.labels.formatter = formatterQuarterlyResults(options);
	    }
	  }
	  if (options.categoriesAreDates && !Q) {
	    data.xAxis.labels.style.whiteSpace = 'nowrap';
	
	    if (options.fiscalYears) {
	      data.xAxis.tickInterval = _axesCommon.YEAR_MILLISECONDS;
	    } else {
	      if (!options.irregularDates) data.xAxis.tickInterval = getDatetimeTickInterval(data, options);
	
	      var firstDate = new Date(options.originalCategories[0]);
	      var lastDate = new Date(options.originalCategories[options.originalCategories.length - 1]);
	      var diff = Math.abs((firstDate.getTime() - lastDate.getTime()) / (24 * 3600 * 1000));
	      var hasMoreThanTwoDays = diff > 2;
	
	      if (options.irregularDates && hasMoreThanTwoDays) {
	        data.xAxis.minTickInterval = 24 * 3600 * 1000;
	      }
	    }
	    if (data.xAxis.tickInterval) {
	      data.xAxis.tickInterval = Math.round(data.xAxis.tickInterval);
	    }
	
	    data.xAxis.labels.formatter = function () {
	      return formatterDate(this, options, data.xAxis.tickInterval);
	    };
	    data.xAxis.type = 'datetime';
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      var isPrintColor = options.print ? 'rgb(0, 0, 0)' : options.styles.axes.label.color;
	      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
	        fontSize: options.styles.axes.label.fontSize,
	        color: isPrintColor,
	        fill: isPrintColor
	      });
	
	      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
	        fontSize: options.styles.axes.label.fontSize,
	        color: isPrintColor,
	        fill: isPrintColor
	      });
	
	      if (options.type === 'column' && !options.categoriesAreDates) {
	        data.xAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
	          fontSize: options.styles.axes.label.seriesAreNotDates.fontSize,
	          fontWeight: options.styles.axes.label.seriesAreNotDates.fontWeight,
	          lineHeight: options.styles.axes.label.seriesAreNotDates.lineHeight
	        });
	      }
	    }
	  }
	
	  return data;
	}
	
	function calculateYAxesLabelY(options, initialValue) {
	  if (true) {
	    if (options.product === 'wsj') {
	      if (options.size === 'print-wsj') {
	        if (options.type === 'line') {
	          return -2.5;
	        }
	
	        if (options.type === 'column') {
	          return -1.5;
	        }
	      }
	      // non print
	      return -2;
	    }
	  }
	
	  return initialValue;
	}
	
	// Returns correct spacing between ticks on x-axis depending.
	function getDatetimeTickInterval(context, options) {
	  if (options.datesAll) {
	    var currYear = void 0;
	    var yearsTraversed = 0;
	    var yearRepeated = false;
	
	    var currMonth = void 0;
	    var monthsTraversed = 0;
	    var monthRepeated = false;
	
	    var currDate = void 0;
	    var datesTraversed = 0;
	    var dateRepeated = false;
	
	    if (options.datesAll.year && !options.datesAll.month) {
	      var isYears = true;
	      for (var i = 0; isYears && i < options.dates.length; i++) {
	        if (currYear === undefined || options.dates[i].year !== currYear) {
	          currYear = options.dates[i].year;
	        } else if (options.dates[i].year === currYear) {
	          isYears = false;
	        }
	      }
	      return _axesCommon.YEAR_MILLISECONDS;
	    }
	
	    for (var _i = 0; _i < options.dates.length; _i++) {
	      // If data passes through >= 3 years but data is spaced less than a year
	      // apart, ensure that ticks are spaced by years.
	      if (options.datesAll.year && options.datesAll.month) {
	        if (currYear === undefined || options.dates[_i].year !== currYear) {
	          currYear = options.dates[_i].year;
	          yearsTraversed += 1;
	        } else if (!yearRepeated && options.dates[_i].year === currYear) {
	          yearRepeated = true;
	        }
	        if (yearRepeated && yearsTraversed >= 3) {
	          return _axesCommon.YEAR_MILLISECONDS;
	        }
	      }
	    }
	
	    for (var _i2 = 0; _i2 < options.dates.length; _i2++) {
	      // If data passes through >= 3 months but data is spaced less than a
	      // month apart, ensure that ticks are spaced by months.
	      if (options.datesAll.month && options.datesAll.date) {
	        if (currMonth === undefined || options.dates[_i2].month !== currMonth) {
	          currMonth = options.dates[_i2].month;
	          monthsTraversed += 1;
	        } else if (!monthRepeated && options.dates[_i2].month === currMonth) {
	          monthRepeated = true;
	        }
	        if (monthRepeated && monthsTraversed >= 3) {
	          return 1000 * 60 * 60 * 24 * 30;
	        }
	      }
	    }
	
	    for (var _i3 = 0; _i3 < options.dates.length; _i3++) {
	      // If data passes through >= 3 dates but data is spaced less than a day
	      // apart, ensure that ticks are spaced by days.
	      if (options.datesAll.date) {
	        if (currDate === undefined || options.dates[_i3].date !== currDate) {
	          currDate = options.dates[_i3].date;
	          datesTraversed += 1;
	        } else if (!dateRepeated && options.dates[_i3].date === currDate) {
	          dateRepeated = true;
	        }
	        if (dateRepeated && datesTraversed >= 3) {
	          return 1000 * 60 * 60 * 24;
	        }
	      }
	    }
	
	    if (options.datesAll.hour && !options.datesAll.year && !options.datesAll.month) {
	      var fd = options.dates[0];
	      var ld = options.dates[options.dates.length - 1];
	      var d1 = new Date();
	      var d2 = new Date();
	      var hour = 1000 * 60 * 60;
	      d1.setUTCHours(fd.hour);
	      d1.setUTCMinutes(fd.minute);
	      d2.setUTCHours(ld.hour);
	      d2.setUTCMinutes(ld.minute);
	      if (d2.valueOf() - d1.valueOf() > hour) {
	        return hour;
	      }
	    }
	  }
	  return null;
	}
	
	// A Highcharts `formatter` function to formate x-axis dates.
	function formatterDate(context, options, interval) {
	  // INDEX = (INDEX >= options.series[0].data.length) ? 0 : INDEX;
	  // const index = INDEX++;
	  var index = getDataIndex(context.value, options.series[0].data, interval);
	
	  // This gives some whack results...
	  // const date = new Date(context.value);
	
	  // ...therefore, track the index of this tick:
	  // options.xAxisLabelIndex = options.xAxisLabelIndex || 0;
	  // options.xAxisLabelIndex %= options.series[0].data.length;
	  // const index = options.xAxisLabelIndex;
	  // const date = new Date(options.series[0].data[index].x);
	  var date = new Date(context.value);
	  // options.xAxisLabelIndex += 1;
	
	  options.dateTimeLabelFormat = context.dateTimeLabelFormat;
	  var labelFormat = options.dateTimeLabelFormat;
	  // if (labelFormat === '%H:%M') labelFormat = '%e. %b'
	
	  var dateObj = options.dates[index];
	  switch (labelFormat) {
	    case '%H:%M':
	    case '%H:%M:%S':
	      var incSecs = false; //context.dateTimeLabelFormat === '%H:%M:%S';
	      options.series[0].data[index].xAxisLabel = formatHM(date, incSecs);
	      return formatHM(date, incSecs);
	    case '%e. %b':
	      options.series[0].data[index].xAxisLabel = [_constants.MONTHS[date.getUTCMonth()], date.getUTCDate()].join(' ');
	      return [_constants.MONTHS[date.getUTCMonth()], date.getUTCDate()].join(' ');
	    case '%b \'%y':
	      if (options.dates[index].yearIsProxy) {
	        options.series[0].data[index].xAxisLabel = _constants.MONTHS[date.getUTCMonth()];
	        return _constants.MONTHS[date.getUTCMonth()];
	      } else {
	        options.series[0].data[index].xAxisLabel = [_constants.MONTHS[date.getUTCMonth()], '’' + (date.getUTCFullYear() + '').substr(2)].join(' ');
	        return [_constants.MONTHS[date.getUTCMonth()], '’' + (date.getUTCFullYear() + '').substr(2)].join(' ');
	      }
	    case '%Y':
	      // console.log(index, date.getUTCFullYear(), date.getFullYear(), realDate.getFullYear());
	      options.series[0].data[index].xAxisLabel = date.getUTCFullYear() + '';
	      //(dateObj.year || realDate.getUTCFullYear()) + '';
	      // return dateObj.year || (date.getFullYear() + '');
	      return date.getUTCFullYear() + '';
	  }
	  options.series[0].data[index].xAxisLabel = '0';
	  return '0';
	}
	
	function getDataIndex(value, data, interval) {
	  var index = 0;
	  for (var i = 0; i < data.length; i++) {
	    index = i;
	    if (value < data[i].x) {
	      break;
	    }
	  }
	  return index;
	}
	
	function formatHM(date, includeSeconds) {
	  var h = date.getUTCHours();
	  var a = h < 12 ? ' a.m.' : ' p.m.';
	  var m = (0, _zero.addZeroes)(date.getUTCMinutes(), 2);
	  var s = includeSeconds ? (0, _zero.addZeroes)(date.getUTCSeconds(), 2) : null;
	  if (h === 12 && m == '00') {
	    return 'noon';
	  }
	  if (h === 0) {
	    h = 12;
	  } else {
	    h %= 12;
	  }
	  m = m === '00' ? '' : ':' + m;
	  s = includeSeconds ? ':' + s : '';
	  return [h, m, s, a].join('');
	}
	
	// Used as Highcharts `formatter` function (not directly).
	function formatterYAxisLabel(units, value, minDecimals, special) {
	  value += '';
	  var decimalUnits = (0, _lodash2.default)({}, units);
	  if (units.forceDecimals !== undefined) {
	    decimalUnits.forceDecimals = Math.max(units.forceDecimals, minDecimals);
	  }
	  if (units.maxDecimals !== undefined) {
	    decimalUnits.maxDecimals = Math.max(units.maxDecimals, minDecimals);
	  }
	  value = format.decimals(value, decimalUnits);
	  value = format.commas(value, units.commas);
	  if (special) {
	    var neg = '';
	    if (units.prefix && value.charAt(0) === '-') {
	      neg = '-';
	      value = value.substr(1);
	    }
	    value = [neg, units.prefix, value].join('');
	  }
	  return value;
	}
	
	// A Highcharts `formatter` function that returns 'nQ<br/>YYYY'.
	function formatterQuarterlyResults(options) {
	  var rows = options.series[0].data.length;
	  var quarter = undefined;
	  var year = undefined;
	  return function () {
	    var value = '';
	    var parts = this.value.split(/\s/);
	    var tmpQ = parts[0] || null;
	    var tmpY = parts[1] || null;
	    var FY = tmpY ? tmpY.indexOf('FY') === 0 : false;
	    if (FY) {
	      tmpY = tmpY.substr(2);
	    }
	    if (this.isFirst) {
	      // Sometimes Highcharts runs through the date *twice*!
	      quarter = year = undefined;
	    }
	    if (tmpQ && rows <= 9 && options.interactive) {
	      value += tmpQ;
	    }
	    if (tmpY) {
	      if (value !== '') {
	        value += '<br>';
	      }
	      if (tmpY !== year) {
	        if (year === undefined) {
	          value += (FY ? 'FY' : '') + tmpY;
	        } else {
	          value += _constants.APOSTROPHE + tmpY.substr(2, 4);
	        }
	      }
	    }
	    quarter = tmpQ;
	    year = tmpY;
	    return value;
	  };
	}
	
	// Returns an array of category objects as an array of strings for use as the
	// value for `data[x|yAxis].categories`.
	function getCategoryLabels(categories) {
	  var strings = [];
	  if (categories) {
	    categories.forEach(function (cat, index) {
	      if (typeof cat === 'string' || typeof cat === 'number') {
	        strings[index] = cat + '';
	      } else if (cat && (typeof cat === 'undefined' ? 'undefined' : _typeof(cat)) === 'object') {
	        strings[index] = cat.text;
	      } else {
	        strings[index] = null;
	      }
	    });
	  }
	  return strings;
	}
	
	// Attempts to allow manual tweaking of min and max axis values, but does not
	// quite do what is requested: Set an *absolute* max and min, whereas
	// Highcharts uses the values as a guide.
	function writeMinMax(data, options) {
	  if (options.type !== 'pie') {
	    if (options.axes.minYAxisValue !== undefined) {
	      data.yAxis.min = options.axes.minYAxisValue;
	    }
	    if (options.axes.maxYAxisValue !== undefined) {
	      data.yAxis.max = options.axes.maxYAxisValue;
	    }
	  }
	  return data;
	}
	
	// Finds if yAxis.min should be set automatically so as to ensure that
	// a zero line is included.
	function valuesBelowPositive2(options) {
	  var found = false;
	  for (var s = 0; s < options.series.length; s++) {
	    for (var d = 0; d < options.series[s].data.length; d++) {
	      if (options.series[s].data[d].y < 0) {
	        return false;
	      } else if (!found && options.series[s].data[d].y <= 2) {
	        found = true;
	      }
	    }
	  }
	  return found;
	}
	
	// Finds if yAxis.max should be set automatically so as to ensure that
	// a zero line is included.
	function valuesAboveNegative2(options) {
	  var found = false;
	  for (var s = 0; s < options.series.length; s++) {
	    for (var d = 0; d < options.series[s].data.length; d++) {
	      if (options.series[s].data[d].y > 0) {
	        return false;
	      } else if (!found && options.series[s].data[d].y <= -2) {
	        found = true;
	      }
	    }
	  }
	  return found;
	}
	
	// Sometimes decimals are 17 or something outrageous, but decimalsDelta is something like 0.20000000000000002
	// which should be just 0.2. This fixes the issue.
	function roundPlaces(float) {
	  for (var places = 1; places < 19; places++) {
	    if (float.toFixed(places) + '0' === float.toFixed(places + 1)) break;
	  }
	  return places;
	}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _axesPrerender = __webpack_require__(145);
	
	var _axesPrerender2 = _interopRequireDefault(_axesPrerender);
	
	var _axesPostrender = __webpack_require__(144);
	
	var _axesPostrender2 = _interopRequireDefault(_axesPostrender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = null;
	
	function preRender(data, options) {
	  styles = writeStyles(options);
	  return (0, _axesPrerender2.default)(data, options, styles);
	}
	
	function postRender(highchart, options) {
	  return (0, _axesPostrender2.default)(highchart, options, styles);
	}
	
	// Writes styles constants used throughout axes processing.
	function writeStyles(options) {
	  // const isWSJOnline = !options.product === 'wsj' && options.print ? options.styles.get('normal') : 
	  // options.styles.get('normal').fontFamily = '"Retina Narrow", sans-serif';
	  var normal = options.styles.get('normal');
	  if (options.product === 'wsj' && !options.print) {
	    if (options.categoriesAreDates || options.type !== 'column') normal.fontFamily = '"Retina Narrow", sans-serif';
	    normal.lineHeight = 15;
	  }
	  var defaultOptions = {
	    FONT_SIZE: parseFloat(options.styles.size.normal),
	    NORMAL_STYLE: normal,
	    LIGHT_STYLE: options.styles.get('normal', {
	      fontFamily: options.styles.font.light,
	      fontWeight: options.styles.weight.light
	    }),
	    BOLD_STYLE: options.styles.get('normal', {
	      fontFamily: options.styles.font.bold,
	      fontWeight: options.styles.weight.bold
	    }),
	    SHORT_TICK_LENGTH: 4,
	    MEDIUM_TICK_LENGTH: 7,
	    LONG_TICK_LENGTH: parseFloat(options.styles.size.normal) + 5,
	    MARGIN: 3
	  };
	
	  if (false) {
	    if (options.product === 'marketwatch') {
	      return Object.assign({}, defaultOptions, {
	        NORMAL_STYLE: options.styles.get('normal', {
	          fontFamily: options.styles.font.semibold,
	          fontWeight: options.styles.weight.semibold
	        })
	      });
	    }
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      var hideTicks = !options.categoriesAreDates && options.type === 'column';
	
	      return Object.assign({}, defaultOptions, {
	        SHORT_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.shortSize,
	        MEDIUM_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.mediumSize,
	        FONT_SIZE: options.styles.axes.label.fontSize,
	        LONG_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.longSize,
	        AXES: options.styles.axes
	      });
	    }
	  }
	
	  return defaultOptions;
	}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartUtil = __webpack_require__(7);
	
	/**
	 * Adds options for LINE charts.
	 */
	function preRender(data, options) {
	  data.plotOptions.area = {
	    lineWidth: options.series.length > 1 ? 1 : 0,
	    lineColor: '#fff',
	    linecap: 'square',
	    fillOpacity: 1.0,
	    enableMouseTracking: options.interactive,
	    stacking: options.stacking,
	    states: {
	      hover: {
	        halo: {
	          opacity: 1,
	          size: 4
	        },
	        lineWidthPlus: 0
	      }
	    }
	  };
	  data.plotOptions.series = {
	    marker: {
	      symbol: 'circle',
	      radius: 0,
	      lineWidth: 0,
	      lineColor: null
	    }
	  };
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.plotOptions.area.lineWidth = 1.5;
	      // data.plotOptions.area.linecap = 'butt';
	    }
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  roundLineJoins(highchart, options);
	}
	
	function roundLineJoins(highchart, options) {
	  var selector = 'g.highcharts-series-group g.highcharts-series path';
	  var paths = highchart.container.querySelectorAll(selector);
	  for (var i = 0; i < paths.length; i++) {
	    paths[i].setAttribute('stroke-linejoin', 'bevel');
	    if (true) {
	      if (options.size === 'print-wsj') {
	        paths[i].setAttribute('stroke-linecap', 'butt');
	      }
	    }
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartUtil = __webpack_require__(7);
	
	/**
	 * Adds options for BAR and COLUMN charts.
	 */
	
	function preRender(data, options) {
	  var bar = data.plotOptions[options.type];
	  bar.stacking = options.stacking;
	  bar.marker = {
	    enabled: false
	  };
	  bar.borderWidth = 0;
	  // data = adjustBarsWidth(data, options);
	  data.plotOptions[options.type].pointPadding = 0.125;
	  data.plotOptions[options.type].groupPadding = options.series.length > 1 && options.stacking === null ? 0.2 : 0;
	  return data;
	}
	
	// For bar charts, tweaks the spacing between bars.
	// function adjustBarsWidth(data, options) {
	//   if (options.type === 'column') {
	//     const c = data.plotOptions[options.type];
	//     const seriesLen = options.stacking ? 1 : data.series.length;
	//     let maxDataLen = 0;
	//     data.series.forEach(item => {
	//       maxDataLen = Math.max(maxDataLen, item.data.length);
	//     });
	//     const yAxisEstimate = getYAxisEstimatedWidth(data, options);
	//     const xAxisWidth = options.width - yAxisEstimate;
	//     const bars = seriesLen * maxDataLen;
	//     const groupBars = (seriesLen > 1) ? (maxDataLen - 1) : 0;
	//     const pointBars = (seriesLen === 1) ? (maxDataLen - 1) :
	//       (maxDataLen * (seriesLen - 1));
	
	//     const adjustedGroupBars = groupBars * 2;
	//     // designed = 0.25 :
	//     const adjustedPointBars = pointBars * (0.35 + 0.2 * seriesLen);
	
	//     c.pointWidth = Math.max(2, xAxisWidth /
	//       (bars + adjustedGroupBars + adjustedPointBars));
	
	//     // if (options.legend.enabled && options.legend.layout === 'right') {
	//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.25);
	//     // } else {
	//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.5)
	//     // }
	
	
	//     // let factorToSubtractBy = 0;
	
	//     // if (data.series[0].data.length > 100) {
	//     //   if (options.width < 500) {
	//     //     factorToSubtractBy = 0.95;
	//     //   }
	//     //   if (options.width < 620 && options.width > 500) {
	//     //     factorToSubtractBy = 0.75;
	//     //   }
	//     //   if (options.width >= 620) {
	//     //     factorToSubtractBy = 0.25;
	//     //   }
	//     // }
	
	//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length > 100) {
	//     //   if (options.width < 500) {
	//     //     factorToSubtractBy = 0.95;
	//     //   }
	//     //   if (options.width < 620 && options.width > 500) {
	//     //     factorToSubtractBy = 0.9;
	//     //   }
	//     //   if (options.width === 620) {
	//     //     factorToSubtractBy = 0.7;
	//     //   }
	//     //   if (options.width > 620) {
	//     //     factorToSubtractBy = 0.25;
	//     //   }
	//     // }
	
	//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length < 100) {
	//     //   factorToSubtractBy = options.width < 420 ? 0.35 : 0.25;
	//     // }
	
	//     // c.pointWidth = c.pointWidth - (c.pointWidth * factorToSubtractBy);
	//     // c.pointPadding = 0.5;
	//     // c.groupPadding = 0;
	
	//   }
	//   return data;
	// }
	
	function getYAxisEstimatedWidth(data, options) {
	  var maxNum = 0;
	  data.series.forEach(function (series) {
	    for (var i = 0; i < series.data.length; i++) {
	      maxNum = Math.max(maxNum, series.data[i].y);
	    }
	  });
	  maxNum = (Math.round(maxNum) + '').length;
	  var units = options.axes.units;
	  var forceDecimals = units.forceDecimals !== undefined ? units.forceDecimals : 0;
	  var maxDecimals = units.maxDecimals !== undefined ? units.maxDecimals : Number.MAX_VALUE;
	  var len = maxNum + Math.min(forceDecimals, maxDecimals);
	  var fontSize = parseFloat(options.styles.normal.fontSize) * 0.5;
	  return len * fontSize;
	}
	
	function postRender(highchart, options) {
	  if (options.type === 'column') {
	    adjustBarSpacing(highchart, options);
	  }
	  stylizeStacks(highchart, options);
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}
	
	// Tweak spacing to improve rounding/pixel issues.
	function adjustBarSpacing(highchart, options) {
	  var axis = highchart.yAxis[0];
	  var delta = {
	    index1: -1,
	    index2: -1
	  };
	  // Set X for each bar to NOT rounded position. I thought this would look
	  // terrible, but it's fine.
	  var seriesLen = axis.series.length;
	  axis.series.forEach(function (series) {
	    for (var i = 0; i < series.data.length; i++) {
	      var point = series.data[i];
	      if (point.graphic) {
	        point.graphic.element.setAttribute('x', point.barX);
	        // Measure the distance between bars:
	        if (delta.index1 === -1) {
	          delta.index1 = i;
	          delta.bar1 = point.barX;
	        } else if (delta.index2 === -1) {
	          if (delta.index1 < i - 1) {
	            delta.index1 = -1;
	          } else {
	            delta.index2 = i;
	            delta.bar2 = point.barX - point.pointWidth;
	          }
	        }
	      }
	    }
	  });
	  // if (delta.index1 !== -1 && delta.index2 !== -1) {
	  //   // If bars are too close together, merge them:
	  //   const deltaPx = delta.bar2 - delta.bar1;
	  //   console.log(deltaPx);
	  //   const hasOverOneFiftyDataPoints = options.series[0].data.length > 150 ? 1.5 : 0.5;
	  //   console.log(deltaPx, options.size);
	  //   if (deltaPx < hasOverOneFiftyDataPoints) {
	  //     axis.series.forEach(series => {
	  //       for (let i = 0; i < series.data.length; i++) {
	  //         const point = series.data[i];
	  //         if (point.graphic) {
	  //           let isLegendRight = options.legend.enabled && options.legend.layout === 'right' ? 0.25 : 0.125;
	  //           isLegendRight = options.series[0].data.length > 150 ? isLegendRight + 0.05 : isLegendRight;
	  //           point.graphic.element.setAttribute('x', point.barX + (deltaPx / 2));
	  //           point.graphic.element.setAttribute('width', point.pointWidth - deltaPx);
	  //         }
	  //       }
	  //     });
	  //   }
	  // }
	}
	
	// If stacking is enabled, adjust the style of the stacks.
	function stylizeStacks(highchart, options) {
	  if (options.stacking) {
	    highchart.yAxis[0].series.forEach(function (series) {
	      series.data.forEach(function (item) {
	        if (item.graphic) {
	          var el = item.graphic.element;
	          var px = parseFloat(el.attributes.height.value);
	          if (px > 0) {
	            el.setAttribute('height', px - 1);
	          }
	        }
	      });
	    });
	  }
	}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartUtil = __webpack_require__(7);
	
	/**
	 * Adds options for LINE charts.
	 */
	function preRender(data, options) {
	  data.plotOptions.line = {
	    lineWidth: 3,
	    linecap: 'square',
	    enableMouseTracking: options.interactive,
	    states: {
	      hover: {
	        halo: {
	          opacity: 1,
	          size: 4
	        },
	        lineWidthPlus: 0
	      }
	    }
	  };
	  data.plotOptions.series = {
	    marker: {
	      symbol: 'circle',
	      radius: 0,
	      lineWidth: 0,
	      lineColor: null
	    }
	  };
	  if (true) {
	    if (options.size === 'print-wsj') {
	      data.plotOptions.line.lineWidth = 1.5;
	      data.plotOptions.line.linecap = 'round';
	    }
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  roundLineJoins(highchart);
	}
	
	function roundLineJoins(highchart) {
	  var selector = 'g.highcharts-series-group g.highcharts-series path';
	  var paths = highchart.container.querySelectorAll(selector);
	  for (var i = 0; i < paths.length; i++) {
	    paths[i].setAttribute('stroke-linejoin', 'bevel');
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _transform = __webpack_require__(5);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _chartUtil = __webpack_require__(7);
	
	var _format = __webpack_require__(4);
	
	var format = _interopRequireWildcard(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var TOP_LEFT = 0; /**
	                   * Adds options for PIE charts.
	                   */
	
	var TOP_RIGHT = 1;
	var BOTTOM_RIGHT = 2;
	var BOTTOM_LEFT = 3;
	
	var PERC_MARGIN = 4;
	var LABEL_MARGIN = 10;
	
	function preRender(data, options) {
	  options = writeDataNames(options);
	  var arrayofYValues = data.series[0].data;
	  var sumofYValues = 0;
	  arrayofYValues.forEach(function (data) {
	    sumofYValues += data.y;
	  });
	  arrayofYValues.forEach(function (data) {
	    data.y = data.y / sumofYValues;
	    // data.y = format.decimals(data.y, options.axes.units, true, true);
	    data.y = parseFloat(data.y * 100);
	    var forceDecimals = Number(options.axes.units.forceDecimals);
	    if (forceDecimals === 1) forceDecimals = 10;
	    if (forceDecimals === 2) forceDecimals = 100;
	    if (forceDecimals === 3) forceDecimals = 1000;
	    if (forceDecimals === 0) forceDecimals = 'round';
	    if (forceDecimals) {
	      data.y = forceDecimals !== 'round' ? Math.ceil(data.y * forceDecimals) / forceDecimals : data.y;
	      if (data.y.toString().length > 4 && forceDecimals === 'round') {
	        data.y = Math.round(data.y);
	      }
	    }
	  });
	  data.plotOptions.pie = {
	    dataLabels: { enabled: false },
	    enableMouseTracking: options.interactive,
	    showInLegend: true,
	    minSize: minSize(data, options),
	    center: ['50%', '50%'],
	    states: {
	      hover: {
	        enabled: false
	      }
	    }
	  };
	  return data;
	}
	
	// Writes the categories into the series[0] data so that they are available
	// for data labels.
	function writeDataNames(options) {
	  options.series[0].data.forEach(function (item, index) {
	    if (options.type === 'pie' && options.optimizeDataOrder) {
	      item.name = options.longCategories[item.originalIndex];
	    } else {
	      item.name = options.longCategories[index];
	    }
	  });
	  return options;
	}
	
	// Set a minimum radius for the chart to render.
	function minSize(data, options) {
	  return Math.min(options.height - data.chart.spacing[0] - data.chart.spacing[2], options.width - data.chart.spacing[3] - data.chart.spacing[1]) * 0.5;
	}
	
	/**
	 * Draws the data labels using custom methods instead of Highcharts.
	 * 1) Draw labels into corners of quadrants.
	 * 2) Resize and move pie chart based on data labels locations.
	 * 3) Draw connectors.
	 */
	function postRender(highchart, options) {
	  if (options.legend.enabled && options.size.indexOf('thumb') !== 0) {
	    var g = drawLabelsGroup(highchart);
	    var rect = getPieRect(highchart);
	    if (rect) {
	      var labels = drawLabels(highchart, options, g, rect);
	      if (labels.length) {
	        var sorted = sortLabels(labels);
	        sorted = positionLabels(highchart, sorted, rect);
	        var resizedRect = resizeChart(highchart, rect, sorted, labels[0].lineHeight);
	        truncateLabels(highchart, labels, resizedRect);
	        improveLabelPositions(highchart, labels, resizedRect);
	        if (options.product === 'financialnews') {
	          makeDonutChart(highchart, options);
	        }
	      }
	    }
	  }
	}
	
	// Creates a `g` element to contain the data labels, translated to the same
	// position as the pie chart.
	function drawLabelsGroup(highchart) {
	  var gPieSelector = '.highcharts-series-group .highcharts-series';
	  var gPie = highchart.container.querySelector(gPieSelector);
	  var g = highchart.renderer.g().add();
	  g.element.setAttribute('transform', gPie.getAttribute('transform'));
	  g.element.setAttribute('class', 'pie-chart-data-labels');
	  return g;
	}
	
	function drawLabels(highchart, options, g, rect) {
	  var labels = [];
	  var data = highchart.series[0].data;
	  var smallSize = isSmall(options.size);
	  var styleLabel = options.styles.get(smallSize ? 'small' : 'normal', {
	    fontFamily: options.styles.font.bold,
	    fontWeight: options.styles.weight.bold
	  });
	  var stylePerc = options.styles.get(smallSize ? 'small' : 'normal');
	  var lineHeight = parseFloat(styleLabel.fontSize);
	  var pi2 = Math.PI * 2;
	
	  for (var i = 0; i < data.length; i++) {
	    var slice = data[i];
	    labels[i] = {};
	    labels[i].slice = slice;
	    labels[i].radians = (slice.angle + pi2) % pi2;
	    labels[i].styleLabel = options.styles.get(smallSize ? 'small' : 'normal', {
	      fontFamily: options.styles.font.bold,
	      fontWeight: options.styles.weight.bold
	    });
	    labels[i].stylePerc = options.styles.get(smallSize ? 'small' : 'normal', {});
	    labels[i].g = highchart.renderer.g().add(g);
	
	    // const labelName = getLabelName(slice, options);
	    labels[i].labelName = highchart.renderer.text(slice.name, 0, 0).css(labels[i].styleLabel).add(labels[i].g);
	    labels[i].labelPerc = highchart.renderer.text(slice.y + '%', labels[i].labelName.element.getBoundingClientRect().width + PERC_MARGIN, 0).css(labels[i].stylePerc).add(labels[i].g);
	    labels[i].lineHeight = smallSize ? 14 : parseFloat(styleLabel.lineHeight);
	    var isMW = options.product === 'marketwatch';
	    var isFN = options.product === 'financialnews';
	    var widthVal = isMW ? 12 : 9;
	    var heightVal = isMW ? 12 : 13;
	    if (!isFN) {
	      highchart.renderer.rect().attr({
	        width: widthVal,
	        height: heightVal,
	        fill: slice.color
	      }).add(labels[i].g);
	    } else {
	      highchart.renderer.circle(5, -4, widthVal / 2).attr({
	        fill: slice.color
	      }).add(labels[i].g);
	    }
	
	    var xVal = isMW ? 15 : 12;
	    var yVal = isMW ? -10 : -12;
	    labels[i].g.element.lastElementChild.setAttribute('x', 0);
	    labels[i].g.element.firstElementChild.setAttribute('x', xVal);
	    var percentageCurrentX = Number(labels[i].g.element.children[1].getAttribute('x'));
	    labels[i].g.element.children[1].setAttribute('x', percentageCurrentX + xVal);
	    labels[i].g.element.lastElementChild.setAttribute('y', yVal);
	  }
	
	  return labels;
	}
	
	// function getLabelName(slice, options) {
	//   if (options.optimizeDataOrder && Array.isArray(options.categories) &&
	//       options.categories.length) {
	//     return options.categories[0][slice.originalIndex] || slice.name;
	//   }
	//   return slice.name
	// }
	
	
	// Sorts labels intro quadrants.
	function sortLabels(labels, rect) {
	  var BR = [];
	  var BL = [];
	  var TL = [];
	  var TR = [];
	
	  labels = labels.sort(sortOnRadians);
	  for (var i = 0; i < labels.length; i++) {
	    var r = labels[i].radians;
	    if (r > 0 && r <= Math.PI * 0.5) {
	      BR.push(labels[i]);
	    } else if (r > Math.PI * 0.5 && r < Math.PI) {
	      BL.push(labels[i]);
	    } else if (r >= Math.PI && r < Math.PI * 1.5) {
	      TL.push(labels[i]);
	    } else {
	      TR.push(labels[i]);
	    }
	  }
	
	  if (TR.length === 0 && BR.length) {
	    TR.push(BR.shift());
	  }
	  BR.reverse();
	  TL.reverse();
	  return { BR: BR, BL: BL, TL: TL, TR: TR };
	}
	
	function positionLabels(highchart, sorted, rect) {
	  // Top right
	  var x = void 0;
	  var y = 0;
	  sorted.TR.forEach(function (label) {
	    label.x = getRightX(highchart, label);
	    label.y = y + label.lineHeight;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y += label.lineHeight;
	  });
	
	  // Bottom right
	  y = getBottomY(highchart);
	  sorted.BR.forEach(function (label) {
	    label.x = getRightX(highchart, label);
	    label.y = y;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y -= label.lineHeight;
	  });
	
	  // Bottom left
	  x = getLeftX(highchart);
	  y = getBottomY(highchart);
	  sorted.BL.forEach(function (label) {
	    label.x = x;
	    label.y = y;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y -= label.lineHeight;
	  });
	
	  // Top left
	  y = 0;
	  sorted.TL.forEach(function (label) {
	    label.x = x;
	    label.y = y + label.lineHeight;
	    transform.write(label.g.element, 'translate', label.x, label.y);
	    y += label.lineHeight;
	  });
	  return sorted;
	}
	
	// Returns default label left x.
	function getLeftX(highchart) {
	  return 0; //highchart.plotLeft;
	}
	
	// Returns default label right x.
	function getRightX(highchart, label) {
	  return highchart.plotLeft + highchart.plotWidth - highchart.spacing[1] - label.g.element.getBoundingClientRect().width;
	}
	
	// Returns default label bottom y.
	function getBottomY(highchart) {
	  return highchart.plotHeight - LABEL_MARGIN; // - highchart.spacing[2];
	}
	
	// Scales the chart down to compensate for labels.
	function resizeChart(highchart, rect, sorted, lineHeight) {
	  var maxLabelsTop = Math.max(sorted.TL.length, sorted.TR.length);
	  var maxLabelsBot = Math.max(sorted.BL.length, sorted.BR.length);
	  var newHeight = rect.height - (maxLabelsTop + maxLabelsBot) * lineHeight;
	  newHeight = Math.max(newHeight, Math.min(highchart.plotWidth * 0.6, highchart.plotHeight * 0.6));
	
	  var scaleRatio = newHeight / rect.height;
	  var pieG = highchart.series[0].data[0].graphic.parentGroup;
	  var pieContainer = pieG.element.parentElement;
	  var translate = transform.read(pieG.element, 'translate');
	  var x = (highchart.chartWidth - highchart.chartWidth * scaleRatio) * 0.5;
	  var y = translate[1];
	  y += maxLabelsTop * lineHeight;
	  // y += (rect.height - newHeight) / 2;
	
	  transform.write(pieG.element, 'translate', translate[0], 0);
	  pieContainer.setAttribute('transform', ['matrix(', scaleRatio, ',0,0,', scaleRatio, ',', x, ',', y, ')'].join(''));
	
	  var r = {
	    width: rect.width * scaleRatio
	  };
	  r.height = r.width;
	  r.left = rect.center - r.width / 2 + highchart.spacing[3];
	  r.center = rect.center;
	  r.right = r.left + r.width;
	  r.top = y + 10 * scaleRatio;
	  r.middle = r.top + r.height / 2;
	  r.bottom = r.top + r.height;
	  // debugRect(highchart, r.left, r.top, r.width, r.height);
	  return r;
	}
	
	// Truncate any labels that overlap the pie chart with '…'.
	function truncateLabels(highchart, labels, rect) {
	  var labelsLen = labels.length;
	  if (labelsLen) {
	    var parentGroup = labels[0].g.element.parentElement;
	    var parentTop = transform.read(parentGroup, 'translate')[1];
	
	    for (var i = 0; i < labelsLen; i++) {
	      var label = labels[i];
	      parentGroup = parentGroup || label.g.element.parentElement;
	      var labelRect = label.g.element.getBoundingClientRect();
	      label.bounds = {
	        x: label.x + highchart.spacing[3],
	        y: label.y + parentTop - parseFloat(label.styleLabel.fontSize) + highchart.spacing[0],
	        width: labelRect.width,
	        height: labelRect.height
	      };
	      // debugRect(highchart, testRect.x, testRect.y, testRect.width, testRect.height);
	
	      var maxWidth;
	      if (label.bounds.y > rect.top && label.bounds.y < rect.bottom) {
	        // Label is next to pie chart.
	        if (label.x < rect.left) {
	          maxWidth = rect.left - label.x - LABEL_MARGIN;
	          truncateLabelLeft(labelRect, label, rect.left - label.x - LABEL_MARGIN);
	        } else {
	          maxWidth = highchart.chartWidth - highchart.spacing[1] - rect.right;
	          truncateLabelRight(labelRect, label, label.bounds.x + labelRect.width, maxWidth);
	        }
	      } else {
	        // Label is above or below the pie.
	        if (label.radians > Math.PI / 2 && label.radians < Math.PI * 1.5) {
	          maxWidth = rect.center - label.x - LABEL_MARGIN;
	          truncateLabelLeft(labelRect, label, maxWidth);
	        } else {
	          maxWidth = highchart.chartWidth - highchart.spacing[1] - rect.center;
	          truncateLabelRight(labelRect, label, label.bounds.x + labelRect.width, maxWidth);
	        }
	      }
	    }
	  }
	}
	
	function truncateLabelLeft(labelRect, label, maxWidth) {
	  var tspan = label.labelName.element.querySelector('tspan') || label.labelName.element;
	  var s = label.labelName.textStr;
	  var n = s.length - 2;
	  while (labelRect.width > maxWidth && n > 0) {
	    s = s.substr(0, n--);
	    tspan.innerHTML = s + '…';
	    label.labelPerc.element.setAttribute('x', label.labelName.element.getBoundingClientRect().width + PERC_MARGIN);
	    labelRect = label.g.element.getBoundingClientRect();
	  }
	}
	
	function truncateLabelRight(labelRect, label, rightX, maxWidth) {
	  var tspan = label.labelName.element.querySelector('tspan') || label.labelName.element;
	  var s = label.labelName.textStr;
	  var n = s.length - 2;
	  while (labelRect.width > maxWidth && n > 0) {
	    s = s.substr(0, n--);
	    tspan.innerHTML = s + '…';
	    label.labelPerc.element.setAttribute('x', label.labelName.element.getBoundingClientRect().width + PERC_MARGIN);
	    labelRect = label.g.element.getBoundingClientRect();
	  }
	  var translate = transform.read(label.g.element, 'translate');
	  transform.write(label.g.element, 'translate', rightX - labelRect.width, translate[1]);
	}
	
	// Moves labels closer to the chart, if possible.
	function improveLabelPositions(highchart, labels, rect) {
	  var L = [];
	  var R = [];
	  var maxL = 0;
	  var maxR = 0;
	  for (var i = 0; i < labels.length; i++) {
	    var label = labels[i];
	    if (label.radians > Math.PI * 0.5 && label.radians < Math.PI * 1.5) {
	      L.push(label);
	      maxL = Math.max(maxL, label.bounds.width);
	    } else {
	      R.push(label);
	      maxR = Math.max(maxR, label.bounds.width);
	    }
	  }
	  var delta = rect.left - LABEL_MARGIN - maxL;
	  if (delta > 0) {
	    L.forEach(function (item) {
	      var t = transform.read(item.g.element, 'translate');
	      transform.write(item.g.element, 'translate', t[0] + delta, t[1]);
	    });
	  }
	  delta = highchart.chartWidth - (rect.right + LABEL_MARGIN) - maxR;
	  if (delta > 0) {
	    R.forEach(function (item) {
	      var t = transform.read(item.g.element, 'translate');
	      transform.write(item.g.element, 'translate', t[0] - delta, t[1]);
	    });
	  }
	}
	
	// We decided, at least for the moment, not to do this.
	function connectLabels(highchart, rect, labels) {}
	//
	
	
	// For sorting the labels from top to bottom.
	function sortOnY(a, b) {
	  // var ta = transform.read(a.dataLabel.element, 'translate')[1];
	  // var tb = transform.read(b.dataLabel.element, 'translate')[1];
	  // return ta - tb;
	  return a.y - b.y;
	}
	
	// Sorts the labels clockwise around the pie, starting at 3 o'clock. The
	// radians should already have been normalized to a number >= 0 and
	// <= Math.PI * 2.
	function sortOnRadians(a, b) {
	  return a.radians - b.radians;
	}
	
	// Returns position and dimensions of the pie graphic.
	function getPieRect(highchart) {
	  var d = highchart.series[0].data[0];
	  var g = !!d ? d.graphic : null;
	  if (g) {
	    var r = {
	      left: g.x - g.r,
	      top: g.y - g.r
	    };
	    r.width = g.r * 2;
	    r.height = r.width;
	    r.right = r.left + r.width;
	    r.bottom = r.top + r.height;
	    r.center = r.left + r.width / 2;
	    r.middle = r.top + r.height / 2;
	    return r;
	  }
	  return null;
	}
	
	function debugRect(highchart, x, y, width, height) {
	  return highchart.renderer.rect(x, y, width, height).attr({
	    'stroke-width': 1,
	    'stroke': 'red',
	    'fill': 'rgba(255, 255, 255, 0)'
	  }).add();
	}
	
	// Used for determining whether to use 'small' or 'normal' font sizes.
	function isSmall(size) {
	  return size === 'D' || size === '4u' || size === 'fon';
	}
	
	function makeDonutChart(highchart, options) {
	  if (false) {
	    var highchartContainer = highchart.container;
	    var highchartContainerSVG = highchartContainer.firstElementChild;
	    var svgWidth = Number(highchartContainerSVG.getAttribute('width'));
	    var radius = !options.interactive ? highchart.plotWidth / 2 * .25 : highchart.plotWidth / 2 * .444;
	    radius = options.id === 'fn-large-inset' ? highchart.plotWidth / 2 * .333 : radius;
	    var svgHeight = highchartContainerSVG.getAttribute('height');
	    var groupOfPieValue = highchartContainer.getElementsByClassName('highcharts-pie-series')[0];
	    var lastPathOfPie = groupOfPieValue.lastElementChild.getAttribute('d').split(' ');
	    var lastPathOfPieYVal = Number(lastPathOfPie[lastPathOfPie.length - 2]);
	    var circle = highchart.renderer.circle(svgWidth / 2, lastPathOfPieYVal, radius).attr({
	      fill: 'white'
	    });
	    var text = highchart.renderer.text('%', svgWidth / 2 - radius / 2 * .85, lastPathOfPieYVal + radius / 2 * .75).attr({
	      'font-size': radius,
	      stroke: 'black',
	      text: '%'
	    }).add();
	    groupOfPieValue.append(circle.element);
	    groupOfPieValue.append(text.element);
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
	  }
	}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _chartLine = __webpack_require__(149);
	
	var line = _interopRequireWildcard(_chartLine);
	
	var _chartArea = __webpack_require__(147);
	
	var area = _interopRequireWildcard(_chartArea);
	
	var _chartBar = __webpack_require__(148);
	
	var bar = _interopRequireWildcard(_chartBar);
	
	var _chartPie = __webpack_require__(150);
	
	var pie = _interopRequireWildcard(_chartPie);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Updates options for specific chart types.
	 */
	function preRender(data, options) {
	  switch (options.type) {
	    case 'line':
	      return line.preRender(data, options);
	    case 'area':
	      return area.preRender(data, options);
	    case 'pie':
	      return pie.preRender(data, options);
	    case 'bar':
	    case 'column':
	      return bar.preRender(data, options);
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  switch (options.type) {
	    case 'line':
	      line.postRender(highchart, options);
	      break;
	    case 'area':
	      area.postRender(highchart, options);
	      break;
	    case 'pie':
	      pie.postRender(highchart, options);
	      break;
	    case 'bar':
	    case 'column':
	      bar.postRender(highchart, options);
	      break;
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    switch (options.type) {
	      case 'line':
	        return line.renderInvalidated(rendered, options, invalidated);
	      case 'area':
	        return area.renderInvalidated(rendered, options, invalidated);
	      case 'pie':
	        return pie.renderInvalidated(rendered, options, invalidated);
	      case 'bar':
	      case 'column':
	        return bar.renderInvalidated(rendered, options, invalidated);
	    }
	    return false;
	  }
	}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _spacing = __webpack_require__(155);
	
	var _chart = __webpack_require__(151);
	
	var chart = _interopRequireWildcard(_chart);
	
	var _legend = __webpack_require__(153);
	
	var legend = _interopRequireWildcard(_legend);
	
	var _tooltips = __webpack_require__(156);
	
	var tooltips = _interopRequireWildcard(_tooltips);
	
	var _axes = __webpack_require__(146);
	
	var axes = _interopRequireWildcard(_axes);
	
	var _recessions = __webpack_require__(154);
	
	var recessions = _interopRequireWildcard(_recessions);
	
	var _annotations = __webpack_require__(141);
	
	var annotations = _interopRequireWildcard(_annotations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * The Inner Chart renders the actual chart sans headlines or footnotes.
	 */
	function preRender(options) {
	  var data = {
	    exporting: {
	      enabled: false
	    },
	    series: options.series,
	    chart: {
	      reflow: false,
	      type: options.type,
	      width: options.width,
	      height: options.height,
	      style: options.styles.base,
	      renderTo: options.el.querySelector('.dj-chart-inner'),
	      backgroundColor: 'transparent'
	      // backgroundColor: 'rgba(255, 0, 0, 0.1)'
	    },
	    credits: { enabled: false },
	    title: { text: null },
	    legend: { enabled: false },
	    plotOptions: {},
	    xAxis: {},
	    yAxis: {}
	  };
	  if (options.irregularDates) {
	    data.scrollbar = { enabled: false };
	    data.rangeSelector = { enabled: false };
	    data.navigator = { enabled: false };
	  }
	  data.chart.spacing = (0, _spacing.chartSpacing)(options);
	  var isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
	  // only invoke addSpaceForAnnotations for charts that can't be found in isSmallMW variable
	  if (!isSmallMW) {
	    data.chart.spacing = (0, _spacing.addSpaceForAnnotations)(data.chart.spacing, options);
	  }
	
	  data.plotOptions[options.type] = {};
	  data = chart.preRender(data, options);
	  var isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
	  if (isZR || options.size.indexOf('thumb') === 0) {
	    data.plotOptions.series = data.plotOptions.series || {};
	    data.plotOptions.series.enableMouseTracking = false;
	    data.xAxis.labels = data.xAxis.labels || {};
	    data.yAxis.labels = data.yAxis.labels || {};
	    data.yAxis.labels.enabled = false;
	    if (isZR) data.xAxis.labels.enabled = false;
	    data.xAxis.tickWidth = 0;
	    data.yAxis.title = data.yAxis.title || {};
	    data.yAxis.title.text = '';
	    data.yAxis.gridLineWidth = data.xAxis.gridLineWidth = 0;
	    data.xAxis.lineWidth = 0;
	    data.chart.spacingTop = 0;
	  } else {
	    data = legend.preRender(data, options);
	    data = tooltips.preRender(data, options);
	    data = axes.preRender(data, options);
	    data = recessions.preRender(data, options);
	  }
	  if (options.size === 'marketwatch-ZT') {
	    data.xAxis.labels.enabled = false;
	    data.chart.spacingBottom = 20;
	  }
	  if (options.irregularDates) {
	    data.xAxis.crosshair = { width: 0 };
	    data.yAxis.showLastLabel = true;
	  }
	
	  return data;
	}
	
	function postRender(highchart, options) {
	  chart.postRender(highchart, options);
	  var isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
	  if (options.size.indexOf('thumb') === 0 || isZR || options.size === 'marketwatch-ZT') {
	    if (false) {
	      if (options.type !== 'bar') {
	        // unclear what this did
	        var topEl = options.el.lastChild.lastChild.lastChild.lastChild;
	        var firstChildThumb = topEl.firstChild;
	        var secondChildThumb = topEl.lastChild;
	        // firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
	        // firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
	      }
	    }
	  } else {
	    legend.postRender(highchart, options);
	    tooltips.postRender(highchart, options);
	    axes.postRender(highchart, options);
	    recessions.postRender(highchart, options);
	    annotations.postRender(highchart, options);
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    chart.renderInvalidated(rendered, options, invalidated);
	  }
	}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _constants = __webpack_require__(2);
	
	var _transform = __webpack_require__(5);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	var _format = __webpack_require__(4);
	
	var format = _interopRequireWildcard(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MIN_ITEM_CHARS = 16;
	var MAX_ITEM_CHARS = 32;
	var MIN_CHARS_RATIO = MIN_ITEM_CHARS / _constants.MAX_4U_WIDTH;
	
	function preRender(data, options) {
	  if (false) {
	    if (options.size === 'marketwatch-ZT') {
	      return data;
	    }
	  }
	  data.legend = {
	    enabled: options.legend.enabled && options.type !== 'pie' && options.size !== 'marketwatch-ZT',
	    navigation: { enabled: false }
	  };
	  if (data.legend.enabled) {
	    options.forceLegendTop = options.legend.layout === 'right' && (options.print && options.width <= _constants.MAX_NARROW_WIDTH_PRINT || !options.print && options.width <= _constants.MAX_4U_WIDTH);
	    styleLegend(data, options);
	    compileLegendText(data, options);
	    positionLegend(data, options);
	  }
	  return data;
	}
	
	function positionLegend(data, options) {
	  var LH = parseFloat(options.styles.normal.lineHeight);
	  if (options.forceLegendTop) {
	    options.legend.layout = 'top';
	  }
	  switch (options.legend.layout) {
	    case 'top':
	      data.legend.layout = 'horizontal';
	      data.legend.align = 'left';
	      data.legend.verticalAlign = 'top';
	      if (options.print) {
	        data.legend.margin = options.type === 'bar' ? 8 : 4;
	      }
	      break;
	    case 'bottom':
	      data.legend.layout = 'horizontal';
	      data.legend.verticalAlign = 'bottom';
	      data.legend.align = 'left';
	      if (options.print) {
	        if (options.type === 'bar') {
	          data.legend.margin = 4;
	          data.chart.spacing[2] += 6;
	        } else {
	          data.chart.spacing[2] += -2;
	        }
	      }
	      break;
	    // case 'right':
	    default:
	      data.legend.layout = 'vertical';
	      data.legend.align = 'right';
	      data.legend.verticalAlign = 'middle';
	      break;
	  }
	  return data;
	}
	
	function compileLegendText(data, options) {
	  data.legend.labelFormatter = function () {
	    var _this = this;
	
	    var openTag = '<b>',
	        closeTag = '</b>';
	    var series = options.series.find(function (series) {
	      return series.name === _this.name;
	    });
	    var text = compileText(series, this, options);
	    var textBr = element.replaceLineBreaks(text);
	    var lines = textBr.split('<br>');
	    var boldLegend = element.boldText();
	    var bolded = lines.map(function (line) {
	      return boldLegend(line, openTag, closeTag);
	    });
	    return bolded.join('<br>');
	  };
	}
	
	function styleLegend(data, options) {
	  var fontFamilyStyle = options.product === 'financialnews' ? options.styles.font.normal : options.styles.font.semibold;
	  var fontFamilyWeight = options.product === 'financialnews' ? options.styles.weight.normal : options.styles.weight.semibold;
	  var fontSizePrint = 7.5;
	  if (false) {
	    if (options.product === 'financialnews') {
	      fontSizePrint = options.print && options.sizes['print-fn'].columns <= 2 ? '7.75px' : '12px';
	    }
	  }
	  var fontStyle = options.print ? {
	    fontFamily: options.styles.font.normal,
	    fontWeight: options.styles.weight.normal,
	    fontSize: fontSizePrint
	  } : {
	    fontFamily: fontFamilyStyle,
	    fontWeight: fontFamilyStyle
	  };
	  var styles = options.styles.get('normal', fontStyle);
	
	  if (true) {
	    if (options.product === 'wsj') {
	      styles = Object.assign({}, {
	        fontSize: options.styles.legend.fontSize,
	        fontWeight: options.styles.legend.fontWeight,
	        lineHeight: options.styles.legend.lineHeight
	      });
	    }
	  }
	
	  data.legend.itemStyle = styles;
	
	  if (options.legend.layout === 'right' && !options.forceLegendTop) {
	    // if (options.print) {
	    var width = options.width * 0.25 - 20; //data.legend.margin;
	    data.legend.itemStyle.width = width; //`${width}px`;
	    // }
	
	    if (options.print) {
	      data.legend.margin = 4;
	    }
	    data.legend.padding = 2;
	  } else {
	    data.legend.padding = options.print ? 0 : 2;
	  }
	  data.legend.itemDistance = options.print ? 6 : 12;
	  data.legend.itemMarginBottom = options.print ? 4 : 6;
	
	  // this doesnt do what you think it does.
	  // for some reason this helps space the series name and the series symbol
	  data.legend.symbolWidth = options.print ? 4 : 9;
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.legend.symbolWidth = options.print ? 4 : 7;
	    }
	  }
	
	  if (!options.print) {
	    data.legend.itemStyle.textOverflow = null;
	  }
	
	  data.legend.symbolHeight = options.print ? 6 : 12;
	  data.legend.symbolRadius = 0;
	  var isTooSmallForLineUp = options.series.length > 4 && options.height < 400;
	  if (isTooSmallForLineUp) {
	    data.legend.verticalAlign = 'middle';
	  }
	
	  return data;
	}
	
	function postRender(highchart, options) {
	  if (highchart.legend.options.enabled) {
	    positionLegendContainer(highchart, options);
	    var items = highchart.container.querySelectorAll('.highcharts-legend-item');
	    disableItems(highchart, options, items);
	    formatItems(highchart, options, items);
	    if (options.legend.layout === 'right' && items.length) {
	      positionRightAlignedItems(highchart, options, items);
	    }
	    if ((options.type === 'column' || options.type === 'bar') && options.colorMode === 'THRESHOLD' && items.length) {
	      styleColorChip(options.series[0], items[0]);
	    }
	  }
	}
	
	// Resets the legend group Y as items will track data/item paths instead.
	// Note that `null` in Highcharts is not the same as `0`.
	function positionLegendContainer(highchart, options) {
	  var el = highchart.container.querySelector('.highcharts-legend');
	  var isBar = options.type === 'bar';
	  var x = null;
	  var y = null;
	  if (options.legend.layout === 'top') {
	    y = isBar ? 0 : 0;
	  } else if (options.legend.layout === 'bottom') {
	    // y = highchart.spacingBox.height + highchart.legend.itemHeight;
	    // y = options.height - parseFloat(options.styles.normal.lineHeight) * 2;
	  } else if (options.legend.layout === 'right') {
	    y = isBar ? null : 0;
	  }
	  transform.write(el, 'translate', x, y);
	}
	
	// Disable clicks on legend items since the Highcharts behavior is not
	// requested and also a bit strange.
	function disableItems(highchart, options, items) {
	  for (var i = 0; i < highchart.series.length; i++) {
	    if (highchart.series[i].legendGroup) {
	      highchart.series[i].legendGroup.element.onmouseover = null;
	      if (items[i]) items[i].querySelector('text').style.cursor = 'default';
	    }
	  }
	}
	
	// Takes the color in the block and applies it to the text.
	function formatItems(highchart, options, items) {
	  var x = 0;
	  var initX = 0;
	  for (var i = 0; i < items.length; i++) {
	    var item = items[i];
	    // Draw the key with the correct dimensions:
	    var rect = null;
	    var path = null;
	
	    if (rect = item.querySelector('rect')) {
	      if (options.product !== 'marketwatch') {
	        var isWSJ = options.product === 'wsj' ? 12 : 13;
	        rect.setAttribute('width', options.print ? 4 : 9);
	        rect.setAttribute('height', options.print ? 6 : isWSJ);
	        rect.setAttribute('x', 0);
	        rect.setAttribute('y', options.print ? 9 : 5);
	      }
	      if (false) {
	        if (options.product === 'financialnews') {
	          var circleX = Number(items[i].children[0].getAttribute('x'));
	          var circleY = Number(items[i].children[0].getAttribute('y'));
	          var circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
	          var positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 11;
	          var positionX = options.print ? 0 : 7;
	          var circle = highchart.renderer.circle(positionX, positionY, circleRadius).attr({
	            fill: items[i].children[1].getAttribute('fill')
	          });
	          items[i].append(circle.element);
	          if (options.print) {
	            items[i].children[0].setAttribute('x', circleX + 10);
	          }
	          rect.setAttribute('opacity', 0);
	        }
	      }
	
	      if (false) {
	        if ((options.type === 'bar' || options.type === 'area' || options.type === 'column') && options.product === 'marketwatch') {
	          rect.setAttribute('width', 13);
	          rect.setAttribute('height', 13);
	          rect.setAttribute('x', -3);
	          rect.setAttribute('y', 5);
	        }
	      }
	    } else if (path = item.querySelector('path')) {
	      if (options.product !== 'marketwatch') {
	        path.setAttribute('stroke-width', options.print ? 6 : 13);
	        path.setAttribute('d', options.print ? 'M 0 12 L 4 12' : 'M 0 11 L 9 11');
	      }
	
	      if (true) {
	        if (options.product === 'wsj') {
	          path.setAttribute('stroke-width', options.styles.legend.rectHeight);
	          path.setAttribute('d', 'M 0 11 L ' + options.styles.legend.rectWidth + ' 11');
	        }
	      }
	
	      if (false) {
	        if (options.type === 'line' && options.product === 'marketwatch') {
	          path.setAttribute('stroke-width', 3);
	          path.setAttribute('d', 'M 0 11 L 9 11');
	        } else if (options.type !== 'line' && options.product === 'marketwatch') {
	          path.setAttribute('stroke-width', options.print ? 6 : 13);
	          path.setAttribute('d', options.print ? 'M 0 12 L 4 12' : 'M 0 11 L 9 11');
	        }
	      }
	      if (false) {
	        if (options.product === 'financialnews') {
	          var pathColor = items[i].children[1].getAttribute('fill');
	          var _circleX = Number(items[i].children[2].getAttribute('x'));
	          var _circleY = Number(items[i].children[2].getAttribute('y'));
	          var _circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
	          var _positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 4;
	          var _positionX = options.print ? 10 : 8;
	          var _circle = highchart.renderer.circle(_circleX - _positionX, _circleY - _positionY, _circleRadius).attr({
	            fill: pathColor
	          });
	          items[i].append(_circle.element);
	          path.setAttribute('opacity', 0);
	          if (options.print) {
	            var translateVal = items[i].getAttribute('transform');
	            var getLastVal = translateVal.split(',');
	            items[i].setAttribute('transform', 'translate(10,' + getLastVal[1]);
	          }
	        }
	      }
	    }
	
	    if (options.print) {
	      var text = item.querySelector('text');
	      text.setAttribute('x', 6);
	    }
	
	    if (options.product === 'wsj' && !options.print) {
	      var _text = item.querySelector('text');
	      _text.setAttribute('y', 17);
	    }
	
	    // Space the items apart. TODO: Figure out how to make Highcharts do this!
	    // if (options.legend.layout !== 'right') {
	    //   const translate = transform.read(item, 'translate');
	    //   if (i === 0) {
	    //      initX = translate[0];
	    //   }
	    //   if (translate[0] <= initX) {
	    //     x = 0;
	    //   }
	    //   transform.write(item, 'translate', translate[0] + x);
	    //   x += options.print ? 6 : 12;
	    // }
	  }
	}
	
	function positionRightAlignedItems(highchart, options, items) {
	  switch (options.type) {
	    case 'area':
	    case 'line':
	      positionLineItems(highchart, items, options);
	      break;
	    case 'column':
	      positionColumnItems(highchart, items, options);
	      break;
	    case 'bar':
	      positionItemsMiddle(highchart);
	      break;
	  }
	}
	
	function positionLineItems(highchart, items, options) {
	  // const isTooSmallForLineUp = options.series.length > 4 && options.height < 400;
	  var itemY = getLineItemsY(highchart.container, items, options);
	  var botY = highchart.plotTop + highchart.plotHeight;
	  positionLegendItems(itemY, items, options, botY, highchart);
	  // if (!isTooSmallForLineUp) {
	  //   positionLegendItems(itemY, items, options, botY, highchart);
	  // } else {
	  //   positionItemsMiddle(highchart);
	  // } 
	}
	
	function positionColumnItems(highchart, items, options) {
	  var itemY = getColumnItemsY(highchart.container, items, options);
	  var botY = highchart.plotTop + highchart.plotHeight;
	  positionItemsMiddle(highchart);
	}
	
	// Necessary because Highcharts messes up "middle".
	function positionItemsMiddle(highchart) {
	  var legendEl = highchart.container.querySelector('g.highcharts-legend');
	  var translate = transform.read(legendEl, 'translate');
	  var height = legendEl.getBoundingClientRect().height;
	  var newY = highchart.plotTop + (highchart.plotHeight - height) / 2;
	  transform.write(legendEl, 'translate', translate[0], newY);
	}
	
	// Positions the legend items to track data points but not overlap.
	function positionLegendItems(itemY, items, options, botY, highchart) {
	  var lineHeight = parseFloat(options.styles.lineHeight.normal);
	  var midIndex = Math.min(itemY.length - 1, Math.round(itemY.length / 2));
	  var margin = 8; //options.print ? 4 : 8;
	  var willFit = true;
	
	  // let y = itemY[midIndex].y;
	  // for (let i = midIndex - 1; i >= 0; i--) {
	  //   let h = items[itemY[i].index].getBoundingClientRect().height + margin;
	  //   itemY[i].y = Math.min(itemY[i].y, y - h);
	  //   y = itemY[i].y;
	  // }
	  // y = itemY[midIndex].y +
	  // items[itemY[midIndex].index].getBoundingClientRect().height + margin;
	
	  // find the Y positions for the corresponding series by matching color
	  var legendItemPositions = [].concat(_toConsumableArray(items)).map(function (legendItem, i) {
	    var _ref = options.type === 'line' ? ['path', 'stroke'] : ['rect', 'fill'],
	        _ref2 = _slicedToArray(_ref, 2),
	        el = _ref2[0],
	        attr = _ref2[1];
	
	    var colorChip = legendItem.querySelector(el);
	    var color = window.getComputedStyle(colorChip).getPropertyValue(attr);
	    var match = itemY.find(function (obj) {
	      return obj.color === color;
	    });
	    return { index: i, y: match.y };
	  });
	  sortItemY(legendItemPositions);
	  var y = legendItemPositions[0].y;
	
	  legendItemPositions.forEach(function (position) {
	    position.y = Math.max(position.y, y);
	    y = position.y + items[position.index].getBoundingClientRect().height + margin;
	  });
	
	  // y = 0;
	  // for (let i = 0; i < midIndex; i++) {
	  //   itemY[i].y = Math.max(y, itemY[i].y);
	  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
	  // }
	
	  // for (let i = midIndex; i < items.length; i++) {
	  //   // let h = y + items[itemY[i - 1].index].getBoundingClientRect().height;// + margin;
	  //   itemY[i].y = Math.max(itemY[i].y, y);
	  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
	  // }
	
	
	  legendItemPositions.forEach(function (position) {
	    if (position.y > botY) {
	      positionItemsMiddle(highchart);
	      willFit = false;
	    }
	  });
	
	  // Finally, set the Y of the actual legend item element.
	  if (willFit) {
	    legendItemPositions.forEach(function (position) {
	      if (position.y < botY) {
	        transform.write(items[position.index], 'translate', null, position.y);
	      }
	    });
	  }
	}
	
	// Returns array of Y positions for each legend item for column charts.
	function getColumnItemsY(container, items, options) {
	  var fontSize = parseFloat(options.styles.size.normal);
	  var seriesEl = container.querySelector('.highcharts-series-group');
	  var barsEl = seriesEl.querySelectorAll('.highcharts-series');
	  var printOffset = options.print ? -8 : 0;
	  var itemY = [];
	
	  for (var i = 0; i < items.length; i++) {
	    // Get the path's parent and path Y.
	    var g = barsEl[i];
	    var rects = g.querySelectorAll('rect');
	    var r = rects[rects.length - 1];
	    var rY = rects && rects.length ? transform.read(g, 'translate')[1] + (+r.getAttribute('y') + +r.getAttribute('height') / 2) : fontSize;
	
	    // Combine the results.
	    itemY[i] = {
	      index: i,
	      y: rY - fontSize + printOffset
	    };
	  }
	
	  return sortItemY(itemY);
	}
	
	// Returns array of Y positions for each legend item for line/area charts.
	function getLineItemsY(container, items, options) {
	  var fontSize = parseFloat(options.styles.size.normal);
	  var seriesEl = container.querySelector('.highcharts-series-group');
	  var linesEl = seriesEl.querySelectorAll('.highcharts-series');
	  var itemY = [];
	
	  for (var i = 0; i < linesEl.length; i++) {
	    // Get the path's parent and path Y.
	    var _ref3 = options.type === 'area' ? [i, 'fill'] : [linesEl.length - i - 1, 'stroke'],
	        _ref4 = _slicedToArray(_ref3, 2),
	        lineIndex = _ref4[0],
	        attr = _ref4[1];
	
	    var pathEl = linesEl[lineIndex];
	    var pathElY = transform.read(pathEl, 'translate')[1];
	    var paths = pathEl.querySelectorAll('path');
	    var d = transform.read(paths[0], 'd');
	    var color = window.getComputedStyle(paths[0]).getPropertyValue(attr);
	    d.sort(function (a, b) {
	      return b[0] - a[0];
	    });
	
	    var pathY = void 0;
	    if (options.type === 'line') {
	      pathY = d[0][1];
	    } else {
	      (function () {
	        var dx = d[0][0];
	        var d0 = d.filter(function (item) {
	          return item[0] === dx;
	        }).sort(function (a, b) {
	          return a[1] - b[1];
	        });
	        if (d0.length >= 2) {
	          pathY = (d0[d0.length - 1][1] - d0[0][1]) / 2 + d0[0][1];
	        } else {
	          pathY = d0[0][1];
	        }
	      })();
	    }
	
	    // Combine the results.
	    itemY[i] = {
	      index: i,
	      y: pathY + fontSize / 2,
	      color: color
	    };
	  }
	  return sortItemY(itemY);
	}
	
	// Sort on Y and return.
	function sortItemY(itemY) {
	  itemY.sort(function (a, b) {
	    return a.y - b.y;
	  });
	  return itemY;
	}
	
	function compileText(series, item, options) {
	  return (series.markdown || '').replace(_constants.CATEGORY, compiledCategory(options) || 'n/a').replace(_constants.SERIES, series.name || 'n/a').replace(_constants.VALUE, lastItem(item.yData)).replace(_constants.POINT, compiledPoint(item.yData, options));
	}
	
	function compiledCategory(options) {
	  return options.categoriesAreDates && options.dates[0].value > lastItem(options.dates).value ? options.longCategories[0] : lastItem(options.longCategories);
	}
	
	function compiledPoint(data, options) {
	  return lastItem(data) ? format.applyFull(lastItem(data), options.tooltips, options.type === 'pie', true, true) : 'null';
	}
	
	function lastItem(arr) {
	  return arr[arr.length - 1];
	}
	
	// split the color chip into two colors for threshold charts
	function styleColorChip(series, item) {
	  var colorChip = item.querySelector('rect');
	  var topColor = series.color;
	  var bottomColor = series.negativeColor;
	  var _ref5 = [createSvgEl('defs'), createSvgEl('linearGradient'), createSvgEl('stop'), createSvgEl('stop')],
	      defs = _ref5[0],
	      gradient = _ref5[1],
	      topStop = _ref5[2],
	      bottomStop = _ref5[3];
	
	  var gradientAttrs = { 'id': 'lg', 'x2': '0%', 'y2': '100%' };
	  setAttrs(gradient, gradientAttrs);
	  setOffset(topStop, bottomStop);
	  setColor(topStop, topColor);
	  setColor(bottomStop, bottomColor);
	  gradient.appendChild(topStop);
	  gradient.appendChild(bottomStop);
	  defs.appendChild(gradient);
	  item.appendChild(defs);
	  colorChip.setAttribute('fill', 'url(#lg)');
	}
	
	function createSvgEl(type) {
	  var svgns = 'http://www.w3.org/2000/svg';
	  return document.createElementNS(svgns, type);
	}
	
	function setAttrs(el, attrs) {
	  for (var key in attrs) {
	    el.setAttribute(key, attrs[key]);
	  }
	}
	
	function setOffset() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  args.forEach(function (arg) {
	    return arg.setAttribute('offset', '50%');
	  });
	}
	
	function setColor(el, color) {
	  el.setAttribute('stop-color', color);
	}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RECESSIONS = undefined;
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _transform = __webpack_require__(5);
	
	var transform = _interopRequireWildcard(_transform);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var COLOR_BAND = '#E6E6E6';
	var COLOR_LABEL_VER = '#666666'; //'rgba(0, 0, 0, 0.2)';
	var COLOR_LABEL_HOR = '#666666'; //#727272
	var MARGIN_VER = 8;
	var MARGIN_HOR = 2;
	var OFFSET = 0; //-0.38;
	
	// Data from http://www.nber.org/cycles.html
	var RECESSIONS = exports.RECESSIONS = [{ start: { month: 5, year: 1857 }, end: { month: 11, year: 1858 } }, { start: { month: 9, year: 1860 }, end: { month: 5, year: 1861 } }, { start: { month: 3, year: 1865 }, end: { month: 11, year: 1867 } }, { start: { month: 5, year: 1869 }, end: { month: 11, year: 1870 } }, { start: { month: 9, year: 1873 }, end: { month: 2, year: 1879 } }, { start: { month: 2, year: 1882 }, end: { month: 4, year: 1885 } }, { start: { month: 2, year: 1887 }, end: { month: 3, year: 1888 } }, { start: { month: 6, year: 1890 }, end: { month: 4, year: 1891 } }, { start: { month: 0, year: 1893 }, end: { month: 5, year: 1894 } }, { start: { month: 11, year: 1895 }, end: { month: 5, year: 1897 } }, { start: { month: 5, year: 1899 }, end: { month: 11, year: 1900 } }, { start: { month: 8, year: 1902 }, end: { month: 7, year: 1904 } }, { start: { month: 4, year: 1907 }, end: { month: 5, year: 1908 } }, { start: { month: 0, year: 1910 }, end: { month: 0, year: 1912 } }, { start: { month: 0, year: 1913 }, end: { month: 11, year: 1914 } }, { start: { month: 7, year: 1918 }, end: { month: 2, year: 1919 } }, { start: { month: 0, year: 1920 }, end: { month: 6, year: 1921 } }, { start: { month: 4, year: 1923 }, end: { month: 6, year: 1924 } }, { start: { month: 9, year: 1926 }, end: { month: 10, year: 1927 } }, { start: { month: 7, year: 1929 }, end: { month: 2, year: 1933 } }, { start: { month: 4, year: 1937 }, end: { month: 5, year: 1938 } }, { start: { month: 1, year: 1945 }, end: { month: 9, year: 1945 } }, { start: { month: 10, year: 1948 }, end: { month: 9, year: 1949 } }, { start: { month: 6, year: 1953 }, end: { month: 4, year: 1954 } }, { start: { month: 7, year: 1957 }, end: { month: 3, year: 1958 } }, { start: { month: 3, year: 1960 }, end: { month: 1, year: 1961 } }, { start: { month: 11, year: 1969 }, end: { month: 10, year: 1970 } }, { start: { month: 10, year: 1973 }, end: { month: 2, year: 1975 } }, { start: { month: 0, year: 1980 }, end: { month: 6, year: 1980 } }, { start: { month: 6, year: 1981 }, end: { month: 10, year: 1982 } }, { start: { month: 6, year: 1990 }, end: { month: 2, year: 1991 } }, { start: { month: 2, year: 2001 }, end: { month: 10, year: 2001 } }, { start: { month: 11, year: 2007 }, end: { month: 5, year: 2009 } }];
	
	/**
	 * Pre Render
	 */
	function preRender(data, options) {
	  if (canShowRecessions(options)) {
	    var values = convertDataToValues();
	    var dateA = options.dates[0];
	    var dateB = options.dates[options.dates.length - 1];
	    var axisValueA = new Date(dateA.year, dateA.month || 0).valueOf();
	    var axisValueB = new Date(dateB.year, dateB.month || 0).valueOf();
	
	    var conditionalColorBand = void 0;
	    if (options.product === 'marketwatch') {
	      conditionalColorBand = '#eeeff0';
	    } else {
	      conditionalColorBand = COLOR_BAND;
	    }
	
	    var plotBands = values.map(function (v) {
	      if (v.start <= axisValueB && v.end >= axisValueA) {
	        return {
	          from: Math.max(axisValueA, v.start),
	          to: Math.min(axisValueB, v.end),
	          color: conditionalColorBand
	        };
	      }
	      return null;
	    }).filter(function (item) {
	      return item !== null;
	    });
	
	    if (plotBands.length) {
	      if (options.quarterlyResults && options.series[0].data.length <= 44) {
	        plotBands = convertDatetimeToLinear(plotBands, options.dates);
	      }
	      data.xAxis.plotBands = plotBands;
	    }
	  }
	  return data;
	}
	
	function canShowRecessions(options) {
	  return options.axes.showRecessions && options.dates && options.type !== 'pie' && options.type !== 'bar' && allHaveYears(options.dates);
	}
	
	function allHaveYears(dates) {
	  return !dates.some(function (date) {
	    return date.year === undefined;
	  });
	}
	
	function convertDataToValues() {
	  return RECESSIONS.map(function (r) {
	    return {
	      start: new Date(r.start.year, r.start.month).valueOf(),
	      end: new Date(r.end.year, r.end.month).valueOf()
	    };
	  });
	}
	
	// On datetime axes, values are milliseconds. On linear axes, values are
	// just indices. For quarterly results, the axis is actually linear and just
	// pretends to be datetime, so plotBands must be converted from datetime.
	function convertDatetimeToLinear(plotBands, dates) {
	  var datesLen = dates.length;
	  plotBands.forEach(function (pb) {
	    var newFrom = 0;
	    var newTo = datesLen - 1;
	    dates.forEach(function (date, index) {
	      if (pb.from >= date.value) {
	        newFrom = index;
	      }
	      if (pb.to >= date.value) {
	        newTo = index;
	      }
	    });
	    newFrom = getLinearPrecise(newFrom, pb.from, dates);
	    newTo = getLinearPrecise(newTo, pb.to, dates);
	    pb.from = newFrom;
	    pb.to = newTo;
	  });
	  return plotBands;
	}
	
	// For use with convertDatetimeToLinear().
	function getLinearPrecise(linear, datetime, dates) {
	  if (linear < dates.length - 1) {
	    linear += (datetime - dates[linear].value) / (dates[linear + 1].value - dates[linear].value);
	  }
	  return linear;
	}
	
	/**
	 * Post Render
	 */
	function postRender(highchart, options) {
	  var xAxis = highchart.xAxis[0];
	  var pb = xAxis.plotLinesAndBands;
	
	  if (pb.length) {
	    var pos = null;
	    var rtext = null;
	    var maxPx = 0;
	
	    if (options.type === 'bar') {
	      pos = {
	        x: highchart.plotLeft + highchart.plotWidth - MARGIN_HOR,
	        y: highchart.plotTop + parseFloat(options.styles.small.fontSize)
	      };
	      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_HOR);
	      rtext.element.setAttribute('x', +rtext.element.getAttribute('x') - rtext.element.getBoundingClientRect().width);
	      maxPx = highchart.plotTop + highchart.plotHeight;
	
	      moveRecessionTextHorizontal(pb, rtext.element, maxPx);
	    } else {
	      if (options.ticksOffsetX) {
	        offsetPlotBands(pb, options.ticksOffsetX);
	      }
	      pos = topYAxisLabelPosition(highchart, options);
	      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_VER);
	      maxPx = highchart.plotLeft + highchart.plotWidth;
	      moveRecessionTextVertical(pb, rtext.element, options.ticksOffsetX || 0, maxPx);
	    }
	  }
	}
	
	function offsetPlotBands(plotBands, offsetX) {
	  plotBands.forEach(function (pb) {
	    transform.write(pb.svgElem.element, 'translate', offsetX);
	  });
	}
	
	function moveRecessionTextHorizontal(pb, el, maxY) {
	  var y = +el.getAttribute('y');
	  var origY = y;
	  var elHeight = el.getBoundingClientRect().height + MARGIN_HOR;
	  for (var i = 0; i < pb.length; i++) {
	    if (!pb[i].svgElem) continue;
	    var d = transform.read(null, 'd', pb[i].svgElem.d);
	    if (d[2][1] - d[1][1] >= elHeight) {
	      y = d[2][1] - MARGIN_HOR;
	      break;
	    } else if (i === pb.length - 1) {
	      y = d[1][1] - MARGIN_HOR;
	    }
	  }
	  el.setAttribute('y', Math.max(origY, Math.min(y, maxY - elHeight)));
	}
	
	function moveRecessionTextVertical(pb, el, offsetX, maxX) {
	  var elWidth = el.getBoundingClientRect().width;
	  var x = +el.getAttribute('x');
	  for (var i = 0; i < pb.length; i++) {
	    if (!pb[i].svgElem) continue;
	    var d = transform.read(null, 'd', pb[i].svgElem.d);
	    if (d[0][0] >= x) {
	      x = d[0][0];
	      break;
	    } else if (d[2][0] >= x + elWidth) {
	      x = d[2][0] - elWidth;
	      break;
	    }
	  }
	  x += offsetX;
	  el.setAttribute('x', Math.min(x, maxX - elWidth));
	}
	
	function writeRecessionText(highchart, options, pos, color) {
	  if ((options.product === 'marketwatch' || options.product === 'financialnews') && options.type === 'line') {
	    var bandsX = highchart.container.getElementsByClassName('highcharts-plot-bands-0')[0].getBoundingClientRect();
	    bandsX = bandsX.left - bandsX.width;
	    pos.x = bandsX;
	  }
	
	  var css = options.styles.get('normal', { color: color });
	
	  if (true) {
	    if (options.product === 'wsj') {
	      css.fontSize = "13px";
	      css.fontFamily = "Retina Narrow";
	
	      if (options.print) {
	        css.fontSize = "7.5px";
	      }
	    }
	  }
	  return highchart.renderer.text('RECESSION', pos.x, pos.y).css(css).attr('class', 'label-recession').add();
	}
	
	// Finds the Y of the top label on the y-axis in order to align "recession"
	// on the same baseline. If units have been set, uses that as a shortcut.
	function topYAxisLabelPosition(highchart, options) {
	  var pos = { x: 0, y: 0 };
	  var textUnits = highchart.container.querySelector('text.units');
	  if (textUnits) {
	    pos.x = +textUnits.getAttribute('x') + textUnits.getBoundingClientRect().width;
	    pos.y = +textUnits.getAttribute('y') - 1;
	  } else {
	    (0, _util.forAxisTicks)(highchart.yAxis[0], function (tick) {
	      if (tick.isLast) {
	        pos.x = +tick.label.element.getAttribute('x') + tick.label.element.getBoundingClientRect().width;
	        pos.y = +tick.label.element.getAttribute('y');
	        return false;
	      }
	    });
	  }
	
	  if (true) {
	    if (options.product === 'wsj' && options.print) {
	      pos.y = pos.y + 1;
	    }
	  }
	
	  pos.x += MARGIN_VER;
	  return pos;
	}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.chartSpacing = chartSpacing;
	exports.chartMargin = chartMargin;
	exports.addSpaceForAnnotations = addSpaceForAnnotations;
	
	var _constants = __webpack_require__(2);
	
	function chartSpacing(options) {
	  var spacing = [16, 0, 0, 0]; // formerly 28 for index 2
	  if (options.type === 'bar') {
	    spacing[0] += options.print ? -28 : -40; // This makes no sense to me.
	    if (options.print) {
	      spacing[2] = 0;
	    }
	
	    if (true) {
	      if (options.product === 'wsj') {
	        if (options.print) {
	          spacing[0] = -12;
	          spacing[2] = 4;
	        } else {
	          spacing[0] = -20;
	          spacing[2] = 8;
	        }
	      }
	    }
	  } else {
	    if (false) {
	      if (options.product === 'marketwatch') {
	        var hasExtraLegendSpacingRight = options.legend.layout === 'right' && options.legend.enabled ? true : false;
	        var isLineOrColumn = options.type === 'line' || options.type === 'column';
	        var isThumb = options.size === 'thumb-marketwatch-MA' || options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT';
	        var hasSuffix = options.axes.units.suffix;
	        var hasPrefix = options.axes.units.prefix;
	        if (isThumb) {
	          return spacing;
	        }
	        if (isLineOrColumn && options.annotations !== null) {
	          // if no annotations spacing[0] should equal 6
	          spacing[0] = options.annotations.length === 0 ? 6 : 16;
	        }
	        if (isLineOrColumn && options.annotations === null) {
	          spacing[0] = 6;
	        }
	        if (isLineOrColumn && !hasExtraLegendSpacingRight) {
	          var givenSuffix = hasSuffix === " thousand" || hasSuffix === "%" || hasSuffix === " hundred" || hasSuffix === " billion" || hasSuffix === " trillion" || hasSuffix === " cents";
	          if (hasSuffix) {
	            if (hasSuffix === " thousand") {
	              spacing[1] = 70;
	            }
	            if (hasSuffix === "%") {
	              spacing[1] = 20;
	            }
	            if (hasSuffix === " hundred") {
	              spacing[1] = 60;
	            }
	            if (hasSuffix === " billion") {
	              spacing[1] = 45;
	            }
	            if (hasSuffix === " trillion") {
	              spacing[1] = 50;
	            }
	            if (hasSuffix === " cents") {
	              spacing[1] = 40;
	            }
	            if (!givenSuffix) {
	              var suffixLength = hasSuffix.length;
	              var thousand = " thousand";
	              var thousandLength = thousand.length;
	              var diff = suffixLength - thousandLength;
	              if (suffixLength === thousandLength) {
	                spacing[1] = 70;
	              }
	              if (suffixLength > thousandLength) {
	                spacing[1] = 70 + diff * 7;
	              } else {
	                spacing[1] = 70 + diff * 5;
	              }
	            }
	          } else {
	            spacing[1] = 6;
	          }
	          if (hasPrefix && !options.axes.units.formatDecimals && !hasExtraLegendSpacingRight) {
	            spacing[1] = spacing[1] + 5;
	          }
	        }
	      }
	    }
	    if (false) {
	      if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
	        spacing[1] = options.type === 'column' && options.axes.units.suffix === '%' ? 15 : 6;
	      }
	    }
	
	    if (true) {
	      if (options.product === 'wsj') {
	        spacing[0] = 15;
	        spacing[2] = 9;
	
	        if (options.print) {
	          spacing[0] = 14;
	          spacing[2] = 9;
	        }
	
	        if (options.id === '16u') {
	          spacing[0] = 16;
	          spacing[2] = 10;
	        }
	
	        if (options.id === '12u') {
	          spacing[0] = 14;
	          spacing[2] = 10;
	        }
	
	        if (options.id === '8u') {
	          spacing[0] = 13;
	          spacing[2] = 7;
	        }
	
	        if (options.id === '4u') {
	          spacing[0] = 12;
	          spacing[2] = 6;
	        }
	
	        if (options.annotations !== null && options.annotations.length !== 0) {
	          spacing[0] = 16;
	        }
	      }
	    }
	  }
	  if (Array.isArray(options.spacing)) {
	    spacing.forEach(function (n, i) {
	      spacing[i] += options.spacing[i] || 0;
	    });
	  }
	  return spacing;
	}
	
	// DO NOT USE! Interferes with legend spacing!!!
	function chartMargin(options) {
	  return [null, null, null, null];
	  // const lineHeight = parseFloat(options.styles.normal.lineHeight);
	  // const margin = [lineHeight, null, lineHeight * 2, null];
	  // if (options.type === 'bar') {
	  //   margin[0] += 4;
	  //   margin[2] -= lineHeight;
	  // }
	  // return margin;
	  // if (options.size.indexOf('thumb') === 0) {
	  //   return margin;
	  // }
	  // margin[0] = 16;
	  // margin[2] = 28;
	  // if (options.quarterlyResults && options.series[0].data.length <= 9) {
	  //   margin[2] += parseFloat(options.styles.normal.fontSize);
	  // }
	  // if (__WSJ__) {
	  //   if (options.size === 'print-wsj') {
	  //     if (options.type === 'bar') {
	  //       margin[0] = 14;
	  //       margin[2] = 0;
	  //     } else {
	  //       margin[0] = 12;
	  //       margin[2] = 8;
	  //     }
	  //   }
	  // }
	  // return margin;
	}
	
	function addSpaceForAnnotations(spacing, options) {
	  if (possibleAnnotationsSpacing(options) && needsAnnotationSpace(options)) {
	    spacing[1] += options.print ? _constants.ANNOTATIONS_SPACE_PRINT : _constants.ANNOTATIONS_SPACE;
	    options.spaceAddedForAnnotations = true;
	  }
	  return spacing;
	}
	
	function possibleAnnotationsSpacing(options) {
	  return !(options.product === 'marketwatch' || options.type === 'pie' || options.type === 'bar' || options.type === 'column' && options.stacking);
	}
	
	function needsAnnotationSpace(options) {
	  var endIndex = Math.floor((options.maxDataLength - 1) * 0.95);
	  for (var i = 0; i < options.annotations.length; i++) {
	    var a = options.annotations[i];
	    var attach = a.attach.point.enabled ? a.attach.point : a.attach.category;
	    var index = attach.index;
	    if (index >= endIndex) {
	      if (a.lineEnd === 'circle') {
	        return true;
	      }
	      if (options.print && a.lineEnd === 'dot') {
	        return true;
	      }
	    }
	  }
	  return false;
	}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _format = __webpack_require__(4);
	
	var format = _interopRequireWildcard(_format);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function preRender(data, options) {
	  var tooltip = data.tooltip = { enabled: options.interactive };
	  if (tooltip.enabled) {
	    tooltip.borderWidth = 1;
	    tooltip.borderColor = '#CCC';
	    tooltip.shared = false;
	    tooltip.style = getStyle(options);
	
	    tooltip.shadow = false;
	    tooltip.formatter = function () {
	      return formatter(data, options, this);
	    };
	  }
	
	  if (true) {
	    if (options.product === 'wsj') {
	      tooltip.borderRadius = 0;
	      tooltip.padding = 5;
	    }
	  }
	  return data;
	}
	
	function formatter(data, options, context) {
	  // hide tooltip for transparent data
	  if (context.color === _constants.TRANSPARENT) return false;
	  var value = format.applyFull(context.point.y, options.tooltips, options.type === 'pie', true, true);
	  var categories = options.longCategories || (options.categories ? options.categories[0] : null);
	  var firstYear = categories[0];
	  var lastYear = categories[categories.length - 1];
	  var isReverse = false;
	  if (typeof firstYear === 'string' && typeof lastYear === 'string' && options.categoriesAreDates) {
	    var firstYearSplit = firstYear.split(' ');
	    var lastYearSplit = lastYear.split(' ');
	    if (firstYearSplit.indexOf('p.m.') !== -1 && firstYearSplit.indexOf('a.m.') !== -1) {
	      var firstYearTime = firstYearSplit[firstYearSplit.length - 2];
	      var firstYearTimeSplit = firstYearTime.split(':');
	      var hourFirstTimeSplit = parseInt(firstYearTimeSplit) + 12;
	      hourFirstTimeSplit = hourFirstTimeSplit.toString();
	      firstYearTimeSplit[0] = hourFirstTimeSplit;
	      firstYearTimeSplit = firstYearTimeSplit.join(':');
	      var lastYearTime = lastYearSplit[lastYearSplit.length - 2];
	      var lastYearTimeSplit = lastYearTime.split(':');
	      var hourLastTimeSplit = parseInt(lastYearTimeSplit) + 12;
	      hourLastTimeSplit = hourLastTimeSplit.toString();
	      lastYearTimeSplit[0] = hourLastTimeSplit;
	      lastYearTimeSplit = lastYearTimeSplit.join(':');
	
	      isReverse = firstYearTimeSplit > lastYearTimeSplit;
	    } else {
	      isReverse = findIfReverse(categories);
	    }
	  }
	
	  if (isReverse) {
	    categories.reverse();
	  }
	  var seriesData = !data.series ? options.series : data.series;
	  var dataPoint = getDataPoint(seriesData, context, isReverse);
	  var category = void 0;
	  if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
	    category = context.point.name;
	  } else {
	    category = categories ? categories[dataPoint.index] : context.point.category || context.point.options.name;
	  }
	  // console.log(context.point);
	  // if (categories) {
	  //   if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
	  //     category = categories[dataPoint.point.originalIndex];
	  //   } else {
	  //     category = categories[dataPoint.index];
	  //   }
	  // } else {
	  //   category = context.point.category || context.point.options.name;
	  // }
	  var formatter = { index: dataPoint.index, category: category, value: value };
	
	  if ((options.type === 'column' || options.type === 'area') && options.stacking === 'percent') {
	    return formatStackedPercent(data, options, context, formatter);
	  }
	  return formatStandard(options, context, formatter);
	}
	
	function findIfReverse(categories) {
	  var currentDateComparison = categories[0];
	  for (var f = 1; f < categories.length; f++) {
	    if (isNaN(new Date(categories[f]))) {
	      return false;
	    }
	    if (f === 1) {
	      if (Date.parse(currentDateComparison) < Date.parse(categories[f])) {
	        return false;
	      }
	    } else {
	      currentDateComparison = categories[f - 1];
	      if (Date.parse(currentDateComparison) < Date.parse(categories[f])) {
	        return false;
	      }
	      if (f === categories.length - 1 && Date.parse(currentDateComparison) > Date.parse(categories[f])) {
	        return true;
	      }
	    }
	  }
	}
	
	function getDataPoint(series, context, isReverse) {
	  if (context.x !== undefined) {
	    for (var s = 0; s < series.length; s++) {
	      for (var d = 0; d < series[s].data.length; d++) {
	        if (series[s].data[d].x === context.x) {
	          return { point: series[s].data[d], index: series[s].data[d].index };
	        }
	      }
	    }
	  }
	  return {
	    point: context.point,
	    index: context.point.hasOwnProperty('index') ? context.point.index : context.point.x
	  };
	}
	
	function divideValue(value, divisorUnit) {
	  if (divisorUnit && divisorUnit !== 'none') {
	    var divisor = format.getDivisor(divisorUnit);
	    return +value / divisor;
	  }
	  return value;
	}
	
	function space() {
	  return '<span style="color: rgba(255, 255, 255, 0);">x</span>';
	}
	
	function formatStandard(options, context, formatter) {
	  var isWSJWeight = options.product === 'wsj' ? 500 : 600;
	  return ['<span>', formatSeries(options, context), '<span>', formatter.category, '</span>', space(), '<span style="font-weight: ' + isWSJWeight + ';">', formatter.value, '</span>', '</span>'].join('');
	}
	
	function formatStackedPercent(data, options, context, formatter) {
	  var isWSJWeight = options.product === 'wsj' ? 500 : 600;
	  var total = 0;
	  data.series.forEach(function (item) {
	    total += item.data[formatter.index].y;
	  });
	  return ['<span style="', formatter.style, '">', formatSeries(options, context), '<span style="padding: 0 6px 0 0;">', formatter.category, '</span>', space(), '<span style="font-weight: ' + isWSJWeight + '; margin: 0 0 0 24px">', formatter.value, ' (', Math.round(context.point.y / total * 100), '%)', '</span>', '</span>'].join('');
	}
	
	function formatSeries(options, context) {
	  if (options.legend.enabled && options.series.length > 1) {
	    var css = void 0;
	    var defaultCSS = ['padding: 0 6px 0 0;'];
	
	    if (options.product !== 'wsj') {
	      css = defaultCSS.concat(['font-weight: 600;', 'color: ' + context.series.color + ';']).join('');
	    }
	
	    if (options.product === 'wsj') {
	      css = defaultCSS.concat(['font-weight: 500;']).join('');
	    }
	    var nameArray = context.series.name.toString().split(' ');
	    if (nameArray[0] === '<br') {
	      for (var i = 0; i < nameArray.length; i++) {
	        if (nameArray[i] === '<br' || nameArray[i] === '/>') {
	          nameArray.splice(i, 1);
	          i--;
	        }
	      }
	    }
	    nameArray = nameArray.join(' ');
	    return ['<span style="' + css + '">', nameArray, '</span>', space()].join('');
	  }
	}
	
	function getStyle(options) {
	  var data = {
	    padding: '8px',
	    width: '400px',
	    fontSize: '14px',
	    fontFamily: options.styles.font.normal,
	    fontWeight: options.styles.weight.normal,
	    fontStyle: 'normal',
	    color: '#000000'
	  };
	
	  if (true) {
	    if (options.product === 'wsj') {
	      data.fontSize = '15px';
	      data.lineHeight = '18px';
	      data.fontWeight = 300;
	    }
	  }
	
	  return data;
	}
	
	function postRender(highchart, options) {}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaults = undefined;
	exports.preRender = preRender;
	exports.postRender = postRender;
	
	var _format = __webpack_require__(4);
	
	var format = _interopRequireWildcard(_format);
	
	var _constants = __webpack_require__(2);
	
	var _getPoint = __webpack_require__(12);
	
	var _getPoint2 = _interopRequireDefault(_getPoint);
	
	var _lodash = __webpack_require__(166);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _element = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function preRender(data, options) {
	  return data;
	}
	
	function postRender(highchart, options) {
	  var result = {
	    yTop: 0,
	    yBot: 0,
	    items: null
	  };
	  if (chartTypeOk(options)) {
	    // render text with proper styles
	    result.items = renderAnnotations(highchart, options, options.annotations.items);
	    // set spacing value to allow room for annotations at top of chart
	    if (result.items.length) {
	      updateYTop(result, options);
	      // updateYBot(result, options);
	    }
	  }
	  return result;
	}
	
	var defaults = exports.defaults = {
	  type: 'lines',
	  showLine: true,
	  lineEnd: null,
	  textAlign: 'left',
	  flushAlign: 'flush'
	};
	
	function updateYTop(result, options) {
	  var lineHeight = options.product === 'wsj' && !options.print ? 24 : parseFloat(options.styles.normal.lineHeight);
	  var maxHeight = 0;
	  result.items.forEach(function (item, index) {
	    // This works because the only child nodes should be <tspan>s.
	    maxHeight = Math.max(maxHeight, (item.element.children.length - 1) * lineHeight);
	  });
	  result.yTop = maxHeight;
	}
	
	// function updateYBot(result) {
	//   const itemsLen = result.items.length;
	//   let maxHeight = 0;
	//   if (itemsLen > 3) {
	//     for (let i = 1; i < itemsLen; i += 2) {
	//       const itemHeight = result.items[i].element.getBoundingClientRect().height;
	//       maxHeight = Math.max(itemHeight, maxHeight);
	//     }
	//   }
	//   result.yBot = maxHeight;
	// }
	
	function renderAnnotations(highchart, options, items) {
	  var margin = 10;
	  var itemWidth = getItemWidth(options, items);
	  var css = options.styles.get('normal');
	  if (false) {
	    if (options.product === 'financialnews') {
	      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
	        css.fontSize = 8.5;
	      }
	    }
	  }
	  css.width = itemWidth + 'px';
	  var lineHeight = parseFloat(css.lineHeight);
	  items.some(function (item, index) {
	    item.element = renderItemText(highchart, options, item, itemWidth, css);
	  });
	  return items;
	}
	
	function getItemWidth(options, items) {
	  var itemsLen = items.length;
	  if (itemsLen === 1) {
	    return options.width * 0.67;
	  } else if (itemsLen === 2) {
	    return options.width * 0.5;
	  } else if (itemsLen >= 3) {
	    return options.width * 0.33;
	  }
	  return 0;
	}
	
	function renderItemText(highchart, options, item, itemWidth, css) {
	  var text = compileText(item, options);
	  var textBr = (0, _element.replaceLineBreaks)(text);
	  var render = highchart.renderer.text(textBr, 0, 0).css(css).add();
	  var wsjFont = options.product === 'wsj' ? 'Retina' : options.styles.font.bold;
	  // bold any text bracketed by **
	  var openTag = '<tspan font-family=\'' + wsjFont + '\' font-weight="' + options.styles.weight.bold + '">';
	  var closeTag = '</tspan>';
	  var tspans = [].concat(_toConsumableArray(render.element.querySelectorAll('tspan')));
	  var boldAnnotation = (0, _element.boldText)();
	  tspans.forEach(function (tspan, i) {
	    var tspanStr = tspan.innerHTML.toString();
	    tspan.innerHTML = boldAnnotation(tspanStr, openTag, closeTag);
	    // move all tspans up except for the first one;
	    if (true) {
	      if (options.product === 'wsj') {
	        if (i !== 0) {
	          var offset = options.print ? 0 : 2;
	          var dy = tspan.getAttribute('dy');
	          tspan.setAttribute('dy', +dy + offset);
	        }
	      }
	    }
	  });
	  return render.element;
	}
	
	function compileText(item, options) {
	  return (item.text || '').replace(/\\{/g, '__LEFT_BRACKET__').replace(/\\}/g, '__RIGHT_BRACKET__').replace(_constants.CATEGORY, compiledCategory(item, options)).replace(_constants.SERIES, compiledSeries(item, options)).replace(_constants.VALUE, compiledValue(item, options)).replace(_constants.POINT, compiledPoint(item, options)).replace(/__LEFT_BRACKET__/g, '{').replace(/__RIGHT_BRACKET__/g, '}');
	}
	
	function compiledCategory(item, options) {
	  if (item.attach.category.enabled) {
	    return options.longCategories[item.attach.category.index];
	  } else {
	    return options.longCategories[item.attach.point.index];
	  }
	}
	
	function compiledSeries(item, options) {
	  var p = item.attach.point;
	  if (p.enabled && options.series[p.series]) {
	    return options.series[p.series].name || 'n/a';
	  }
	  return '{series}';
	}
	
	function compiledValue(item, options) {
	  var p = item.attach.point;
	  if (p.enabled && options.series[p.series]) {
	    var point = (0, _getPoint2.default)(options.series[p.series], p.index);
	    return point ? point.y : 'n/a';
	  }
	  return '{value}';
	}
	
	function compiledPoint(item, options) {
	  var p = item.attach.point;
	  if (p.enabled && options.series[p.series]) {
	    var point = (0, _getPoint2.default)(options.series[p.series], p.index);
	    if (point && (0, _lodash2.default)(point.y)) {
	      return format.applyFull(point.y, options.tooltips, options.type === 'pie', true, true);
	    }
	    return 'n/a';
	  }
	  return '{point}';
	}
	
	function chartTypeOk(options) {
	  var type = options.type,
	      stacking = options.stacking;
	
	  return type === 'column' && !stacking || type === 'area' || type === 'line';
	}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _textRules = __webpack_require__(15);
	
	var _textRules2 = _interopRequireDefault(_textRules);
	
	var _util = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HED_AND_DEK_MARGIN = 8;
	var WSJ_PRINT_HED_MARGIN = 4;
	var SUBDEK_MARGIN = 14;
	var WSJ_PRINT_SUBDEK_MARGIN = 7;
	var PRINT_LINE = 9.6;
	
	function preRender(data, options) {
	  return data;
	}
	
	function postRender(highchart, options) {
	  var R = getRules(options);
	  var result = {
	    hed: null,
	    dek: null,
	    subdek: null,
	    x: highchart.spacing[3],
	    y: highchart.spacing[0],
	    width: options.width - highchart.spacing[3] - highchart.spacing[1] + 'px'
	  };
	  if (R.HED) {
	    writeHed(options, highchart.renderer, R.HEADINGS.title.text, result);
	  }
	  if (R.HED && R.DEK || R.HED && R.SUBDEK) {
	    result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
	    if (options.product === 'wsj' && !options.print) result.y -= 3;
	  }
	  if (R.DEK) {
	    writeDek(options, highchart.renderer, R.HEADINGS.dek.text, result, R);
	  }
	  if (R.HED && R.DEK && R.SUBDEK || R.DEK && R.SUBDEK) {
	    result.y += R.WSJ_PRINT ? WSJ_PRINT_SUBDEK_MARGIN : SUBDEK_MARGIN;
	    if (options.product === 'wsj' && !options.print) result.y += 9;
	  }
	  if (R.SUBDEK) {
	    writeChartLabel(options, highchart.renderer, R.HEADINGS.subdek.text, result, R);
	  }
	  if (R.WSJ_PRINT) {
	    result.y = Math.max(result.y, PRINT_LINE);
	  }
	  return result;
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    if (!rendered.outerInfo.info) {
	      return false;
	    }
	    var R = getRules(options);
	    var result = rendered.outerInfo.info.headlines;
	    var invalidHed = invalidated.indexOf('headings/title') !== -1;
	    var invalidDek = invalidated.indexOf('headings/dek') !== -1 || R.DEK && invalidHed && !result.hed;
	
	    if ((invalidHed || invalidDek) && !!rendered.outer.spacing) {
	      result.y = rendered.outer.spacing[0];
	
	      // If previously there was no HED but now there is, rewrite the DEK to
	      // force the face to change from bold to normal.
	      var invalidDek2 = R.DEK && invalidHed && !result.hed;
	
	      if (invalidHed) {
	        (0, _util.removeEl)(result.hed);
	        if (R.HED) {
	          writeHed(options, rendered.outer.renderer, R.HEADINGS.title.text, result);
	        } else {
	          result.hed = null;
	        }
	      } else if (result.hed) {
	        result.y = result.hed.bottom;
	      }
	
	      if (R.HED && R.DEK) {
	        result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
	      }
	
	      if (invalidDek) {
	        (0, _util.removeEl)(result.dek);
	        if (R.DEK) {
	          writeDek(options, rendered.outer.renderer, R.HEADINGS.dek.text, result, R.HED);
	        } else {
	          result.dek = null;
	        }
	      } else if (result.dek) {
	        if (result.y !== result.dek.y) {
	          var delta = result.y - result.dek.y;
	          if (result.dek.el) {
	            var nowY = +result.dek.el.element.getAttribute('y');
	            result.dek.el.element.setAttribute('y', nowY + delta);
	          }
	          result.dek.y += delta;
	          result.dek.bottom += delta;
	        }
	        result.y = result.dek.bottom;
	      }
	
	      rendered.outerInfo.y = result.y;
	      if (R.WSJ_PRINT) {
	        rendered.outerInfo.y = Math.max(rendered.outerInfo.y, PRINT_LINE);
	      }
	      return true;
	    }
	    return false;
	  }
	}
	
	function getRules(options) {
	  var RULE = (0, _textRules.getBestRule)(options.size);
	  var HEADINGS = options.headings;
	  var HED = HEADINGS.title.text && HEADINGS.title.enabled && RULE.title;
	  var DEK = HEADINGS.dek.text && HEADINGS.dek.enabled && RULE.dek;
	  var SUBDEK = HEADINGS.subdek.text && HEADINGS.subdek.enabled && RULE.subdek;
	  var WSJ_PRINT = options.size === 'print-wsj';
	  return { RULE: RULE, HEADINGS: HEADINGS, HED: HED, DEK: DEK, SUBDEK: SUBDEK, WSJ_PRINT: WSJ_PRINT };
	}
	
	function writeHed(options, renderer, text, result) {
	  var css = getCss(options, 'hed', result.width);
	  var wsjPrint = false;
	  if (true) {
	    if (wsjPrint = options.size === 'print-wsj') {
	      result.y = PRINT_LINE * 2;
	    }
	  }
	  var financialnewsFirstLetterJ = false;
	  if (false) {
	    if (text.charAt(0) === "J") {
	      financialnewsFirstLetterJ = true;
	    }
	  }
	  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, wsjPrint, 'charts-headline');
	  result.hed = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    offsetY: obj.offsetY,
	    bottom: obj.bottom,
	    el: obj.el
	  };
	  result.y = obj.bottom;
	}
	
	function writeDek(options, renderer, text, result, rules) {
	  var financialnewsFirstLetterJ = false;
	  if (true) {
	    if (!rules.HED && options.size === 'print-wsj') {
	      result.y = PRINT_LINE;
	    }
	  }
	  var css = getCss(options, 'dek', result.width);
	  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek');
	  result.dek = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    offsetY: obj.offsetY,
	    bottom: obj.bottom,
	    el: obj.el
	  };
	  result.y = obj.bottom;
	}
	
	function writeChartLabel(options, renderer, text, result, rules) {
	  var financialnewsFirstLetterJ = false;
	  if (true) {
	    if (!rules.HED && !rules.DEK && options.size === 'print-wsj') {
	      result.y = PRINT_LINE;
	    }
	  }
	  var css = getCss(options, 'subdek', result.width, rules);
	  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek');
	  result.chartLabel = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    offsetY: obj.offsetY,
	    bottom: obj.bottom,
	    el: obj.el
	  };
	  result.y = obj.bottom;
	}
	
	function getCss(options, headline, width, rules) {
	  var size = headline === 'hed' ? 'xlarge' : 'large';
	  var type = headline === 'dek' ? headline : 'hed';
	  var boldSubdek = headline === 'subdek' && (rules.DEK || !rules.HED && !rules.DEK);
	  var subdekSameAsDek = headline === 'subdek' && rules.HED && rules.SUBDEK && !rules.DEK;
	  var weight = boldSubdek ? 'bold' : 'normal';
	  var fontFamily = options.styles.font.normal;
	  var fontWeight = options.styles.weight[weight];
	  var color = options.styles.color[type];
	
	  // HED
	  if (headline === 'hed') {
	    if (options.product === 'financialnews') {
	      fontFamily = '"Publico Text","Publico"';
	      fontWeight = options.styles.weight.bold;
	    } else if (options.product === 'marketwatch') {
	      color = '#666F7D';
	      fontFamily = options.styles.font.bold;
	      fontWeight = options.styles.weight.bold;
	    } else if (options.product === 'mansionglobal') {
	      fontFamily = '"Chronicle SSm Semi-Bold","Chronicle Text G1 A"';
	      fontWeight = options.styles.weight.semibold;
	    } else if (options.product === 'heatstreet') {
	      fontFamily = options.styles.font.semibold;
	      fontWeight = options.styles.weight.semibold;
	    }
	  }
	
	  var css = options.styles.get(size, {
	    fontFamily: fontFamily,
	    fontWeight: fontWeight,
	    color: color,
	    width: width
	  });
	
	  if (true) {
	    if (options.product === 'wsj') {
	      var prop = headline === 'hed' ? 'headline' : 'description';
	      var colorProp = type === 'dek' ? 'description' : 'headline';
	      var printSubdek = options.print && headline === 'subdek';
	      css.fontFamily = printSubdek && boldSubdek ? options.styles.headline.fontFamily : options.styles[prop].fontFamily;
	      css.color = options.styles[colorProp].color;
	      css.fontSize = headline === 'subdek' && !options.print ? '15px' : options.styles[prop].fontSize;
	      if (options.size === 'appfeed') {
	        css.fontSize = headline === 'subdek' ? '18px' : options.styles[prop].fontSize;
	      }
	      css.fontWeight = headline === 'subdek' ? css.fontWeight : options.styles[prop].fontWeight;
	      css.lineHeight = options.styles[prop].lineHeight;
	
	      if (subdekSameAsDek && headline === 'subdek') {
	        css.fontSize = options.styles['description'].fontSize;
	        css.lineHeight = options.styles['description'].lineHeight;
	        css.fontWeight = options.styles['description'].fontWeight;
	        css.color = options.styles['description'].color;
	      }
	    }
	  }
	  return css;
	}
	
	// Renders a generic block of text (either hed, dek or subdek) and returns the element
	// and its bottom y.
	function writeText(financialnewsFirstLetterJ, renderer, text, x, y, css) {
	  var skipOffsetY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	  var className = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
	
	  var offsetY = skipOffsetY ? 0 : parseInt(css.fontSize, 10);
	  if (financialnewsFirstLetterJ) {
	    x = 3;
	  };
	  var el = renderer.text(text).css(css).attr({ x: x, y: y + offsetY, class: className }).add();
	  var tspan = el.element.querySelectorAll('tspan');
	  var lines = tspan && tspan.length ? tspan.length : 1;
	  var lineHeight = parseInt(css.lineHeight, 10);
	  var bottom = y + offsetY + lineHeight * (lines - 1);
	  return { el: el, offsetY: offsetY, bottom: bottom };
	}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _spacing = __webpack_require__(161);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _headlines = __webpack_require__(158);
	
	var headlines = _interopRequireWildcard(_headlines);
	
	var _notes = __webpack_require__(160);
	
	var notes = _interopRequireWildcard(_notes);
	
	var _annotations = __webpack_require__(157);
	
	var annotations = _interopRequireWildcard(_annotations);
	
	var _element = __webpack_require__(3);
	
	var element = _interopRequireWildcard(_element);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
	                                                                                                                                                                                                                   * The Outer Chart renders headlines, footnotes, and credits.
	                                                                                                                                                                                                                   */
	
	
	var MARGIN = 12;
	
	function preRender(options) {
	  var data = {
	    exporting: {
	      enabled: false
	    },
	    chart: _defineProperty({
	      renderTo: options.el.querySelector('.dj-chart-container'),
	      width: options.width,
	      height: options.height,
	      reflow: false,
	      backgroundColor: 'transparent'
	    }, 'backgroundColor', options.styles.color.background),
	    title: { text: null },
	    subtitle: { text: null },
	    credits: { enabled: false }
	  };
	  if (options.size.indexOf('thumb') !== 0) {
	    data.chart.spacing = (0, _spacing2.default)(options);
	    data = headlines.preRender(data, options);
	    data = notes.preRender(data, options);
	    data = annotations.preRender(data, options);
	  }
	  return data;
	}
	
	function postRender(highchart, options) {
	  if (options.size.indexOf('thumb') === 0) {
	    return {
	      innerEl: createInnerEl(highchart, options),
	      x: 0,
	      y: 0,
	      width: options.width,
	      height: options.height,
	      info: null
	    };
	  } else {
	    if (true) {
	      if (options.size === 'print-wsj') {
	        highchart.renderer.rect(0, 3.2, options.width, 0.5, 0).attr({
	          'fill': '#000'
	        }).add();
	        // let y = 0;
	        // while (y < options.height) {
	        //   highchart.renderer.rect(0, y, options.width, 0.5, 0)
	        //     .attr({
	        //       'fill': 'rgba(255, 0, 0, 0.25)',
	        //     })
	        //     .add();
	        //   y += 9.6;
	        // }
	      }
	    }
	    // we only want to call annotations.postRender() for charts that are large enough for annotations
	    var isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
	    var info = {
	      headlines: headlines.postRender(highchart, options),
	      notes: notes.postRender(highchart, options),
	      annotations: isSmallMW ? 'small' : annotations.postRender(highchart, options)
	    };
	    var margin = info.headlines.y > 0 ? MARGIN : 0;
	    if (true) {
	      margin = options.size === 'print-wsj' ? 0 : margin;
	    }
	    return {
	      innerEl: createInnerEl(highchart, options),
	      x: highchart.spacing[3],
	      y: info.headlines.y + margin,
	      width: options.width - highchart.spacing[1] - highchart.spacing[3],
	      height: info.notes.y - info.headlines.y - margin,
	      spacing: [info.annotations.yTop, 0, info.annotations.yBot, 0],
	      info: info
	    };
	  }
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    var updateH = headlines.renderInvalidated(rendered, options, invalidated);
	    var updateN = notes.renderInvalidated(rendered, options, invalidated);
	    var margin = rendered.outerInfo.info && rendered.outerInfo.info.headlines.y > 0 ? MARGIN : 0;
	    if (__WSJ__) {
	      margin = options.size === 'print-wsj' ? 0 : margin;
	    }
	    if (updateH) {
	      rendered.outerInfo.y += margin;
	    }
	    if (updateH || updateN) {
	      rendered.outerInfo.height = 0;
	      if (rendered.outerInfo.info) {
	        rendered.outerInfo.height = rendered.outerInfo.info.notes.y - rendered.outerInfo.info.headlines.y - margin;
	      }
	    }
	  }
	}
	
	function getTopHeight(highchart, options) {
	  var svg = options.el.querySelector('svg');
	  var svgY = svg.getBoundingClientRect().top;
	  if (highchart.subtitle) {
	    var srect = highchart.subtitle.element.getBoundingClientRect();
	    return srect.top - svgY + srect.height;
	  } else if (highchart.title) {
	    var trect = highchart.title.element.getBoundingClientRect();
	    return trect.top - svgY + trect.height;
	  }
	  return highchart.spacing[0];
	}
	
	function getBottomHeight(highchart, options) {
	  return highchart.spacing[2];
	}
	
	// Cleans up the outer SVG, removing unnecessary `g` elements, and creates a
	// `g` element specifically for the inner chart SVG.
	function createInnerEl(highchart, options) {
	  var svg = options.el.querySelector('svg');
	  if (svg) {
	    var gEls = svg.querySelectorAll('g');
	    for (var i = 0; i < gEls.length; i++) {
	      element.removeChild(gEls[i]);
	    }
	    return highchart.renderer.g('djchart').add().element;
	  }
	  return null;
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preRender = preRender;
	exports.postRender = postRender;
	exports.renderInvalidated = renderInvalidated;
	
	var _textRules = __webpack_require__(15);
	
	var _textRules2 = _interopRequireDefault(_textRules);
	
	var _util = __webpack_require__(16);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function preRender(data, options) {
	  return data;
	}
	
	function postRender(highchart, options) {
	  var R = getRules(options);
	  var renderer = highchart.renderer;
	  var result = {
	    tagline: null,
	    source: null,
	    note: null,
	    x: highchart.spacing[3],
	    y: getStartY(highchart, options),
	    width: options.width - highchart.spacing[3] - highchart.spacing[1] + 'px'
	  };
	  if (R.tagline) {
	    var wsjPrintTagline = isWsjPrintTagline(options.size, 'tagline');
	    var taglineAlign = getTaglineAlign(options);
	    if (wsjPrintTagline) {
	      result.y = options.height;
	    }
	    result = writeSection(R.headings, options, 'tagline', renderer, R.headings.tagline.text, result, taglineAlign);
	    if (wsjPrintTagline) {
	      result.y = options.height - 9.2;
	    }
	  }
	  if (R.source) {
	    result = writeSection(R.headings, options, 'source', renderer, R.headings.source.text, result, getSourceAlign(options));
	  }
	  if (R.note) {
	    result = writeSection(R.headings, options, 'note', renderer, R.headings.note.text, result);
	  }
	
	  return result;
	}
	
	function renderInvalidated(rendered, options, invalidated) {
	  if (false) {
	    var invalidTagline = invalidated.indexOf('headings/tagline') !== -1;
	    var invalidSource = invalidated.indexOf('headings/source') !== -1;
	    var invalidNote = invalidated.indexOf('headings/note') !== -1;
	
	    if (invalidTagline || invalidSource || invalidNote) {
	      var R = getRules(options);
	      var renderer = rendered.outer.renderer;
	      var info = rendered.outerInfo.info;
	      if (!info) return true;
	      info = info.notes;
	      info.y = getStartY(rendered.outer, options);
	
	      var taglineAlign = getTaglineAlign(options);
	      if (invalidTagline) {
	        (0, _util.removeEl)(info.tagline);
	        if (R.tagline) {
	          info = writeSection(R.headings, options, 'tagline', renderer, R.headings.tagline.text, info, taglineAlign);
	        } else {
	          info.tagline = null;
	        }
	      } else if (info.tagline) {
	        info.y = info.tagline.top;
	      }
	
	      if (invalidSource) {
	        (0, _util.removeEl)(info.source);
	        if (R.source) {
	          info = writeSection(R.headings, options, 'source', renderer, R.headings.source.text, info);
	        } else {
	          info.source = null;
	        }
	      } else if (info.source) {
	        if (info.y !== info.source.y) {
	          var delta = info.y - info.source.y;
	          if (info.source.el) {
	            var nowY = +info.source.el.element.getAttribute('y');
	            info.source.el.element.setAttribute('y', nowY + delta);
	          }
	          info.source.y += delta;
	          info.source.top += delta;
	        }
	        info.y = info.source.top;
	      }
	
	      if (invalidNote) {
	        (0, _util.removeEl)(info.note);
	        if (R.note) {
	          info = writeSection(R.headings, options, 'note', renderer, R.headings.note.text, info);
	        } else {
	          info.note = null;
	        }
	      } else if (info.note) {
	        if (info.y !== info.note.y) {
	          var _delta = info.y - info.note.y;
	          if (info.note.el) {
	            var _nowY = +info.note.el.element.getAttribute('y');
	            info.note.el.element.setAttribute('y', _nowY + _delta);
	          }
	          info.note.y += _delta;
	          info.note.top += _delta;
	        }
	        info.y = info.note.top;
	      }
	      return true;
	    }
	    return false;
	  }
	}
	
	function getRules(options) {
	  var rule = (0, _textRules.getBestRule)(options.size);
	  var headings = options.headings;
	  var tagline = headings.tagline.text && headings.tagline.enabled && rule.tagline;
	  var source = headings.source.text && headings.source.enabled && rule.source;
	  var note = headings.note.text && headings.note.enabled && rule.note;
	  return { rule: rule, headings: headings, tagline: tagline, source: source, note: note };
	}
	
	function writeSection(headings, options, section, renderer, text, result) {
	  var align = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'left';
	
	  result[section] = {
	    x: result.x,
	    y: result.y,
	    width: result.width,
	    top: result.y,
	    el: null
	  };
	  var obj = writeText(options, renderer, text, result, align, section);
	  result[section].el = obj.el;
	  result[section].top = obj.top;
	  result.y = obj.top;
	  if ((section === 'source' || section === 'note') && options.product === 'wsj' && !options.print) {
	    if (result.note && !headings.source.text) result.y -= 3;
	    if (!headings.note.text && result.source) result.y -= 3;
	    if (headings.note.text && headings.source.text && section === 'source') {
	      result.y -= 1;
	    }
	  }
	  return result;
	}
	
	// Renders a generic block of text (tagline or source) and returns the element
	// and its top y.
	function writeText(options, renderer, text, result) {
	  var align = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'left';
	  var section = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	
	  var offsetTagline = options.print ? 1 : 0;
	  var css = options.styles.get('small', {
	    width: result.width
	  });
	  if (options.product === 'wsj' && !options.print) {
	    css.fontSize = '13px';
	    css.lineHeight = 17;
	  }
	  if (true) {
	    if (isWsjPrintTagline(options.size, section)) {
	      css.fontFamily = "'DJ5EscrowCond Semibold'";
	      css.fontSize = 6.6;
	    } else if (options.size === 'print-wsj') {
	      css.fontFamily = "'DJ5RetinaAgReg Medium'";
	    }
	  }
	  var el = renderer.text(text).css(css).attr({
	    x: align === 'left' ? result.x : parseFloat(result.width),
	    y: result.y - offsetTagline,
	    align: align
	  }).add();
	  var lines = el.element.querySelectorAll('tspan').length;
	  var lineHeight = parseFloat(css.lineHeight);
	  var height = lines * lineHeight;
	  var yPx = result.y;
	  if (lines > 1) {
	    yPx = +el.element.getAttribute('y');
	    yPx -= (lines - 1) * lineHeight;
	    el.element.setAttribute('y', yPx);
	  }
	  return {
	    el: el,
	    y: yPx,
	    top: yPx - lineHeight
	  };
	}
	
	function getSourceAlign(options) {
	  return options.product === 'marketwatch' ? 'right' : 'left';
	}
	
	function getTaglineAlign(options) {
	  if (true) {
	    if (options.size === 'print-wsj') {
	      return options.sizes['print-wsj'].columns >= 2 ? 'right' : 'left';
	    } else {
	      return options.width > _constants.MAX_4U_WIDTH ? 'right' : 'left';
	    }
	  }
	  if (false) {
	    return options.width > _constants.MAX_4U_WIDTH ? 'right' : 'left';
	  }
	}
	
	function getStartY(highchart, options) {
	  return options.height - highchart.spacing[2] - yOffset(options);
	}
	
	// Lifts text just enough so that bottom line shows tails.
	function yOffset(options) {
	  return Math.round((parseFloat(options.styles.lineHeight.small) - parseFloat(options.styles.size.small)) * 0.5);
	}
	
	function isWsjPrintTagline(size, section) {
	  if (true) {
	    return size === 'print-wsj' && section === 'tagline';
	  }
	  return false;
	}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function spacing(options) {
	  switch (options.size) {
	    case 'fon':
	      return [30, 15, 0, 15];
	    case 'soc':
	      return [10, 10, 10, 10];
	    case 'appfeed':
	      return [3, 0, 3, 0];
	  }
	  return [0, 0, 0, 0];
	}
	
	exports.default = spacing;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyles = processStyles;
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(10);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Whitney SSm will be displayed in the SVG, but in the image export, the
	// fonts prepended below ('Whitney SSm Regular') will be used.
	var BASE_STYLE = {
	  color: {
	    background: '#fff',
	    normal: '#333',
	    light: '#666',
	    hed: '#333',
	    dek: '#666'
	  },
	  font: {
	    light: 'sans-serif',
	    normal: 'sans-serif',
	    semibold: 'sans-serif',
	    bold: 'sans-serif'
	  },
	  weight: {
	    light: 300,
	    normal: 400,
	    semibold: 600,
	    bold: 700
	  },
	  size: {
	    small: '11px',
	    normal: '13px',
	    large: '16px',
	    xlarge: '16px'
	  },
	  lineHeight: {
	    small: '16px',
	    normal: '16px',
	    large: '20px',
	    xlarge: '20px'
	  },
	  annotations: {},
	  headline: {},
	  description: {},
	  notes: {},
	  source: {},
	  tick: {},
	  axes: {
	    zeroGridLine: {},
	    label: {
	      seriesAreNotDates: {},
	      bar: {
	        x: {},
	        y: {}
	      }
	    }
	  },
	  legend: {}
	};
	
	function processStyles(options) {
	  var STYLE = (0, _lodash2.default)({}, BASE_STYLE);
	  var product = options.product,
	      print = options.print;
	
	  if (true) {
	    if (product === 'wsj') {
	      if (print) {
	        STYLE.annotations.fontSize = 7.5;
	        STYLE.annotations.lineHeight = 10;
	        STYLE.axes.label.bar.x.fontSize = 7.5;
	        STYLE.axes.label.bar.x.fontWeight = 'normal';
	        STYLE.axes.label.bar.x.lineHeight = 7.5;
	        STYLE.axes.label.bar.y.fontSize = 7.5;
	        STYLE.axes.label.bar.y.fontWeight = 'normal';
	        STYLE.axes.label.bar.y.lineHeight = 7.5;
	        STYLE.axes.label.color = '#666';
	        STYLE.axes.label.fontSize = 7.5;
	        STYLE.axes.label.fontWeight = 400;
	        STYLE.axes.label.lineHeight = 7.5;
	        STYLE.axes.label.seriesAreNotDates.fontSize = 7;
	        STYLE.axes.label.seriesAreNotDates.fontWeight = 'normal';
	        STYLE.axes.label.seriesAreNotDates.lineHeight = 8;
	        STYLE.axes.zeroGridLine.color = '#333';
	        STYLE.color.dek = '#000';
	        STYLE.color.hed = '#000';
	        STYLE.color.normal = '#000';
	        STYLE.description.color = '#000';
	        STYLE.description.fontFamily = '"DJ5RetinaNr Medium",sans-serif';
	        STYLE.description.fontSize = 8.4;
	        STYLE.description.fontWeight = 400;
	        STYLE.description.lineHeight = 10;
	        STYLE.font.bold = '"DJ5RetinaNr Bold",' + STYLE.font.bold;
	        STYLE.font.light = '"DJ5RetinaNr Light",' + STYLE.font.light;
	        STYLE.font.normal = '"DJ5RetinaNr Medium",' + STYLE.font.normal;
	        STYLE.font.semibold = '"DJ5RetinaNr Semibold",' + STYLE.font.bold;
	        STYLE.headline.color = '#000';
	        STYLE.headline.fontFamily = '"DJ5RetinaNr Bold",sans-serif';
	        STYLE.headline.fontSize = 12.6;
	        STYLE.headline.fontWeight = 'normal';
	        STYLE.headline.lineHeight = 14.4;
	        STYLE.legend.fontSize = 7.5;
	        STYLE.legend.fontWeight = 400;
	        STYLE.legend.lineHeight = 'inherit';
	        STYLE.legend.rectHeight = 6;
	        STYLE.legend.rectWidth = 4;
	        STYLE.lineHeight.large = 9.6;
	        STYLE.lineHeight.normal = 8;
	        STYLE.lineHeight.small = 7.2;
	        STYLE.lineHeight.xlarge = 14.4;
	        STYLE.size.large = 8.4;
	        STYLE.size.normal = 7.5;
	        STYLE.size.small = 6;
	        STYLE.size.xlarge = 12.6;
	        STYLE.tick.color = '#333';
	        STYLE.tick.longSize = 5;
	        STYLE.tick.mediumSize = 4;
	        STYLE.tick.shortSize = 2;
	        STYLE.tick.yOffset = 1;
	        STYLE.weight.bold = 'normal';
	        STYLE.weight.light = 'normal';
	        STYLE.weight.normal = 'normal';
	        STYLE.weight.semibold = 'normal';
	      } else {
	        STYLE.annotations.fontSize = '15px';
	        STYLE.annotations.lineHeight = 20;
	        // STYLE.axes.label.fontFamily = '"Retina", "Retina Narrow"'
	        STYLE.axes.label.bar.x.fontSize = '15px';
	        STYLE.axes.label.bar.x.fontWeight = 500;
	        STYLE.axes.label.bar.x.lineHeight = 20;
	        STYLE.axes.label.bar.y.fontSize = '13px';
	        STYLE.axes.label.bar.y.fontWeight = 300;
	        STYLE.axes.label.bar.y.lineHeight = 20;
	        STYLE.axes.label.color = '#333';
	        // weirdly breaks if I set below to '13px' in firefox
	        STYLE.axes.label.fontSize = 13;
	        STYLE.axes.label.fontWeight = 300;
	        STYLE.axes.label.lineHeight = 20;
	        STYLE.axes.label.seriesAreNotDates.fontSize = '15px';
	        STYLE.axes.label.seriesAreNotDates.fontWeight = 500;
	        STYLE.axes.label.seriesAreNotDates.lineHeight = 18;
	        STYLE.axes.label.seriesAreNotDates.fontFamily = '"Retina", sans-serif';
	        STYLE.axes.zeroGridLine.color = '#333';
	        STYLE.description.color = '#333';
	        STYLE.description.fontFamily = '"Retina", sans-serif';
	        STYLE.description.fontSize = '15px';
	        STYLE.description.fontWeight = 300;
	        STYLE.description.lineHeight = 20;
	        STYLE.font.bold = '"Retina",' + STYLE.font.bold;
	        STYLE.font.light = '"Retina",' + STYLE.font.light;
	        STYLE.font.normal = '"Retina",' + STYLE.font.normal;
	        STYLE.font.semibold = '"Retina",' + STYLE.font.bold;
	        STYLE.weight.bold = 500;
	        STYLE.weight.light = 300;
	        STYLE.weight.normal = 300;
	        STYLE.weight.semibold = 500;
	        STYLE.headline.color = '#333';
	        STYLE.headline.fontFamily = "Retina";
	        STYLE.headline.fontSize = '18px';
	        STYLE.headline.fontWeight = 500;
	        STYLE.headline.lineHeight = '20px';
	        STYLE.legend.fontSize = '15px';
	        STYLE.legend.fontWeight = 300;
	        STYLE.legend.lineHeight = 18;
	        STYLE.legend.rectHeight = 12;
	        STYLE.legend.rectWidth = 8;
	        STYLE.notes.lineHeight = 14;
	        STYLE.source.lineHeight = 14;
	        STYLE.source.fontWeight = 300;
	        STYLE.tick.color = '#333';
	        STYLE.tick.longSize = 7;
	        STYLE.tick.mediumSize = 5;
	        STYLE.tick.shortSize = 3;
	        STYLE.tick.yOffset = 1.5;
	        STYLE.weight.bold = 500;
	        STYLE.weight.semibold = 500;
	      }
	    }
	  }
	  if (false) {
	    if (product === 'barrons') {
	      STYLE.color.background = 'transparent';
	      STYLE.color.normal = '#8E99A2';
	      STYLE.color.light = '#8E99A2';
	      STYLE.color.hed = '#122225';
	      STYLE.color.dek = '#8E99A2';
	      STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
	      STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
	      STYLE.font.semibold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.size.small = '12px';
	      STYLE.size.normal = '12px';
	      STYLE.size.large = '18px';
	      STYLE.size.xlarge = '24px';
	      STYLE.lineHeight.xlarge = '25px';
	    }
	  }
	  if (false) {
	    if (product === 'financialnews') {
	      STYLE.color.background = 'transparent';
	      STYLE.color.normal = '#70808C';
	      STYLE.color.light = '#70808C';
	      STYLE.color.hed = '#005879';
	      STYLE.color.dek = '#4D6172';
	      STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
	      STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
	      STYLE.font.semibold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
	      STYLE.size.small = '12px';
	      STYLE.size.normal = '12px';
	      STYLE.size.large = '16px';
	      STYLE.size.xlarge = '24px';
	      STYLE.lineHeight.small = '17px';
	      STYLE.lineHeight.normal = '17px';
	      STYLE.lineHeight.large = '22px';
	      STYLE.lineHeight.xlarge = '28px';
	    }
	  }
	  if (false) {
	    if (product === 'marketwatch') {
	      STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
	      STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
	      STYLE.font.semibold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.semibold;
	      STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
	      STYLE.font.axes = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + 'sans-serif';
	      STYLE.weight.light = 300;
	      STYLE.weight.normal = 400;
	      STYLE.weight.semibold = 600;
	      STYLE.weight.bold = 600;
	      STYLE.weight.axes = 600;
	      STYLE.color.normal = '#555';
	      STYLE.color.dek = '#555';
	      STYLE.color.light = '#555';
	      STYLE.color.axes = '#555';
	      STYLE.size.small = '13px';
	      STYLE.size.axes = '13px';
	      STYLE.size.normal = '13px';
	      STYLE.size.large = '16px';
	      STYLE.size.xlarge = '28px';
	      STYLE.lineHeight.small = '19px';
	      STYLE.lineHeight.normal = '19px';
	      STYLE.lineHeight.large = '25px';
	      STYLE.lineHeight.xlarge = '34px';
	    }
	  }
	  if (false) {
	    if (product === 'mansionglobal') {
	      STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
	      STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
	      STYLE.font.semibold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.semibold;
	      STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
	      STYLE.weight.light = 400;
	      STYLE.weight.normal = 400;
	      STYLE.weight.semibold = 600;
	      STYLE.weight.bold = 700;
	      STYLE.size.small = '14px';
	      STYLE.size.normal = '14px';
	      STYLE.size.large = '18px';
	      STYLE.size.xlarge = '24px';
	      STYLE.lineHeight.xlarge = '28px';
	    }
	  }
	  if (false) {
	    if (product === 'heatstreet') {
	      STYLE.font.light = '"Ideal Sans","Ideal Sans A",' + STYLE.font.light;
	      STYLE.font.normal = '"Ideal Sans","Ideal Sans A",' + STYLE.font.normal;
	      STYLE.font.semibold = '"Ideal Sans Semi-Bold","Ideal Sans A",' + STYLE.font.semibold;
	      STYLE.font.bold = '"Ideal Sans","Ideal Sans A",' + STYLE.font.bold;
	      STYLE.weight.light = 300;
	      STYLE.weight.normal = 300;
	      STYLE.weight.semibold = 600;
	      STYLE.weight.bold = 700;
	      STYLE.size.small = '14px';
	      STYLE.size.normal = '14px';
	      STYLE.size.large = '14px';
	      STYLE.size.xlarge = '22px';
	    }
	  }
	  STYLE.base = {
	    fontFamily: STYLE.font.normal,
	    fontSize: STYLE.size.normal,
	    fontWeight: STYLE.weight.normal,
	    lineHeight: STYLE.lineHeight.normal,
	    color: STYLE.color.normal
	  };
	  STYLE.get = function (size, options) {
	    var sizeStyle = STYLE[size];
	    return sizeStyle ? (0, _lodash4.default)({}, sizeStyle, options) : STYLE.base;
	  };
	  STYLE.small = STYLE.get('base', {
	    fontSize: STYLE.size.small,
	    lineHeight: STYLE.lineHeight.small
	  });
	  STYLE.normal = STYLE.get('base');
	  STYLE.large = STYLE.get('base', {
	    fontSize: STYLE.size.large,
	    lineHeight: STYLE.lineHeight.large
	  });
	  STYLE.xlarge = STYLE.get('base', {
	    fontSize: STYLE.size.xlarge,
	    lineHeight: STYLE.lineHeight.xlarge
	  });
	  return STYLE;
	}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.fonts = fonts;
	
	var _webfontloader = __webpack_require__(169);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URL_WHITNEY = 'https://asset.wsj.net/fonts.wsj.net/fonts/pkg/whitney-ssm.css';
	
	/**
	 * Preload fonts depending on product. If fonts are *not* preloaded, then
	 * line breaks fail (because line breaks are determined with a fallback font).
	 */
	function fonts(options, complete) {
	  var product = options.product,
	      print = options.print;
	
	  var info = fontsInfo(product, print);
	  var interval = 0;
	  if (info === true) {
	    complete();
	  } else {
	    var status = window.__charts_fonts_status__ = _typeof(window.__charts_fonts_status__) === 'object' ? window.__charts_fonts_status__ : {};
	
	    var callbackComplete = function callbackComplete() {
	      status[info.product] = 'complete';
	      complete();
	    };
	
	    var checkComplete = function checkComplete() {
	      if (status[info.product] === 'complete') {
	        clearInterval(interval);
	        complete();
	      }
	    };
	
	    var checkQueued = function checkQueued() {
	      if (!areFontsLoading()) {
	        clearInterval(interval);
	        if (status[info.product] === 'complete') {
	          complete();
	        } else {
	          status[info.product] = 'loading';
	          _webfontloader2.default.load({
	            custom: info,
	            active: callbackComplete,
	            inactive: callbackComplete
	          });
	        }
	      }
	    };
	
	    if (status[info.product] === 'loading') {
	      interval = setInterval(checkComplete, 1);
	    } else if (status[info.product] === 'complete') {
	      complete();
	    } else {
	      interval = setInterval(checkQueued, 1);
	    }
	  }
	}
	
	function areFontsLoading() {
	  var status = window.__charts_fonts_status__;
	  if (status) {
	    var keys = Object.keys(status);
	    for (var i = 0; i < keys.length; i++) {
	      if (status[keys[i]] === 'loading') {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function fontsInfo(product) {
	  var print = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (true) {
	    if (product === 'wsj') {
	      if (print) {
	        return {
	          product: 'wsj-print',
	          families: [
	          // 'Retina Standard Narrow:n3,n4,n6',
	          // 'DJ5EscrowCond:n6'
	          'DJ5RetinaNr Light', 'DJ5RetinaNr Medium', 'DJ5RetinaNr Semibold', 'DJ5RetinaNr Bold', 'DJ5RetinaAgReg Medium', 'DJ5EscrowCond'],
	          urls: ['/assets/css/wsj-print.css']
	        };
	      } else {
	        return {
	          product: product,
	          families: ['Retina', 'Retina Narrow'],
	          urls: ['https://www.wsj.com/fonts/retina.css']
	        };
	      }
	    }
	  }
	  if (false) {
	    if (product === 'barrons') {
	      return {
	        product: product,
	        families: ['Theinhardt:n4,n6'],
	        urls: ['https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
	      };
	    }
	  }
	  if (false) {
	    if (product === 'financialnews') {
	      return {
	        product: product,
	        families: ['Publico:n6', 'Theinhardt:n3,n4,n6'],
	        urls: ['https://fonts.wsj.net/PublicoMedium.css', 'https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
	      };
	    }
	  }
	  if (false) {
	    if (product === 'marketwatch') {
	      return {
	        product: product,
	        families: ['Whitney SSm:n4,n5,n6'],
	        urls: [URL_WHITNEY]
	      };
	    }
	  }
	  if (false) {
	    if (product === 'mansionglobal') {
	      return {
	        product: product,
	        families: ['Chronicle Text G1 A:n6', 'Whitney SSm A:n4,n6,n7'],
	        urls: ['https://www.mansionglobal.com/fonts/442807/457709E0582EC35B6.css']
	      };
	    }
	  }
	  if (false) {
	    if (product === 'heatstreet') {
	      return {
	        product: product,
	        families: ['Ideal Sans B:n3,n6,n7', 'Ideal Sans B:n3,n6,n7'],
	        urls: ['https://heatst.com/wp-content/themes/heatstreet/static/fonts/447427/CACC8AE198F1E0D08.css']
	      };
	    }
	  }
	  return true;
	}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	/**
	 * @license Highcharts JS v5.0.14 (2017-07-28)
	 *
	 * (c) 2009-2016 Torstein Honsi
	 *
	 * License: www.highcharts.com/license
	 */
	'use strict';
	(function(root, factory) {
	    if (typeof module === 'object' && module.exports) {
	        module.exports = root.document ?
	            factory(root) :
	            factory;
	    } else {
	        root.Highcharts = factory(root);
	    }
	}(typeof window !== 'undefined' ? window : this, function(win) {
	    var Highcharts = (function() {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* global window */
	        var win = window,
	            doc = win.document;
	
	        var SVG_NS = 'http://www.w3.org/2000/svg',
	            userAgent = (win.navigator && win.navigator.userAgent) || '',
	            svg = doc && doc.createElementNS && !!doc.createElementNS(SVG_NS, 'svg').createSVGRect,
	            isMS = /(edge|msie|trident)/i.test(userAgent) && !window.opera,
	            vml = !svg,
	            isFirefox = /Firefox/.test(userAgent),
	            hasBidiBug = isFirefox && parseInt(userAgent.split('Firefox/')[1], 10) < 4; // issue #38
	
	        var Highcharts = win.Highcharts ? win.Highcharts.error(16, true) : {
	            product: 'Highcharts',
	            version: '5.0.14',
	            deg2rad: Math.PI * 2 / 360,
	            doc: doc,
	            hasBidiBug: hasBidiBug,
	            hasTouch: doc && doc.documentElement.ontouchstart !== undefined,
	            isMS: isMS,
	            isWebKit: /AppleWebKit/.test(userAgent),
	            isFirefox: isFirefox,
	            isTouchDevice: /(Mobile|Android|Windows Phone)/.test(userAgent),
	            SVG_NS: SVG_NS,
	            chartCount: 0,
	            seriesTypes: {},
	            symbolSizes: {},
	            svg: svg,
	            vml: vml,
	            win: win,
	            marginNames: ['plotTop', 'marginRight', 'marginBottom', 'plotLeft'],
	            noop: function() {
	                return undefined;
	            },
	            /**
	             * An array containing the current chart objects in the page. A chart's
	             * position in the array is preserved throughout the page's lifetime. When
	             * a chart is destroyed, the array item becomes `undefined`.
	             * @type {Array.<Highcharts.Chart>}
	             * @memberOf Highcharts
	             */
	            charts: []
	        };
	        return Highcharts;
	    }());
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* eslint max-len: ["warn", 80, 4] */
	
	        /**
	         * The Highcharts object is the placeholder for all other members, and various
	         * utility functions. The most important member of the namespace would be the
	         * chart constructor.
	         *
	         * @example
	         * var chart = Highcharts.chart('container', { ... });
	         * 
	         * @namespace Highcharts
	         */
	
	        var timers = [];
	
	        var charts = H.charts,
	            doc = H.doc,
	            win = H.win;
	
	        /**
	         * Provide error messages for debugging, with links to online explanation. This
	         * function can be overridden to provide custom error handling.
	         *
	         * @function #error
	         * @memberOf Highcharts
	         * @param {Number|String} code - The error code. See [errors.xml]{@link 
	         *     https://github.com/highcharts/highcharts/blob/master/errors/errors.xml}
	         *     for available codes. If it is a string, the error message is printed
	         *     directly in the console.
	         * @param {Boolean} [stop=false] - Whether to throw an error or just log a 
	         *     warning in the console.
	         *
	         * @sample highcharts/chart/highcharts-error/ Custom error handler
	         */
	        H.error = function(code, stop) {
	            var msg = H.isNumber(code) ?
	                'Highcharts error #' + code + ': www.highcharts.com/errors/' + code :
	                code;
	            if (stop) {
	                throw new Error(msg);
	            }
	            // else ...
	            if (win.console) {
	                console.log(msg); // eslint-disable-line no-console
	            }
	        };
	
	        /**
	         * An animator object used internally. One instance applies to one property
	         * (attribute or style prop) on one element. Animation is always initiated
	         * through {@link SVGElement#animate}.
	         *
	         * @constructor Fx
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement|SVGElement} elem - The element to animate.
	         * @param {AnimationOptions} options - Animation options.
	         * @param {string} prop - The single attribute or CSS property to animate.
	         * @private
	         *
	         * @example
	         * var rect = renderer.rect(0, 0, 10, 10).add();
	         * rect.animate({ width: 100 });
	         */
	        H.Fx = function(elem, options, prop) {
	            this.options = options;
	            this.elem = elem;
	            this.prop = prop;
	        };
	        H.Fx.prototype = {
	
	            /**
	             * Set the current step of a path definition on SVGElement.
	             *
	             * @function #dSetter
	             * @memberOf Highcharts.Fx
	             */
	            dSetter: function() {
	                var start = this.paths[0],
	                    end = this.paths[1],
	                    ret = [],
	                    now = this.now,
	                    i = start.length,
	                    startVal;
	
	                // Land on the final path without adjustment points appended in the ends
	                if (now === 1) {
	                    ret = this.toD;
	
	                } else if (i === end.length && now < 1) {
	                    while (i--) {
	                        startVal = parseFloat(start[i]);
	                        ret[i] =
	                            isNaN(startVal) ? // a letter instruction like M or L
	                            start[i] :
	                            now * (parseFloat(end[i] - startVal)) + startVal;
	
	                    }
	                    // If animation is finished or length not matching, land on right value
	                } else {
	                    ret = end;
	                }
	                this.elem.attr('d', ret, null, true);
	            },
	
	            /**
	             * Update the element with the current animation step.
	             *
	             * @function #update
	             * @memberOf Highcharts.Fx
	             */
	            update: function() {
	                var elem = this.elem,
	                    prop = this.prop, // if destroyed, it is null
	                    now = this.now,
	                    step = this.options.step;
	
	                // Animation setter defined from outside
	                if (this[prop + 'Setter']) {
	                    this[prop + 'Setter']();
	
	                    // Other animations on SVGElement
	                } else if (elem.attr) {
	                    if (elem.element) {
	                        elem.attr(prop, now, null, true);
	                    }
	
	                    // HTML styles, raw HTML content like container size
	                } else {
	                    elem.style[prop] = now + this.unit;
	                }
	
	                if (step) {
	                    step.call(elem, now, this);
	                }
	
	            },
	
	            /**
	             * Run an animation.
	             *
	             * @function #run
	             * @memberOf Highcharts.Fx
	             * @param {Number} from - The current value, value to start from.
	             * @param {Number} to - The end value, value to land on.
	             * @param {String} [unit] - The property unit, for example `px`.
	             * 
	             */
	            run: function(from, to, unit) {
	                var self = this,
	                    timer = function(gotoEnd) {
	                        return timer.stopped ? false : self.step(gotoEnd);
	                    },
	                    i;
	
	                this.startTime = +new Date();
	                this.start = from;
	                this.end = to;
	                this.unit = unit;
	                this.now = this.start;
	                this.pos = 0;
	
	                timer.elem = this.elem;
	                timer.prop = this.prop;
	
	                if (timer() && timers.push(timer) === 1) {
	                    timer.timerId = setInterval(function() {
	
	                        for (i = 0; i < timers.length; i++) {
	                            if (!timers[i]()) {
	                                timers.splice(i--, 1);
	                            }
	                        }
	
	                        if (!timers.length) {
	                            clearInterval(timer.timerId);
	                        }
	                    }, 13);
	                }
	            },
	
	            /**
	             * Run a single step in the animation.
	             *
	             * @function #step
	             * @memberOf Highcharts.Fx
	             * @param   {Boolean} [gotoEnd] - Whether to go to the endpoint of the
	             *     animation after abort.
	             * @returns {Boolean} Returns `true` if animation continues.
	             */
	            step: function(gotoEnd) {
	                var t = +new Date(),
	                    ret,
	                    done,
	                    options = this.options,
	                    elem = this.elem,
	                    complete = options.complete,
	                    duration = options.duration,
	                    curAnim = options.curAnim;
	
	                if (elem.attr && !elem.element) { // #2616, element is destroyed
	                    ret = false;
	
	                } else if (gotoEnd || t >= duration + this.startTime) {
	                    this.now = this.end;
	                    this.pos = 1;
	                    this.update();
	
	                    curAnim[this.prop] = true;
	
	                    done = true;
	
	                    H.objectEach(curAnim, function(val) {
	                        if (val !== true) {
	                            done = false;
	                        }
	                    });
	
	                    if (done && complete) {
	                        complete.call(elem);
	                    }
	                    ret = false;
	
	                } else {
	                    this.pos = options.easing((t - this.startTime) / duration);
	                    this.now = this.start + ((this.end - this.start) * this.pos);
	                    this.update();
	                    ret = true;
	                }
	                return ret;
	            },
	
	            /**
	             * Prepare start and end values so that the path can be animated one to one.
	             *
	             * @function #initPath
	             * @memberOf Highcharts.Fx
	             * @param {SVGElement} elem - The SVGElement item.
	             * @param {String} fromD - Starting path definition.
	             * @param {Array} toD - Ending path definition.
	             * @returns {Array} An array containing start and end paths in array form
	             * so that they can be animated in parallel.
	             */
	            initPath: function(elem, fromD, toD) {
	                fromD = fromD || '';
	                var shift,
	                    startX = elem.startX,
	                    endX = elem.endX,
	                    bezier = fromD.indexOf('C') > -1,
	                    numParams = bezier ? 7 : 3,
	                    fullLength,
	                    slice,
	                    i,
	                    start = fromD.split(' '),
	                    end = toD.slice(), // copy
	                    isArea = elem.isArea,
	                    positionFactor = isArea ? 2 : 1,
	                    reverse;
	
	                /**
	                 * In splines make moveTo and lineTo points have six parameters like
	                 * bezier curves, to allow animation one-to-one.
	                 */
	                function sixify(arr) {
	                    var isOperator,
	                        nextIsOperator;
	                    i = arr.length;
	                    while (i--) {
	
	                        // Fill in dummy coordinates only if the next operator comes
	                        // three places behind (#5788)
	                        isOperator = arr[i] === 'M' || arr[i] === 'L';
	                        nextIsOperator = /[a-zA-Z]/.test(arr[i + 3]);
	                        if (isOperator && nextIsOperator) {
	                            arr.splice(
	                                i + 1, 0,
	                                arr[i + 1], arr[i + 2],
	                                arr[i + 1], arr[i + 2]
	                            );
	                        }
	                    }
	                }
	
	                /**
	                 * Insert an array at the given position of another array
	                 */
	                function insertSlice(arr, subArr, index) {
	                    [].splice.apply(
	                        arr, [index, 0].concat(subArr)
	                    );
	                }
	
	                /**
	                 * If shifting points, prepend a dummy point to the end path. 
	                 */
	                function prepend(arr, other) {
	                    while (arr.length < fullLength) {
	
	                        // Move to, line to or curve to?
	                        arr[0] = other[fullLength - arr.length];
	
	                        // Prepend a copy of the first point
	                        insertSlice(arr, arr.slice(0, numParams), 0);
	
	                        // For areas, the bottom path goes back again to the left, so we
	                        // need to append a copy of the last point.
	                        if (isArea) {
	                            insertSlice(
	                                arr,
	                                arr.slice(arr.length - numParams), arr.length
	                            );
	                            i--;
	                        }
	                    }
	                    arr[0] = 'M';
	                }
	
	                /**
	                 * Copy and append last point until the length matches the end length
	                 */
	                function append(arr, other) {
	                    var i = (fullLength - arr.length) / numParams;
	                    while (i > 0 && i--) {
	
	                        // Pull out the slice that is going to be appended or inserted.
	                        // In a line graph, the positionFactor is 1, and the last point
	                        // is sliced out. In an area graph, the positionFactor is 2,
	                        // causing the middle two points to be sliced out, since an area
	                        // path starts at left, follows the upper path then turns and
	                        // follows the bottom back. 
	                        slice = arr.slice().splice(
	                            (arr.length / positionFactor) - numParams,
	                            numParams * positionFactor
	                        );
	
	                        // Move to, line to or curve to?
	                        slice[0] = other[fullLength - numParams - (i * numParams)];
	
	                        // Disable first control point
	                        if (bezier) {
	                            slice[numParams - 6] = slice[numParams - 2];
	                            slice[numParams - 5] = slice[numParams - 1];
	                        }
	
	                        // Now insert the slice, either in the middle (for areas) or at
	                        // the end (for lines)
	                        insertSlice(arr, slice, arr.length / positionFactor);
	
	                        if (isArea) {
	                            i--;
	                        }
	                    }
	                }
	
	                if (bezier) {
	                    sixify(start);
	                    sixify(end);
	                }
	
	                // For sideways animation, find out how much we need to shift to get the
	                // start path Xs to match the end path Xs.
	                if (startX && endX) {
	                    for (i = 0; i < startX.length; i++) {
	                        // Moving left, new points coming in on right
	                        if (startX[i] === endX[0]) {
	                            shift = i;
	                            break;
	                            // Moving right
	                        } else if (startX[0] ===
	                            endX[endX.length - startX.length + i]) {
	                            shift = i;
	                            reverse = true;
	                            break;
	                        }
	                    }
	                    if (shift === undefined) {
	                        start = [];
	                    }
	                }
	
	                if (start.length && H.isNumber(shift)) {
	
	                    // The common target length for the start and end array, where both 
	                    // arrays are padded in opposite ends
	                    fullLength = end.length + shift * positionFactor * numParams;
	
	                    if (!reverse) {
	                        prepend(end, start);
	                        append(start, end);
	                    } else {
	                        prepend(start, end);
	                        append(end, start);
	                    }
	                }
	
	                return [start, end];
	            }
	        }; // End of Fx prototype
	
	        /**
	         * Handle animation of the color attributes directly.
	         */
	        H.Fx.prototype.fillSetter =
	            H.Fx.prototype.strokeSetter = function() {
	                this.elem.attr(
	                    this.prop,
	                    H.color(this.start).tweenTo(H.color(this.end), this.pos),
	                    null,
	                    true
	                );
	            };
	
	
	        /**
	         * Utility function to extend an object with the members of another.
	         *
	         * @function #extend
	         * @memberOf Highcharts
	         * @param {Object} a - The object to be extended.
	         * @param {Object} b - The object to add to the first one.
	         * @returns {Object} Object a, the original object.
	         */
	        H.extend = function(a, b) {
	            var n;
	            if (!a) {
	                a = {};
	            }
	            for (n in b) {
	                a[n] = b[n];
	            }
	            return a;
	        };
	
	        /**
	         * Utility function to deep merge two or more objects and return a third object.
	         * If the first argument is true, the contents of the second object is copied
	         * into the first object. The merge function can also be used with a single 
	         * object argument to create a deep copy of an object.
	         *
	         * @function #merge
	         * @memberOf Highcharts
	         * @param {Boolean} [extend] - Whether to extend the left-side object (a) or
	                  return a whole new object.
	         * @param {Object} a - The first object to extend. When only this is given, the
	                  function returns a deep copy.
	         * @param {...Object} [n] - An object to merge into the previous one.
	         * @returns {Object} - The merged object. If the first argument is true, the 
	         * return is the same as the second argument.
	         */
	        H.merge = function() {
	            var i,
	                args = arguments,
	                len,
	                ret = {},
	                doCopy = function(copy, original) {
	                    // An object is replacing a primitive
	                    if (typeof copy !== 'object') {
	                        copy = {};
	                    }
	
	                    H.objectEach(original, function(value, key) {
	
	                        // Copy the contents of objects, but not arrays or DOM nodes
	                        if (
	                            H.isObject(value, true) &&
	                            !H.isClass(value) &&
	                            !H.isDOMElement(value)
	                        ) {
	                            copy[key] = doCopy(copy[key] || {}, value);
	
	                            // Primitives and arrays are copied over directly
	                        } else {
	                            copy[key] = original[key];
	                        }
	                    });
	                    return copy;
	                };
	
	            // If first argument is true, copy into the existing object. Used in
	            // setOptions.
	            if (args[0] === true) {
	                ret = args[1];
	                args = Array.prototype.slice.call(args, 2);
	            }
	
	            // For each argument, extend the return
	            len = args.length;
	            for (i = 0; i < len; i++) {
	                ret = doCopy(ret, args[i]);
	            }
	
	            return ret;
	        };
	
	        /**
	         * Shortcut for parseInt
	         * @ignore
	         * @param {Object} s
	         * @param {Number} mag Magnitude
	         */
	        H.pInt = function(s, mag) {
	            return parseInt(s, mag || 10);
	        };
	
	        /**
	         * Utility function to check for string type.
	         *
	         * @function #isString
	         * @memberOf Highcharts
	         * @param {Object} s - The item to check.
	         * @returns {Boolean} - True if the argument is a string.
	         */
	        H.isString = function(s) {
	            return typeof s === 'string';
	        };
	
	        /**
	         * Utility function to check if an item is an array.
	         *
	         * @function #isArray
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is an array.
	         */
	        H.isArray = function(obj) {
	            var str = Object.prototype.toString.call(obj);
	            return str === '[object Array]' || str === '[object Array Iterator]';
	        };
	
	        /**
	         * Utility function to check if an item is of type object.
	         *
	         * @function #isObject
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @param {Boolean} [strict=false] - Also checks that the object is not an
	         *    array.
	         * @returns {Boolean} - True if the argument is an object.
	         */
	        H.isObject = function(obj, strict) {
	            return !!obj && typeof obj === 'object' && (!strict || !H.isArray(obj));
	        };
	
	        /**
	         * Utility function to check if an Object is a HTML Element.
	         *
	         * @function #isDOMElement
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is a HTML Element.
	         */
	        H.isDOMElement = function(obj) {
	            return H.isObject(obj) && typeof obj.nodeType === 'number';
	        };
	
	        /**
	         * Utility function to check if an Object is an class.
	         *
	         * @function #isClass
	         * @memberOf Highcharts
	         * @param {Object} obj - The item to check.
	         * @returns {Boolean} - True if the argument is an class.
	         */
	        H.isClass = function(obj) {
	            var c = obj && obj.constructor;
	            return !!(
	                H.isObject(obj, true) &&
	                !H.isDOMElement(obj) &&
	                (c && c.name && c.name !== 'Object')
	            );
	        };
	
	        /**
	         * Utility function to check if an item is of type number.
	         *
	         * @function #isNumber
	         * @memberOf Highcharts
	         * @param {Object} n - The item to check.
	         * @returns {Boolean} - True if the item is a number and is not NaN.
	         */
	        H.isNumber = function(n) {
	            return typeof n === 'number' && !isNaN(n);
	        };
	
	        /**
	         * Remove the last occurence of an item from an array.
	         *
	         * @function #erase
	         * @memberOf Highcharts
	         * @param {Array} arr - The array.
	         * @param {*} item - The item to remove.
	         */
	        H.erase = function(arr, item) {
	            var i = arr.length;
	            while (i--) {
	                if (arr[i] === item) {
	                    arr.splice(i, 1);
	                    break;
	                }
	            }
	        };
	
	        /**
	         * Check if an object is null or undefined.
	         *
	         * @function #defined
	         * @memberOf Highcharts
	         * @param {Object} obj - The object to check.
	         * @returns {Boolean} - False if the object is null or undefined, otherwise
	         *        true.
	         */
	        H.defined = function(obj) {
	            return obj !== undefined && obj !== null;
	        };
	
	        /**
	         * Set or get an attribute or an object of attributes. To use as a setter, pass
	         * a key and a value, or let the second argument be a collection of keys and
	         * values. To use as a getter, pass only a string as the second argument.
	         *
	         * @function #attr
	         * @memberOf Highcharts
	         * @param {Object} elem - The DOM element to receive the attribute(s).
	         * @param {String|Object} [prop] - The property or an object of key-value pairs.
	         * @param {String} [value] - The value if a single property is set.
	         * @returns {*} When used as a getter, return the value.
	         */
	        H.attr = function(elem, prop, value) {
	            var ret;
	
	            // if the prop is a string
	            if (H.isString(prop)) {
	                // set the value
	                if (H.defined(value)) {
	                    elem.setAttribute(prop, value);
	
	                    // get the value
	                } else if (elem && elem.getAttribute) {
	                    ret = elem.getAttribute(prop);
	                }
	
	                // else if prop is defined, it is a hash of key/value pairs
	            } else if (H.defined(prop) && H.isObject(prop)) {
	                H.objectEach(prop, function(val, key) {
	                    elem.setAttribute(key, val);
	                });
	            }
	            return ret;
	        };
	
	        /**
	         * Check if an element is an array, and if not, make it into an array.
	         *
	         * @function #splat
	         * @memberOf Highcharts
	         * @param obj {*} - The object to splat.
	         * @returns {Array} The produced or original array.
	         */
	        H.splat = function(obj) {
	            return H.isArray(obj) ? obj : [obj];
	        };
	
	        /**
	         * Set a timeout if the delay is given, otherwise perform the function
	         * synchronously.
	         *
	         * @function #syncTimeout
	         * @memberOf Highcharts
	         * @param   {Function} fn - The function callback.
	         * @param   {Number}   delay - Delay in milliseconds.
	         * @param   {Object}   [context] - The context.
	         * @returns {Number} An identifier for the timeout that can later be cleared
	         * with clearTimeout.
	         */
	        H.syncTimeout = function(fn, delay, context) {
	            if (delay) {
	                return setTimeout(fn, delay, context);
	            }
	            fn.call(0, context);
	        };
	
	
	        /**
	         * Return the first value that is not null or undefined.
	         *
	         * @function #pick
	         * @memberOf Highcharts
	         * @param {...*} items - Variable number of arguments to inspect.
	         * @returns {*} The value of the first argument that is not null or undefined.
	         */
	        H.pick = function() {
	            var args = arguments,
	                i,
	                arg,
	                length = args.length;
	            for (i = 0; i < length; i++) {
	                arg = args[i];
	                if (arg !== undefined && arg !== null) {
	                    return arg;
	                }
	            }
	        };
	
	        /**
	         * @typedef {Object} CSSObject - A style object with camel case property names.
	         * The properties can be whatever styles are supported on the given SVG or HTML
	         * element.
	         * @example
	         * {
	         *    fontFamily: 'monospace',
	         *    fontSize: '1.2em'
	         * }
	         */
	        /**
	         * Set CSS on a given element.
	         *
	         * @function #css
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - A HTML DOM element.
	         * @param {CSSObject} styles - Style object with camel case property names.
	         * 
	         */
	        H.css = function(el, styles) {
	            if (H.isMS && !H.svg) { // #2686
	                if (styles && styles.opacity !== undefined) {
	                    styles.filter = 'alpha(opacity=' + (styles.opacity * 100) + ')';
	                }
	            }
	            H.extend(el.style, styles);
	        };
	
	        /**
	         * A HTML DOM element.
	         * @typedef {Object} HTMLDOMElement
	         */
	
	        /**
	         * Utility function to create an HTML element with attributes and styles.
	         *
	         * @function #createElement
	         * @memberOf Highcharts
	         * @param {String} tag - The HTML tag.
	         * @param {Object} [attribs] - Attributes as an object of key-value pairs.
	         * @param {CSSObject} [styles] - Styles as an object of key-value pairs.
	         * @param {Object} [parent] - The parent HTML object.
	         * @param {Boolean} [nopad=false] - If true, remove all padding, border and
	         *    margin.
	         * @returns {HTMLDOMElement} The created DOM element.
	         */
	        H.createElement = function(tag, attribs, styles, parent, nopad) {
	            var el = doc.createElement(tag),
	                css = H.css;
	            if (attribs) {
	                H.extend(el, attribs);
	            }
	            if (nopad) {
	                css(el, {
	                    padding: 0,
	                    border: 'none',
	                    margin: 0
	                });
	            }
	            if (styles) {
	                css(el, styles);
	            }
	            if (parent) {
	                parent.appendChild(el);
	            }
	            return el;
	        };
	
	        /**
	         * Extend a prototyped class by new members.
	         *
	         * @function #extendClass
	         * @memberOf Highcharts
	         * @param {Object} parent - The parent prototype to inherit.
	         * @param {Object} members - A collection of prototype members to add or
	         *        override compared to the parent prototype.
	         * @returns {Object} A new prototype.
	         */
	        H.extendClass = function(parent, members) {
	            var object = function() {};
	            object.prototype = new parent(); // eslint-disable-line new-cap
	            H.extend(object.prototype, members);
	            return object;
	        };
	
	        /**
	         * Left-pad a string to a given length by adding a character repetetively.
	         *
	         * @function #pad
	         * @memberOf Highcharts
	         * @param {Number} number - The input string or number.
	         * @param {Number} length - The desired string length.
	         * @param {String} [padder=0] - The character to pad with.
	         * @returns {String} The padded string.
	         */
	        H.pad = function(number, length, padder) {
	            return new Array((length || 2) + 1 -
	                String(number).length).join(padder || 0) + number;
	        };
	
	        /**
	         * @typedef {Number|String} RelativeSize - If a number is given, it defines the
	         *    pixel length. If a percentage string is given, like for example `'50%'`,
	         *    the setting defines a length relative to a base size, for example the size
	         *    of a container.
	         */
	        /**
	         * Return a length based on either the integer value, or a percentage of a base.
	         *
	         * @function #relativeLength
	         * @memberOf Highcharts
	         * @param  {RelativeSize} value
	         *         A percentage string or a number.
	         * @param  {number} base
	         *         The full length that represents 100%.
	         * @param  {number} [offset=0]
	         *         A pixel offset to apply for percentage values. Used internally in 
	         *         axis positioning.
	         * @return {number}
	         *         The computed length.
	         */
	        H.relativeLength = function(value, base, offset) {
	            return (/%$/).test(value) ?
	                (base * parseFloat(value) / 100) + (offset || 0) :
	                parseFloat(value);
	        };
	
	        /**
	         * Wrap a method with extended functionality, preserving the original function.
	         *
	         * @function #wrap
	         * @memberOf Highcharts
	         * @param {Object} obj - The context object that the method belongs to. In real
	         *        cases, this is often a prototype.
	         * @param {String} method - The name of the method to extend.
	         * @param {Function} func - A wrapper function callback. This function is called
	         *        with the same arguments as the original function, except that the
	         *        original function is unshifted and passed as the first argument.
	         * 
	         */
	        H.wrap = function(obj, method, func) {
	            var proceed = obj[method];
	            obj[method] = function() {
	                var args = Array.prototype.slice.call(arguments),
	                    outerArgs = arguments,
	                    ctx = this,
	                    ret;
	                ctx.proceed = function() {
	                    proceed.apply(ctx, arguments.length ? arguments : outerArgs);
	                };
	                args.unshift(proceed);
	                ret = func.apply(this, args);
	                ctx.proceed = null;
	                return ret;
	            };
	        };
	
	        /**
	         * Get the time zone offset based on the current timezone information as set in
	         * the global options.
	         *
	         * @function #getTZOffset
	         * @memberOf Highcharts
	         * @param  {Number} timestamp - The JavaScript timestamp to inspect.
	         * @return {Number} - The timezone offset in minutes compared to UTC.
	         */
	        H.getTZOffset = function(timestamp) {
	            var d = H.Date;
	            return ((d.hcGetTimezoneOffset && d.hcGetTimezoneOffset(timestamp)) ||
	                d.hcTimezoneOffset || 0) * 60000;
	        };
	
	        /**
	         * Formats a JavaScript date timestamp (milliseconds since Jan 1st 1970) into a
	         * human readable date string. The format is a subset of the formats for PHP's
	         * [strftime]{@link
	         * http://www.php.net/manual/en/function.strftime.php} function. Additional
	         * formats can be given in the {@link Highcharts.dateFormats} hook.
	         *
	         * @function #dateFormat
	         * @memberOf Highcharts
	         * @param {String} format - The desired format where various time
	         *        representations are prefixed with %.
	         * @param {Number} timestamp - The JavaScript timestamp.
	         * @param {Boolean} [capitalize=false] - Upper case first letter in the return.
	         * @returns {String} The formatted date.
	         */
	        H.dateFormat = function(format, timestamp, capitalize) {
	            if (!H.defined(timestamp) || isNaN(timestamp)) {
	                return H.defaultOptions.lang.invalidDate || '';
	            }
	            format = H.pick(format, '%Y-%m-%d %H:%M:%S');
	
	            var D = H.Date,
	                date = new D(timestamp - H.getTZOffset(timestamp)),
	                // get the basic time values
	                hours = date[D.hcGetHours](),
	                day = date[D.hcGetDay](),
	                dayOfMonth = date[D.hcGetDate](),
	                month = date[D.hcGetMonth](),
	                fullYear = date[D.hcGetFullYear](),
	                lang = H.defaultOptions.lang,
	                langWeekdays = lang.weekdays,
	                shortWeekdays = lang.shortWeekdays,
	                pad = H.pad,
	
	                // List all format keys. Custom formats can be added from the outside. 
	                replacements = H.extend({
	
	                        //-- Day
	                        // Short weekday, like 'Mon'
	                        'a': shortWeekdays ?
	                            shortWeekdays[day] : langWeekdays[day].substr(0, 3),
	                        // Long weekday, like 'Monday'
	                        'A': langWeekdays[day],
	                        // Two digit day of the month, 01 to 31
	                        'd': pad(dayOfMonth),
	                        // Day of the month, 1 through 31
	                        'e': pad(dayOfMonth, 2, ' '),
	                        'w': day,
	
	                        // Week (none implemented)
	                        //'W': weekNumber(),
	
	                        //-- Month
	                        // Short month, like 'Jan'
	                        'b': lang.shortMonths[month],
	                        // Long month, like 'January'
	                        'B': lang.months[month],
	                        // Two digit month number, 01 through 12
	                        'm': pad(month + 1),
	
	                        //-- Year
	                        // Two digits year, like 09 for 2009
	                        'y': fullYear.toString().substr(2, 2),
	                        // Four digits year, like 2009
	                        'Y': fullYear,
	
	                        //-- Time
	                        // Two digits hours in 24h format, 00 through 23
	                        'H': pad(hours),
	                        // Hours in 24h format, 0 through 23
	                        'k': hours,
	                        // Two digits hours in 12h format, 00 through 11
	                        'I': pad((hours % 12) || 12),
	                        // Hours in 12h format, 1 through 12
	                        'l': (hours % 12) || 12,
	                        // Two digits minutes, 00 through 59
	                        'M': pad(date[D.hcGetMinutes]()),
	                        // Upper case AM or PM
	                        'p': hours < 12 ? 'AM' : 'PM',
	                        // Lower case AM or PM
	                        'P': hours < 12 ? 'am' : 'pm',
	                        // Two digits seconds, 00 through  59
	                        'S': pad(date.getSeconds()),
	                        // Milliseconds (naming from Ruby)
	                        'L': pad(Math.round(timestamp % 1000), 3)
	                    },
	
	                    /**
	                     * A hook for defining additional date format specifiers. New
	                     * specifiers are defined as key-value pairs by using the specifier
	                     * as key, and a function which takes the timestamp as value. This
	                     * function returns the formatted portion of the date.
	                     *
	                     * @type {Object}
	                     * @name dateFormats
	                     * @memberOf Highcharts
	                     * @sample highcharts/global/dateformats/ Adding support for week
	                     * number
	                     */
	                    H.dateFormats
	                );
	
	
	            // Do the replaces
	            H.objectEach(replacements, function(val, key) {
	                // Regex would do it in one line, but this is faster
	                while (format.indexOf('%' + key) !== -1) {
	                    format = format.replace(
	                        '%' + key,
	                        typeof val === 'function' ? val(timestamp) : val
	                    );
	                }
	
	            });
	
	            // Optionally capitalize the string and return
	            return capitalize ?
	                format.substr(0, 1).toUpperCase() + format.substr(1) :
	                format;
	        };
	
	        /**
	         * Format a single variable. Similar to sprintf, without the % prefix.
	         *
	         * @example
	         * formatSingle('.2f', 5); // => '5.00'.
	         *
	         * @function #formatSingle
	         * @memberOf Highcharts
	         * @param {String} format The format string.
	         * @param {*} val The value.
	         * @returns {String} The formatted representation of the value.
	         */
	        H.formatSingle = function(format, val) {
	            var floatRegex = /f$/,
	                decRegex = /\.([0-9])/,
	                lang = H.defaultOptions.lang,
	                decimals;
	
	            if (floatRegex.test(format)) { // float
	                decimals = format.match(decRegex);
	                decimals = decimals ? decimals[1] : -1;
	                if (val !== null) {
	                    val = H.numberFormat(
	                        val,
	                        decimals,
	                        lang.decimalPoint,
	                        format.indexOf(',') > -1 ? lang.thousandsSep : ''
	                    );
	                }
	            } else {
	                val = H.dateFormat(format, val);
	            }
	            return val;
	        };
	
	        /**
	         * Format a string according to a subset of the rules of Python's String.format
	         * method.
	         *
	         * @function #format
	         * @memberOf Highcharts
	         * @param {String} str The string to format.
	         * @param {Object} ctx The context, a collection of key-value pairs where each
	         *        key is replaced by its value.
	         * @returns {String} The formatted string.
	         *
	         * @example
	         * var s = Highcharts.format(
	         *     'The {color} fox was {len:.2f} feet long',
	         *     { color: 'red', len: Math.PI }
	         * );
	         * // => The red fox was 3.14 feet long
	         */
	        H.format = function(str, ctx) {
	            var splitter = '{',
	                isInside = false,
	                segment,
	                valueAndFormat,
	                path,
	                i,
	                len,
	                ret = [],
	                val,
	                index;
	
	            while (str) {
	                index = str.indexOf(splitter);
	                if (index === -1) {
	                    break;
	                }
	
	                segment = str.slice(0, index);
	                if (isInside) { // we're on the closing bracket looking back
	
	                    valueAndFormat = segment.split(':');
	                    path = valueAndFormat.shift().split('.'); // get first and leave
	                    len = path.length;
	                    val = ctx;
	
	                    // Assign deeper paths
	                    for (i = 0; i < len; i++) {
	                        val = val[path[i]];
	                    }
	
	                    // Format the replacement
	                    if (valueAndFormat.length) {
	                        val = H.formatSingle(valueAndFormat.join(':'), val);
	                    }
	
	                    // Push the result and advance the cursor
	                    ret.push(val);
	
	                } else {
	                    ret.push(segment);
	
	                }
	                str = str.slice(index + 1); // the rest
	                isInside = !isInside; // toggle
	                splitter = isInside ? '}' : '{'; // now look for next matching bracket
	            }
	            ret.push(str);
	            return ret.join('');
	        };
	
	        /**
	         * Get the magnitude of a number.
	         *
	         * @function #getMagnitude
	         * @memberOf Highcharts
	         * @param {Number} number The number.
	         * @returns {Number} The magnitude, where 1-9 are magnitude 1, 10-99 magnitude 2
	         *        etc.
	         */
	        H.getMagnitude = function(num) {
	            return Math.pow(10, Math.floor(Math.log(num) / Math.LN10));
	        };
	
	        /**
	         * Take an interval and normalize it to multiples of round numbers.
	         *
	         * @todo  Move this function to the Axis prototype. It is here only for
	         *        historical reasons.
	         * @function #normalizeTickInterval
	         * @memberOf Highcharts
	         * @param {Number} interval - The raw, un-rounded interval.
	         * @param {Array} [multiples] - Allowed multiples.
	         * @param {Number} [magnitude] - The magnitude of the number.
	         * @param {Boolean} [allowDecimals] - Whether to allow decimals.
	         * @param {Boolean} [hasTickAmount] - If it has tickAmount, avoid landing
	         *        on tick intervals lower than original.
	         * @returns {Number} The normalized interval.
	         */
	        H.normalizeTickInterval = function(interval, multiples, magnitude,
	            allowDecimals, hasTickAmount) {
	            var normalized,
	                i,
	                retInterval = interval;
	
	            // round to a tenfold of 1, 2, 2.5 or 5
	            magnitude = H.pick(magnitude, 1);
	            normalized = interval / magnitude;
	
	            // multiples for a linear scale
	            if (!multiples) {
	                multiples = hasTickAmount ?
	                    // Finer grained ticks when the tick amount is hard set, including
	                    // when alignTicks is true on multiple axes (#4580).
	                    [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] :
	
	                    // Else, let ticks fall on rounder numbers
	                    [1, 2, 2.5, 5, 10];
	
	
	                // the allowDecimals option
	                if (allowDecimals === false) {
	                    if (magnitude === 1) {
	                        multiples = H.grep(multiples, function(num) {
	                            return num % 1 === 0;
	                        });
	                    } else if (magnitude <= 0.1) {
	                        multiples = [1 / magnitude];
	                    }
	                }
	            }
	
	            // normalize the interval to the nearest multiple
	            for (i = 0; i < multiples.length; i++) {
	                retInterval = multiples[i];
	                // only allow tick amounts smaller than natural
	                if ((hasTickAmount && retInterval * magnitude >= interval) ||
	                    (!hasTickAmount && (normalized <= (multiples[i] +
	                        (multiples[i + 1] || multiples[i])) / 2))) {
	                    break;
	                }
	            }
	
	            // Multiply back to the correct magnitude. Correct floats to appropriate 
	            // precision (#6085).
	            retInterval = H.correctFloat(
	                retInterval * magnitude, -Math.round(Math.log(0.001) / Math.LN10)
	            );
	
	            return retInterval;
	        };
	
	
	        /**
	         * Sort an object array and keep the order of equal items. The ECMAScript
	         * standard does not specify the behaviour when items are equal.
	         *
	         * @function #stableSort
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to sort.
	         * @param {Function} sortFunction - The function to sort it with, like with 
	         *        regular Array.prototype.sort.
	         * 
	         */
	        H.stableSort = function(arr, sortFunction) {
	            var length = arr.length,
	                sortValue,
	                i;
	
	            // Add index to each item
	            for (i = 0; i < length; i++) {
	                arr[i].safeI = i; // stable sort index
	            }
	
	            arr.sort(function(a, b) {
	                sortValue = sortFunction(a, b);
	                return sortValue === 0 ? a.safeI - b.safeI : sortValue;
	            });
	
	            // Remove index from items
	            for (i = 0; i < length; i++) {
	                delete arr[i].safeI; // stable sort index
	            }
	        };
	
	        /**
	         * Non-recursive method to find the lowest member of an array. `Math.min` raises
	         * a maximum call stack size exceeded error in Chrome when trying to apply more
	         * than 150.000 points. This method is slightly slower, but safe.
	         *
	         * @function #arrayMin
	         * @memberOf  Highcharts
	         * @param {Array} data An array of numbers.
	         * @returns {Number} The lowest number.
	         */
	        H.arrayMin = function(data) {
	            var i = data.length,
	                min = data[0];
	
	            while (i--) {
	                if (data[i] < min) {
	                    min = data[i];
	                }
	            }
	            return min;
	        };
	
	        /**
	         * Non-recursive method to find the lowest member of an array. `Math.max` raises
	         * a maximum call stack size exceeded error in Chrome when trying to apply more
	         * than 150.000 points. This method is slightly slower, but safe.
	         *
	         * @function #arrayMax
	         * @memberOf  Highcharts
	         * @param {Array} data - An array of numbers.
	         * @returns {Number} The highest number.
	         */
	        H.arrayMax = function(data) {
	            var i = data.length,
	                max = data[0];
	
	            while (i--) {
	                if (data[i] > max) {
	                    max = data[i];
	                }
	            }
	            return max;
	        };
	
	        /**
	         * Utility method that destroys any SVGElement instances that are properties on
	         * the given object. It loops all properties and invokes destroy if there is a
	         * destroy method. The property is then delete.
	         *
	         * @function #destroyObjectProperties
	         * @memberOf Highcharts
	         * @param {Object} obj - The object to destroy properties on.
	         * @param {Object} [except] - Exception, do not destroy this property, only
	         *    delete it.
	         * 
	         */
	        H.destroyObjectProperties = function(obj, except) {
	            H.objectEach(obj, function(val, n) {
	                // If the object is non-null and destroy is defined
	                if (val && val !== except && val.destroy) {
	                    // Invoke the destroy
	                    val.destroy();
	                }
	
	                // Delete the property from the object.
	                delete obj[n];
	            });
	        };
	
	
	        /**
	         * Discard a HTML element by moving it to the bin and delete.
	         *
	         * @function #discardElement
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} element - The HTML node to discard.
	         * 
	         */
	        H.discardElement = function(element) {
	            var garbageBin = H.garbageBin;
	            // create a garbage bin element, not part of the DOM
	            if (!garbageBin) {
	                garbageBin = H.createElement('div');
	            }
	
	            // move the node and empty bin
	            if (element) {
	                garbageBin.appendChild(element);
	            }
	            garbageBin.innerHTML = '';
	        };
	
	        /**
	         * Fix JS round off float errors.
	         *
	         * @function #correctFloat
	         * @memberOf Highcharts
	         * @param {Number} num - A float number to fix.
	         * @param {Number} [prec=14] - The precision.
	         * @returns {Number} The corrected float number.
	         */
	        H.correctFloat = function(num, prec) {
	            return parseFloat(
	                num.toPrecision(prec || 14)
	            );
	        };
	
	        /**
	         * Set the global animation to either a given value, or fall back to the given
	         * chart's animation option.
	         *
	         * @function #setAnimation
	         * @memberOf Highcharts
	         * @param {Boolean|Animation} animation - The animation object.
	         * @param {Object} chart - The chart instance.
	         * 
	         * @todo This function always relates to a chart, and sets a property on the
	         *        renderer, so it should be moved to the SVGRenderer.
	         */
	        H.setAnimation = function(animation, chart) {
	            chart.renderer.globalAnimation = H.pick(
	                animation,
	                chart.options.chart.animation,
	                true
	            );
	        };
	
	        /**
	         * Get the animation in object form, where a disabled animation is always
	         * returned as `{ duration: 0 }`.
	         *
	         * @function #animObject
	         * @memberOf Highcharts
	         * @param {Boolean|AnimationOptions} animation - An animation setting. Can be an
	         *        object with duration, complete and easing properties, or a boolean to
	         *        enable or disable.
	         * @returns {AnimationOptions} An object with at least a duration property.
	         */
	        H.animObject = function(animation) {
	            return H.isObject(animation) ?
	                H.merge(animation) : {
	                    duration: animation ? 500 : 0
	                };
	        };
	
	        /**
	         * The time unit lookup
	         */
	        H.timeUnits = {
	            millisecond: 1,
	            second: 1000,
	            minute: 60000,
	            hour: 3600000,
	            day: 24 * 3600000,
	            week: 7 * 24 * 3600000,
	            month: 28 * 24 * 3600000,
	            year: 364 * 24 * 3600000
	        };
	
	        /**
	         * Format a number and return a string based on input settings.
	         *
	         * @function #numberFormat
	         * @memberOf Highcharts
	         * @param {Number} number - The input number to format.
	         * @param {Number} decimals - The amount of decimals. A value of -1 preserves
	         *        the amount in the input number.
	         * @param {String} [decimalPoint] - The decimal point, defaults to the one given
	         *        in the lang options, or a dot.
	         * @param {String} [thousandsSep] - The thousands separator, defaults to the one
	         *        given in the lang options, or a space character.
	         * @returns {String} The formatted number.
	         *
	         * @sample members/highcharts-numberformat/ Custom number format
	         */
	        H.numberFormat = function(number, decimals, decimalPoint, thousandsSep) {
	            number = +number || 0;
	            decimals = +decimals;
	
	            var lang = H.defaultOptions.lang,
	                origDec = (number.toString().split('.')[1] || '').split('e')[0].length,
	                strinteger,
	                thousands,
	                ret,
	                roundedNumber,
	                exponent = number.toString().split('e');
	
	            if (decimals === -1) {
	                // Preserve decimals. Not huge numbers (#3793).
	                decimals = Math.min(origDec, 20);
	            } else if (!H.isNumber(decimals)) {
	                decimals = 2;
	            }
	
	            // Add another decimal to avoid rounding errors of float numbers. (#4573)
	            // Then use toFixed to handle rounding.
	            roundedNumber = (
	                Math.abs(exponent[1] ? exponent[0] : number) +
	                Math.pow(10, -Math.max(decimals, origDec) - 1)
	            ).toFixed(decimals);
	
	            // A string containing the positive integer component of the number
	            strinteger = String(H.pInt(roundedNumber));
	
	            // Leftover after grouping into thousands. Can be 0, 1 or 3.
	            thousands = strinteger.length > 3 ? strinteger.length % 3 : 0;
	
	            // Language
	            decimalPoint = H.pick(decimalPoint, lang.decimalPoint);
	            thousandsSep = H.pick(thousandsSep, lang.thousandsSep);
	
	            // Start building the return
	            ret = number < 0 ? '-' : '';
	
	            // Add the leftover after grouping into thousands. For example, in the
	            // number 42 000 000, this line adds 42.
	            ret += thousands ? strinteger.substr(0, thousands) + thousandsSep : '';
	
	            // Add the remaining thousands groups, joined by the thousands separator
	            ret += strinteger
	                .substr(thousands)
	                .replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep);
	
	            // Add the decimal point and the decimal component
	            if (decimals) {
	                // Get the decimal component
	                ret += decimalPoint + roundedNumber.slice(-decimals);
	            }
	
	            if (exponent[1]) {
	                ret += 'e' + exponent[1];
	            }
	
	            return ret;
	        };
	
	        /**
	         * Easing definition
	         * @ignore
	         * @param   {Number} pos Current position, ranging from 0 to 1.
	         */
	        Math.easeInOutSine = function(pos) {
	            return -0.5 * (Math.cos(Math.PI * pos) - 1);
	        };
	
	        /**
	         * Get the computed CSS value for given element and property, only for numerical
	         * properties. For width and height, the dimension of the inner box (excluding
	         * padding) is returned. Used for fitting the chart within the container.
	         *
	         * @function #getStyle
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - A HTML element.
	         * @param {String} prop - The property name.
	         * @param {Boolean} [toInt=true] - Parse to integer.
	         * @returns {Number} - The numeric value.
	         */
	        H.getStyle = function(el, prop, toInt) {
	
	            var style;
	
	            // For width and height, return the actual inner pixel size (#4913)
	            if (prop === 'width') {
	                return Math.min(el.offsetWidth, el.scrollWidth) -
	                    H.getStyle(el, 'padding-left') -
	                    H.getStyle(el, 'padding-right');
	            } else if (prop === 'height') {
	                return Math.min(el.offsetHeight, el.scrollHeight) -
	                    H.getStyle(el, 'padding-top') -
	                    H.getStyle(el, 'padding-bottom');
	            }
	
	            // Otherwise, get the computed style
	            style = win.getComputedStyle(el, undefined);
	            if (style) {
	                style = style.getPropertyValue(prop);
	                if (H.pick(toInt, true)) {
	                    style = H.pInt(style);
	                }
	            }
	            return style;
	        };
	
	        /**
	         * Search for an item in an array.
	         *
	         * @function #inArray
	         * @memberOf Highcharts
	         * @param {*} item - The item to search for.
	         * @param {arr} arr - The array or node collection to search in.
	         * @returns {Number} - The index within the array, or -1 if not found.
	         */
	        H.inArray = function(item, arr) {
	            return arr.indexOf ? arr.indexOf(item) : [].indexOf.call(arr, item);
	        };
	
	        /**
	         * Filter an array by a callback.
	         *
	         * @function #grep
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to filter.
	         * @param {Function} callback - The callback function. The function receives the
	         *        item as the first argument. Return `true` if the item is to be
	         *        preserved.
	         * @returns {Array} - A new, filtered array.
	         */
	        H.grep = function(arr, callback) {
	            return [].filter.call(arr, callback);
	        };
	
	        /**
	         * Return the value of the first element in the array that satisfies the 
	         * provided testing function.
	         *
	         * @function #find
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to test.
	         * @param {Function} callback - The callback function. The function receives the
	         *        item as the first argument. Return `true` if this item satisfies the
	         *        condition.
	         * @returns {Mixed} - The value of the element.
	         */
	        H.find = function(arr, callback) {
	            return [].find.call(arr, callback);
	        };
	
	        /**
	         * Map an array by a callback.
	         *
	         * @function #map
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to map.
	         * @param {Function} fn - The callback function. Return the new value for the 
	         *        new array.
	         * @returns {Array} - A new array item with modified items.
	         */
	        H.map = function(arr, fn) {
	            var results = [],
	                i = 0,
	                len = arr.length;
	
	            for (; i < len; i++) {
	                results[i] = fn.call(arr[i], arr[i], i, arr);
	            }
	
	            return results;
	        };
	
	        /**
	         * Get the element's offset position, corrected for `overflow: auto`.
	         *
	         * @function #offset
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement} el - The HTML element.
	         * @returns {Object} An object containing `left` and `top` properties for the
	         * position in the page.
	         */
	        H.offset = function(el) {
	            var docElem = doc.documentElement,
	                box = el.getBoundingClientRect();
	
	            return {
	                top: box.top + (win.pageYOffset || docElem.scrollTop) -
	                    (docElem.clientTop || 0),
	                left: box.left + (win.pageXOffset || docElem.scrollLeft) -
	                    (docElem.clientLeft || 0)
	            };
	        };
	
	        /**
	         * Stop running animation.
	         *
	         * @todo A possible extension to this would be to stop a single property, when
	         * we want to continue animating others. Then assign the prop to the timer
	         * in the Fx.run method, and check for the prop here. This would be an
	         * improvement in all cases where we stop the animation from .attr. Instead of
	         * stopping everything, we can just stop the actual attributes we're setting.
	         *
	         * @function #stop
	         * @memberOf Highcharts
	         * @param {SVGElement} el - The SVGElement to stop animation on.
	         * @param {string} [prop] - The property to stop animating. If given, the stop
	         *    method will stop a single property from animating, while others continue.
	         * 
	         */
	        H.stop = function(el, prop) {
	
	            var i = timers.length;
	
	            // Remove timers related to this element (#4519)
	            while (i--) {
	                if (timers[i].elem === el && (!prop || prop === timers[i].prop)) {
	                    timers[i].stopped = true; // #4667
	                }
	            }
	        };
	
	        /**
	         * Iterate over an array.
	         *
	         * @function #each
	         * @memberOf Highcharts
	         * @param {Array} arr - The array to iterate over.
	         * @param {Function} fn - The iterator callback. It passes three arguments:
	         * * item - The array item.
	         * * index - The item's index in the array.
	         * * arr - The array that each is being applied to.
	         * @param {Object} [ctx] The context.
	         */
	        H.each = function(arr, fn, ctx) { // modern browsers
	            return Array.prototype.forEach.call(arr, fn, ctx);
	        };
	
	        /**
	         * Iterate over object key pairs in an object.
	         *
	         * @function #objectEach
	         * @memberOf Highcharts
	         * @param  {Object}   obj - The object to iterate over.
	         * @param  {Function} fn  - The iterator callback. It passes three arguments:
	         * * value - The property value.
	         * * key - The property key.
	         * * obj - The object that objectEach is being applied to.
	         * @param  {Object}   ctx The context
	         */
	        H.objectEach = function(obj, fn, ctx) {
	            for (var key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    fn.call(ctx, obj[key], key, obj);
	                }
	            }
	        };
	
	        /**
	         * Add an event listener.
	         *
	         * @function #addEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The element or object to add a listener to. It can be a
	         *        {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
	         * @param {String} type - The event type.
	         * @param {Function} fn - The function callback to execute when the event is 
	         *        fired.
	         * @returns {Function} A callback function to remove the added event.
	         */
	        H.addEvent = function(el, type, fn) {
	
	            var events = el.hcEvents = el.hcEvents || {};
	
	            function wrappedFn(e) {
	                e.target = e.srcElement || win; // #2820
	                fn.call(el, e);
	            }
	
	            // Handle DOM events in modern browsers
	            if (el.addEventListener) {
	                el.addEventListener(type, fn, false);
	
	                // Handle old IE implementation
	            } else if (el.attachEvent) {
	
	                if (!el.hcEventsIE) {
	                    el.hcEventsIE = {};
	                }
	
	                // unique function string (#6746)
	                if (!fn.hcGetKey) {
	                    fn.hcGetKey = H.uniqueKey();
	                }
	
	                // Link wrapped fn with original fn, so we can get this in removeEvent
	                el.hcEventsIE[fn.hcGetKey] = wrappedFn;
	
	                el.attachEvent('on' + type, wrappedFn);
	            }
	
	            if (!events[type]) {
	                events[type] = [];
	            }
	
	            events[type].push(fn);
	
	            // Return a function that can be called to remove this event.
	            return function() {
	                H.removeEvent(el, type, fn);
	            };
	        };
	
	        /**
	         * Remove an event that was added with {@link Highcharts#addEvent}.
	         *
	         * @function #removeEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The element to remove events on.
	         * @param {String} [type] - The type of events to remove. If undefined, all
	         *        events are removed from the element.
	         * @param {Function} [fn] - The specific callback to remove. If undefined, all
	         *        events that match the element and optionally the type are removed.
	         * 
	         */
	        H.removeEvent = function(el, type, fn) {
	
	            var events,
	                hcEvents = el.hcEvents,
	                index;
	
	            function removeOneEvent(type, fn) {
	                if (el.removeEventListener) {
	                    el.removeEventListener(type, fn, false);
	                } else if (el.attachEvent) {
	                    fn = el.hcEventsIE[fn.hcGetKey];
	                    el.detachEvent('on' + type, fn);
	                }
	            }
	
	            function removeAllEvents() {
	                var types,
	                    len;
	
	                if (!el.nodeName) {
	                    return; // break on non-DOM events
	                }
	
	                if (type) {
	                    types = {};
	                    types[type] = true;
	                } else {
	                    types = hcEvents;
	                }
	
	                H.objectEach(types, function(val, n) {
	                    if (hcEvents[n]) {
	                        len = hcEvents[n].length;
	                        while (len--) {
	                            removeOneEvent(n, hcEvents[n][len]);
	                        }
	                    }
	                });
	            }
	
	            if (hcEvents) {
	                if (type) {
	                    events = hcEvents[type] || [];
	                    if (fn) {
	                        index = H.inArray(fn, events);
	                        if (index > -1) {
	                            events.splice(index, 1);
	                            hcEvents[type] = events;
	                        }
	                        removeOneEvent(type, fn);
	
	                    } else {
	                        removeAllEvents();
	                        hcEvents[type] = [];
	                    }
	                } else {
	                    removeAllEvents();
	                    el.hcEvents = {};
	                }
	            }
	        };
	
	        /**
	         * Fire an event that was registered with {@link Highcharts#addEvent}.
	         *
	         * @function #fireEvent
	         * @memberOf Highcharts
	         * @param {Object} el - The object to fire the event on. It can be a
	         *        {@link HTMLDOMElement}, an {@link SVGElement} or any other object.
	         * @param {String} type - The type of event.
	         * @param {Object} [eventArguments] - Custom event arguments that are passed on
	         *        as an argument to the event handler.
	         * @param {Function} [defaultFunction] - The default function to execute if the 
	         *        other listeners haven't returned false.
	         * 
	         */
	        H.fireEvent = function(el, type, eventArguments, defaultFunction) {
	            var e,
	                hcEvents = el.hcEvents,
	                events,
	                len,
	                i,
	                fn;
	
	            eventArguments = eventArguments || {};
	
	            if (doc.createEvent && (el.dispatchEvent || el.fireEvent)) {
	                e = doc.createEvent('Events');
	                e.initEvent(type, true, true);
	                //e.target = el;
	
	                H.extend(e, eventArguments);
	
	                if (el.dispatchEvent) {
	                    el.dispatchEvent(e);
	                } else {
	                    el.fireEvent(type, e);
	                }
	
	            } else if (hcEvents) {
	
	                events = hcEvents[type] || [];
	                len = events.length;
	
	                if (!eventArguments.target) { // We're running a custom event
	
	                    H.extend(eventArguments, {
	                        // Attach a simple preventDefault function to skip default
	                        // handler if called. The built-in defaultPrevented property is
	                        // not overwritable (#5112)
	                        preventDefault: function() {
	                            eventArguments.defaultPrevented = true;
	                        },
	                        // Setting target to native events fails with clicking the
	                        // zoom-out button in Chrome.
	                        target: el,
	                        // If the type is not set, we're running a custom event (#2297).
	                        // If it is set, we're running a browser event, and setting it
	                        // will cause en error in IE8 (#2465).		
	                        type: type
	                    });
	                }
	
	
	                for (i = 0; i < len; i++) {
	                    fn = events[i];
	
	                    // If the event handler return false, prevent the default handler
	                    // from executing
	                    if (fn && fn.call(el, eventArguments) === false) {
	                        eventArguments.preventDefault();
	                    }
	                }
	            }
	
	            // Run the default if not prevented
	            if (defaultFunction && !eventArguments.defaultPrevented) {
	                defaultFunction(eventArguments);
	            }
	        };
	
	        /**
	         * An animation configuration. Animation configurations can also be defined as
	         * booleans, where `false` turns off animation and `true` defaults to a duration
	         * of 500ms.
	         * @typedef {Object} AnimationOptions
	         * @property {Number} duration - The animation duration in milliseconds.
	         * @property {String} [easing] - The name of an easing function as defined on
	         *     the `Math` object.
	         * @property {Function} [complete] - A callback function to exectute when the
	         *     animation finishes.
	         * @property {Function} [step] - A callback function to execute on each step of
	         *     each attribute or CSS property that's being animated. The first argument
	         *     contains information about the animation and progress.
	         */
	
	
	        /**
	         * The global animate method, which uses Fx to create individual animators.
	         *
	         * @function #animate
	         * @memberOf Highcharts
	         * @param {HTMLDOMElement|SVGElement} el - The element to animate.
	         * @param {Object} params - An object containing key-value pairs of the
	         *        properties to animate. Supports numeric as pixel-based CSS properties
	         *        for HTML objects and attributes for SVGElements.
	         * @param {AnimationOptions} [opt] - Animation options.
	         */
	        H.animate = function(el, params, opt) {
	            var start,
	                unit = '',
	                end,
	                fx,
	                args;
	
	            if (!H.isObject(opt)) { // Number or undefined/null
	                args = arguments;
	                opt = {
	                    duration: args[2],
	                    easing: args[3],
	                    complete: args[4]
	                };
	            }
	            if (!H.isNumber(opt.duration)) {
	                opt.duration = 400;
	            }
	            opt.easing = typeof opt.easing === 'function' ?
	                opt.easing :
	                (Math[opt.easing] || Math.easeInOutSine);
	            opt.curAnim = H.merge(params);
	
	            H.objectEach(params, function(val, prop) {
	                // Stop current running animation of this property
	                H.stop(el, prop);
	
	                fx = new H.Fx(el, opt, prop);
	                end = null;
	
	                if (prop === 'd') {
	                    fx.paths = fx.initPath(
	                        el,
	                        el.d,
	                        params.d
	                    );
	                    fx.toD = params.d;
	                    start = 0;
	                    end = 1;
	                } else if (el.attr) {
	                    start = el.attr(prop);
	                } else {
	                    start = parseFloat(H.getStyle(el, prop)) || 0;
	                    if (prop !== 'opacity') {
	                        unit = 'px';
	                    }
	                }
	
	                if (!end) {
	                    end = val;
	                }
	                if (end && end.match && end.match('px')) {
	                    end = end.replace(/px/g, ''); // #4351
	                }
	                fx.run(start, end, unit);
	            });
	        };
	
	        /**
	         * Factory to create new series prototypes.
	         *
	         * @function #seriesType
	         * @memberOf Highcharts
	         *
	         * @param {String} type - The series type name.
	         * @param {String} parent - The parent series type name. Use `line` to inherit
	         *        from the basic {@link Series} object.
	         * @param {Object} options - The additional default options that is merged with
	         *        the parent's options.
	         * @param {Object} props - The properties (functions and primitives) to set on
	         *        the new prototype.
	         * @param {Object} [pointProps] - Members for a series-specific extension of the
	         *        {@link Point} prototype if needed.
	         * @returns {*} - The newly created prototype as extended from {@link Series}
	         * or its derivatives.
	         */
	        // docs: add to API + extending Highcharts
	        H.seriesType = function(type, parent, options, props, pointProps) {
	            var defaultOptions = H.getOptions(),
	                seriesTypes = H.seriesTypes;
	
	            // Merge the options
	            defaultOptions.plotOptions[type] = H.merge(
	                defaultOptions.plotOptions[parent],
	                options
	            );
	
	            // Create the class
	            seriesTypes[type] = H.extendClass(seriesTypes[parent] ||
	                function() {}, props);
	            seriesTypes[type].prototype.type = type;
	
	            // Create the point class if needed
	            if (pointProps) {
	                seriesTypes[type].prototype.pointClass =
	                    H.extendClass(H.Point, pointProps);
	            }
	
	            return seriesTypes[type];
	        };
	
	        /**
	         * Get a unique key for using in internal element id's and pointers. The key
	         * is composed of a random hash specific to this Highcharts instance, and a 
	         * counter.
	         * @function #uniqueKey
	         * @memberOf Highcharts
	         * @return {string} The key.
	         * @example
	         * var id = H.uniqueKey(); // => 'highcharts-x45f6hp-0'
	         */
	        H.uniqueKey = (function() {
	
	            var uniqueKeyHash = Math.random().toString(36).substring(2, 9),
	                idCounter = 0;
	
	            return function() {
	                return 'highcharts-' + uniqueKeyHash + '-' + idCounter++;
	            };
	        }());
	
	        /**
	         * Register Highcharts as a plugin in jQuery
	         */
	        if (win.jQuery) {
	            win.jQuery.fn.highcharts = function() {
	                var args = [].slice.call(arguments);
	
	                if (this[0]) { // this[0] is the renderTo div
	
	                    // Create the chart
	                    if (args[0]) {
	                        new H[ // eslint-disable-line no-new
	                            // Constructor defaults to Chart
	                            H.isString(args[0]) ? args.shift() : 'Chart'
	                        ](this[0], args[0], args[1]);
	                        return this;
	                    }
	
	                    // When called without parameters or with the return argument,
	                    // return an existing chart
	                    return charts[H.attr(this[0], 'data-highcharts-chart')];
	                }
	            };
	        }
	
	
	        /**
	         * Compatibility section to add support for legacy IE. This can be removed if
	         * old IE support is not needed.
	         */
	        if (doc && !doc.defaultView) {
	            H.getStyle = function(el, prop) {
	                var val,
	                    alias = {
	                        width: 'clientWidth',
	                        height: 'clientHeight'
	                    }[prop];
	
	                if (el.style[prop]) {
	                    return H.pInt(el.style[prop]);
	                }
	                if (prop === 'opacity') {
	                    prop = 'filter';
	                }
	
	                // Getting the rendered width and height
	                if (alias) {
	                    el.style.zoom = 1;
	                    return Math.max(el[alias] - 2 * H.getStyle(el, 'padding'), 0);
	                }
	
	                val = el.currentStyle[prop.replace(/\-(\w)/g, function(a, b) {
	                    return b.toUpperCase();
	                })];
	                if (prop === 'filter') {
	                    val = val.replace(
	                        /alpha\(opacity=([0-9]+)\)/,
	                        function(a, b) {
	                            return b / 100;
	                        }
	                    );
	                }
	
	                return val === '' ? 1 : H.pInt(val);
	            };
	        }
	
	        if (!Array.prototype.forEach) {
	            H.each = function(arr, fn, ctx) { // legacy
	                var i = 0,
	                    len = arr.length;
	                for (; i < len; i++) {
	                    if (fn.call(ctx, arr[i], i, arr) === false) {
	                        return i;
	                    }
	                }
	            };
	        }
	
	        if (!Array.prototype.indexOf) {
	            H.inArray = function(item, arr) {
	                var len,
	                    i = 0;
	
	                if (arr) {
	                    len = arr.length;
	
	                    for (; i < len; i++) {
	                        if (arr[i] === item) {
	                            return i;
	                        }
	                    }
	                }
	
	                return -1;
	            };
	        }
	
	        if (!Array.prototype.filter) {
	            H.grep = function(elements, fn) {
	                var ret = [],
	                    i = 0,
	                    length = elements.length;
	
	                for (; i < length; i++) {
	                    if (fn(elements[i], i)) {
	                        ret.push(elements[i]);
	                    }
	                }
	
	                return ret;
	            };
	        }
	
	        if (!Array.prototype.find) {
	            H.find = function(arr, fn) {
	                var i,
	                    length = arr.length;
	
	                for (i = 0; i < length; i++) {
	                    if (fn(arr[i], i)) {
	                        return arr[i];
	                    }
	                }
	            };
	        }
	
	        //--- End compatibility section ---
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var each = H.each,
	            isNumber = H.isNumber,
	            map = H.map,
	            merge = H.merge,
	            pInt = H.pInt;
	
	        /**
	         * @typedef {string} ColorString
	         * A valid color to be parsed and handled by Highcharts. Highcharts internally 
	         * supports hex colors like `#ffffff`, rgb colors like `rgb(255,255,255)` and
	         * rgba colors like `rgba(255,255,255,1)`. Other colors may be supported by the
	         * browsers and displayed correctly, but Highcharts is not able to process them
	         * and apply concepts like opacity and brightening.
	         */
	        /**
	         * Handle color operations. The object methods are chainable.
	         * @param {String} input The input color in either rbga or hex format
	         */
	        H.Color = function(input) {
	            // Backwards compatibility, allow instanciation without new
	            if (!(this instanceof H.Color)) {
	                return new H.Color(input);
	            }
	            // Initialize
	            this.init(input);
	        };
	        H.Color.prototype = {
	
	            // Collection of parsers. This can be extended from the outside by pushing parsers
	            // to Highcharts.Color.prototype.parsers.
	            parsers: [{
	                // RGBA color
	                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
	                parse: function(result) {
	                    return [pInt(result[1]), pInt(result[2]), pInt(result[3]), parseFloat(result[4], 10)];
	                }
	            }, {
	                // RGB color
	                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
	                parse: function(result) {
	                    return [pInt(result[1]), pInt(result[2]), pInt(result[3]), 1];
	                }
	            }],
	
	            // Collection of named colors. Can be extended from the outside by adding
	            // colors to Highcharts.Color.prototype.names.
	            names: {
	                none: 'rgba(255,255,255,0)',
	                white: '#ffffff',
	                black: '#000000'
	            },
	
	            /**
	             * Parse the input color to rgba array
	             * @param {String} input
	             */
	            init: function(input) {
	                var result,
	                    rgba,
	                    i,
	                    parser,
	                    len;
	
	                this.input = input = this.names[
	                    input && input.toLowerCase ?
	                    input.toLowerCase() :
	                    ''
	                ] || input;
	
	                // Gradients
	                if (input && input.stops) {
	                    this.stops = map(input.stops, function(stop) {
	                        return new H.Color(stop[1]);
	                    });
	
	                    // Solid colors
	                } else {
	
	                    // Bitmasking as input[0] is not working for legacy IE.
	                    if (input && input.charAt() === '#') {
	
	                        len = input.length;
	                        input = parseInt(input.substr(1), 16);
	
	                        // Handle long-form, e.g. #AABBCC
	                        if (len === 7) {
	
	                            rgba = [
	                                (input & 0xFF0000) >> 16,
	                                (input & 0xFF00) >> 8,
	                                (input & 0xFF),
	                                1
	                            ];
	
	                            // Handle short-form, e.g. #ABC
	                            // In short form, the value is assumed to be the same 
	                            // for both nibbles for each component. e.g. #ABC = #AABBCC
	                        } else if (len === 4) {
	
	                            rgba = [
	                                ((input & 0xF00) >> 4) | (input & 0xF00) >> 8,
	                                ((input & 0xF0) >> 4) | (input & 0xF0),
	                                ((input & 0xF) << 4) | (input & 0xF),
	                                1
	                            ];
	                        }
	                    }
	
	                    // Otherwise, check regex parsers
	                    if (!rgba) {
	                        i = this.parsers.length;
	                        while (i-- && !rgba) {
	                            parser = this.parsers[i];
	                            result = parser.regex.exec(input);
	                            if (result) {
	                                rgba = parser.parse(result);
	                            }
	                        }
	                    }
	                }
	                this.rgba = rgba || [];
	            },
	
	            /**
	             * Return the color a specified format
	             * @param {String} format
	             */
	            get: function(format) {
	                var input = this.input,
	                    rgba = this.rgba,
	                    ret;
	
	                if (this.stops) {
	                    ret = merge(input);
	                    ret.stops = [].concat(ret.stops);
	                    each(this.stops, function(stop, i) {
	                        ret.stops[i] = [ret.stops[i][0], stop.get(format)];
	                    });
	
	                    // it's NaN if gradient colors on a column chart
	                } else if (rgba && isNumber(rgba[0])) {
	                    if (format === 'rgb' || (!format && rgba[3] === 1)) {
	                        ret = 'rgb(' + rgba[0] + ',' + rgba[1] + ',' + rgba[2] + ')';
	                    } else if (format === 'a') {
	                        ret = rgba[3];
	                    } else {
	                        ret = 'rgba(' + rgba.join(',') + ')';
	                    }
	                } else {
	                    ret = input;
	                }
	                return ret;
	            },
	
	            /**
	             * Brighten the color
	             * @param {Number} alpha
	             */
	            brighten: function(alpha) {
	                var i,
	                    rgba = this.rgba;
	
	                if (this.stops) {
	                    each(this.stops, function(stop) {
	                        stop.brighten(alpha);
	                    });
	
	                } else if (isNumber(alpha) && alpha !== 0) {
	                    for (i = 0; i < 3; i++) {
	                        rgba[i] += pInt(alpha * 255);
	
	                        if (rgba[i] < 0) {
	                            rgba[i] = 0;
	                        }
	                        if (rgba[i] > 255) {
	                            rgba[i] = 255;
	                        }
	                    }
	                }
	                return this;
	            },
	
	            /**
	             * Set the color's opacity to a given alpha value
	             * @param {Number} alpha
	             */
	            setOpacity: function(alpha) {
	                this.rgba[3] = alpha;
	                return this;
	            },
	
	            /*
	             * Return an intermediate color between two colors.
	             *
	             * @param  {Highcharts.Color} to
	             *         The color object to tween to.
	             * @param  {Number} pos
	             *         The intermediate position, where 0 is the from color (current
	             *         color item), and 1 is the `to` color.
	             *
	             * @return {String}
	             *         The intermediate color in rgba notation.
	             */
	            tweenTo: function(to, pos) {
	                // Check for has alpha, because rgba colors perform worse due to lack of
	                // support in WebKit.
	                var from = this,
	                    hasAlpha,
	                    ret;
	
	                // Unsupported color, return to-color (#3920)
	                if (!to.rgba.length) {
	                    ret = to.input || 'none';
	
	                    // Interpolate
	                } else {
	                    from = from.rgba;
	                    to = to.rgba;
	                    hasAlpha = (to[3] !== 1 || from[3] !== 1);
	                    ret = (hasAlpha ? 'rgba(' : 'rgb(') +
	                        Math.round(to[0] + (from[0] - to[0]) * (1 - pos)) + ',' +
	                        Math.round(to[1] + (from[1] - to[1]) * (1 - pos)) + ',' +
	                        Math.round(to[2] + (from[2] - to[2]) * (1 - pos)) +
	                        (hasAlpha ?
	                            (',' + (to[3] + (from[3] - to[3]) * (1 - pos))) :
	                            '') + ')';
	                }
	                return ret;
	            }
	        };
	        H.color = function(input) {
	            return new H.Color(input);
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var SVGElement,
	            SVGRenderer,
	
	            addEvent = H.addEvent,
	            animate = H.animate,
	            attr = H.attr,
	            charts = H.charts,
	            color = H.color,
	            css = H.css,
	            createElement = H.createElement,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            destroyObjectProperties = H.destroyObjectProperties,
	            doc = H.doc,
	            each = H.each,
	            extend = H.extend,
	            erase = H.erase,
	            grep = H.grep,
	            hasTouch = H.hasTouch,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isFirefox = H.isFirefox,
	            isMS = H.isMS,
	            isObject = H.isObject,
	            isString = H.isString,
	            isWebKit = H.isWebKit,
	            merge = H.merge,
	            noop = H.noop,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            pInt = H.pInt,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            stop = H.stop,
	            svg = H.svg,
	            SVG_NS = H.SVG_NS,
	            symbolSizes = H.symbolSizes,
	            win = H.win;
	
	        /**
	         * @typedef {Object} SVGDOMElement - An SVG DOM element.
	         */
	        /**
	         * The SVGElement prototype is a JavaScript wrapper for SVG elements used in the
	         * rendering layer of Highcharts. Combined with the {@link
	         * Highcharts.SVGRenderer} object, these prototypes allow freeform annotation
	         * in the charts or even in HTML pages without instanciating a chart. The
	         * SVGElement can also wrap HTML labels, when `text` or `label` elements are
	         * created with the `useHTML` parameter.
	         *
	         * The SVGElement instances are created through factory functions on the 
	         * {@link Highcharts.SVGRenderer} object, like
	         * [rect]{@link Highcharts.SVGRenderer#rect}, [path]{@link
	         * Highcharts.SVGRenderer#path}, [text]{@link Highcharts.SVGRenderer#text},
	         * [label]{@link Highcharts.SVGRenderer#label}, [g]{@link
	         * Highcharts.SVGRenderer#g} and more.
	         *
	         * @class Highcharts.SVGElement
	         */
	        SVGElement = H.SVGElement = function() {
	            return this;
	        };
	        extend(SVGElement.prototype, /** @lends Highcharts.SVGElement.prototype */ {
	
	            // Default base for animation
	            opacity: 1,
	            SVG_NS: SVG_NS,
	
	            /**
	             * For labels, these CSS properties are applied to the `text` node directly.
	             *
	             * @private
	             * @type {Array.<string>}
	             */
	            textProps: ['direction', 'fontSize', 'fontWeight', 'fontFamily',
	                'fontStyle', 'color', 'lineHeight', 'width', 'textAlign',
	                'textDecoration', 'textOverflow', 'textOutline'
	            ],
	
	            /**
	             * Initialize the SVG renderer. This function only exists to make the
	             * initiation process overridable. It should not be called directly.
	             *
	             * @param  {SVGRenderer} renderer
	             *         The SVGRenderer instance to initialize to.
	             * @param  {String} nodeName
	             *         The SVG node name.
	             * 
	             */
	            init: function(renderer, nodeName) {
	
	                /** 
	                 * The primary DOM node. Each `SVGElement` instance wraps a main DOM
	                 * node, but may also represent more nodes.
	                 *
	                 * @name  element
	                 * @memberOf SVGElement
	                 * @type {SVGDOMNode|HTMLDOMNode}
	                 */
	                this.element = nodeName === 'span' ?
	                    createElement(nodeName) :
	                    doc.createElementNS(this.SVG_NS, nodeName);
	
	                /**
	                 * The renderer that the SVGElement belongs to.
	                 *
	                 * @name renderer
	                 * @memberOf SVGElement
	                 * @type {SVGRenderer}
	                 */
	                this.renderer = renderer;
	            },
	
	            /**
	             * Animate to given attributes or CSS properties.
	             * 
	             * @param {SVGAttributes} params SVG attributes or CSS to animate.
	             * @param {AnimationOptions} [options] Animation options.
	             * @param {Function} [complete] Function to perform at the end of animation.
	             *
	             * @sample highcharts/members/element-on/
	             *         Setting some attributes by animation
	             * 
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            animate: function(params, options, complete) {
	                var animOptions = H.animObject(
	                    pick(options, this.renderer.globalAnimation, true)
	                );
	                if (animOptions.duration !== 0) {
	                    // allows using a callback with the global animation without
	                    // overwriting it
	                    if (complete) {
	                        animOptions.complete = complete;
	                    }
	                    animate(this, params, animOptions);
	                } else {
	                    this.attr(params, null, complete);
	                    if (animOptions.step) {
	                        animOptions.step.call(this);
	                    }
	                }
	                return this;
	            },
	
	            /**
	             * @typedef {Object} GradientOptions
	             * @property {Object} linearGradient Holds an object that defines the start
	             *    position and the end position relative to the shape.
	             * @property {Number} linearGradient.x1 Start horizontal position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.x2 End horizontal position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.y1 Start vertical position of the
	             *    gradient. Ranges 0-1.
	             * @property {Number} linearGradient.y2 End vertical position of the
	             *    gradient. Ranges 0-1.
	             * @property {Object} radialGradient Holds an object that defines the center
	             *    position and the radius.
	             * @property {Number} radialGradient.cx Center horizontal position relative
	             *    to the shape. Ranges 0-1.
	             * @property {Number} radialGradient.cy Center vertical position relative
	             *    to the shape. Ranges 0-1.
	             * @property {Number} radialGradient.r Radius relative to the shape. Ranges
	             *    0-1.
	             * @property {Array.<Array>} stops The first item in each tuple is the
	             *    position in the gradient, where 0 is the start of the gradient and 1
	             *    is the end of the gradient. Multiple stops can be applied. The second
	             *    item is the color for each stop. This color can also be given in the
	             *    rgba format.
	             *
	             * @example
	             * // Linear gradient used as a color option
	             * color: {
	             *     linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
	             *         stops: [
	             *             [0, '#003399'], // start
	             *             [0.5, '#ffffff'], // middle
	             *             [1, '#3366AA'] // end
	             *         ]
	             *     }
	             * }
	             */
	            /**
	             * Build and apply an SVG gradient out of a common JavaScript configuration
	             * object. This function is called from the attribute setters.
	             *
	             * @private
	             * @param {GradientOptions} color The gradient options structure.
	             * @param {string} prop The property to apply, can either be `fill` or
	             * `stroke`. 
	             * @param {SVGDOMElement} elem SVG DOM element to apply the gradient on.
	             */
	            colorGradient: function(color, prop, elem) {
	                var renderer = this.renderer,
	                    colorObject,
	                    gradName,
	                    gradAttr,
	                    radAttr,
	                    gradients,
	                    gradientObject,
	                    stops,
	                    stopColor,
	                    stopOpacity,
	                    radialReference,
	                    id,
	                    key = [],
	                    value;
	
	                // Apply linear or radial gradients
	                if (color.radialGradient) {
	                    gradName = 'radialGradient';
	                } else if (color.linearGradient) {
	                    gradName = 'linearGradient';
	                }
	
	                if (gradName) {
	                    gradAttr = color[gradName];
	                    gradients = renderer.gradients;
	                    stops = color.stops;
	                    radialReference = elem.radialReference;
	
	                    // Keep < 2.2 kompatibility
	                    if (isArray(gradAttr)) {
	                        color[gradName] = gradAttr = {
	                            x1: gradAttr[0],
	                            y1: gradAttr[1],
	                            x2: gradAttr[2],
	                            y2: gradAttr[3],
	                            gradientUnits: 'userSpaceOnUse'
	                        };
	                    }
	
	                    // Correct the radial gradient for the radial reference system
	                    if (
	                        gradName === 'radialGradient' &&
	                        radialReference &&
	                        !defined(gradAttr.gradientUnits)
	                    ) {
	                        radAttr = gradAttr; // Save the radial attributes for updating
	                        gradAttr = merge(
	                            gradAttr,
	                            renderer.getRadialAttr(radialReference, radAttr), {
	                                gradientUnits: 'userSpaceOnUse'
	                            }
	                        );
	                    }
	
	                    // Build the unique key to detect whether we need to create a new
	                    // element (#1282)
	                    objectEach(gradAttr, function(val, n) {
	                        if (n !== 'id') {
	                            key.push(n, val);
	                        }
	                    });
	                    objectEach(stops, function(val) {
	                        key.push(val);
	                    });
	                    key = key.join(',');
	
	                    // Check if a gradient object with the same config object is created
	                    // within this renderer
	                    if (gradients[key]) {
	                        id = gradients[key].attr('id');
	
	                    } else {
	
	                        // Set the id and create the element
	                        gradAttr.id = id = H.uniqueKey();
	                        gradients[key] = gradientObject =
	                            renderer.createElement(gradName)
	                            .attr(gradAttr)
	                            .add(renderer.defs);
	
	                        gradientObject.radAttr = radAttr;
	
	                        // The gradient needs to keep a list of stops to be able to
	                        // destroy them
	                        gradientObject.stops = [];
	                        each(stops, function(stop) {
	                            var stopObject;
	                            if (stop[1].indexOf('rgba') === 0) {
	                                colorObject = H.color(stop[1]);
	                                stopColor = colorObject.get('rgb');
	                                stopOpacity = colorObject.get('a');
	                            } else {
	                                stopColor = stop[1];
	                                stopOpacity = 1;
	                            }
	                            stopObject = renderer.createElement('stop').attr({
	                                offset: stop[0],
	                                'stop-color': stopColor,
	                                'stop-opacity': stopOpacity
	                            }).add(gradientObject);
	
	                            // Add the stop element to the gradient
	                            gradientObject.stops.push(stopObject);
	                        });
	                    }
	
	                    // Set the reference to the gradient object
	                    value = 'url(' + renderer.url + '#' + id + ')';
	                    elem.setAttribute(prop, value);
	                    elem.gradient = key;
	
	                    // Allow the color to be concatenated into tooltips formatters etc.
	                    // (#2995)
	                    color.toString = function() {
	                        return value;
	                    };
	                }
	            },
	
	            /**
	             * Apply a text outline through a custom CSS property, by copying the text
	             * element and apply stroke to the copy. Used internally. Contrast checks
	             * at http://jsfiddle.net/highcharts/43soe9m1/2/ .
	             *
	             * @private
	             * @param {String} textOutline A custom CSS `text-outline` setting, defined
	             *    by `width color`. 
	             * @example
	             * // Specific color
	             * text.css({
	             *    textOutline: '1px black'
	             * });
	             * // Automatic contrast
	             * text.css({
	             *    color: '#000000', // black text
	             *    textOutline: '1px contrast' // => white outline
	             * });
	             */
	            applyTextOutline: function(textOutline) {
	                var elem = this.element,
	                    tspans,
	                    tspan,
	                    hasContrast = textOutline.indexOf('contrast') !== -1,
	                    styles = {},
	                    color,
	                    strokeWidth,
	                    firstRealChild,
	                    i;
	
	                // When the text shadow is set to contrast, use dark stroke for light
	                // text and vice versa.
	                if (hasContrast) {
	                    styles.textOutline = textOutline = textOutline.replace(
	                        /contrast/g,
	                        this.renderer.getContrast(elem.style.fill)
	                    );
	                }
	
	                // Extract the stroke width and color
	                textOutline = textOutline.split(' ');
	                color = textOutline[textOutline.length - 1];
	                strokeWidth = textOutline[0];
	
	                if (strokeWidth && strokeWidth !== 'none' && H.svg) {
	
	                    this.fakeTS = true; // Fake text shadow
	
	                    tspans = [].slice.call(elem.getElementsByTagName('tspan'));
	
	                    // In order to get the right y position of the clone,
	                    // copy over the y setter
	                    this.ySetter = this.xSetter;
	
	                    // Since the stroke is applied on center of the actual outline, we
	                    // need to double it to get the correct stroke-width outside the 
	                    // glyphs.
	                    strokeWidth = strokeWidth.replace(
	                        /(^[\d\.]+)(.*?)$/g,
	                        function(match, digit, unit) {
	                            return (2 * digit) + unit;
	                        }
	                    );
	
	                    // Remove shadows from previous runs. Iterate from the end to
	                    // support removing items inside the cycle (#6472).
	                    i = tspans.length;
	                    while (i--) {
	                        tspan = tspans[i];
	                        if (tspan.getAttribute('class') === 'highcharts-text-outline') {
	                            // Remove then erase
	                            erase(tspans, elem.removeChild(tspan));
	                        }
	                    }
	
	                    // For each of the tspans, create a stroked copy behind it.
	                    firstRealChild = elem.firstChild;
	                    each(tspans, function(tspan, y) {
	                        var clone;
	
	                        // Let the first line start at the correct X position
	                        if (y === 0) {
	                            tspan.setAttribute('x', elem.getAttribute('x'));
	                            y = elem.getAttribute('y');
	                            tspan.setAttribute('y', y || 0);
	                            if (y === null) {
	                                elem.setAttribute('y', 0);
	                            }
	                        }
	
	                        // Create the clone and apply outline properties
	                        clone = tspan.cloneNode(1);
	                        attr(clone, {
	                            'class': 'highcharts-text-outline',
	                            'fill': color,
	                            'stroke': color,
	                            'stroke-width': strokeWidth,
	                            'stroke-linejoin': 'round'
	                        });
	                        elem.insertBefore(clone, firstRealChild);
	                    });
	                }
	            },
	
	            /**
	             *
	             * @typedef {Object} SVGAttributes An object of key-value pairs for SVG
	             *   attributes. Attributes in Highcharts elements for the most parts
	             *   correspond to SVG, but some are specific to Highcharts, like `zIndex`,
	             *   `rotation`, `translateX`, `translateY`, `scaleX` and `scaleY`. SVG
	             *   attributes containing a hyphen are _not_ camel-cased, they should be
	             *   quoted to preserve the hyphen.
	             * @example
	             * {
	             *     'stroke': '#ff0000', // basic
	             *     'stroke-width': 2, // hyphenated
	             *     'rotation': 45 // custom
	             *     'd': ['M', 10, 10, 'L', 30, 30, 'z'] // path definition, note format
	             * }
	             */
	            /**
	             * Apply native and custom attributes to the SVG elements.
	             * 
	             * In order to set the rotation center for rotation, set x and y to 0 and
	             * use `translateX` and `translateY` attributes to position the element
	             * instead.
	             *
	             * Attributes frequently used in Highcharts are `fill`, `stroke`,
	             * `stroke-width`.
	             *
	             * @param {SVGAttributes|String} hash - The native and custom SVG
	             *    attributes. 
	             * @param {string} [val] - If the type of the first argument is `string`, 
	             *    the second can be a value, which will serve as a single attribute
	             *    setter. If the first argument is a string and the second is undefined,
	             *    the function serves as a getter and the current value of the property
	             *    is returned.
	             * @param {Function} [complete] - A callback function to execute after
	             *    setting the attributes. This makes the function compliant and
	             *    interchangeable with the {@link SVGElement#animate} function.
	             * @param {boolean} [continueAnimation=true] Used internally when `.attr` is
	             *    called as part of an animation step. Otherwise, calling `.attr` for an
	             *    attribute will stop animation for that attribute.
	             *    
	             * @returns {SVGElement|string|number} If used as a setter, it returns the 
	             *    current {@link SVGElement} so the calls can be chained. If used as a 
	             *    getter, the current value of the attribute is returned.
	             *
	             * @sample highcharts/members/renderer-rect/
	             *         Setting some attributes
	             * 
	             * @example
	             * // Set multiple attributes
	             * element.attr({
	             *     stroke: 'red',
	             *     fill: 'blue',
	             *     x: 10,
	             *     y: 10
	             * });
	             *
	             * // Set a single attribute
	             * element.attr('stroke', 'red');
	             *
	             * // Get an attribute
	             * element.attr('stroke'); // => 'red'
	             * 
	             */
	            attr: function(hash, val, complete, continueAnimation) {
	                var key,
	                    element = this.element,
	                    hasSetSymbolSize,
	                    ret = this,
	                    skipAttr,
	                    setter;
	
	                // single key-value pair
	                if (typeof hash === 'string' && val !== undefined) {
	                    key = hash;
	                    hash = {};
	                    hash[key] = val;
	                }
	
	                // used as a getter: first argument is a string, second is undefined
	                if (typeof hash === 'string') {
	                    ret = (this[hash + 'Getter'] || this._defaultGetter).call(
	                        this,
	                        hash,
	                        element
	                    );
	
	                    // setter
	                } else {
	
	                    objectEach(hash, function(val, key) {
	                        skipAttr = false;
	
	                        // Unless .attr is from the animator update, stop current
	                        // running animation of this property
	                        if (!continueAnimation) {
	                            stop(this, key);
	                        }
	
	                        // Special handling of symbol attributes
	                        if (
	                            this.symbolName &&
	                            /^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/
	                            .test(key)
	                        ) {
	                            if (!hasSetSymbolSize) {
	                                this.symbolAttr(hash);
	                                hasSetSymbolSize = true;
	                            }
	                            skipAttr = true;
	                        }
	
	                        if (this.rotation && (key === 'x' || key === 'y')) {
	                            this.doTransform = true;
	                        }
	
	                        if (!skipAttr) {
	                            setter = this[key + 'Setter'] || this._defaultSetter;
	                            setter.call(this, val, key, element);
	
	
	                            // Let the shadow follow the main element
	                            if (
	                                this.shadows &&
	                                /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/
	                                .test(key)
	                            ) {
	                                this.updateShadows(key, val, setter);
	                            }
	
	                        }
	                    }, this);
	
	                    this.afterSetters();
	                }
	
	                // In accordance with animate, run a complete callback
	                if (complete) {
	                    complete();
	                }
	
	                return ret;
	            },
	
	            /**
	             * This method is executed in the end of `attr()`, after setting all
	             * attributes in the hash. In can be used to efficiently consolidate
	             * multiple attributes in one SVG property -- e.g., translate, rotate and
	             * scale are merged in one "transform" attribute in the SVG node.
	             *
	             * @private
	             */
	            afterSetters: function() {
	                // Update transform. Do this outside the loop to prevent redundant
	                // updating for batch setting of attributes.
	                if (this.doTransform) {
	                    this.updateTransform();
	                    this.doTransform = false;
	                }
	            },
	
	
	            /**
	             * Update the shadow elements with new attributes.
	             *
	             * @private
	             * @param {String} key - The attribute name.
	             * @param {String|Number} value - The value of the attribute.
	             * @param {Function} setter - The setter function, inherited from the
	             *   parent wrapper
	             * 
	             */
	            updateShadows: function(key, value, setter) {
	                var shadows = this.shadows,
	                    i = shadows.length;
	
	                while (i--) {
	                    setter.call(
	                        shadows[i],
	                        key === 'height' ?
	                        Math.max(value - (shadows[i].cutHeight || 0), 0) :
	                        key === 'd' ? this.d : value,
	                        key,
	                        shadows[i]
	                    );
	                }
	            },
	
	
	            /**
	             * Add a class name to an element.
	             *
	             * @param {string} className - The new class name to add.
	             * @param {boolean} [replace=false] - When true, the existing class name(s)
	             *    will be overwritten with the new one. When false, the new one is
	             *    added.
	             * @returns {SVGElement} Return the SVG element for chainability.
	             */
	            addClass: function(className, replace) {
	                var currentClassName = this.attr('class') || '';
	                if (currentClassName.indexOf(className) === -1) {
	                    if (!replace) {
	                        className =
	                            (currentClassName + (currentClassName ? ' ' : '') +
	                                className).replace('  ', ' ');
	                    }
	                    this.attr('class', className);
	                }
	
	                return this;
	            },
	
	            /**
	             * Check if an element has the given class name.
	             * @param  {string} className
	             *         The class name to check for.
	             * @return {Boolean}
	             *         Whether the class name is found.
	             */
	            hasClass: function(className) {
	                return inArray(
	                    className,
	                    (this.attr('class') || '').split(' ')
	                ) !== -1;
	            },
	
	            /**
	             * Remove a class name from the element.
	             * @param  {string} className The class name to remove.
	             * @return {SVGElement} Returns the SVG element for chainability.
	             */
	            removeClass: function(className) {
	                return this.attr(
	                    'class',
	                    (this.attr('class') || '').replace(className, '')
	                );
	            },
	
	            /**
	             * If one of the symbol size affecting parameters are changed,
	             * check all the others only once for each call to an element's
	             * .attr() method
	             * @param {Object} hash - The attributes to set.
	             * @private
	             */
	            symbolAttr: function(hash) {
	                var wrapper = this;
	
	                each([
	                    'x',
	                    'y',
	                    'r',
	                    'start',
	                    'end',
	                    'width',
	                    'height',
	                    'innerR',
	                    'anchorX',
	                    'anchorY'
	                ], function(key) {
	                    wrapper[key] = pick(hash[key], wrapper[key]);
	                });
	
	                wrapper.attr({
	                    d: wrapper.renderer.symbols[wrapper.symbolName](
	                        wrapper.x,
	                        wrapper.y,
	                        wrapper.width,
	                        wrapper.height,
	                        wrapper
	                    )
	                });
	            },
	
	            /**
	             * Apply a clipping rectangle to this element.
	             * 
	             * @param {ClipRect} [clipRect] - The clipping rectangle. If skipped, the
	             *    current clip is removed.
	             * @returns {SVGElement} Returns the SVG element to allow chaining.
	             */
	            clip: function(clipRect) {
	                return this.attr(
	                    'clip-path',
	                    clipRect ?
	                    'url(' + this.renderer.url + '#' + clipRect.id + ')' :
	                    'none'
	                );
	            },
	
	            /**
	             * Calculate the coordinates needed for drawing a rectangle crisply and
	             * return the calculated attributes.
	             * 
	             * @param {Object} rect - A rectangle.
	             * @param {number} rect.x - The x position.
	             * @param {number} rect.y - The y position.
	             * @param {number} rect.width - The width.
	             * @param {number} rect.height - The height.
	             * @param {number} [strokeWidth] - The stroke width to consider when
	             *    computing crisp positioning. It can also be set directly on the rect
	             *    parameter.
	             *
	             * @returns {{x: Number, y: Number, width: Number, height: Number}} The
	             *    modified rectangle arguments.
	             */
	            crisp: function(rect, strokeWidth) {
	
	                var wrapper = this,
	                    attribs = {},
	                    normalizer;
	
	                strokeWidth = strokeWidth || rect.strokeWidth || 0;
	                // Math.round because strokeWidth can sometimes have roundoff errors
	                normalizer = Math.round(strokeWidth) % 2 / 2;
	
	                // normalize for crisp edges
	                rect.x = Math.floor(rect.x || wrapper.x || 0) + normalizer;
	                rect.y = Math.floor(rect.y || wrapper.y || 0) + normalizer;
	                rect.width = Math.floor(
	                    (rect.width || wrapper.width || 0) - 2 * normalizer
	                );
	                rect.height = Math.floor(
	                    (rect.height || wrapper.height || 0) - 2 * normalizer
	                );
	                if (defined(rect.strokeWidth)) {
	                    rect.strokeWidth = strokeWidth;
	                }
	
	                objectEach(rect, function(val, key) {
	                    if (wrapper[key] !== val) { // only set attribute if changed
	                        wrapper[key] = attribs[key] = val;
	                    }
	                });
	
	                return attribs;
	            },
	
	            /**
	             * Set styles for the element. In addition to CSS styles supported by 
	             * native SVG and HTML elements, there are also some custom made for 
	             * Highcharts, like `width`, `ellipsis` and `textOverflow` for SVG text
	             * elements.
	             * @param {CSSObject} styles The new CSS styles.
	             * @returns {SVGElement} Return the SVG element for chaining.
	             *
	             * @sample highcharts/members/renderer-text-on-chart/
	             *         Styled text
	             */
	            css: function(styles) {
	                var oldStyles = this.styles,
	                    newStyles = {},
	                    elem = this.element,
	                    textWidth,
	                    serializedCss = '',
	                    hyphenate,
	                    hasNew = !oldStyles,
	                    // These CSS properties are interpreted internally by the SVG
	                    // renderer, but are not supported by SVG and should not be added to
	                    // the DOM. In styled mode, no CSS should find its way to the DOM
	                    // whatsoever (#6173, #6474).
	                    svgPseudoProps = ['textOutline', 'textOverflow', 'width'];
	
	                // convert legacy
	                if (styles && styles.color) {
	                    styles.fill = styles.color;
	                }
	
	                // Filter out existing styles to increase performance (#2640)
	                if (oldStyles) {
	                    objectEach(styles, function(style, n) {
	                        if (style !== oldStyles[n]) {
	                            newStyles[n] = style;
	                            hasNew = true;
	                        }
	                    });
	                }
	                if (hasNew) {
	
	                    // Merge the new styles with the old ones
	                    if (oldStyles) {
	                        styles = extend(
	                            oldStyles,
	                            newStyles
	                        );
	                    }
	
	                    // Get the text width from style
	                    textWidth = this.textWidth = (
	                        styles &&
	                        styles.width &&
	                        styles.width !== 'auto' &&
	                        elem.nodeName.toLowerCase() === 'text' &&
	                        pInt(styles.width)
	                    );
	
	                    // store object
	                    this.styles = styles;
	
	                    if (textWidth && (!svg && this.renderer.forExport)) {
	                        delete styles.width;
	                    }
	
	                    // serialize and set style attribute
	                    if (isMS && !svg) {
	                        css(this.element, styles);
	                    } else {
	                        hyphenate = function(a, b) {
	                            return '-' + b.toLowerCase();
	                        };
	                        objectEach(styles, function(style, n) {
	                            if (inArray(n, svgPseudoProps) === -1) {
	                                serializedCss +=
	                                    n.replace(/([A-Z])/g, hyphenate) + ':' +
	                                    style + ';';
	                            }
	                        });
	                        if (serializedCss) {
	                            attr(elem, 'style', serializedCss); // #1881
	                        }
	                    }
	
	
	                    if (this.added) {
	
	                        // Rebuild text after added. Cache mechanisms in the buildText
	                        // will prevent building if there are no significant changes.
	                        if (this.element.nodeName === 'text') {
	                            this.renderer.buildText(this);
	                        }
	
	                        // Apply text outline after added
	                        if (styles && styles.textOutline) {
	                            this.applyTextOutline(styles.textOutline);
	                        }
	                    }
	                }
	
	                return this;
	            },
	
	
	            /**
	             * Get the current stroke width. In classic mode, the setter registers it 
	             * directly on the element.
	             * @returns {number} The stroke width in pixels.
	             * @ignore
	             */
	            strokeWidth: function() {
	                return this['stroke-width'] || 0;
	            },
	
	
	            /**
	             * Add an event listener. This is a simple setter that replaces all other
	             * events of the same type, opposed to the {@link Highcharts#addEvent}
	             * function.
	             * @param {string} eventType - The event type. If the type is `click`, 
	             *    Highcharts will internally translate it to a `touchstart` event on 
	             *    touch devices, to prevent the browser from waiting for a click event
	             *    from firing.
	             * @param {Function} handler - The handler callback.
	             * @returns {SVGElement} The SVGElement for chaining.
	             *
	             * @sample highcharts/members/element-on/
	             *         A clickable rectangle
	             */
	            on: function(eventType, handler) {
	                var svgElement = this,
	                    element = svgElement.element;
	
	                // touch
	                if (hasTouch && eventType === 'click') {
	                    element.ontouchstart = function(e) {
	                        svgElement.touchEventFired = Date.now(); // #2269
	                        e.preventDefault();
	                        handler.call(element, e);
	                    };
	                    element.onclick = function(e) {
	                        if (win.navigator.userAgent.indexOf('Android') === -1 ||
	                            Date.now() - (svgElement.touchEventFired || 0) > 1100) {
	                            handler.call(element, e);
	                        }
	                    };
	                } else {
	                    // simplest possible event model for internal use
	                    element['on' + eventType] = handler;
	                }
	                return this;
	            },
	
	            /**
	             * Set the coordinates needed to draw a consistent radial gradient across
	             * a shape regardless of positioning inside the chart. Used on pie slices
	             * to make all the slices have the same radial reference point.
	             *
	             * @param {Array} coordinates The center reference. The format is
	             *    `[centerX, centerY, diameter]` in pixels.
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            setRadialReference: function(coordinates) {
	                var existingGradient = this.renderer.gradients[this.element.gradient];
	
	                this.element.radialReference = coordinates;
	
	                // On redrawing objects with an existing gradient, the gradient needs
	                // to be repositioned (#3801)
	                if (existingGradient && existingGradient.radAttr) {
	                    existingGradient.animate(
	                        this.renderer.getRadialAttr(
	                            coordinates,
	                            existingGradient.radAttr
	                        )
	                    );
	                }
	
	                return this;
	            },
	
	            /**
	             * Move an object and its children by x and y values.
	             * 
	             * @param {number} x - The x value.
	             * @param {number} y - The y value.
	             */
	            translate: function(x, y) {
	                return this.attr({
	                    translateX: x,
	                    translateY: y
	                });
	            },
	
	            /**
	             * Invert a group, rotate and flip. This is used internally on inverted 
	             * charts, where the points and graphs are drawn as if not inverted, then
	             * the series group elements are inverted.
	             *
	             * @param  {boolean} inverted
	             *         Whether to invert or not. An inverted shape can be un-inverted by
	             *         setting it to false.
	             * @return {SVGElement}
	             *         Return the SVGElement for chaining.
	             */
	            invert: function(inverted) {
	                var wrapper = this;
	                wrapper.inverted = inverted;
	                wrapper.updateTransform();
	                return wrapper;
	            },
	
	            /**
	             * Update the transform attribute based on internal properties. Deals with
	             * the custom `translateX`, `translateY`, `rotation`, `scaleX` and `scaleY`
	             * attributes and updates the SVG `transform` attribute.
	             * @private
	             * 
	             */
	            updateTransform: function() {
	                var wrapper = this,
	                    translateX = wrapper.translateX || 0,
	                    translateY = wrapper.translateY || 0,
	                    scaleX = wrapper.scaleX,
	                    scaleY = wrapper.scaleY,
	                    inverted = wrapper.inverted,
	                    rotation = wrapper.rotation,
	                    element = wrapper.element,
	                    transform;
	
	                // Flipping affects translate as adjustment for flipping around the
	                // group's axis
	                if (inverted) {
	                    translateX += wrapper.width;
	                    translateY += wrapper.height;
	                }
	
	                // Apply translate. Nearly all transformed elements have translation,
	                // so instead of checking for translate = 0, do it always (#1767,
	                // #1846).
	                transform = ['translate(' + translateX + ',' + translateY + ')'];
	
	                // apply rotation
	                if (inverted) {
	                    transform.push('rotate(90) scale(-1,1)');
	                } else if (rotation) { // text rotation
	                    transform.push(
	                        'rotate(' + rotation + ' ' + (element.getAttribute('x') || 0) +
	                        ' ' + (element.getAttribute('y') || 0) + ')'
	                    );
	                }
	
	                // apply scale
	                if (defined(scaleX) || defined(scaleY)) {
	                    transform.push(
	                        'scale(' + pick(scaleX, 1) + ' ' + pick(scaleY, 1) + ')'
	                    );
	                }
	
	                if (transform.length) {
	                    element.setAttribute('transform', transform.join(' '));
	                }
	            },
	
	            /**
	             * Bring the element to the front. Alternatively, a new zIndex can be set.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             *
	             * @sample highcharts/members/element-tofront/
	             *         Click an element to bring it to front
	             */
	            toFront: function() {
	                var element = this.element;
	                element.parentNode.appendChild(element);
	                return this;
	            },
	
	
	            /**
	             * Align the element relative to the chart or another box.
	             * 
	             * @param {Object} [alignOptions] The alignment options. The function can be
	             *   called without this parameter in order to re-align an element after the
	             *   box has been updated.
	             * @param {string} [alignOptions.align=left] Horizontal alignment. Can be
	             *   one of `left`, `center` and `right`.
	             * @param {string} [alignOptions.verticalAlign=top] Vertical alignment. Can
	             *   be one of `top`, `middle` and `bottom`.
	             * @param {number} [alignOptions.x=0] Horizontal pixel offset from
	             *   alignment.
	             * @param {number} [alignOptions.y=0] Vertical pixel offset from alignment.
	             * @param {Boolean} [alignByTranslate=false] Use the `transform` attribute
	             *   with translateX and translateY custom attributes to align this elements
	             *   rather than `x` and `y` attributes.
	             * @param {String|Object} box The box to align to, needs a width and height.
	             *   When the box is a string, it refers to an object in the Renderer. For
	             *   example, when box is `spacingBox`, it refers to `Renderer.spacingBox`
	             *   which holds `width`, `height`, `x` and `y` properties.
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            align: function(alignOptions, alignByTranslate, box) {
	                var align,
	                    vAlign,
	                    x,
	                    y,
	                    attribs = {},
	                    alignTo,
	                    renderer = this.renderer,
	                    alignedObjects = renderer.alignedObjects,
	                    alignFactor,
	                    vAlignFactor;
	
	                // First call on instanciate
	                if (alignOptions) {
	                    this.alignOptions = alignOptions;
	                    this.alignByTranslate = alignByTranslate;
	                    if (!box || isString(box)) { // boxes other than renderer handle this internally
	                        this.alignTo = alignTo = box || 'renderer';
	                        erase(alignedObjects, this); // prevent duplicates, like legendGroup after resize
	                        alignedObjects.push(this);
	                        box = null; // reassign it below
	                    }
	
	                    // When called on resize, no arguments are supplied
	                } else {
	                    alignOptions = this.alignOptions;
	                    alignByTranslate = this.alignByTranslate;
	                    alignTo = this.alignTo;
	                }
	
	                box = pick(box, renderer[alignTo], renderer);
	
	                // Assign variables
	                align = alignOptions.align;
	                vAlign = alignOptions.verticalAlign;
	                x = (box.x || 0) + (alignOptions.x || 0); // default: left align
	                y = (box.y || 0) + (alignOptions.y || 0); // default: top align
	
	                // Align
	                if (align === 'right') {
	                    alignFactor = 1;
	                } else if (align === 'center') {
	                    alignFactor = 2;
	                }
	                if (alignFactor) {
	                    x += (box.width - (alignOptions.width || 0)) / alignFactor;
	                }
	                attribs[alignByTranslate ? 'translateX' : 'x'] = Math.round(x);
	
	
	                // Vertical align
	                if (vAlign === 'bottom') {
	                    vAlignFactor = 1;
	                } else if (vAlign === 'middle') {
	                    vAlignFactor = 2;
	                }
	                if (vAlignFactor) {
	                    y += (box.height - (alignOptions.height || 0)) / vAlignFactor;
	                }
	                attribs[alignByTranslate ? 'translateY' : 'y'] = Math.round(y);
	
	                // Animate only if already placed
	                this[this.placed ? 'animate' : 'attr'](attribs);
	                this.placed = true;
	                this.alignAttr = attribs;
	
	                return this;
	            },
	
	            /**
	             * Get the bounding box (width, height, x and y) for the element. Generally
	             * used to get rendered text size. Since this is called a lot in charts,
	             * the results are cached based on text properties, in order to save DOM
	             * traffic. The returned bounding box includes the rotation, so for example
	             * a single text line of rotation 90 will report a greater height, and a
	             * width corresponding to the line-height.
	             *
	             * @param {boolean} [reload] Skip the cache and get the updated DOM bouding
	             *   box.
	             * @param {number} [rot] Override the element's rotation. This is internally
	             *   used on axis labels with a value of 0 to find out what the bounding box
	             *   would be have been if it were not rotated.
	             * @returns {Object} The bounding box with `x`, `y`, `width` and `height`
	             * properties.
	             *
	             * @sample highcharts/members/renderer-on-chart/
	             *         Draw a rectangle based on a text's bounding box
	             */
	            getBBox: function(reload, rot) {
	                var wrapper = this,
	                    bBox, // = wrapper.bBox,
	                    renderer = wrapper.renderer,
	                    width,
	                    height,
	                    rotation,
	                    rad,
	                    element = wrapper.element,
	                    styles = wrapper.styles,
	                    fontSize,
	                    textStr = wrapper.textStr,
	                    toggleTextShadowShim,
	                    cache = renderer.cache,
	                    cacheKeys = renderer.cacheKeys,
	                    cacheKey;
	
	                rotation = pick(rot, wrapper.rotation);
	                rad = rotation * deg2rad;
	
	
	                fontSize = styles && styles.fontSize;
	
	
	                if (textStr !== undefined) {
	
	                    cacheKey = textStr.toString();
	
	                    // Since numbers are monospaced, and numerical labels appear a lot
	                    // in a chart, we assume that a label of n characters has the same
	                    // bounding box as others of the same length. Unless there is inner
	                    // HTML in the label. In that case, leave the numbers as is (#5899).
	                    if (cacheKey.indexOf('<') === -1) {
	                        cacheKey = cacheKey.replace(/[0-9]/g, '0');
	                    }
	
	                    // Properties that affect bounding box
	                    cacheKey += [
	                            '',
	                            rotation || 0,
	                            fontSize,
	                            styles && styles.width,
	                            styles && styles.textOverflow // #5968
	                        ]
	                        .join(',');
	
	                }
	
	                if (cacheKey && !reload) {
	                    bBox = cache[cacheKey];
	                }
	
	                // No cache found
	                if (!bBox) {
	
	                    // SVG elements
	                    if (element.namespaceURI === wrapper.SVG_NS || renderer.forExport) {
	                        try { // Fails in Firefox if the container has display: none.
	
	                            // When the text shadow shim is used, we need to hide the fake shadows
	                            // to get the correct bounding box (#3872)
	                            toggleTextShadowShim = this.fakeTS && function(display) {
	                                each(element.querySelectorAll('.highcharts-text-outline'), function(tspan) {
	                                    tspan.style.display = display;
	                                });
	                            };
	
	                            // Workaround for #3842, Firefox reporting wrong bounding box for shadows
	                            if (toggleTextShadowShim) {
	                                toggleTextShadowShim('none');
	                            }
	
	                            bBox = element.getBBox ?
	                                // SVG: use extend because IE9 is not allowed to change width and height in case
	                                // of rotation (below)
	                                extend({}, element.getBBox()) : {
	
	                                    // Legacy IE in export mode
	                                    width: element.offsetWidth,
	                                    height: element.offsetHeight
	                                };
	
	                            // #3842
	                            if (toggleTextShadowShim) {
	                                toggleTextShadowShim('');
	                            }
	                        } catch (e) {}
	
	                        // If the bBox is not set, the try-catch block above failed. The other condition
	                        // is for Opera that returns a width of -Infinity on hidden elements.
	                        if (!bBox || bBox.width < 0) {
	                            bBox = {
	                                width: 0,
	                                height: 0
	                            };
	                        }
	
	
	                        // VML Renderer or useHTML within SVG
	                    } else {
	
	                        bBox = wrapper.htmlGetBBox();
	
	                    }
	
	                    // True SVG elements as well as HTML elements in modern browsers using the .useHTML option
	                    // need to compensated for rotation
	                    if (renderer.isSVG) {
	                        width = bBox.width;
	                        height = bBox.height;
	
	                        // Workaround for wrong bounding box in IE, Edge and Chrome on
	                        // Windows. With Highcharts' default font, IE and Edge report
	                        // a box height of 16.899 and Chrome rounds it to 17. If this 
	                        // stands uncorrected, it results in more padding added below
	                        // the text than above when adding a label border or background.
	                        // Also vertical positioning is affected.
	                        // http://jsfiddle.net/highcharts/em37nvuj/
	                        // (#1101, #1505, #1669, #2568, #6213).
	                        if (
	                            styles &&
	                            styles.fontSize === '11px' &&
	                            Math.round(height) === 17
	                        ) {
	                            bBox.height = height = 14;
	                        }
	
	                        // Adjust for rotated text
	                        if (rotation) {
	                            bBox.width = Math.abs(height * Math.sin(rad)) + Math.abs(width * Math.cos(rad));
	                            bBox.height = Math.abs(height * Math.cos(rad)) + Math.abs(width * Math.sin(rad));
	                        }
	                    }
	
	                    // Cache it. When loading a chart in a hidden iframe in Firefox and IE/Edge, the
	                    // bounding box height is 0, so don't cache it (#5620).
	                    if (cacheKey && bBox.height > 0) {
	
	                        // Rotate (#4681)
	                        while (cacheKeys.length > 250) {
	                            delete cache[cacheKeys.shift()];
	                        }
	
	                        if (!cache[cacheKey]) {
	                            cacheKeys.push(cacheKey);
	                        }
	                        cache[cacheKey] = bBox;
	                    }
	                }
	                return bBox;
	            },
	
	            /**
	             * Show the element after it has been hidden. 
	             *
	             * @param {boolean} [inherit=false] Set the visibility attribute to
	             * `inherit` rather than `visible`. The difference is that an element with
	             * `visibility="visible"` will be visible even if the parent is hidden.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            show: function(inherit) {
	                return this.attr({
	                    visibility: inherit ? 'inherit' : 'visible'
	                });
	            },
	
	            /**
	             * Hide the element, equivalent to setting the `visibility` attribute to
	             * `hidden`.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             */
	            hide: function() {
	                return this.attr({
	                    visibility: 'hidden'
	                });
	            },
	
	            /**
	             * Fade out an element by animating its opacity down to 0, and hide it on
	             * complete. Used internally for the tooltip.
	             * 
	             * @param {number} [duration=150] The fade duration in milliseconds.
	             */
	            fadeOut: function(duration) {
	                var elemWrapper = this;
	                elemWrapper.animate({
	                    opacity: 0
	                }, {
	                    duration: duration || 150,
	                    complete: function() {
	                        // #3088, assuming we're only using this for tooltips
	                        elemWrapper.attr({
	                            y: -9999
	                        });
	                    }
	                });
	            },
	
	            /**
	             * Add the element to the DOM. All elements must be added this way.
	             * 
	             * @param {SVGElement|SVGDOMElement} [parent] The parent item to add it to.
	             *   If undefined, the element is added to the {@link
	             *   Highcharts.SVGRenderer.box}.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             *
	             * @sample highcharts/members/renderer-g - Elements added to a group
	             */
	            add: function(parent) {
	
	                var renderer = this.renderer,
	                    element = this.element,
	                    inserted;
	
	                if (parent) {
	                    this.parentGroup = parent;
	                }
	
	                // mark as inverted
	                this.parentInverted = parent && parent.inverted;
	
	                // build formatted text
	                if (this.textStr !== undefined) {
	                    renderer.buildText(this);
	                }
	
	                // Mark as added
	                this.added = true;
	
	                // If we're adding to renderer root, or other elements in the group
	                // have a z index, we need to handle it
	                if (!parent || parent.handleZ || this.zIndex) {
	                    inserted = this.zIndexSetter();
	                }
	
	                // If zIndex is not handled, append at the end
	                if (!inserted) {
	                    (parent ? parent.element : renderer.box).appendChild(element);
	                }
	
	                // fire an event for internal hooks
	                if (this.onAdd) {
	                    this.onAdd();
	                }
	
	                return this;
	            },
	
	            /**
	             * Removes an element from the DOM.
	             *
	             * @private
	             * @param {SVGDOMElement|HTMLDOMElement} element The DOM node to remove.
	             */
	            safeRemoveChild: function(element) {
	                var parentNode = element.parentNode;
	                if (parentNode) {
	                    parentNode.removeChild(element);
	                }
	            },
	
	            /**
	             * Destroy the element and element wrapper and clear up the DOM and event
	             * hooks.
	             *
	             * 
	             */
	            destroy: function() {
	                var wrapper = this,
	                    element = wrapper.element || {},
	                    parentToClean =
	                    wrapper.renderer.isSVG &&
	                    element.nodeName === 'SPAN' &&
	                    wrapper.parentGroup,
	                    grandParent,
	                    ownerSVGElement = element.ownerSVGElement,
	                    i;
	
	                // remove events
	                element.onclick = element.onmouseout = element.onmouseover =
	                    element.onmousemove = element.point = null;
	                stop(wrapper); // stop running animations
	
	                if (wrapper.clipPath && ownerSVGElement) {
	                    // Look for existing references to this clipPath and remove them
	                    // before destroying the element (#6196).
	                    each(
	                        ownerSVGElement.querySelectorAll('[clip-path]'),
	                        function(el) {
	                            // Include the closing paranthesis in the test to rule out
	                            // id's from 10 and above (#6550)
	                            if (el.getAttribute('clip-path')
	                                .indexOf(wrapper.clipPath.element.id + ')') > -1) {
	                                el.removeAttribute('clip-path');
	                            }
	                        }
	                    );
	                    wrapper.clipPath = wrapper.clipPath.destroy();
	                }
	
	                // Destroy stops in case this is a gradient object
	                if (wrapper.stops) {
	                    for (i = 0; i < wrapper.stops.length; i++) {
	                        wrapper.stops[i] = wrapper.stops[i].destroy();
	                    }
	                    wrapper.stops = null;
	                }
	
	                // remove element
	                wrapper.safeRemoveChild(element);
	
	
	                wrapper.destroyShadows();
	
	
	                // In case of useHTML, clean up empty containers emulating SVG groups
	                // (#1960, #2393, #2697).
	                while (
	                    parentToClean &&
	                    parentToClean.div &&
	                    parentToClean.div.childNodes.length === 0
	                ) {
	                    grandParent = parentToClean.parentGroup;
	                    wrapper.safeRemoveChild(parentToClean.div);
	                    delete parentToClean.div;
	                    parentToClean = grandParent;
	                }
	
	                // remove from alignObjects
	                if (wrapper.alignTo) {
	                    erase(wrapper.renderer.alignedObjects, wrapper);
	                }
	
	                objectEach(wrapper, function(val, key) {
	                    delete wrapper[key];
	                });
	
	                return null;
	            },
	
	
	            /**
	             * @typedef {Object} ShadowOptions
	             * @property {string} [color=#000000] The shadow color.
	             * @property {number} [offsetX=1] The horizontal offset from the element.
	             * @property {number} [offsetY=1] The vertical offset from the element.
	             * @property {number} [opacity=0.15] The shadow opacity.
	             * @property {number} [width=3] The shadow width or distance from the
	             *    element.
	             */
	            /**
	             * Add a shadow to the element. Must be called after the element is added to
	             * the DOM. In styled mode, this method is not used, instead use `defs` and
	             * filters.
	             * 
	             * @param {boolean|ShadowOptions} shadowOptions The shadow options. If
	             *    `true`, the default options are applied. If `false`, the current
	             *    shadow will be removed.
	             * @param {SVGElement} [group] The SVG group element where the shadows will 
	             *    be applied. The default is to add it to the same parent as the current
	             *    element. Internally, this is ised for pie slices, where all the
	             *    shadows are added to an element behind all the slices.
	             * @param {boolean} [cutOff] Used internally for column shadows.
	             *
	             * @returns {SVGElement} Returns the SVGElement for chaining.
	             *
	             * @example
	             * renderer.rect(10, 100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .shadow(true);
	             */
	            shadow: function(shadowOptions, group, cutOff) {
	                var shadows = [],
	                    i,
	                    shadow,
	                    element = this.element,
	                    strokeWidth,
	                    shadowWidth,
	                    shadowElementOpacity,
	
	                    // compensate for inverted plot area
	                    transform;
	
	                if (!shadowOptions) {
	                    this.destroyShadows();
	
	                } else if (!this.shadows) {
	                    shadowWidth = pick(shadowOptions.width, 3);
	                    shadowElementOpacity = (shadowOptions.opacity || 0.15) /
	                        shadowWidth;
	                    transform = this.parentInverted ?
	                        '(-1,-1)' :
	                        '(' + pick(shadowOptions.offsetX, 1) + ', ' +
	                        pick(shadowOptions.offsetY, 1) + ')';
	                    for (i = 1; i <= shadowWidth; i++) {
	                        shadow = element.cloneNode(0);
	                        strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	                        attr(shadow, {
	                            'isShadow': 'true',
	                            'stroke': shadowOptions.color || '#000000',
	                            'stroke-opacity': shadowElementOpacity * i,
	                            'stroke-width': strokeWidth,
	                            'transform': 'translate' + transform,
	                            'fill': 'none'
	                        });
	                        if (cutOff) {
	                            attr(
	                                shadow,
	                                'height',
	                                Math.max(attr(shadow, 'height') - strokeWidth, 0)
	                            );
	                            shadow.cutHeight = strokeWidth;
	                        }
	
	                        if (group) {
	                            group.element.appendChild(shadow);
	                        } else {
	                            element.parentNode.insertBefore(shadow, element);
	                        }
	
	                        shadows.push(shadow);
	                    }
	
	                    this.shadows = shadows;
	                }
	                return this;
	
	            },
	
	            /**
	             * Destroy shadows on the element.
	             * @private
	             */
	            destroyShadows: function() {
	                each(this.shadows || [], function(shadow) {
	                    this.safeRemoveChild(shadow);
	                }, this);
	                this.shadows = undefined;
	            },
	
	
	
	            xGetter: function(key) {
	                if (this.element.nodeName === 'circle') {
	                    if (key === 'x') {
	                        key = 'cx';
	                    } else if (key === 'y') {
	                        key = 'cy';
	                    }
	                }
	                return this._defaultGetter(key);
	            },
	
	            /**
	             * Get the current value of an attribute or pseudo attribute, used mainly
	             * for animation. Called internally from the {@link
	             * Highcharts.SVGRenderer#attr}
	             * function.
	             *
	             * @private
	             */
	            _defaultGetter: function(key) {
	                var ret = pick(
	                    this[key],
	                    this.element ? this.element.getAttribute(key) : null,
	                    0
	                );
	
	                if (/^[\-0-9\.]+$/.test(ret)) { // is numerical
	                    ret = parseFloat(ret);
	                }
	                return ret;
	            },
	
	
	            dSetter: function(value, key, element) {
	                if (value && value.join) { // join path
	                    value = value.join(' ');
	                }
	                if (/(NaN| {2}|^$)/.test(value)) {
	                    value = 'M 0 0';
	                }
	
	                // Check for cache before resetting. Resetting causes disturbance in the
	                // DOM, causing flickering in some cases in Edge/IE (#6747). Also
	                // possible performance gain.
	                if (this[key] !== value) {
	                    element.setAttribute(key, value);
	                    this[key] = value;
	                }
	
	            },
	
	            dashstyleSetter: function(value) {
	                var i,
	                    strokeWidth = this['stroke-width'];
	
	                // If "inherit", like maps in IE, assume 1 (#4981). With HC5 and the new
	                // strokeWidth function, we should be able to use that instead.
	                if (strokeWidth === 'inherit') {
	                    strokeWidth = 1;
	                }
	                value = value && value.toLowerCase();
	                if (value) {
	                    value = value
	                        .replace('shortdashdotdot', '3,1,1,1,1,1,')
	                        .replace('shortdashdot', '3,1,1,1')
	                        .replace('shortdot', '1,1,')
	                        .replace('shortdash', '3,1,')
	                        .replace('longdash', '8,3,')
	                        .replace(/dot/g, '1,3,')
	                        .replace('dash', '4,3,')
	                        .replace(/,$/, '')
	                        .split(','); // ending comma
	
	                    i = value.length;
	                    while (i--) {
	                        value[i] = pInt(value[i]) * strokeWidth;
	                    }
	                    value = value.join(',')
	                        .replace(/NaN/g, 'none'); // #3226
	                    this.element.setAttribute('stroke-dasharray', value);
	                }
	            },
	
	            alignSetter: function(value) {
	                var convert = {
	                    left: 'start',
	                    center: 'middle',
	                    right: 'end'
	                };
	                this.element.setAttribute('text-anchor', convert[value]);
	            },
	            opacitySetter: function(value, key, element) {
	                this[key] = value;
	                element.setAttribute(key, value);
	            },
	            titleSetter: function(value) {
	                var titleNode = this.element.getElementsByTagName('title')[0];
	                if (!titleNode) {
	                    titleNode = doc.createElementNS(this.SVG_NS, 'title');
	                    this.element.appendChild(titleNode);
	                }
	
	                // Remove text content if it exists
	                if (titleNode.firstChild) {
	                    titleNode.removeChild(titleNode.firstChild);
	                }
	
	                titleNode.appendChild(
	                    doc.createTextNode(
	                        (String(pick(value), '')).replace(/<[^>]*>/g, '') // #3276, #3895
	                    )
	                );
	            },
	            textSetter: function(value) {
	                if (value !== this.textStr) {
	                    // Delete bBox memo when the text changes
	                    delete this.bBox;
	
	                    this.textStr = value;
	                    if (this.added) {
	                        this.renderer.buildText(this);
	                    }
	                }
	            },
	            fillSetter: function(value, key, element) {
	                if (typeof value === 'string') {
	                    element.setAttribute(key, value);
	                } else if (value) {
	                    this.colorGradient(value, key, element);
	                }
	            },
	            visibilitySetter: function(value, key, element) {
	                // IE9-11 doesn't handle visibilty:inherit well, so we remove the attribute instead (#2881, #3909)
	                if (value === 'inherit') {
	                    element.removeAttribute(key);
	                } else if (this[key] !== value) { // #6747
	                    element.setAttribute(key, value);
	                }
	                this[key] = value;
	            },
	            zIndexSetter: function(value, key) {
	                var renderer = this.renderer,
	                    parentGroup = this.parentGroup,
	                    parentWrapper = parentGroup || renderer,
	                    parentNode = parentWrapper.element || renderer.box,
	                    childNodes,
	                    otherElement,
	                    otherZIndex,
	                    element = this.element,
	                    inserted,
	                    run = this.added,
	                    i;
	
	                if (defined(value)) {
	                    element.zIndex = value; // So we can read it for other elements in the group
	                    value = +value;
	                    if (this[key] === value) { // Only update when needed (#3865)
	                        run = false;
	                    }
	                    this[key] = value;
	                }
	
	                // Insert according to this and other elements' zIndex. Before .add() is called,
	                // nothing is done. Then on add, or by later calls to zIndexSetter, the node
	                // is placed on the right place in the DOM.
	                if (run) {
	                    value = this.zIndex;
	
	                    if (value && parentGroup) {
	                        parentGroup.handleZ = true;
	                    }
	
	                    childNodes = parentNode.childNodes;
	                    for (i = 0; i < childNodes.length && !inserted; i++) {
	                        otherElement = childNodes[i];
	                        otherZIndex = otherElement.zIndex;
	                        if (otherElement !== element && (
	                                // Insert before the first element with a higher zIndex
	                                pInt(otherZIndex) > value ||
	                                // If no zIndex given, insert before the first element with a zIndex
	                                (!defined(value) && defined(otherZIndex)) ||
	                                // Negative zIndex versus no zIndex:
	                                // On all levels except the highest. If the parent is <svg>,
	                                // then we don't want to put items before <desc> or <defs>
	                                (value < 0 && !defined(otherZIndex) && parentNode !== renderer.box)
	
	                            )) {
	                            parentNode.insertBefore(element, otherElement);
	                            inserted = true;
	                        }
	                    }
	                    if (!inserted) {
	                        parentNode.appendChild(element);
	                    }
	                }
	                return inserted;
	            },
	            _defaultSetter: function(value, key, element) {
	                element.setAttribute(key, value);
	            }
	        });
	
	        // Some shared setters and getters
	        SVGElement.prototype.yGetter = SVGElement.prototype.xGetter;
	        SVGElement.prototype.translateXSetter = SVGElement.prototype.translateYSetter =
	            SVGElement.prototype.rotationSetter = SVGElement.prototype.verticalAlignSetter =
	            SVGElement.prototype.scaleXSetter = SVGElement.prototype.scaleYSetter = function(value, key) {
	                this[key] = value;
	                this.doTransform = true;
	            };
	
	
	        // WebKit and Batik have problems with a stroke-width of zero, so in this case we remove the 
	        // stroke attribute altogether. #1270, #1369, #3065, #3072.
	        SVGElement.prototype['stroke-widthSetter'] = SVGElement.prototype.strokeSetter = function(value, key, element) {
	            this[key] = value;
	            // Only apply the stroke attribute if the stroke width is defined and larger than 0
	            if (this.stroke && this['stroke-width']) {
	                SVGElement.prototype.fillSetter.call(this, this.stroke, 'stroke', element); // use prototype as instance may be overridden
	                element.setAttribute('stroke-width', this['stroke-width']);
	                this.hasStroke = true;
	            } else if (key === 'stroke-width' && value === 0 && this.hasStroke) {
	                element.removeAttribute('stroke');
	                this.hasStroke = false;
	            }
	        };
	
	
	        /**
	         * Allows direct access to the Highcharts rendering layer in order to draw
	         * primitive shapes like circles, rectangles, paths or text directly on a chart,
	         * or independent from any chart. The SVGRenderer represents a wrapper object
	         * for SVGin modern browsers and through the VMLRenderer, for VML in IE < 8.
	         *
	         * An existing chart's renderer can be accessed through {@link Chart.renderer}.
	         * The renderer can also be used completely decoupled from a chart.
	         *
	         * @param {HTMLDOMElement} container - Where to put the SVG in the web page.
	         * @param {number} width - The width of the SVG.
	         * @param {number} height - The height of the SVG.
	         * @param {boolean} [forExport=false] - Whether the rendered content is intended
	         *   for export.
	         * @param {boolean} [allowHTML=true] - Whether the renderer is allowed to
	         *   include HTML text, which will be projected on top of the SVG.
	         *
	         * @example
	         * // Use directly without a chart object.
	         * var renderer = new Highcharts.Renderer(parentNode, 600, 400);
	         *
	         * @sample highcharts/members/renderer-on-chart - Annotating a chart programmatically.
	         * @sample highcharts/members/renderer-basic - Independent SVG drawing.
	         *
	         * @class Highcharts.SVGRenderer
	         */
	        SVGRenderer = H.SVGRenderer = function() {
	            this.init.apply(this, arguments);
	        };
	        extend(SVGRenderer.prototype, /** @lends Highcharts.SVGRenderer.prototype */ {
	            /**
	             * A pointer to the renderer's associated Element class. The VMLRenderer
	             * will have a pointer to VMLElement here.
	             * @type {SVGElement}
	             */
	            Element: SVGElement,
	            SVG_NS: SVG_NS,
	            /**
	             * Initialize the SVGRenderer. Overridable initiator function that takes
	             * the same parameters as the constructor.
	             */
	            init: function(container, width, height, style, forExport, allowHTML) {
	                var renderer = this,
	                    boxWrapper,
	                    element,
	                    desc;
	
	                boxWrapper = renderer.createElement('svg')
	                    .attr({
	                        'version': '1.1',
	                        'class': 'highcharts-root'
	                    })
	
	                    .css(this.getStyle(style));
	                element = boxWrapper.element;
	                container.appendChild(element);
	
	                // For browsers other than IE, add the namespace attribute (#1978)
	                if (container.innerHTML.indexOf('xmlns') === -1) {
	                    attr(element, 'xmlns', this.SVG_NS);
	                }
	
	                // object properties
	                renderer.isSVG = true;
	
	                /** 
	                 * The root `svg` node of the renderer.
	                 * @name box
	                 * @memberOf SVGRenderer
	                 * @type {SVGDOMElement}
	                 */
	                this.box = element;
	                /** 
	                 * The wrapper for the root `svg` node of the renderer.
	                 *
	                 * @name boxWrapper
	                 * @memberOf SVGRenderer
	                 * @type {SVGElement}
	                 */
	                this.boxWrapper = boxWrapper;
	                renderer.alignedObjects = [];
	
	                /**
	                 * Page url used for internal references.
	                 * @type {string}
	                 */
	                // #24, #672, #1070
	                this.url = (isFirefox || isWebKit) && doc.getElementsByTagName('base').length ?
	                    win.location.href
	                    .replace(/#.*?$/, '') // remove the hash
	                    .replace(/<[^>]*>/g, '') // wing cut HTML
	                    .replace(/([\('\)])/g, '\\$1') // escape parantheses and quotes
	                    .replace(/ /g, '%20') : // replace spaces (needed for Safari only)
	                    '';
	
	                // Add description
	                desc = this.createElement('desc').add();
	                desc.element.appendChild(doc.createTextNode('Created with Highcharts 5.0.14'));
	
	                /**
	                 * A pointer to the `defs` node of the root SVG.
	                 * @type {SVGElement}
	                 * @name defs
	                 * @memberOf SVGRenderer
	                 */
	                renderer.defs = this.createElement('defs').add();
	                renderer.allowHTML = allowHTML;
	                renderer.forExport = forExport;
	                renderer.gradients = {}; // Object where gradient SvgElements are stored
	                renderer.cache = {}; // Cache for numerical bounding boxes
	                renderer.cacheKeys = [];
	                renderer.imgCount = 0;
	
	                renderer.setSize(width, height, false);
	
	
	
	                // Issue 110 workaround:
	                // In Firefox, if a div is positioned by percentage, its pixel position may land
	                // between pixels. The container itself doesn't display this, but an SVG element
	                // inside this container will be drawn at subpixel precision. In order to draw
	                // sharp lines, this must be compensated for. This doesn't seem to work inside
	                // iframes though (like in jsFiddle).
	                var subPixelFix, rect;
	                if (isFirefox && container.getBoundingClientRect) {
	                    subPixelFix = function() {
	                        css(container, {
	                            left: 0,
	                            top: 0
	                        });
	                        rect = container.getBoundingClientRect();
	                        css(container, {
	                            left: (Math.ceil(rect.left) - rect.left) + 'px',
	                            top: (Math.ceil(rect.top) - rect.top) + 'px'
	                        });
	                    };
	
	                    // run the fix now
	                    subPixelFix();
	
	                    // run it on resize
	                    renderer.unSubPixelFix = addEvent(win, 'resize', subPixelFix);
	                }
	            },
	
	
	
	            /**
	             * Get the global style setting for the renderer.
	             * @private
	             * @param  {CSSObject} style - Style settings.
	             * @return {CSSObject} The style settings mixed with defaults.
	             */
	            getStyle: function(style) {
	                this.style = extend({
	
	                    fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', // default font
	                    fontSize: '12px'
	
	                }, style);
	                return this.style;
	            },
	            /**
	             * Apply the global style on the renderer, mixed with the default styles.
	             * 
	             * @param {CSSObject} style - CSS to apply.
	             */
	            setStyle: function(style) {
	                this.boxWrapper.css(this.getStyle(style));
	            },
	
	
	            /**
	             * Detect whether the renderer is hidden. This happens when one of the
	             * parent elements has `display: none`. Used internally to detect when we
	             * needto render preliminarily in another div to get the text bounding boxes 
	             * right.
	             *
	             * @returns {boolean} True if it is hidden.
	             */
	            isHidden: function() { // #608
	                return !this.boxWrapper.getBBox().width;
	            },
	
	            /**
	             * Destroys the renderer and its allocated members.
	             */
	            destroy: function() {
	                var renderer = this,
	                    rendererDefs = renderer.defs;
	                renderer.box = null;
	                renderer.boxWrapper = renderer.boxWrapper.destroy();
	
	                // Call destroy on all gradient elements
	                destroyObjectProperties(renderer.gradients || {});
	                renderer.gradients = null;
	
	                // Defs are null in VMLRenderer
	                // Otherwise, destroy them here.
	                if (rendererDefs) {
	                    renderer.defs = rendererDefs.destroy();
	                }
	
	                // Remove sub pixel fix handler (#982)
	                if (renderer.unSubPixelFix) {
	                    renderer.unSubPixelFix();
	                }
	
	                renderer.alignedObjects = null;
	
	                return null;
	            },
	
	            /**
	             * Create a wrapper for an SVG element. Serves as a factory for 
	             * {@link SVGElement}, but this function is itself mostly called from 
	             * primitive factories like {@link SVGRenderer#path}, {@link
	             * SVGRenderer#rect} or {@link SVGRenderer#text}.
	             * 
	             * @param {string} nodeName - The node name, for example `rect`, `g` etc.
	             * @returns {SVGElement} The generated SVGElement.
	             */
	            createElement: function(nodeName) {
	                var wrapper = new this.Element();
	                wrapper.init(this, nodeName);
	                return wrapper;
	            },
	
	            /**
	             * Dummy function for plugins, called every time the renderer is updated.
	             * Prior to Highcharts 5, this was used for the canvg renderer.
	             * @function
	             */
	            draw: noop,
	
	            /**
	             * Get converted radial gradient attributes according to the radial
	             * reference. Used internally from the {@link SVGElement#colorGradient}
	             * function.
	             *
	             * @private
	             */
	            getRadialAttr: function(radialReference, gradAttr) {
	                return {
	                    cx: (radialReference[0] - radialReference[2] / 2) + gradAttr.cx * radialReference[2],
	                    cy: (radialReference[1] - radialReference[2] / 2) + gradAttr.cy * radialReference[2],
	                    r: gradAttr.r * radialReference[2]
	                };
	            },
	
	            getSpanWidth: function(wrapper, tspan) {
	                var renderer = this,
	                    bBox = wrapper.getBBox(true),
	                    actualWidth = bBox.width;
	
	                // Old IE cannot measure the actualWidth for SVG elements (#2314)
	                if (!svg && renderer.forExport) {
	                    actualWidth = renderer.measureSpanWidth(tspan.firstChild.data, wrapper.styles);
	                }
	                return actualWidth;
	            },
	
	            applyEllipsis: function(wrapper, tspan, text, width) {
	                var renderer = this,
	                    rotation = wrapper.rotation,
	                    str = text,
	                    currentIndex,
	                    minIndex = 0,
	                    maxIndex = text.length,
	                    updateTSpan = function(s) {
	                        tspan.removeChild(tspan.firstChild);
	                        if (s) {
	                            tspan.appendChild(doc.createTextNode(s));
	                        }
	                    },
	                    actualWidth,
	                    wasTooLong;
	                wrapper.rotation = 0; // discard rotation when computing box
	                actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                wasTooLong = actualWidth > width;
	                if (wasTooLong) {
	                    while (minIndex <= maxIndex) {
	                        currentIndex = Math.ceil((minIndex + maxIndex) / 2);
	                        str = text.substring(0, currentIndex) + '\u2026';
	                        updateTSpan(str);
	                        actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                        if (minIndex === maxIndex) {
	                            // Complete
	                            minIndex = maxIndex + 1;
	                        } else if (actualWidth > width) {
	                            // Too large. Set max index to current.
	                            maxIndex = currentIndex - 1;
	                        } else {
	                            // Within width. Set min index to current.
	                            minIndex = currentIndex;
	                        }
	                    }
	                    // If max index was 0 it means just ellipsis was also to large.
	                    if (maxIndex === 0) {
	                        // Remove ellipses.
	                        updateTSpan('');
	                    }
	                }
	                wrapper.rotation = rotation; // Apply rotation again.
	                return wasTooLong;
	            },
	
	            /**
	             * Parse a simple HTML string into SVG tspans. Called internally when text
	             *   is set on an SVGElement. The function supports a subset of HTML tags,
	             *   CSS text features like `width`, `text-overflow`, `white-space`, and
	             *   also attributes like `href` and `style`.
	             * @private
	             * @param {SVGElement} wrapper The parent SVGElement.
	             */
	            buildText: function(wrapper) {
	                var textNode = wrapper.element,
	                    renderer = this,
	                    forExport = renderer.forExport,
	                    textStr = pick(wrapper.textStr, '').toString(),
	                    hasMarkup = textStr.indexOf('<') !== -1,
	                    lines,
	                    childNodes = textNode.childNodes,
	                    clsRegex,
	                    styleRegex,
	                    hrefRegex,
	                    wasTooLong,
	                    parentX = attr(textNode, 'x'),
	                    textStyles = wrapper.styles,
	                    width = wrapper.textWidth,
	                    textLineHeight = textStyles && textStyles.lineHeight,
	                    textOutline = textStyles && textStyles.textOutline,
	                    ellipsis = textStyles && textStyles.textOverflow === 'ellipsis',
	                    noWrap = textStyles && textStyles.whiteSpace === 'nowrap',
	                    fontSize = textStyles && textStyles.fontSize,
	                    textCache,
	                    isSubsequentLine,
	                    i = childNodes.length,
	                    tempParent = width && !wrapper.added && this.box,
	                    getLineHeight = function(tspan) {
	                        var fontSizeStyle;
	
	                        fontSizeStyle = /(px|em)$/.test(tspan && tspan.style.fontSize) ?
	                            tspan.style.fontSize :
	                            (fontSize || renderer.style.fontSize || 12);
	
	
	                        return textLineHeight ?
	                            pInt(textLineHeight) :
	                            renderer.fontMetrics(
	                                fontSizeStyle,
	                                // Get the computed size from parent if not explicit
	                                tspan.getAttribute('style') ? tspan : textNode
	                            ).h;
	                    },
	                    unescapeAngleBrackets = function(inputStr) {
	                        return inputStr.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	                    };
	
	                // The buildText code is quite heavy, so if we're not changing something
	                // that affects the text, skip it (#6113).
	                textCache = [
	                    textStr,
	                    ellipsis,
	                    noWrap,
	                    textLineHeight,
	                    textOutline,
	                    fontSize,
	                    width
	                ].join(',');
	                if (textCache === wrapper.textCache) {
	                    return;
	                }
	                wrapper.textCache = textCache;
	
	                /// remove old text
	                while (i--) {
	                    textNode.removeChild(childNodes[i]);
	                }
	
	                // Skip tspans, add text directly to text node. The forceTSpan is a hook
	                // used in text outline hack.
	                if (!hasMarkup && !textOutline && !ellipsis && !width && textStr.indexOf(' ') === -1) {
	                    textNode.appendChild(doc.createTextNode(unescapeAngleBrackets(textStr)));
	
	                    // Complex strings, add more logic
	                } else {
	
	                    clsRegex = /<.*class="([^"]+)".*>/;
	                    styleRegex = /<.*style="([^"]+)".*>/;
	                    hrefRegex = /<.*href="([^"]+)".*>/;
	
	                    if (tempParent) {
	                        tempParent.appendChild(textNode); // attach it to the DOM to read offset width
	                    }
	
	                    if (hasMarkup) {
	                        lines = textStr
	
	                            .replace(/<(b|strong)>/g, '<span style="font-weight:bold">')
	                            .replace(/<(i|em)>/g, '<span style="font-style:italic">')
	
	                            .replace(/<a/g, '<span')
	                            .replace(/<\/(b|strong|i|em|a)>/g, '</span>')
	                            .split(/<br.*?>/g);
	
	                    } else {
	                        lines = [textStr];
	                    }
	
	
	                    // Trim empty lines (#5261)
	                    lines = grep(lines, function(line) {
	                        return line !== '';
	                    });
	
	
	                    // build the lines
	                    each(lines, function buildTextLines(line, lineNo) {
	                        var spans,
	                            spanNo = 0;
	                        line = line
	                            .replace(/^\s+|\s+$/g, '') // Trim to prevent useless/costly process on the spaces (#5258)
	                            .replace(/<span/g, '|||<span')
	                            .replace(/<\/span>/g, '</span>|||');
	                        spans = line.split('|||');
	
	                        each(spans, function buildTextSpans(span) {
	                            if (span !== '' || spans.length === 1) {
	                                var attributes = {},
	                                    tspan = doc.createElementNS(renderer.SVG_NS, 'tspan'),
	                                    spanCls,
	                                    spanStyle; // #390
	                                if (clsRegex.test(span)) {
	                                    spanCls = span.match(clsRegex)[1];
	                                    attr(tspan, 'class', spanCls);
	                                }
	                                if (styleRegex.test(span)) {
	                                    spanStyle = span.match(styleRegex)[1].replace(/(;| |^)color([ :])/, '$1fill$2');
	                                    attr(tspan, 'style', spanStyle);
	                                }
	                                if (hrefRegex.test(span) && !forExport) { // Not for export - #1529
	                                    attr(tspan, 'onclick', 'location.href=\"' + span.match(hrefRegex)[1] + '\"');
	                                    css(tspan, {
	                                        cursor: 'pointer'
	                                    });
	                                }
	
	                                span = unescapeAngleBrackets(span.replace(/<(.|\n)*?>/g, '') || ' ');
	
	                                // Nested tags aren't supported, and cause crash in Safari (#1596)
	                                if (span !== ' ') {
	
	                                    // add the text node
	                                    tspan.appendChild(doc.createTextNode(span));
	
	                                    if (!spanNo) { // first span in a line, align it to the left
	                                        if (lineNo && parentX !== null) {
	                                            attributes.x = parentX;
	                                        }
	                                    } else {
	                                        attributes.dx = 0; // #16
	                                    }
	
	                                    // add attributes
	                                    attr(tspan, attributes);
	
	                                    // Append it
	                                    textNode.appendChild(tspan);
	
	                                    // first span on subsequent line, add the line height
	                                    if (!spanNo && isSubsequentLine) {
	
	                                        // allow getting the right offset height in exporting in IE
	                                        if (!svg && forExport) {
	                                            css(tspan, {
	                                                display: 'block'
	                                            });
	                                        }
	
	                                        // Set the line height based on the font size of either
	                                        // the text element or the tspan element
	                                        attr(
	                                            tspan,
	                                            'dy',
	                                            getLineHeight(tspan)
	                                        );
	                                    }
	
	                                    /*if (width) {
	                                    	renderer.breakText(wrapper, width);
	                                    }*/
	
	                                    // Check width and apply soft breaks or ellipsis
	                                    if (width) {
	                                        var words = span.replace(/([^\^])-/g, '$1- ').split(' '), // #1273
	                                            hasWhiteSpace = spans.length > 1 || lineNo || (words.length > 1 && !noWrap),
	                                            tooLong,
	                                            rest = [],
	                                            actualWidth,
	                                            dy = getLineHeight(tspan),
	                                            rotation = wrapper.rotation;
	
	                                        if (ellipsis) {
	                                            wasTooLong = renderer.applyEllipsis(wrapper, tspan, span, width);
	                                        }
	
	                                        while (!ellipsis && hasWhiteSpace && (words.length || rest.length)) {
	                                            wrapper.rotation = 0; // discard rotation when computing box
	                                            actualWidth = renderer.getSpanWidth(wrapper, tspan);
	                                            tooLong = actualWidth > width;
	
	                                            // For ellipsis, do a binary search for the correct string length
	                                            if (wasTooLong === undefined) {
	                                                wasTooLong = tooLong; // First time
	                                            }
	
	                                            // Looping down, this is the first word sequence that is not too long,
	                                            // so we can move on to build the next line.
	                                            if (!tooLong || words.length === 1) {
	                                                words = rest;
	                                                rest = [];
	
	                                                if (words.length && !noWrap) {
	                                                    tspan = doc.createElementNS(SVG_NS, 'tspan');
	                                                    attr(tspan, {
	                                                        dy: dy,
	                                                        x: parentX
	                                                    });
	                                                    if (spanStyle) { // #390
	                                                        attr(tspan, 'style', spanStyle);
	                                                    }
	                                                    textNode.appendChild(tspan);
	                                                }
	                                                if (actualWidth > width) { // a single word is pressing it out
	                                                    width = actualWidth;
	                                                }
	                                            } else { // append to existing line tspan
	                                                tspan.removeChild(tspan.firstChild);
	                                                rest.unshift(words.pop());
	                                            }
	                                            if (words.length) {
	                                                tspan.appendChild(doc.createTextNode(words.join(' ').replace(/- /g, '-')));
	                                            }
	                                        }
	                                        wrapper.rotation = rotation;
	                                    }
	
	                                    spanNo++;
	                                }
	                            }
	                        });
	                        // To avoid beginning lines that doesn't add to the textNode (#6144)
	                        isSubsequentLine = isSubsequentLine || textNode.childNodes.length;
	                    });
	
	                    if (wasTooLong) {
	                        wrapper.attr('title', wrapper.textStr);
	                    }
	                    if (tempParent) {
	                        tempParent.removeChild(textNode); // attach it to the DOM to read offset width
	                    }
	
	                    // Apply the text outline
	                    if (textOutline && wrapper.applyTextOutline) {
	                        wrapper.applyTextOutline(textOutline);
	                    }
	                }
	            },
	
	
	
	            /*
	            breakText: function (wrapper, width) {
	            	var bBox = wrapper.getBBox(),
	            		node = wrapper.element,
	            		textLength = node.textContent.length,
	            		pos = Math.round(width * textLength / bBox.width), // try this position first, based on average character width
	            		increment = 0,
	            		finalPos;
	
	            	if (bBox.width > width) {
	            		while (finalPos === undefined) {
	            			textLength = node.getSubStringLength(0, pos);
	
	            			if (textLength <= width) {
	            				if (increment === -1) {
	            					finalPos = pos;
	            				} else {
	            					increment = 1;
	            				}
	            			} else {
	            				if (increment === 1) {
	            					finalPos = pos - 1;
	            				} else {
	            					increment = -1;
	            				}
	            			}
	            			pos += increment;
	            		}
	            	}
	            	console.log('width', width, 'stringWidth', node.getSubStringLength(0, finalPos))
	            },
	            */
	
	            /**
	             * Returns white for dark colors and black for bright colors.
	             *
	             * @param {ColorString} rgba - The color to get the contrast for.
	             * @returns {string} The contrast color, either `#000000` or `#FFFFFF`.
	             */
	            getContrast: function(rgba) {
	                rgba = color(rgba).rgba;
	
	                // The threshold may be discussed. Here's a proposal for adding
	                // different weight to the color channels (#6216)
	                /*
	        rgba[0] *= 1; // red
	        rgba[1] *= 1.2; // green
	        rgba[2] *= 0.7; // blue
	        */
	
	                return rgba[0] + rgba[1] + rgba[2] > 2 * 255 ? '#000000' : '#FFFFFF';
	            },
	
	            /**
	             * Create a button with preset states.
	             * @param {string} text - The text or HTML to draw.
	             * @param {number} x - The x position of the button's left side.
	             * @param {number} y - The y position of the button's top side.
	             * @param {Function} callback - The function to execute on button click or 
	             *    touch.
	             * @param {SVGAttributes} [normalState] - SVG attributes for the normal
	             *    state.
	             * @param {SVGAttributes} [hoverState] - SVG attributes for the hover state.
	             * @param {SVGAttributes} [pressedState] - SVG attributes for the pressed
	             *    state.
	             * @param {SVGAttributes} [disabledState] - SVG attributes for the disabled
	             *    state.
	             * @param {Symbol} [shape=rect] - The shape type.
	             * @returns {SVGRenderer} The button element.
	             */
	            button: function(text, x, y, callback, normalState, hoverState, pressedState, disabledState, shape) {
	                var label = this.label(text, x, y, shape, null, null, null, null, 'button'),
	                    curState = 0;
	
	                // Default, non-stylable attributes
	                label.attr(merge({
	                    'padding': 8,
	                    'r': 2
	                }, normalState));
	
	
	                // Presentational
	                var normalStyle,
	                    hoverStyle,
	                    pressedStyle,
	                    disabledStyle;
	
	                // Normal state - prepare the attributes
	                normalState = merge({
	                    fill: '#f7f7f7',
	                    stroke: '#cccccc',
	                    'stroke-width': 1,
	                    style: {
	                        color: '#333333',
	                        cursor: 'pointer',
	                        fontWeight: 'normal'
	                    }
	                }, normalState);
	                normalStyle = normalState.style;
	                delete normalState.style;
	
	                // Hover state
	                hoverState = merge(normalState, {
	                    fill: '#e6e6e6'
	                }, hoverState);
	                hoverStyle = hoverState.style;
	                delete hoverState.style;
	
	                // Pressed state
	                pressedState = merge(normalState, {
	                    fill: '#e6ebf5',
	                    style: {
	                        color: '#000000',
	                        fontWeight: 'bold'
	                    }
	                }, pressedState);
	                pressedStyle = pressedState.style;
	                delete pressedState.style;
	
	                // Disabled state
	                disabledState = merge(normalState, {
	                    style: {
	                        color: '#cccccc'
	                    }
	                }, disabledState);
	                disabledStyle = disabledState.style;
	                delete disabledState.style;
	
	
	                // Add the events. IE9 and IE10 need mouseover and mouseout to funciton (#667).
	                addEvent(label.element, isMS ? 'mouseover' : 'mouseenter', function() {
	                    if (curState !== 3) {
	                        label.setState(1);
	                    }
	                });
	                addEvent(label.element, isMS ? 'mouseout' : 'mouseleave', function() {
	                    if (curState !== 3) {
	                        label.setState(curState);
	                    }
	                });
	
	                label.setState = function(state) {
	                    // Hover state is temporary, don't record it
	                    if (state !== 1) {
	                        label.state = curState = state;
	                    }
	                    // Update visuals
	                    label.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/)
	                        .addClass('highcharts-button-' + ['normal', 'hover', 'pressed', 'disabled'][state || 0]);
	
	
	                    label.attr([normalState, hoverState, pressedState, disabledState][state || 0])
	                        .css([normalStyle, hoverStyle, pressedStyle, disabledStyle][state || 0]);
	
	                };
	
	
	
	                // Presentational attributes
	                label
	                    .attr(normalState)
	                    .css(extend({
	                        cursor: 'default'
	                    }, normalStyle));
	
	
	                return label
	                    .on('click', function(e) {
	                        if (curState !== 3) {
	                            callback.call(label, e);
	                        }
	                    });
	            },
	
	            /**
	             * Make a straight line crisper by not spilling out to neighbour pixels.
	             * 
	             * @param {Array} points - The original points on the format `['M', 0, 0,
	             *    'L', 100, 0]`.
	             * @param {number} width - The width of the line.
	             * @returns {Array} The original points array, but modified to render
	             * crisply.
	             */
	            crispLine: function(points, width) {
	                // normalize to a crisp line
	                if (points[1] === points[4]) {
	                    // Substract due to #1129. Now bottom and left axis gridlines behave the same.
	                    points[1] = points[4] = Math.round(points[1]) - (width % 2 / 2);
	                }
	                if (points[2] === points[5]) {
	                    points[2] = points[5] = Math.round(points[2]) + (width % 2 / 2);
	                }
	                return points;
	            },
	
	
	            /**
	             * Draw a path, wraps the SVG `path` element.
	             * 
	             * @param {Array} [path] An SVG path definition in array form.
	             * 
	             * @example
	             * var path = renderer.path(['M', 10, 10, 'L', 30, 30, 'z'])
	             *     .attr({ stroke: '#ff00ff' })
	             *     .add();
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-path-on-chart/
	             *         Draw a path in a chart
	             * @sample highcharts/members/renderer-path/
	             *         Draw a path independent from a chart
	             *
	             */
	            /**
	             * Draw a path, wraps the SVG `path` element.
	             * 
	             * @param {SVGAttributes} [attribs] The initial attributes.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            path: function(path) {
	                var attribs = {
	
	                    fill: 'none'
	
	                };
	                if (isArray(path)) {
	                    attribs.d = path;
	                } else if (isObject(path)) { // attributes
	                    extend(attribs, path);
	                }
	                return this.createElement('path').attr(attribs);
	            },
	
	            /**
	             * Draw a circle, wraps the SVG `circle` element.
	             * 
	             * @param {number} [x] The center x position.
	             * @param {number} [y] The center y position.
	             * @param {number} [r] The radius.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-circle/ Drawing a circle
	             */
	            /**
	             * Draw a circle, wraps the SVG `circle` element.
	             * 
	             * @param {SVGAttributes} [attribs] The initial attributes.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            circle: function(x, y, r) {
	                var attribs = isObject(x) ? x : {
	                        x: x,
	                        y: y,
	                        r: r
	                    },
	                    wrapper = this.createElement('circle');
	
	                // Setting x or y translates to cx and cy
	                wrapper.xSetter = wrapper.ySetter = function(value, key, element) {
	                    element.setAttribute('c' + key, value);
	                };
	
	                return wrapper.attr(attribs);
	            },
	
	            /**
	             * Draw and return an arc.
	             * @param {number} [x=0] Center X position.
	             * @param {number} [y=0] Center Y position.
	             * @param {number} [r=0] The outer radius of the arc.
	             * @param {number} [innerR=0] Inner radius like used in donut charts.
	             * @param {number} [start=0] The starting angle of the arc in radians, where
	             *    0 is to the right and `-Math.PI/2` is up.
	             * @param {number} [end=0] The ending angle of the arc in radians, where 0
	             *    is to the right and `-Math.PI/2` is up.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-arc/
	             *         Drawing an arc
	             */
	            /**
	             * Draw and return an arc. Overloaded function that takes arguments object.
	             * @param {SVGAttributes} attribs Initial SVG attributes.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            arc: function(x, y, r, innerR, start, end) {
	                var arc,
	                    options;
	
	                if (isObject(x)) {
	                    options = x;
	                    y = options.y;
	                    r = options.r;
	                    innerR = options.innerR;
	                    start = options.start;
	                    end = options.end;
	                    x = options.x;
	                } else {
	                    options = {
	                        innerR: innerR,
	                        start: start,
	                        end: end
	                    };
	                }
	
	                // Arcs are defined as symbols for the ability to set
	                // attributes in attr and animate
	                arc = this.symbol('arc', x, y, r, r, options);
	                arc.r = r; // #959
	                return arc;
	            },
	
	            /**
	             * Draw and return a rectangle.
	             * @param {number} [x] Left position.
	             * @param {number} [y] Top position.
	             * @param {number} [width] Width of the rectangle.
	             * @param {number} [height] Height of the rectangle.
	             * @param {number} [r] Border corner radius.
	             * @param {number} [strokeWidth] A stroke width can be supplied to allow
	             *    crisp drawing.
	             * @returns {SVGElement} The generated wrapper element.
	             */
	            /**
	             * Draw and return a rectangle.
	             * @param  {SVGAttributes} [attributes]
	             *         General SVG attributes for the rectangle.
	             * @return {SVGElement}
	             *         The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-rect-on-chart/
	             *         Draw a rectangle in a chart
	             * @sample highcharts/members/renderer-rect/
	             *         Draw a rectangle independent from a chart
	             */
	            rect: function(x, y, width, height, r, strokeWidth) {
	
	                r = isObject(x) ? x.r : r;
	
	                var wrapper = this.createElement('rect'),
	                    attribs = isObject(x) ? x : x === undefined ? {} : {
	                        x: x,
	                        y: y,
	                        width: Math.max(width, 0),
	                        height: Math.max(height, 0)
	                    };
	
	
	                if (strokeWidth !== undefined) {
	                    attribs.strokeWidth = strokeWidth;
	                    attribs = wrapper.crisp(attribs);
	                }
	                attribs.fill = 'none';
	
	
	                if (r) {
	                    attribs.r = r;
	                }
	
	                wrapper.rSetter = function(value, key, element) {
	                    attr(element, {
	                        rx: value,
	                        ry: value
	                    });
	                };
	
	                return wrapper.attr(attribs);
	            },
	
	            /**
	             * Resize the {@link SVGRenderer#box} and re-align all aligned child
	             * elements.
	             * @param  {number} width
	             *         The new pixel width.
	             * @param  {number} height
	             *         The new pixel height.
	             * @param  {Boolean|AnimationOptions} [animate=true]
	             *         Whether and how to animate.
	             */
	            setSize: function(width, height, animate) {
	                var renderer = this,
	                    alignedObjects = renderer.alignedObjects,
	                    i = alignedObjects.length;
	
	                renderer.width = width;
	                renderer.height = height;
	
	                renderer.boxWrapper.animate({
	                    width: width,
	                    height: height
	                }, {
	                    step: function() {
	                        this.attr({
	                            viewBox: '0 0 ' + this.attr('width') + ' ' + this.attr('height')
	                        });
	                    },
	                    duration: pick(animate, true) ? undefined : 0
	                });
	
	                while (i--) {
	                    alignedObjects[i].align();
	                }
	            },
	
	            /**
	             * Create and return an svg group element. Child {@link Highcharts.SVGElement}
	             * objects are added to the group by using the group as the first parameter
	             * in {@link Highcharts.SVGElement#add|add()}.
	             * 
	             * @param {string} [name] The group will be given a class name of
	             * `highcharts-{name}`. This can be used for styling and scripting.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-g/
	             *         Show and hide grouped objects
	             */
	            g: function(name) {
	                var elem = this.createElement('g');
	                return name ? elem.attr({
	                    'class': 'highcharts-' + name
	                }) : elem;
	            },
	
	            /**
	             * Display an image.
	             * @param {string} src The image source.
	             * @param {number} [x] The X position.
	             * @param {number} [y] The Y position.
	             * @param {number} [width] The image width. If omitted, it defaults to the 
	             *    image file width.
	             * @param {number} [height] The image height. If omitted it defaults to the
	             *    image file height.
	             * @returns {SVGElement} The generated wrapper element.
	             *
	             * @sample highcharts/members/renderer-image-on-chart/
	             *         Add an image in a chart
	             * @sample highcharts/members/renderer-image/
	             *         Add an image independent of a chart
	             */
	            image: function(src, x, y, width, height) {
	                var attribs = {
	                        preserveAspectRatio: 'none'
	                    },
	                    elemWrapper;
	
	                // optional properties
	                if (arguments.length > 1) {
	                    extend(attribs, {
	                        x: x,
	                        y: y,
	                        width: width,
	                        height: height
	                    });
	                }
	
	                elemWrapper = this.createElement('image').attr(attribs);
	
	                // set the href in the xlink namespace
	                if (elemWrapper.element.setAttributeNS) {
	                    elemWrapper.element.setAttributeNS('http://www.w3.org/1999/xlink',
	                        'href', src);
	                } else {
	                    // could be exporting in IE
	                    // using href throws "not supported" in ie7 and under, requries regex shim to fix later
	                    elemWrapper.element.setAttribute('hc-svg-href', src);
	                }
	                return elemWrapper;
	            },
	
	            /**
	             * Draw a symbol out of pre-defined shape paths from {@link SVGRenderer#symbols}.
	             * It is used in Highcharts for point makers, which cake a `symbol` option,
	             * and label and button backgrounds like in the tooltip and stock flags.
	             *
	             * @param {Symbol} symbol - The symbol name.
	             * @param {number} x - The X coordinate for the top left position.
	             * @param {number} y - The Y coordinate for the top left position.
	             * @param {number} width - The pixel width.
	             * @param {number} height - The pixel height.
	             * @param {Object} [options] - Additional options, depending on the actual
	             *    symbol drawn. 
	             * @param {number} [options.anchorX] - The anchor X position for the
	             *    `callout` symbol. This is where the chevron points to.
	             * @param {number} [options.anchorY] - The anchor Y position for the
	             *    `callout` symbol. This is where the chevron points to.
	             * @param {number} [options.end] - The end angle of an `arc` symbol.
	             * @param {boolean} [options.open] - Whether to draw `arc` symbol open or
	             *    closed.
	             * @param {number} [options.r] - The radius of an `arc` symbol, or the
	             *    border radius for the `callout` symbol.
	             * @param {number} [options.start] - The start angle of an `arc` symbol.
	             */
	            symbol: function(symbol, x, y, width, height, options) {
	
	                var ren = this,
	                    obj,
	                    imageRegex = /^url\((.*?)\)$/,
	                    isImage = imageRegex.test(symbol),
	                    sym = !isImage && (this.symbols[symbol] ? symbol : 'circle'),
	
	
	                    // get the symbol definition function
	                    symbolFn = sym && this.symbols[sym],
	
	                    // check if there's a path defined for this symbol
	                    path = defined(x) && symbolFn && symbolFn.call(
	                        this.symbols,
	                        Math.round(x),
	                        Math.round(y),
	                        width,
	                        height,
	                        options
	                    ),
	                    imageSrc,
	                    centerImage;
	
	                if (symbolFn) {
	                    obj = this.path(path);
	
	
	                    obj.attr('fill', 'none');
	
	
	                    // expando properties for use in animate and attr
	                    extend(obj, {
	                        symbolName: sym,
	                        x: x,
	                        y: y,
	                        width: width,
	                        height: height
	                    });
	                    if (options) {
	                        extend(obj, options);
	                    }
	
	
	                    // Image symbols
	                } else if (isImage) {
	
	
	                    imageSrc = symbol.match(imageRegex)[1];
	
	                    // Create the image synchronously, add attribs async
	                    obj = this.image(imageSrc);
	
	                    // The image width is not always the same as the symbol width. The
	                    // image may be centered within the symbol, as is the case when
	                    // image shapes are used as label backgrounds, for example in flags.
	                    obj.imgwidth = pick(
	                        symbolSizes[imageSrc] && symbolSizes[imageSrc].width,
	                        options && options.width
	                    );
	                    obj.imgheight = pick(
	                        symbolSizes[imageSrc] && symbolSizes[imageSrc].height,
	                        options && options.height
	                    );
	                    /**
	                     * Set the size and position
	                     */
	                    centerImage = function() {
	                        obj.attr({
	                            width: obj.width,
	                            height: obj.height
	                        });
	                    };
	
	                    /**
	                     * Width and height setters that take both the image's physical size
	                     * and the label size into consideration, and translates the image
	                     * to center within the label.
	                     */
	                    each(['width', 'height'], function(key) {
	                        obj[key + 'Setter'] = function(value, key) {
	                            var attribs = {},
	                                imgSize = this['img' + key],
	                                trans = key === 'width' ? 'translateX' : 'translateY';
	                            this[key] = value;
	                            if (defined(imgSize)) {
	                                if (this.element) {
	                                    this.element.setAttribute(key, imgSize);
	                                }
	                                if (!this.alignByTranslate) {
	                                    attribs[trans] = ((this[key] || 0) - imgSize) / 2;
	                                    this.attr(attribs);
	                                }
	                            }
	                        };
	                    });
	
	
	                    if (defined(x)) {
	                        obj.attr({
	                            x: x,
	                            y: y
	                        });
	                    }
	                    obj.isImg = true;
	
	                    if (defined(obj.imgwidth) && defined(obj.imgheight)) {
	                        centerImage();
	                    } else {
	                        // Initialize image to be 0 size so export will still function if there's no cached sizes.
	                        obj.attr({
	                            width: 0,
	                            height: 0
	                        });
	
	                        // Create a dummy JavaScript image to get the width and height. Due to a bug in IE < 8,
	                        // the created element must be assigned to a variable in order to load (#292).
	                        createElement('img', {
	                            onload: function() {
	
	                                var chart = charts[ren.chartIndex];
	
	                                // Special case for SVGs on IE11, the width is not accessible until the image is
	                                // part of the DOM (#2854).
	                                if (this.width === 0) {
	                                    css(this, {
	                                        position: 'absolute',
	                                        top: '-999em'
	                                    });
	                                    doc.body.appendChild(this);
	                                }
	
	                                // Center the image
	                                symbolSizes[imageSrc] = { // Cache for next	
	                                    width: this.width,
	                                    height: this.height
	                                };
	                                obj.imgwidth = this.width;
	                                obj.imgheight = this.height;
	
	                                if (obj.element) {
	                                    centerImage();
	                                }
	
	                                // Clean up after #2854 workaround.
	                                if (this.parentNode) {
	                                    this.parentNode.removeChild(this);
	                                }
	
	                                // Fire the load event when all external images are loaded
	                                ren.imgCount--;
	                                if (!ren.imgCount && chart && chart.onload) {
	                                    chart.onload();
	                                }
	                            },
	                            src: imageSrc
	                        });
	                        this.imgCount++;
	                    }
	                }
	
	                return obj;
	            },
	
	            /**
	             * @typedef {string} Symbol
	             * 
	             * Can be one of `arc`, `callout`, `circle`, `diamond`, `square`,
	             * `triangle`, `triangle-down`. Symbols are used internally for point
	             * markers, button and label borders and backgrounds, or custom shapes.
	             * Extendable by adding to {@link SVGRenderer#symbols}.
	             */
	            /**
	             * An extendable collection of functions for defining symbol paths.
	             */
	            symbols: {
	                'circle': function(x, y, w, h) {
	                    // Return a full arc
	                    return this.arc(x + w / 2, y + h / 2, w / 2, h / 2, {
	                        start: 0,
	                        end: Math.PI * 2,
	                        open: false
	                    });
	                },
	
	                'square': function(x, y, w, h) {
	                    return [
	                        'M', x, y,
	                        'L', x + w, y,
	                        x + w, y + h,
	                        x, y + h,
	                        'Z'
	                    ];
	                },
	
	                'triangle': function(x, y, w, h) {
	                    return [
	                        'M', x + w / 2, y,
	                        'L', x + w, y + h,
	                        x, y + h,
	                        'Z'
	                    ];
	                },
	
	                'triangle-down': function(x, y, w, h) {
	                    return [
	                        'M', x, y,
	                        'L', x + w, y,
	                        x + w / 2, y + h,
	                        'Z'
	                    ];
	                },
	                'diamond': function(x, y, w, h) {
	                    return [
	                        'M', x + w / 2, y,
	                        'L', x + w, y + h / 2,
	                        x + w / 2, y + h,
	                        x, y + h / 2,
	                        'Z'
	                    ];
	                },
	                'arc': function(x, y, w, h, options) {
	                    var start = options.start,
	                        rx = options.r || w,
	                        ry = options.r || h || w,
	                        proximity = 0.001,
	                        fullCircle =
	                        Math.abs(options.end - options.start - 2 * Math.PI) <
	                        proximity,
	                        // Substract a small number to prevent cos and sin of start and
	                        // end from becoming equal on 360 arcs (related: #1561)
	                        end = options.end - proximity,
	                        innerRadius = options.innerR,
	                        open = pick(options.open, fullCircle),
	                        cosStart = Math.cos(start),
	                        sinStart = Math.sin(start),
	                        cosEnd = Math.cos(end),
	                        sinEnd = Math.sin(end),
	                        // Proximity takes care of rounding errors around PI (#6971)
	                        longArc = options.end - start - Math.PI < proximity ? 0 : 1,
	                        arc;
	
	                    arc = [
	                        'M',
	                        x + rx * cosStart,
	                        y + ry * sinStart,
	                        'A', // arcTo
	                        rx, // x radius
	                        ry, // y radius
	                        0, // slanting
	                        longArc, // long or short arc
	                        1, // clockwise
	                        x + rx * cosEnd,
	                        y + ry * sinEnd
	                    ];
	
	                    if (defined(innerRadius)) {
	                        arc.push(
	                            open ? 'M' : 'L',
	                            x + innerRadius * cosEnd,
	                            y + innerRadius * sinEnd,
	                            'A', // arcTo
	                            innerRadius, // x radius
	                            innerRadius, // y radius
	                            0, // slanting
	                            longArc, // long or short arc
	                            0, // clockwise
	                            x + innerRadius * cosStart,
	                            y + innerRadius * sinStart
	                        );
	                    }
	
	                    arc.push(open ? '' : 'Z'); // close
	                    return arc;
	                },
	
	                /**
	                 * Callout shape used for default tooltips, also used for rounded rectangles in VML
	                 */
	                callout: function(x, y, w, h, options) {
	                    var arrowLength = 6,
	                        halfDistance = 6,
	                        r = Math.min((options && options.r) || 0, w, h),
	                        safeDistance = r + halfDistance,
	                        anchorX = options && options.anchorX,
	                        anchorY = options && options.anchorY,
	                        path;
	
	                    path = [
	                        'M', x + r, y,
	                        'L', x + w - r, y, // top side
	                        'C', x + w, y, x + w, y, x + w, y + r, // top-right corner
	                        'L', x + w, y + h - r, // right side
	                        'C', x + w, y + h, x + w, y + h, x + w - r, y + h, // bottom-right corner
	                        'L', x + r, y + h, // bottom side
	                        'C', x, y + h, x, y + h, x, y + h - r, // bottom-left corner
	                        'L', x, y + r, // left side
	                        'C', x, y, x, y, x + r, y // top-left corner
	                    ];
	
	                    // Anchor on right side
	                    if (anchorX && anchorX > w) {
	
	                        // Chevron
	                        if (anchorY > y + safeDistance && anchorY < y + h - safeDistance) {
	                            path.splice(13, 3,
	                                'L', x + w, anchorY - halfDistance,
	                                x + w + arrowLength, anchorY,
	                                x + w, anchorY + halfDistance,
	                                x + w, y + h - r
	                            );
	
	                            // Simple connector
	                        } else {
	                            path.splice(13, 3,
	                                'L', x + w, h / 2,
	                                anchorX, anchorY,
	                                x + w, h / 2,
	                                x + w, y + h - r
	                            );
	                        }
	
	                        // Anchor on left side
	                    } else if (anchorX && anchorX < 0) {
	
	                        // Chevron
	                        if (anchorY > y + safeDistance && anchorY < y + h - safeDistance) {
	                            path.splice(33, 3,
	                                'L', x, anchorY + halfDistance,
	                                x - arrowLength, anchorY,
	                                x, anchorY - halfDistance,
	                                x, y + r
	                            );
	
	                            // Simple connector
	                        } else {
	                            path.splice(33, 3,
	                                'L', x, h / 2,
	                                anchorX, anchorY,
	                                x, h / 2,
	                                x, y + r
	                            );
	                        }
	
	                    } else if (anchorY && anchorY > h && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace bottom
	                        path.splice(23, 3,
	                            'L', anchorX + halfDistance, y + h,
	                            anchorX, y + h + arrowLength,
	                            anchorX - halfDistance, y + h,
	                            x + r, y + h
	                        );
	                    } else if (anchorY && anchorY < 0 && anchorX > x + safeDistance && anchorX < x + w - safeDistance) { // replace top
	                        path.splice(3, 3,
	                            'L', anchorX - halfDistance, y,
	                            anchorX, y - arrowLength,
	                            anchorX + halfDistance, y,
	                            w - r, y
	                        );
	                    }
	
	                    return path;
	                }
	            },
	
	            /**
	             * @typedef {SVGElement} ClipRect - A clipping rectangle that can be applied
	             * to one or more {@link SVGElement} instances. It is instanciated with the
	             * {@link SVGRenderer#clipRect} function and applied with the {@link 
	             * SVGElement#clip} function.
	             *
	             * @example
	             * var circle = renderer.circle(100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .add();
	             * var clipRect = renderer.clipRect(100, 100, 100, 100);
	             *
	             * // Leave only the lower right quarter visible
	             * circle.clip(clipRect);
	             */
	            /**
	             * Define a clipping rectangle. The clipping rectangle is later applied
	             * to {@link SVGElement} objects through the {@link SVGElement#clip}
	             * function.
	             * 
	             * @param {String} id
	             * @param {number} x
	             * @param {number} y
	             * @param {number} width
	             * @param {number} height
	             * @returns {ClipRect} A clipping rectangle.
	             *
	             * @example
	             * var circle = renderer.circle(100, 100, 100)
	             *     .attr({ fill: 'red' })
	             *     .add();
	             * var clipRect = renderer.clipRect(100, 100, 100, 100);
	             *
	             * // Leave only the lower right quarter visible
	             * circle.clip(clipRect);
	             */
	            clipRect: function(x, y, width, height) {
	                var wrapper,
	                    id = H.uniqueKey(),
	
	                    clipPath = this.createElement('clipPath').attr({
	                        id: id
	                    }).add(this.defs);
	
	                wrapper = this.rect(x, y, width, height, 0).add(clipPath);
	                wrapper.id = id;
	                wrapper.clipPath = clipPath;
	                wrapper.count = 0;
	
	                return wrapper;
	            },
	
	
	
	
	
	            /**
	             * Draw text. The text can contain a subset of HTML, like spans and anchors
	             * and some basic text styling of these. For more advanced features like
	             * border and background, use {@link Highcharts.SVGRenderer#label} instead.
	             * To update the text after render, run `text.attr({ text: 'New text' })`.
	             * @param  {String} str
	             *         The text of (subset) HTML to draw.
	             * @param  {number} x
	             *         The x position of the text's lower left corner.
	             * @param  {number} y
	             *         The y position of the text's lower left corner.
	             * @param  {Boolean} [useHTML=false]
	             *         Use HTML to render the text.
	             *
	             * @return {SVGElement} The text object.
	             *
	             * @sample highcharts/members/renderer-text-on-chart/
	             *         Annotate the chart freely
	             * @sample highcharts/members/renderer-on-chart/
	             *         Annotate with a border and in response to the data
	             * @sample highcharts/members/renderer-text/
	             *         Formatted text
	             */
	            text: function(str, x, y, useHTML) {
	
	                // declare variables
	                var renderer = this,
	                    fakeSVG = !svg && renderer.forExport,
	                    wrapper,
	                    attribs = {};
	
	                if (useHTML && (renderer.allowHTML || !renderer.forExport)) {
	                    return renderer.html(str, x, y);
	                }
	
	                attribs.x = Math.round(x || 0); // X is always needed for line-wrap logic
	                if (y) {
	                    attribs.y = Math.round(y);
	                }
	                if (str || str === 0) {
	                    attribs.text = str;
	                }
	
	                wrapper = renderer.createElement('text')
	                    .attr(attribs);
	
	                // Prevent wrapping from creating false offsetWidths in export in legacy IE (#1079, #1063)
	                if (fakeSVG) {
	                    wrapper.css({
	                        position: 'absolute'
	                    });
	                }
	
	                if (!useHTML) {
	                    wrapper.xSetter = function(value, key, element) {
	                        var tspans = element.getElementsByTagName('tspan'),
	                            tspan,
	                            parentVal = element.getAttribute(key),
	                            i;
	                        for (i = 0; i < tspans.length; i++) {
	                            tspan = tspans[i];
	                            // If the x values are equal, the tspan represents a linebreak
	                            if (tspan.getAttribute(key) === parentVal) {
	                                tspan.setAttribute(key, value);
	                            }
	                        }
	                        element.setAttribute(key, value);
	                    };
	                }
	
	                return wrapper;
	            },
	
	            /**
	             * Utility to return the baseline offset and total line height from the font
	             * size.
	             *
	             * @param {?string} fontSize The current font size to inspect. If not given,
	             *   the font size will be found from the DOM element.
	             * @param {SVGElement|SVGDOMElement} [elem] The element to inspect for a
	             *   current font size.
	             * @returns {Object} An object containing `h`: the line height, `b`: the
	             * baseline relative to the top of the box, and `f`: the font size.
	             */
	            fontMetrics: function(fontSize, elem) {
	                var lineHeight,
	                    baseline;
	
	
	                fontSize = fontSize ||
	                    // When the elem is a DOM element (#5932)
	                    (elem && elem.style && elem.style.fontSize) ||
	                    // Fall back on the renderer style default
	                    (this.style && this.style.fontSize);
	
	
	
	                // Handle different units
	                if (/px/.test(fontSize)) {
	                    fontSize = pInt(fontSize);
	                } else if (/em/.test(fontSize)) {
	                    // The em unit depends on parent items
	                    fontSize = parseFloat(fontSize) *
	                        (elem ? this.fontMetrics(null, elem.parentNode).f : 16);
	                } else {
	                    fontSize = 12;
	                }
	
	                // Empirical values found by comparing font size and bounding box
	                // height. Applies to the default font family.
	                // http://jsfiddle.net/highcharts/7xvn7/
	                lineHeight = fontSize < 24 ? fontSize + 3 : Math.round(fontSize * 1.2);
	                baseline = Math.round(lineHeight * 0.8);
	
	                return {
	                    h: lineHeight,
	                    b: baseline,
	                    f: fontSize
	                };
	            },
	
	            /**
	             * Correct X and Y positioning of a label for rotation (#1764).
	             *
	             * @private
	             */
	            rotCorr: function(baseline, rotation, alterY) {
	                var y = baseline;
	                if (rotation && alterY) {
	                    y = Math.max(y * Math.cos(rotation * deg2rad), 4);
	                }
	                return {
	                    x: (-baseline / 3) * Math.sin(rotation * deg2rad),
	                    y: y
	                };
	            },
	
	            /**
	             * Draw a label, which is an extended text element with support for border
	             * and background. Highcharts creates a `g` element with a text and a `path`
	             * or `rect` inside, to make it behave somewhat like a HTML div. Border and
	             * background are set through `stroke`, `stroke-width` and `fill` attributes
	             * using the {@link Highcharts.SVGElement#attr|attr} method. To update the
	             * text after render, run `label.attr({ text: 'New text' })`.
	             * 
	             * @param  {string} str
	             *         The initial text string or (subset) HTML to render.
	             * @param  {number} x
	             *         The x position of the label's left side.
	             * @param  {number} y
	             *         The y position of the label's top side or baseline, depending on
	             *         the `baseline` parameter.
	             * @param  {String} shape
	             *         The shape of the label's border/background, if any. Defaults to
	             *         `rect`. Other possible values are `callout` or other shapes
	             *         defined in {@link Highcharts.SVGRenderer#symbols}.
	             * @param  {number} anchorX
	             *         In case the `shape` has a pointer, like a flag, this is the
	             *         coordinates it should be pinned to.
	             * @param  {number} anchorY
	             *         In case the `shape` has a pointer, like a flag, this is the
	             *         coordinates it should be pinned to.
	             * @param  {Boolean} baseline
	             *         Whether to position the label relative to the text baseline,
	             *	       like {@link Highcharts.SVGRenderer#text|renderer.text}, or to the
	             *	       upper border of the rectangle.
	             * @param  {String} className
	             *         Class name for the group.
	             *
	             * @return {SVGElement}
	             *         The generated label.
	             *
	             * @sample highcharts/members/renderer-label-on-chart/
	             *         A label on the chart
	             */
	            label: function(str, x, y, shape, anchorX, anchorY, useHTML, baseline, className) {
	
	                var renderer = this,
	                    wrapper = renderer.g(className !== 'button' && 'label'),
	                    text = wrapper.text = renderer.text('', 0, 0, useHTML)
	                    .attr({
	                        zIndex: 1
	                    }),
	                    box,
	                    bBox,
	                    alignFactor = 0,
	                    padding = 3,
	                    paddingLeft = 0,
	                    width,
	                    height,
	                    wrapperX,
	                    wrapperY,
	                    textAlign,
	                    deferredAttr = {},
	                    strokeWidth,
	                    baselineOffset,
	                    hasBGImage = /^url\((.*?)\)$/.test(shape),
	                    needsBox = hasBGImage,
	                    getCrispAdjust,
	                    updateBoxSize,
	                    updateTextPadding,
	                    boxAttr;
	
	                if (className) {
	                    wrapper.addClass('highcharts-' + className);
	                }
	
	
	                needsBox = hasBGImage;
	                getCrispAdjust = function() {
	                    return (strokeWidth || 0) % 2 / 2;
	                };
	
	
	
	                /**
	                 * This function runs after the label is added to the DOM (when the bounding box is
	                 * available), and after the text of the label is updated to detect the new bounding
	                 * box and reflect it in the border box.
	                 */
	                updateBoxSize = function() {
	                    var style = text.element.style,
	                        crispAdjust,
	                        attribs = {};
	
	                    bBox = (width === undefined || height === undefined || textAlign) && defined(text.textStr) &&
	                        text.getBBox(); //#3295 && 3514 box failure when string equals 0
	                    wrapper.width = (width || bBox.width || 0) + 2 * padding + paddingLeft;
	                    wrapper.height = (height || bBox.height || 0) + 2 * padding;
	
	                    // Update the label-scoped y offset
	                    baselineOffset = padding + renderer.fontMetrics(style && style.fontSize, text).b;
	
	
	                    if (needsBox) {
	
	                        // Create the border box if it is not already present
	                        if (!box) {
	                            wrapper.box = box = renderer.symbols[shape] || hasBGImage ? // Symbol definition exists (#5324)
	                                renderer.symbol(shape) :
	                                renderer.rect();
	
	                            box.addClass(
	                                (className === 'button' ? '' : 'highcharts-label-box') + // Don't use label className for buttons
	                                (className ? ' highcharts-' + className + '-box' : '')
	                            );
	
	                            box.add(wrapper);
	
	                            crispAdjust = getCrispAdjust();
	                            attribs.x = crispAdjust;
	                            attribs.y = (baseline ? -baselineOffset : 0) + crispAdjust;
	                        }
	
	                        // Apply the box attributes
	                        attribs.width = Math.round(wrapper.width);
	                        attribs.height = Math.round(wrapper.height);
	
	                        box.attr(extend(attribs, deferredAttr));
	                        deferredAttr = {};
	                    }
	                };
	
	                /**
	                 * This function runs after setting text or padding, but only if padding is changed
	                 */
	                updateTextPadding = function() {
	                    var textX = paddingLeft + padding,
	                        textY;
	
	                    // determin y based on the baseline
	                    textY = baseline ? 0 : baselineOffset;
	
	                    // compensate for alignment
	                    if (defined(width) && bBox && (textAlign === 'center' || textAlign === 'right')) {
	                        textX += {
	                            center: 0.5,
	                            right: 1
	                        }[textAlign] * (width - bBox.width);
	                    }
	
	                    // update if anything changed
	                    if (textX !== text.x || textY !== text.y) {
	                        text.attr('x', textX);
	                        if (textY !== undefined) {
	                            text.attr('y', textY);
	                        }
	                    }
	
	                    // record current values
	                    text.x = textX;
	                    text.y = textY;
	                };
	
	                /**
	                 * Set a box attribute, or defer it if the box is not yet created
	                 * @param {Object} key
	                 * @param {Object} value
	                 */
	                boxAttr = function(key, value) {
	                    if (box) {
	                        box.attr(key, value);
	                    } else {
	                        deferredAttr[key] = value;
	                    }
	                };
	
	                /**
	                 * After the text element is added, get the desired size of the border box
	                 * and add it before the text in the DOM.
	                 */
	                wrapper.onAdd = function() {
	                    text.add(wrapper);
	                    wrapper.attr({
	                        text: (str || str === 0) ? str : '', // alignment is available now // #3295: 0 not rendered if given as a value
	                        x: x,
	                        y: y
	                    });
	
	                    if (box && defined(anchorX)) {
	                        wrapper.attr({
	                            anchorX: anchorX,
	                            anchorY: anchorY
	                        });
	                    }
	                };
	
	                /*
	                 * Add specific attribute setters.
	                 */
	
	                // only change local variables
	                wrapper.widthSetter = function(value) {
	                    width = H.isNumber(value) ? value : null; // width:auto => null
	                };
	                wrapper.heightSetter = function(value) {
	                    height = value;
	                };
	                wrapper['text-alignSetter'] = function(value) {
	                    textAlign = value;
	                };
	                wrapper.paddingSetter = function(value) {
	                    if (defined(value) && value !== padding) {
	                        padding = wrapper.padding = value;
	                        updateTextPadding();
	                    }
	                };
	                wrapper.paddingLeftSetter = function(value) {
	                    if (defined(value) && value !== paddingLeft) {
	                        paddingLeft = value;
	                        updateTextPadding();
	                    }
	                };
	
	
	                // change local variable and prevent setting attribute on the group
	                wrapper.alignSetter = function(value) {
	                    value = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[value];
	                    if (value !== alignFactor) {
	                        alignFactor = value;
	                        if (bBox) { // Bounding box exists, means we're dynamically changing
	                            wrapper.attr({
	                                x: wrapperX
	                            }); // #5134
	                        }
	                    }
	                };
	
	                // apply these to the box and the text alike
	                wrapper.textSetter = function(value) {
	                    if (value !== undefined) {
	                        text.textSetter(value);
	                    }
	                    updateBoxSize();
	                    updateTextPadding();
	                };
	
	                // apply these to the box but not to the text
	                wrapper['stroke-widthSetter'] = function(value, key) {
	                    if (value) {
	                        needsBox = true;
	                    }
	                    strokeWidth = this['stroke-width'] = value;
	                    boxAttr(key, value);
	                };
	
	                wrapper.strokeSetter = wrapper.fillSetter = wrapper.rSetter = function(value, key) {
	                    if (key !== 'r') {
	                        if (key === 'fill' && value) {
	                            needsBox = true;
	                        }
	                        // for animation getter (#6776)
	                        wrapper[key] = value;
	                    }
	                    boxAttr(key, value);
	                };
	
	                wrapper.anchorXSetter = function(value, key) {
	                    anchorX = wrapper.anchorX = value;
	                    boxAttr(key, Math.round(value) - getCrispAdjust() - wrapperX);
	                };
	                wrapper.anchorYSetter = function(value, key) {
	                    anchorY = wrapper.anchorY = value;
	                    boxAttr(key, value - wrapperY);
	                };
	
	                // rename attributes
	                wrapper.xSetter = function(value) {
	                    wrapper.x = value; // for animation getter
	                    if (alignFactor) {
	                        value -= alignFactor * ((width || bBox.width) + 2 * padding);
	                    }
	                    wrapperX = Math.round(value);
	                    wrapper.attr('translateX', wrapperX);
	                };
	                wrapper.ySetter = function(value) {
	                    wrapperY = wrapper.y = Math.round(value);
	                    wrapper.attr('translateY', wrapperY);
	                };
	
	                // Redirect certain methods to either the box or the text
	                var baseCss = wrapper.css;
	                return extend(wrapper, {
	                    /**
	                     * Pick up some properties and apply them to the text instead of the
	                     * wrapper.
	                     * @ignore
	                     */
	                    css: function(styles) {
	                        if (styles) {
	                            var textStyles = {};
	                            styles = merge(styles); // create a copy to avoid altering the original object (#537)
	                            each(wrapper.textProps, function(prop) {
	                                if (styles[prop] !== undefined) {
	                                    textStyles[prop] = styles[prop];
	                                    delete styles[prop];
	                                }
	                            });
	                            text.css(textStyles);
	                        }
	                        return baseCss.call(wrapper, styles);
	                    },
	                    /**
	                     * Return the bounding box of the box, not the group.
	                     * @ignore
	                     */
	                    getBBox: function() {
	                        return {
	                            width: bBox.width + 2 * padding,
	                            height: bBox.height + 2 * padding,
	                            x: bBox.x - padding,
	                            y: bBox.y - padding
	                        };
	                    },
	
	                    /**
	                     * Apply the shadow to the box.
	                     * @ignore
	                     */
	                    shadow: function(b) {
	                        if (b) {
	                            updateBoxSize();
	                            if (box) {
	                                box.shadow(b);
	                            }
	                        }
	                        return wrapper;
	                    },
	
	                    /**
	                     * Destroy and release memory.
	                     * @ignore
	                     */
	                    destroy: function() {
	
	                        // Added by button implementation
	                        removeEvent(wrapper.element, 'mouseenter');
	                        removeEvent(wrapper.element, 'mouseleave');
	
	                        if (text) {
	                            text = text.destroy();
	                        }
	                        if (box) {
	                            box = box.destroy();
	                        }
	                        // Call base implementation to destroy the rest
	                        SVGElement.prototype.destroy.call(wrapper);
	
	                        // Release local pointers (#1298)
	                        wrapper = renderer = updateBoxSize = updateTextPadding = boxAttr = null;
	                    }
	                });
	            }
	        }); // end SVGRenderer
	
	
	        // general renderer
	        H.Renderer = SVGRenderer;
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /* eslint max-len: ["warn", 80, 4] */
	        var attr = H.attr,
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            isFirefox = H.isFirefox,
	            isMS = H.isMS,
	            isWebKit = H.isWebKit,
	            pInt = H.pInt,
	            SVGElement = H.SVGElement,
	            SVGRenderer = H.SVGRenderer,
	            win = H.win,
	            wrap = H.wrap;
	
	        // Extend SvgElement for useHTML option
	        extend(SVGElement.prototype, /** @lends SVGElement.prototype */ {
	            /**
	             * Apply CSS to HTML elements. This is used in text within SVG rendering and
	             * by the VML renderer
	             */
	            htmlCss: function(styles) {
	                var wrapper = this,
	                    element = wrapper.element,
	                    textWidth = styles && element.tagName === 'SPAN' && styles.width;
	
	                if (textWidth) {
	                    delete styles.width;
	                    wrapper.textWidth = textWidth;
	                    wrapper.updateTransform();
	                }
	                if (styles && styles.textOverflow === 'ellipsis') {
	                    styles.whiteSpace = 'nowrap';
	                    styles.overflow = 'hidden';
	                }
	                wrapper.styles = extend(wrapper.styles, styles);
	                css(wrapper.element, styles);
	
	                return wrapper;
	            },
	
	            /**
	             * VML and useHTML method for calculating the bounding box based on offsets
	             * @param {Boolean} refresh Whether to force a fresh value from the DOM or
	             * to use the cached value.
	             *
	             * @return {Object} A hash containing values for x, y, width and height
	             */
	
	            htmlGetBBox: function() {
	                var wrapper = this,
	                    element = wrapper.element;
	
	                // faking getBBox in exported SVG in legacy IE (is this a duplicate of
	                // the fix for #1079?)
	                if (element.nodeName === 'text') {
	                    element.style.position = 'absolute';
	                }
	
	                return {
	                    x: element.offsetLeft,
	                    y: element.offsetTop,
	                    width: element.offsetWidth,
	                    height: element.offsetHeight
	                };
	            },
	
	            /**
	             * VML override private method to update elements based on internal
	             * properties based on SVG transform
	             */
	            htmlUpdateTransform: function() {
	                // aligning non added elements is expensive
	                if (!this.added) {
	                    this.alignOnAdd = true;
	                    return;
	                }
	
	                var wrapper = this,
	                    renderer = wrapper.renderer,
	                    elem = wrapper.element,
	                    translateX = wrapper.translateX || 0,
	                    translateY = wrapper.translateY || 0,
	                    x = wrapper.x || 0,
	                    y = wrapper.y || 0,
	                    align = wrapper.textAlign || 'left',
	                    alignCorrection = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[align],
	                    styles = wrapper.styles;
	
	                // apply translate
	                css(elem, {
	                    marginLeft: translateX,
	                    marginTop: translateY
	                });
	
	
	                if (wrapper.shadows) { // used in labels/tooltip
	                    each(wrapper.shadows, function(shadow) {
	                        css(shadow, {
	                            marginLeft: translateX + 1,
	                            marginTop: translateY + 1
	                        });
	                    });
	                }
	
	
	                // apply inversion
	                if (wrapper.inverted) { // wrapper is a group
	                    each(elem.childNodes, function(child) {
	                        renderer.invertChild(child, elem);
	                    });
	                }
	
	                if (elem.tagName === 'SPAN') {
	
	                    var rotation = wrapper.rotation,
	                        baseline,
	                        textWidth = pInt(wrapper.textWidth),
	                        whiteSpace = styles && styles.whiteSpace,
	                        currentTextTransform = [
	                            rotation,
	                            align,
	                            elem.innerHTML,
	                            wrapper.textWidth,
	                            wrapper.textAlign
	                        ].join(',');
	
	                    // Do the calculations and DOM access only if properties changed
	                    if (currentTextTransform !== wrapper.cTT) {
	
	
	                        baseline = renderer.fontMetrics(elem.style.fontSize).b;
	
	                        // Renderer specific handling of span rotation
	                        if (defined(rotation)) {
	                            wrapper.setSpanRotation(
	                                rotation,
	                                alignCorrection,
	                                baseline
	                            );
	                        }
	
	                        // Reset multiline/ellipsis in order to read width (#4928,
	                        // #5417)
	                        css(elem, {
	                            width: '',
	                            whiteSpace: whiteSpace || 'nowrap'
	                        });
	
	                        // Update textWidth
	                        if (
	                            elem.offsetWidth > textWidth &&
	                            /[ \-]/.test(elem.textContent || elem.innerText)
	                        ) { // #983, #1254
	                            css(elem, {
	                                width: textWidth + 'px',
	                                display: 'block',
	                                whiteSpace: whiteSpace || 'normal' // #3331
	                            });
	                        }
	
	
	                        wrapper.getSpanCorrection(
	                            elem.offsetWidth,
	                            baseline,
	                            alignCorrection,
	                            rotation,
	                            align
	                        );
	                    }
	
	                    // apply position with correction
	                    css(elem, {
	                        left: (x + (wrapper.xCorr || 0)) + 'px',
	                        top: (y + (wrapper.yCorr || 0)) + 'px'
	                    });
	
	                    // Force reflow in webkit to apply the left and top on useHTML
	                    // element (#1249)
	                    if (isWebKit) {
	                        // Assigned to baseline for lint purpose
	                        baseline = elem.offsetHeight;
	                    }
	
	                    // record current text transform
	                    wrapper.cTT = currentTextTransform;
	                }
	            },
	
	            /**
	             * Set the rotation of an individual HTML span
	             */
	            setSpanRotation: function(rotation, alignCorrection, baseline) {
	                var rotationStyle = {},
	                    cssTransformKey =
	                    isMS ?
	                    '-ms-transform' :
	                    isWebKit ?
	                    '-webkit-transform' :
	                    isFirefox ?
	                    'MozTransform' :
	                    win.opera ?
	                    '-o-transform' :
	                    '';
	
	                rotationStyle[cssTransformKey] = rotationStyle.transform =
	                    'rotate(' + rotation + 'deg)';
	                rotationStyle[cssTransformKey + (isFirefox ? 'Origin' : '-origin')] =
	                    rotationStyle.transformOrigin =
	                    (alignCorrection * 100) + '% ' + baseline + 'px';
	                css(this.element, rotationStyle);
	            },
	
	            /**
	             * Get the correction in X and Y positioning as the element is rotated.
	             */
	            getSpanCorrection: function(width, baseline, alignCorrection) {
	                this.xCorr = -width * alignCorrection;
	                this.yCorr = -baseline;
	            }
	        });
	
	        // Extend SvgRenderer for useHTML option.
	        extend(SVGRenderer.prototype, /** @lends SVGRenderer.prototype */ {
	            /**
	             * Create HTML text node. This is used by the VML renderer as well as the
	             * SVG renderer through the useHTML option.
	             *
	             * @param {String} str
	             * @param {Number} x
	             * @param {Number} y
	             */
	            html: function(str, x, y) {
	                var wrapper = this.createElement('span'),
	                    element = wrapper.element,
	                    renderer = wrapper.renderer,
	                    isSVG = renderer.isSVG,
	                    addSetters = function(element, style) {
	                        // These properties are set as attributes on the SVG group, and
	                        // as identical CSS properties on the div. (#3542)
	                        each(['opacity', 'visibility'], function(prop) {
	                            wrap(element, prop + 'Setter', function(
	                                proceed,
	                                value,
	                                key,
	                                elem
	                            ) {
	                                proceed.call(this, value, key, elem);
	                                style[key] = value;
	                            });
	                        });
	                    };
	
	                // Text setter
	                wrapper.textSetter = function(value) {
	                    if (value !== element.innerHTML) {
	                        delete this.bBox;
	                    }
	                    element.innerHTML = this.textStr = value;
	                    wrapper.htmlUpdateTransform();
	                };
	
	                // Add setters for the element itself (#4938)
	                if (isSVG) { // #4938, only for HTML within SVG
	                    addSetters(wrapper, wrapper.element.style);
	                }
	
	                // Various setters which rely on update transform
	                wrapper.xSetter =
	                    wrapper.ySetter =
	                    wrapper.alignSetter =
	                    wrapper.rotationSetter =
	                    function(value, key) {
	                        if (key === 'align') {
	                            // Do not overwrite the SVGElement.align method. Same as VML.
	                            key = 'textAlign';
	                        }
	                        wrapper[key] = value;
	                        wrapper.htmlUpdateTransform();
	                    };
	
	                // Set the default attributes
	                wrapper
	                    .attr({
	                        text: str,
	                        x: Math.round(x),
	                        y: Math.round(y)
	                    })
	                    .css({
	
	                        fontFamily: this.style.fontFamily,
	                        fontSize: this.style.fontSize,
	
	                        position: 'absolute'
	                    });
	
	                // Keep the whiteSpace style outside the wrapper.styles collection
	                element.style.whiteSpace = 'nowrap';
	
	                // Use the HTML specific .css method
	                wrapper.css = wrapper.htmlCss;
	
	                // This is specific for HTML within SVG
	                if (isSVG) {
	                    wrapper.add = function(svgGroupWrapper) {
	
	                        var htmlGroup,
	                            container = renderer.box.parentNode,
	                            parentGroup,
	                            parents = [];
	
	                        this.parentGroup = svgGroupWrapper;
	
	                        // Create a mock group to hold the HTML elements
	                        if (svgGroupWrapper) {
	                            htmlGroup = svgGroupWrapper.div;
	                            if (!htmlGroup) {
	
	                                // Read the parent chain into an array and read from top
	                                // down
	                                parentGroup = svgGroupWrapper;
	                                while (parentGroup) {
	
	                                    parents.push(parentGroup);
	
	                                    // Move up to the next parent group
	                                    parentGroup = parentGroup.parentGroup;
	                                }
	
	                                // Ensure dynamically updating position when any parent
	                                // is translated
	                                each(parents.reverse(), function(parentGroup) {
	                                    var htmlGroupStyle,
	                                        cls = attr(parentGroup.element, 'class');
	
	                                    if (cls) {
	                                        cls = {
	                                            className: cls
	                                        };
	                                    } // else null
	
	                                    // Create a HTML div and append it to the parent div
	                                    // to emulate the SVG group structure
	                                    htmlGroup =
	                                        parentGroup.div =
	                                        parentGroup.div || createElement('div', cls, {
	                                            position: 'absolute',
	                                            left: (parentGroup.translateX || 0) + 'px',
	                                            top: (parentGroup.translateY || 0) + 'px',
	                                            display: parentGroup.display,
	                                            opacity: parentGroup.opacity, // #5075
	                                            pointerEvents: (
	                                                parentGroup.styles &&
	                                                parentGroup.styles.pointerEvents
	                                            ) // #5595
	
	                                            // the top group is appended to container
	                                        }, htmlGroup || container);
	
	                                    // Shortcut
	                                    htmlGroupStyle = htmlGroup.style;
	
	                                    // Set listeners to update the HTML div's position
	                                    // whenever the SVG group position is changed.
	                                    extend(parentGroup, {
	                                        classSetter: function(value) {
	                                            this.element.setAttribute('class', value);
	                                            htmlGroup.className = value;
	                                        },
	                                        on: function() {
	                                            if (parents[0].div) { // #6418
	                                                wrapper.on.apply({
	                                                        element: parents[0].div
	                                                    },
	                                                    arguments
	                                                );
	                                            }
	                                            return parentGroup;
	                                        },
	                                        translateXSetter: function(value, key) {
	                                            htmlGroupStyle.left = value + 'px';
	                                            parentGroup[key] = value;
	                                            parentGroup.doTransform = true;
	                                        },
	                                        translateYSetter: function(value, key) {
	                                            htmlGroupStyle.top = value + 'px';
	                                            parentGroup[key] = value;
	                                            parentGroup.doTransform = true;
	                                        }
	                                    });
	                                    addSetters(parentGroup, htmlGroupStyle);
	                                });
	
	                            }
	                        } else {
	                            htmlGroup = container;
	                        }
	
	                        htmlGroup.appendChild(element);
	
	                        // Shared with VML:
	                        wrapper.added = true;
	                        if (wrapper.alignOnAdd) {
	                            wrapper.htmlUpdateTransform();
	                        }
	
	                        return wrapper;
	                    };
	                }
	                return wrapper;
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var VMLRenderer,
	            VMLRendererExtension,
	            VMLElement,
	
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            discardElement = H.discardElement,
	            doc = H.doc,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            extendClass = H.extendClass,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            pInt = H.pInt,
	            svg = H.svg,
	            SVGElement = H.SVGElement,
	            SVGRenderer = H.SVGRenderer,
	            win = H.win;
	
	        /* ****************************************************************************
	         *                                                                            *
	         * START OF INTERNET EXPLORER <= 8 SPECIFIC CODE                              *
	         *                                                                            *
	         * For applications and websites that don't need IE support, like platform    *
	         * targeted mobile apps and web apps, this code can be removed.               *
	         *                                                                            *
	         *****************************************************************************/
	
	        /**
	         * @constructor
	         */
	        if (!svg) {
	
	            /**
	             * The VML element wrapper.
	             */
	            VMLElement = {
	
	                docMode8: doc && doc.documentMode === 8,
	
	                /**
	                 * Initialize a new VML element wrapper. It builds the markup as a string
	                 * to minimize DOM traffic.
	                 * @param {Object} renderer
	                 * @param {Object} nodeName
	                 */
	                init: function(renderer, nodeName) {
	                    var wrapper = this,
	                        markup = ['<', nodeName, ' filled="f" stroked="f"'],
	                        style = ['position: ', 'absolute', ';'],
	                        isDiv = nodeName === 'div';
	
	                    // divs and shapes need size
	                    if (nodeName === 'shape' || isDiv) {
	                        style.push('left:0;top:0;width:1px;height:1px;');
	                    }
	                    style.push('visibility: ', isDiv ? 'hidden' : 'visible');
	
	                    markup.push(' style="', style.join(''), '"/>');
	
	                    // create element with default attributes and style
	                    if (nodeName) {
	                        markup = isDiv || nodeName === 'span' || nodeName === 'img' ?
	                            markup.join('') :
	                            renderer.prepVML(markup);
	                        wrapper.element = createElement(markup);
	                    }
	
	                    wrapper.renderer = renderer;
	                },
	
	                /**
	                 * Add the node to the given parent
	                 * @param {Object} parent
	                 */
	                add: function(parent) {
	                    var wrapper = this,
	                        renderer = wrapper.renderer,
	                        element = wrapper.element,
	                        box = renderer.box,
	                        inverted = parent && parent.inverted,
	
	                        // get the parent node
	                        parentNode = parent ?
	                        parent.element || parent :
	                        box;
	
	                    if (parent) {
	                        this.parentGroup = parent;
	                    }
	
	                    // if the parent group is inverted, apply inversion on all children
	                    if (inverted) { // only on groups
	                        renderer.invertChild(element, parentNode);
	                    }
	
	                    // append it
	                    parentNode.appendChild(element);
	
	                    // align text after adding to be able to read offset
	                    wrapper.added = true;
	                    if (wrapper.alignOnAdd && !wrapper.deferUpdateTransform) {
	                        wrapper.updateTransform();
	                    }
	
	                    // fire an event for internal hooks
	                    if (wrapper.onAdd) {
	                        wrapper.onAdd();
	                    }
	
	                    // IE8 Standards can't set the class name before the element is appended
	                    if (this.className) {
	                        this.attr('class', this.className);
	                    }
	
	                    return wrapper;
	                },
	
	                /**
	                 * VML always uses htmlUpdateTransform
	                 */
	                updateTransform: SVGElement.prototype.htmlUpdateTransform,
	
	                /**
	                 * Set the rotation of a span with oldIE's filter
	                 */
	                setSpanRotation: function() {
	                    // Adjust for alignment and rotation. Rotation of useHTML content is not yet implemented
	                    // but it can probably be implemented for Firefox 3.5+ on user request. FF3.5+
	                    // has support for CSS3 transform. The getBBox method also needs to be updated
	                    // to compensate for the rotation, like it currently does for SVG.
	                    // Test case: http://jsfiddle.net/highcharts/Ybt44/
	
	                    var rotation = this.rotation,
	                        costheta = Math.cos(rotation * deg2rad),
	                        sintheta = Math.sin(rotation * deg2rad);
	
	                    css(this.element, {
	                        filter: rotation ? ['progid:DXImageTransform.Microsoft.Matrix(M11=', costheta,
	                            ', M12=', -sintheta, ', M21=', sintheta, ', M22=', costheta,
	                            ', sizingMethod=\'auto expand\')'
	                        ].join('') : 'none'
	                    });
	                },
	
	                /**
	                 * Get the positioning correction for the span after rotating.
	                 */
	                getSpanCorrection: function(width, baseline, alignCorrection, rotation, align) {
	
	                    var costheta = rotation ? Math.cos(rotation * deg2rad) : 1,
	                        sintheta = rotation ? Math.sin(rotation * deg2rad) : 0,
	                        height = pick(this.elemHeight, this.element.offsetHeight),
	                        quad,
	                        nonLeft = align && align !== 'left';
	
	                    // correct x and y
	                    this.xCorr = costheta < 0 && -width;
	                    this.yCorr = sintheta < 0 && -height;
	
	                    // correct for baseline and corners spilling out after rotation
	                    quad = costheta * sintheta < 0;
	                    this.xCorr += sintheta * baseline * (quad ? 1 - alignCorrection : alignCorrection);
	                    this.yCorr -= costheta * baseline * (rotation ? (quad ? alignCorrection : 1 - alignCorrection) : 1);
	                    // correct for the length/height of the text
	                    if (nonLeft) {
	                        this.xCorr -= width * alignCorrection * (costheta < 0 ? -1 : 1);
	                        if (rotation) {
	                            this.yCorr -= height * alignCorrection * (sintheta < 0 ? -1 : 1);
	                        }
	                        css(this.element, {
	                            textAlign: align
	                        });
	                    }
	                },
	
	                /**
	                 * Converts a subset of an SVG path definition to its VML counterpart. Takes an array
	                 * as the parameter and returns a string.
	                 */
	                pathToVML: function(value) {
	                    // convert paths
	                    var i = value.length,
	                        path = [];
	
	                    while (i--) {
	
	                        // Multiply by 10 to allow subpixel precision.
	                        // Substracting half a pixel seems to make the coordinates
	                        // align with SVG, but this hasn't been tested thoroughly
	                        if (isNumber(value[i])) {
	                            path[i] = Math.round(value[i] * 10) - 5;
	                        } else if (value[i] === 'Z') { // close the path
	                            path[i] = 'x';
	                        } else {
	                            path[i] = value[i];
	
	                            // When the start X and end X coordinates of an arc are too close,
	                            // they are rounded to the same value above. In this case, substract or
	                            // add 1 from the end X and Y positions. #186, #760, #1371, #1410.
	                            if (value.isArc && (value[i] === 'wa' || value[i] === 'at')) {
	                                // Start and end X
	                                if (path[i + 5] === path[i + 7]) {
	                                    path[i + 7] += value[i + 7] > value[i + 5] ? 1 : -1;
	                                }
	                                // Start and end Y
	                                if (path[i + 6] === path[i + 8]) {
	                                    path[i + 8] += value[i + 8] > value[i + 6] ? 1 : -1;
	                                }
	                            }
	                        }
	                    }
	
	
	                    // Loop up again to handle path shortcuts (#2132)
	                    /*while (i++ < path.length) {
	                    	if (path[i] === 'H') { // horizontal line to
	                    		path[i] = 'L';
	                    		path.splice(i + 2, 0, path[i - 1]);
	                    	} else if (path[i] === 'V') { // vertical line to
	                    		path[i] = 'L';
	                    		path.splice(i + 1, 0, path[i - 2]);
	                    	}
	                    }*/
	                    return path.join(' ') || 'x';
	                },
	
	                /**
	                 * Set the element's clipping to a predefined rectangle
	                 *
	                 * @param {String} id The id of the clip rectangle
	                 */
	                clip: function(clipRect) {
	                    var wrapper = this,
	                        clipMembers,
	                        cssRet;
	
	                    if (clipRect) {
	                        clipMembers = clipRect.members;
	                        erase(clipMembers, wrapper); // Ensure unique list of elements (#1258)
	                        clipMembers.push(wrapper);
	                        wrapper.destroyClip = function() {
	                            erase(clipMembers, wrapper);
	                        };
	                        cssRet = clipRect.getCSS(wrapper);
	
	                    } else {
	                        if (wrapper.destroyClip) {
	                            wrapper.destroyClip();
	                        }
	                        cssRet = {
	                            clip: wrapper.docMode8 ? 'inherit' : 'rect(auto)'
	                        }; // #1214
	                    }
	
	                    return wrapper.css(cssRet);
	
	                },
	
	                /**
	                 * Set styles for the element
	                 * @param {Object} styles
	                 */
	                css: SVGElement.prototype.htmlCss,
	
	                /**
	                 * Removes a child either by removeChild or move to garbageBin.
	                 * Issue 490; in VML removeChild results in Orphaned nodes according to sIEve, discardElement does not.
	                 */
	                safeRemoveChild: function(element) {
	                    // discardElement will detach the node from its parent before attaching it
	                    // to the garbage bin. Therefore it is important that the node is attached and have parent.
	                    if (element.parentNode) {
	                        discardElement(element);
	                    }
	                },
	
	                /**
	                 * Extend element.destroy by removing it from the clip members array
	                 */
	                destroy: function() {
	                    if (this.destroyClip) {
	                        this.destroyClip();
	                    }
	
	                    return SVGElement.prototype.destroy.apply(this);
	                },
	
	                /**
	                 * Add an event listener. VML override for normalizing event parameters.
	                 * @param {String} eventType
	                 * @param {Function} handler
	                 */
	                on: function(eventType, handler) {
	                    // simplest possible event model for internal use
	                    this.element['on' + eventType] = function() {
	                        var evt = win.event;
	                        evt.target = evt.srcElement;
	                        handler(evt);
	                    };
	                    return this;
	                },
	
	                /**
	                 * In stacked columns, cut off the shadows so that they don't overlap
	                 */
	                cutOffPath: function(path, length) {
	
	                    var len;
	
	                    path = path.split(/[ ,]/); // The extra comma tricks the trailing comma remover in "gulp scripts" task
	                    len = path.length;
	
	                    if (len === 9 || len === 11) {
	                        path[len - 4] = path[len - 2] = pInt(path[len - 2]) - 10 * length;
	                    }
	                    return path.join(' ');
	                },
	
	                /**
	                 * Apply a drop shadow by copying elements and giving them different strokes
	                 * @param {Boolean|Object} shadowOptions
	                 */
	                shadow: function(shadowOptions, group, cutOff) {
	                    var shadows = [],
	                        i,
	                        element = this.element,
	                        renderer = this.renderer,
	                        shadow,
	                        elemStyle = element.style,
	                        markup,
	                        path = element.path,
	                        strokeWidth,
	                        modifiedPath,
	                        shadowWidth,
	                        shadowElementOpacity;
	
	                    // some times empty paths are not strings
	                    if (path && typeof path.value !== 'string') {
	                        path = 'x';
	                    }
	                    modifiedPath = path;
	
	                    if (shadowOptions) {
	                        shadowWidth = pick(shadowOptions.width, 3);
	                        shadowElementOpacity = (shadowOptions.opacity || 0.15) / shadowWidth;
	                        for (i = 1; i <= 3; i++) {
	
	                            strokeWidth = (shadowWidth * 2) + 1 - (2 * i);
	
	                            // Cut off shadows for stacked column items
	                            if (cutOff) {
	                                modifiedPath = this.cutOffPath(path.value, strokeWidth + 0.5);
	                            }
	
	                            markup = ['<shape isShadow="true" strokeweight="', strokeWidth,
	                                '" filled="false" path="', modifiedPath,
	                                '" coordsize="10 10" style="', element.style.cssText, '" />'
	                            ];
	
	                            shadow = createElement(renderer.prepVML(markup),
	                                null, {
	                                    left: pInt(elemStyle.left) + pick(shadowOptions.offsetX, 1),
	                                    top: pInt(elemStyle.top) + pick(shadowOptions.offsetY, 1)
	                                }
	                            );
	                            if (cutOff) {
	                                shadow.cutOff = strokeWidth + 1;
	                            }
	
	                            // apply the opacity
	                            markup = [
	                                '<stroke color="',
	                                shadowOptions.color || '#000000',
	                                '" opacity="', shadowElementOpacity * i, '"/>'
	                            ];
	                            createElement(renderer.prepVML(markup), null, null, shadow);
	
	
	                            // insert it
	                            if (group) {
	                                group.element.appendChild(shadow);
	                            } else {
	                                element.parentNode.insertBefore(shadow, element);
	                            }
	
	                            // record it
	                            shadows.push(shadow);
	
	                        }
	
	                        this.shadows = shadows;
	                    }
	                    return this;
	                },
	                updateShadows: noop, // Used in SVG only
	
	                setAttr: function(key, value) {
	                    if (this.docMode8) { // IE8 setAttribute bug
	                        this.element[key] = value;
	                    } else {
	                        this.element.setAttribute(key, value);
	                    }
	                },
	                classSetter: function(value) {
	                    // IE8 Standards mode has problems retrieving the className unless set like this.
	                    // IE8 Standards can't set the class name before the element is appended.
	                    (this.added ? this.element : this).className = value;
	                },
	                dashstyleSetter: function(value, key, element) {
	                    var strokeElem = element.getElementsByTagName('stroke')[0] ||
	                        createElement(this.renderer.prepVML(['<stroke/>']), null, null, element);
	                    strokeElem[key] = value || 'solid';
	                    this[key] = value;
	                    /* because changing stroke-width will change the dash length
					and cause an epileptic effect */
	                },
	                dSetter: function(value, key, element) {
	                    var i,
	                        shadows = this.shadows;
	                    value = value || [];
	                    this.d = value.join && value.join(' '); // used in getter for animation
	
	                    element.path = value = this.pathToVML(value);
	
	                    // update shadows
	                    if (shadows) {
	                        i = shadows.length;
	                        while (i--) {
	                            shadows[i].path = shadows[i].cutOff ? this.cutOffPath(value, shadows[i].cutOff) : value;
	                        }
	                    }
	                    this.setAttr(key, value);
	                },
	                fillSetter: function(value, key, element) {
	                    var nodeName = element.nodeName;
	                    if (nodeName === 'SPAN') { // text color
	                        element.style.color = value;
	                    } else if (nodeName !== 'IMG') { // #1336
	                        element.filled = value !== 'none';
	                        this.setAttr('fillcolor', this.renderer.color(value, element, key, this));
	                    }
	                },
	                'fill-opacitySetter': function(value, key, element) {
	                    createElement(
	                        this.renderer.prepVML(['<', key.split('-')[0], ' opacity="', value, '"/>']),
	                        null,
	                        null,
	                        element
	                    );
	                },
	                opacitySetter: noop, // Don't bother - animation is too slow and filters introduce artifacts
	                rotationSetter: function(value, key, element) {
	                    var style = element.style;
	                    this[key] = style[key] = value; // style is for #1873
	
	                    // Correction for the 1x1 size of the shape container. Used in gauge needles.
	                    style.left = -Math.round(Math.sin(value * deg2rad) + 1) + 'px';
	                    style.top = Math.round(Math.cos(value * deg2rad)) + 'px';
	                },
	                strokeSetter: function(value, key, element) {
	                    this.setAttr('strokecolor', this.renderer.color(value, element, key, this));
	                },
	                'stroke-widthSetter': function(value, key, element) {
	                    element.stroked = !!value; // VML "stroked" attribute
	                    this[key] = value; // used in getter, issue #113
	                    if (isNumber(value)) {
	                        value += 'px';
	                    }
	                    this.setAttr('strokeweight', value);
	                },
	                titleSetter: function(value, key) {
	                    this.setAttr(key, value);
	                },
	                visibilitySetter: function(value, key, element) {
	
	                    // Handle inherited visibility
	                    if (value === 'inherit') {
	                        value = 'visible';
	                    }
	
	                    // Let the shadow follow the main element
	                    if (this.shadows) {
	                        each(this.shadows, function(shadow) {
	                            shadow.style[key] = value;
	                        });
	                    }
	
	                    // Instead of toggling the visibility CSS property, move the div out of the viewport.
	                    // This works around #61 and #586
	                    if (element.nodeName === 'DIV') {
	                        value = value === 'hidden' ? '-999em' : 0;
	
	                        // In order to redraw, IE7 needs the div to be visible when tucked away
	                        // outside the viewport. So the visibility is actually opposite of
	                        // the expected value. This applies to the tooltip only.
	                        if (!this.docMode8) {
	                            element.style[key] = value ? 'visible' : 'hidden';
	                        }
	                        key = 'top';
	                    }
	                    element.style[key] = value;
	                },
	                xSetter: function(value, key, element) {
	                    this[key] = value; // used in getter
	
	                    if (key === 'x') {
	                        key = 'left';
	                    } else if (key === 'y') {
	                        key = 'top';
	                    }
	                    /* else {
	                    				value = Math.max(0, value); // don't set width or height below zero (#311)
	                    			}*/
	
	                    // clipping rectangle special
	                    if (this.updateClipping) {
	                        this[key] = value; // the key is now 'left' or 'top' for 'x' and 'y'
	                        this.updateClipping();
	                    } else {
	                        // normal
	                        element.style[key] = value;
	                    }
	                },
	                zIndexSetter: function(value, key, element) {
	                    element.style[key] = value;
	                }
	            };
	            VMLElement['stroke-opacitySetter'] = VMLElement['fill-opacitySetter'];
	            H.VMLElement = VMLElement = extendClass(SVGElement, VMLElement);
	
	            // Some shared setters
	            VMLElement.prototype.ySetter =
	                VMLElement.prototype.widthSetter =
	                VMLElement.prototype.heightSetter =
	                VMLElement.prototype.xSetter;
	
	
	            /**
	             * The VML renderer
	             */
	            VMLRendererExtension = { // inherit SVGRenderer
	
	                Element: VMLElement,
	                isIE8: win.navigator.userAgent.indexOf('MSIE 8.0') > -1,
	
	
	                /**
	                 * Initialize the VMLRenderer
	                 * @param {Object} container
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                init: function(container, width, height) {
	                    var renderer = this,
	                        boxWrapper,
	                        box,
	                        css;
	
	                    renderer.alignedObjects = [];
	
	                    boxWrapper = renderer.createElement('div')
	                        .css({
	                            position: 'relative'
	                        });
	                    box = boxWrapper.element;
	                    container.appendChild(boxWrapper.element);
	
	
	                    // generate the containing box
	                    renderer.isVML = true;
	                    renderer.box = box;
	                    renderer.boxWrapper = boxWrapper;
	                    renderer.gradients = {};
	                    renderer.cache = {}; // Cache for numerical bounding boxes
	                    renderer.cacheKeys = [];
	                    renderer.imgCount = 0;
	
	
	                    renderer.setSize(width, height, false);
	
	                    // The only way to make IE6 and IE7 print is to use a global namespace. However,
	                    // with IE8 the only way to make the dynamic shapes visible in screen and print mode
	                    // seems to be to add the xmlns attribute and the behaviour style inline.
	                    if (!doc.namespaces.hcv) {
	
	                        doc.namespaces.add('hcv', 'urn:schemas-microsoft-com:vml');
	
	                        // Setup default CSS (#2153, #2368, #2384)
	                        css = 'hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke' +
	                            '{ behavior:url(#default#VML); display: inline-block; } ';
	                        try {
	                            doc.createStyleSheet().cssText = css;
	                        } catch (e) {
	                            doc.styleSheets[0].cssText += css;
	                        }
	
	                    }
	                },
	
	
	                /**
	                 * Detect whether the renderer is hidden. This happens when one of the parent elements
	                 * has display: none
	                 */
	                isHidden: function() {
	                    return !this.box.offsetWidth;
	                },
	
	                /**
	                 * Define a clipping rectangle. In VML it is accomplished by storing the values
	                 * for setting the CSS style to all associated members.
	                 *
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                clipRect: function(x, y, width, height) {
	
	                    // create a dummy element
	                    var clipRect = this.createElement(),
	                        isObj = isObject(x);
	
	                    // mimic a rectangle with its style object for automatic updating in attr
	                    return extend(clipRect, {
	                        members: [],
	                        count: 0,
	                        left: (isObj ? x.x : x) + 1,
	                        top: (isObj ? x.y : y) + 1,
	                        width: (isObj ? x.width : width) - 1,
	                        height: (isObj ? x.height : height) - 1,
	                        getCSS: function(wrapper) {
	                            var element = wrapper.element,
	                                nodeName = element.nodeName,
	                                isShape = nodeName === 'shape',
	                                inverted = wrapper.inverted,
	                                rect = this,
	                                top = rect.top - (isShape ? element.offsetTop : 0),
	                                left = rect.left,
	                                right = left + rect.width,
	                                bottom = top + rect.height,
	                                ret = {
	                                    clip: 'rect(' +
	                                        Math.round(inverted ? left : top) + 'px,' +
	                                        Math.round(inverted ? bottom : right) + 'px,' +
	                                        Math.round(inverted ? right : bottom) + 'px,' +
	                                        Math.round(inverted ? top : left) + 'px)'
	                                };
	
	                            // issue 74 workaround
	                            if (!inverted && wrapper.docMode8 && nodeName === 'DIV') {
	                                extend(ret, {
	                                    width: right + 'px',
	                                    height: bottom + 'px'
	                                });
	                            }
	                            return ret;
	                        },
	
	                        // used in attr and animation to update the clipping of all members
	                        updateClipping: function() {
	                            each(clipRect.members, function(member) {
	                                // Member.element is falsy on deleted series, like in
	                                // stock/members/series-remove demo. Should be removed
	                                // from members, but this will do.
	                                if (member.element) {
	                                    member.css(clipRect.getCSS(member));
	                                }
	                            });
	                        }
	                    });
	
	                },
	
	
	                /**
	                 * Take a color and return it if it's a string, make it a gradient if it's a
	                 * gradient configuration object, and apply opacity.
	                 *
	                 * @param {Object} color The color or config object
	                 */
	                color: function(color, elem, prop, wrapper) {
	                    var renderer = this,
	                        colorObject,
	                        regexRgba = /^rgba/,
	                        markup,
	                        fillType,
	                        ret = 'none';
	
	                    // Check for linear or radial gradient
	                    if (color && color.linearGradient) {
	                        fillType = 'gradient';
	                    } else if (color && color.radialGradient) {
	                        fillType = 'pattern';
	                    }
	
	
	                    if (fillType) {
	
	                        var stopColor,
	                            stopOpacity,
	                            gradient = color.linearGradient || color.radialGradient,
	                            x1,
	                            y1,
	                            x2,
	                            y2,
	                            opacity1,
	                            opacity2,
	                            color1,
	                            color2,
	                            fillAttr = '',
	                            stops = color.stops,
	                            firstStop,
	                            lastStop,
	                            colors = [],
	                            addFillNode = function() {
	                                // Add the fill subnode. When colors attribute is used, the meanings of opacity and o:opacity2
	                                // are reversed.
	                                markup = ['<fill colors="' + colors.join(',') +
	                                    '" opacity="', opacity2, '" o:opacity2="',
	                                    opacity1, '" type="', fillType, '" ', fillAttr,
	                                    'focus="100%" method="any" />'
	                                ];
	                                createElement(renderer.prepVML(markup), null, null, elem);
	                            };
	
	                        // Extend from 0 to 1
	                        firstStop = stops[0];
	                        lastStop = stops[stops.length - 1];
	                        if (firstStop[0] > 0) {
	                            stops.unshift([
	                                0,
	                                firstStop[1]
	                            ]);
	                        }
	                        if (lastStop[0] < 1) {
	                            stops.push([
	                                1,
	                                lastStop[1]
	                            ]);
	                        }
	
	                        // Compute the stops
	                        each(stops, function(stop, i) {
	                            if (regexRgba.test(stop[1])) {
	                                colorObject = H.color(stop[1]);
	                                stopColor = colorObject.get('rgb');
	                                stopOpacity = colorObject.get('a');
	                            } else {
	                                stopColor = stop[1];
	                                stopOpacity = 1;
	                            }
	
	                            // Build the color attribute
	                            colors.push((stop[0] * 100) + '% ' + stopColor);
	
	                            // Only start and end opacities are allowed, so we use the first and the last
	                            if (!i) {
	                                opacity1 = stopOpacity;
	                                color2 = stopColor;
	                            } else {
	                                opacity2 = stopOpacity;
	                                color1 = stopColor;
	                            }
	                        });
	
	                        // Apply the gradient to fills only.
	                        if (prop === 'fill') {
	
	                            // Handle linear gradient angle
	                            if (fillType === 'gradient') {
	                                x1 = gradient.x1 || gradient[0] || 0;
	                                y1 = gradient.y1 || gradient[1] || 0;
	                                x2 = gradient.x2 || gradient[2] || 0;
	                                y2 = gradient.y2 || gradient[3] || 0;
	                                fillAttr = 'angle="' + (90 - Math.atan(
	                                    (y2 - y1) / // y vector
	                                    (x2 - x1) // x vector
	                                ) * 180 / Math.PI) + '"';
	
	                                addFillNode();
	
	                                // Radial (circular) gradient
	                            } else {
	
	                                var r = gradient.r,
	                                    sizex = r * 2,
	                                    sizey = r * 2,
	                                    cx = gradient.cx,
	                                    cy = gradient.cy,
	                                    radialReference = elem.radialReference,
	                                    bBox,
	                                    applyRadialGradient = function() {
	                                        if (radialReference) {
	                                            bBox = wrapper.getBBox();
	                                            cx += (radialReference[0] - bBox.x) / bBox.width - 0.5;
	                                            cy += (radialReference[1] - bBox.y) / bBox.height - 0.5;
	                                            sizex *= radialReference[2] / bBox.width;
	                                            sizey *= radialReference[2] / bBox.height;
	                                        }
	                                        fillAttr = 'src="' + H.getOptions().global.VMLRadialGradientURL + '" ' +
	                                            'size="' + sizex + ',' + sizey + '" ' +
	                                            'origin="0.5,0.5" ' +
	                                            'position="' + cx + ',' + cy + '" ' +
	                                            'color2="' + color2 + '" ';
	
	                                        addFillNode();
	                                    };
	
	                                // Apply radial gradient
	                                if (wrapper.added) {
	                                    applyRadialGradient();
	                                } else {
	                                    // We need to know the bounding box to get the size and position right
	                                    wrapper.onAdd = applyRadialGradient;
	                                }
	
	                                // The fill element's color attribute is broken in IE8 standards mode, so we
	                                // need to set the parent shape's fillcolor attribute instead.
	                                ret = color1;
	                            }
	
	                            // Gradients are not supported for VML stroke, return the first color. #722.
	                        } else {
	                            ret = stopColor;
	                        }
	
	                        // If the color is an rgba color, split it and add a fill node
	                        // to hold the opacity component
	                    } else if (regexRgba.test(color) && elem.tagName !== 'IMG') {
	
	                        colorObject = H.color(color);
	
	                        wrapper[prop + '-opacitySetter'](colorObject.get('a'), prop, elem);
	
	                        ret = colorObject.get('rgb');
	
	
	                    } else {
	                        var propNodes = elem.getElementsByTagName(prop); // 'stroke' or 'fill' node
	                        if (propNodes.length) {
	                            propNodes[0].opacity = 1;
	                            propNodes[0].type = 'solid';
	                        }
	                        ret = color;
	                    }
	
	                    return ret;
	                },
	
	                /**
	                 * Take a VML string and prepare it for either IE8 or IE6/IE7.
	                 * @param {Array} markup A string array of the VML markup to prepare
	                 */
	                prepVML: function(markup) {
	                    var vmlStyle = 'display:inline-block;behavior:url(#default#VML);',
	                        isIE8 = this.isIE8;
	
	                    markup = markup.join('');
	
	                    if (isIE8) { // add xmlns and style inline
	                        markup = markup.replace('/>', ' xmlns="urn:schemas-microsoft-com:vml" />');
	                        if (markup.indexOf('style="') === -1) {
	                            markup = markup.replace('/>', ' style="' + vmlStyle + '" />');
	                        } else {
	                            markup = markup.replace('style="', 'style="' + vmlStyle);
	                        }
	
	                    } else { // add namespace
	                        markup = markup.replace('<', '<hcv:');
	                    }
	
	                    return markup;
	                },
	
	                /**
	                 * Create rotated and aligned text
	                 * @param {String} str
	                 * @param {Number} x
	                 * @param {Number} y
	                 */
	                text: SVGRenderer.prototype.html,
	
	                /**
	                 * Create and return a path element
	                 * @param {Array} path
	                 */
	                path: function(path) {
	                    var attr = {
	                        // subpixel precision down to 0.1 (width and height = 1px)
	                        coordsize: '10 10'
	                    };
	                    if (isArray(path)) {
	                        attr.d = path;
	                    } else if (isObject(path)) { // attributes
	                        extend(attr, path);
	                    }
	                    // create the shape
	                    return this.createElement('shape').attr(attr);
	                },
	
	                /**
	                 * Create and return a circle element. In VML circles are implemented as
	                 * shapes, which is faster than v:oval
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} r
	                 */
	                circle: function(x, y, r) {
	                    var circle = this.symbol('circle');
	                    if (isObject(x)) {
	                        r = x.r;
	                        y = x.y;
	                        x = x.x;
	                    }
	                    circle.isCircle = true; // Causes x and y to mean center (#1682)
	                    circle.r = r;
	                    return circle.attr({
	                        x: x,
	                        y: y
	                    });
	                },
	
	                /**
	                 * Create a group using an outer div and an inner v:group to allow rotating
	                 * and flipping. A simple v:group would have problems with positioning
	                 * child HTML elements and CSS clip.
	                 *
	                 * @param {String} name The name of the group
	                 */
	                g: function(name) {
	                    var wrapper,
	                        attribs;
	
	                    // set the class name
	                    if (name) {
	                        attribs = {
	                            'className': 'highcharts-' + name,
	                            'class': 'highcharts-' + name
	                        };
	                    }
	
	                    // the div to hold HTML and clipping
	                    wrapper = this.createElement('div').attr(attribs);
	
	                    return wrapper;
	                },
	
	                /**
	                 * VML override to create a regular HTML image
	                 * @param {String} src
	                 * @param {Number} x
	                 * @param {Number} y
	                 * @param {Number} width
	                 * @param {Number} height
	                 */
	                image: function(src, x, y, width, height) {
	                    var obj = this.createElement('img')
	                        .attr({
	                            src: src
	                        });
	
	                    if (arguments.length > 1) {
	                        obj.attr({
	                            x: x,
	                            y: y,
	                            width: width,
	                            height: height
	                        });
	                    }
	                    return obj;
	                },
	
	                /**
	                 * For rectangles, VML uses a shape for rect to overcome bugs and rotation problems
	                 */
	                createElement: function(nodeName) {
	                    return nodeName === 'rect' ?
	                        this.symbol(nodeName) :
	                        SVGRenderer.prototype.createElement.call(this, nodeName);
	                },
	
	                /**
	                 * In the VML renderer, each child of an inverted div (group) is inverted
	                 * @param {Object} element
	                 * @param {Object} parentNode
	                 */
	                invertChild: function(element, parentNode) {
	                    var ren = this,
	                        parentStyle = parentNode.style,
	                        imgStyle = element.tagName === 'IMG' && element.style; // #1111
	
	                    css(element, {
	                        flip: 'x',
	                        left: pInt(parentStyle.width) - (imgStyle ? pInt(imgStyle.top) : 1),
	                        top: pInt(parentStyle.height) - (imgStyle ? pInt(imgStyle.left) : 1),
	                        rotation: -90
	                    });
	
	                    // Recursively invert child elements, needed for nested composite
	                    // shapes like box plots and error bars. #1680, #1806.
	                    each(element.childNodes, function(child) {
	                        ren.invertChild(child, element);
	                    });
	                },
	
	                /**
	                 * Symbol definitions that override the parent SVG renderer's symbols
	                 *
	                 */
	                symbols: {
	                    // VML specific arc function
	                    arc: function(x, y, w, h, options) {
	                        var start = options.start,
	                            end = options.end,
	                            radius = options.r || w || h,
	                            innerRadius = options.innerR,
	                            cosStart = Math.cos(start),
	                            sinStart = Math.sin(start),
	                            cosEnd = Math.cos(end),
	                            sinEnd = Math.sin(end),
	                            ret;
	
	                        if (end - start === 0) { // no angle, don't show it.
	                            return ['x'];
	                        }
	
	                        ret = [
	                            'wa', // clockwise arc to
	                            x - radius, // left
	                            y - radius, // top
	                            x + radius, // right
	                            y + radius, // bottom
	                            x + radius * cosStart, // start x
	                            y + radius * sinStart, // start y
	                            x + radius * cosEnd, // end x
	                            y + radius * sinEnd // end y
	                        ];
	
	                        if (options.open && !innerRadius) {
	                            ret.push(
	                                'e',
	                                'M',
	                                x, // - innerRadius,
	                                y // - innerRadius
	                            );
	                        }
	
	                        ret.push(
	                            'at', // anti clockwise arc to
	                            x - innerRadius, // left
	                            y - innerRadius, // top
	                            x + innerRadius, // right
	                            y + innerRadius, // bottom
	                            x + innerRadius * cosEnd, // start x
	                            y + innerRadius * sinEnd, // start y
	                            x + innerRadius * cosStart, // end x
	                            y + innerRadius * sinStart, // end y
	                            'x', // finish path
	                            'e' // close
	                        );
	
	                        ret.isArc = true;
	                        return ret;
	
	                    },
	                    // Add circle symbol path. This performs significantly faster than v:oval.
	                    circle: function(x, y, w, h, wrapper) {
	
	                        if (wrapper && defined(wrapper.r)) {
	                            w = h = 2 * wrapper.r;
	                        }
	
	                        // Center correction, #1682
	                        if (wrapper && wrapper.isCircle) {
	                            x -= w / 2;
	                            y -= h / 2;
	                        }
	
	                        // Return the path
	                        return [
	                            'wa', // clockwisearcto
	                            x, // left
	                            y, // top
	                            x + w, // right
	                            y + h, // bottom
	                            x + w, // start x
	                            y + h / 2, // start y
	                            x + w, // end x
	                            y + h / 2, // end y
	                            //'x', // finish path
	                            'e' // close
	                        ];
	                    },
	                    /**
	                     * Add rectangle symbol path which eases rotation and omits arcsize problems
	                     * compared to the built-in VML roundrect shape. When borders are not rounded,
	                     * use the simpler square path, else use the callout path without the arrow.
	                     */
	                    rect: function(x, y, w, h, options) {
	                        return SVGRenderer.prototype.symbols[!defined(options) || !options.r ? 'square' : 'callout'].call(0, x, y, w, h, options);
	                    }
	                }
	            };
	            H.VMLRenderer = VMLRenderer = function() {
	                this.init.apply(this, arguments);
	            };
	            VMLRenderer.prototype = merge(SVGRenderer.prototype, VMLRendererExtension);
	
	            // general renderer
	            H.Renderer = VMLRenderer;
	        }
	
	        // This method is used with exporting in old IE, when emulating SVG (see #2314)
	        SVGRenderer.prototype.measureSpanWidth = function(text, styles) {
	            var measuringSpan = doc.createElement('span'),
	                offsetWidth,
	                textNode = doc.createTextNode(text);
	
	            measuringSpan.appendChild(textNode);
	            css(measuringSpan, styles);
	            this.box.appendChild(measuringSpan);
	            offsetWidth = measuringSpan.offsetWidth;
	            discardElement(measuringSpan); // #2463
	            return offsetWidth;
	        };
	
	
	        /* ****************************************************************************
	         *                                                                            *
	         * END OF INTERNET EXPLORER <= 8 SPECIFIC CODE                                *
	         *                                                                            *
	         *****************************************************************************/
	
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var color = H.color,
	            each = H.each,
	            getTZOffset = H.getTZOffset,
	            isTouchDevice = H.isTouchDevice,
	            merge = H.merge,
	            pick = H.pick,
	            svg = H.svg,
	            win = H.win;
	
	        /* ****************************************************************************
	         * Handle the options                                                         *
	         *****************************************************************************/
	        /** 	 
	         * @optionparent
	         */
	        H.defaultOptions = {
	
	
	            /**
	             * An array containing the default colors for the chart's series. When
	             * all colors are used, new colors are pulled from the start again.
	             * 
	             * Default colors can also be set on a series or series.type basis,
	             * see [column.colors](#plotOptions.column.colors), [pie.colors](#plotOptions.
	             * pie.colors).
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the colors option doesn't exist. Instead, colors
	             * are defined in CSS and applied either through series or point class
	             * names, or through the [chart.colorCount](#chart.colorCount) option.
	             * 
	             * 
	             * ### Legacy
	             * 
	             * In Highcharts 3.x, the default colors were:
	             * 
	             * <pre>colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
	             * 
	             * '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a']</pre>
	             * 
	             * In Highcharts 2.x, the default colors were:
	             * 
	             * <pre>colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',
	             * 
	             *    '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92']</pre>
	             * 
	             * @type {Array<Color>}
	             * @sample {highcharts} highcharts/chart/colors/ Assign a global color theme
	             * @default [ "#7cb5ec" , "#434348" , "#90ed7d" , "#f7a35c" , "#8085e9" ,
	             *          "#f15c80" , "#e4d354" , "#2b908f" , "#f45b5b" , "#91e8e1"]
	             * @product highcharts highstock highmaps
	             */
	            colors: '#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1'.split(' '),
	
	
	            /**
	             */
	            symbols: ['circle', 'diamond', 'square', 'triangle', 'triangle-down'],
	            lang: {
	
	                /**
	                 * The loading text that appears when the chart is set into the loading
	                 * state following a call to `chart.showLoading`.
	                 * 
	                 * @type {String}
	                 * @default Loading...
	                 * @product highcharts highstock highmaps
	                 */
	                loading: 'Loading...',
	
	                /**
	                 * An array containing the months names. Corresponds to the `%B` format
	                 * in `Highcharts.dateFormat()`.
	                 * 
	                 * @type {Array<String>}
	                 * @default [ "January" , "February" , "March" , "April" , "May" ,
	                 *          "June" , "July" , "August" , "September" , "October" ,
	                 *          "November" , "December"]
	                 * @product highcharts highstock highmaps
	                 */
	                months: [
	                    'January', 'February', 'March', 'April', 'May', 'June', 'July',
	                    'August', 'September', 'October', 'November', 'December'
	                ],
	
	                /**
	                 * An array containing the months names in abbreviated form. Corresponds
	                 * to the `%b` format in `Highcharts.dateFormat()`.
	                 * 
	                 * @type {Array<String>}
	                 * @default [ "Jan" , "Feb" , "Mar" , "Apr" , "May" , "Jun" ,
	                 *          "Jul" , "Aug" , "Sep" , "Oct" , "Nov" , "Dec"]
	                 */
	                shortMonths: [
	                    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
	                    'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	                ],
	
	                /**
	                 * An array containing the weekday names.
	                 * 
	                 * @type {Array<String>}
	                 * @default ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday",
	                 *          "Friday", "Saturday"]
	                 * @product highcharts highstock highmaps
	                 */
	                weekdays: [
	                    'Sunday', 'Monday', 'Tuesday', 'Wednesday',
	                    'Thursday', 'Friday', 'Saturday'
	                ],
	                // invalidDate: '',
	
	                /**
	                 * The default decimal point used in the `Highcharts.numberFormat`
	                 * method unless otherwise specified in the function arguments.
	                 * 
	                 * @type {String}
	                 * @default .
	                 * @since 1.2.2
	                 * @product highcharts highstock highmaps
	                 */
	                decimalPoint: '.',
	
	                /**
	                 * [Metric prefixes](http://en.wikipedia.org/wiki/Metric_prefix) used
	                 * to shorten high numbers in axis labels. Replacing any of the positions
	                 * with `null` causes the full number to be written. Setting `numericSymbols`
	                 * to `null` disables shortening altogether.
	                 * 
	                 * @type {Array<String>}
	                 * @sample {highcharts} highcharts/lang/numericsymbols/ Replacing the symbols with text
	                 * @sample {highstock} highcharts/lang/numericsymbols/ Replacing the symbols with text
	                 * @default [ "k" , "M" , "G" , "T" , "P" , "E"]
	                 * @since 2.3.0
	                 * @product highcharts highstock highmaps
	                 */
	                numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
	
	                /**
	                 * The text for the label appearing when a chart is zoomed.
	                 * 
	                 * @type {String}
	                 * @default Reset zoom
	                 * @since 1.2.4
	                 * @product highcharts highstock highmaps
	                 */
	                resetZoom: 'Reset zoom',
	
	                /**
	                 * The tooltip title for the label appearing when a chart is zoomed.
	                 * 
	                 * @type {String}
	                 * @default Reset zoom level 1:1
	                 * @since 1.2.4
	                 * @product highcharts highstock highmaps
	                 */
	                resetZoomTitle: 'Reset zoom level 1:1',
	
	                /**
	                 * The default thousands separator used in the `Highcharts.numberFormat`
	                 * method unless otherwise specified in the function arguments. Since
	                 * Highcharts 4.1 it defaults to a single space character, which is
	                 * compatible with ISO and works across Anglo-American and continental
	                 * European languages.
	                 * 
	                 * The default is a single space.
	                 * 
	                 * @type {String}
	                 * @default  
	                 * @since 1.2.2
	                 * @product highcharts highstock highmaps
	                 */
	                thousandsSep: ' '
	            },
	
	            /**
	             * Global options that don't apply to each chart. These options, like
	             * the `lang` options, must be set using the `Highcharts.setOptions`
	             * method.
	             * 
	             * <pre>Highcharts.setOptions({
	             * global: {
	             * useUTC: false
	             * }
	             * });</pre>
	             * 
	             * @product highcharts highstock highmaps
	             */
	            global: {
	
	                /**
	                 * Whether to use UTC time for axis scaling, tickmark placement and
	                 * time display in `Highcharts.dateFormat`. Advantages of using UTC
	                 * is that the time displays equally regardless of the user agent's
	                 * time zone settings. Local time can be used when the data is loaded
	                 * in real time or when correct Daylight Saving Time transitions are
	                 * required.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/global/useutc-true/ True by default
	                 * @sample {highcharts} highcharts/global/useutc-false/ False
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                useUTC: true,
	                //timezoneOffset: 0,
	
	
	                /**
	                 * Path to the pattern image required by VML browsers in order to
	                 * draw radial gradients.
	                 * 
	                 * @type {String}
	                 * @default {highcharts} http://code.highcharts.com/{version}/gfx/vml-radial-gradient.png
	                 * @default {highstock} http://code.highcharts.com/highstock/{version}/gfx/vml-radial-gradient.png
	                 * @default {highmaps} http://code.highcharts.com/{version}/gfx/vml-radial-gradient.png
	                 * @since 2.3.0
	                 * @product highcharts highstock highmaps
	                 */
	                VMLRadialGradientURL: 'http://code.highcharts.com/5.0.14/gfx/vml-radial-gradient.png'
	
	            },
	            chart: {
	
	                /**
	                 * When using multiple axis, the ticks of two or more opposite axes
	                 * will automatically be aligned by adding ticks to the axis or axes
	                 * with the least ticks, as if `tickAmount` were specified.
	                 * 
	                 * This can be prevented by setting `alignTicks` to false. If the grid
	                 * lines look messy, it's a good idea to hide them for the secondary
	                 * axis by setting `gridLineWidth` to 0.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/alignticks-true/ True by default
	                 * @sample {highcharts} highcharts/chart/alignticks-false/ False
	                 * @sample {highstock} stock/chart/alignticks-true/
	                 *         True by default
	                 * @sample {highstock} stock/chart/alignticks-false/
	                 *         False
	                 * @default true
	                 * @product highcharts highstock
	                 * @apioption chart.alignTicks
	                 */
	
	
	                /**
	                 * Set the overall animation for all chart updating. Animation can be
	                 * disabled throughout the chart by setting it to false here. It can
	                 * be overridden for each individual API method as a function parameter.
	                 * The only animation not affected by this option is the initial series
	                 * animation, see [plotOptions.series.animation](#plotOptions.series.
	                 * animation).
	                 * 
	                 * The animation can either be set as a boolean or a configuration
	                 * object. If `true`, it will use the 'swing' jQuery easing and a
	                 * duration of 500 ms. If used as a configuration object, the following
	                 * properties are supported:
	                 * 
	                 * <dl>
	                 * 
	                 * <dt>duration</dt>
	                 * 
	                 * <dd>The duration of the animation in milliseconds.</dd>
	                 * 
	                 * <dt>easing</dt>
	                 * 
	                 * <dd>A string reference to an easing function set on the `Math` object.
	                 * See [the easing demo](http://jsfiddle.net/gh/get/library/pure/
	                 * highcharts/highcharts/tree/master/samples/highcharts/plotoptions/
	                 * series-animation-easing/).</dd>
	                 * 
	                 * </dl>
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/chart/animation-none/
	                 *         Updating with no animation
	                 * @sample {highcharts} highcharts/chart/animation-duration/
	                 *         With a longer duration
	                 * @sample {highcharts} highcharts/chart/animation-easing/
	                 *         With a jQuery UI easing
	                 * @sample {highmaps} maps/chart/animation-none/
	                 *         Updating with no animation
	                 * @sample {highmaps} maps/chart/animation-duration/
	                 *         With a longer duration
	                 * @default true
	                 * @apioption chart.animation
	                 */
	
	                /**
	                 * A CSS class name to apply to the charts container `div`, allowing
	                 * unique CSS styling for each chart.
	                 * 
	                 * @type {String}
	                 * @apioption chart.className
	                 */
	
	                /**
	                 * Event listeners for the chart.
	                 * 
	                 * @apioption chart.events
	                 */
	
	                /**
	                 * Fires when a series is added to the chart after load time, using
	                 * the `addSeries` method. One parameter, `event`, is passed to the
	                 * function, containing common event information.
	                 * Through `event.options` you can access the series options that was
	                 * passed to the `addSeries` method. Returning false prevents the series
	                 * from being added.
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-addseries/ Alert on add series
	                 * @sample {highstock} stock/chart/events-addseries/ Alert on add series
	                 * @since 1.2.0
	                 * @apioption chart.events.addSeries
	                 */
	
	                /**
	                 * Fires when clicking on the plot background. One parameter, `event`,
	                 * is passed to the function, containing common event information.
	                 * 
	                 * Information on the clicked spot can be found through `event.xAxis`
	                 * and `event.yAxis`, which are arrays containing the axes of each dimension
	                 * and each axis' value at the clicked spot. The primary axes are `event.
	                 * xAxis[0]` and `event.yAxis[0]`. Remember the unit of a datetime axis
	                 * is milliseconds since 1970-01-01 00:00:00.
	                 * 
	                 * <pre>click: function(e) {
	                 * console.log(
	                 * Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', e.xAxis[0].value),
	                 * e.yAxis[0].value
	                 * )
	                 * }</pre>
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-click/
	                 *         Alert coordinates on click
	                 * @sample {highcharts} highcharts/chart/events-container/
	                 *         Alternatively, attach event to container
	                 * @sample {highstock} stock/chart/events-click/
	                 *         Alert coordinates on click
	                 * @sample {highstock} highcharts/chart/events-container/
	                 *         Alternatively, attach event to container
	                 * @sample {highmaps} maps/chart/events-click/
	                 *         Record coordinates on click
	                 * @sample {highmaps} highcharts/chart/events-container/
	                 *         Alternatively, attach event to container
	                 * @since 1.2.0
	                 * @apioption chart.events.click
	                 */
	
	
	                /**
	                 * Fires when the chart is finished loading. Since v4.2.2, it also waits
	                 * for images to be loaded, for example from point markers. One parameter,
	                 * `event`, is passed to the function, containing common event information.
	                 * 
	                 * There is also a second parameter to the chart constructor where a
	                 * callback function can be passed to be executed on chart.load.
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-load/
	                 *         Alert on chart load
	                 * @sample {highstock} stock/chart/events-load/
	                 *         Alert on chart load
	                 * @sample {highmaps} maps/chart/events-load/
	                 *         Add series on chart load
	                 * @apioption chart.events.load
	                 */
	
	                /**
	                 * Fires when the chart is redrawn, either after a call to chart.redraw()
	                 * or after an axis, series or point is modified with the `redraw` option
	                 * set to true. One parameter, `event`, is passed to the function, containing common event information.
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @sample {highcharts} highcharts/chart/events-redraw/
	                 *         Alert on chart redraw
	                 * @sample {highstock} stock/chart/events-redraw/
	                 *         Alert on chart redraw when adding a series or moving the
	                 *         zoomed range
	                 * @sample {highmaps} maps/chart/events-redraw/
	                 *         Set subtitle on chart redraw
	                 * @since 1.2.0
	                 * @apioption chart.events.redraw
	                 */
	
	                /**
	                 * Fires after initial load of the chart (directly after the `load`
	                 * event), and after each redraw (directly after the `redraw` event).
	                 * 
	                 * @type {Function}
	                 * @context Chart
	                 * @since 5.0.7
	                 * @apioption chart.events.render
	                 */
	
	                /**
	                 * Fires when an area of the chart has been selected. Selection is enabled
	                 * by setting the chart's zoomType. One parameter, `event`, is passed
	                 * to the function, containing common event information. The default action for the selection event is to
	                 * zoom the chart to the selected area. It can be prevented by calling
	                 * `event.preventDefault()`.
	                 * 
	                 * Information on the selected area can be found through `event.xAxis`
	                 * and `event.yAxis`, which are arrays containing the axes of each dimension
	                 * and each axis' min and max values. The primary axes are `event.xAxis[0]`
	                 * and `event.yAxis[0]`. Remember the unit of a datetime axis is milliseconds
	                 * since 1970-01-01 00:00:00.
	                 * 
	                 * <pre>selection: function(event) {
	                 * // log the min and max of the primary, datetime x-axis
	                 * console.log(
	                 * Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', event.xAxis[0].min),
	                 * 
	                 * Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', event.xAxis[0].max)
	                 * );
	                 * // log the min and max of the y axis
	                 * console.log(event.yAxis[0].min, event.yAxis[0].max);
	                 * }</pre>
	                 * 
	                 * @type {Function}
	                 * @sample {highcharts} highcharts/chart/events-selection/
	                 *         Report on selection and reset
	                 * @sample {highcharts} highcharts/chart/events-selection-points/
	                 *         Select a range of points through a drag selection
	                 * @sample {highstock} stock/chart/events-selection/
	                 *         Report on selection and reset
	                 * @sample {highstock} highcharts/chart/events-selection-points/
	                 *         Select a range of points through a drag selection (Highcharts)
	                 * @apioption chart.events.selection
	                 */
	
	                /**
	                 * The margin between the outer edge of the chart and the plot area.
	                 * The numbers in the array designate top, right, bottom and left
	                 * respectively. Use the options `marginTop`, `marginRight`,
	                 * `marginBottom` and `marginLeft` for shorthand setting of one option.
	                 * 
	                 * By default there is no margin. The actual space is dynamically calculated
	                 * from the offset of axis labels, axis title, title, subtitle and legend
	                 * in addition to the `spacingTop`, `spacingRight`, `spacingBottom`
	                 * and `spacingLeft` options.
	                 * 
	                 * @type {Array}
	                 * @sample {highcharts} highcharts/chart/margins-zero/
	                 *         Zero margins
	                 * @sample {highstock} stock/chart/margin-zero/
	                 *         Zero margins
	                 *
	                 * @defaults {all} null
	                 * @apioption chart.margin
	                 */
	
	                /**
	                 * The margin between the bottom outer edge of the chart and the plot
	                 * area. Use this to set a fixed pixel value for the margin as opposed
	                 * to the default dynamic margin. See also `spacingBottom`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/marginbottom/
	                 *         100px bottom margin
	                 * @sample {highstock} stock/chart/marginbottom/
	                 *         100px bottom margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @since 2.0
	                 * @apioption chart.marginBottom
	                 */
	
	                /**
	                 * The margin between the left outer edge of the chart and the plot
	                 * area. Use this to set a fixed pixel value for the margin as opposed
	                 * to the default dynamic margin. See also `spacingLeft`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/marginleft/
	                 *         150px left margin
	                 * @sample {highstock} stock/chart/marginleft/
	                 *         150px left margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @default null
	                 * @since 2.0
	                 * @apioption chart.marginLeft
	                 */
	
	                /**
	                 * The margin between the right outer edge of the chart and the plot
	                 * area. Use this to set a fixed pixel value for the margin as opposed
	                 * to the default dynamic margin. See also `spacingRight`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/marginright/
	                 *         100px right margin
	                 * @sample {highstock} stock/chart/marginright/
	                 *         100px right margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @default null
	                 * @since 2.0
	                 * @apioption chart.marginRight
	                 */
	
	                /**
	                 * The margin between the top outer edge of the chart and the plot area.
	                 * Use this to set a fixed pixel value for the margin as opposed to
	                 * the default dynamic margin. See also `spacingTop`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/margintop/ 100px top margin
	                 * @sample {highstock} stock/chart/margintop/
	                 *         100px top margin
	                 * @sample {highmaps} maps/chart/margin/
	                 *         100px margins
	                 * @default null
	                 * @since 2.0
	                 * @apioption chart.marginTop
	                 */
	
	                /**
	                 * Allows setting a key to switch between zooming and panning. Can be
	                 * one of `alt`, `ctrl`, `meta` (the command key on Mac and Windows
	                 * key on Windows) or `shift`. The keys are mapped directly to the key
	                 * properties of the click event argument (`event.altKey`, `event.ctrlKey`,
	                 * `event.metaKey` and `event.shiftKey`).
	                 * 
	                 * @validvalue [null, "alt", "ctrl", "meta", "shift"]
	                 * @type {String}
	                 * @since 4.0.3
	                 * @product highcharts
	                 * @apioption chart.panKey
	                 */
	
	                /**
	                 * Allow panning in a chart. Best used with [panKey](#chart.panKey)
	                 * to combine zooming and panning.
	                 * 
	                 * On touch devices, when the [tooltip.followTouchMove](#tooltip.followTouchMove)
	                 * option is `true` (default), panning requires two fingers. To allow
	                 * panning with one finger, set `followTouchMove` to `false`.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/pankey/ Zooming and panning
	                 * @default {highcharts} false
	                 * @default {highstock} true
	                 * @since 4.0.3
	                 * @product highcharts highstock
	                 * @apioption chart.panning
	                 */
	
	
	                /**
	                 * Equivalent to [zoomType](#chart.zoomType), but for multitouch gestures
	                 * only. By default, the `pinchType` is the same as the `zoomType` setting.
	                 * However, pinching can be enabled separately in some cases, for example
	                 * in stock charts where a mouse drag pans the chart, while pinching
	                 * is enabled. When [tooltip.followTouchMove](#tooltip.followTouchMove)
	                 * is true, pinchType only applies to two-finger touches.
	                 * 
	                 * @validvalue ["x", "y", "xy"]
	                 * @type {String}
	                 * @default {highcharts} null
	                 * @default {highstock} x
	                 * @since 3.0
	                 * @product highcharts highstock
	                 * @apioption chart.pinchType
	                 */
	
	                /**
	                 * The corner radius of the outer chart border.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/borderradius/ 20px radius
	                 * @sample {highstock} stock/chart/border/ 10px radius
	                 * @sample {highmaps} maps/chart/border/ Border options
	                 * @default 0
	                 * @product highcharts highstock highmaps
	                 */
	                borderRadius: 0,
	
	
	                /**
	                 * Alias of `type`.
	                 * 
	                 * @validvalue ["line", "spline", "column", "area", "areaspline", "pie"]
	                 * @type {String}
	                 * @deprecated
	                 * @sample {highcharts} highcharts/chart/defaultseriestype/ Bar
	                 * @default line
	                 * @product highcharts
	                 */
	                defaultSeriesType: 'line',
	
	                /**
	                 * If true, the axes will scale to the remaining visible series once
	                 * one series is hidden. If false, hiding and showing a series will
	                 * not affect the axes or the other series. For stacks, once one series
	                 * within the stack is hidden, the rest of the stack will close in
	                 * around it even if the axis is not affected.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/ignorehiddenseries-true/
	                 *         True by default
	                 * @sample {highcharts} highcharts/chart/ignorehiddenseries-false/
	                 *         False
	                 * @sample {highcharts} highcharts/chart/ignorehiddenseries-true-stacked/
	                 *         True with stack
	                 * @sample {highstock} stock/chart/ignorehiddenseries-true/
	                 *         True by default
	                 * @sample {highstock} stock/chart/ignorehiddenseries-false/
	                 *         False
	                 * @default true
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                ignoreHiddenSeries: true,
	
	
	                /**
	                 * Whether to invert the axes so that the x axis is vertical and y axis
	                 * is horizontal. When `true`, the x axis is [reversed](#xAxis.reversed)
	                 * by default.
	                 *
	                 * @productdesc {highcharts}
	                 * If a bar series is present in the chart, it will be inverted
	                 * automatically. Inverting the chart doesn't have an effect if there
	                 * are no cartesian series in the chart, or if the chart is
	                 * [polar](#chart.polar).
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/inverted/
	                 *         Inverted line
	                 * @sample {highstock} stock/navigator/inverted/
	                 *         Inverted stock chart
	                 * @default false
	                 * @product highcharts highstock
	                 * @apioption chart.inverted
	                 */
	
	                /**
	                 * The distance between the outer edge of the chart and the content,
	                 * like title or legend, or axis title and labels if present. The
	                 * numbers in the array designate top, right, bottom and left respectively.
	                 * Use the options spacingTop, spacingRight, spacingBottom and spacingLeft
	                 * options for shorthand setting of one option.
	                 * 
	                 * @type {Array<Number>}
	                 * @see [chart.margin](#chart.margin)
	                 * @default [10, 10, 15, 10]
	                 * @since 3.0.6
	                 * @product highcharts highstock highmaps
	                 */
	                spacing: [10, 10, 15, 10],
	
	                /**
	                 * The button that appears after a selection zoom, allowing the user
	                 * to reset zoom.
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                resetZoomButton: {
	
	                    /**
	                     * A collection of attributes for the button. The object takes SVG
	                     * attributes like `fill`, `stroke`, `stroke-width` or `r`, the border
	                     * radius. The theme also supports `style`, a collection of CSS properties
	                     * for the text. Equivalent attributes for the hover state are given
	                     * in `theme.states.hover`.
	                     * 
	                     * @type {Object}
	                     * @sample {highcharts} highcharts/chart/resetzoombutton-theme/ Theming the button
	                     * @sample {highstock} highcharts/chart/resetzoombutton-theme/ Theming the button
	                     * @since 2.2
	                     * @product highcharts highstock highmaps
	                     */
	                    theme: {
	
	                        /**
	                         */
	                        zIndex: 20
	                    },
	
	                    /**
	                     * The position of the button.
	                     * 
	                     * @type {Object}
	                     * @sample {highcharts} highcharts/chart/resetzoombutton-position/
	                     *         Above the plot area
	                     * @sample {highstock} highcharts/chart/resetzoombutton-position/
	                     *         Above the plot area
	                     * @sample {highmaps} highcharts/chart/resetzoombutton-position/
	                     *         Above the plot area
	                     * @since 2.2
	                     * @product highcharts highstock highmaps
	                     */
	                    position: {
	
	                        /**
	                         * The horizontal alignment of the button.
	                         * 
	                         * @type {String}
	                         */
	                        align: 'right',
	
	                        /**
	                         * The horizontal offset of the button.
	                         * 
	                         * @type {Number}
	                         */
	                        x: -10,
	
	                        /**
	                         * The vertical alignment of the button.
	                         * 
	                         * @validvalue ["top", "middle", "bottom"]
	                         * @type {String}
	                         * @default top
	                         * @apioption chart.resetZoomButton.position.verticalAlign
	                         */
	
	                        /**
	                         * The vertical offset of the button.
	                         * 
	                         * @type {Number}
	                         */
	                        y: 10
	                    }
	
	                    /**
	                     * What frame the button should be placed related to. Can be either
	                     * `plot` or `chart`
	                     * 
	                     * @validvalue ["plot", "chart"]
	                     * @type {String}
	                     * @sample {highcharts} highcharts/chart/resetzoombutton-relativeto/
	                     *         Relative to the chart
	                     * @sample {highstock} highcharts/chart/resetzoombutton-relativeto/
	                     *         Relative to the chart
	                     * @default plot
	                     * @since 2.2
	                     * @apioption chart.resetZoomButton.relativeTo
	                     */
	                },
	
	                /**
	                 * An explicit width for the chart. By default (when `null`) the width
	                 * is calculated from the offset width of the containing element.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/width/ 800px wide
	                 * @sample {highstock} stock/chart/width/ 800px wide
	                 * @sample {highmaps} maps/chart/size/ Chart with explicit size
	                 * @default null
	                 * @product highcharts highstock highmaps
	                 */
	                width: null,
	
	                /**
	                 * An explicit height for the chart. If a _number_, the height is
	                 * given in pixels. If given a _percentage string_ (for example `'56%'`),
	                 * the height is given as the percentage of the actual chart width.
	                 * This allows for preserving the aspect ratio across responsive
	                 * sizes.
	                 * 
	                 * By default (when `null`) the height is calculated from the offset
	                 * height of the containing element, or 400 pixels if the containing
	                 * element's height is 0.
	                 * 
	                 * @type {Number|String}
	                 * @sample {highcharts} highcharts/chart/height/
	                 *         500px height
	                 * @sample {highstock} stock/chart/height/
	                 *         300px height
	                 * @sample {highmaps} maps/chart/size/
	                 *         Chart with explicit size
	                 * @sample highcharts/chart/height-percent/
	                 *         Highcharts with percentage height
	                 * @default null
	                 * @product highcharts highstock highmaps
	                 */
	                height: null,
	
	
	
	                /**
	                 * The color of the outer chart border.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is set with the `.highcharts-background`
	                 * class.
	                 * @sample {highcharts} highcharts/chart/bordercolor/ Brown border
	                 * @sample {highstock} stock/chart/border/ Brown border
	                 * @sample {highmaps} maps/chart/border/ Border options
	                 * @default #335cad
	                 * @product highcharts highstock highmaps
	                 */
	                borderColor: '#335cad',
	
	                /**
	                 * The pixel width of the outer chart border.
	                 * 
	                 * @type {Number}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is set with the `.highcharts-background`
	                 * class.
	                 * @sample {highcharts} highcharts/chart/borderwidth/ 5px border
	                 * @sample {highstock} stock/chart/border/
	                 *         2px border
	                 * @sample {highmaps} maps/chart/border/
	                 *         Border options
	                 * @default 0
	                 * @apioption chart.borderWidth
	                 */
	
	                //style: {
	                //	fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif', // default font
	                //	fontSize: '12px'
	                //},
	
	                /**
	                 * The background color or gradient for the outer chart area.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the background is set with the `.highcharts-
	                 * background` class.
	                 * @sample {highcharts} highcharts/chart/backgroundcolor-color/ Color
	                 * @sample {highcharts} highcharts/chart/backgroundcolor-gradient/ Gradient
	                 * @sample {highstock} stock/chart/backgroundcolor-color/
	                 *         Color
	                 * @sample {highstock} stock/chart/backgroundcolor-gradient/
	                 *         Gradient
	                 * @sample {highmaps} maps/chart/backgroundcolor-color/
	                 *         Color
	                 * @sample {highmaps} maps/chart/backgroundcolor-gradient/
	                 *         Gradient
	                 * @default #FFFFFF
	                 * @product highcharts highstock highmaps
	                 */
	                backgroundColor: '#ffffff',
	
	                /**
	                 * The background color or gradient for the plot area.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the plot background is set with the `.highcharts-
	                 * plot-background` class.
	                 * @sample {highcharts} highcharts/chart/plotbackgroundcolor-color/
	                 *         Color
	                 * @sample {highcharts} highcharts/chart/plotbackgroundcolor-gradient/
	                 *         Gradient
	                 * @sample {highstock} stock/chart/plotbackgroundcolor-color/
	                 *         Color
	                 * @sample {highstock} stock/chart/plotbackgroundcolor-gradient/
	                 *         Gradient
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-color/
	                 *         Color
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/
	                 *         Gradient
	                 * @default null
	                 * @apioption chart.plotBackgroundColor
	                 */
	
	
	                /**
	                 * The URL for an image to use as the plot background. To set an image
	                 * as the background for the entire chart, set a CSS background image
	                 * to the container element. Note that for the image to be applied to
	                 * exported charts, its URL needs to be accessible by the export server.
	                 * 
	                 * @type {String}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), a plot background image can be set with the
	                 * `.highcharts-plot-background` class and a [custom pattern](http://www.
	                 * highcharts.com/docs/chart-design-and-style/gradients-shadows-and-
	                 * patterns).
	                 * @sample {highcharts} highcharts/chart/plotbackgroundimage/ Skies
	                 * @sample {highstock} stock/chart/plotbackgroundimage/ Skies
	                 * @default null
	                 * @apioption chart.plotBackgroundImage
	                 */
	
	                /**
	                 * The color of the inner chart or plot area border.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), a plot border stroke can be set with the `.
	                 * highcharts-plot-border` class.
	                 * @sample {highcharts} highcharts/chart/plotbordercolor/ Blue border
	                 * @sample {highstock} stock/chart/plotborder/ Blue border
	                 * @sample {highmaps} maps/chart/plotborder/ Plot border options
	                 * @default #cccccc
	                 * @product highcharts highstock highmaps
	                 */
	                plotBorderColor: '#cccccc'
	
	
	                /**
	                 * The pixel width of the plot area border.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/plotborderwidth/ 1px border
	                 * @sample {highstock} stock/chart/plotborder/
	                 *         2px border
	                 * @sample {highmaps} maps/chart/plotborder/
	                 *         Plot border options
	                 * @default 0
	                 * @apioption chart.plotBorderWidth
	                 */
	
	                /**
	                 * Whether to apply a drop shadow to the plot area. Requires that
	                 * plotBackgroundColor be set. The shadow can be an object configuration
	                 * containing `color`, `offsetX`, `offsetY`, `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/chart/plotshadow/ Plot shadow
	                 * @sample {highstock} stock/chart/plotshadow/
	                 *         Plot shadow
	                 * @sample {highmaps} maps/chart/plotborder/
	                 *         Plot border options
	                 * @default false
	                 * @apioption chart.plotShadow
	                 */
	
	                /**
	                 * When true, cartesian charts like line, spline, area and column are
	                 * transformed into the polar coordinate system. Requires `highcharts-
	                 * more.js`.
	                 * 
	                 * @type {Boolean}
	                 * @default false
	                 * @since 2.3.0
	                 * @product highcharts
	                 * @apioption chart.polar
	                 */
	
	                /**
	                 * Whether to reflow the chart to fit the width of the container div
	                 * on resizing the window.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/reflow-true/ True by default
	                 * @sample {highcharts} highcharts/chart/reflow-false/ False
	                 * @sample {highstock} stock/chart/reflow-true/
	                 *         True by default
	                 * @sample {highstock} stock/chart/reflow-false/
	                 *         False
	                 * @sample {highmaps} maps/chart/reflow-true/
	                 *         True by default
	                 * @sample {highmaps} maps/chart/reflow-false/
	                 *         False
	                 * @default true
	                 * @since 2.1
	                 * @apioption chart.reflow
	                 */
	
	
	
	
	                /**
	                 * The HTML element where the chart will be rendered. If it is a string,
	                 * the element by that id is used. The HTML element can also be passed
	                 * by direct reference, or as the first argument of the chart constructor,
	                 *  in which case the option is not needed.
	                 * 
	                 * @type {String|Object}
	                 * @sample {highcharts} highcharts/chart/reflow-true/
	                 *         String
	                 * @sample {highcharts} highcharts/chart/renderto-object/
	                 *         Object reference
	                 * @sample {highcharts} highcharts/chart/renderto-jquery/
	                 *         Object reference through jQuery
	                 * @sample {highstock} stock/chart/renderto-string/
	                 *         String
	                 * @sample {highstock} stock/chart/renderto-object/
	                 *         Object reference
	                 * @sample {highstock} stock/chart/renderto-jquery/
	                 *         Object reference through jQuery
	                 * @apioption chart.renderTo
	                 */
	
	                /**
	                 * The background color of the marker square when selecting (zooming
	                 * in on) an area of the chart.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the selection marker fill is set with the
	                 * `.highcharts-selection-marker` class.
	                 * @default rgba(51,92,173,0.25)
	                 * @since 2.1.7
	                 * @apioption chart.selectionMarkerFill
	                 */
	
	                /**
	                 * Whether to apply a drop shadow to the outer chart area. Requires
	                 * that backgroundColor be set. The shadow can be an object configuration
	                 * containing `color`, `offsetX`, `offsetY`, `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/chart/shadow/ Shadow
	                 * @sample {highstock} stock/chart/shadow/
	                 *         Shadow
	                 * @sample {highmaps} maps/chart/border/
	                 *         Chart border and shadow
	                 * @default false
	                 * @apioption chart.shadow
	                 */
	
	                /**
	                 * Whether to show the axes initially. This only applies to empty charts
	                 * where series are added dynamically, as axes are automatically added
	                 * to cartesian series.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/showaxes-false/ False by default
	                 * @sample {highcharts} highcharts/chart/showaxes-true/ True
	                 * @since 1.2.5
	                 * @product highcharts
	                 * @apioption chart.showAxes
	                 */
	
	                /**
	                 * The space between the bottom edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingbottom/
	                 *         Spacing bottom set to 100
	                 * @sample {highstock} stock/chart/spacingbottom/
	                 *         Spacing bottom set to 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 15
	                 * @since 2.1
	                 * @apioption chart.spacingBottom
	                 */
	
	                /**
	                 * The space between the left edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingleft/
	                 *         Spacing left set to 100
	                 * @sample {highstock} stock/chart/spacingleft/
	                 *         Spacing left set to 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 10
	                 * @since 2.1
	                 * @apioption chart.spacingLeft
	                 */
	
	                /**
	                 * The space between the right edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top
	                 * position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingright-100/
	                 *         Spacing set to 100
	                 * @sample {highcharts} highcharts/chart/spacingright-legend/
	                 *         Legend in right position with default spacing
	                 * @sample {highstock} stock/chart/spacingright/
	                 *         Spacing set to 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 10
	                 * @since 2.1
	                 * @apioption chart.spacingRight
	                 */
	
	                /**
	                 * The space between the top edge of the chart and the content (plot
	                 * area, axis title and labels, title, subtitle or legend in top
	                 * position).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/chart/spacingtop-100/
	                 * A top spacing of 100
	                 * @sample {highcharts} highcharts/chart/spacingtop-10/
	                 *         Floating chart title makes the plot area align to the default
	                 *         spacingTop of 10.
	                 * @sample {highstock} stock/chart/spacingtop/
	                 *         A top spacing of 100
	                 * @sample {highmaps} maps/chart/spacing/
	                 *         Spacing 100 all around
	                 * @default 10
	                 * @since 2.1
	                 * @apioption chart.spacingTop
	                 */
	
	                /**
	                 * Additional CSS styles to apply inline to the container `div`. Note
	                 * that since the default font styles are applied in the renderer, it
	                 * is ignorant of the individual chart options and must be set globally.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), general chart styles can be set with the `.highcharts-
	                 * root` class.
	                 * @sample {highcharts} highcharts/chart/style-serif-font/
	                 *         Using a serif type font
	                 * @sample {highcharts} highcharts/css/em/
	                 *         Styled mode with relative font sizes
	                 * @sample {highstock} stock/chart/style/
	                 *         Using a serif type font
	                 * @sample {highmaps} maps/chart/style-serif-font/
	                 *         Using a serif type font
	                 * @default {"fontFamily":"\"Lucida Grande\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif","fontSize":"12px"}
	                 * @apioption chart.style
	                 */
	
	                /**
	                 * The default series type for the chart. Can be any of the chart types
	                 * listed under [plotOptions](#plotOptions).
	                 * 
	                 * @validvalue ["line", "spline", "column", "bar", "area", "areaspline", "pie", "arearange", "areasplinerange", "boxplot", "bubble", "columnrange", "errorbar", "funnel", "gauge", "heatmap", "polygon", "pyramid", "scatter", "solidgauge", "treemap", "waterfall"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/chart/type-bar/ Bar
	                 * @sample {highstock} stock/chart/type/
	                 *         Areaspline
	                 * @sample {highmaps} maps/chart/type-mapline/
	                 *         Mapline
	                 * @default {highcharts} line
	                 * @default {highstock} line
	                 * @default {highmaps} map
	                 * @since 2.1.0
	                 * @apioption chart.type
	                 */
	
	                /**
	                 * Decides in what dimensions the user can zoom by dragging the mouse.
	                 * Can be one of `x`, `y` or `xy`.
	                 * 
	                 * @validvalue [null, "x", "y", "xy"]
	                 * @type {String}
	                 * @see [panKey](#chart.panKey)
	                 * @sample {highcharts} highcharts/chart/zoomtype-none/ None by default
	                 * @sample {highcharts} highcharts/chart/zoomtype-x/ X
	                 * @sample {highcharts} highcharts/chart/zoomtype-y/ Y
	                 * @sample {highcharts} highcharts/chart/zoomtype-xy/ Xy
	                 * @sample {highstock} stock/demo/basic-line/ None by default
	                 * @sample {highstock} stock/chart/zoomtype-x/ X
	                 * @sample {highstock} stock/chart/zoomtype-y/ Y
	                 * @sample {highstock} stock/chart/zoomtype-xy/ Xy
	                 * @product highcharts highstock
	                 * @apioption chart.zoomType
	                 */
	            },
	
	            /**
	             * The chart's main title.
	             * 
	             * @sample {highmaps} maps/title/title/ Title options demonstrated
	             * @product highcharts highstock highmaps
	             */
	            title: {
	
	                /**
	                 * The title of the chart. To disable the title, set the `text` to
	                 * `null`.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/title/text/ Custom title
	                 * @sample {highstock} stock/chart/title-text/ Custom title
	                 * @default {highcharts} Chart title
	                 * @default {highstock} null
	                 * @default {highmaps} Chart title
	                 * @product highcharts highstock highmaps
	                 */
	                text: 'Chart title',
	
	                /**
	                 * The horizontal alignment of the title. Can be one of "left", "center"
	                 * and "right".
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/title/align/ Aligned to the plot area (x = 70px     = margin left - spacing left)
	                 * @sample {highstock} stock/chart/title-align/ Aligned to the plot area (x = 50px     = margin left - spacing left)
	                 * @default center
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                align: 'center',
	                // floating: false,
	
	                /**
	                 * The margin between the title and the plot area, or if a subtitle
	                 * is present, the margin between the subtitle and the plot area.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/title/margin-50/ A chart title margin of 50
	                 * @sample {highcharts} highcharts/title/margin-subtitle/ The same margin applied with a subtitle
	                 * @sample {highstock} stock/chart/title-margin/ A chart title margin of 50
	                 * @default 15
	                 * @since 2.1
	                 * @product highcharts highstock highmaps
	                 */
	                margin: 15,
	                // x: 0,
	                // verticalAlign: 'top',
	                // y: null,
	                // style: {}, // defined inline
	
	                /**
	                 * Adjustment made to the title width, normally to reserve space for
	                 * the exporting burger menu.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highstock} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highmaps} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @default -44
	                 * @since 4.2.5
	                 * @product highcharts highstock highmaps
	                 */
	                widthAdjust: -44
	
	            },
	
	            /**
	             * The chart's subtitle. This can be used both to display a subtitle below
	             * the main title, and to display random text anywhere in the chart. The
	             * subtitle can be updated after chart initialization through the 
	             * `Chart.setTitle` method.
	             * 
	             * @sample {highmaps} maps/title/subtitle/ Subtitle options demonstrated
	             * @product highcharts highstock highmaps
	             */
	            subtitle: {
	
	                /**
	                 * The subtitle of the chart.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/subtitle/text/ Custom subtitle
	                 * @sample {highcharts} highcharts/subtitle/text-formatted/ Formatted and linked text.
	                 * @sample {highstock} stock/chart/subtitle-text Custom subtitle
	                 * @sample {highstock} stock/chart/subtitle-text-formatted Formatted and linked text.
	                 * @product highcharts highstock highmaps
	                 */
	                text: '',
	
	                /**
	                 * The horizontal alignment of the subtitle. Can be one of "left",
	                 *  "center" and "right".
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/subtitle/align/ Footnote at right of plot area
	                 * @sample {highstock} stock/chart/subtitle-footnote Footnote at bottom right of plot area
	                 * @default center
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                align: 'center',
	                // floating: false
	                // x: 0,
	                // verticalAlign: 'top',
	                // y: null,
	                // style: {}, // defined inline
	
	                /**
	                 * Adjustment made to the subtitle width, normally to reserve space
	                 * for the exporting burger menu.
	                 * 
	                 * @type {Number}
	                 * @see [title.widthAdjust](#title.widthAdjust)
	                 * @sample {highcharts} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highstock} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @sample {highmaps} highcharts/title/widthadjust/ Wider menu, greater padding
	                 * @default -44
	                 * @since 4.2.5
	                 * @product highcharts highstock highmaps
	                 */
	                widthAdjust: -44
	            },
	
	            /**
	             * The plotOptions is a wrapper object for config objects for each series
	             * type. The config objects for each series can also be overridden for
	             * each series item as given in the series array.
	             * 
	             * Configuration options for the series are given in three levels. Options
	             * for all series in a chart are given in the [plotOptions.series](#plotOptions.
	             * series) object. Then options for all series of a specific type are
	             * given in the plotOptions of that type, for example plotOptions.line.
	             * Next, options for one single series are given in [the series array](#series).
	             * 
	             * @product highcharts highstock highmaps
	             */
	            plotOptions: {},
	
	            /**
	             * HTML labels that can be positioned anywhere in the chart area.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            labels: {
	                //items: [],
	
	                /**
	                 * Shared CSS styles for all labels.
	                 * 
	                 * @type {CSSObject}
	                 * @default { "color": "#333333" }
	                 * @product highcharts highstock highmaps
	                 */
	                style: {
	                    //font: defaultFont,
	
	                    /**
	                     */
	                    position: 'absolute',
	
	                    /**
	                     */
	                    color: '#333333'
	                }
	            },
	
	            /**
	             * The legend is a box containing a symbol and name for each series
	             * item or point item in the chart. Each series (or points in case
	             * of pie charts) is represented by a symbol and its name in the legend.
	             *  
	             * It is possible to override the symbol creator function and
	             * create [custom legend symbols](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/studies/legend-
	             * custom-symbol/).
	             * 
	             * @productdesc {highmaps}
	             * A Highmaps legend by default contains one legend item per series, but if
	             * a `colorAxis` is defined, the axis will be displayed in the legend.
	             * Either as a gradient, or as multiple legend items for `dataClasses`.
	             */
	            legend: {
	
	                /**
	                 * Enable or disable the legend.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/legend/enabled-false/ Legend disabled
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/enabled-false/ Legend disabled
	                 * @default {highstock} false
	                 * @default {highmaps} true
	                 * @product highcharts highstock highmaps
	                 */
	                enabled: true,
	
	                /**
	                 * The horizontal alignment of the legend box within the chart area.
	                 * Valid values are `left`, `center` and `right`.
	                 * 
	                 * In the case that the legend is aligned in a corner position, the
	                 * `layout` option will determine whether to place it above/below
	                 * or on the side of the plot area.
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/legend/align/ Legend at the right of the chart
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/alignment/ Legend alignment
	                 * @default center
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                align: 'center',
	                //floating: false,
	
	                /**
	                 * The layout of the legend items. Can be one of "horizontal" or "vertical".
	                 * 
	                 * @validvalue ["horizontal", "vertical"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/legend/layout-horizontal/ Horizontal by default
	                 * @sample {highcharts} highcharts/legend/layout-vertical/ Vertical
	                 * @sample {highstock} stock/legend/layout-horizontal/ Horizontal by default
	                 * @sample {highmaps} maps/legend/padding-itemmargin/ Vertical with data classes
	                 * @sample {highmaps} maps/legend/layout-vertical/ Vertical with color axis gradient
	                 * @default horizontal
	                 * @product highcharts highstock highmaps
	                 */
	                layout: 'horizontal',
	
	                /**
	                 * Callback function to format each of the series' labels. The `this`
	                 * keyword refers to the series object, or the point object in case
	                 * of pie charts. By default the series or point name is printed.
	                 *
	                 * @productdesc {highmaps}
	                 *              In Highmaps the context can also be a data class in case
	                 *              of a `colorAxis`.
	                 * 
	                 * @type {Function}
	                 * @sample {highcharts} highcharts/legend/labelformatter/ Add text
	                 * @sample {highmaps} maps/legend/labelformatter/ Data classes with label formatter
	                 * @context {Series|Point}
	                 */
	                labelFormatter: function() {
	                    return this.name;
	                },
	                //borderWidth: 0,
	
	                /**
	                 * The color of the drawn border around the legend.
	                 * 
	                 * @type {Color}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the legend border stroke can be applied with
	                 * the `.highcharts-legend-box` class.
	                 * @sample {highcharts} highcharts/legend/bordercolor/ Brown border
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/border-background/ Border and background options
	                 * @default #999999
	                 * @product highcharts highstock highmaps
	                 */
	                borderColor: '#999999',
	
	                /**
	                 * The border corner radius of the legend.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/borderradius-default/ Square by default
	                 * @sample {highcharts} highcharts/legend/borderradius-round/ 5px rounded
	                 * @sample {highmaps} maps/legend/border-background/ Border and background options
	                 * @default 0
	                 * @product highcharts highstock highmaps
	                 */
	                borderRadius: 0,
	
	                /**
	                 * Options for the paging or navigation appearing when the legend
	                 * is overflown. Navigation works well on screen, but not in static
	                 * exported images. One way of working around that is to [increase
	                 * the chart height in export](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/legend/navigation-
	                 * enabled-false/).
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                navigation: {
	
	
	                    /**
	                     * The color for the active up or down arrow in the legend page navigation.
	                     * 
	                     * @type {Color}
	                     * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the active arrow be styled with the `.highcharts-
	                     * legend-nav-active` class.
	                     * @sample {highcharts} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @sample {highstock} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @default #003399
	                     * @since 2.2.4
	                     * @product highcharts highstock highmaps
	                     */
	                    activeColor: '#003399',
	
	                    /**
	                     * The color of the inactive up or down arrow in the legend page
	                     * navigation. .
	                     * 
	                     * @type {Color}
	                     * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the inactive arrow be styled with the `.highcharts-
	                     * legend-nav-inactive` class.
	                     * @sample {highcharts} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @sample {highstock} highcharts/legend/navigation/ Legend page navigation demonstrated
	                     * @default {highcharts} #cccccc
	                     * @default {highstock} #cccccc
	                     * @default {highmaps} ##cccccc
	                     * @since 2.2.4
	                     * @product highcharts highstock highmaps
	                     */
	                    inactiveColor: '#cccccc'
	
	                    // animation: true,
	                    // arrowSize: 12
	                    // style: {} // text styles
	                },
	                // margin: 20,
	                // reversed: false,
	                // backgroundColor: null,
	                /*style: {
	                	padding: '5px'
	                },*/
	
	
	                /**
	                 * CSS styles for each legend item. Only a subset of CSS is supported,
	                 * notably those options related to text. The default `textOverflow`
	                 * property makes long texts truncate. Set it to `null` to wrap text
	                 * instead. A `width` property can be added to control the text width.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the legend items can be styled with the `.
	                 * highcharts-legend-item` class.
	                 * @sample {highcharts} highcharts/legend/itemstyle/ Bold black text
	                 * @sample {highmaps} maps/legend/itemstyle/ Item text styles
	                 * @default { "color": "#333333", "cursor": "pointer", "fontSize": "12px", "fontWeight": "bold", "textOverflow": "ellipsis" }
	                 * @product highcharts highstock highmaps
	                 */
	                itemStyle: {
	
	                    /**
	                     */
	                    color: '#333333',
	
	                    /**
	                     */
	                    fontSize: '12px',
	
	                    /**
	                     */
	                    fontWeight: 'bold',
	
	                    /**
	                     */
	                    textOverflow: 'ellipsis'
	                },
	
	                /**
	                 * CSS styles for each legend item in hover mode. Only a subset of
	                 * CSS is supported, notably those options related to text. Properties
	                 * are inherited from `style` unless overridden here.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the hovered legend items can be styled with
	                 * the `.highcharts-legend-item:hover` pesudo-class.
	                 * @sample {highcharts} highcharts/legend/itemhoverstyle/ Red on hover
	                 * @sample {highmaps} maps/legend/itemstyle/ Item text styles
	                 * @default { "color": "#000000" }
	                 * @product highcharts highstock highmaps
	                 */
	                itemHoverStyle: {
	                    //cursor: 'pointer', removed as of #601
	
	                    /**
	                     */
	                    color: '#000000'
	                },
	
	                /**
	                 * CSS styles for each legend item when the corresponding series or
	                 * point is hidden. Only a subset of CSS is supported, notably those
	                 * options related to text. Properties are inherited from `style`
	                 * unless overridden here.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the hidden legend items can be styled with
	                 * the `.highcharts-legend-item-hidden` class.
	                 * @sample {highcharts} highcharts/legend/itemhiddenstyle/ Darker gray color
	                 * @default { "color": "#cccccc" }
	                 * @product highcharts highstock highmaps
	                 */
	                itemHiddenStyle: {
	
	                    /**
	                     */
	                    color: '#cccccc'
	                },
	
	                /**
	                 * Whether to apply a drop shadow to the legend. A `backgroundColor`
	                 * also needs to be applied for this to take effect. The shadow can be
	                 * an object configuration containing `color`, `offsetX`, `offsetY`,
	                 * `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/legend/shadow/
	                 *         White background and drop shadow
	                 * @sample {highstock} stock/legend/align/
	                 *         Various legend options
	                 * @sample {highmaps} maps/legend/border-background/
	                 *         Border and background options
	                 * @default false
	                 * @product highcharts highstock highmaps
	                 */
	                shadow: false,
	
	
	                /**
	                 */
	                itemCheckboxStyle: {
	
	                    /**
	                     */
	                    position: 'absolute',
	
	                    /**
	                     */
	                    width: '13px', // for IE precision
	
	                    /**
	                     */
	                    height: '13px'
	                },
	                // itemWidth: undefined,
	
	                /**
	                 * When this is true, the legend symbol width will be the same as
	                 * the symbol height, which in turn defaults to the font size of the
	                 * legend items.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 5.0.0
	                 * @product highcharts highstock highmaps
	                 */
	                squareSymbol: true,
	
	                /**
	                 * The pixel height of the symbol for series types that use a rectangle
	                 * in the legend. Defaults to the font size of legend items.
	                 *
	                 * @productdesc {highmaps}
	                 * In Highmaps, when the symbol is the gradient of a vertical color
	                 * axis, the height defaults to 200.
	                 * 
	                 * @type {Number}
	                 * @sample {highmaps} maps/legend/layout-vertical-sized/
	                 *         Sized vertical gradient
	                 * @sample {highmaps} maps/legend/padding-itemmargin/
	                 *         No distance between data classes
	                 * @since 3.0.8
	                 * @apioption legend.symbolHeight
	                 */
	
	                /**
	                 * The border radius of the symbol for series types that use a rectangle
	                 * in the legend. Defaults to half the `symbolHeight`.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/symbolradius/ Round symbols
	                 * @sample {highstock} highcharts/legend/symbolradius/ Round symbols
	                 * @sample {highmaps} highcharts/legend/symbolradius/ Round symbols
	                 * @since 3.0.8
	                 * @apioption legend.symbolRadius
	                 */
	
	                /**
	                 * The pixel width of the legend item symbol. When the `squareSymbol`
	                 * option is set, this defaults to the `symbolHeight`, otherwise 16.
	                 * 
	                 * @productdesc {highmaps}
	                 * In Highmaps, when the symbol is the gradient of a horizontal color
	                 * axis, the width defaults to 200.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/symbolwidth/
	                 *         Greater symbol width and padding
	                 * @sample {highmaps} maps/legend/padding-itemmargin/
	                 *         Padding and item margins demonstrated
	                 * @sample {highmaps} maps/legend/layout-vertical-sized/
	                 *         Sized vertical gradient
	                 * @apioption legend.symbolWidth
	                 */
	
	                /**
	                 * Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-
	                 * and-string-formatting#html) to render the legend item texts. Prior
	                 * to 4.1.7, when using HTML, [legend.navigation](#legend.navigation)
	                 * was disabled.
	                 * 
	                 * @type {Boolean}
	                 * @default false
	                 * @apioption legend.useHTML
	                 */
	
	                /**
	                 * The width of the legend box.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/width/ Aligned to the plot area
	                 * @default null
	                 * @since 2.0
	                 * @apioption legend.width
	                 */
	
	                /**
	                 * The pixel padding between the legend item symbol and the legend
	                 * item text.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/symbolpadding/ Greater symbol width and padding
	                 * @default 5
	                 * @product highcharts highstock highmaps
	                 */
	                symbolPadding: 5,
	
	                /**
	                 * The vertical alignment of the legend box. Can be one of `top`,
	                 * `middle` or `bottom`. Vertical position can be further determined
	                 * by the `y` option.
	                 * 
	                 * In the case that the legend is aligned in a corner position, the
	                 * `layout` option will determine whether to place it above/below
	                 * or on the side of the plot area.
	                 * 
	                 * @validvalue ["top", "middle", "bottom"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/legend/verticalalign/ Legend 100px from the top of the chart
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/alignment/ Legend alignment
	                 * @default bottom
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                verticalAlign: 'bottom',
	                // width: undefined,
	
	                /**
	                 * The x offset of the legend relative to its horizontal alignment
	                 * `align` within chart.spacingLeft and chart.spacingRight. Negative
	                 * x moves it to the left, positive x moves it to the right.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/width/ Aligned to the plot area
	                 * @default 0
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                x: 0,
	
	                /**
	                 * The vertical offset of the legend relative to it's vertical alignment
	                 * `verticalAlign` within chart.spacingTop and chart.spacingBottom.
	                 *  Negative y moves it up, positive y moves it down.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/legend/verticalalign/ Legend 100px from the top of the chart
	                 * @sample {highstock} stock/legend/align/ Various legend options
	                 * @sample {highmaps} maps/legend/alignment/ Legend alignment
	                 * @default 0
	                 * @since 2.0
	                 * @product highcharts highstock highmaps
	                 */
	                y: 0,
	
	                /**
	                 * A title to be added on top of the legend.
	                 * 
	                 * @sample {highcharts} highcharts/legend/title/ Legend title
	                 * @sample {highmaps} maps/legend/alignment/ Legend with title
	                 * @since 3.0
	                 * @product highcharts highstock highmaps
	                 */
	                title: {
	                    //text: null,
	
	
	                    /**
	                     * Generic CSS styles for the legend title.
	                     * 
	                     * @type {CSSObject}
	                     * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the legend title is styled with the `.highcharts-
	                     * legend-title` class.
	                     * @default {"fontWeight":"bold"}
	                     * @since 3.0
	                     * @product highcharts highstock highmaps
	                     */
	                    style: {
	
	                        /**
	                         */
	                        fontWeight: 'bold'
	                    }
	
	                }
	            },
	
	
	            /**
	             * The loading options control the appearance of the loading screen
	             * that covers the plot area on chart operations. This screen only
	             * appears after an explicit call to `chart.showLoading()`. It is a
	             * utility for developers to communicate to the end user that something
	             * is going on, for example while retrieving new data via an XHR connection.
	             * The "Loading..." text itself is not part of this configuration
	             * object, but part of the `lang` object.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            loading: {
	
	                /**
	                 * The duration in milliseconds of the fade out effect.
	                 * 
	                 * @type {Number}
	                 * @sample highcharts/loading/hideduration/ Fade in and out over a second
	                 * @default 100
	                 * @since 1.2.0
	                 * @apioption loading.hideDuration
	                 */
	
	                /**
	                 * The duration in milliseconds of the fade in effect.
	                 * 
	                 * @type {Number}
	                 * @sample highcharts/loading/hideduration/ Fade in and out over a second
	                 * @default 100
	                 * @since 1.2.0
	                 * @apioption loading.showDuration
	                 */
	
	
	                /**
	                 * CSS styles for the loading label `span`.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the loading label is styled with the
	                 * `.highcharts-legend-loading-inner` class.
	                 * @sample {highcharts|highmaps} highcharts/loading/labelstyle/ Vertically centered
	                 * @sample {highstock} stock/loading/general/ Label styles
	                 * @default { "fontWeight": "bold", "position": "relative", "top": "45%" }
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                labelStyle: {
	                    fontWeight: 'bold',
	                    position: 'relative',
	                    top: '45%'
	                },
	
	                /**
	                 * CSS styles for the loading screen that covers the plot area.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the loading label is styled with the `.highcharts-
	                 * legend-loading` class.
	                 * @sample {highcharts|highmaps} highcharts/loading/style/ Gray plot area, white text
	                 * @sample {highstock} stock/loading/general/ Gray plot area, white text
	                 * @default { "position": "absolute", "backgroundColor": "#ffffff", "opacity": 0.5, "textAlign": "center" }
	                 * @since 1.2.0
	                 */
	                style: {
	                    position: 'absolute',
	                    backgroundColor: '#ffffff',
	                    opacity: 0.5,
	                    textAlign: 'center'
	                }
	
	            },
	
	
	            /**
	             * Options for the tooltip that appears when the user hovers over a
	             * series or point.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            tooltip: {
	
	                /**
	                 * Enable or disable the tooltip.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/tooltip/enabled/ Disabled
	                 * @sample {highcharts} highcharts/plotoptions/series-point-events-mouseover/ Disable tooltip and show values on chart instead
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                enabled: true,
	
	                /**
	                 * Enable or disable animation of the tooltip. In slow legacy IE browsers
	                 * the animation is disabled by default.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 2.3.0
	                 * @product highcharts highstock highmaps
	                 */
	                animation: svg,
	                //crosshairs: null,
	
	                /**
	                 * The radius of the rounded border corners.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ 5px by default
	                 * @sample {highcharts} highcharts/tooltip/borderradius-0/ Square borders
	                 * @sample {highmaps} maps/tooltip/background-border/ Background and border demo
	                 * @default 3
	                 * @product highcharts highstock highmaps
	                 */
	                borderRadius: 3,
	
	                /**
	                 * For series on a datetime axes, the date format in the tooltip's
	                 * header will by default be guessed based on the closest data points.
	                 * This member gives the default string representations used for
	                 * each unit. For an overview of the replacement codes, see [dateFormat](#Highcharts.
	                 * dateFormat).
	                 * 
	                 * Defaults to:
	                 * 
	                 * <pre>{
	                 * millisecond:"%A, %b %e, %H:%M:%S.%L",
	                 * second:"%A, %b %e, %H:%M:%S",
	                 * minute:"%A, %b %e, %H:%M",
	                 * hour:"%A, %b %e, %H:%M",
	                 * day:"%A, %b %e, %Y",
	                 * week:"Week from %A, %b %e, %Y",
	                 * month:"%B %Y",
	                 * year:"%Y"
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @see [xAxis.dateTimeLabelFormats](#xAxis.dateTimeLabelFormats)
	                 * @product highcharts highstock
	                 */
	                dateTimeLabelFormats: {
	
	                    /**
	                     */
	                    millisecond: '%A, %b %e, %H:%M:%S.%L',
	
	                    /**
	                     */
	                    second: '%A, %b %e, %H:%M:%S',
	
	                    /**
	                     */
	                    minute: '%A, %b %e, %H:%M',
	
	                    /**
	                     */
	                    hour: '%A, %b %e, %H:%M',
	
	                    /**
	                     */
	                    day: '%A, %b %e, %Y',
	
	                    /**
	                     */
	                    week: 'Week from %A, %b %e, %Y',
	
	                    /**
	                     */
	                    month: '%B %Y',
	
	                    /**
	                     */
	                    year: '%Y'
	                },
	
	                /**
	                 * A string to append to the tooltip format.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/tooltip/footerformat/ A table for value alignment
	                 * @sample {highmaps} maps/tooltip/format/ Format demo
	                 * @default false
	                 * @since 2.2
	                 * @product highcharts highmaps
	                 */
	                footerFormat: '',
	                //formatter: defaultFormatter,
	                /* todo: em font-size when finished comparing against HC4
	                headerFormat: '<span style="font-size: 0.85em">{point.key}</span><br/>',
	                */
	
	                /**
	                 * Padding inside the tooltip, in pixels.
	                 * 
	                 * @type {Number}
	                 * @default 8
	                 * @since 5.0.0
	                 * @product highcharts highstock highmaps
	                 */
	                padding: 8,
	
	                //shape: 'callout',
	                //shared: false,
	
	                /**
	                 * Proximity snap for graphs or single points. It defaults to 10 for
	                 * mouse-powered devices and 25 for touch devices.
	                 * 
	                 * Note that in most cases the whole plot area captures the mouse
	                 * movement, and in these cases `tooltip.snap` doesn't make sense.
	                 * This applies when [stickyTracking](#plotOptions.series.stickyTracking)
	                 * is `true` (default) and when the tooltip is [shared](#tooltip.shared)
	                 * or [split](#tooltip.split).
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ 10 px by default
	                 * @sample {highcharts} highcharts/tooltip/snap-50/ 50 px on graph
	                 * @default 10/25
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                snap: isTouchDevice ? 25 : 10,
	
	
	                /**
	                 * The background color or gradient for the tooltip.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is set in the `.highcharts-
	                 * tooltip-box` class.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/tooltip/backgroundcolor-solid/ Yellowish background
	                 * @sample {highcharts} highcharts/tooltip/backgroundcolor-gradient/ Gradient
	                 * @sample {highcharts} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highstock} stock/tooltip/general/ Custom tooltip
	                 * @sample {highstock} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highmaps} maps/tooltip/background-border/ Background and border demo
	                 * @sample {highmaps} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @default rgba(247,247,247,0.85)
	                 * @product highcharts highstock highmaps
	                 */
	                backgroundColor: color('#f7f7f7').setOpacity(0.85).get(),
	
	                /**
	                 * The pixel width of the tooltip border.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is set in the `.highcharts-
	                 * tooltip-box` class.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ 2px by default
	                 * @sample {highcharts} highcharts/tooltip/borderwidth/ No border (shadow only)
	                 * @sample {highcharts} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highstock} stock/tooltip/general/ Custom tooltip
	                 * @sample {highstock} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @sample {highmaps} maps/tooltip/background-border/ Background and border demo
	                 * @sample {highmaps} highcharts/css/tooltip-border-background/ Tooltip in styled mode
	                 * @default 1
	                 * @product highcharts highstock highmaps
	                 */
	                borderWidth: 1,
	
	                /**
	                 * The HTML of the tooltip header line. Variables are enclosed by
	                 * curly brackets. Available variables are `point.key`, `series.name`,
	                 * `series.color` and other members from the `point` and `series`
	                 * objects. The `point.key` variable contains the category name, x
	                 * value or datetime string depending on the type of axis. For datetime
	                 * axes, the `point.key` date format can be set using tooltip.xDateFormat.
	                 * 
	                 * 
	                 * Defaults to `<span style="font-size: 10px">{point.key}</span><br/>`
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/tooltip/footerformat/ A HTML table in the tooltip
	                 * @sample {highstock} highcharts/tooltip/footerformat/ A HTML table in the tooltip
	                 * @sample {highmaps} maps/tooltip/format/ Format demo
	                 * @product highcharts highstock highmaps
	                 */
	                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
	
	                /**
	                 * The HTML of the point's line in the tooltip. Variables are enclosed
	                 * by curly brackets. Available variables are point.x, point.y, series.
	                 * name and series.color and other properties on the same form. Furthermore,
	                 * point.y can be extended by the `tooltip.valuePrefix` and `tooltip.
	                 * valueSuffix` variables. This can also be overridden for each series,
	                 * which makes it a good hook for displaying units.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the dot is colored by a class name rather
	                 * than the point color.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/tooltip/pointformat/ A different point format with value suffix
	                 * @sample {highmaps} maps/tooltip/format/ Format demo
	                 * @default <span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>
	                 * @since 2.2
	                 * @product highcharts highstock highmaps
	                 */
	                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
	
	                /**
	                 * Whether to apply a drop shadow to the tooltip.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/tooltip/bordercolor-default/ True by default
	                 * @sample {highcharts} highcharts/tooltip/shadow/ False
	                 * @sample {highmaps} maps/tooltip/positioner/ Fixed tooltip position, border and shadow disabled
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                shadow: true,
	
	                /**
	                 * CSS styles for the tooltip. The tooltip can also be styled through
	                 * the CSS class `.highcharts-tooltip`.
	                 * 
	                 * @type {CSSObject}
	                 * @sample {highcharts} highcharts/tooltip/style/ Greater padding, bold text
	                 * @default { "color": "#333333", "cursor": "default", "fontSize": "12px", "pointerEvents": "none", "whiteSpace": "nowrap" }
	                 * @product highcharts highstock highmaps
	                 */
	                style: {
	
	                    /**
	                     */
	                    color: '#333333',
	
	                    /**
	                     */
	                    cursor: 'default',
	
	                    /**
	                     */
	                    fontSize: '12px',
	
	                    /**
	                     */
	                    pointerEvents: 'none', // #1686 http://caniuse.com/#feat=pointer-events
	
	                    /**
	                     */
	                    whiteSpace: 'nowrap'
	                }
	
	                //xDateFormat: '%A, %b %e, %Y',
	                //valueDecimals: null,
	                //valuePrefix: '',
	                //valueSuffix: ''
	            },
	
	
	            /**
	             * Highchart by default puts a credits label in the lower right corner
	             * of the chart. This can be changed using these options.
	             * 
	             * @product highcharts highstock highmaps
	             */
	            credits: {
	
	                /**
	                 * Whether to show the credits text.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/credits/enabled-false/ Credits disabled
	                 * @sample {highstock} stock/credits/enabled/ Credits disabled
	                 * @sample {highmaps} maps/credits/enabled-false/ Credits disabled
	                 * @default true
	                 * @product highcharts highstock highmaps
	                 */
	                enabled: true,
	
	                /**
	                 * The URL for the credits label.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/credits/href/ Custom URL and text
	                 * @sample {highmaps} maps/credits/customized/ Custom URL and text
	                 * @default {highcharts} http://www.highcharts.com
	                 * @default {highstock} "http://www.highcharts.com"
	                 * @default {highmaps} http://www.highcharts.com
	                 * @product highcharts highstock highmaps
	                 */
	                href: 'http://www.highcharts.com',
	
	                /**
	                 * Position configuration for the credits label.
	                 * 
	                 * @type {Object}
	                 * @sample {highcharts} highcharts/credits/position-left/ Left aligned
	                 * @sample {highcharts} highcharts/credits/position-left/ Left aligned
	                 * @sample {highmaps} maps/credits/customized/ Left aligned
	                 * @sample {highmaps} maps/credits/customized/ Left aligned
	                 * @since 2.1
	                 * @product highcharts highstock highmaps
	                 */
	                position: {
	
	                    /**
	                     * Horizontal alignment of the credits.
	                     * 
	                     * @validvalue ["left", "center", "right"]
	                     * @type {String}
	                     * @default right
	                     * @product highcharts highstock highmaps
	                     */
	                    align: 'right',
	
	                    /**
	                     * Horizontal pixel offset of the credits.
	                     * 
	                     * @type {Number}
	                     * @default -10
	                     * @product highcharts highstock highmaps
	                     */
	                    x: -10,
	
	                    /**
	                     * Vertical alignment of the credits.
	                     * 
	                     * @validvalue ["top", "middle", "bottom"]
	                     * @type {String}
	                     * @default bottom
	                     * @product highcharts highstock highmaps
	                     */
	                    verticalAlign: 'bottom',
	
	                    /**
	                     * Vertical pixel offset of the credits.
	                     * 
	                     * @type {Number}
	                     * @default -5
	                     * @product highcharts highstock highmaps
	                     */
	                    y: -5
	                },
	
	
	                /**
	                 * CSS styles for the credits label.
	                 * 
	                 * @type {CSSObject}
	                 * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), credits styles can be set with the `.highcharts-
	                 * credits` class.
	                 * @default { "cursor": "pointer", "color": "#999999", "fontSize": "10px" }
	                 * @product highcharts highstock highmaps
	                 */
	                style: {
	
	                    /**
	                     */
	                    cursor: 'pointer',
	
	                    /**
	                     */
	                    color: '#999999',
	
	                    /**
	                     */
	                    fontSize: '9px'
	                },
	
	
	                /**
	                 * The text for the credits label.
	                 *
	                 * @productdesc {highmaps}
	                 * If a map is loaded as GeoJSON, the text defaults to `Highcharts @
	                 * {map-credits}`. Otherwise, it defaults to `Highcharts.com`.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/credits/href/ Custom URL and text
	                 * @sample {highmaps} maps/credits/customized/ Custom URL and text
	                 * @default {highcharts|highstock} Highcharts.com
	                 */
	                text: 'Highcharts.com'
	            }
	        };
	
	
	
	        /**
	         * Sets the getTimezoneOffset function. If the timezone option is set, a default
	         * getTimezoneOffset function with that timezone is returned. If not, the
	         * specified getTimezoneOffset function is returned. If neither are specified,
	         * undefined is returned.
	         * @return {function} a getTimezoneOffset function or undefined
	         */
	        function getTimezoneOffsetOption() {
	            var globalOptions = H.defaultOptions.global,
	                moment = win.moment;
	
	            if (globalOptions.timezone) {
	                if (!moment) {
	                    // getTimezoneOffset-function stays undefined because it depends on
	                    // Moment.js
	                    H.error(25);
	
	                } else {
	                    return function(timestamp) {
	                        return -moment.tz(
	                            timestamp,
	                            globalOptions.timezone
	                        ).utcOffset();
	                    };
	                }
	            }
	
	            // If not timezone is set, look for the getTimezoneOffset callback
	            return globalOptions.useUTC && globalOptions.getTimezoneOffset;
	        }
	
	        /**
	         * Set the time methods globally based on the useUTC option. Time method can be
	         *   either local time or UTC (default). It is called internally on initiating
	         *   Highcharts and after running `Highcharts.setOptions`.
	         *
	         * @private
	         */
	        function setTimeMethods() {
	            var globalOptions = H.defaultOptions.global,
	                Date,
	                useUTC = globalOptions.useUTC,
	                GET = useUTC ? 'getUTC' : 'get',
	                SET = useUTC ? 'setUTC' : 'set';
	
	            H.Date = Date = globalOptions.Date || win.Date; // Allow using a different Date class
	            Date.hcTimezoneOffset = useUTC && globalOptions.timezoneOffset;
	            Date.hcGetTimezoneOffset = getTimezoneOffsetOption();
	            Date.hcMakeTime = function(year, month, date, hours, minutes, seconds) {
	                var d;
	                if (useUTC) {
	                    d = Date.UTC.apply(0, arguments);
	                    d += getTZOffset(d);
	                } else {
	                    d = new Date(
	                        year,
	                        month,
	                        pick(date, 1),
	                        pick(hours, 0),
	                        pick(minutes, 0),
	                        pick(seconds, 0)
	                    ).getTime();
	                }
	                return d;
	            };
	            each(['Minutes', 'Hours', 'Day', 'Date', 'Month', 'FullYear'], function(s) {
	                Date['hcGet' + s] = GET + s;
	            });
	            each(['Milliseconds', 'Seconds', 'Minutes', 'Hours', 'Date', 'Month', 'FullYear'], function(s) {
	                Date['hcSet' + s] = SET + s;
	            });
	        }
	
	        /**
	         * Merge the default options with custom options and return the new options
	         * structure. Commonly used for defining reusable templates.
	         *
	         * @function #setOptions
	         * @memberOf  Highcharts
	         * @sample highcharts/global/useutc-false Setting a global option
	         * @sample highcharts/members/setoptions Applying a global theme
	         * @param {Object} options The new custom chart options.
	         * @returns {Object} Updated options.
	         */
	        H.setOptions = function(options) {
	
	            // Copy in the default options
	            H.defaultOptions = merge(true, H.defaultOptions, options);
	
	            // Apply UTC
	            setTimeMethods();
	
	            return H.defaultOptions;
	        };
	
	        /**
	         * Get the updated default options. Until 3.0.7, merely exposing defaultOptions for outside modules
	         * wasn't enough because the setOptions method created a new object.
	         */
	        H.getOptions = function() {
	            return H.defaultOptions;
	        };
	
	
	        // Series defaults
	        H.defaultPlotOptions = H.defaultOptions.plotOptions;
	
	        // set the default time methods
	        setTimeMethods();
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var correctFloat = H.correctFloat,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            isNumber = H.isNumber,
	            merge = H.merge,
	            pick = H.pick,
	            deg2rad = H.deg2rad;
	
	        /**
	         * The Tick class
	         */
	        H.Tick = function(axis, pos, type, noLabel) {
	            this.axis = axis;
	            this.pos = pos;
	            this.type = type || '';
	            this.isNew = true;
	            this.isNewLabel = true;
	
	            if (!type && !noLabel) {
	                this.addLabel();
	            }
	        };
	
	        H.Tick.prototype = {
	            /**
	             * Write the tick label
	             */
	            addLabel: function() {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    chart = axis.chart,
	                    categories = axis.categories,
	                    names = axis.names,
	                    pos = tick.pos,
	                    labelOptions = options.labels,
	                    str,
	                    tickPositions = axis.tickPositions,
	                    isFirst = pos === tickPositions[0],
	                    isLast = pos === tickPositions[tickPositions.length - 1],
	                    value = categories ?
	                    pick(categories[pos], names[pos], pos) :
	                    pos,
	                    label = tick.label,
	                    tickPositionInfo = tickPositions.info,
	                    dateTimeLabelFormat;
	
	                // Set the datetime label format. If a higher rank is set for this position, use that. If not,
	                // use the general format.
	                if (axis.isDatetimeAxis && tickPositionInfo) {
	                    dateTimeLabelFormat =
	                        options.dateTimeLabelFormats[
	                            tickPositionInfo.higherRanks[pos] || tickPositionInfo.unitName
	                        ];
	                }
	                // set properties for access in render method
	                tick.isFirst = isFirst;
	                tick.isLast = isLast;
	
	                // get the string
	                str = axis.labelFormatter.call({
	                    axis: axis,
	                    chart: chart,
	                    isFirst: isFirst,
	                    isLast: isLast,
	                    dateTimeLabelFormat: dateTimeLabelFormat,
	                    value: axis.isLog ? correctFloat(axis.lin2log(value)) : value,
	                    pos: pos
	                });
	
	                // prepare CSS
	                //css = width && { width: Math.max(1, Math.round(width - 2 * (labelOptions.padding || 10))) + 'px' };
	
	                // first call
	                if (!defined(label)) {
	
	                    tick.label = label =
	                        defined(str) && labelOptions.enabled ?
	                        chart.renderer.text(
	                            str,
	                            0,
	                            0,
	                            labelOptions.useHTML
	                        )
	
	                        // without position absolute, IE export sometimes is wrong
	                        .css(merge(labelOptions.style))
	
	                        .add(axis.labelGroup) :
	                        null;
	                    tick.labelLength = label && label.getBBox().width; // Un-rotated length
	                    tick.rotation = 0; // Base value to detect change for new calls to getBBox
	
	                    // update
	                } else if (label) {
	                    label.attr({
	                        text: str
	                    });
	                }
	            },
	
	            /**
	             * Get the offset height or width of the label
	             */
	            getLabelSize: function() {
	                return this.label ?
	                    this.label.getBBox()[this.axis.horiz ? 'height' : 'width'] :
	                    0;
	            },
	
	            /**
	             * Handle the label overflow by adjusting the labels to the left and right edge, or
	             * hide them if they collide into the neighbour label.
	             */
	            handleOverflow: function(xy) {
	                var axis = this.axis,
	                    pxPos = xy.x,
	                    chartWidth = axis.chart.chartWidth,
	                    spacing = axis.chart.spacing,
	                    leftBound = pick(axis.labelLeft, Math.min(axis.pos, spacing[3])),
	                    rightBound = pick(axis.labelRight, Math.max(axis.pos + axis.len, chartWidth - spacing[1])),
	                    label = this.label,
	                    rotation = this.rotation,
	                    factor = {
	                        left: 0,
	                        center: 0.5,
	                        right: 1
	                    }[axis.labelAlign],
	                    labelWidth = label.getBBox().width,
	                    slotWidth = axis.getSlotWidth(),
	                    modifiedSlotWidth = slotWidth,
	                    xCorrection = factor,
	                    goRight = 1,
	                    leftPos,
	                    rightPos,
	                    textWidth,
	                    css = {};
	
	                // Check if the label overshoots the chart spacing box. If it does, move it.
	                // If it now overshoots the slotWidth, add ellipsis.
	                if (!rotation) {
	                    leftPos = pxPos - factor * labelWidth;
	                    rightPos = pxPos + (1 - factor) * labelWidth;
	
	                    if (leftPos < leftBound) {
	                        modifiedSlotWidth = xy.x + modifiedSlotWidth * (1 - factor) - leftBound;
	                    } else if (rightPos > rightBound) {
	                        modifiedSlotWidth = rightBound - xy.x + modifiedSlotWidth * factor;
	                        goRight = -1;
	                    }
	
	                    modifiedSlotWidth = Math.min(slotWidth, modifiedSlotWidth); // #4177
	                    if (modifiedSlotWidth < slotWidth && axis.labelAlign === 'center') {
	                        xy.x += goRight * (slotWidth - modifiedSlotWidth - xCorrection *
	                            (slotWidth - Math.min(labelWidth, modifiedSlotWidth)));
	                    }
	                    // If the label width exceeds the available space, set a text width to be
	                    // picked up below. Also, if a width has been set before, we need to set a new
	                    // one because the reported labelWidth will be limited by the box (#3938).
	                    if (labelWidth > modifiedSlotWidth || (axis.autoRotation && (label.styles || {}).width)) {
	                        textWidth = modifiedSlotWidth;
	                    }
	
	                    // Add ellipsis to prevent rotated labels to be clipped against the edge of the chart
	                } else if (rotation < 0 && pxPos - factor * labelWidth < leftBound) {
	                    textWidth = Math.round(pxPos / Math.cos(rotation * deg2rad) - leftBound);
	                } else if (rotation > 0 && pxPos + factor * labelWidth > rightBound) {
	                    textWidth = Math.round((chartWidth - pxPos) / Math.cos(rotation * deg2rad));
	                }
	
	                if (textWidth) {
	                    css.width = textWidth;
	                    if (!(axis.options.labels.style || {}).textOverflow) {
	                        css.textOverflow = 'ellipsis';
	                    }
	                    label.css(css);
	                }
	            },
	
	            /**
	             * Get the x and y position for ticks and labels
	             */
	            getPosition: function(horiz, pos, tickmarkOffset, old) {
	                var axis = this.axis,
	                    chart = axis.chart,
	                    cHeight = (old && chart.oldChartHeight) || chart.chartHeight;
	
	                return {
	                    x: horiz ?
	                        axis.translate(pos + tickmarkOffset, null, null, old) + axis.transB : axis.left + axis.offset +
	                        (axis.opposite ?
	                            ((old && chart.oldChartWidth) || chart.chartWidth) - axis.right - axis.left :
	                            0
	                        ),
	
	                    y: horiz ?
	                        cHeight - axis.bottom + axis.offset - (axis.opposite ? axis.height : 0) : cHeight - axis.translate(pos + tickmarkOffset, null, null, old) - axis.transB
	                };
	
	            },
	
	            /**
	             * Get the x, y position of the tick label
	             */
	            getLabelPosition: function(x, y, label, horiz, labelOptions, tickmarkOffset, index, step) {
	                var axis = this.axis,
	                    transA = axis.transA,
	                    reversed = axis.reversed,
	                    staggerLines = axis.staggerLines,
	                    rotCorr = axis.tickRotCorr || {
	                        x: 0,
	                        y: 0
	                    },
	                    yOffset = labelOptions.y,
	                    line;
	
	                if (!defined(yOffset)) {
	                    if (axis.side === 0) {
	                        yOffset = label.rotation ? -8 : -label.getBBox().height;
	                    } else if (axis.side === 2) {
	                        yOffset = rotCorr.y + 8;
	                    } else {
	                        // #3140, #3140
	                        yOffset = Math.cos(label.rotation * deg2rad) * (rotCorr.y - label.getBBox(false, 0).height / 2);
	                    }
	                }
	
	                x = x + labelOptions.x + rotCorr.x - (tickmarkOffset && horiz ?
	                    tickmarkOffset * transA * (reversed ? -1 : 1) : 0);
	                y = y + yOffset - (tickmarkOffset && !horiz ?
	                    tickmarkOffset * transA * (reversed ? 1 : -1) : 0);
	
	                // Correct for staggered labels
	                if (staggerLines) {
	                    line = (index / (step || 1) % staggerLines);
	                    if (axis.opposite) {
	                        line = staggerLines - line - 1;
	                    }
	                    y += line * (axis.labelOffset / staggerLines);
	                }
	
	                return {
	                    x: x,
	                    y: Math.round(y)
	                };
	            },
	
	            /**
	             * Extendible method to return the path of the marker
	             */
	            getMarkPath: function(x, y, tickLength, tickWidth, horiz, renderer) {
	                return renderer.crispLine([
	                    'M',
	                    x,
	                    y,
	                    'L',
	                    x + (horiz ? 0 : -tickLength),
	                    y + (horiz ? tickLength : 0)
	                ], tickWidth);
	            },
	
	            /**
	             * Renders the gridLine.
	             * @param  {Boolean} old         Whether or not the tick is old
	             * @param  {number} opacity      The opacity of the grid line
	             * @param  {number} reverseCrisp Modifier for avoiding overlapping 1 or -1
	             * @return {undefined}
	             */
	            renderGridLine: function(old, opacity, reverseCrisp) {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    gridLine = tick.gridLine,
	                    gridLinePath,
	                    attribs = {},
	                    pos = tick.pos,
	                    type = tick.type,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    renderer = axis.chart.renderer;
	
	
	                var gridPrefix = type ? type + 'Grid' : 'grid',
	                    gridLineWidth = options[gridPrefix + 'LineWidth'],
	                    gridLineColor = options[gridPrefix + 'LineColor'],
	                    dashStyle = options[gridPrefix + 'LineDashStyle'];
	
	
	                if (!gridLine) {
	
	                    attribs.stroke = gridLineColor;
	                    attribs['stroke-width'] = gridLineWidth;
	                    if (dashStyle) {
	                        attribs.dashstyle = dashStyle;
	                    }
	
	                    if (!type) {
	                        attribs.zIndex = 1;
	                    }
	                    if (old) {
	                        attribs.opacity = 0;
	                    }
	                    tick.gridLine = gridLine = renderer.path()
	                        .attr(attribs)
	                        .addClass(
	                            'highcharts-' + (type ? type + '-' : '') + 'grid-line'
	                        )
	                        .add(axis.gridGroup);
	                }
	
	                // If the parameter 'old' is set, the current call will be followed
	                // by another call, therefore do not do any animations this time
	                if (!old && gridLine) {
	                    gridLinePath = axis.getPlotLinePath(
	                        pos + tickmarkOffset,
	                        gridLine.strokeWidth() * reverseCrisp,
	                        old, true
	                    );
	                    if (gridLinePath) {
	                        gridLine[tick.isNew ? 'attr' : 'animate']({
	                            d: gridLinePath,
	                            opacity: opacity
	                        });
	                    }
	                }
	            },
	
	            /**
	             * Renders the tick mark.
	             * @param  {Object} xy           The position vector of the mark
	             * @param  {number} xy.x         The x position of the mark
	             * @param  {number} xy.y         The y position of the mark
	             * @param  {number} opacity      The opacity of the mark
	             * @param  {number} reverseCrisp Modifier for avoiding overlapping 1 or -1
	             * @return {undefined}
	             */
	            renderMark: function(xy, opacity, reverseCrisp) {
	                var tick = this,
	                    axis = tick.axis,
	                    options = axis.options,
	                    renderer = axis.chart.renderer,
	                    type = tick.type,
	                    tickPrefix = type ? type + 'Tick' : 'tick',
	                    tickSize = axis.tickSize(tickPrefix),
	                    mark = tick.mark,
	                    isNewMark = !mark,
	                    x = xy.x,
	                    y = xy.y;
	
	
	                var tickWidth = pick(
	                        options[tickPrefix + 'Width'], !type && axis.isXAxis ? 1 : 0
	                    ), // X axis defaults to 1
	                    tickColor = options[tickPrefix + 'Color'];
	
	
	                if (tickSize) {
	
	                    // negate the length
	                    if (axis.opposite) {
	                        tickSize[0] = -tickSize[0];
	                    }
	
	                    // First time, create it
	                    if (isNewMark) {
	                        tick.mark = mark = renderer.path()
	                            .addClass('highcharts-' + (type ? type + '-' : '') + 'tick')
	                            .add(axis.axisGroup);
	
	
	                        mark.attr({
	                            stroke: tickColor,
	                            'stroke-width': tickWidth
	                        });
	
	                    }
	                    mark[isNewMark ? 'attr' : 'animate']({
	                        d: tick.getMarkPath(
	                            x,
	                            y,
	                            tickSize[0],
	                            mark.strokeWidth() * reverseCrisp,
	                            axis.horiz,
	                            renderer),
	                        opacity: opacity
	                    });
	
	                }
	            },
	
	            /**
	             * Renders the tick label.
	             * Note: The label should already be created in init(), so it should only
	             * have to be moved into place.
	             * @param  {Object} xy      The position vector of the label
	             * @param  {number} xy.x    The x position of the label
	             * @param  {number} xy.y    The y position of the label
	             * @param  {Boolean} old    Whether or not the tick is old
	             * @param  {number} opacity The opacity of the label
	             * @param  {number} index   The index of the tick
	             * @return {undefined}
	             */
	            renderLabel: function(xy, old, opacity, index) {
	                var tick = this,
	                    axis = tick.axis,
	                    horiz = axis.horiz,
	                    options = axis.options,
	                    label = tick.label,
	                    labelOptions = options.labels,
	                    step = labelOptions.step,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    show = true,
	                    x = xy.x,
	                    y = xy.y;
	                if (label && isNumber(x)) {
	                    label.xy = xy = tick.getLabelPosition(
	                        x,
	                        y,
	                        label,
	                        horiz,
	                        labelOptions,
	                        tickmarkOffset,
	                        index,
	                        step
	                    );
	
	                    // Apply show first and show last. If the tick is both first and
	                    // last, it is a single centered tick, in which case we show the
	                    // label anyway (#2100).
	                    if (
	                        (
	                            tick.isFirst &&
	                            !tick.isLast &&
	                            !pick(options.showFirstLabel, 1)
	                        ) ||
	                        (
	                            tick.isLast &&
	                            !tick.isFirst &&
	                            !pick(options.showLastLabel, 1)
	                        )
	                    ) {
	                        show = false;
	
	                        // Handle label overflow and show or hide accordingly
	                    } else if (horiz && !axis.isRadial && !labelOptions.step &&
	                        !labelOptions.rotation && !old && opacity !== 0) {
	                        tick.handleOverflow(xy);
	                    }
	
	                    // apply step
	                    if (step && index % step) {
	                        // show those indices dividable by step
	                        show = false;
	                    }
	
	                    // Set the new position, and show or hide
	                    if (show && isNumber(xy.y)) {
	                        xy.opacity = opacity;
	                        label[tick.isNewLabel ? 'attr' : 'animate'](xy);
	                        tick.isNewLabel = false;
	                    } else {
	                        label.attr('y', -9999); // #1338
	                        tick.isNewLabel = true;
	                    }
	                    tick.isNew = false;
	                }
	            },
	
	            /**
	             * Put everything in place
	             *
	             * @param index {Number}
	             * @param old {Boolean} Use old coordinates to prepare an animation into new
	             *                      position
	             */
	            render: function(index, old, opacity) {
	                var tick = this,
	                    axis = tick.axis,
	                    horiz = axis.horiz,
	                    pos = tick.pos,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    xy = tick.getPosition(horiz, pos, tickmarkOffset, old),
	                    x = xy.x,
	                    y = xy.y,
	                    reverseCrisp = ((horiz && x === axis.pos + axis.len) ||
	                        (!horiz && y === axis.pos)) ? -1 : 1; // #1480, #1687
	
	                opacity = pick(opacity, 1);
	                this.isActive = true;
	
	                // Create the grid line
	                this.renderGridLine(old, opacity, reverseCrisp);
	
	                // create the tick mark
	                this.renderMark(xy, opacity, reverseCrisp);
	
	                // the label is created on init - now move it into place
	                this.renderLabel(xy, old, opacity, index);
	            },
	
	            /**
	             * Destructor for the tick prototype
	             */
	            destroy: function() {
	                destroyObjectProperties(this, this.axis);
	            }
	        };
	
	    }(Highcharts));
	    var Axis = (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var addEvent = H.addEvent,
	            animObject = H.animObject,
	            arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            color = H.color,
	            correctFloat = H.correctFloat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            deg2rad = H.deg2rad,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            format = H.format,
	            getMagnitude = H.getMagnitude,
	            grep = H.grep,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            merge = H.merge,
	            normalizeTickInterval = H.normalizeTickInterval,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            syncTimeout = H.syncTimeout,
	            Tick = H.Tick;
	
	        /**
	         * Create a new axis object. Called internally when instanciating a new chart or
	         * adding axes by {@link Highcharts.Chart#addAxis}.
	         *
	         * A chart can have from 0 axes (pie chart) to multiples. In a normal, single
	         * series cartesian chart, there is one X axis and one Y axis.
	         * 
	         * The X axis or axes are referenced by {@link Highcharts.Chart.xAxis}, which is
	         * an array of Axis objects. If there is only one axis, it can be referenced
	         * through `chart.xAxis[0]`, and multiple axes have increasing indices. The same
	         * pattern goes for Y axes.
	         * 
	         * If you need to get the axes from a series object, use the `series.xAxis` and
	         * `series.yAxis` properties. These are not arrays, as one series can only be
	         * associated to one X and one Y axis.
	         * 
	         * A third way to reference the axis programmatically is by `id`. Add an `id` in
	         * the axis configuration options, and get the axis by
	         * {@link Highcharts.Chart#get}.
	         * 
	         * Configuration options for the axes are given in options.xAxis and
	         * options.yAxis.
	         * 
	         * @class Highcharts.Axis
	         * @memberOf Highcharts
	         * @param {Highcharts.Chart} chart - The Chart instance to apply the axis on.
	         * @param {Object} options - Axis options
	         */
	        var Axis = function() {
	            this.init.apply(this, arguments);
	        };
	
	        H.extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * The X axis or category axis. Normally this is the horizontal axis,
	             * though if the chart is inverted this is the vertical axis. In case of
	             * multiple axes, the xAxis node is an array of configuration objects.
	             * 
	             * See [../class-reference/Highcharts.Axis](the Axis object) for
	             * programmatic access to the axis.
	             *
	             * @productdesc {highmaps}
	             * In Highmaps, the axis is hidden, but it is used behind the scenes to
	             * control features like zooming and panning. Zooming is in effect the same
	             * as setting the extremes of one of the exes.
	             * 
	             * @optionparent xAxis
	             */
	            defaultOptions: {
	                // allowDecimals: null,
	                // alternateGridColor: null,
	                // categories: [],
	
	                /**
	                 * For a datetime axis, the scale will automatically adjust to the
	                 * appropriate unit. This member gives the default string representations
	                 * used for each unit. For intermediate values, different units may
	                 * be used, for example the `day` unit can be used on midnight and
	                 * `hour` unit be used for intermediate values on the same axis. For
	                 * an overview of the replacement codes, see [dateFormat](#Highcharts.
	                 * dateFormat). Defaults to:
	                 * 
	                 * <pre>{
	                 * millisecond: '%H:%M:%S.%L',
	                 * second: '%H:%M:%S',
	                 * minute: '%H:%M',
	                 * hour: '%H:%M',
	                 * day: '%e. %b',
	                 * week: '%e. %b',
	                 * month: '%b \'%y',
	                 * year: '%Y'
	                 * }</pre>
	                 * 
	                 * @type {Object}
	                 * @sample {highcharts} highcharts/xaxis/datetimelabelformats/ Different day format on X axis
	                 * @sample {highstock} stock/xaxis/datetimelabelformats/ More information in x axis labels
	                 * @product highcharts highstock
	                 */
	                dateTimeLabelFormats: {
	
	                    /**
	                     */
	                    millisecond: '%H:%M:%S.%L',
	
	                    /**
	                     */
	                    second: '%H:%M:%S',
	
	                    /**
	                     */
	                    minute: '%H:%M',
	
	                    /**
	                     */
	                    hour: '%H:%M',
	
	                    /**
	                     */
	                    day: '%e. %b',
	
	                    /**
	                     */
	                    week: '%e. %b',
	
	                    /**
	                     */
	                    month: '%b \'%y',
	
	                    /**
	                     */
	                    year: '%Y'
	                },
	
	                /**
	                 * Whether to force the axis to end on a tick. Use this option with
	                 * the `maxPadding` option to control the axis end.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/reflow-true/ True by default
	                 * @sample {highcharts} highcharts/yaxis/endontick/ False
	                 * @sample {highstock} stock/demo/basic-line/ True by default
	                 * @sample {highstock} stock/xaxis/endontick/ False
	                 * @default false
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                endOnTick: false,
	                // reversed: false,
	
	
	                /**
	                 * The axis labels show the number or category for each tick.
	                 *
	                 * @productdesc {highmaps}
	                 * X and Y axis labels are by default disabled in Highmaps, but the
	                 * functionality is inherited from Highcharts and used on `colorAxis`,
	                 * and can be enabled on X and Y axes too.
	                 */
	                labels: {
	
	                    /**
	                     * Enable or disable the axis labels.
	                     * 
	                     * @type {Boolean}
	                     * @sample {highcharts} highcharts/xaxis/labels-enabled/ X axis labels disabled
	                     * @sample {highstock} stock/xaxis/labels-enabled/ X axis labels disabled
	                     * @default {highstock} true
	                     * @default {highmaps} false
	                     * @product highcharts highstock highmaps
	                     */
	                    enabled: true,
	                    // rotation: 0,
	                    // align: 'center',
	                    // step: null,
	
	
	                    /**
	                     * CSS styles for the label. Use `whiteSpace: 'nowrap'` to prevent
	                     * wrapping of category labels. Use `textOverflow: 'none'` to prevent
	                     * ellipsis (dots).
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the labels are styled with the `.highcharts-
	                     * axis-labels` class.
	                     * 
	                     * @type {CSSObject}
	                     * @sample {highcharts} highcharts/xaxis/labels-style/ Red X axis labels
	                     * @default { "color": "#666666", "cursor": "default", "fontSize": "11px" }
	                     * @product highcharts highstock highmaps
	                     */
	                    style: {
	
	                        /**
	                         */
	                        color: '#666666',
	
	                        /**
	                         */
	                        cursor: 'default',
	
	                        /**
	                         */
	                        fontSize: '11px'
	                    },
	
	
	                    /**
	                     * The x position offset of the label relative to the tick position
	                     * on the axis.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/xaxis/labels-x/ Y axis labels placed on grid lines
	                     * @default 0
	                     * @product highcharts highstock highmaps
	                     */
	                    x: 0
	                    //y: undefined
	                    /*formatter: function () {
	                    	return this.value;
	                    },*/
	                },
	                //linkedTo: null,
	                //max: undefined,
	                //min: undefined,
	
	                /**
	                 * Padding of the min value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the lowest data value to appear on the edge
	                 * of the plot area. When the axis' `min` option is set or a min extreme
	                 * is set using `axis.setExtremes()`, the minPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minpadding/ Min padding of 0.2
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/ Add some padding
	                 * @default {highcharts} 0.01
	                 * @default {highstock} 0
	                 * @default {highmaps} 0
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                minPadding: 0.01,
	
	                /**
	                 * Padding of the max value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the highest data value to appear on the edge
	                 * of the plot area. When the axis' `max` option is set or a max extreme
	                 * is set using `axis.setExtremes()`, the maxPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/maxpadding/ Max padding of 0.25 on y axis
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @sample {highmaps} maps/chart/plotbackgroundcolor-gradient/ Add some padding
	                 * @default {highcharts} 0.01
	                 * @default {highstock} 0
	                 * @default {highmaps} 0
	                 * @since 1.2.0
	                 * @product highcharts highstock highmaps
	                 */
	                maxPadding: 0.01,
	                //minRange: null,
	                //minorTickInterval: null,
	
	                /**
	                 * The pixel length of the minor tick marks.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minorticklength/ 10px on Y axis
	                 * @sample {highstock} stock/xaxis/minorticks/ 10px on Y axis
	                 * @default 2
	                 * @product highcharts highstock highmaps
	                 */
	                minorTickLength: 2,
	
	                /**
	                 * The position of the minor tick marks relative to the axis line.
	                 *  Can be one of `inside` and `outside`.
	                 * 
	                 * @validvalue ["inside", "outside"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/yaxis/minortickposition-outside/ Outside by default
	                 * @sample {highcharts} highcharts/yaxis/minortickposition-inside/ Inside
	                 * @sample {highstock} stock/xaxis/minorticks/ Inside
	                 * @default outside
	                 * @product highcharts highstock highmaps
	                 */
	                minorTickPosition: 'outside', // inside or outside
	                //opposite: false,
	                //offset: 0,
	                //plotBands: [{
	                //	events: {},
	                //	zIndex: 1,
	                //	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
	                //}],
	                //plotLines: [{
	                //	events: {}
	                //  dashStyle: {}
	                //	zIndex:
	                //	labels: { align, x, verticalAlign, y, style, rotation, textAlign }
	                //}],
	                //reversed: false,
	                // showFirstLabel: true,
	                // showLastLabel: true,
	
	                /**
	                 * For datetime axes, this decides where to put the tick between weeks.
	                 *  0 = Sunday, 1 = Monday.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/xaxis/startofweek-monday/ Monday by default
	                 * @sample {highcharts} highcharts/xaxis/startofweek-sunday/ Sunday
	                 * @sample {highstock} stock/xaxis/startofweek-1 Monday by default
	                 * @sample {highstock} stock/xaxis/startofweek-0 Sunday
	                 * @default 1
	                 * @product highcharts highstock
	                 */
	                startOfWeek: 1,
	
	                /**
	                 * Whether to force the axis to start on a tick. Use this option with
	                 * the `minPadding` option to control the axis start.
	                 *
	                 * @productdesc {highstock}
	                 * In Highstock, `startOnTick` is always false when the navigator is
	                 * enabled, to prevent jumpy scrolling.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/xaxis/startontick-false/ False by default
	                 * @sample {highcharts} highcharts/xaxis/startontick-true/ True
	                 * @sample {highstock} stock/xaxis/endontick/ False for Y axis
	                 * @default false
	                 * @since 1.2.0
	                 */
	                startOnTick: false,
	                //tickInterval: null,
	
	                /**
	                 * The pixel length of the main tick marks.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/xaxis/ticklength/ 20 px tick length on the X axis
	                 * @sample {highstock} stock/xaxis/ticks/ Formatted ticks on X axis
	                 * @default 10
	                 * @product highcharts highstock highmaps
	                 */
	                tickLength: 10,
	
	                /**
	                 * For categorized axes only. If `on` the tick mark is placed in the
	                 * center of the category, if `between` the tick mark is placed between
	                 * categories. The default is `between` if the `tickInterval` is 1,
	                 *  else `on`.
	                 * 
	                 * @validvalue [null, "on", "between"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/xaxis/tickmarkplacement-between/ "between" by default
	                 * @sample {highcharts} highcharts/xaxis/tickmarkplacement-on/ "on"
	                 * @default null
	                 * @product highcharts
	                 */
	                tickmarkPlacement: 'between', // on or between
	
	                /**
	                 * If tickInterval is `null` this option sets the approximate pixel
	                 * interval of the tick marks. Not applicable to categorized axis.
	                 * 
	                 * 
	                 * The tick interval is also influenced by the [minTickInterval](#xAxis.
	                 * minTickInterval) option, that, by default prevents ticks from being
	                 * denser than the data points.
	                 * 
	                 * Defaults to `72` for the Y axis and `100` for the X axis.
	                 * 
	                 * @type {Number}
	                 * @see [tickInterval](#xAxis.tickInterval), [tickPositioner](#xAxis.tickPositioner),
	                 *  [tickPositions](#xAxis.tickPositions)-
	                 * @sample {highcharts} highcharts/xaxis/tickpixelinterval-50/ 50 px on X axis
	                 * @sample {highstock} stock/xaxis/tickpixelinterval/ 200 px on X axis
	                 * @product highcharts highstock highmaps
	                 */
	                tickPixelInterval: 100,
	
	                /**
	                 * The position of the major tick marks relative to the axis line.
	                 *  Can be one of `inside` and `outside`.
	                 * 
	                 * @validvalue ["inside", "outside"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/xaxis/tickposition-outside/ "outside" by default
	                 * @sample {highcharts} highcharts/xaxis/tickposition-inside/ "inside"
	                 * @sample {highstock} stock/xaxis/ticks/ Formatted ticks on X axis
	                 * @default {highcharts} outside
	                 * @default {highstock} "outside"
	                 * @default {highmaps} outside
	                 * @product highcharts highstock highmaps
	                 */
	                tickPosition: 'outside',
	
	                /**
	                 * The axis title, showing next to the axis line.
	                 *
	                 * @productdesc {highmaps}
	                 * In Highmaps, the axis is hidden by default, but adding an axis title
	                 * is still possible. X axis and Y axis titles will appear at the bottom
	                 * and left by default.
	                 */
	                title: {
	                    //text: null,
	
	                    /**
	                     * Alignment of the title relative to the axis values. Possible values
	                     * are "low", "middle" or "high".
	                     * 
	                     * @validvalue ["low", "middle", "high"]
	                     * @type {String}
	                     * @sample {highcharts} highcharts/xaxis/title-align-low/ "low"
	                     * @sample {highcharts} highcharts/xaxis/title-align-center/ "middle" by default
	                     * @sample {highcharts} highcharts/xaxis/title-align-high/ "high"
	                     * @sample {highcharts} highcharts/yaxis/title-offset/ Place the Y axis title on top of the axis
	                     * @sample {highstock} stock/xaxis/title-align/ Aligned to "high" value
	                     * @default {highcharts} middle
	                     * @default {highstock} "middle"
	                     * @default {highmaps} middle
	                     * @product highcharts highstock highmaps
	                     */
	                    align: 'middle', // low, middle or high
	                    //margin: 0 for horizontal, 10 for vertical axes,
	                    // reserveSpace: true,
	                    //rotation: 0,
	                    //side: 'outside',
	
	
	                    /**
	                     * CSS styles for the title. If the title text is longer than the
	                     * axis length, it will wrap to multiple lines by default. This can
	                     * be customized by setting `textOverflow: 'ellipsis'`, by 
	                     * setting a specific `width` or by setting `wordSpace: 'nowrap'`.
	                     * 
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the stroke width is given in the
	                     * `.highcharts-axis-title` class.
	                     * 
	                     * @type {CSSObject}
	                     * @sample {highcharts} highcharts/xaxis/title-style/ Red
	                     * @sample {highcharts} highcharts/css/axis/ Styled mode
	                     * @default { "color": "#666666" }
	                     * @product highcharts highstock highmaps
	                     */
	                    style: {
	
	                        /**
	                         */
	                        color: '#666666'
	                    }
	
	                    //x: 0,
	                    //y: 0
	                },
	
	                /**
	                 * The type of axis. Can be one of `linear`, `logarithmic`, `datetime`
	                 * or `category`. In a datetime axis, the numbers are given in milliseconds,
	                 * and tick marks are placed on appropriate values like full hours
	                 * or days. In a category axis, the [point names](#series<line>.data.
	                 * name) of the chart's series are used for categories, if not a [categories](#xAxis.
	                 * categories) array is defined.
	                 * 
	                 * @validvalue ["linear", "logarithmic", "datetime", "category"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/xaxis/type-linear/ Linear
	                 * @sample {highcharts} highcharts/yaxis/type-log/ Logarithmic
	                 * @sample {highcharts} highcharts/yaxis/type-log-minorgrid/ Logarithmic with minor grid lines
	                 * @sample {highcharts} highcharts/xaxis/type-log-both/ Logarithmic on two axes
	                 * @sample {highcharts} highcharts/yaxis/type-log-negative/ Logarithmic with extension to emulate negative values
	                 * @default linear
	                 * @product highcharts
	                 */
	                type: 'linear', // linear, logarithmic or datetime
	                //visible: true
	
	
	                /**
	                 * Color of the minor, secondary grid lines.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is given in the `.highcharts-
	                 * minor-grid-line` class.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/minorgridlinecolor/ Bright grey lines from Y axis
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/minorgridlinecolor/ Bright grey lines from Y axis
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default #f2f2f2
	                 * @product highcharts highstock highmaps
	                 */
	                minorGridLineColor: '#f2f2f2',
	                // minorGridLineDashStyle: null,
	
	                /**
	                 * Width of the minor, secondary grid lines.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is given in the `.highcharts-
	                 * grid-line` class.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minorgridlinewidth/ 2px lines from Y axis
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/minorgridlinewidth/ 2px lines from Y axis
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default 1
	                 * @product highcharts highstock highmaps
	                 */
	                minorGridLineWidth: 1,
	
	                /**
	                 * Color for the minor tick marks.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/minortickcolor/ Black tick marks on Y axis
	                 * @sample {highstock} stock/xaxis/minorticks/ Black tick marks on Y axis
	                 * @default #999999
	                 * @product highcharts highstock highmaps
	                 */
	                minorTickColor: '#999999',
	                //minorTickWidth: 0,
	
	                /**
	                 * The color of the line marking the axis itself.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the line stroke is given in the `.highcharts-
	                 * axis-line` or `.highcharts-xaxis-line` class.
	                 * 
	                 * @productdesc {highmaps}
	                 * In Highmaps, the axis line is hidden by default.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/linecolor/ A red line on Y axis
	                 * @sample {highcharts} highcharts/css/axis/ Axes in styled mode
	                 * @sample {highstock} stock/xaxis/linecolor/ A red line on X axis
	                 * @sample {highstock} highcharts/css/axis/ Axes in styled mode
	                 * @default #ccd6eb
	                 * @product highcharts highstock highmaps
	                 */
	                lineColor: '#ccd6eb',
	
	                /**
	                 * The width of the line marking the axis itself.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke width is given in the `.highcharts-
	                 * axis-line` or `.highcharts-xaxis-line` class.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/linecolor/ A 1px line on Y axis
	                 * @sample {highcharts} highcharts/css/axis/ Axes in styled mode
	                 * @sample {highstock} stock/xaxis/linewidth/ A 2px line on X axis
	                 * @sample {highstock} highcharts/css/axis/ Axes in styled mode
	                 * @default {highcharts} 1
	                 * @default {highstock} 1
	                 * @default {highmaps} 0
	                 * @product highcharts highstock highmaps
	                 */
	                lineWidth: 1,
	
	                /**
	                 * Color of the grid lines extending the ticks across the plot area.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is given in the `.highcharts-grid-
	                 * line` class.
	                 *
	                 * @productdesc {highmaps}
	                 * In Highmaps, the grid lines are hidden by default.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/yaxis/gridlinecolor/ Green lines
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/gridlinecolor/ Green lines
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default #e6e6e6
	                 * @product highcharts highstock highmaps
	                 */
	                gridLineColor: '#e6e6e6',
	                // gridLineDashStyle: 'solid',
	                // gridLineWidth: 0,
	
	                /**
	                 * Color for the main tick marks.
	                 * 
	                 * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                 * style/style-by-css), the stroke is given in the `.highcharts-tick`
	                 * class.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/xaxis/tickcolor/ Red ticks on X axis
	                 * @sample {highcharts} highcharts/css/axis-grid/ Styled mode
	                 * @sample {highstock} stock/xaxis/ticks/ Formatted ticks on X axis
	                 * @sample {highstock} highcharts/css/axis-grid/ Styled mode
	                 * @default #ccd6eb
	                 * @product highcharts highstock highmaps
	                 */
	                tickColor: '#ccd6eb'
	                // tickWidth: 1
	
	            },
	
	            /**
	             * This option set extends the defaultOptions for Y axes.
	             * @extends xAxis
	             * @optionparent yAxis
	             */
	            defaultYAxisOptions: {
	
	                /**
	                 * Whether to force the axis to end on a tick. Use this option with
	                 * the `maxPadding` option to control the axis end.
	                 *
	                 * @productdesc {highstock}
	                 * In Highstock, `endOnTick` is always false when the navigator is
	                 * enabled, to prevent jumpy scrolling.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/chart/reflow-true/ True by default
	                 * @sample {highcharts} highcharts/yaxis/endontick-false/ False
	                 * @sample {highcharts} highcharts/yaxis/endontick-log-false/ False
	                 * @sample {highstock} stock/demo/basic-line/ True by default
	                 * @sample {highstock} stock/xaxis/endontick/ False
	                 * @default true
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                endOnTick: true,
	
	                /**
	                 */
	                tickPixelInterval: 72,
	
	                /**
	                 * Whether to show the last tick label. Defaults to `true` on cartesian
	                 * charts, and `false` on polar charts.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/xaxis/showlastlabel-true/ Set to true on X axis
	                 * @sample {highstock} stock/xaxis/showfirstlabel/ Labels below plot lines on Y axis
	                 * @default false
	                 * @product highcharts highstock
	                 */
	                showLastLabel: true,
	
	                /**
	                 * @extends xAxis.labels
	                 * @product highcharts highstock highmaps
	                 */
	                labels: {
	
	                    /**
	                     * The x position offset of the label relative to the tick position
	                     * on the axis. Defaults to -15 for left axis, 15 for right axis.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/xaxis/labels-x/ Y axis labels placed on grid lines
	                     * @default 0
	                     * @product highcharts highstock highmaps
	                     */
	                    x: -8
	                },
	
	                /**
	                 * Padding of the max value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the highest data value to appear on the edge
	                 * of the plot area. When the axis' `max` option is set or a max extreme
	                 * is set using `axis.setExtremes()`, the maxPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/maxpadding-02/ Max padding of 0.2
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @default 0.05
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                maxPadding: 0.05,
	
	                /**
	                 * Padding of the min value relative to the length of the axis. A
	                 * padding of 0.05 will make a 100px axis 5px longer. This is useful
	                 * when you don't want the lowest data value to appear on the edge
	                 * of the plot area. When the axis' `min` option is set or a max extreme
	                 * is set using `axis.setExtremes()`, the maxPadding will be ignored.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/minpadding/ Min padding of 0.2
	                 * @sample {highstock} stock/xaxis/minpadding-maxpadding/ Greater min- and maxPadding
	                 * @default 0.05
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                minPadding: 0.05,
	
	                /**
	                 * Whether to force the axis to start on a tick. Use this option with
	                 * the `maxPadding` option to control the axis start.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/xaxis/startontick-false/ False by default
	                 * @sample {highcharts} highcharts/xaxis/startontick-true/ True
	                 * @sample {highstock} stock/xaxis/endontick/ False for Y axis
	                 * @default true
	                 * @since 1.2.0
	                 * @product highcharts highstock
	                 */
	                startOnTick: true,
	
	                /**
	                 * @extends xAxis.title
	                 * @product highcharts highstock highmaps
	                 */
	                title: {
	
	                    /**
	                     * The rotation of the text in degrees. 0 is horizontal, 270 is vertical
	                     * reading from bottom to top.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/yaxis/title-offset/ Horizontal
	                     * @default 270
	                     * @product highcharts highstock highmaps
	                     */
	                    rotation: 270,
	
	                    /**
	                     * The actual text of the axis title. Horizontal texts can contain
	                     * HTML, but rotated texts are painted using vector techniques and
	                     * must be clean text. The Y axis title is disabled by setting the
	                     * `text` option to `null`.
	                     * 
	                     * @type {String}
	                     * @sample {highcharts} highcharts/xaxis/title-text/ Custom HTML
	                     * @default Values
	                     * @product highcharts
	                     */
	                    text: 'Values'
	                },
	
	                /**
	                 * The stack labels show the total value for each bar in a stacked
	                 * column or bar chart. The label will be placed on top of positive
	                 * columns and below negative columns. In case of an inverted column
	                 * chart or a bar chart the label is placed to the right of positive
	                 * bars and to the left of negative bars.
	                 * 
	                 * @product highcharts
	                 */
	                stackLabels: {
	
	                    /**
	                     * Allow the stack labels to overlap.
	                     * 
	                     * @type {Boolean}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-allowoverlap-false/
	                     *         Default false
	                     * @since 5.0.13
	                     * @product highcharts
	                     */
	                    allowOverlap: false,
	
	                    /**
	                     * Enable or disable the stack total labels.
	                     * 
	                     * @type {Boolean}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-enabled/ Enabled stack total labels
	                     * @since 2.1.5
	                     * @product highcharts
	                     */
	                    enabled: false,
	                    //align: dynamic,
	                    //y: dynamic,
	                    //x: dynamic,
	                    //verticalAlign: dynamic,
	                    //textAlign: dynamic,
	                    //rotation: 0,
	
	                    /**
	                     * Callback JavaScript function to format the label. The value is
	                     * given by `this.total`. Defaults to:
	                     * 
	                     * <pre>function() {
	                     * return this.total;
	                     * }</pre>
	                     * 
	                     * @type {Function}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-formatter/ Added units to stack total value
	                     * @since 2.1.5
	                     * @product highcharts
	                     */
	                    formatter: function() {
	                        return H.numberFormat(this.total, -1);
	                    },
	
	
	                    /**
	                     * CSS styles for the label.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the styles are set in the `.highcharts-stack-
	                     * label` class.
	                     * 
	                     * @type {CSSObject}
	                     * @sample {highcharts} highcharts/yaxis/stacklabels-style/ Red stack total labels
	                     * @default { "color": "#000000", "fontSize": "11px", "fontWeight": "bold", "textShadow": "1px 1px contrast, -1px -1px contrast, -1px 1px contrast, 1px -1px contrast" }
	                     * @since 2.1.5
	                     * @product highcharts
	                     */
	                    style: {
	
	                        /**
	                         */
	                        fontSize: '11px',
	
	                        /**
	                         */
	                        fontWeight: 'bold',
	
	                        /**
	                         */
	                        color: '#000000',
	
	                        /**
	                         */
	                        textOutline: '1px contrast'
	                    }
	
	                },
	
	
	                /**
	                 * The width of the grid lines extending the ticks across the plot
	                 * area.
	                 * 
	                 * @productdesc {highmaps}
	                 * In Highmaps, the grid lines are hidden by default.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/gridlinewidth/ 2px lines
	                 * @sample {highstock} stock/xaxis/gridlinewidth/ 2px lines
	                 * @default 1
	                 * @product highcharts highstock
	                 */
	                gridLineWidth: 1,
	
	                /**
	                 * The width of the line marking the axis itself.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/yaxis/linecolor/ A 1px line on Y axis
	                 * @sample {highstock} stock/xaxis/linewidth/ A 2px line on X axis
	                 * @default 0
	                 * @product highcharts highstock
	                 */
	                lineWidth: 0
	                // tickWidth: 0
	
	            },
	
	            /**
	             * These options extend the defaultOptions for left axes.
	             * 
	             * @private
	             * @type {Object}
	             */
	            defaultLeftAxisOptions: {
	                labels: {
	                    x: -15
	                },
	                title: {
	                    rotation: 270
	                }
	            },
	
	            /**
	             * These options extend the defaultOptions for right axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultRightAxisOptions: {
	                labels: {
	                    x: 15
	                },
	                title: {
	                    rotation: 90
	                }
	            },
	
	            /**
	             * These options extend the defaultOptions for bottom axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultBottomAxisOptions: {
	                labels: {
	                    autoRotation: [-45],
	                    x: 0
	                    // overflow: undefined,
	                    // staggerLines: null
	                },
	                title: {
	                    rotation: 0
	                }
	            },
	            /**
	             * These options extend the defaultOptions for top axes.
	             *
	             * @private
	             * @type {Object}
	             */
	            defaultTopAxisOptions: {
	                labels: {
	                    autoRotation: [-45],
	                    x: 0
	                    // overflow: undefined
	                    // staggerLines: null
	                },
	                title: {
	                    rotation: 0
	                }
	            },
	
	            /**
	             * Overrideable function to initialize the axis. 
	             *
	             * @see {@link Axis}
	             */
	            init: function(chart, userOptions) {
	
	
	                var isXAxis = userOptions.isX,
	                    axis = this;
	
	
	                /**
	                 * The Chart that the axis belongs to.
	                 *
	                 * @name chart
	                 * @memberOf Axis
	                 * @type {Chart}
	                 */
	                axis.chart = chart;
	
	                /**
	                 * Whether the axis is horizontal.
	                 *
	                 * @name horiz
	                 * @memberOf Axis
	                 * @type {Boolean}
	                 */
	                axis.horiz = chart.inverted && !axis.isZAxis ? !isXAxis : isXAxis;
	
	                // Flag, isXAxis
	                axis.isXAxis = isXAxis;
	
	                /**
	                 * The collection where the axis belongs, for example `xAxis`, `yAxis`
	                 * or `colorAxis`. Corresponds to properties on Chart, for example
	                 * {@link Chart.xAxis}.
	                 *
	                 * @name coll
	                 * @memberOf Axis
	                 * @type {String}
	                 */
	                axis.coll = axis.coll || (isXAxis ? 'xAxis' : 'yAxis');
	
	
	                axis.opposite = userOptions.opposite; // needed in setOptions
	
	                /**
	                 * The side on which the axis is rendered. 0 is top, 1 is right, 2 is
	                 * bottom and 3 is left.
	                 *
	                 * @name side
	                 * @memberOf Axis
	                 * @type {Number}
	                 */
	                axis.side = userOptions.side || (axis.horiz ?
	                    (axis.opposite ? 0 : 2) : // top : bottom
	                    (axis.opposite ? 1 : 3)); // right : left
	
	                axis.setOptions(userOptions);
	
	
	                var options = this.options,
	                    type = options.type,
	                    isDatetimeAxis = type === 'datetime';
	
	                axis.labelFormatter = options.labels.formatter ||
	                    axis.defaultLabelFormatter; // can be overwritten by dynamic format
	
	
	                // Flag, stagger lines or not
	                axis.userOptions = userOptions;
	
	                //axis.axisTitleMargin = undefined,// = options.title.margin,
	                axis.minPixelPadding = 0;
	
	
	                /**
	                 * Whether the axis is reversed. Based on the `axis.reversed`,
	                 * option, but inverted charts have reversed xAxis by default.
	                 *
	                 * @name reversed
	                 * @memberOf Axis
	                 * @type {Boolean}
	                 */
	                axis.reversed = options.reversed;
	                axis.visible = options.visible !== false;
	                axis.zoomEnabled = options.zoomEnabled !== false;
	
	                // Initial categories
	                axis.hasNames = type === 'category' || options.categories === true;
	                axis.categories = options.categories || axis.hasNames;
	                axis.names = axis.names || []; // Preserve on update (#3830)
	
	                // Elements
	                //axis.axisGroup = undefined;
	                //axis.gridGroup = undefined;
	                //axis.axisTitle = undefined;
	                //axis.axisLine = undefined;
	
	                // Placeholder for plotlines and plotbands groups
	                axis.plotLinesAndBandsGroups = {};
	
	                // Shorthand types
	                axis.isLog = type === 'logarithmic';
	                axis.isDatetimeAxis = isDatetimeAxis;
	                axis.positiveValuesOnly = axis.isLog && !axis.allowNegativeLog;
	
	                // Flag, if axis is linked to another axis
	                axis.isLinked = defined(options.linkedTo);
	                // Linked axis.
	                //axis.linkedParent = undefined;
	
	                // Major ticks
	                axis.ticks = {};
	                axis.labelEdge = [];
	                // Minor ticks
	                axis.minorTicks = {};
	
	                // List of plotLines/Bands
	                axis.plotLinesAndBands = [];
	
	                // Alternate bands
	                axis.alternateBands = {};
	
	                // Axis metrics
	                //axis.left = undefined;
	                //axis.top = undefined;
	                //axis.width = undefined;
	                //axis.height = undefined;
	                //axis.bottom = undefined;
	                //axis.right = undefined;
	                //axis.transA = undefined;
	                //axis.transB = undefined;
	                //axis.oldTransA = undefined;
	                axis.len = 0;
	                //axis.oldMin = undefined;
	                //axis.oldMax = undefined;
	                //axis.oldUserMin = undefined;
	                //axis.oldUserMax = undefined;
	                //axis.oldAxisLength = undefined;
	                axis.minRange = axis.userMinRange = options.minRange || options.maxZoom;
	                axis.range = options.range;
	                axis.offset = options.offset || 0;
	
	
	                // Dictionary for stacks
	                axis.stacks = {};
	                axis.oldStacks = {};
	                axis.stacksTouched = 0;
	
	                // Min and max in the data
	                //axis.dataMin = undefined,
	                //axis.dataMax = undefined,
	
	                /**
	                 * The maximum value of the axis. In a logarithmic axis, this is the
	                 * logarithm of the real value, and the real value can be obtained from
	                 * {@link Axis#getExtremes}.
	                 *
	                 * @name max
	                 * @memberOf Axis
	                 * @type {Number}
	                 */
	                axis.max = null;
	                /**
	                 * The minimum value of the axis. In a logarithmic axis, this is the
	                 * logarithm of the real value, and the real value can be obtained from
	                 * {@link Axis#getExtremes}.
	                 *
	                 * @name min
	                 * @memberOf Axis
	                 * @type {Number}
	                 */
	                axis.min = null;
	
	                // User set min and max
	                //axis.userMin = undefined,
	                //axis.userMax = undefined,
	
	                /**
	                 * The processed crosshair options.
	                 *
	                 * @name crosshair
	                 * @memberOf Axis
	                 * @type {AxisCrosshairOptions}
	                 */
	                axis.crosshair = pick(
	                    options.crosshair,
	                    splat(chart.options.tooltip.crosshairs)[isXAxis ? 0 : 1],
	                    false
	                );
	
	                var events = axis.options.events;
	
	                // Register. Don't add it again on Axis.update().
	                if (inArray(axis, chart.axes) === -1) { // 
	                    if (isXAxis) { // #2713
	                        chart.axes.splice(chart.xAxis.length, 0, axis);
	                    } else {
	                        chart.axes.push(axis);
	                    }
	
	                    chart[axis.coll].push(axis);
	                }
	
	                /**
	                 * All series associated to the axis.
	                 *
	                 * @name series
	                 * @memberOf Axis
	                 * @type {Array.<Series>}
	                 */
	                axis.series = axis.series || []; // populated by Series
	
	                // Reversed axis
	                if (
	                    chart.inverted &&
	                    !axis.isZAxis &&
	                    isXAxis &&
	                    axis.reversed === undefined
	                ) {
	                    axis.reversed = true;
	                }
	
	                // register event listeners
	                objectEach(events, function(event, eventType) {
	                    addEvent(axis, eventType, event);
	                });
	
	                // extend logarithmic axis
	                axis.lin2log = options.linearToLogConverter || axis.lin2log;
	                if (axis.isLog) {
	                    axis.val2lin = axis.log2lin;
	                    axis.lin2val = axis.lin2log;
	                }
	            },
	
	            /**
	             * Merge and set options.
	             *
	             * @private
	             */
	            setOptions: function(userOptions) {
	                this.options = merge(
	                    this.defaultOptions,
	                    this.coll === 'yAxis' && this.defaultYAxisOptions, [
	                        this.defaultTopAxisOptions,
	                        this.defaultRightAxisOptions,
	                        this.defaultBottomAxisOptions,
	                        this.defaultLeftAxisOptions
	                    ][this.side],
	                    merge(
	                        defaultOptions[this.coll], // if set in setOptions (#1053)
	                        userOptions
	                    )
	                );
	            },
	
	            /**
	             * The default label formatter. The context is a special config object for
	             * the label. In apps, use the {@link
	             * https://api.highcharts.com/highcharts/xAxis.labels.formatter|
	             * labels.formatter} instead except when a modification is needed.
	             *
	             * @private
	             */
	            defaultLabelFormatter: function() {
	                var axis = this.axis,
	                    value = this.value,
	                    categories = axis.categories,
	                    dateTimeLabelFormat = this.dateTimeLabelFormat,
	                    lang = defaultOptions.lang,
	                    numericSymbols = lang.numericSymbols,
	                    numSymMagnitude = lang.numericSymbolMagnitude || 1000,
	                    i = numericSymbols && numericSymbols.length,
	                    multi,
	                    ret,
	                    formatOption = axis.options.labels.format,
	
	                    // make sure the same symbol is added for all labels on a linear
	                    // axis
	                    numericSymbolDetector = axis.isLog ?
	                    Math.abs(value) :
	                    axis.tickInterval;
	
	                if (formatOption) {
	                    ret = format(formatOption, this);
	
	                } else if (categories) {
	                    ret = value;
	
	                } else if (dateTimeLabelFormat) { // datetime axis
	                    ret = H.dateFormat(dateTimeLabelFormat, value);
	
	                } else if (i && numericSymbolDetector >= 1000) {
	                    // Decide whether we should add a numeric symbol like k (thousands)
	                    // or M (millions). If we are to enable this in tooltip or other
	                    // places as well, we can move this logic to the numberFormatter and
	                    // enable it by a parameter.
	                    while (i-- && ret === undefined) {
	                        multi = Math.pow(numSymMagnitude, i + 1);
	                        if (
	                            numericSymbolDetector >= multi &&
	                            (value * 10) % multi === 0 &&
	                            numericSymbols[i] !== null &&
	                            value !== 0
	                        ) { // #5480
	                            ret = H.numberFormat(value / multi, -1) + numericSymbols[i];
	                        }
	                    }
	                }
	
	                if (ret === undefined) {
	                    if (Math.abs(value) >= 10000) { // add thousands separators
	                        ret = H.numberFormat(value, -1);
	                    } else { // small numbers
	                        ret = H.numberFormat(value, -1, undefined, ''); // #2466
	                    }
	                }
	
	                return ret;
	            },
	
	            /**
	             * Get the minimum and maximum for the series of each axis. The function
	             * analyzes the axis series and updates `this.dataMin` and `this.dataMax`.
	             *
	             * @private
	             */
	            getSeriesExtremes: function() {
	                var axis = this,
	                    chart = axis.chart;
	                axis.hasVisibleSeries = false;
	
	                // Reset properties in case we're redrawing (#3353)
	                axis.dataMin = axis.dataMax = axis.threshold = null;
	                axis.softThreshold = !axis.isXAxis;
	
	                if (axis.buildStacks) {
	                    axis.buildStacks();
	                }
	
	                // loop through this axis' series
	                each(axis.series, function(series) {
	
	                    if (series.visible || !chart.options.chart.ignoreHiddenSeries) {
	
	                        var seriesOptions = series.options,
	                            xData,
	                            threshold = seriesOptions.threshold,
	                            seriesDataMin,
	                            seriesDataMax;
	
	                        axis.hasVisibleSeries = true;
	
	                        // Validate threshold in logarithmic axes
	                        if (axis.positiveValuesOnly && threshold <= 0) {
	                            threshold = null;
	                        }
	
	                        // Get dataMin and dataMax for X axes
	                        if (axis.isXAxis) {
	                            xData = series.xData;
	                            if (xData.length) {
	                                // If xData contains values which is not numbers, then
	                                // filter them out. To prevent performance hit, we only
	                                // do this after we have already found seriesDataMin
	                                // because in most cases all data is valid. #5234.
	                                seriesDataMin = arrayMin(xData);
	                                if (!isNumber(seriesDataMin) &&
	                                    !(seriesDataMin instanceof Date) // #5010
	                                ) {
	                                    xData = grep(xData, function(x) {
	                                        return isNumber(x);
	                                    });
	                                    seriesDataMin = arrayMin(xData); // Do it again with valid data
	                                }
	
	                                axis.dataMin = Math.min(
	                                    pick(axis.dataMin, xData[0]),
	                                    seriesDataMin
	                                );
	                                axis.dataMax = Math.max(
	                                    pick(axis.dataMax, xData[0]),
	                                    arrayMax(xData)
	                                );
	
	                            }
	
	                            // Get dataMin and dataMax for Y axes, as well as handle
	                            // stacking and processed data
	                        } else {
	
	                            // Get this particular series extremes
	                            series.getExtremes();
	                            seriesDataMax = series.dataMax;
	                            seriesDataMin = series.dataMin;
	
	                            // Get the dataMin and dataMax so far. If percentage is
	                            // used, the min and max are always 0 and 100. If
	                            // seriesDataMin and seriesDataMax is null, then series
	                            // doesn't have active y data, we continue with nulls
	                            if (defined(seriesDataMin) && defined(seriesDataMax)) {
	                                axis.dataMin = Math.min(
	                                    pick(axis.dataMin, seriesDataMin),
	                                    seriesDataMin
	                                );
	                                axis.dataMax = Math.max(
	                                    pick(axis.dataMax, seriesDataMax),
	                                    seriesDataMax
	                                );
	                            }
	
	                            // Adjust to threshold
	                            if (defined(threshold)) {
	                                axis.threshold = threshold;
	                            }
	                            // If any series has a hard threshold, it takes precedence
	                            if (!seriesOptions.softThreshold ||
	                                axis.positiveValuesOnly
	                            ) {
	                                axis.softThreshold = false;
	                            }
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Translate from axis value to pixel position on the chart, or back. Use
	             * the `toPixels` and `toValue` functions in applications.
	             *
	             * @private
	             */
	            translate: function(val, backwards, cvsCoord, old, handleLog, pointPlacement) {
	                var axis = this.linkedParent || this, // #1417
	                    sign = 1,
	                    cvsOffset = 0,
	                    localA = old ? axis.oldTransA : axis.transA,
	                    localMin = old ? axis.oldMin : axis.min,
	                    returnValue,
	                    minPixelPadding = axis.minPixelPadding,
	                    doPostTranslate = (axis.isOrdinal || axis.isBroken || (axis.isLog && handleLog)) && axis.lin2val;
	
	                if (!localA) {
	                    localA = axis.transA;
	                }
	
	                // In vertical axes, the canvas coordinates start from 0 at the top like in
	                // SVG.
	                if (cvsCoord) {
	                    sign *= -1; // canvas coordinates inverts the value
	                    cvsOffset = axis.len;
	                }
	
	                // Handle reversed axis
	                if (axis.reversed) {
	                    sign *= -1;
	                    cvsOffset -= sign * (axis.sector || axis.len);
	                }
	
	                // From pixels to value
	                if (backwards) { // reverse translation
	
	                    val = val * sign + cvsOffset;
	                    val -= minPixelPadding;
	                    returnValue = val / localA + localMin; // from chart pixel to value
	                    if (doPostTranslate) { // log and ordinal axes
	                        returnValue = axis.lin2val(returnValue);
	                    }
	
	                    // From value to pixels
	                } else {
	                    if (doPostTranslate) { // log and ordinal axes
	                        val = axis.val2lin(val);
	                    }
	                    returnValue = sign * (val - localMin) * localA + cvsOffset +
	                        (sign * minPixelPadding) +
	                        (isNumber(pointPlacement) ? localA * pointPlacement : 0);
	                }
	
	                return returnValue;
	            },
	
	            /**
	             * Translate a value in terms of axis units into pixels within the chart.
	             * 
	             * @param  {Number} value
	             *         A value in terms of axis units.
	             * @param  {Boolean} paneCoordinates
	             *         Whether to return the pixel coordinate relative to the chart or
	             *         just the axis/pane itself.
	             * @return {Number} Pixel position of the value on the chart or axis.
	             */
	            toPixels: function(value, paneCoordinates) {
	                return this.translate(value, false, !this.horiz, null, true) +
	                    (paneCoordinates ? 0 : this.pos);
	            },
	
	            /**
	             * Translate a pixel position along the axis to a value in terms of axis
	             * units.
	             * @param  {Number} pixel
	             *         The pixel value coordinate.
	             * @param  {Boolean} paneCoordiantes
	             *         Whether the input pixel is relative to the chart or just the
	             *         axis/pane itself.
	             * @return {Number} The axis value.
	             */
	            toValue: function(pixel, paneCoordinates) {
	                return this.translate(
	                    pixel - (paneCoordinates ? 0 : this.pos),
	                    true, !this.horiz,
	                    null,
	                    true
	                );
	            },
	
	            /**
	             * Create the path for a plot line that goes from the given value on
	             * this axis, across the plot to the opposite side. Also used internally for
	             * grid lines and crosshairs.
	             * 
	             * @param  {Number} value
	             *         Axis value.
	             * @param  {Number} [lineWidth=1]
	             *         Used for calculation crisp line coordinates.
	             * @param  {Boolean} [old=false]
	             *         Use old coordinates (for resizing and rescaling).
	             * @param  {Boolean} [force=false]
	             *         If `false`, the function will return null when it falls outside
	             *         the axis bounds.
	             * @param  {Number} [translatedValue]
	             *         If given, return the plot line path of a pixel position on the
	             *         axis.
	             *
	             * @return {Array.<String|Number>}
	             *         The SVG path definition for the plot line.
	             */
	            getPlotLinePath: function(value, lineWidth, old, force, translatedValue) {
	                var axis = this,
	                    chart = axis.chart,
	                    axisLeft = axis.left,
	                    axisTop = axis.top,
	                    x1,
	                    y1,
	                    x2,
	                    y2,
	                    cHeight = (old && chart.oldChartHeight) || chart.chartHeight,
	                    cWidth = (old && chart.oldChartWidth) || chart.chartWidth,
	                    skip,
	                    transB = axis.transB,
	                    /**
	                     * Check if x is between a and b. If not, either move to a/b or skip,
	                     * depending on the force parameter.
	                     */
	                    between = function(x, a, b) {
	                        if (x < a || x > b) {
	                            if (force) {
	                                x = Math.min(Math.max(a, x), b);
	                            } else {
	                                skip = true;
	                            }
	                        }
	                        return x;
	                    };
	
	                translatedValue = pick(translatedValue, axis.translate(value, null, null, old));
	                x1 = x2 = Math.round(translatedValue + transB);
	                y1 = y2 = Math.round(cHeight - translatedValue - transB);
	                if (!isNumber(translatedValue)) { // no min or max
	                    skip = true;
	
	                } else if (axis.horiz) {
	                    y1 = axisTop;
	                    y2 = cHeight - axis.bottom;
	                    x1 = x2 = between(x1, axisLeft, axisLeft + axis.width);
	                } else {
	                    x1 = axisLeft;
	                    x2 = cWidth - axis.right;
	                    y1 = y2 = between(y1, axisTop, axisTop + axis.height);
	                }
	                return skip && !force ?
	                    null :
	                    chart.renderer.crispLine(['M', x1, y1, 'L', x2, y2], lineWidth || 1);
	            },
	
	            /**
	             * Internal function to et the tick positions of a linear axis to round
	             * values like whole tens or every five.
	             *
	             * @param  {Number} tickInterval
	             *         The normalized tick interval
	             * @param  {Number} min
	             *         Axis minimum.
	             * @param  {Number} max
	             *         Axis maximum.
	             *
	             * @return {Array.<Number>}
	             *         An array of axis values where ticks should be placed.
	             */
	            getLinearTickPositions: function(tickInterval, min, max) {
	                var pos,
	                    lastPos,
	                    roundedMin = correctFloat(Math.floor(min / tickInterval) * tickInterval),
	                    roundedMax = correctFloat(Math.ceil(max / tickInterval) * tickInterval),
	                    tickPositions = [];
	
	                // For single points, add a tick regardless of the relative position
	                // (#2662, #6274)
	                if (this.single) {
	                    return [min];
	                }
	
	                // Populate the intermediate values
	                pos = roundedMin;
	                while (pos <= roundedMax) {
	
	                    // Place the tick on the rounded value
	                    tickPositions.push(pos);
	
	                    // Always add the raw tickInterval, not the corrected one.
	                    pos = correctFloat(pos + tickInterval);
	
	                    // If the interval is not big enough in the current min - max range to actually increase
	                    // the loop variable, we need to break out to prevent endless loop. Issue #619
	                    if (pos === lastPos) {
	                        break;
	                    }
	
	                    // Record the last value
	                    lastPos = pos;
	                }
	                return tickPositions;
	            },
	
	            /**
	             * Internal function to return the minor tick positions. For logarithmic
	             * axes, the same logic as for major ticks is reused.
	             *
	             * @return {Array.<Number>}
	             *         An array of axis values where ticks should be placed.
	             */
	            getMinorTickPositions: function() {
	                var axis = this,
	                    options = axis.options,
	                    tickPositions = axis.tickPositions,
	                    minorTickInterval = axis.minorTickInterval,
	                    minorTickPositions = [],
	                    pos,
	                    pointRangePadding = axis.pointRangePadding || 0,
	                    min = axis.min - pointRangePadding, // #1498
	                    max = axis.max + pointRangePadding, // #1498
	                    range = max - min;
	
	                // If minor ticks get too dense, they are hard to read, and may cause long running script. So we don't draw them.
	                if (range && range / minorTickInterval < axis.len / 3) { // #3875
	
	                    if (axis.isLog) {
	                        // For each interval in the major ticks, compute the minor ticks
	                        // separately.
	                        each(this.paddedTicks, function(pos, i, paddedTicks) {
	                            if (i) {
	                                minorTickPositions.push.apply(
	                                    minorTickPositions,
	                                    axis.getLogTickPositions(
	                                        minorTickInterval,
	                                        paddedTicks[i - 1],
	                                        paddedTicks[i],
	                                        true
	                                    )
	                                );
	                            }
	                        });
	
	                    } else if (axis.isDatetimeAxis && options.minorTickInterval === 'auto') { // #1314
	                        minorTickPositions = minorTickPositions.concat(
	                            axis.getTimeTicks(
	                                axis.normalizeTimeTickInterval(minorTickInterval),
	                                min,
	                                max,
	                                options.startOfWeek
	                            )
	                        );
	                    } else {
	                        for (
	                            pos = min + (tickPositions[0] - min) % minorTickInterval; pos <= max; pos += minorTickInterval
	                        ) {
	                            // Very, very, tight grid lines (#5771)
	                            if (pos === minorTickPositions[0]) {
	                                break;
	                            }
	                            minorTickPositions.push(pos);
	                        }
	                    }
	                }
	
	                if (minorTickPositions.length !== 0) {
	                    axis.trimTicks(minorTickPositions); // #3652 #3743 #1498 #6330
	                }
	                return minorTickPositions;
	            },
	
	            /**
	             * Adjust the min and max for the minimum range. Keep in mind that the series data is
	             * not yet processed, so we don't have information on data cropping and grouping, or
	             * updated axis.pointRange or series.pointRange. The data can't be processed until
	             * we have finally established min and max.
	             *
	             * @private
	             */
	            adjustForMinRange: function() {
	                var axis = this,
	                    options = axis.options,
	                    min = axis.min,
	                    max = axis.max,
	                    zoomOffset,
	                    spaceAvailable,
	                    closestDataRange,
	                    i,
	                    distance,
	                    xData,
	                    loopLength,
	                    minArgs,
	                    maxArgs,
	                    minRange;
	
	                // Set the automatic minimum range based on the closest point distance
	                if (axis.isXAxis && axis.minRange === undefined && !axis.isLog) {
	
	                    if (defined(options.min) || defined(options.max)) {
	                        axis.minRange = null; // don't do this again
	
	                    } else {
	
	                        // Find the closest distance between raw data points, as opposed to
	                        // closestPointRange that applies to processed points (cropped and grouped)
	                        each(axis.series, function(series) {
	                            xData = series.xData;
	                            loopLength = series.xIncrement ? 1 : xData.length - 1;
	                            for (i = loopLength; i > 0; i--) {
	                                distance = xData[i] - xData[i - 1];
	                                if (closestDataRange === undefined || distance < closestDataRange) {
	                                    closestDataRange = distance;
	                                }
	                            }
	                        });
	                        axis.minRange = Math.min(closestDataRange * 5, axis.dataMax - axis.dataMin);
	                    }
	                }
	
	                // if minRange is exceeded, adjust
	                if (max - min < axis.minRange) {
	
	                    spaceAvailable = axis.dataMax - axis.dataMin >= axis.minRange;
	                    minRange = axis.minRange;
	                    zoomOffset = (minRange - max + min) / 2;
	
	                    // if min and max options have been set, don't go beyond it
	                    minArgs = [min - zoomOffset, pick(options.min, min - zoomOffset)];
	                    if (spaceAvailable) { // if space is available, stay within the data range
	                        minArgs[2] = axis.isLog ? axis.log2lin(axis.dataMin) : axis.dataMin;
	                    }
	                    min = arrayMax(minArgs);
	
	                    maxArgs = [min + minRange, pick(options.max, min + minRange)];
	                    if (spaceAvailable) { // if space is availabe, stay within the data range
	                        maxArgs[2] = axis.isLog ? axis.log2lin(axis.dataMax) : axis.dataMax;
	                    }
	
	                    max = arrayMin(maxArgs);
	
	                    // now if the max is adjusted, adjust the min back
	                    if (max - min < minRange) {
	                        minArgs[0] = max - minRange;
	                        minArgs[1] = pick(options.min, max - minRange);
	                        min = arrayMax(minArgs);
	                    }
	                }
	
	                // Record modified extremes
	                axis.min = min;
	                axis.max = max;
	            },
	
	            /**
	             * Find the closestPointRange across all series.
	             *
	             * @private
	             */
	            getClosest: function() {
	                var ret;
	
	                if (this.categories) {
	                    ret = 1;
	                } else {
	                    each(this.series, function(series) {
	                        var seriesClosest = series.closestPointRange,
	                            visible = series.visible ||
	                            !series.chart.options.chart.ignoreHiddenSeries;
	
	                        if (!series.noSharedTooltip &&
	                            defined(seriesClosest) &&
	                            visible
	                        ) {
	                            ret = defined(ret) ?
	                                Math.min(ret, seriesClosest) :
	                                seriesClosest;
	                        }
	                    });
	                }
	                return ret;
	            },
	
	            /**
	             * When a point name is given and no x, search for the name in the existing
	             * categories, or if categories aren't provided, search names or create a
	             * new category (#2522).
	             *
	             * @private
	             *
	             * @param  {Point}
	             *         The point to inspect.
	             *
	             * @return {Number}
	             *         The X value that the point is given.
	             */
	            nameToX: function(point) {
	                var explicitCategories = isArray(this.categories),
	                    names = explicitCategories ? this.categories : this.names,
	                    nameX = point.options.x,
	                    x;
	
	                point.series.requireSorting = false;
	
	                if (!defined(nameX)) {
	                    nameX = this.options.uniqueNames === false ?
	                        point.series.autoIncrement() :
	                        inArray(point.name, names);
	                }
	                if (nameX === -1) { // The name is not found in currenct categories
	                    if (!explicitCategories) {
	                        x = names.length;
	                    }
	                } else {
	                    x = nameX;
	                }
	
	                // Write the last point's name to the names array
	                if (x !== undefined) {
	                    this.names[x] = point.name;
	                }
	
	                return x;
	            },
	
	            /**
	             * When changes have been done to series data, update the axis.names.
	             *
	             * @private
	             */
	            updateNames: function() {
	                var axis = this;
	
	                if (this.names.length > 0) {
	                    this.names.length = 0;
	                    this.minRange = this.userMinRange; // Reset
	                    each(this.series || [], function(series) {
	
	                        // Reset incrementer (#5928)
	                        series.xIncrement = null;
	
	                        // When adding a series, points are not yet generated
	                        if (!series.points || series.isDirtyData) {
	                            series.processData();
	                            series.generatePoints();
	                        }
	
	                        each(series.points, function(point, i) {
	                            var x;
	                            if (point.options) {
	                                x = axis.nameToX(point);
	                                if (x !== undefined && x !== point.x) {
	                                    point.x = x;
	                                    series.xData[i] = x;
	                                }
	                            }
	                        });
	                    });
	                }
	            },
	
	            /**
	             * Update translation information.
	             *
	             * @private
	             */
	            setAxisTranslation: function(saveOld) {
	                var axis = this,
	                    range = axis.max - axis.min,
	                    pointRange = axis.axisPointRange || 0,
	                    closestPointRange,
	                    minPointOffset = 0,
	                    pointRangePadding = 0,
	                    linkedParent = axis.linkedParent,
	                    ordinalCorrection,
	                    hasCategories = !!axis.categories,
	                    transA = axis.transA,
	                    isXAxis = axis.isXAxis;
	
	                // Adjust translation for padding. Y axis with categories need to go through the same (#1784).
	                if (isXAxis || hasCategories || pointRange) {
	
	                    // Get the closest points
	                    closestPointRange = axis.getClosest();
	
	                    if (linkedParent) {
	                        minPointOffset = linkedParent.minPointOffset;
	                        pointRangePadding = linkedParent.pointRangePadding;
	                    } else {
	                        each(axis.series, function(series) {
	                            var seriesPointRange = hasCategories ?
	                                1 :
	                                (isXAxis ?
	                                    pick(series.options.pointRange, closestPointRange, 0) :
	                                    (axis.axisPointRange || 0)), // #2806
	                                pointPlacement = series.options.pointPlacement;
	
	                            pointRange = Math.max(pointRange, seriesPointRange);
	
	                            if (!axis.single) {
	                                // minPointOffset is the value padding to the left of the axis in order to make
	                                // room for points with a pointRange, typically columns. When the pointPlacement option
	                                // is 'between' or 'on', this padding does not apply.
	                                minPointOffset = Math.max(
	                                    minPointOffset,
	                                    isString(pointPlacement) ? 0 : seriesPointRange / 2
	                                );
	
	                                // Determine the total padding needed to the length of the axis to make room for the
	                                // pointRange. If the series' pointPlacement is 'on', no padding is added.
	                                pointRangePadding = Math.max(
	                                    pointRangePadding,
	                                    pointPlacement === 'on' ? 0 : seriesPointRange
	                                );
	                            }
	                        });
	                    }
	
	                    // Record minPointOffset and pointRangePadding
	                    ordinalCorrection = axis.ordinalSlope && closestPointRange ? axis.ordinalSlope / closestPointRange : 1; // #988, #1853
	                    axis.minPointOffset = minPointOffset = minPointOffset * ordinalCorrection;
	                    axis.pointRangePadding = pointRangePadding = pointRangePadding * ordinalCorrection;
	
	                    // pointRange means the width reserved for each point, like in a column chart
	                    axis.pointRange = Math.min(pointRange, range);
	
	                    // closestPointRange means the closest distance between points. In columns
	                    // it is mostly equal to pointRange, but in lines pointRange is 0 while closestPointRange
	                    // is some other value
	                    if (isXAxis) {
	                        axis.closestPointRange = closestPointRange;
	                    }
	                }
	
	                // Secondary values
	                if (saveOld) {
	                    axis.oldTransA = transA;
	                }
	                axis.translationSlope = axis.transA = transA =
	                    axis.options.staticScale ||
	                    axis.len / ((range + pointRangePadding) || 1);
	                axis.transB = axis.horiz ? axis.left : axis.bottom; // translation addend
	                axis.minPixelPadding = transA * minPointOffset;
	            },
	
	            minFromRange: function() {
	                return this.max - this.range;
	            },
	
	            /**
	             * Set the tick positions to round values and optionally extend the extremes
	             * to the nearest tick.
	             *
	             * @private
	             */
	            setTickInterval: function(secondPass) {
	                var axis = this,
	                    chart = axis.chart,
	                    options = axis.options,
	                    isLog = axis.isLog,
	                    log2lin = axis.log2lin,
	                    isDatetimeAxis = axis.isDatetimeAxis,
	                    isXAxis = axis.isXAxis,
	                    isLinked = axis.isLinked,
	                    maxPadding = options.maxPadding,
	                    minPadding = options.minPadding,
	                    length,
	                    linkedParentExtremes,
	                    tickIntervalOption = options.tickInterval,
	                    minTickInterval,
	                    tickPixelIntervalOption = options.tickPixelInterval,
	                    categories = axis.categories,
	                    threshold = axis.threshold,
	                    softThreshold = axis.softThreshold,
	                    thresholdMin,
	                    thresholdMax,
	                    hardMin,
	                    hardMax;
	
	                if (!isDatetimeAxis && !categories && !isLinked) {
	                    this.getTickAmount();
	                }
	
	                // Min or max set either by zooming/setExtremes or initial options
	                hardMin = pick(axis.userMin, options.min);
	                hardMax = pick(axis.userMax, options.max);
	
	                // Linked axis gets the extremes from the parent axis
	                if (isLinked) {
	                    axis.linkedParent = chart[axis.coll][options.linkedTo];
	                    linkedParentExtremes = axis.linkedParent.getExtremes();
	                    axis.min = pick(linkedParentExtremes.min, linkedParentExtremes.dataMin);
	                    axis.max = pick(linkedParentExtremes.max, linkedParentExtremes.dataMax);
	                    if (options.type !== axis.linkedParent.options.type) {
	                        H.error(11, 1); // Can't link axes of different type
	                    }
	
	                    // Initial min and max from the extreme data values
	                } else {
	
	                    // Adjust to hard threshold
	                    if (!softThreshold && defined(threshold)) {
	                        if (axis.dataMin >= threshold) {
	                            thresholdMin = threshold;
	                            minPadding = 0;
	                        } else if (axis.dataMax <= threshold) {
	                            thresholdMax = threshold;
	                            maxPadding = 0;
	                        }
	                    }
	
	                    axis.min = pick(hardMin, thresholdMin, axis.dataMin);
	                    axis.max = pick(hardMax, thresholdMax, axis.dataMax);
	
	                }
	
	                if (isLog) {
	                    if (
	                        axis.positiveValuesOnly &&
	                        !secondPass &&
	                        Math.min(axis.min, pick(axis.dataMin, axis.min)) <= 0
	                    ) { // #978
	                        H.error(10, 1); // Can't plot negative values on log axis
	                    }
	                    // The correctFloat cures #934, float errors on full tens. But it
	                    // was too aggressive for #4360 because of conversion back to lin,
	                    // therefore use precision 15.
	                    axis.min = correctFloat(log2lin(axis.min), 15);
	                    axis.max = correctFloat(log2lin(axis.max), 15);
	                }
	
	                // handle zoomed range
	                if (axis.range && defined(axis.max)) {
	                    axis.userMin = axis.min = hardMin = Math.max(axis.dataMin, axis.minFromRange()); // #618, #6773
	                    axis.userMax = hardMax = axis.max;
	
	                    axis.range = null; // don't use it when running setExtremes
	                }
	
	                // Hook for Highstock Scroller. Consider combining with beforePadding.
	                fireEvent(axis, 'foundExtremes');
	
	                // Hook for adjusting this.min and this.max. Used by bubble series.
	                if (axis.beforePadding) {
	                    axis.beforePadding();
	                }
	
	                // adjust min and max for the minimum range
	                axis.adjustForMinRange();
	
	                // Pad the values to get clear of the chart's edges. To avoid tickInterval taking the padding
	                // into account, we do this after computing tick interval (#1337).
	                if (!categories && !axis.axisPointRange && !axis.usePercentage && !isLinked && defined(axis.min) && defined(axis.max)) {
	                    length = axis.max - axis.min;
	                    if (length) {
	                        if (!defined(hardMin) && minPadding) {
	                            axis.min -= length * minPadding;
	                        }
	                        if (!defined(hardMax) && maxPadding) {
	                            axis.max += length * maxPadding;
	                        }
	                    }
	                }
	
	                // Handle options for floor, ceiling, softMin and softMax (#6359)
	                if (isNumber(options.softMin)) {
	                    axis.min = Math.min(axis.min, options.softMin);
	                }
	                if (isNumber(options.softMax)) {
	                    axis.max = Math.max(axis.max, options.softMax);
	                }
	                if (isNumber(options.floor)) {
	                    axis.min = Math.max(axis.min, options.floor);
	                }
	                if (isNumber(options.ceiling)) {
	                    axis.max = Math.min(axis.max, options.ceiling);
	                }
	
	
	                // When the threshold is soft, adjust the extreme value only if
	                // the data extreme and the padded extreme land on either side of the threshold. For example,
	                // a series of [0, 1, 2, 3] would make the yAxis add a tick for -1 because of the
	                // default minPadding and startOnTick options. This is prevented by the softThreshold
	                // option.
	                if (softThreshold && defined(axis.dataMin)) {
	                    threshold = threshold || 0;
	                    if (!defined(hardMin) && axis.min < threshold && axis.dataMin >= threshold) {
	                        axis.min = threshold;
	                    } else if (!defined(hardMax) && axis.max > threshold && axis.dataMax <= threshold) {
	                        axis.max = threshold;
	                    }
	                }
	
	
	                // get tickInterval
	                if (axis.min === axis.max || axis.min === undefined || axis.max === undefined) {
	                    axis.tickInterval = 1;
	                } else if (isLinked && !tickIntervalOption &&
	                    tickPixelIntervalOption === axis.linkedParent.options.tickPixelInterval) {
	                    axis.tickInterval = tickIntervalOption = axis.linkedParent.tickInterval;
	                } else {
	                    axis.tickInterval = pick(
	                        tickIntervalOption,
	                        this.tickAmount ? ((axis.max - axis.min) / Math.max(this.tickAmount - 1, 1)) : undefined,
	                        categories ? // for categoried axis, 1 is default, for linear axis use tickPix
	                        1 :
	                        // don't let it be more than the data range
	                        (axis.max - axis.min) * tickPixelIntervalOption / Math.max(axis.len, tickPixelIntervalOption)
	                    );
	                }
	
	                // Now we're finished detecting min and max, crop and group series data. This
	                // is in turn needed in order to find tick positions in ordinal axes.
	                if (isXAxis && !secondPass) {
	                    each(axis.series, function(series) {
	                        series.processData(axis.min !== axis.oldMin || axis.max !== axis.oldMax);
	                    });
	                }
	
	                // set the translation factor used in translate function
	                axis.setAxisTranslation(true);
	
	                // hook for ordinal axes and radial axes
	                if (axis.beforeSetTickPositions) {
	                    axis.beforeSetTickPositions();
	                }
	
	                // hook for extensions, used in Highstock ordinal axes
	                if (axis.postProcessTickInterval) {
	                    axis.tickInterval = axis.postProcessTickInterval(axis.tickInterval);
	                }
	
	                // In column-like charts, don't cramp in more ticks than there are points (#1943, #4184)
	                if (axis.pointRange && !tickIntervalOption) {
	                    axis.tickInterval = Math.max(axis.pointRange, axis.tickInterval);
	                }
	
	                // Before normalizing the tick interval, handle minimum tick interval. This applies only if tickInterval is not defined.
	                minTickInterval = pick(options.minTickInterval, axis.isDatetimeAxis && axis.closestPointRange);
	                if (!tickIntervalOption && axis.tickInterval < minTickInterval) {
	                    axis.tickInterval = minTickInterval;
	                }
	
	                // for linear axes, get magnitude and normalize the interval
	                if (!isDatetimeAxis && !isLog && !tickIntervalOption) {
	                    axis.tickInterval = normalizeTickInterval(
	                        axis.tickInterval,
	                        null,
	                        getMagnitude(axis.tickInterval),
	                        // If the tick interval is between 0.5 and 5 and the axis max is in the order of
	                        // thousands, chances are we are dealing with years. Don't allow decimals. #3363.
	                        pick(options.allowDecimals, !(axis.tickInterval > 0.5 && axis.tickInterval < 5 && axis.max > 1000 && axis.max < 9999)), !!this.tickAmount
	                    );
	                }
	
	                // Prevent ticks from getting so close that we can't draw the labels
	                if (!this.tickAmount) {
	                    axis.tickInterval = axis.unsquish();
	                }
	
	                this.setTickPositions();
	            },
	
	            /**
	             * Now we have computed the normalized tickInterval, get the tick positions
	             */
	            setTickPositions: function() {
	
	                var options = this.options,
	                    tickPositions,
	                    tickPositionsOption = options.tickPositions,
	                    tickPositioner = options.tickPositioner,
	                    startOnTick = options.startOnTick,
	                    endOnTick = options.endOnTick;
	
	                // Set the tickmarkOffset
	                this.tickmarkOffset = (this.categories && options.tickmarkPlacement === 'between' &&
	                    this.tickInterval === 1) ? 0.5 : 0; // #3202
	
	
	                // get minorTickInterval
	                this.minorTickInterval = options.minorTickInterval === 'auto' && this.tickInterval ?
	                    this.tickInterval / 5 : options.minorTickInterval;
	
	                // When there is only one point, or all points have the same value on
	                // this axis, then min and max are equal and tickPositions.length is 0
	                // or 1. In this case, add some padding in order to center the point,
	                // but leave it with one tick. #1337.
	                this.single =
	                    this.min === this.max &&
	                    defined(this.min) &&
	                    !this.tickAmount &&
	                    (
	                        // Data is on integer (#6563)
	                        parseInt(this.min, 10) === this.min ||
	
	                        // Between integers and decimals are not allowed (#6274)
	                        options.allowDecimals !== false
	                    );
	
	                // Find the tick positions
	                this.tickPositions = tickPositions = tickPositionsOption && tickPositionsOption.slice(); // Work on a copy (#1565)
	                if (!tickPositions) {
	
	                    if (this.isDatetimeAxis) {
	                        tickPositions = this.getTimeTicks(
	                            this.normalizeTimeTickInterval(
	                                this.tickInterval,
	                                options.units
	                            ),
	                            this.min,
	                            this.max,
	                            options.startOfWeek,
	                            this.ordinalPositions,
	                            this.closestPointRange,
	                            true
	                        );
	                    } else if (this.isLog) {
	                        tickPositions = this.getLogTickPositions(
	                            this.tickInterval,
	                            this.min,
	                            this.max
	                        );
	                    } else {
	                        tickPositions = this.getLinearTickPositions(
	                            this.tickInterval,
	                            this.min,
	                            this.max
	                        );
	                    }
	
	                    // Too dense ticks, keep only the first and last (#4477)
	                    if (tickPositions.length > this.len) {
	                        tickPositions = [tickPositions[0], tickPositions.pop()];
	                    }
	
	                    this.tickPositions = tickPositions;
	
	                    // Run the tick positioner callback, that allows modifying auto tick positions.
	                    if (tickPositioner) {
	                        tickPositioner = tickPositioner.apply(this, [this.min, this.max]);
	                        if (tickPositioner) {
	                            this.tickPositions = tickPositions = tickPositioner;
	                        }
	                    }
	
	                }
	
	                // Reset min/max or remove extremes based on start/end on tick
	                this.paddedTicks = tickPositions.slice(0); // Used for logarithmic minor
	                this.trimTicks(tickPositions, startOnTick, endOnTick);
	                if (!this.isLinked) {
	
	                    // Substract half a unit (#2619, #2846, #2515, #3390),
	                    // but not in case of multiple ticks (#6897)
	                    if (this.single && tickPositions.length < 2) {
	                        this.min -= 0.5;
	                        this.max += 0.5;
	                    }
	                    if (!tickPositionsOption && !tickPositioner) {
	                        this.adjustTickAmount();
	                    }
	                }
	            },
	
	            /**
	             * Handle startOnTick and endOnTick by either adapting to padding min/max or
	             * rounded min/max. Also handle single data points.
	             *
	             * @private
	             */
	            trimTicks: function(tickPositions, startOnTick, endOnTick) {
	                var roundedMin = tickPositions[0],
	                    roundedMax = tickPositions[tickPositions.length - 1],
	                    minPointOffset = this.minPointOffset || 0;
	
	                if (!this.isLinked) {
	                    if (startOnTick && roundedMin !== -Infinity) { // #6502
	                        this.min = roundedMin;
	                    } else {
	                        while (this.min - minPointOffset > tickPositions[0]) {
	                            tickPositions.shift();
	                        }
	                    }
	
	                    if (endOnTick) {
	                        this.max = roundedMax;
	                    } else {
	                        while (this.max + minPointOffset < tickPositions[tickPositions.length - 1]) {
	                            tickPositions.pop();
	                        }
	                    }
	
	                    // If no tick are left, set one tick in the middle (#3195)
	                    if (tickPositions.length === 0 && defined(roundedMin)) {
	                        tickPositions.push((roundedMax + roundedMin) / 2);
	                    }
	                }
	            },
	
	            /**
	             * Check if there are multiple axes in the same pane.
	             *
	             * @private
	             * @return {Boolean}
	             *         True if there are other axes.
	             */
	            alignToOthers: function() {
	                var others = {}, // Whether there is another axis to pair with this one
	                    hasOther,
	                    options = this.options;
	
	                if (
	                    // Only if alignTicks is true
	                    this.chart.options.chart.alignTicks !== false &&
	                    options.alignTicks !== false &&
	
	                    // Don't try to align ticks on a log axis, they are not evenly
	                    // spaced (#6021)
	                    !this.isLog
	                ) {
	                    each(this.chart[this.coll], function(axis) {
	                        var otherOptions = axis.options,
	                            horiz = axis.horiz,
	                            key = [
	                                horiz ? otherOptions.left : otherOptions.top,
	                                otherOptions.width,
	                                otherOptions.height,
	                                otherOptions.pane
	                            ].join(',');
	
	
	                        if (axis.series.length) { // #4442
	                            if (others[key]) {
	                                hasOther = true; // #4201
	                            } else {
	                                others[key] = 1;
	                            }
	                        }
	                    });
	                }
	                return hasOther;
	            },
	
	            /**
	             * Find the max ticks of either the x and y axis collection, and record it
	             * in `this.tickAmount`.
	             *
	             * @private
	             */
	            getTickAmount: function() {
	                var options = this.options,
	                    tickAmount = options.tickAmount,
	                    tickPixelInterval = options.tickPixelInterval;
	
	                if (!defined(options.tickInterval) && this.len < tickPixelInterval && !this.isRadial &&
	                    !this.isLog && options.startOnTick && options.endOnTick) {
	                    tickAmount = 2;
	                }
	
	                if (!tickAmount && this.alignToOthers()) {
	                    // Add 1 because 4 tick intervals require 5 ticks (including first and last)
	                    tickAmount = Math.ceil(this.len / tickPixelInterval) + 1;
	                }
	
	                // For tick amounts of 2 and 3, compute five ticks and remove the intermediate ones. This
	                // prevents the axis from adding ticks that are too far away from the data extremes.
	                if (tickAmount < 4) {
	                    this.finalTickAmt = tickAmount;
	                    tickAmount = 5;
	                }
	
	                this.tickAmount = tickAmount;
	            },
	
	            /**
	             * When using multiple axes, adjust the number of ticks to match the highest
	             * number of ticks in that group.
	             *
	             * @private
	             */
	            adjustTickAmount: function() {
	                var tickInterval = this.tickInterval,
	                    tickPositions = this.tickPositions,
	                    tickAmount = this.tickAmount,
	                    finalTickAmt = this.finalTickAmt,
	                    currentTickAmount = tickPositions && tickPositions.length,
	                    i,
	                    len;
	
	                if (currentTickAmount < tickAmount) {
	                    while (tickPositions.length < tickAmount) {
	                        tickPositions.push(correctFloat(
	                            tickPositions[tickPositions.length - 1] + tickInterval
	                        ));
	                    }
	                    this.transA *= (currentTickAmount - 1) / (tickAmount - 1);
	                    this.max = tickPositions[tickPositions.length - 1];
	
	                    // We have too many ticks, run second pass to try to reduce ticks
	                } else if (currentTickAmount > tickAmount) {
	                    this.tickInterval *= 2;
	                    this.setTickPositions();
	                }
	
	                // The finalTickAmt property is set in getTickAmount
	                if (defined(finalTickAmt)) {
	                    i = len = tickPositions.length;
	                    while (i--) {
	                        if (
	                            (finalTickAmt === 3 && i % 2 === 1) || // Remove every other tick
	                            (finalTickAmt <= 2 && i > 0 && i < len - 1) // Remove all but first and last
	                        ) {
	                            tickPositions.splice(i, 1);
	                        }
	                    }
	                    this.finalTickAmt = undefined;
	                }
	            },
	
	            /**
	             * Set the scale based on data min and max, user set min and max or options.
	             * 
	             * @private
	             */
	            setScale: function() {
	                var axis = this,
	                    isDirtyData,
	                    isDirtyAxisLength;
	
	                axis.oldMin = axis.min;
	                axis.oldMax = axis.max;
	                axis.oldAxisLength = axis.len;
	
	                // set the new axisLength
	                axis.setAxisSize();
	                //axisLength = horiz ? axisWidth : axisHeight;
	                isDirtyAxisLength = axis.len !== axis.oldAxisLength;
	
	                // is there new data?
	                each(axis.series, function(series) {
	                    if (series.isDirtyData || series.isDirty ||
	                        series.xAxis.isDirty) { // when x axis is dirty, we need new data extremes for y as well
	                        isDirtyData = true;
	                    }
	                });
	
	                // do we really need to go through all this?
	                if (isDirtyAxisLength || isDirtyData || axis.isLinked || axis.forceRedraw ||
	                    axis.userMin !== axis.oldUserMin || axis.userMax !== axis.oldUserMax || axis.alignToOthers()) {
	
	                    if (axis.resetStacks) {
	                        axis.resetStacks();
	                    }
	
	                    axis.forceRedraw = false;
	
	                    // get data extremes if needed
	                    axis.getSeriesExtremes();
	
	                    // get fixed positions based on tickInterval
	                    axis.setTickInterval();
	
	                    // record old values to decide whether a rescale is necessary later on (#540)
	                    axis.oldUserMin = axis.userMin;
	                    axis.oldUserMax = axis.userMax;
	
	                    // Mark as dirty if it is not already set to dirty and extremes have changed. #595.
	                    if (!axis.isDirty) {
	                        axis.isDirty = isDirtyAxisLength || axis.min !== axis.oldMin || axis.max !== axis.oldMax;
	                    }
	                } else if (axis.cleanStacks) {
	                    axis.cleanStacks();
	                }
	            },
	
	            /**
	             * Set the minimum and maximum of the axes after render time. If the
	             * `startOnTick` and `endOnTick` options are true, the minimum and maximum
	             * values are rounded off to the nearest tick. To prevent this, these
	             * options can be set to false before calling setExtremes. Also, setExtremes
	             * will not allow a range lower than the `minRange` option, which by default
	             * is the range of five points.
	             * 
	             * @param  {Number} [newMin]
	             *         The new minimum value.
	             * @param  {Number} [newMax]
	             *         The new maximum value.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart or wait for an explicit call to 
	             *         {@link Highcharts.Chart#redraw}
	             * @param  {AnimationOptions} [animation=true]
	             *         Enable or modify animations.
	             * @param  {Object} [eventArguments]
	             *         Arguments to be accessed in event handler.
	             *
	             * @sample highcharts/members/axis-setextremes/
	             *         Set extremes from a button
	             * @sample highcharts/members/axis-setextremes-datetime/
	             *         Set extremes on a datetime axis
	             * @sample highcharts/members/axis-setextremes-off-ticks/
	             *         Set extremes off ticks
	             * @sample stock/members/axis-setextremes/
	             *         Set extremes in Highstock
	             * @sample maps/members/axis-setextremes/
	             *         Set extremes in Highmaps
	             */
	            setExtremes: function(newMin, newMax, redraw, animation, eventArguments) {
	                var axis = this,
	                    chart = axis.chart;
	
	                redraw = pick(redraw, true); // defaults to true
	
	                each(axis.series, function(serie) {
	                    delete serie.kdTree;
	                });
	
	                // Extend the arguments with min and max
	                eventArguments = extend(eventArguments, {
	                    min: newMin,
	                    max: newMax
	                });
	
	                // Fire the event
	                fireEvent(axis, 'setExtremes', eventArguments, function() { // the default event handler
	
	                    axis.userMin = newMin;
	                    axis.userMax = newMax;
	                    axis.eventArgs = eventArguments;
	
	                    if (redraw) {
	                        chart.redraw(animation);
	                    }
	                });
	            },
	
	            /**
	             * Overridable method for zooming chart. Pulled out in a separate method to
	             * allow overriding in stock charts.
	             *
	             * @private
	             */
	            zoom: function(newMin, newMax) {
	                var dataMin = this.dataMin,
	                    dataMax = this.dataMax,
	                    options = this.options,
	                    min = Math.min(dataMin, pick(options.min, dataMin)),
	                    max = Math.max(dataMax, pick(options.max, dataMax));
	
	                if (newMin !== this.min || newMax !== this.max) { // #5790
	
	                    // Prevent pinch zooming out of range. Check for defined is for #1946. #1734.
	                    if (!this.allowZoomOutside) {
	                        // #6014, sometimes newMax will be smaller than min (or newMin will be larger than max).
	                        if (defined(dataMin)) {
	                            if (newMin < min) {
	                                newMin = min;
	                            }
	                            if (newMin > max) {
	                                newMin = max;
	                            }
	                        }
	                        if (defined(dataMax)) {
	                            if (newMax < min) {
	                                newMax = min;
	                            }
	                            if (newMax > max) {
	                                newMax = max;
	                            }
	                        }
	                    }
	
	                    // In full view, displaying the reset zoom button is not required
	                    this.displayBtn = newMin !== undefined || newMax !== undefined;
	
	                    // Do it
	                    this.setExtremes(
	                        newMin,
	                        newMax,
	                        false,
	                        undefined, {
	                            trigger: 'zoom'
	                        }
	                    );
	                }
	
	                return true;
	            },
	
	            /**
	             * Update the axis metrics.
	             *
	             * @private
	             */
	            setAxisSize: function() {
	                var chart = this.chart,
	                    options = this.options,
	                    offsets = options.offsets || [0, 0, 0, 0], // top / right / bottom / left
	                    horiz = this.horiz,
	
	                    // Check for percentage based input values. Rounding fixes problems
	                    // with column overflow and plot line filtering (#4898, #4899)
	                    width = this.width = Math.round(H.relativeLength(
	                        pick(
	                            options.width,
	                            chart.plotWidth - offsets[3] + offsets[1]
	                        ),
	                        chart.plotWidth
	                    )),
	                    height = this.height = Math.round(H.relativeLength(
	                        pick(
	                            options.height,
	                            chart.plotHeight - offsets[0] + offsets[2]
	                        ),
	                        chart.plotHeight
	                    )),
	                    top = this.top = Math.round(H.relativeLength(
	                        pick(options.top, chart.plotTop + offsets[0]),
	                        chart.plotHeight,
	                        chart.plotTop
	                    )),
	                    left = this.left = Math.round(H.relativeLength(
	                        pick(options.left, chart.plotLeft + offsets[3]),
	                        chart.plotWidth,
	                        chart.plotLeft
	                    ));
	
	                // Expose basic values to use in Series object and navigator
	                this.bottom = chart.chartHeight - height - top;
	                this.right = chart.chartWidth - width - left;
	
	                // Direction agnostic properties
	                this.len = Math.max(horiz ? width : height, 0); // Math.max fixes #905
	                this.pos = horiz ? left : top; // distance from SVG origin
	            },
	
	            /**
	             * The returned object literal from the {@link Highcharts.Axis#getExtremes}
	             * function. 
	             * @typedef {Object} Extremes
	             * @property {Number} dataMax
	             *         The maximum value of the axis' associated series.
	             * @property {Number} dataMin
	             *         The minimum value of the axis' associated series.
	             * @property {Number} max
	             *         The maximum axis value, either automatic or set manually. If the
	             *         `max` option is not set, `maxPadding` is 0 and `endOnTick` is
	             *         false, this value will be the same as `dataMax`.
	             * @property {Number} min
	             *         The minimum axis value, either automatic or set manually. If the
	             *         `min` option is not set, `minPadding` is 0 and `startOnTick` is
	             *         false, this value will be the same as `dataMin`.
	             */
	            /**
	             * Get the current extremes for the axis.
	             *
	             * @returns {Extremes}
	             * An object containing extremes information.
	             * 
	             * @sample  members/axis-getextremes/
	             *          Report extremes by click on a button
	             * @sample  maps/members/axis-getextremes/
	             *          Get extremes in Highmaps
	             */
	            getExtremes: function() {
	                var axis = this,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log;
	
	                return {
	                    min: isLog ? correctFloat(lin2log(axis.min)) : axis.min,
	                    max: isLog ? correctFloat(lin2log(axis.max)) : axis.max,
	                    dataMin: axis.dataMin,
	                    dataMax: axis.dataMax,
	                    userMin: axis.userMin,
	                    userMax: axis.userMax
	                };
	            },
	
	            /**
	             * Get the zero plane either based on zero or on the min or max value.
	             * Used in bar and area plots.
	             *
	             * @param  {Number} threshold
	             *         The threshold in axis values.
	             *
	             * @return {Number}
	             *         The translated threshold position in terms of pixels, and
	             *         corrected to stay within the axis bounds.
	             */
	            getThreshold: function(threshold) {
	                var axis = this,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log,
	                    realMin = isLog ? lin2log(axis.min) : axis.min,
	                    realMax = isLog ? lin2log(axis.max) : axis.max;
	
	                if (threshold === null) {
	                    threshold = realMin;
	                } else if (realMin > threshold) {
	                    threshold = realMin;
	                } else if (realMax < threshold) {
	                    threshold = realMax;
	                }
	
	                return axis.translate(threshold, 0, 1, 0, 1);
	            },
	
	            /**
	             * Compute auto alignment for the axis label based on which side the axis is
	             * on and the given rotation for the label.
	             *
	             * @param  {Number} rotation
	             *         The rotation in degrees as set by either the `rotation` or 
	             *         `autoRotation` options.
	             * @private
	             */
	            autoLabelAlign: function(rotation) {
	                var ret,
	                    angle = (pick(rotation, 0) - (this.side * 90) + 720) % 360;
	
	                if (angle > 15 && angle < 165) {
	                    ret = 'right';
	                } else if (angle > 195 && angle < 345) {
	                    ret = 'left';
	                } else {
	                    ret = 'center';
	                }
	                return ret;
	            },
	
	            /**
	             * Get the tick length and width for the axis based on axis options.
	             *
	             * @private
	             * 
	             * @param  {String} prefix
	             *         'tick' or 'minorTick'
	             * @return {Array.<Number>}
	             *         An array of tickLength and tickWidth
	             */
	            tickSize: function(prefix) {
	                var options = this.options,
	                    tickLength = options[prefix + 'Length'],
	                    tickWidth = pick(options[prefix + 'Width'], prefix === 'tick' && this.isXAxis ? 1 : 0); // X axis defaults to 1
	
	                if (tickWidth && tickLength) {
	                    // Negate the length
	                    if (options[prefix + 'Position'] === 'inside') {
	                        tickLength = -tickLength;
	                    }
	                    return [tickLength, tickWidth];
	                }
	
	            },
	
	            /**
	             * Return the size of the labels.
	             *
	             * @private
	             */
	            labelMetrics: function() {
	                var index = this.tickPositions && this.tickPositions[0] || 0;
	                return this.chart.renderer.fontMetrics(
	                    this.options.labels.style && this.options.labels.style.fontSize,
	                    this.ticks[index] && this.ticks[index].label
	                );
	            },
	
	            /**
	             * Prevent the ticks from getting so close we can't draw the labels. On a
	             * horizontal axis, this is handled by rotating the labels, removing ticks
	             * and adding ellipsis. On a vertical axis remove ticks and add ellipsis.
	             *
	             * @private
	             */
	            unsquish: function() {
	                var labelOptions = this.options.labels,
	                    horiz = this.horiz,
	                    tickInterval = this.tickInterval,
	                    newTickInterval = tickInterval,
	                    slotSize = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / tickInterval),
	                    rotation,
	                    rotationOption = labelOptions.rotation,
	                    labelMetrics = this.labelMetrics(),
	                    step,
	                    bestScore = Number.MAX_VALUE,
	                    autoRotation,
	                    // Return the multiple of tickInterval that is needed to avoid collision
	                    getStep = function(spaceNeeded) {
	                        var step = spaceNeeded / (slotSize || 1);
	                        step = step > 1 ? Math.ceil(step) : 1;
	                        return step * tickInterval;
	                    };
	
	                if (horiz) {
	                    autoRotation = !labelOptions.staggerLines && !labelOptions.step && ( // #3971
	                        defined(rotationOption) ? [rotationOption] :
	                        slotSize < pick(labelOptions.autoRotationLimit, 80) && labelOptions.autoRotation
	                    );
	
	                    if (autoRotation) {
	
	                        // Loop over the given autoRotation options, and determine which gives the best score. The
	                        // best score is that with the lowest number of steps and a rotation closest to horizontal.
	                        each(autoRotation, function(rot) {
	                            var score;
	
	                            if (rot === rotationOption || (rot && rot >= -90 && rot <= 90)) { // #3891
	
	                                step = getStep(Math.abs(labelMetrics.h / Math.sin(deg2rad * rot)));
	
	                                score = step + Math.abs(rot / 360);
	
	                                if (score < bestScore) {
	                                    bestScore = score;
	                                    rotation = rot;
	                                    newTickInterval = step;
	                                }
	                            }
	                        });
	                    }
	
	                } else if (!labelOptions.step) { // #4411
	                    newTickInterval = getStep(labelMetrics.h);
	                }
	
	                this.autoRotation = autoRotation;
	                this.labelRotation = pick(rotation, rotationOption);
	
	                return newTickInterval;
	            },
	
	            /**
	             * Get the general slot width for labels/categories on this axis. This may
	             * change between the pre-render (from Axis.getOffset) and the final tick
	             * rendering and placement.
	             *
	             * @private
	             * @return {Number}
	             *         The pixel width allocated to each axis label.
	             */
	            getSlotWidth: function() {
	                // #5086, #1580, #1931
	                var chart = this.chart,
	                    horiz = this.horiz,
	                    labelOptions = this.options.labels,
	                    slotCount = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
	                    marginLeft = chart.margin[3];
	
	                return (
	                    horiz &&
	                    (labelOptions.step || 0) < 2 &&
	                    !labelOptions.rotation && // #4415
	                    ((this.staggerLines || 1) * this.len) / slotCount
	                ) || (!horiz && (
	                    (marginLeft && (marginLeft - chart.spacing[3])) ||
	                    chart.chartWidth * 0.33
	                ));
	
	            },
	
	            /**
	             * Render the axis labels and determine whether ellipsis or rotation need
	             * to be applied.
	             *
	             * @private
	             */
	            renderUnsquish: function() {
	                var chart = this.chart,
	                    renderer = chart.renderer,
	                    tickPositions = this.tickPositions,
	                    ticks = this.ticks,
	                    labelOptions = this.options.labels,
	                    horiz = this.horiz,
	                    slotWidth = this.getSlotWidth(),
	                    innerWidth = Math.max(1, Math.round(slotWidth - 2 * (labelOptions.padding || 5))),
	                    attr = {},
	                    labelMetrics = this.labelMetrics(),
	                    textOverflowOption = labelOptions.style && labelOptions.style.textOverflow,
	                    css,
	                    maxLabelLength = 0,
	                    label,
	                    i,
	                    pos;
	
	                // Set rotation option unless it is "auto", like in gauges
	                if (!isString(labelOptions.rotation)) {
	                    attr.rotation = labelOptions.rotation || 0; // #4443
	                }
	
	                // Get the longest label length
	                each(tickPositions, function(tick) {
	                    tick = ticks[tick];
	                    if (tick && tick.labelLength > maxLabelLength) {
	                        maxLabelLength = tick.labelLength;
	                    }
	                });
	                this.maxLabelLength = maxLabelLength;
	
	
	                // Handle auto rotation on horizontal axis
	                if (this.autoRotation) {
	
	                    // Apply rotation only if the label is too wide for the slot, and
	                    // the label is wider than its height.
	                    if (maxLabelLength > innerWidth && maxLabelLength > labelMetrics.h) {
	                        attr.rotation = this.labelRotation;
	                    } else {
	                        this.labelRotation = 0;
	                    }
	
	                    // Handle word-wrap or ellipsis on vertical axis
	                } else if (slotWidth) {
	                    // For word-wrap or ellipsis
	                    css = {
	                        width: innerWidth + 'px'
	                    };
	
	                    if (!textOverflowOption) {
	                        css.textOverflow = 'clip';
	
	                        // On vertical axis, only allow word wrap if there is room for more lines.
	                        i = tickPositions.length;
	                        while (!horiz && i--) {
	                            pos = tickPositions[i];
	                            label = ticks[pos].label;
	                            if (label) {
	                                // Reset ellipsis in order to get the correct bounding box (#4070)
	                                if (label.styles && label.styles.textOverflow === 'ellipsis') {
	                                    label.css({
	                                        textOverflow: 'clip'
	                                    });
	
	                                    // Set the correct width in order to read the bounding box height (#4678, #5034)
	                                } else if (ticks[pos].labelLength > slotWidth) {
	                                    label.css({
	                                        width: slotWidth + 'px'
	                                    });
	                                }
	
	                                if (label.getBBox().height > this.len / tickPositions.length - (labelMetrics.h - labelMetrics.f)) {
	                                    label.specCss = {
	                                        textOverflow: 'ellipsis'
	                                    };
	                                }
	                            }
	                        }
	                    }
	                }
	
	
	                // Add ellipsis if the label length is significantly longer than ideal
	                if (attr.rotation) {
	                    css = {
	                        width: (maxLabelLength > chart.chartHeight * 0.5 ? chart.chartHeight * 0.33 : chart.chartHeight) + 'px'
	                    };
	                    if (!textOverflowOption) {
	                        css.textOverflow = 'ellipsis';
	                    }
	                }
	
	                // Set the explicit or automatic label alignment
	                this.labelAlign = labelOptions.align || this.autoLabelAlign(this.labelRotation);
	                if (this.labelAlign) {
	                    attr.align = this.labelAlign;
	                }
	
	                // Apply general and specific CSS
	                each(tickPositions, function(pos) {
	                    var tick = ticks[pos],
	                        label = tick && tick.label;
	                    if (label) {
	                        label.attr(attr); // This needs to go before the CSS in old IE (#4502)
	                        if (css) {
	                            label.css(merge(css, label.specCss));
	                        }
	                        delete label.specCss;
	                        tick.rotation = attr.rotation;
	                    }
	                });
	
	                // Note: Why is this not part of getLabelPosition?
	                this.tickRotCorr = renderer.rotCorr(labelMetrics.b, this.labelRotation || 0, this.side !== 0);
	            },
	
	            /**
	             * Return true if the axis has associated data.
	             *
	             * @return {Boolean}
	             *         True if the axis has associated visible series and those series
	             *         have either valid data points or explicit `min` and `max`
	             *         settings.
	             */
	            hasData: function() {
	                return (
	                    this.hasVisibleSeries ||
	                    (defined(this.min) && defined(this.max) && !!this.tickPositions)
	                );
	            },
	
	            /**
	             * Adds the title defined in axis.options.title.
	             * @param {Boolean} display - whether or not to display the title
	             */
	            addTitle: function(display) {
	                var axis = this,
	                    renderer = axis.chart.renderer,
	                    horiz = axis.horiz,
	                    opposite = axis.opposite,
	                    options = axis.options,
	                    axisTitleOptions = options.title,
	                    textAlign;
	
	                if (!axis.axisTitle) {
	                    textAlign = axisTitleOptions.textAlign;
	                    if (!textAlign) {
	                        textAlign = (horiz ? {
	                            low: 'left',
	                            middle: 'center',
	                            high: 'right'
	                        } : {
	                            low: opposite ? 'right' : 'left',
	                            middle: 'center',
	                            high: opposite ? 'left' : 'right'
	                        })[axisTitleOptions.align];
	                    }
	                    axis.axisTitle = renderer.text(
	                            axisTitleOptions.text,
	                            0,
	                            0,
	                            axisTitleOptions.useHTML
	                        )
	                        .attr({
	                            zIndex: 7,
	                            rotation: axisTitleOptions.rotation || 0,
	                            align: textAlign
	                        })
	                        .addClass('highcharts-axis-title')
	
	                        .css(axisTitleOptions.style)
	
	                        .add(axis.axisGroup);
	                    axis.axisTitle.isNew = true;
	                }
	
	                // Max width defaults to the length of the axis
	
	                if (!axisTitleOptions.style.width && !axis.isRadial) {
	
	                    axis.axisTitle.css({
	                        width: axis.len
	                    });
	
	                }
	
	
	
	                // hide or show the title depending on whether showEmpty is set
	                axis.axisTitle[display ? 'show' : 'hide'](true);
	            },
	
	            /**
	             * Generates a tick for initial positioning.
	             *
	             * @private
	             * @param  {number} pos
	             *         The tick position in axis values.
	             * @param  {number} i
	             *         The index of the tick in {@link Axis.tickPositions}.
	             */
	            generateTick: function(pos) {
	                var ticks = this.ticks;
	
	                if (!ticks[pos]) {
	                    ticks[pos] = new Tick(this, pos);
	                } else {
	                    ticks[pos].addLabel(); // update labels depending on tick interval
	                }
	            },
	
	            /**
	             * Render the tick labels to a preliminary position to get their sizes.
	             *
	             * @private
	             */
	            getOffset: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    renderer = chart.renderer,
	                    options = axis.options,
	                    tickPositions = axis.tickPositions,
	                    ticks = axis.ticks,
	                    horiz = axis.horiz,
	                    side = axis.side,
	                    invertedSide = chart.inverted && !axis.isZAxis ? [1, 0, 3, 2][side] : side,
	                    hasData,
	                    showAxis,
	                    titleOffset = 0,
	                    titleOffsetOption,
	                    titleMargin = 0,
	                    axisTitleOptions = options.title,
	                    labelOptions = options.labels,
	                    labelOffset = 0, // reset
	                    labelOffsetPadded,
	                    axisOffset = chart.axisOffset,
	                    clipOffset = chart.clipOffset,
	                    clip,
	                    directionFactor = [-1, 1, 1, -1][side],
	                    className = options.className,
	                    axisParent = axis.axisParent, // Used in color axis
	                    lineHeightCorrection,
	                    tickSize = this.tickSize('tick');
	
	                // For reuse in Axis.render
	                hasData = axis.hasData();
	                axis.showAxis = showAxis = hasData || pick(options.showEmpty, true);
	
	                // Set/reset staggerLines
	                axis.staggerLines = axis.horiz && labelOptions.staggerLines;
	
	                // Create the axisGroup and gridGroup elements on first iteration
	                if (!axis.axisGroup) {
	                    axis.gridGroup = renderer.g('grid')
	                        .attr({
	                            zIndex: options.gridZIndex || 1
	                        })
	                        .addClass('highcharts-' + this.coll.toLowerCase() + '-grid ' + (className || ''))
	                        .add(axisParent);
	                    axis.axisGroup = renderer.g('axis')
	                        .attr({
	                            zIndex: options.zIndex || 2
	                        })
	                        .addClass('highcharts-' + this.coll.toLowerCase() + ' ' + (className || ''))
	                        .add(axisParent);
	                    axis.labelGroup = renderer.g('axis-labels')
	                        .attr({
	                            zIndex: labelOptions.zIndex || 7
	                        })
	                        .addClass('highcharts-' + axis.coll.toLowerCase() + '-labels ' + (className || ''))
	                        .add(axisParent);
	                }
	
	                if (hasData || axis.isLinked) {
	
	                    // Generate ticks
	                    each(tickPositions, function(pos, i) {
	                        // i is not used here, but may be used in overrides
	                        axis.generateTick(pos, i);
	                    });
	
	                    axis.renderUnsquish();
	
	
	                    // Left side must be align: right and right side must have align: left for labels
	                    if (labelOptions.reserveSpace !== false && (side === 0 || side === 2 || {
	                            1: 'left',
	                            3: 'right'
	                        }[side] === axis.labelAlign || axis.labelAlign === 'center')) {
	                        each(tickPositions, function(pos) {
	
	                            // get the highest offset
	                            labelOffset = Math.max(
	                                ticks[pos].getLabelSize(),
	                                labelOffset
	                            );
	                        });
	                    }
	
	                    if (axis.staggerLines) {
	                        labelOffset *= axis.staggerLines;
	                        axis.labelOffset = labelOffset * (axis.opposite ? -1 : 1);
	                    }
	
	
	                } else { // doesn't have data
	                    objectEach(ticks, function(tick, n) {
	                        tick.destroy();
	                        delete ticks[n];
	                    });
	                }
	
	                if (axisTitleOptions && axisTitleOptions.text && axisTitleOptions.enabled !== false) {
	                    axis.addTitle(showAxis);
	
	                    if (showAxis && axisTitleOptions.reserveSpace !== false) {
	                        axis.titleOffset = titleOffset =
	                            axis.axisTitle.getBBox()[horiz ? 'height' : 'width'];
	                        titleOffsetOption = axisTitleOptions.offset;
	                        titleMargin = defined(titleOffsetOption) ? 0 : pick(axisTitleOptions.margin, horiz ? 5 : 10);
	                    }
	                }
	
	                // Render the axis line
	                axis.renderLine();
	
	                // handle automatic or user set offset
	                axis.offset = directionFactor * pick(options.offset, axisOffset[side]);
	
	                axis.tickRotCorr = axis.tickRotCorr || {
	                    x: 0,
	                    y: 0
	                }; // polar
	                if (side === 0) {
	                    lineHeightCorrection = -axis.labelMetrics().h;
	                } else if (side === 2) {
	                    lineHeightCorrection = axis.tickRotCorr.y;
	                } else {
	                    lineHeightCorrection = 0;
	                }
	
	                // Find the padded label offset
	                labelOffsetPadded = Math.abs(labelOffset) + titleMargin;
	                if (labelOffset) {
	                    labelOffsetPadded -= lineHeightCorrection;
	                    labelOffsetPadded += directionFactor * (horiz ? pick(labelOptions.y, axis.tickRotCorr.y + directionFactor * 8) : labelOptions.x);
	                }
	                axis.axisTitleMargin = pick(titleOffsetOption, labelOffsetPadded);
	
	                axisOffset[side] = Math.max(
	                    axisOffset[side],
	                    axis.axisTitleMargin + titleOffset + directionFactor * axis.offset,
	                    labelOffsetPadded, // #3027
	                    hasData && tickPositions.length && tickSize ?
	                    tickSize[0] + directionFactor * axis.offset :
	                    0 // #4866
	                );
	
	                // Decide the clipping needed to keep the graph inside the plot area and
	                // axis lines
	                clip = Math.floor(axis.axisLine.strokeWidth() / 2) * 2; // #4308, #4371
	                if (options.offset > 0) {
	                    clip -= options.offset * 2;
	                }
	                clipOffset[invertedSide] = Math.max(
	                    clipOffset[invertedSide] || clip,
	                    clip
	                );
	            },
	
	            /**
	             * Internal function to get the path for the axis line. Extended for polar
	             * charts.
	             *
	             * @param  {Number} lineWidth
	             *         The line width in pixels.
	             * @return {Array}
	             *         The SVG path definition in array form.
	             */
	            getLinePath: function(lineWidth) {
	                var chart = this.chart,
	                    opposite = this.opposite,
	                    offset = this.offset,
	                    horiz = this.horiz,
	                    lineLeft = this.left + (opposite ? this.width : 0) + offset,
	                    lineTop = chart.chartHeight - this.bottom -
	                    (opposite ? this.height : 0) + offset;
	
	                if (opposite) {
	                    lineWidth *= -1; // crispify the other way - #1480, #1687
	                }
	
	                return chart.renderer
	                    .crispLine([
	                        'M',
	                        horiz ?
	                        this.left :
	                        lineLeft,
	                        horiz ?
	                        lineTop :
	                        this.top,
	                        'L',
	                        horiz ?
	                        chart.chartWidth - this.right :
	                        lineLeft,
	                        horiz ?
	                        lineTop :
	                        chart.chartHeight - this.bottom
	                    ], lineWidth);
	            },
	
	            /**
	             * Render the axis line. Called internally when rendering and redrawing the
	             * axis.
	             */
	            renderLine: function() {
	                if (!this.axisLine) {
	                    this.axisLine = this.chart.renderer.path()
	                        .addClass('highcharts-axis-line')
	                        .add(this.axisGroup);
	
	
	                    this.axisLine.attr({
	                        stroke: this.options.lineColor,
	                        'stroke-width': this.options.lineWidth,
	                        zIndex: 7
	                    });
	
	                }
	            },
	
	            /**
	             * Position the axis title.
	             *
	             * @private
	             *
	             * @return {Object}
	             *         X and Y positions for the title.
	             */
	            getTitlePosition: function() {
	                // compute anchor points for each of the title align options
	                var horiz = this.horiz,
	                    axisLeft = this.left,
	                    axisTop = this.top,
	                    axisLength = this.len,
	                    axisTitleOptions = this.options.title,
	                    margin = horiz ? axisLeft : axisTop,
	                    opposite = this.opposite,
	                    offset = this.offset,
	                    xOption = axisTitleOptions.x || 0,
	                    yOption = axisTitleOptions.y || 0,
	                    axisTitle = this.axisTitle,
	                    fontMetrics = this.chart.renderer.fontMetrics(
	                        axisTitleOptions.style && axisTitleOptions.style.fontSize,
	                        axisTitle
	                    ),
	                    // The part of a multiline text that is below the baseline of the
	                    // first line. Subtract 1 to preserve pixel-perfectness from the 
	                    // old behaviour (v5.0.12), where only one line was allowed.
	                    textHeightOvershoot = Math.max(
	                        axisTitle.getBBox(null, 0).height - fontMetrics.h - 1,
	                        0
	                    ),
	
	                    // the position in the length direction of the axis
	                    alongAxis = {
	                        low: margin + (horiz ? 0 : axisLength),
	                        middle: margin + axisLength / 2,
	                        high: margin + (horiz ? axisLength : 0)
	                    }[axisTitleOptions.align],
	
	                    // the position in the perpendicular direction of the axis
	                    offAxis = (horiz ? axisTop + this.height : axisLeft) +
	                    (horiz ? 1 : -1) * // horizontal axis reverses the margin
	                    (opposite ? -1 : 1) * // so does opposite axes
	                    this.axisTitleMargin + [-textHeightOvershoot, // top
	                        textHeightOvershoot, // right
	                        fontMetrics.f, // bottom
	                        -textHeightOvershoot // left
	                    ][this.side];
	
	
	                return {
	                    x: horiz ?
	                        alongAxis + xOption : offAxis + (opposite ? this.width : 0) + offset + xOption,
	                    y: horiz ?
	                        offAxis + yOption - (opposite ? this.height : 0) + offset : alongAxis + yOption
	                };
	            },
	
	            /**
	             * Render a minor tick into the given position. If a minor tick already 
	             * exists in this position, move it.
	             * 
	             * @param  {number} pos
	             *         The position in axis values.
	             */
	            renderMinorTick: function(pos) {
	                var slideInTicks = this.chart.hasRendered && isNumber(this.oldMin),
	                    minorTicks = this.minorTicks;
	
	                if (!minorTicks[pos]) {
	                    minorTicks[pos] = new Tick(this, pos, 'minor');
	                }
	
	                // Render new ticks in old position
	                if (slideInTicks && minorTicks[pos].isNew) {
	                    minorTicks[pos].render(null, true);
	                }
	
	                minorTicks[pos].render(null, false, 1);
	            },
	
	            /**
	             * Render a major tick into the given position. If a tick already exists
	             * in this position, move it.
	             * 
	             * @param  {number} pos
	             *         The position in axis values.
	             * @param  {number} i
	             *         The tick index.
	             */
	            renderTick: function(pos, i) {
	                var isLinked = this.isLinked,
	                    ticks = this.ticks,
	                    slideInTicks = this.chart.hasRendered && isNumber(this.oldMin);
	
	                // Linked axes need an extra check to find out if
	                if (!isLinked || (pos >= this.min && pos <= this.max)) {
	
	                    if (!ticks[pos]) {
	                        ticks[pos] = new Tick(this, pos);
	                    }
	
	                    // render new ticks in old position
	                    if (slideInTicks && ticks[pos].isNew) {
	                        ticks[pos].render(i, true, 0.1);
	                    }
	
	                    ticks[pos].render(i);
	                }
	            },
	
	            /**
	             * Render the axis.
	             *
	             * @private
	             */
	            render: function() {
	                var axis = this,
	                    chart = axis.chart,
	                    renderer = chart.renderer,
	                    options = axis.options,
	                    isLog = axis.isLog,
	                    lin2log = axis.lin2log,
	                    isLinked = axis.isLinked,
	                    tickPositions = axis.tickPositions,
	                    axisTitle = axis.axisTitle,
	                    ticks = axis.ticks,
	                    minorTicks = axis.minorTicks,
	                    alternateBands = axis.alternateBands,
	                    stackLabelOptions = options.stackLabels,
	                    alternateGridColor = options.alternateGridColor,
	                    tickmarkOffset = axis.tickmarkOffset,
	                    axisLine = axis.axisLine,
	                    showAxis = axis.showAxis,
	                    animation = animObject(renderer.globalAnimation),
	                    from,
	                    to;
	
	                // Reset
	                axis.labelEdge.length = 0;
	                //axis.justifyToPlot = overflow === 'justify';
	                axis.overlap = false;
	
	                // Mark all elements inActive before we go over and mark the active ones
	                each([ticks, minorTicks, alternateBands], function(coll) {
	                    objectEach(coll, function(tick) {
	                        tick.isActive = false;
	                    });
	                });
	
	                // If the series has data draw the ticks. Else only the line and title
	                if (axis.hasData() || isLinked) {
	
	                    // minor ticks
	                    if (axis.minorTickInterval && !axis.categories) {
	                        each(axis.getMinorTickPositions(), function(pos) {
	                            axis.renderMinorTick(pos);
	                        });
	                    }
	
	                    // Major ticks. Pull out the first item and render it last so that
	                    // we can get the position of the neighbour label. #808.
	                    if (tickPositions.length) { // #1300
	                        each(tickPositions, function(pos, i) {
	                            axis.renderTick(pos, i);
	                        });
	                        // In a categorized axis, the tick marks are displayed between labels. So
	                        // we need to add a tick mark and grid line at the left edge of the X axis.
	                        if (tickmarkOffset && (axis.min === 0 || axis.single)) {
	                            if (!ticks[-1]) {
	                                ticks[-1] = new Tick(axis, -1, null, true);
	                            }
	                            ticks[-1].render(-1);
	                        }
	
	                    }
	
	                    // alternate grid color
	                    if (alternateGridColor) {
	                        each(tickPositions, function(pos, i) {
	                            to = tickPositions[i + 1] !== undefined ? tickPositions[i + 1] + tickmarkOffset : axis.max - tickmarkOffset;
	                            if (i % 2 === 0 && pos < axis.max && to <= axis.max + (chart.polar ? -tickmarkOffset : tickmarkOffset)) { // #2248, #4660
	                                if (!alternateBands[pos]) {
	                                    alternateBands[pos] = new H.PlotLineOrBand(axis);
	                                }
	                                from = pos + tickmarkOffset; // #949
	                                alternateBands[pos].options = {
	                                    from: isLog ? lin2log(from) : from,
	                                    to: isLog ? lin2log(to) : to,
	                                    color: alternateGridColor
	                                };
	                                alternateBands[pos].render();
	                                alternateBands[pos].isActive = true;
	                            }
	                        });
	                    }
	
	                    // custom plot lines and bands
	                    if (!axis._addedPlotLB) { // only first time
	                        each((options.plotLines || []).concat(options.plotBands || []), function(plotLineOptions) {
	                            axis.addPlotBandOrLine(plotLineOptions);
	                        });
	                        axis._addedPlotLB = true;
	                    }
	
	                } // end if hasData
	
	                // Remove inactive ticks
	                each([ticks, minorTicks, alternateBands], function(coll) {
	                    var i,
	                        forDestruction = [],
	                        delay = animation.duration,
	                        destroyInactiveItems = function() {
	                            i = forDestruction.length;
	                            while (i--) {
	                                // When resizing rapidly, the same items may be destroyed in different timeouts,
	                                // or the may be reactivated
	                                if (coll[forDestruction[i]] && !coll[forDestruction[i]].isActive) {
	                                    coll[forDestruction[i]].destroy();
	                                    delete coll[forDestruction[i]];
	                                }
	                            }
	
	                        };
	
	                    objectEach(coll, function(tick, pos) {
	                        if (!tick.isActive) {
	                            // Render to zero opacity
	                            tick.render(pos, false, 0);
	                            tick.isActive = false;
	                            forDestruction.push(pos);
	                        }
	                    });
	
	                    // When the objects are finished fading out, destroy them
	                    syncTimeout(
	                        destroyInactiveItems,
	                        coll === alternateBands || !chart.hasRendered || !delay ? 0 : delay
	                    );
	                });
	
	                // Set the axis line path
	                if (axisLine) {
	                    axisLine[axisLine.isPlaced ? 'animate' : 'attr']({
	                        d: this.getLinePath(axisLine.strokeWidth())
	                    });
	                    axisLine.isPlaced = true;
	
	                    // Show or hide the line depending on options.showEmpty
	                    axisLine[showAxis ? 'show' : 'hide'](true);
	                }
	
	                if (axisTitle && showAxis) {
	                    var titleXy = axis.getTitlePosition();
	                    if (isNumber(titleXy.y)) {
	                        axisTitle[axisTitle.isNew ? 'attr' : 'animate'](titleXy);
	                        axisTitle.isNew = false;
	                    } else {
	                        axisTitle.attr('y', -9999);
	                        axisTitle.isNew = true;
	                    }
	                }
	
	                // Stacked totals:
	                if (stackLabelOptions && stackLabelOptions.enabled) {
	                    axis.renderStackTotals();
	                }
	                // End stacked totals
	
	                axis.isDirty = false;
	            },
	
	            /**
	             * Redraw the axis to reflect changes in the data or axis extremes. Called
	             * internally from {@link Chart#redraw}.
	             *
	             * @private
	             */
	            redraw: function() {
	
	                if (this.visible) {
	                    // render the axis
	                    this.render();
	
	                    // move plot lines and bands
	                    each(this.plotLinesAndBands, function(plotLine) {
	                        plotLine.render();
	                    });
	                }
	
	                // mark associated series as dirty and ready for redraw
	                each(this.series, function(series) {
	                    series.isDirty = true;
	                });
	
	            },
	
	            // Properties to survive after destroy, needed for Axis.update (#4317,
	            // #5773, #5881).
	            keepProps: ['extKey', 'hcEvents', 'names', 'series', 'userMax', 'userMin'],
	
	            /**
	             * Destroys an Axis instance. See {@link Axis#remove} for the API endpoint
	             * to fully remove the axis.
	             *
	             * @private
	             * @param  {Boolean} keepEvents
	             *         Whether to preserve events, used internally in Axis.update.
	             */
	            destroy: function(keepEvents) {
	                var axis = this,
	                    stacks = axis.stacks,
	                    plotLinesAndBands = axis.plotLinesAndBands,
	                    plotGroup,
	                    i;
	
	                // Remove the events
	                if (!keepEvents) {
	                    removeEvent(axis);
	                }
	
	                // Destroy each stack total
	                objectEach(stacks, function(stack, stackKey) {
	                    destroyObjectProperties(stack);
	
	                    stacks[stackKey] = null;
	                });
	
	                // Destroy collections
	                each([axis.ticks, axis.minorTicks, axis.alternateBands], function(coll) {
	                    destroyObjectProperties(coll);
	                });
	                if (plotLinesAndBands) {
	                    i = plotLinesAndBands.length;
	                    while (i--) { // #1975
	                        plotLinesAndBands[i].destroy();
	                    }
	                }
	
	                // Destroy local variables
	                each(['stackTotalGroup', 'axisLine', 'axisTitle', 'axisGroup', 'gridGroup', 'labelGroup', 'cross'], function(prop) {
	                    if (axis[prop]) {
	                        axis[prop] = axis[prop].destroy();
	                    }
	                });
	
	                // Destroy each generated group for plotlines and plotbands
	                for (plotGroup in axis.plotLinesAndBandsGroups) {
	                    axis.plotLinesAndBandsGroups[plotGroup] = axis.plotLinesAndBandsGroups[plotGroup].destroy();
	                }
	
	                // Delete all properties and fall back to the prototype.
	                objectEach(axis, function(val, key) {
	                    if (inArray(key, axis.keepProps) === -1) {
	                        delete axis[key];
	                    }
	                });
	            },
	
	            /**
	             * Internal function to draw a crosshair.
	             *
	             * @param  {PointerEvent} [e]
	             *         The event arguments from the modified pointer event, extended 
	             *         with `chartX` and `chartY`
	             * @param  {Point} [point]
	             *         The Point object if the crosshair snaps to points.
	             */
	            drawCrosshair: function(e, point) {
	
	                var path,
	                    options = this.crosshair,
	                    snap = pick(options.snap, true),
	                    pos,
	                    categorized,
	                    graphic = this.cross;
	
	                // Use last available event when updating non-snapped crosshairs without
	                // mouse interaction (#5287)
	                if (!e) {
	                    e = this.cross && this.cross.e;
	                }
	
	                if (
	                    // Disabled in options
	                    !this.crosshair ||
	                    // Snap
	                    ((defined(point) || !snap) === false)
	                ) {
	                    this.hideCrosshair();
	                } else {
	
	                    // Get the path
	                    if (!snap) {
	                        pos = e && (this.horiz ? e.chartX - this.pos : this.len - e.chartY + this.pos);
	                    } else if (defined(point)) {
	                        pos = this.isXAxis ? point.plotX : this.len - point.plotY; // #3834
	                    }
	
	                    if (defined(pos)) {
	                        path = this.getPlotLinePath(
	                            // First argument, value, only used on radial
	                            point && (this.isXAxis ? point.x : pick(point.stackY, point.y)),
	                            null,
	                            null,
	                            null,
	                            pos // Translated position
	                        ) || null; // #3189
	                    }
	
	                    if (!defined(path)) {
	                        this.hideCrosshair();
	                        return;
	                    }
	
	                    categorized = this.categories && !this.isRadial;
	
	                    // Draw the cross
	                    if (!graphic) {
	                        this.cross = graphic = this.chart.renderer
	                            .path()
	                            .addClass('highcharts-crosshair highcharts-crosshair-' +
	                                (categorized ? 'category ' : 'thin ') + options.className)
	                            .attr({
	                                zIndex: pick(options.zIndex, 2)
	                            })
	                            .add();
	
	
	                        // Presentational attributes
	                        graphic.attr({
	                            'stroke': options.color || (categorized ? color('#ccd6eb').setOpacity(0.25).get() : '#cccccc'),
	                            'stroke-width': pick(options.width, 1)
	                        });
	                        if (options.dashStyle) {
	                            graphic.attr({
	                                dashstyle: options.dashStyle
	                            });
	                        }
	
	
	                    }
	
	                    graphic.show().attr({
	                        d: path
	                    });
	
	                    if (categorized && !options.width) {
	                        graphic.attr({
	                            'stroke-width': this.transA
	                        });
	                    }
	                    this.cross.e = e;
	                }
	            },
	
	            /**
	             *	Hide the crosshair if visible.
	             */
	            hideCrosshair: function() {
	                if (this.cross) {
	                    this.cross.hide();
	                }
	            }
	        }); // end Axis
	
	        H.Axis = Axis;
	        return Axis;
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            Date = H.Date,
	            dateFormat = H.dateFormat,
	            defaultOptions = H.defaultOptions,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            getMagnitude = H.getMagnitude,
	            getTZOffset = H.getTZOffset,
	            normalizeTickInterval = H.normalizeTickInterval,
	            pick = H.pick,
	            timeUnits = H.timeUnits;
	        /**
	         * Set the tick positions to a time unit that makes sense, for example
	         * on the first of each month or on every Monday. Return an array
	         * with the time positions. Used in datetime axes as well as for grouping
	         * data on a datetime axis.
	         *
	         * @param {Object} normalizedInterval The interval in axis values (ms) and the count
	         * @param {Number} min The minimum in axis values
	         * @param {Number} max The maximum in axis values
	         * @param {Number} startOfWeek
	         */
	        Axis.prototype.getTimeTicks = function(normalizedInterval, min, max, startOfWeek) {
	            var tickPositions = [],
	                i,
	                higherRanks = {},
	                useUTC = defaultOptions.global.useUTC,
	                minYear, // used in months and years as a basis for Date.UTC()
	                // When crossing DST, use the max. Resolves #6278.
	                minDate = new Date(min - Math.max(getTZOffset(min), getTZOffset(max))),
	                makeTime = Date.hcMakeTime,
	                interval = normalizedInterval.unitRange,
	                count = normalizedInterval.count,
	                baseOffset, // #6797
	                variableDayLength;
	
	            if (defined(min)) { // #1300
	                minDate[Date.hcSetMilliseconds](interval >= timeUnits.second ? 0 : // #3935
	                    count * Math.floor(minDate.getMilliseconds() / count)); // #3652, #3654
	
	                if (interval >= timeUnits.second) { // second
	                    minDate[Date.hcSetSeconds](interval >= timeUnits.minute ? 0 : // #3935
	                        count * Math.floor(minDate.getSeconds() / count));
	                }
	
	                if (interval >= timeUnits.minute) { // minute
	                    minDate[Date.hcSetMinutes](interval >= timeUnits.hour ? 0 :
	                        count * Math.floor(minDate[Date.hcGetMinutes]() / count));
	                }
	
	                if (interval >= timeUnits.hour) { // hour
	                    minDate[Date.hcSetHours](interval >= timeUnits.day ? 0 :
	                        count * Math.floor(minDate[Date.hcGetHours]() / count));
	                }
	
	                if (interval >= timeUnits.day) { // day
	                    minDate[Date.hcSetDate](interval >= timeUnits.month ? 1 :
	                        count * Math.floor(minDate[Date.hcGetDate]() / count));
	                }
	
	                if (interval >= timeUnits.month) { // month
	                    minDate[Date.hcSetMonth](interval >= timeUnits.year ? 0 :
	                        count * Math.floor(minDate[Date.hcGetMonth]() / count));
	                    minYear = minDate[Date.hcGetFullYear]();
	                }
	
	                if (interval >= timeUnits.year) { // year
	                    minYear -= minYear % count;
	                    minDate[Date.hcSetFullYear](minYear);
	                }
	
	                // week is a special case that runs outside the hierarchy
	                if (interval === timeUnits.week) {
	                    // get start of current week, independent of count
	                    minDate[Date.hcSetDate](minDate[Date.hcGetDate]() - minDate[Date.hcGetDay]() +
	                        pick(startOfWeek, 1));
	                }
	
	
	                // Get basics for variable time spans
	                minYear = minDate[Date.hcGetFullYear]();
	                var minMonth = minDate[Date.hcGetMonth](),
	                    minDateDate = minDate[Date.hcGetDate](),
	                    minHours = minDate[Date.hcGetHours]();
	
	
	                // Handle local timezone offset
	                if (Date.hcTimezoneOffset || Date.hcGetTimezoneOffset) {
	
	                    // Detect whether we need to take the DST crossover into
	                    // consideration. If we're crossing over DST, the day length may be
	                    // 23h or 25h and we need to compute the exact clock time for each
	                    // tick instead of just adding hours. This comes at a cost, so first
	                    // we found out if it is needed. #4951.
	                    variableDayLength =
	                        (!useUTC || !!Date.hcGetTimezoneOffset) &&
	                        (
	                            // Long range, assume we're crossing over.
	                            max - min > 4 * timeUnits.month ||
	                            // Short range, check if min and max are in different time 
	                            // zones.
	                            getTZOffset(min) !== getTZOffset(max)
	                        );
	
	                    // Adjust minDate to the offset date
	                    minDate = minDate.getTime();
	                    baseOffset = getTZOffset(minDate);
	                    minDate = new Date(minDate + baseOffset);
	                }
	
	
	                // Iterate and add tick positions at appropriate values
	                var time = minDate.getTime();
	                i = 1;
	                while (time < max) {
	                    tickPositions.push(time);
	
	                    // if the interval is years, use Date.UTC to increase years
	                    if (interval === timeUnits.year) {
	                        time = makeTime(minYear + i * count, 0);
	
	                        // if the interval is months, use Date.UTC to increase months
	                    } else if (interval === timeUnits.month) {
	                        time = makeTime(minYear, minMonth + i * count);
	
	                        // if we're using global time, the interval is not fixed as it jumps
	                        // one hour at the DST crossover
	                    } else if (
	                        variableDayLength &&
	                        (interval === timeUnits.day || interval === timeUnits.week)
	                    ) {
	                        time = makeTime(minYear, minMonth, minDateDate +
	                            i * count * (interval === timeUnits.day ? 1 : 7));
	
	                    } else if (variableDayLength && interval === timeUnits.hour) {
	                        // corrected by the start date time zone offset (baseOffset)
	                        // to hide duplicated label (#6797)
	                        time = makeTime(minYear, minMonth, minDateDate, minHours +
	                            i * count, 0, 0, baseOffset) - baseOffset;
	
	                        // else, the interval is fixed and we use simple addition
	                    } else {
	                        time += interval * count;
	                    }
	
	                    i++;
	                }
	
	                // push the last time
	                tickPositions.push(time);
	
	
	                // Handle higher ranks. Mark new days if the time is on midnight
	                // (#950, #1649, #1760, #3349). Use a reasonable dropout threshold to 
	                // prevent looping over dense data grouping (#6156).
	                if (interval <= timeUnits.hour && tickPositions.length < 10000) {
	                    each(tickPositions, function(time) {
	                        if (
	                            // Speed optimization, no need to run dateFormat unless
	                            // we're on a full or half hour
	                            time % 1800000 === 0 &&
	                            // Check for local or global midnight
	                            dateFormat('%H%M%S%L', time) === '000000000'
	                        ) {
	                            higherRanks[time] = 'day';
	                        }
	                    });
	                }
	            }
	
	
	            // record information on the chosen unit - for dynamic label formatter
	            tickPositions.info = extend(normalizedInterval, {
	                higherRanks: higherRanks,
	                totalRange: interval * count
	            });
	
	            return tickPositions;
	        };
	
	        /**
	         * Get a normalized tick interval for dates. Returns a configuration object with
	         * unit range (interval), count and name. Used to prepare data for getTimeTicks.
	         * Previously this logic was part of getTimeTicks, but as getTimeTicks now runs
	         * of segments in stock charts, the normalizing logic was extracted in order to
	         * prevent it for running over again for each segment having the same interval.
	         * #662, #697.
	         */
	        Axis.prototype.normalizeTimeTickInterval = function(tickInterval, unitsOption) {
	            var units = unitsOption || [
	                    [
	                        'millisecond', // unit name
	                        [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples
	                    ],
	                    [
	                        'second', [1, 2, 5, 10, 15, 30]
	                    ],
	                    [
	                        'minute', [1, 2, 5, 10, 15, 30]
	                    ],
	                    [
	                        'hour', [1, 2, 3, 4, 6, 8, 12]
	                    ],
	                    [
	                        'day', [1, 2]
	                    ],
	                    [
	                        'week', [1, 2]
	                    ],
	                    [
	                        'month', [1, 2, 3, 4, 6]
	                    ],
	                    [
	                        'year',
	                        null
	                    ]
	                ],
	                unit = units[units.length - 1], // default unit is years
	                interval = timeUnits[unit[0]],
	                multiples = unit[1],
	                count,
	                i;
	
	            // loop through the units to find the one that best fits the tickInterval
	            for (i = 0; i < units.length; i++) {
	                unit = units[i];
	                interval = timeUnits[unit[0]];
	                multiples = unit[1];
	
	
	                if (units[i + 1]) {
	                    // lessThan is in the middle between the highest multiple and the next unit.
	                    var lessThan = (interval * multiples[multiples.length - 1] +
	                        timeUnits[units[i + 1][0]]) / 2;
	
	                    // break and keep the current unit
	                    if (tickInterval <= lessThan) {
	                        break;
	                    }
	                }
	            }
	
	            // prevent 2.5 years intervals, though 25, 250 etc. are allowed
	            if (interval === timeUnits.year && tickInterval < 5 * interval) {
	                multiples = [1, 2, 5];
	            }
	
	            // get the count
	            count = normalizeTickInterval(
	                tickInterval / interval,
	                multiples,
	                unit[0] === 'year' ? Math.max(getMagnitude(tickInterval / interval), 1) : 1 // #1913, #2360
	            );
	
	            return {
	                unitRange: interval,
	                count: count,
	                unitName: unit[0]
	            };
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            getMagnitude = H.getMagnitude,
	            map = H.map,
	            normalizeTickInterval = H.normalizeTickInterval,
	            pick = H.pick;
	        /**
	         * Methods defined on the Axis prototype
	         */
	
	        /**
	         * Set the tick positions of a logarithmic axis
	         */
	        Axis.prototype.getLogTickPositions = function(interval, min, max, minor) {
	            var axis = this,
	                options = axis.options,
	                axisLength = axis.len,
	                lin2log = axis.lin2log,
	                log2lin = axis.log2lin,
	                // Since we use this method for both major and minor ticks,
	                // use a local variable and return the result
	                positions = [];
	
	            // Reset
	            if (!minor) {
	                axis._minorAutoInterval = null;
	            }
	
	            // First case: All ticks fall on whole logarithms: 1, 10, 100 etc.
	            if (interval >= 0.5) {
	                interval = Math.round(interval);
	                positions = axis.getLinearTickPositions(interval, min, max);
	
	                // Second case: We need intermediary ticks. For example
	                // 1, 2, 4, 6, 8, 10, 20, 40 etc.
	            } else if (interval >= 0.08) {
	                var roundedMin = Math.floor(min),
	                    intermediate,
	                    i,
	                    j,
	                    len,
	                    pos,
	                    lastPos,
	                    break2;
	
	                if (interval > 0.3) {
	                    intermediate = [1, 2, 4];
	                } else if (interval > 0.15) { // 0.2 equals five minor ticks per 1, 10, 100 etc
	                    intermediate = [1, 2, 4, 6, 8];
	                } else { // 0.1 equals ten minor ticks per 1, 10, 100 etc
	                    intermediate = [1, 2, 3, 4, 5, 6, 7, 8, 9];
	                }
	
	                for (i = roundedMin; i < max + 1 && !break2; i++) {
	                    len = intermediate.length;
	                    for (j = 0; j < len && !break2; j++) {
	                        pos = log2lin(lin2log(i) * intermediate[j]);
	                        if (pos > min && (!minor || lastPos <= max) && lastPos !== undefined) { // #1670, lastPos is #3113
	                            positions.push(lastPos);
	                        }
	
	                        if (lastPos > max) {
	                            break2 = true;
	                        }
	                        lastPos = pos;
	                    }
	                }
	
	                // Third case: We are so deep in between whole logarithmic values that
	                // we might as well handle the tick positions like a linear axis. For
	                // example 1.01, 1.02, 1.03, 1.04.
	            } else {
	                var realMin = lin2log(min),
	                    realMax = lin2log(max),
	                    tickIntervalOption = options[minor ? 'minorTickInterval' : 'tickInterval'],
	                    filteredTickIntervalOption = tickIntervalOption === 'auto' ? null : tickIntervalOption,
	                    tickPixelIntervalOption = options.tickPixelInterval / (minor ? 5 : 1),
	                    totalPixelLength = minor ? axisLength / axis.tickPositions.length : axisLength;
	
	                interval = pick(
	                    filteredTickIntervalOption,
	                    axis._minorAutoInterval,
	                    (realMax - realMin) * tickPixelIntervalOption / (totalPixelLength || 1)
	                );
	
	                interval = normalizeTickInterval(
	                    interval,
	                    null,
	                    getMagnitude(interval)
	                );
	
	                positions = map(axis.getLinearTickPositions(
	                    interval,
	                    realMin,
	                    realMax
	                ), log2lin);
	
	                if (!minor) {
	                    axis._minorAutoInterval = interval / 5;
	                }
	            }
	
	            // Set the axis-level tickInterval variable
	            if (!minor) {
	                axis.tickInterval = interval;
	            }
	            return positions;
	        };
	
	        Axis.prototype.log2lin = function(num) {
	            return Math.log(num) / Math.LN10;
	        };
	
	        Axis.prototype.lin2log = function(num) {
	            return Math.pow(10, num);
	        };
	
	    }(Highcharts));
	    (function(H, Axis) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            erase = H.erase,
	            merge = H.merge,
	            pick = H.pick;
	        /*
	         * The object wrapper for plot lines and plot bands
	         * @param {Object} options
	         */
	        H.PlotLineOrBand = function(axis, options) {
	            this.axis = axis;
	
	            if (options) {
	                this.options = options;
	                this.id = options.id;
	            }
	        };
	
	        H.PlotLineOrBand.prototype = {
	
	            /**
	             * Render the plot line or plot band. If it is already existing,
	             * move it.
	             */
	            render: function() {
	                var plotLine = this,
	                    axis = plotLine.axis,
	                    horiz = axis.horiz,
	                    options = plotLine.options,
	                    optionsLabel = options.label,
	                    label = plotLine.label,
	                    to = options.to,
	                    from = options.from,
	                    value = options.value,
	                    isBand = defined(from) && defined(to),
	                    isLine = defined(value),
	                    svgElem = plotLine.svgElem,
	                    isNew = !svgElem,
	                    path = [],
	                    color = options.color,
	                    zIndex = pick(options.zIndex, 0),
	                    events = options.events,
	                    attribs = {
	                        'class': 'highcharts-plot-' + (isBand ? 'band ' : 'line ') + (options.className || '')
	                    },
	                    groupAttribs = {},
	                    renderer = axis.chart.renderer,
	                    groupName = isBand ? 'bands' : 'lines',
	                    group,
	                    log2lin = axis.log2lin;
	
	                // logarithmic conversion
	                if (axis.isLog) {
	                    from = log2lin(from);
	                    to = log2lin(to);
	                    value = log2lin(value);
	                }
	
	
	                // Set the presentational attributes
	                if (isLine) {
	                    attribs = {
	                        stroke: color,
	                        'stroke-width': options.width
	                    };
	                    if (options.dashStyle) {
	                        attribs.dashstyle = options.dashStyle;
	                    }
	
	                } else if (isBand) { // plot band
	                    if (color) {
	                        attribs.fill = color;
	                    }
	                    if (options.borderWidth) {
	                        attribs.stroke = options.borderColor;
	                        attribs['stroke-width'] = options.borderWidth;
	                    }
	                }
	
	
	                // Grouping and zIndex
	                groupAttribs.zIndex = zIndex;
	                groupName += '-' + zIndex;
	
	                group = axis.plotLinesAndBandsGroups[groupName];
	                if (!group) {
	                    axis.plotLinesAndBandsGroups[groupName] = group = renderer.g('plot-' + groupName)
	                        .attr(groupAttribs).add();
	                }
	
	                // Create the path
	                if (isNew) {
	                    plotLine.svgElem = svgElem =
	                        renderer
	                        .path()
	                        .attr(attribs).add(group);
	                }
	
	
	                // Set the path or return
	                if (isLine) {
	                    path = axis.getPlotLinePath(value, svgElem.strokeWidth());
	                } else if (isBand) { // plot band
	                    path = axis.getPlotBandPath(from, to, options);
	                } else {
	                    return;
	                }
	
	
	                // common for lines and bands
	                if (isNew && path && path.length) {
	                    svgElem.attr({
	                        d: path
	                    });
	
	                    // events
	                    if (events) {
	                        H.objectEach(events, function(event, eventType) {
	                            svgElem.on(eventType, function(e) {
	                                events[eventType].apply(plotLine, [e]);
	                            });
	                        });
	                    }
	                } else if (svgElem) {
	                    if (path) {
	                        svgElem.show();
	                        svgElem.animate({
	                            d: path
	                        });
	                    } else {
	                        svgElem.hide();
	                        if (label) {
	                            plotLine.label = label = label.destroy();
	                        }
	                    }
	                }
	
	                // the plot band/line label
	                if (optionsLabel && defined(optionsLabel.text) && path && path.length &&
	                    axis.width > 0 && axis.height > 0 && !path.flat) {
	                    // apply defaults
	                    optionsLabel = merge({
	                        align: horiz && isBand && 'center',
	                        x: horiz ? !isBand && 4 : 10,
	                        verticalAlign: !horiz && isBand && 'middle',
	                        y: horiz ? isBand ? 16 : 10 : isBand ? 6 : -4,
	                        rotation: horiz && !isBand && 90
	                    }, optionsLabel);
	
	                    this.renderLabel(optionsLabel, path, isBand, zIndex);
	
	                } else if (label) { // move out of sight
	                    label.hide();
	                }
	
	                // chainable
	                return plotLine;
	            },
	
	            /**
	             * Render and align label for plot line or band.
	             */
	            renderLabel: function(optionsLabel, path, isBand, zIndex) {
	                var plotLine = this,
	                    label = plotLine.label,
	                    renderer = plotLine.axis.chart.renderer,
	                    attribs,
	                    xs,
	                    ys,
	                    x,
	                    y;
	
	                // add the SVG element
	                if (!label) {
	                    attribs = {
	                        align: optionsLabel.textAlign || optionsLabel.align,
	                        rotation: optionsLabel.rotation,
	                        'class': 'highcharts-plot-' + (isBand ? 'band' : 'line') + '-label ' + (optionsLabel.className || '')
	                    };
	
	                    attribs.zIndex = zIndex;
	
	                    plotLine.label = label = renderer.text(
	                            optionsLabel.text,
	                            0,
	                            0,
	                            optionsLabel.useHTML
	                        )
	                        .attr(attribs)
	                        .add();
	
	
	                    label.css(optionsLabel.style);
	
	                }
	
	                // get the bounding box and align the label
	                // #3000 changed to better handle choice between plotband or plotline
	                xs = [path[1], path[4], (isBand ? path[6] : path[1])];
	                ys = [path[2], path[5], (isBand ? path[7] : path[2])];
	                x = arrayMin(xs);
	                y = arrayMin(ys);
	
	                label.align(optionsLabel, false, {
	                    x: x,
	                    y: y,
	                    width: arrayMax(xs) - x,
	                    height: arrayMax(ys) - y
	                });
	                label.show();
	            },
	
	            /**
	             * Remove the plot line or band
	             */
	            destroy: function() {
	                // remove it from the lookup
	                erase(this.axis.plotLinesAndBands, this);
	
	                delete this.axis;
	                destroyObjectProperties(this);
	            }
	        };
	
	        /**
	         * Object with members for extending the Axis prototype
	         * @todo Extend directly instead of adding object to Highcharts first
	         */
	
	        H.extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Internal function to create the SVG path definition for a plot band.
	             *
	             * @param  {Number} from
	             *         The axis value to start from.
	             * @param  {Number} to
	             *         The axis value to end on.
	             *
	             * @return {Array.<String|Number>}
	             *         The SVG path definition in array form.
	             */
	            getPlotBandPath: function(from, to) {
	                var toPath = this.getPlotLinePath(to, null, null, true),
	                    path = this.getPlotLinePath(from, null, null, true),
	                    // #4964 check if chart is inverted or plotband is on yAxis 
	                    horiz = this.horiz,
	                    plus = 1,
	                    outside =
	                    (from < this.min && to < this.min) ||
	                    (from > this.max && to > this.max);
	
	                if (path && toPath) {
	
	                    // Flat paths don't need labels (#3836)
	                    if (outside) {
	                        path.flat = path.toString() === toPath.toString();
	                        plus = 0;
	                    }
	
	                    // Add 1 pixel, when coordinates are the same
	                    path.push(
	                        horiz && toPath[4] === path[4] ? toPath[4] + plus : toPath[4], !horiz && toPath[5] === path[5] ? toPath[5] + plus : toPath[5],
	                        horiz && toPath[1] === path[1] ? toPath[1] + plus : toPath[1], !horiz && toPath[2] === path[2] ? toPath[2] + plus : toPath[2]
	                    );
	                } else { // outside the axis area
	                    path = null;
	                }
	
	                return path;
	            },
	
	            /**
	             * Add a plot band after render time.
	             *
	             * @param  {AxisPlotBandsOptions} options
	             *         A configuration object for the plot band, as defined in {@link
	             *         https://api.highcharts.com/highcharts/xAxis.plotBands|
	             *         xAxis.plotBands}.
	             * @return {Object}
	             *         The added plot band.
	             * @sample highcharts/members/axis-addplotband/
	             *         Toggle the plot band from a button
	             */
	            addPlotBand: function(options) {
	                return this.addPlotBandOrLine(options, 'plotBands');
	            },
	
	            /**
	             * Add a plot line after render time.
	             * 
	             * @param  {AxisPlotLinesOptions} options
	             *         A configuration object for the plot line, as defined in {@link
	             *         https://api.highcharts.com/highcharts/xAxis.plotLines|
	             *         xAxis.plotLines}.
	             * @return {Object}
	             *         The added plot line.
	             * @sample highcharts/members/axis-addplotline/
	             *         Toggle the plot line from a button
	             */
	            addPlotLine: function(options) {
	                return this.addPlotBandOrLine(options, 'plotLines');
	            },
	
	            /**
	             * Add a plot band or plot line after render time. Called from addPlotBand
	             * and addPlotLine internally.
	             *
	             * @private
	             * @param  options {AxisPlotLinesOptions|AxisPlotBandsOptions}
	             *         The plotBand or plotLine configuration object.
	             */
	            addPlotBandOrLine: function(options, coll) {
	                var obj = new H.PlotLineOrBand(this, options).render(),
	                    userOptions = this.userOptions;
	
	                if (obj) { // #2189
	                    // Add it to the user options for exporting and Axis.update
	                    if (coll) {
	                        userOptions[coll] = userOptions[coll] || [];
	                        userOptions[coll].push(options);
	                    }
	                    this.plotLinesAndBands.push(obj);
	                }
	
	                return obj;
	            },
	
	            /**
	             * Remove a plot band or plot line from the chart by id. Called internally
	             * from `removePlotBand` and `removePlotLine`.
	             *
	             * @private
	             * @param {String} id
	             */
	            removePlotBandOrLine: function(id) {
	                var plotLinesAndBands = this.plotLinesAndBands,
	                    options = this.options,
	                    userOptions = this.userOptions,
	                    i = plotLinesAndBands.length;
	                while (i--) {
	                    if (plotLinesAndBands[i].id === id) {
	                        plotLinesAndBands[i].destroy();
	                    }
	                }
	                each([
	                    options.plotLines || [],
	                    userOptions.plotLines || [],
	                    options.plotBands || [],
	                    userOptions.plotBands || []
	                ], function(arr) {
	                    i = arr.length;
	                    while (i--) {
	                        if (arr[i].id === id) {
	                            erase(arr, arr[i]);
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Remove a plot band by its id.
	             * 
	             * @param  {String} id
	             *         The plot band's `id` as given in the original configuration
	             *         object or in the `addPlotBand` option.
	             * @sample highcharts/members/axis-removeplotband/
	             *         Remove plot band by id
	             * @sample highcharts/members/axis-addplotband/
	             *         Toggle the plot band from a button
	             */
	            removePlotBand: function(id) {
	                this.removePlotBandOrLine(id);
	            },
	
	            /**
	             * Remove a plot line by its id.
	             * @param  {String} id
	             *         The plot line's `id` as given in the original configuration
	             *         object or in the `addPlotLine` option.
	             * @sample highcharts/xaxis/plotlines-id/
	             *         Remove plot line by id
	             * @sample highcharts/members/axis-addplotline/
	             *         Toggle the plot line from a button
	             */
	            removePlotLine: function(id) {
	                this.removePlotBandOrLine(id);
	            }
	        });
	
	    }(Highcharts, Axis));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var dateFormat = H.dateFormat,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            isNumber = H.isNumber,
	            map = H.map,
	            merge = H.merge,
	            pick = H.pick,
	            splat = H.splat,
	            syncTimeout = H.syncTimeout,
	            timeUnits = H.timeUnits;
	        /**
	         * The tooltip object
	         * @param {Object} chart The chart instance
	         * @param {Object} options Tooltip options
	         */
	        H.Tooltip = function() {
	            this.init.apply(this, arguments);
	        };
	
	        H.Tooltip.prototype = {
	
	            init: function(chart, options) {
	
	                // Save the chart and options
	                this.chart = chart;
	                this.options = options;
	
	                // Keep track of the current series
	                //this.currentSeries = undefined;
	
	                // List of crosshairs
	                this.crosshairs = [];
	
	                // Current values of x and y when animating
	                this.now = {
	                    x: 0,
	                    y: 0
	                };
	
	                // The tooltip is initially hidden
	                this.isHidden = true;
	
	
	
	                // Public property for getting the shared state.
	                this.split = options.split && !chart.inverted;
	                this.shared = options.shared || this.split;
	
	            },
	
	            /**
	             * Destroy the single tooltips in a split tooltip.
	             * If the tooltip is active then it is not destroyed, unless forced to.
	             * @param  {boolean} force Force destroy all tooltips.
	             * @return {undefined}
	             */
	            cleanSplit: function(force) {
	                each(this.chart.series, function(series) {
	                    var tt = series && series.tt;
	                    if (tt) {
	                        if (!tt.isActive || force) {
	                            series.tt = tt.destroy();
	                        } else {
	                            tt.isActive = false;
	                        }
	                    }
	                });
	            },
	
	
	
	
	            /**
	             * Create the Tooltip label element if it doesn't exist, then return the
	             * label.
	             */
	            getLabel: function() {
	
	                var renderer = this.chart.renderer,
	                    options = this.options;
	
	                if (!this.label) {
	                    // Create the label
	                    if (this.split) {
	                        this.label = renderer.g('tooltip');
	                    } else {
	                        this.label = renderer.label(
	                                '',
	                                0,
	                                0,
	                                options.shape || 'callout',
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'tooltip'
	                            )
	                            .attr({
	                                padding: options.padding,
	                                r: options.borderRadius
	                            });
	
	
	                        this.label
	                            .attr({
	                                'fill': options.backgroundColor,
	                                'stroke-width': options.borderWidth
	                            })
	                            // #2301, #2657
	                            .css(options.style)
	                            .shadow(options.shadow);
	
	                    }
	
	
	
	                    this.label
	                        .attr({
	                            zIndex: 8
	                        })
	                        .add();
	                }
	                return this.label;
	            },
	
	            update: function(options) {
	                this.destroy();
	                // Update user options (#6218)
	                merge(true, this.chart.options.tooltip.userOptions, options);
	                this.init(this.chart, merge(true, this.options, options));
	            },
	
	            /**
	             * Destroy the tooltip and its elements.
	             */
	            destroy: function() {
	                // Destroy and clear local variables
	                if (this.label) {
	                    this.label = this.label.destroy();
	                }
	                if (this.split && this.tt) {
	                    this.cleanSplit(this.chart, true);
	                    this.tt = this.tt.destroy();
	                }
	                clearTimeout(this.hideTimer);
	                clearTimeout(this.tooltipTimeout);
	            },
	
	            /**
	             * Provide a soft movement for the tooltip
	             *
	             * @param {Number} x
	             * @param {Number} y
	             * @private
	             */
	            move: function(x, y, anchorX, anchorY) {
	                var tooltip = this,
	                    now = tooltip.now,
	                    animate = tooltip.options.animation !== false && !tooltip.isHidden &&
	                    // When we get close to the target position, abort animation and land on the right place (#3056)
	                    (Math.abs(x - now.x) > 1 || Math.abs(y - now.y) > 1),
	                    skipAnchor = tooltip.followPointer || tooltip.len > 1;
	
	                // Get intermediate values for animation
	                extend(now, {
	                    x: animate ? (2 * now.x + x) / 3 : x,
	                    y: animate ? (now.y + y) / 2 : y,
	                    anchorX: skipAnchor ? undefined : animate ? (2 * now.anchorX + anchorX) / 3 : anchorX,
	                    anchorY: skipAnchor ? undefined : animate ? (now.anchorY + anchorY) / 2 : anchorY
	                });
	
	                // Move to the intermediate value
	                tooltip.getLabel().attr(now);
	
	
	                // Run on next tick of the mouse tracker
	                if (animate) {
	
	                    // Never allow two timeouts
	                    clearTimeout(this.tooltipTimeout);
	
	                    // Set the fixed interval ticking for the smooth tooltip
	                    this.tooltipTimeout = setTimeout(function() {
	                        // The interval function may still be running during destroy,
	                        // so check that the chart is really there before calling.
	                        if (tooltip) {
	                            tooltip.move(x, y, anchorX, anchorY);
	                        }
	                    }, 32);
	
	                }
	            },
	
	            /**
	             * Hide the tooltip
	             */
	            hide: function(delay) {
	                var tooltip = this;
	                clearTimeout(this.hideTimer); // disallow duplicate timers (#1728, #1766)
	                delay = pick(delay, this.options.hideDelay, 500);
	                if (!this.isHidden) {
	                    this.hideTimer = syncTimeout(function() {
	                        tooltip.getLabel()[delay ? 'fadeOut' : 'hide']();
	                        tooltip.isHidden = true;
	                    }, delay);
	                }
	            },
	
	            /**
	             * Extendable method to get the anchor position of the tooltip
	             * from a point or set of points
	             */
	            getAnchor: function(points, mouseEvent) {
	                var ret,
	                    chart = this.chart,
	                    inverted = chart.inverted,
	                    plotTop = chart.plotTop,
	                    plotLeft = chart.plotLeft,
	                    plotX = 0,
	                    plotY = 0,
	                    yAxis,
	                    xAxis;
	
	                points = splat(points);
	
	                // Pie uses a special tooltipPos
	                ret = points[0].tooltipPos;
	
	                // When tooltip follows mouse, relate the position to the mouse
	                if (this.followPointer && mouseEvent) {
	                    if (mouseEvent.chartX === undefined) {
	                        mouseEvent = chart.pointer.normalize(mouseEvent);
	                    }
	                    ret = [
	                        mouseEvent.chartX - chart.plotLeft,
	                        mouseEvent.chartY - plotTop
	                    ];
	                }
	                // When shared, use the average position
	                if (!ret) {
	                    each(points, function(point) {
	                        yAxis = point.series.yAxis;
	                        xAxis = point.series.xAxis;
	                        plotX += point.plotX + (!inverted && xAxis ? xAxis.left - plotLeft : 0);
	                        plotY += (point.plotLow ? (point.plotLow + point.plotHigh) / 2 : point.plotY) +
	                            (!inverted && yAxis ? yAxis.top - plotTop : 0); // #1151
	                    });
	
	                    plotX /= points.length;
	                    plotY /= points.length;
	
	                    ret = [
	                        inverted ? chart.plotWidth - plotY : plotX,
	                        this.shared && !inverted && points.length > 1 && mouseEvent ?
	                        mouseEvent.chartY - plotTop : // place shared tooltip next to the mouse (#424)
	                        inverted ? chart.plotHeight - plotX : plotY
	                    ];
	                }
	
	                return map(ret, Math.round);
	            },
	
	            /**
	             * Place the tooltip in a chart without spilling over
	             * and not covering the point it self.
	             */
	            getPosition: function(boxWidth, boxHeight, point) {
	
	                var chart = this.chart,
	                    distance = this.distance,
	                    ret = {},
	                    h = point.h || 0, // #4117
	                    swapped,
	                    first = ['y', chart.chartHeight, boxHeight,
	                        point.plotY + chart.plotTop, chart.plotTop,
	                        chart.plotTop + chart.plotHeight
	                    ],
	                    second = ['x', chart.chartWidth, boxWidth,
	                        point.plotX + chart.plotLeft, chart.plotLeft,
	                        chart.plotLeft + chart.plotWidth
	                    ],
	                    // The far side is right or bottom
	                    preferFarSide = !this.followPointer && pick(point.ttBelow, !chart.inverted === !!point.negative), // #4984
	                    /**
	                     * Handle the preferred dimension. When the preferred dimension is tooltip
	                     * on top or bottom of the point, it will look for space there.
	                     */
	                    firstDimension = function(dim, outerSize, innerSize, point, min, max) {
	                        var roomLeft = innerSize < point - distance,
	                            roomRight = point + distance + innerSize < outerSize,
	                            alignedLeft = point - distance - innerSize,
	                            alignedRight = point + distance;
	
	                        if (preferFarSide && roomRight) {
	                            ret[dim] = alignedRight;
	                        } else if (!preferFarSide && roomLeft) {
	                            ret[dim] = alignedLeft;
	                        } else if (roomLeft) {
	                            ret[dim] = Math.min(max - innerSize, alignedLeft - h < 0 ? alignedLeft : alignedLeft - h);
	                        } else if (roomRight) {
	                            ret[dim] = Math.max(
	                                min,
	                                alignedRight + h + innerSize > outerSize ?
	                                alignedRight :
	                                alignedRight + h
	                            );
	                        } else {
	                            return false;
	                        }
	                    },
	                    /**
	                     * Handle the secondary dimension. If the preferred dimension is tooltip
	                     * on top or bottom of the point, the second dimension is to align the tooltip
	                     * above the point, trying to align center but allowing left or right
	                     * align within the chart box.
	                     */
	                    secondDimension = function(dim, outerSize, innerSize, point) {
	                        var retVal;
	
	                        // Too close to the edge, return false and swap dimensions
	                        if (point < distance || point > outerSize - distance) {
	                            retVal = false;
	                            // Align left/top
	                        } else if (point < innerSize / 2) {
	                            ret[dim] = 1;
	                            // Align right/bottom
	                        } else if (point > outerSize - innerSize / 2) {
	                            ret[dim] = outerSize - innerSize - 2;
	                            // Align center
	                        } else {
	                            ret[dim] = point - innerSize / 2;
	                        }
	                        return retVal;
	                    },
	                    /**
	                     * Swap the dimensions
	                     */
	                    swap = function(count) {
	                        var temp = first;
	                        first = second;
	                        second = temp;
	                        swapped = count;
	                    },
	                    run = function() {
	                        if (firstDimension.apply(0, first) !== false) {
	                            if (secondDimension.apply(0, second) === false && !swapped) {
	                                swap(true);
	                                run();
	                            }
	                        } else if (!swapped) {
	                            swap(true);
	                            run();
	                        } else {
	                            ret.x = ret.y = 0;
	                        }
	                    };
	
	                // Under these conditions, prefer the tooltip on the side of the point
	                if (chart.inverted || this.len > 1) {
	                    swap();
	                }
	                run();
	
	                return ret;
	
	            },
	
	            /**
	             * In case no user defined formatter is given, this will be used. Note that the context
	             * here is an object holding point, series, x, y etc.
	             *
	             * @returns {String|Array<String>}
	             */
	            defaultFormatter: function(tooltip) {
	                var items = this.points || splat(this),
	                    s;
	
	                // Build the header
	                s = [tooltip.tooltipFooterHeaderFormatter(items[0])];
	
	                // build the values
	                s = s.concat(tooltip.bodyFormatter(items));
	
	                // footer
	                s.push(tooltip.tooltipFooterHeaderFormatter(items[0], true));
	
	                return s;
	            },
	
	            /**
	             * Refresh the tooltip's text and position.
	             * @param {Object|Array} pointOrPoints Rither a point or an array of points
	             */
	            refresh: function(pointOrPoints, mouseEvent) {
	                var tooltip = this,
	                    label,
	                    options = tooltip.options,
	                    x,
	                    y,
	                    point = pointOrPoints,
	                    anchor,
	                    textConfig = {},
	                    text,
	                    pointConfig = [],
	                    formatter = options.formatter || tooltip.defaultFormatter,
	                    shared = tooltip.shared,
	                    currentSeries;
	
	                if (!options.enabled) {
	                    return;
	                }
	
	                clearTimeout(this.hideTimer);
	
	                // get the reference point coordinates (pie charts use tooltipPos)
	                tooltip.followPointer = splat(point)[0].series.tooltipOptions.followPointer;
	                anchor = tooltip.getAnchor(point, mouseEvent);
	                x = anchor[0];
	                y = anchor[1];
	
	                // shared tooltip, array is sent over
	                if (shared && !(point.series && point.series.noSharedTooltip)) {
	                    each(point, function(item) {
	                        item.setState('hover');
	
	                        pointConfig.push(item.getLabelConfig());
	                    });
	
	                    textConfig = {
	                        x: point[0].category,
	                        y: point[0].y
	                    };
	                    textConfig.points = pointConfig;
	                    point = point[0];
	
	                    // single point tooltip
	                } else {
	                    textConfig = point.getLabelConfig();
	                }
	                this.len = pointConfig.length; // #6128
	                text = formatter.call(textConfig, tooltip);
	
	                // register the current series
	                currentSeries = point.series;
	                this.distance = pick(currentSeries.tooltipOptions.distance, 16);
	
	                // update the inner HTML
	                if (text === false) {
	                    this.hide();
	                } else {
	
	                    label = tooltip.getLabel();
	
	                    // show it
	                    if (tooltip.isHidden) {
	                        label.attr({
	                            opacity: 1
	                        }).show();
	                    }
	
	                    // update text
	                    if (tooltip.split) {
	                        this.renderSplit(text, pointOrPoints);
	                    } else {
	
	                        // Prevent the tooltip from flowing over the chart box (#6659)
	
	                        if (!options.style.width) {
	
	                            label.css({
	                                width: this.chart.spacingBox.width
	                            });
	
	                        }
	
	
	                        label.attr({
	                            text: text && text.join ? text.join('') : text
	                        });
	
	                        // Set the stroke color of the box to reflect the point
	                        label.removeClass(/highcharts-color-[\d]+/g)
	                            .addClass('highcharts-color-' + pick(point.colorIndex, currentSeries.colorIndex));
	
	
	                        label.attr({
	                            stroke: options.borderColor || point.color || currentSeries.color || '#666666'
	                        });
	
	
	                        tooltip.updatePosition({
	                            plotX: x,
	                            plotY: y,
	                            negative: point.negative,
	                            ttBelow: point.ttBelow,
	                            h: anchor[2] || 0
	                        });
	                    }
	
	                    this.isHidden = false;
	                }
	            },
	
	            /**
	             * Render the split tooltip. Loops over each point's text and adds
	             * a label next to the point, then uses the distribute function to 
	             * find best non-overlapping positions.
	             */
	            renderSplit: function(labels, points) {
	                var tooltip = this,
	                    boxes = [],
	                    chart = this.chart,
	                    ren = chart.renderer,
	                    rightAligned = true,
	                    options = this.options,
	                    headerHeight = 0,
	                    tooltipLabel = this.getLabel();
	
	                // Create the individual labels for header and points, ignore footer
	                each(labels.slice(0, points.length + 1), function(str, i) {
	                    if (str !== false) {
	                        var point = points[i - 1] ||
	                            // Item 0 is the header. Instead of this, we could also
	                            // use the crosshair label
	                            {
	                                isHeader: true,
	                                plotX: points[0].plotX
	                            },
	                            owner = point.series || tooltip,
	                            tt = owner.tt,
	                            series = point.series || {},
	                            colorClass = 'highcharts-color-' + pick(
	                                point.colorIndex,
	                                series.colorIndex,
	                                'none'
	                            ),
	                            target,
	                            x,
	                            bBox,
	                            boxWidth;
	
	                        // Store the tooltip referance on the series
	                        if (!tt) {
	                            owner.tt = tt = ren.label(null, null, null, 'callout')
	                                .addClass('highcharts-tooltip-box ' + colorClass)
	                                .attr({
	                                    'padding': options.padding,
	                                    'r': options.borderRadius,
	
	                                    'fill': options.backgroundColor,
	                                    'stroke': (
	                                        options.borderColor ||
	                                        point.color ||
	                                        series.color ||
	                                        '#333333'
	                                    ),
	                                    'stroke-width': options.borderWidth
	
	                                })
	                                .add(tooltipLabel);
	                        }
	
	                        tt.isActive = true;
	                        tt.attr({
	                            text: str
	                        });
	
	                        tt.css(options.style)
	                            .shadow(options.shadow);
	
	
	                        // Get X position now, so we can move all to the other side in
	                        // case of overflow
	                        bBox = tt.getBBox();
	                        boxWidth = bBox.width + tt.strokeWidth();
	                        if (point.isHeader) {
	                            headerHeight = bBox.height;
	                            x = Math.max(
	                                0, // No left overflow
	                                Math.min(
	                                    point.plotX + chart.plotLeft - boxWidth / 2,
	                                    // No right overflow (#5794)
	                                    chart.chartWidth - boxWidth
	                                )
	                            );
	                        } else {
	                            x = point.plotX + chart.plotLeft -
	                                pick(options.distance, 16) - boxWidth;
	                        }
	
	
	                        // If overflow left, we don't use this x in the next loop
	                        if (x < 0) {
	                            rightAligned = false;
	                        }
	
	                        // Prepare for distribution
	                        target = (point.series && point.series.yAxis &&
	                            point.series.yAxis.pos) + (point.plotY || 0);
	                        target -= chart.plotTop;
	                        boxes.push({
	                            target: point.isHeader ?
	                                chart.plotHeight + headerHeight : target,
	                            rank: point.isHeader ? 1 : 0,
	                            size: owner.tt.getBBox().height + 1,
	                            point: point,
	                            x: x,
	                            tt: tt
	                        });
	                    }
	                });
	
	                // Clean previous run (for missing points)
	                this.cleanSplit();
	
	                // Distribute and put in place
	                H.distribute(boxes, chart.plotHeight + headerHeight);
	                each(boxes, function(box) {
	                    var point = box.point,
	                        series = point.series;
	
	                    // Put the label in place
	                    box.tt.attr({
	                        visibility: box.pos === undefined ? 'hidden' : 'inherit',
	                        x: (rightAligned || point.isHeader ?
	                            box.x :
	                            point.plotX + chart.plotLeft + pick(options.distance, 16)),
	                        y: box.pos + chart.plotTop,
	                        anchorX: point.isHeader ?
	                            point.plotX + chart.plotLeft : point.plotX + series.xAxis.pos,
	                        anchorY: point.isHeader ?
	                            box.pos + chart.plotTop - 15 : point.plotY + series.yAxis.pos
	                    });
	                });
	            },
	
	            /**
	             * Find the new position and perform the move
	             */
	            updatePosition: function(point) {
	                var chart = this.chart,
	                    label = this.getLabel(),
	                    pos = (this.options.positioner || this.getPosition).call(
	                        this,
	                        label.width,
	                        label.height,
	                        point
	                    );
	
	                // do the move
	                this.move(
	                    Math.round(pos.x),
	                    Math.round(pos.y || 0), // can be undefined (#3977) 
	                    point.plotX + chart.plotLeft,
	                    point.plotY + chart.plotTop
	                );
	            },
	
	            /**
	             * Get the optimal date format for a point, based on a range.
	             * @param  {number} range - The time range
	             * @param  {number|Date} date - The date of the point in question
	             * @param  {number} startOfWeek - An integer representing the first day of
	             * the week, where 0 is Sunday
	             * @param  {Object} dateTimeLabelFormats - A map of time units to formats
	             * @return {string} - the optimal date format for a point
	             */
	            getDateFormat: function(range, date, startOfWeek, dateTimeLabelFormats) {
	                var dateStr = dateFormat('%m-%d %H:%M:%S.%L', date),
	                    format,
	                    n,
	                    blank = '01-01 00:00:00.000',
	                    strpos = {
	                        millisecond: 15,
	                        second: 12,
	                        minute: 9,
	                        hour: 6,
	                        day: 3
	                    },
	                    lastN = 'millisecond'; // for sub-millisecond data, #4223
	                for (n in timeUnits) {
	
	                    // If the range is exactly one week and we're looking at a Sunday/Monday, go for the week format
	                    if (range === timeUnits.week && +dateFormat('%w', date) === startOfWeek &&
	                        dateStr.substr(6) === blank.substr(6)) {
	                        n = 'week';
	                        break;
	                    }
	
	                    // The first format that is too great for the range
	                    if (timeUnits[n] > range) {
	                        n = lastN;
	                        break;
	                    }
	
	                    // If the point is placed every day at 23:59, we need to show
	                    // the minutes as well. #2637.
	                    if (strpos[n] && dateStr.substr(strpos[n]) !== blank.substr(strpos[n])) {
	                        break;
	                    }
	
	                    // Weeks are outside the hierarchy, only apply them on Mondays/Sundays like in the first condition
	                    if (n !== 'week') {
	                        lastN = n;
	                    }
	                }
	
	                if (n) {
	                    format = dateTimeLabelFormats[n];
	                }
	
	                return format;
	            },
	
	            /**
	             * Get the best X date format based on the closest point range on the axis.
	             */
	            getXDateFormat: function(point, options, xAxis) {
	                var xDateFormat,
	                    dateTimeLabelFormats = options.dateTimeLabelFormats,
	                    closestPointRange = xAxis && xAxis.closestPointRange;
	
	                if (closestPointRange) {
	                    xDateFormat = this.getDateFormat(
	                        closestPointRange,
	                        point.x,
	                        xAxis.options.startOfWeek,
	                        dateTimeLabelFormats
	                    );
	                } else {
	                    xDateFormat = dateTimeLabelFormats.day;
	                }
	
	                return xDateFormat || dateTimeLabelFormats.year; // #2546, 2581
	            },
	
	            /**
	             * Format the footer/header of the tooltip
	             * #3397: abstraction to enable formatting of footer and header
	             */
	            tooltipFooterHeaderFormatter: function(labelConfig, isFooter) {
	                var footOrHead = isFooter ? 'footer' : 'header',
	                    series = labelConfig.series,
	                    tooltipOptions = series.tooltipOptions,
	                    xDateFormat = tooltipOptions.xDateFormat,
	                    xAxis = series.xAxis,
	                    isDateTime = xAxis && xAxis.options.type === 'datetime' && isNumber(labelConfig.key),
	                    formatString = tooltipOptions[footOrHead + 'Format'];
	
	                // Guess the best date format based on the closest point distance (#568, #3418)
	                if (isDateTime && !xDateFormat) {
	                    xDateFormat = this.getXDateFormat(labelConfig, tooltipOptions, xAxis);
	                }
	
	                // Insert the footer date format if any
	                if (isDateTime && xDateFormat) {
	                    formatString = formatString.replace('{point.key}', '{point.key:' + xDateFormat + '}');
	                }
	
	                return format(formatString, {
	                    point: labelConfig,
	                    series: series
	                });
	            },
	
	            /**
	             * Build the body (lines) of the tooltip by iterating over the items and returning one entry for each item,
	             * abstracting this functionality allows to easily overwrite and extend it.
	             */
	            bodyFormatter: function(items) {
	                return map(items, function(item) {
	                    var tooltipOptions = item.series.tooltipOptions;
	                    return (tooltipOptions.pointFormatter || item.point.tooltipFormatter)
	                        .call(item.point, tooltipOptions.pointFormat);
	                });
	            }
	
	        };
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var H = Highcharts,
	            addEvent = H.addEvent,
	            attr = H.attr,
	            charts = H.charts,
	            color = H.color,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            find = H.find,
	            fireEvent = H.fireEvent,
	            isObject = H.isObject,
	            offset = H.offset,
	            pick = H.pick,
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            Tooltip = H.Tooltip,
	            win = H.win;
	
	        /**
	         * The mouse and touch tracker object. Each {@link Chart} item has one
	         * assosiated Pointer item that can be accessed from the  {@link Chart.pointer}
	         * property.
	         *
	         * @class
	         * @param  {Chart} chart
	         *         The Chart instance.
	         * @param  {Options} options
	         *         The root options object. The pointer uses options from the chart and
	         *         tooltip structures.
	         */
	        Highcharts.Pointer = function(chart, options) {
	            this.init(chart, options);
	        };
	
	        Highcharts.Pointer.prototype = {
	            /**
	             * Initialize the Pointer.
	             *
	             * @private
	             */
	            init: function(chart, options) {
	
	                // Store references
	                this.options = options;
	                this.chart = chart;
	
	                // Do we need to handle click on a touch device?
	                this.runChartClick = options.chart.events && !!options.chart.events.click;
	
	                this.pinchDown = [];
	                this.lastValidTouch = {};
	
	                if (Tooltip) {
	                    chart.tooltip = new Tooltip(chart, options.tooltip);
	                    this.followTouchMove = pick(options.tooltip.followTouchMove, true);
	                }
	
	                this.setDOMEvents();
	            },
	
	            /**
	             * Resolve the zoomType option, this is reset on all touch start and mouse
	             * down events.
	             *
	             * @private
	             */
	            zoomOption: function(e) {
	                var chart = this.chart,
	                    options = chart.options.chart,
	                    zoomType = options.zoomType || '',
	                    inverted = chart.inverted,
	                    zoomX,
	                    zoomY;
	
	                // Look for the pinchType option
	                if (/touch/.test(e.type)) {
	                    zoomType = pick(options.pinchType, zoomType);
	                }
	
	                this.zoomX = zoomX = /x/.test(zoomType);
	                this.zoomY = zoomY = /y/.test(zoomType);
	                this.zoomHor = (zoomX && !inverted) || (zoomY && inverted);
	                this.zoomVert = (zoomY && !inverted) || (zoomX && inverted);
	                this.hasZoom = zoomX || zoomY;
	            },
	
	            /**
	             * @typedef  {Object} PointerEvent
	             *           A native browser mouse or touch event, extended with position
	             *           information relative to the {@link Chart.container}.
	             * @property {Number} chartX
	             *           The X coordinate of the pointer interaction relative to the
	             *           chart.
	             * @property {Number} chartY
	             *           The Y coordinate of the pointer interaction relative to the 
	             *           chart.
	             * 
	             */
	            /**
	             * Takes a browser event object and extends it with custom Highcharts
	             * properties `chartX` and `chartY` in order to work on the internal 
	             * coordinate system.
	             * 
	             * @param  {Object} e
	             *         The event object in standard browsers.
	             *
	             * @return {PointerEvent}
	             *         A browser event with extended properties `chartX` and `chartY`.
	             */
	            normalize: function(e, chartPosition) {
	                var chartX,
	                    chartY,
	                    ePos;
	
	                // IE normalizing
	                e = e || win.event;
	                if (!e.target) {
	                    e.target = e.srcElement;
	                }
	
	                // iOS (#2757)
	                ePos = e.touches ? (e.touches.length ? e.touches.item(0) : e.changedTouches[0]) : e;
	
	                // Get mouse position
	                if (!chartPosition) {
	                    this.chartPosition = chartPosition = offset(this.chart.container);
	                }
	
	                // chartX and chartY
	                if (ePos.pageX === undefined) { // IE < 9. #886.
	                    chartX = Math.max(e.x, e.clientX - chartPosition.left); // #2005, #2129: the second case is 
	                    // for IE10 quirks mode within framesets
	                    chartY = e.y;
	                } else {
	                    chartX = ePos.pageX - chartPosition.left;
	                    chartY = ePos.pageY - chartPosition.top;
	                }
	
	                return extend(e, {
	                    chartX: Math.round(chartX),
	                    chartY: Math.round(chartY)
	                });
	            },
	
	            /**
	             * Get the click position in terms of axis values.
	             *
	             * @param  {PointerEvent} e
	             *         A pointer event, extended with `chartX` and `chartY`
	             *         properties.
	             */
	            getCoordinates: function(e) {
	                var coordinates = {
	                    xAxis: [],
	                    yAxis: []
	                };
	
	                each(this.chart.axes, function(axis) {
	                    coordinates[axis.isXAxis ? 'xAxis' : 'yAxis'].push({
	                        axis: axis,
	                        value: axis.toValue(e[axis.horiz ? 'chartX' : 'chartY'])
	                    });
	                });
	                return coordinates;
	            },
	            /**
	             * Finds the closest point to a set of coordinates, using the k-d-tree
	             * algorithm.
	             *
	             * @param  {Array.<Series>} series
	             *         All the series to search in.
	             * @param  {boolean} shared
	             *         Whether it is a shared tooltip or not.
	             * @param  {object} coordinates
	             *         Chart coordinates of the pointer.
	             * @param  {number} coordinates.chartX
	             * @param  {number} coordinates.chartY
	             *
	             * @return {Point|undefined} The point closest to given coordinates.
	             */
	            findNearestKDPoint: function(series, shared, coordinates) {
	                var closest,
	                    sort = function(p1, p2) {
	                        var isCloserX = p1.distX - p2.distX,
	                            isCloser = p1.dist - p2.dist,
	                            isAbove =
	                            (p2.series.group && p2.series.group.zIndex) -
	                            (p1.series.group && p1.series.group.zIndex),
	                            result;
	
	                        // We have two points which are not in the same place on xAxis
	                        // and shared tooltip:
	                        if (isCloserX !== 0 && shared) { // #5721
	                            result = isCloserX;
	                            // Points are not exactly in the same place on x/yAxis:
	                        } else if (isCloser !== 0) {
	                            result = isCloser;
	                            // The same xAxis and yAxis position, sort by z-index:
	                        } else if (isAbove !== 0) {
	                            result = isAbove;
	                            // The same zIndex, sort by array index:
	                        } else {
	                            result = p1.series.index > p2.series.index ? -1 : 1;
	                        }
	                        return result;
	                    };
	                each(series, function(s) {
	                    var noSharedTooltip = s.noSharedTooltip && shared,
	                        compareX = (!noSharedTooltip &&
	                            s.options.findNearestPointBy.indexOf('y') < 0
	                        ),
	                        point = s.searchPoint(
	                            coordinates,
	                            compareX
	                        );
	                    if (
	                        // Check that we actually found a point on the series.
	                        isObject(point, true) &&
	                        // Use the new point if it is closer.
	                        (!isObject(closest, true) || (sort(closest, point) > 0))
	                    ) {
	                        closest = point;
	                    }
	                });
	                return closest;
	            },
	            getPointFromEvent: function(e) {
	                var target = e.target,
	                    point;
	
	                while (target && !point) {
	                    point = target.point;
	                    target = target.parentNode;
	                }
	                return point;
	            },
	
	            getChartCoordinatesFromPoint: function(point, inverted) {
	                var series = point.series,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis;
	
	                if (xAxis && yAxis) {
	                    return inverted ? {
	                        chartX: xAxis.len + xAxis.pos - point.clientX,
	                        chartY: yAxis.len + yAxis.pos - point.plotY
	                    } : {
	                        chartX: point.clientX + xAxis.pos,
	                        chartY: point.plotY + yAxis.pos
	                    };
	                }
	            },
	
	            /**
	             * Calculates what is the current hovered point/points and series.
	             *
	             * @private
	             *
	             * @param  {undefined|Point} existingHoverPoint
	             *         The point currrently beeing hovered.
	             * @param  {undefined|Series} existingHoverSeries
	             *         The series currently beeing hovered.
	             * @param  {Array.<Series>} series
	             *         All the series in the chart.
	             * @param  {boolean} isDirectTouch
	             *         Is the pointer directly hovering the point.
	             * @param  {boolean} shared
	             *         Whether it is a shared tooltip or not.
	             * @param  {object} coordinates
	             *         Chart coordinates of the pointer.
	             * @param  {number} coordinates.chartX
	             * @param  {number} coordinates.chartY
	             * 
	             * @return {object}
	             *         Object containing resulting hover data.
	             */
	            getHoverData: function(
	                existingHoverPoint,
	                existingHoverSeries,
	                series,
	                isDirectTouch,
	                shared,
	                coordinates
	            ) {
	                var hoverPoint,
	                    hoverPoints = [],
	                    hoverSeries = existingHoverSeries,
	                    useExisting = !!(isDirectTouch && existingHoverPoint),
	                    notSticky = hoverSeries && !hoverSeries.stickyTracking,
	                    filter = function(s) {
	                        return (
	                            s.visible &&
	                            !(!shared && s.directTouch) && // #3821
	                            pick(s.options.enableMouseTracking, true)
	                        );
	                    },
	                    // Which series to look in for the hover point
	                    searchSeries = notSticky ?
	                    // Only search on hovered series if it has stickyTracking false
	                    [hoverSeries] :
	                    // Filter what series to look in.
	                    H.grep(series, function(s) {
	                        return filter(s) && s.stickyTracking;
	                    });
	
	                // Use existing hovered point or find the one closest to coordinates.
	                hoverPoint = useExisting ?
	                    existingHoverPoint :
	                    this.findNearestKDPoint(searchSeries, shared, coordinates);
	
	                // Assign hover series
	                hoverSeries = hoverPoint && hoverPoint.series;
	
	                // If we have a hoverPoint, assign hoverPoints.
	                if (hoverPoint) {
	                    // When tooltip is shared, it displays more than one point
	                    if (shared && !hoverSeries.noSharedTooltip) {
	                        searchSeries = H.grep(series, function(s) {
	                            return filter(s) && !s.noSharedTooltip;
	                        });
	
	                        // Get all points with the same x value as the hoverPoint
	                        each(searchSeries, function(s) {
	                            var point = find(s.points, function(p) {
	                                return p.x === hoverPoint.x;
	                            });
	                            if (isObject(point) && !point.isNull) {
	                                hoverPoints.push(point);
	                            }
	                        });
	                    } else {
	                        hoverPoints.push(hoverPoint);
	                    }
	                }
	
	                return {
	                    hoverPoint: hoverPoint,
	                    hoverSeries: hoverSeries,
	                    hoverPoints: hoverPoints
	                };
	            },
	            /**
	             * With line type charts with a single tracker, get the point closest to the
	             * mouse. Run Point.onMouseOver and display tooltip for the point or points.
	             *
	             * @private
	             */
	            runPointActions: function(e, p) {
	                var pointer = this,
	                    chart = pointer.chart,
	                    series = chart.series,
	                    tooltip = chart.tooltip,
	                    shared = tooltip ? tooltip.shared : false,
	                    hoverPoint = p || chart.hoverPoint,
	                    hoverSeries = hoverPoint && hoverPoint.series || chart.hoverSeries,
	                    // onMouseOver or already hovering a series with directTouch
	                    isDirectTouch = !!p || (
	                        (hoverSeries && hoverSeries.directTouch) &&
	                        pointer.isDirectTouch
	                    ),
	                    hoverData = this.getHoverData(
	                        hoverPoint,
	                        hoverSeries,
	                        series,
	                        isDirectTouch,
	                        shared,
	                        e
	                    ),
	                    useSharedTooltip,
	                    followPointer,
	                    anchor,
	                    points;
	                // Update variables from hoverData.
	                hoverPoint = hoverData.hoverPoint;
	                points = hoverData.hoverPoints;
	                hoverSeries = hoverData.hoverSeries;
	                followPointer = hoverSeries && hoverSeries.tooltipOptions.followPointer;
	                useSharedTooltip = shared && hoverSeries && !hoverSeries.noSharedTooltip;
	
	                // Refresh tooltip for kdpoint if new hover point or tooltip was hidden
	                // #3926, #4200
	                if (
	                    hoverPoint &&
	                    // !(hoverSeries && hoverSeries.directTouch) &&
	                    (hoverPoint !== chart.hoverPoint || (tooltip && tooltip.isHidden))
	                ) {
	                    each(chart.hoverPoints || [], function(p) {
	                        if (H.inArray(p, points) === -1) {
	                            p.setState();
	                        }
	                    });
	                    // Do mouseover on all points (#3919, #3985, #4410, #5622)
	                    each(points || [], function(p) {
	                        p.setState('hover');
	                    });
	                    // set normal state to previous series
	                    if (chart.hoverSeries !== hoverSeries) {
	                        hoverSeries.onMouseOver();
	                    }
	
	                    // If tracking is on series in stead of on each point, 
	                    // fire mouseOver on hover point. // #4448
	                    if (chart.hoverPoint) {
	                        chart.hoverPoint.firePointEvent('mouseOut');
	                    }
	                    hoverPoint.firePointEvent('mouseOver');
	                    chart.hoverPoints = points;
	                    chart.hoverPoint = hoverPoint;
	                    // Draw tooltip if necessary
	                    if (tooltip) {
	                        tooltip.refresh(useSharedTooltip ? points : hoverPoint, e);
	                    }
	                    // Update positions (regardless of kdpoint or hoverPoint)
	                } else if (followPointer && tooltip && !tooltip.isHidden) {
	                    anchor = tooltip.getAnchor([{}], e);
	                    tooltip.updatePosition({
	                        plotX: anchor[0],
	                        plotY: anchor[1]
	                    });
	                }
	
	                // Start the event listener to pick up the tooltip and crosshairs
	                if (!pointer.unDocMouseMove) {
	                    pointer.unDocMouseMove = addEvent(
	                        chart.container.ownerDocument,
	                        'mousemove',
	                        function(e) {
	                            var chart = charts[H.hoverChartIndex];
	                            if (chart) {
	                                chart.pointer.onDocumentMouseMove(e);
	                            }
	                        }
	                    );
	                }
	
	                // Issues related to crosshair #4927, #5269 #5066, #5658
	                each(chart.axes, function drawAxisCrosshair(axis) {
	                    var snap = pick(axis.crosshair.snap, true),
	                        point = !snap ?
	                        undefined :
	                        H.find(points, function(p) {
	                            return p.series[axis.coll] === axis;
	                        });
	
	                    // Axis has snapping crosshairs, and one of the hover points belongs
	                    // to axis. Always call drawCrosshair when it is not snap.
	                    if (point || !snap) {
	                        axis.drawCrosshair(e, point);
	                        // Axis has snapping crosshairs, but no hover point belongs to axis
	                    } else {
	                        axis.hideCrosshair();
	                    }
	                });
	            },
	
	            /**
	             * Reset the tracking by hiding the tooltip, the hover series state and the
	             * hover point
	             *
	             * @param allowMove {Boolean}
	             *        Instead of destroying the tooltip altogether, allow moving it if
	             *        possible.
	             */
	            reset: function(allowMove, delay) {
	                var pointer = this,
	                    chart = pointer.chart,
	                    hoverSeries = chart.hoverSeries,
	                    hoverPoint = chart.hoverPoint,
	                    hoverPoints = chart.hoverPoints,
	                    tooltip = chart.tooltip,
	                    tooltipPoints = tooltip && tooltip.shared ? hoverPoints : hoverPoint;
	
	                // Check if the points have moved outside the plot area (#1003, #4736, #5101)
	                if (allowMove && tooltipPoints) {
	                    each(splat(tooltipPoints), function(point) {
	                        if (point.series.isCartesian && point.plotX === undefined) {
	                            allowMove = false;
	                        }
	                    });
	                }
	
	                // Just move the tooltip, #349
	                if (allowMove) {
	                    if (tooltip && tooltipPoints) {
	                        tooltip.refresh(tooltipPoints);
	                        if (hoverPoint) { // #2500
	                            hoverPoint.setState(hoverPoint.state, true);
	                            each(chart.axes, function(axis) {
	                                if (axis.crosshair) {
	                                    axis.drawCrosshair(null, hoverPoint);
	                                }
	                            });
	                        }
	                    }
	
	                    // Full reset
	                } else {
	
	                    if (hoverPoint) {
	                        hoverPoint.onMouseOut();
	                    }
	
	                    if (hoverPoints) {
	                        each(hoverPoints, function(point) {
	                            point.setState();
	                        });
	                    }
	
	                    if (hoverSeries) {
	                        hoverSeries.onMouseOut();
	                    }
	
	                    if (tooltip) {
	                        tooltip.hide(delay);
	                    }
	
	                    if (pointer.unDocMouseMove) {
	                        pointer.unDocMouseMove = pointer.unDocMouseMove();
	                    }
	
	                    // Remove crosshairs
	                    each(chart.axes, function(axis) {
	                        axis.hideCrosshair();
	                    });
	
	                    pointer.hoverX = chart.hoverPoints = chart.hoverPoint = null;
	                }
	            },
	
	            /**
	             * Scale series groups to a certain scale and translation.
	             *
	             * @private
	             */
	            scaleGroups: function(attribs, clip) {
	
	                var chart = this.chart,
	                    seriesAttribs;
	
	                // Scale each series
	                each(chart.series, function(series) {
	                    seriesAttribs = attribs || series.getPlotBox(); // #1701
	                    if (series.xAxis && series.xAxis.zoomEnabled && series.group) {
	                        series.group.attr(seriesAttribs);
	                        if (series.markerGroup) {
	                            series.markerGroup.attr(seriesAttribs);
	                            series.markerGroup.clip(clip ? chart.clipRect : null);
	                        }
	                        if (series.dataLabelsGroup) {
	                            series.dataLabelsGroup.attr(seriesAttribs);
	                        }
	                    }
	                });
	
	                // Clip
	                chart.clipRect.attr(clip || chart.clipBox);
	            },
	
	            /**
	             * Start a drag operation.
	             *
	             * @private
	             */
	            dragStart: function(e) {
	                var chart = this.chart;
	
	                // Record the start position
	                chart.mouseIsDown = e.type;
	                chart.cancelClick = false;
	                chart.mouseDownX = this.mouseDownX = e.chartX;
	                chart.mouseDownY = this.mouseDownY = e.chartY;
	            },
	
	            /**
	             * Perform a drag operation in response to a mousemove event while the mouse
	             * is down.
	             *
	             * @private
	             */
	            drag: function(e) {
	
	                var chart = this.chart,
	                    chartOptions = chart.options.chart,
	                    chartX = e.chartX,
	                    chartY = e.chartY,
	                    zoomHor = this.zoomHor,
	                    zoomVert = this.zoomVert,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop,
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    clickedInside,
	                    size,
	                    selectionMarker = this.selectionMarker,
	                    mouseDownX = this.mouseDownX,
	                    mouseDownY = this.mouseDownY,
	                    panKey = chartOptions.panKey && e[chartOptions.panKey + 'Key'];
	
	                // If the device supports both touch and mouse (like IE11), and we are touch-dragging
	                // inside the plot area, don't handle the mouse event. #4339.
	                if (selectionMarker && selectionMarker.touch) {
	                    return;
	                }
	
	                // If the mouse is outside the plot area, adjust to cooordinates
	                // inside to prevent the selection marker from going outside
	                if (chartX < plotLeft) {
	                    chartX = plotLeft;
	                } else if (chartX > plotLeft + plotWidth) {
	                    chartX = plotLeft + plotWidth;
	                }
	
	                if (chartY < plotTop) {
	                    chartY = plotTop;
	                } else if (chartY > plotTop + plotHeight) {
	                    chartY = plotTop + plotHeight;
	                }
	
	                // determine if the mouse has moved more than 10px
	                this.hasDragged = Math.sqrt(
	                    Math.pow(mouseDownX - chartX, 2) +
	                    Math.pow(mouseDownY - chartY, 2)
	                );
	
	                if (this.hasDragged > 10) {
	                    clickedInside = chart.isInsidePlot(mouseDownX - plotLeft, mouseDownY - plotTop);
	
	                    // make a selection
	                    if (chart.hasCartesianSeries && (this.zoomX || this.zoomY) && clickedInside && !panKey) {
	                        if (!selectionMarker) {
	                            this.selectionMarker = selectionMarker = chart.renderer.rect(
	                                    plotLeft,
	                                    plotTop,
	                                    zoomHor ? 1 : plotWidth,
	                                    zoomVert ? 1 : plotHeight,
	                                    0
	                                )
	                                .attr({
	
	                                    fill: chartOptions.selectionMarkerFill || color('#335cad').setOpacity(0.25).get(),
	
	                                    'class': 'highcharts-selection-marker',
	                                    'zIndex': 7
	                                })
	                                .add();
	                        }
	                    }
	
	                    // adjust the width of the selection marker
	                    if (selectionMarker && zoomHor) {
	                        size = chartX - mouseDownX;
	                        selectionMarker.attr({
	                            width: Math.abs(size),
	                            x: (size > 0 ? 0 : size) + mouseDownX
	                        });
	                    }
	                    // adjust the height of the selection marker
	                    if (selectionMarker && zoomVert) {
	                        size = chartY - mouseDownY;
	                        selectionMarker.attr({
	                            height: Math.abs(size),
	                            y: (size > 0 ? 0 : size) + mouseDownY
	                        });
	                    }
	
	                    // panning
	                    if (clickedInside && !selectionMarker && chartOptions.panning) {
	                        chart.pan(e, chartOptions.panning);
	                    }
	                }
	            },
	
	            /**
	             * On mouse up or touch end across the entire document, drop the selection.
	             *
	             * @private
	             */
	            drop: function(e) {
	                var pointer = this,
	                    chart = this.chart,
	                    hasPinched = this.hasPinched;
	
	                if (this.selectionMarker) {
	                    var selectionData = {
	                            originalEvent: e, // #4890
	                            xAxis: [],
	                            yAxis: []
	                        },
	                        selectionBox = this.selectionMarker,
	                        selectionLeft = selectionBox.attr ? selectionBox.attr('x') : selectionBox.x,
	                        selectionTop = selectionBox.attr ? selectionBox.attr('y') : selectionBox.y,
	                        selectionWidth = selectionBox.attr ? selectionBox.attr('width') : selectionBox.width,
	                        selectionHeight = selectionBox.attr ? selectionBox.attr('height') : selectionBox.height,
	                        runZoom;
	
	                    // a selection has been made
	                    if (this.hasDragged || hasPinched) {
	
	                        // record each axis' min and max
	                        each(chart.axes, function(axis) {
	                            if (axis.zoomEnabled && defined(axis.min) && (hasPinched || pointer[{
	                                    xAxis: 'zoomX',
	                                    yAxis: 'zoomY'
	                                }[axis.coll]])) { // #859, #3569
	                                var horiz = axis.horiz,
	                                    minPixelPadding = e.type === 'touchend' ? axis.minPixelPadding : 0, // #1207, #3075
	                                    selectionMin = axis.toValue((horiz ? selectionLeft : selectionTop) + minPixelPadding),
	                                    selectionMax = axis.toValue((horiz ? selectionLeft + selectionWidth : selectionTop + selectionHeight) - minPixelPadding);
	
	                                selectionData[axis.coll].push({
	                                    axis: axis,
	                                    min: Math.min(selectionMin, selectionMax), // for reversed axes
	                                    max: Math.max(selectionMin, selectionMax)
	                                });
	                                runZoom = true;
	                            }
	                        });
	                        if (runZoom) {
	                            fireEvent(chart, 'selection', selectionData, function(args) {
	                                chart.zoom(extend(args, hasPinched ? {
	                                    animation: false
	                                } : null));
	                            });
	                        }
	
	                    }
	                    this.selectionMarker = this.selectionMarker.destroy();
	
	                    // Reset scaling preview
	                    if (hasPinched) {
	                        this.scaleGroups();
	                    }
	                }
	
	                // Reset all
	                if (chart) { // it may be destroyed on mouse up - #877
	                    css(chart.container, {
	                        cursor: chart._cursor
	                    });
	                    chart.cancelClick = this.hasDragged > 10; // #370
	                    chart.mouseIsDown = this.hasDragged = this.hasPinched = false;
	                    this.pinchDown = [];
	                }
	            },
	
	            onContainerMouseDown: function(e) {
	
	                e = this.normalize(e);
	
	                this.zoomOption(e);
	
	                // issue #295, dragging not always working in Firefox
	                if (e.preventDefault) {
	                    e.preventDefault();
	                }
	
	                this.dragStart(e);
	            },
	
	
	
	            onDocumentMouseUp: function(e) {
	                if (charts[H.hoverChartIndex]) {
	                    charts[H.hoverChartIndex].pointer.drop(e);
	                }
	            },
	
	            /**
	             * Special handler for mouse move that will hide the tooltip when the mouse
	             * leaves the plotarea. Issue #149 workaround. The mouseleave event does not
	             * always fire.
	             *
	             * @private
	             */
	            onDocumentMouseMove: function(e) {
	                var chart = this.chart,
	                    chartPosition = this.chartPosition;
	
	                e = this.normalize(e, chartPosition);
	
	                // If we're outside, hide the tooltip
	                if (chartPosition && !this.inClass(e.target, 'highcharts-tracker') &&
	                    !chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
	                    this.reset();
	                }
	            },
	
	            /**
	             * When mouse leaves the container, hide the tooltip.
	             *
	             * @private
	             */
	            onContainerMouseLeave: function(e) {
	                var chart = charts[H.hoverChartIndex];
	                if (chart && (e.relatedTarget || e.toElement)) { // #4886, MS Touch end fires mouseleave but with no related target
	                    chart.pointer.reset();
	                    chart.pointer.chartPosition = null; // also reset the chart position, used in #149 fix
	                }
	            },
	
	            // The mousemove, touchmove and touchstart event handler
	            onContainerMouseMove: function(e) {
	
	                var chart = this.chart;
	
	                if (!defined(H.hoverChartIndex) || !charts[H.hoverChartIndex] || !charts[H.hoverChartIndex].mouseIsDown) {
	                    H.hoverChartIndex = chart.index;
	                }
	
	                e = this.normalize(e);
	                e.returnValue = false; // #2251, #3224
	
	                if (chart.mouseIsDown === 'mousedown') {
	                    this.drag(e);
	                }
	
	                // Show the tooltip and run mouse over events (#977)
	                if ((this.inClass(e.target, 'highcharts-tracker') ||
	                        chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) && !chart.openMenu) {
	                    this.runPointActions(e);
	                }
	            },
	
	            /**
	             * Utility to detect whether an element has, or has a parent with, a specific
	             * class name. Used on detection of tracker objects and on deciding whether
	             * hovering the tooltip should cause the active series to mouse out.
	             *
	             * @param  {SVGDOMElement|HTMLDOMElement} element
	             *         The element to investigate.
	             * @param  {String} className
	             *         The class name to look for.
	             *
	             * @return {Boolean}
	             *         True if either the element or one of its parents has the given
	             *         class name.
	             */
	            inClass: function(element, className) {
	                var elemClassName;
	                while (element) {
	                    elemClassName = attr(element, 'class');
	                    if (elemClassName) {
	                        if (elemClassName.indexOf(className) !== -1) {
	                            return true;
	                        }
	                        if (elemClassName.indexOf('highcharts-container') !== -1) {
	                            return false;
	                        }
	                    }
	                    element = element.parentNode;
	                }
	            },
	
	            onTrackerMouseOut: function(e) {
	                var series = this.chart.hoverSeries,
	                    relatedTarget = e.relatedTarget || e.toElement;
	                this.isDirectTouch = false;
	                if (series && relatedTarget && !series.stickyTracking &&
	                    !this.inClass(relatedTarget, 'highcharts-tooltip') &&
	                    (!this.inClass(relatedTarget, 'highcharts-series-' + series.index) || // #2499, #4465
	                        !this.inClass(relatedTarget, 'highcharts-tracker') // #5553
	                    )
	                ) {
	                    series.onMouseOut();
	                }
	            },
	
	            onContainerClick: function(e) {
	                var chart = this.chart,
	                    hoverPoint = chart.hoverPoint,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop;
	
	                e = this.normalize(e);
	
	                if (!chart.cancelClick) {
	
	                    // On tracker click, fire the series and point events. #783, #1583
	                    if (hoverPoint && this.inClass(e.target, 'highcharts-tracker')) {
	
	                        // the series click event
	                        fireEvent(hoverPoint.series, 'click', extend(e, {
	                            point: hoverPoint
	                        }));
	
	                        // the point click event
	                        if (chart.hoverPoint) { // it may be destroyed (#1844)
	                            hoverPoint.firePointEvent('click', e);
	                        }
	
	                        // When clicking outside a tracker, fire a chart event
	                    } else {
	                        extend(e, this.getCoordinates(e));
	
	                        // fire a click event in the chart
	                        if (chart.isInsidePlot(e.chartX - plotLeft, e.chartY - plotTop)) {
	                            fireEvent(chart, 'click', e);
	                        }
	                    }
	
	
	                }
	            },
	
	            /**
	             * Set the JS DOM events on the container and document. This method should contain
	             * a one-to-one assignment between methods and their handlers. Any advanced logic should
	             * be moved to the handler reflecting the event's name.
	             *
	             * @private
	             */
	            setDOMEvents: function() {
	
	                var pointer = this,
	                    container = pointer.chart.container,
	                    ownerDoc = container.ownerDocument;
	
	                container.onmousedown = function(e) {
	                    pointer.onContainerMouseDown(e);
	                };
	                container.onmousemove = function(e) {
	                    pointer.onContainerMouseMove(e);
	                };
	                container.onclick = function(e) {
	                    pointer.onContainerClick(e);
	                };
	                addEvent(container, 'mouseleave', pointer.onContainerMouseLeave);
	                if (H.chartCount === 1) {
	                    addEvent(
	                        ownerDoc,
	                        'mouseup',
	                        pointer.onDocumentMouseUp
	                    );
	                }
	                if (H.hasTouch) {
	                    container.ontouchstart = function(e) {
	                        pointer.onContainerTouchStart(e);
	                    };
	                    container.ontouchmove = function(e) {
	                        pointer.onContainerTouchMove(e);
	                    };
	                    if (H.chartCount === 1) {
	                        addEvent(
	                            ownerDoc,
	                            'touchend',
	                            pointer.onDocumentTouchEnd
	                        );
	                    }
	                }
	
	            },
	
	            /**
	             * Destroys the Pointer object and disconnects DOM events.
	             */
	            destroy: function() {
	                var pointer = this,
	                    ownerDoc = this.chart.container.ownerDocument;
	
	                if (pointer.unDocMouseMove) {
	                    pointer.unDocMouseMove();
	                }
	
	                removeEvent(
	                    pointer.chart.container,
	                    'mouseleave',
	                    pointer.onContainerMouseLeave
	                );
	                if (!H.chartCount) {
	                    removeEvent(ownerDoc, 'mouseup', pointer.onDocumentMouseUp);
	                    if (H.hasTouch) {
	                        removeEvent(ownerDoc, 'touchend', pointer.onDocumentTouchEnd);
	                    }
	                }
	
	                // memory and CPU leak
	                clearInterval(pointer.tooltipTimeout);
	
	                H.objectEach(pointer, function(val, prop) {
	                    pointer[prop] = null;
	                });
	            }
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var charts = H.charts,
	            each = H.each,
	            extend = H.extend,
	            map = H.map,
	            noop = H.noop,
	            pick = H.pick,
	            Pointer = H.Pointer;
	
	        /* Support for touch devices */
	        extend(Pointer.prototype, /** @lends Pointer.prototype */ {
	
	            /**
	             * Run translation operations
	             */
	            pinchTranslate: function(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch) {
	                if (this.zoomHor) {
	                    this.pinchTranslateDirection(true, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	                }
	                if (this.zoomVert) {
	                    this.pinchTranslateDirection(false, pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	                }
	            },
	
	            /**
	             * Run translation operations for each direction (horizontal and vertical) independently
	             */
	            pinchTranslateDirection: function(horiz, pinchDown, touches, transform,
	                selectionMarker, clip, lastValidTouch, forcedScale) {
	                var chart = this.chart,
	                    xy = horiz ? 'x' : 'y',
	                    XY = horiz ? 'X' : 'Y',
	                    sChartXY = 'chart' + XY,
	                    wh = horiz ? 'width' : 'height',
	                    plotLeftTop = chart['plot' + (horiz ? 'Left' : 'Top')],
	                    selectionWH,
	                    selectionXY,
	                    clipXY,
	                    scale = forcedScale || 1,
	                    inverted = chart.inverted,
	                    bounds = chart.bounds[horiz ? 'h' : 'v'],
	                    singleTouch = pinchDown.length === 1,
	                    touch0Start = pinchDown[0][sChartXY],
	                    touch0Now = touches[0][sChartXY],
	                    touch1Start = !singleTouch && pinchDown[1][sChartXY],
	                    touch1Now = !singleTouch && touches[1][sChartXY],
	                    outOfBounds,
	                    transformScale,
	                    scaleKey,
	                    setScale = function() {
	                        // Don't zoom if fingers are too close on this axis
	                        if (!singleTouch && Math.abs(touch0Start - touch1Start) > 20) {
	                            scale = forcedScale || Math.abs(touch0Now - touch1Now) / Math.abs(touch0Start - touch1Start);
	                        }
	
	                        clipXY = ((plotLeftTop - touch0Now) / scale) + touch0Start;
	                        selectionWH = chart['plot' + (horiz ? 'Width' : 'Height')] / scale;
	                    };
	
	                // Set the scale, first pass
	                setScale();
	
	                selectionXY = clipXY; // the clip position (x or y) is altered if out of bounds, the selection position is not
	
	                // Out of bounds
	                if (selectionXY < bounds.min) {
	                    selectionXY = bounds.min;
	                    outOfBounds = true;
	                } else if (selectionXY + selectionWH > bounds.max) {
	                    selectionXY = bounds.max - selectionWH;
	                    outOfBounds = true;
	                }
	
	                // Is the chart dragged off its bounds, determined by dataMin and dataMax?
	                if (outOfBounds) {
	
	                    // Modify the touchNow position in order to create an elastic drag movement. This indicates
	                    // to the user that the chart is responsive but can't be dragged further.
	                    touch0Now -= 0.8 * (touch0Now - lastValidTouch[xy][0]);
	                    if (!singleTouch) {
	                        touch1Now -= 0.8 * (touch1Now - lastValidTouch[xy][1]);
	                    }
	
	                    // Set the scale, second pass to adapt to the modified touchNow positions
	                    setScale();
	
	                } else {
	                    lastValidTouch[xy] = [touch0Now, touch1Now];
	                }
	
	                // Set geometry for clipping, selection and transformation
	                if (!inverted) {
	                    clip[xy] = clipXY - plotLeftTop;
	                    clip[wh] = selectionWH;
	                }
	                scaleKey = inverted ? (horiz ? 'scaleY' : 'scaleX') : 'scale' + XY;
	                transformScale = inverted ? 1 / scale : scale;
	
	                selectionMarker[wh] = selectionWH;
	                selectionMarker[xy] = selectionXY;
	                transform[scaleKey] = scale;
	                transform['translate' + XY] = (transformScale * plotLeftTop) + (touch0Now - (transformScale * touch0Start));
	            },
	
	            /**
	             * Handle touch events with two touches
	             */
	            pinch: function(e) {
	
	                var self = this,
	                    chart = self.chart,
	                    pinchDown = self.pinchDown,
	                    touches = e.touches,
	                    touchesLength = touches.length,
	                    lastValidTouch = self.lastValidTouch,
	                    hasZoom = self.hasZoom,
	                    selectionMarker = self.selectionMarker,
	                    transform = {},
	                    fireClickEvent = touchesLength === 1 && ((self.inClass(e.target, 'highcharts-tracker') &&
	                        chart.runTrackerClick) || self.runChartClick),
	                    clip = {};
	
	                // Don't initiate panning until the user has pinched. This prevents us from
	                // blocking page scrolling as users scroll down a long page (#4210).
	                if (touchesLength > 1) {
	                    self.initiated = true;
	                }
	
	                // On touch devices, only proceed to trigger click if a handler is defined
	                if (hasZoom && self.initiated && !fireClickEvent) {
	                    e.preventDefault();
	                }
	
	                // Normalize each touch
	                map(touches, function(e) {
	                    return self.normalize(e);
	                });
	
	                // Register the touch start position
	                if (e.type === 'touchstart') {
	                    each(touches, function(e, i) {
	                        pinchDown[i] = {
	                            chartX: e.chartX,
	                            chartY: e.chartY
	                        };
	                    });
	                    lastValidTouch.x = [pinchDown[0].chartX, pinchDown[1] && pinchDown[1].chartX];
	                    lastValidTouch.y = [pinchDown[0].chartY, pinchDown[1] && pinchDown[1].chartY];
	
	                    // Identify the data bounds in pixels
	                    each(chart.axes, function(axis) {
	                        if (axis.zoomEnabled) {
	                            var bounds = chart.bounds[axis.horiz ? 'h' : 'v'],
	                                minPixelPadding = axis.minPixelPadding,
	                                min = axis.toPixels(pick(axis.options.min, axis.dataMin)),
	                                max = axis.toPixels(pick(axis.options.max, axis.dataMax)),
	                                absMin = Math.min(min, max),
	                                absMax = Math.max(min, max);
	
	                            // Store the bounds for use in the touchmove handler
	                            bounds.min = Math.min(axis.pos, absMin - minPixelPadding);
	                            bounds.max = Math.max(axis.pos + axis.len, absMax + minPixelPadding);
	                        }
	                    });
	                    self.res = true; // reset on next move
	
	                    // Optionally move the tooltip on touchmove
	                } else if (self.followTouchMove && touchesLength === 1) {
	                    this.runPointActions(self.normalize(e));
	
	                    // Event type is touchmove, handle panning and pinching
	                } else if (pinchDown.length) { // can be 0 when releasing, if touchend fires first
	
	
	                    // Set the marker
	                    if (!selectionMarker) {
	                        self.selectionMarker = selectionMarker = extend({
	                            destroy: noop,
	                            touch: true
	                        }, chart.plotBox);
	                    }
	
	                    self.pinchTranslate(pinchDown, touches, transform, selectionMarker, clip, lastValidTouch);
	
	                    self.hasPinched = hasZoom;
	
	                    // Scale and translate the groups to provide visual feedback during pinching
	                    self.scaleGroups(transform, clip);
	
	                    if (self.res) {
	                        self.res = false;
	                        this.reset(false, 0);
	                    }
	                }
	            },
	
	            /**
	             * General touch handler shared by touchstart and touchmove.
	             */
	            touch: function(e, start) {
	                var chart = this.chart,
	                    hasMoved,
	                    pinchDown,
	                    isInside;
	
	                if (chart.index !== H.hoverChartIndex) {
	                    this.onContainerMouseLeave({
	                        relatedTarget: true
	                    });
	                }
	                H.hoverChartIndex = chart.index;
	
	                if (e.touches.length === 1) {
	
	                    e = this.normalize(e);
	
	                    isInside = chart.isInsidePlot(
	                        e.chartX - chart.plotLeft,
	                        e.chartY - chart.plotTop
	                    );
	                    if (isInside && !chart.openMenu) {
	
	                        // Run mouse events and display tooltip etc
	                        if (start) {
	                            this.runPointActions(e);
	                        }
	
	                        // Android fires touchmove events after the touchstart even if the
	                        // finger hasn't moved, or moved only a pixel or two. In iOS however,
	                        // the touchmove doesn't fire unless the finger moves more than ~4px.
	                        // So we emulate this behaviour in Android by checking how much it
	                        // moved, and cancelling on small distances. #3450.
	                        if (e.type === 'touchmove') {
	                            pinchDown = this.pinchDown;
	                            hasMoved = pinchDown[0] ? Math.sqrt( // #5266
	                                Math.pow(pinchDown[0].chartX - e.chartX, 2) +
	                                Math.pow(pinchDown[0].chartY - e.chartY, 2)
	                            ) >= 4 : false;
	                        }
	
	                        if (pick(hasMoved, true)) {
	                            this.pinch(e);
	                        }
	
	                    } else if (start) {
	                        // Hide the tooltip on touching outside the plot area (#1203)
	                        this.reset();
	                    }
	
	                } else if (e.touches.length === 2) {
	                    this.pinch(e);
	                }
	            },
	
	            onContainerTouchStart: function(e) {
	                this.zoomOption(e);
	                this.touch(e, true);
	            },
	
	            onContainerTouchMove: function(e) {
	                this.touch(e);
	            },
	
	            onDocumentTouchEnd: function(e) {
	                if (charts[H.hoverChartIndex]) {
	                    charts[H.hoverChartIndex].pointer.drop(e);
	                }
	            }
	
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            charts = H.charts,
	            css = H.css,
	            doc = H.doc,
	            extend = H.extend,
	            hasTouch = H.hasTouch,
	            noop = H.noop,
	            Pointer = H.Pointer,
	            removeEvent = H.removeEvent,
	            win = H.win,
	            wrap = H.wrap;
	
	        if (!hasTouch && (win.PointerEvent || win.MSPointerEvent)) {
	
	            // The touches object keeps track of the points being touched at all times
	            var touches = {},
	                hasPointerEvent = !!win.PointerEvent,
	                getWebkitTouches = function() {
	                    var fake = [];
	                    fake.item = function(i) {
	                        return this[i];
	                    };
	                    H.objectEach(touches, function(touch) {
	                        fake.push({
	                            pageX: touch.pageX,
	                            pageY: touch.pageY,
	                            target: touch.target
	                        });
	                    });
	                    return fake;
	                },
	                translateMSPointer = function(e, method, wktype, func) {
	                    var p;
	                    if ((e.pointerType === 'touch' || e.pointerType === e.MSPOINTER_TYPE_TOUCH) && charts[H.hoverChartIndex]) {
	                        func(e);
	                        p = charts[H.hoverChartIndex].pointer;
	                        p[method]({
	                            type: wktype,
	                            target: e.currentTarget,
	                            preventDefault: noop,
	                            touches: getWebkitTouches()
	                        });
	                    }
	                };
	
	            /**
	             * Extend the Pointer prototype with methods for each event handler and more
	             */
	            extend(Pointer.prototype, /** @lends Pointer.prototype */ {
	                onContainerPointerDown: function(e) {
	                    translateMSPointer(e, 'onContainerTouchStart', 'touchstart', function(e) {
	                        touches[e.pointerId] = {
	                            pageX: e.pageX,
	                            pageY: e.pageY,
	                            target: e.currentTarget
	                        };
	                    });
	                },
	                onContainerPointerMove: function(e) {
	                    translateMSPointer(e, 'onContainerTouchMove', 'touchmove', function(e) {
	                        touches[e.pointerId] = {
	                            pageX: e.pageX,
	                            pageY: e.pageY
	                        };
	                        if (!touches[e.pointerId].target) {
	                            touches[e.pointerId].target = e.currentTarget;
	                        }
	                    });
	                },
	                onDocumentPointerUp: function(e) {
	                    translateMSPointer(e, 'onDocumentTouchEnd', 'touchend', function(e) {
	                        delete touches[e.pointerId];
	                    });
	                },
	
	                /**
	                 * Add or remove the MS Pointer specific events
	                 */
	                batchMSEvents: function(fn) {
	                    fn(this.chart.container, hasPointerEvent ? 'pointerdown' : 'MSPointerDown', this.onContainerPointerDown);
	                    fn(this.chart.container, hasPointerEvent ? 'pointermove' : 'MSPointerMove', this.onContainerPointerMove);
	                    fn(doc, hasPointerEvent ? 'pointerup' : 'MSPointerUp', this.onDocumentPointerUp);
	                }
	            });
	
	            // Disable default IE actions for pinch and such on chart element
	            wrap(Pointer.prototype, 'init', function(proceed, chart, options) {
	                proceed.call(this, chart, options);
	                if (this.hasZoom) { // #4014
	                    css(chart.container, {
	                        '-ms-touch-action': 'none',
	                        'touch-action': 'none'
	                    });
	                }
	            });
	
	            // Add IE specific touch events to chart
	            wrap(Pointer.prototype, 'setDOMEvents', function(proceed) {
	                proceed.apply(this);
	                if (this.hasZoom || this.followTouchMove) {
	                    this.batchMSEvents(addEvent);
	                }
	            });
	            // Destroy MS events also
	            wrap(Pointer.prototype, 'destroy', function(proceed) {
	                this.batchMSEvents(removeEvent);
	                proceed.call(this);
	            });
	        }
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var H = Highcharts,
	
	            addEvent = H.addEvent,
	            css = H.css,
	            discardElement = H.discardElement,
	            defined = H.defined,
	            each = H.each,
	            isFirefox = H.isFirefox,
	            marginNames = H.marginNames,
	            merge = H.merge,
	            pick = H.pick,
	            setAnimation = H.setAnimation,
	            stableSort = H.stableSort,
	            win = H.win,
	            wrap = H.wrap;
	
	        /**
	         * The overview of the chart's series. The legend object is instanciated
	         * internally in the chart constructor, and available from `chart.legend`. Each
	         * chart has only one legend.
	         * 
	         * @class
	         */
	        Highcharts.Legend = function(chart, options) {
	            this.init(chart, options);
	        };
	
	        Highcharts.Legend.prototype = {
	
	            /**
	             * Initialize the legend.
	             *
	             * @private
	             */
	            init: function(chart, options) {
	
	                this.chart = chart;
	
	                this.setOptions(options);
	
	                if (options.enabled) {
	
	                    // Render it
	                    this.render();
	
	                    // move checkboxes
	                    addEvent(this.chart, 'endResize', function() {
	                        this.legend.positionCheckboxes();
	                    });
	                }
	            },
	
	            setOptions: function(options) {
	
	                var padding = pick(options.padding, 8);
	
	                this.options = options;
	
	
	                this.itemStyle = options.itemStyle;
	                this.itemHiddenStyle = merge(this.itemStyle, options.itemHiddenStyle);
	
	                this.itemMarginTop = options.itemMarginTop || 0;
	                this.padding = padding;
	                this.initialItemY = padding - 5; // 5 is pixels above the text
	                this.maxItemWidth = 0;
	                this.itemHeight = 0;
	                this.symbolWidth = pick(options.symbolWidth, 16);
	                this.pages = [];
	
	            },
	
	            /**
	             * Update the legend with new options. Equivalent to running `chart.update`
	             * with a legend configuration option.
	             * @param  {LegendOptions} options
	             *         Legend options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart.
	             *
	             * @sample highcharts/legend/legend-update/
	             *         Legend update
	             */
	            update: function(options, redraw) {
	                var chart = this.chart;
	
	                this.setOptions(merge(true, this.options, options));
	                this.destroy();
	                chart.isDirtyLegend = chart.isDirtyBox = true;
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Set the colors for the legend item.
	             *
	             * @private
	             * @param  {Series|Point} item
	             *         A Series or Point instance
	             * @param  {Boolean} visible
	             *         Dimmed or colored
	             */
	            colorizeItem: function(item, visible) {
	                item.legendGroup[visible ? 'removeClass' : 'addClass'](
	                    'highcharts-legend-item-hidden'
	                );
	
	
	                var legend = this,
	                    options = legend.options,
	                    legendItem = item.legendItem,
	                    legendLine = item.legendLine,
	                    legendSymbol = item.legendSymbol,
	                    hiddenColor = legend.itemHiddenStyle.color,
	                    textColor = visible ? options.itemStyle.color : hiddenColor,
	                    symbolColor = visible ? (item.color || hiddenColor) : hiddenColor,
	                    markerOptions = item.options && item.options.marker,
	                    symbolAttr = {
	                        fill: symbolColor
	                    };
	
	                if (legendItem) {
	                    legendItem.css({
	                        fill: textColor,
	                        color: textColor // #1553, oldIE
	                    });
	                }
	                if (legendLine) {
	                    legendLine.attr({
	                        stroke: symbolColor
	                    });
	                }
	
	                if (legendSymbol) {
	
	                    // Apply marker options
	                    if (markerOptions && legendSymbol.isMarker) { // #585
	                        symbolAttr = item.pointAttribs();
	                        if (!visible) {
	                            symbolAttr.stroke = symbolAttr.fill = hiddenColor; // #6769
	                        }
	                    }
	
	                    legendSymbol.attr(symbolAttr);
	                }
	
	            },
	
	            /**
	             * Position the legend item.
	             *
	             * @private
	             * @param {Series|Point} item
	             *        The item to position
	             */
	            positionItem: function(item) {
	                var legend = this,
	                    options = legend.options,
	                    symbolPadding = options.symbolPadding,
	                    ltr = !options.rtl,
	                    legendItemPos = item._legendItemPos,
	                    itemX = legendItemPos[0],
	                    itemY = legendItemPos[1],
	                    checkbox = item.checkbox,
	                    legendGroup = item.legendGroup;
	
	                if (legendGroup && legendGroup.element) {
	                    legendGroup.translate(
	                        ltr ?
	                        itemX :
	                        legend.legendWidth - itemX - 2 * symbolPadding - 4,
	                        itemY
	                    );
	                }
	
	                if (checkbox) {
	                    checkbox.x = itemX;
	                    checkbox.y = itemY;
	                }
	            },
	
	            /**
	             * Destroy a single legend item, used internally on removing series items.
	             * 
	             * @param {Series|Point} item
	             *        The item to remove
	             */
	            destroyItem: function(item) {
	                var checkbox = item.checkbox;
	
	                // destroy SVG elements
	                each(
	                    ['legendItem', 'legendLine', 'legendSymbol', 'legendGroup'],
	                    function(key) {
	                        if (item[key]) {
	                            item[key] = item[key].destroy();
	                        }
	                    }
	                );
	
	                if (checkbox) {
	                    discardElement(item.checkbox);
	                }
	            },
	
	            /**
	             * Destroy the legend. Used internally. To reflow objects, `chart.redraw`
	             * must be called after destruction.
	             */
	            destroy: function() {
	                function destroyItems(key) {
	                    if (this[key]) {
	                        this[key] = this[key].destroy();
	                    }
	                }
	
	                // Destroy items
	                each(this.getAllItems(), function(item) {
	                    each(['legendItem', 'legendGroup'], destroyItems, item);
	                });
	
	                // Destroy legend elements
	                each([
	                    'clipRect',
	                    'up',
	                    'down',
	                    'pager',
	                    'nav',
	                    'box',
	                    'title',
	                    'group'
	                ], destroyItems, this);
	                this.display = null; // Reset in .render on update.
	            },
	
	            /**
	             * Position the checkboxes after the width is determined.
	             *
	             * @private
	             */
	            positionCheckboxes: function(scrollOffset) {
	                var alignAttr = this.group && this.group.alignAttr,
	                    translateY,
	                    clipHeight = this.clipHeight || this.legendHeight,
	                    titleHeight = this.titleHeight;
	
	                if (alignAttr) {
	                    translateY = alignAttr.translateY;
	                    each(this.allItems, function(item) {
	                        var checkbox = item.checkbox,
	                            top;
	
	                        if (checkbox) {
	                            top = translateY + titleHeight + checkbox.y +
	                                (scrollOffset || 0) + 3;
	                            css(checkbox, {
	                                left: (alignAttr.translateX + item.checkboxOffset +
	                                    checkbox.x - 20) + 'px',
	                                top: top + 'px',
	                                display: top > translateY - 6 && top < translateY +
	                                    clipHeight - 6 ? '' : 'none'
	                            });
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Render the legend title on top of the legend.
	             *
	             * @private
	             */
	            renderTitle: function() {
	                var options = this.options,
	                    padding = this.padding,
	                    titleOptions = options.title,
	                    titleHeight = 0,
	                    bBox;
	
	                if (titleOptions.text) {
	                    if (!this.title) {
	                        this.title = this.chart.renderer.label(
	                                titleOptions.text,
	                                padding - 3,
	                                padding - 4,
	                                null,
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'legend-title'
	                            )
	                            .attr({
	                                zIndex: 1
	                            })
	
	                            .css(titleOptions.style)
	
	                            .add(this.group);
	                    }
	                    bBox = this.title.getBBox();
	                    titleHeight = bBox.height;
	                    this.offsetWidth = bBox.width; // #1717
	                    this.contentGroup.attr({
	                        translateY: titleHeight
	                    });
	                }
	                this.titleHeight = titleHeight;
	            },
	
	            /**
	             * Set the legend item text.
	             *
	             * @param  {Series|Point} item
	             *         The item for which to update the text in the legend.
	             */
	            setText: function(item) {
	                var options = this.options;
	                item.legendItem.attr({
	                    text: options.labelFormat ?
	                        H.format(options.labelFormat, item) : options.labelFormatter.call(item)
	                });
	            },
	
	            /**
	             * Render a single specific legend item. Called internally from the `render`
	             * function.
	             *
	             * @private
	             * @param {Series|Point} item
	             *        The item to render.
	             */
	            renderItem: function(item) {
	                var legend = this,
	                    chart = legend.chart,
	                    renderer = chart.renderer,
	                    options = legend.options,
	                    horizontal = options.layout === 'horizontal',
	                    symbolWidth = legend.symbolWidth,
	                    symbolPadding = options.symbolPadding,
	
	                    itemStyle = legend.itemStyle,
	                    itemHiddenStyle = legend.itemHiddenStyle,
	
	                    padding = legend.padding,
	                    itemDistance = horizontal ? pick(options.itemDistance, 20) : 0,
	                    ltr = !options.rtl,
	                    itemHeight,
	                    widthOption = options.width,
	                    itemMarginBottom = options.itemMarginBottom || 0,
	                    itemMarginTop = legend.itemMarginTop,
	                    bBox,
	                    itemWidth,
	                    li = item.legendItem,
	                    isSeries = !item.series,
	                    series = !isSeries && item.series.drawLegendSymbol ?
	                    item.series :
	                    item,
	                    seriesOptions = series.options,
	                    showCheckbox = legend.createCheckboxForItem &&
	                    seriesOptions &&
	                    seriesOptions.showCheckbox,
	                    // full width minus text width
	                    itemExtraWidth = symbolWidth + symbolPadding + itemDistance +
	                    (showCheckbox ? 20 : 0),
	                    useHTML = options.useHTML,
	                    fontSize = 12,
	                    itemClassName = item.options.className;
	
	                if (!li) { // generate it once, later move it
	
	                    // Generate the group box, a group to hold the symbol and text. Text
	                    // is to be appended in Legend class.
	                    item.legendGroup = renderer.g('legend-item')
	                        .addClass(
	                            'highcharts-' + series.type + '-series ' +
	                            'highcharts-color-' + item.colorIndex +
	                            (itemClassName ? ' ' + itemClassName : '') +
	                            (isSeries ? ' highcharts-series-' + item.index : '')
	                        )
	                        .attr({
	                            zIndex: 1
	                        })
	                        .add(legend.scrollGroup);
	
	                    // Generate the list item text and add it to the group
	                    item.legendItem = li = renderer.text(
	                            '',
	                            ltr ? symbolWidth + symbolPadding : -symbolPadding,
	                            legend.baseline || 0,
	                            useHTML
	                        )
	
	                        // merge to prevent modifying original (#1021)
	                        .css(merge(item.visible ? itemStyle : itemHiddenStyle))
	
	                        .attr({
	                            align: ltr ? 'left' : 'right',
	                            zIndex: 2
	                        })
	                        .add(item.legendGroup);
	
	                    // Get the baseline for the first item - the font size is equal for
	                    // all
	                    if (!legend.baseline) {
	
	                        fontSize = itemStyle.fontSize;
	
	                        legend.fontMetrics = renderer.fontMetrics(
	                            fontSize,
	                            li
	                        );
	                        legend.baseline = legend.fontMetrics.f + 3 + itemMarginTop;
	                        li.attr('y', legend.baseline);
	                    }
	
	                    // Draw the legend symbol inside the group box
	                    legend.symbolHeight = options.symbolHeight || legend.fontMetrics.f;
	                    series.drawLegendSymbol(legend, item);
	
	                    if (legend.setItemEvents) {
	                        legend.setItemEvents(item, li, useHTML);
	                    }
	
	                    // add the HTML checkbox on top
	                    if (showCheckbox) {
	                        legend.createCheckboxForItem(item);
	                    }
	                }
	
	                // Colorize the items
	                legend.colorizeItem(item, item.visible);
	
	                // Take care of max width and text overflow (#6659)
	
	                if (!itemStyle.width) {
	
	                    li.css({
	                        width: (
	                            options.itemWidth ||
	                            options.width ||
	                            chart.spacingBox.width
	                        ) - itemExtraWidth
	                    });
	
	                }
	
	
	                // Always update the text
	                legend.setText(item);
	
	                // calculate the positions for the next line
	                bBox = li.getBBox();
	
	                itemWidth = item.checkboxOffset =
	                    options.itemWidth ||
	                    item.legendItemWidth ||
	                    bBox.width + itemExtraWidth;
	                legend.itemHeight = itemHeight = Math.round(
	                    item.legendItemHeight || bBox.height || legend.symbolHeight
	                );
	
	                // If the item exceeds the width, start a new line
	                if (
	                    horizontal &&
	                    legend.itemX - padding + itemWidth > (
	                        widthOption || (
	                            chart.spacingBox.width - 2 * padding - options.x
	                        )
	                    )
	                ) {
	                    legend.itemX = padding;
	                    legend.itemY += itemMarginTop + legend.lastLineHeight +
	                        itemMarginBottom;
	                    legend.lastLineHeight = 0; // reset for next line (#915, #3976)
	                }
	
	                // If the item exceeds the height, start a new column
	                /*if (!horizontal && legend.itemY + options.y +
	                		itemHeight > chart.chartHeight - spacingTop - spacingBottom) {
	                	legend.itemY = legend.initialItemY;
	                	legend.itemX += legend.maxItemWidth;
	                	legend.maxItemWidth = 0;
	                }*/
	
	                // Set the edge positions
	                legend.maxItemWidth = Math.max(legend.maxItemWidth, itemWidth);
	                legend.lastItemY = itemMarginTop + legend.itemY + itemMarginBottom;
	                legend.lastLineHeight = Math.max( // #915
	                    itemHeight,
	                    legend.lastLineHeight
	                );
	
	                // cache the position of the newly generated or reordered items
	                item._legendItemPos = [legend.itemX, legend.itemY];
	
	                // advance
	                if (horizontal) {
	                    legend.itemX += itemWidth;
	
	                } else {
	                    legend.itemY += itemMarginTop + itemHeight + itemMarginBottom;
	                    legend.lastLineHeight = itemHeight;
	                }
	
	                // the width of the widest item
	                legend.offsetWidth = widthOption || Math.max(
	                    (
	                        horizontal ? legend.itemX - padding - (item.checkbox ?
	                            // decrease by itemDistance only when no checkbox #4853
	                            0 :
	                            itemDistance
	                        ) : itemWidth
	                    ) + padding,
	                    legend.offsetWidth
	                );
	            },
	
	            /**
	             * Get all items, which is one item per series for most series and one
	             * item per point for pie series and its derivatives.
	             *
	             * @return {Array.<Series|Point>}
	             *         The current items in the legend.
	             */
	            getAllItems: function() {
	                var allItems = [];
	                each(this.chart.series, function(series) {
	                    var seriesOptions = series && series.options;
	
	                    // Handle showInLegend. If the series is linked to another series,
	                    // defaults to false.
	                    if (series && pick(
	                            seriesOptions.showInLegend, !defined(seriesOptions.linkedTo) ? undefined : false, true
	                        )) {
	
	                        // Use points or series for the legend item depending on
	                        // legendType
	                        allItems = allItems.concat(
	                            series.legendItems ||
	                            (
	                                seriesOptions.legendType === 'point' ?
	                                series.data :
	                                series
	                            )
	                        );
	                    }
	                });
	                return allItems;
	            },
	
	            /**
	             * Adjust the chart margins by reserving space for the legend on only one
	             * side of the chart. If the position is set to a corner, top or bottom is
	             * reserved for horizontal legends and left or right for vertical ones.
	             *
	             * @private
	             */
	            adjustMargins: function(margin, spacing) {
	                var chart = this.chart,
	                    options = this.options,
	                    // Use the first letter of each alignment option in order to detect
	                    // the side. (#4189 - use charAt(x) notation instead of [x] for IE7)
	                    alignment = options.align.charAt(0) +
	                    options.verticalAlign.charAt(0) +
	                    options.layout.charAt(0);
	
	                if (!options.floating) {
	
	                    each([
	                        /(lth|ct|rth)/,
	                        /(rtv|rm|rbv)/,
	                        /(rbh|cb|lbh)/,
	                        /(lbv|lm|ltv)/
	                    ], function(alignments, side) {
	                        if (alignments.test(alignment) && !defined(margin[side])) {
	                            // Now we have detected on which side of the chart we should
	                            // reserve space for the legend
	                            chart[marginNames[side]] = Math.max(
	                                chart[marginNames[side]],
	                                (
	                                    chart.legend[
	                                        (side + 1) % 2 ? 'legendHeight' : 'legendWidth'
	                                    ] + [1, -1, -1, 1][side] * options[
	                                        (side % 2) ? 'x' : 'y'
	                                    ] +
	                                    pick(options.margin, 12) +
	                                    spacing[side]
	                                )
	                            );
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Render the legend. This method can be called both before and after
	             * `chart.render`. If called after, it will only rearrange items instead
	             * of creating new ones. Called internally on initial render and after
	             * redraws.
	             */
	            render: function() {
	                var legend = this,
	                    chart = legend.chart,
	                    renderer = chart.renderer,
	                    legendGroup = legend.group,
	                    allItems,
	                    display,
	                    legendWidth,
	                    legendHeight,
	                    box = legend.box,
	                    options = legend.options,
	                    padding = legend.padding;
	
	                legend.itemX = padding;
	                legend.itemY = legend.initialItemY;
	                legend.offsetWidth = 0;
	                legend.lastItemY = 0;
	
	                if (!legendGroup) {
	                    legend.group = legendGroup = renderer.g('legend')
	                        .attr({
	                            zIndex: 7
	                        })
	                        .add();
	                    legend.contentGroup = renderer.g()
	                        .attr({
	                            zIndex: 1
	                        }) // above background
	                        .add(legendGroup);
	                    legend.scrollGroup = renderer.g()
	                        .add(legend.contentGroup);
	                }
	
	                legend.renderTitle();
	
	                // add each series or point
	                allItems = legend.getAllItems();
	
	                // sort by legendIndex
	                stableSort(allItems, function(a, b) {
	                    return ((a.options && a.options.legendIndex) || 0) -
	                        ((b.options && b.options.legendIndex) || 0);
	                });
	
	                // reversed legend
	                if (options.reversed) {
	                    allItems.reverse();
	                }
	
	                legend.allItems = allItems;
	                legend.display = display = !!allItems.length;
	
	                // render the items
	                legend.lastLineHeight = 0;
	                each(allItems, function(item) {
	                    legend.renderItem(item);
	                });
	
	                // Get the box
	                legendWidth = (options.width || legend.offsetWidth) + padding;
	                legendHeight = legend.lastItemY + legend.lastLineHeight +
	                    legend.titleHeight;
	                legendHeight = legend.handleOverflow(legendHeight);
	                legendHeight += padding;
	
	                // Draw the border and/or background
	                if (!box) {
	                    legend.box = box = renderer.rect()
	                        .addClass('highcharts-legend-box')
	                        .attr({
	                            r: options.borderRadius
	                        })
	                        .add(legendGroup);
	                    box.isNew = true;
	                }
	
	
	                // Presentational
	                box
	                    .attr({
	                        stroke: options.borderColor,
	                        'stroke-width': options.borderWidth || 0,
	                        fill: options.backgroundColor || 'none'
	                    })
	                    .shadow(options.shadow);
	
	
	                if (legendWidth > 0 && legendHeight > 0) {
	                    box[box.isNew ? 'attr' : 'animate'](
	                        box.crisp({
	                            x: 0,
	                            y: 0,
	                            width: legendWidth,
	                            height: legendHeight
	                        }, box.strokeWidth())
	                    );
	                    box.isNew = false;
	                }
	
	                // hide the border if no items
	                box[display ? 'show' : 'hide']();
	
	
	
	                legend.legendWidth = legendWidth;
	                legend.legendHeight = legendHeight;
	
	                // Now that the legend width and height are established, put the items
	                // in the final position
	                each(allItems, function(item) {
	                    legend.positionItem(item);
	                });
	
	                // 1.x compatibility: positioning based on style
	                /*var props = ['left', 'right', 'top', 'bottom'],
	                	prop,
	                	i = 4;
	                while (i--) {
	                	prop = props[i];
	                	if (options.style[prop] && options.style[prop] !== 'auto') {
	                		options[i < 2 ? 'align' : 'verticalAlign'] = prop;
	                		options[i < 2 ? 'x' : 'y'] = 
	                			pInt(options.style[prop]) * (i % 2 ? -1 : 1);
	                	}
	                }*/
	
	                if (display) {
	                    legendGroup.align(merge(options, {
	                        width: legendWidth,
	                        height: legendHeight
	                    }), true, 'spacingBox');
	                }
	
	                if (!chart.isResizing) {
	                    this.positionCheckboxes();
	                }
	            },
	
	            /**
	             * Set up the overflow handling by adding navigation with up and down arrows
	             * below the legend.
	             *
	             * @private
	             */
	            handleOverflow: function(legendHeight) {
	                var legend = this,
	                    chart = this.chart,
	                    renderer = chart.renderer,
	                    options = this.options,
	                    optionsY = options.y,
	                    alignTop = options.verticalAlign === 'top',
	                    padding = this.padding,
	                    spaceHeight = chart.spacingBox.height +
	                    (alignTop ? -optionsY : optionsY) - padding,
	                    maxHeight = options.maxHeight,
	                    clipHeight,
	                    clipRect = this.clipRect,
	                    navOptions = options.navigation,
	                    animation = pick(navOptions.animation, true),
	                    arrowSize = navOptions.arrowSize || 12,
	                    nav = this.nav,
	                    pages = this.pages,
	                    lastY,
	                    allItems = this.allItems,
	                    clipToHeight = function(height) {
	                        if (typeof height === 'number') {
	                            clipRect.attr({
	                                height: height
	                            });
	                        } else if (clipRect) { // Reset (#5912)
	                            legend.clipRect = clipRect.destroy();
	                            legend.contentGroup.clip();
	                        }
	
	                        // useHTML
	                        if (legend.contentGroup.div) {
	                            legend.contentGroup.div.style.clip = height ?
	                                'rect(' + padding + 'px,9999px,' +
	                                (padding + height) + 'px,0)' :
	                                'auto';
	                        }
	                    };
	
	
	                // Adjust the height
	                if (
	                    options.layout === 'horizontal' &&
	                    options.verticalAlign !== 'middle' &&
	                    !options.floating
	                ) {
	                    spaceHeight /= 2;
	                }
	                if (maxHeight) {
	                    spaceHeight = Math.min(spaceHeight, maxHeight);
	                }
	
	                // Reset the legend height and adjust the clipping rectangle
	                pages.length = 0;
	                if (legendHeight > spaceHeight && navOptions.enabled !== false) {
	
	                    this.clipHeight = clipHeight =
	                        Math.max(spaceHeight - 20 - this.titleHeight - padding, 0);
	                    this.currentPage = pick(this.currentPage, 1);
	                    this.fullHeight = legendHeight;
	
	                    // Fill pages with Y positions so that the top of each a legend item
	                    // defines the scroll top for each page (#2098)
	                    each(allItems, function(item, i) {
	                        var y = item._legendItemPos[1],
	                            h = Math.round(item.legendItem.getBBox().height),
	                            len = pages.length;
	
	                        if (!len || (y - pages[len - 1] > clipHeight &&
	                                (lastY || y) !== pages[len - 1])) {
	                            pages.push(lastY || y);
	                            len++;
	                        }
	
	                        if (i === allItems.length - 1 &&
	                            y + h - pages[len - 1] > clipHeight) {
	                            pages.push(y);
	                        }
	                        if (y !== lastY) {
	                            lastY = y;
	                        }
	                    });
	
	                    // Only apply clipping if needed. Clipping causes blurred legend in
	                    // PDF export (#1787)
	                    if (!clipRect) {
	                        clipRect = legend.clipRect =
	                            renderer.clipRect(0, padding, 9999, 0);
	                        legend.contentGroup.clip(clipRect);
	                    }
	
	                    clipToHeight(clipHeight);
	
	                    // Add navigation elements
	                    if (!nav) {
	                        this.nav = nav = renderer.g()
	                            .attr({
	                                zIndex: 1
	                            })
	                            .add(this.group);
	
	                        this.up = renderer
	                            .symbol(
	                                'triangle',
	                                0,
	                                0,
	                                arrowSize,
	                                arrowSize
	                            )
	                            .on('click', function() {
	                                legend.scroll(-1, animation);
	                            })
	                            .add(nav);
	
	                        this.pager = renderer.text('', 15, 10)
	                            .addClass('highcharts-legend-navigation')
	
	                            .css(navOptions.style)
	
	                            .add(nav);
	
	                        this.down = renderer
	                            .symbol(
	                                'triangle-down',
	                                0,
	                                0,
	                                arrowSize,
	                                arrowSize
	                            )
	                            .on('click', function() {
	                                legend.scroll(1, animation);
	                            })
	                            .add(nav);
	                    }
	
	                    // Set initial position
	                    legend.scroll(0);
	
	                    legendHeight = spaceHeight;
	
	                    // Reset
	                } else if (nav) {
	                    clipToHeight();
	                    this.nav = nav.destroy(); // #6322
	                    this.scrollGroup.attr({
	                        translateY: 1
	                    });
	                    this.clipHeight = 0; // #1379
	                }
	
	                return legendHeight;
	            },
	
	            /**
	             * Scroll the legend by a number of pages.
	             * @param  {Number} scrollBy
	             *         The number of pages to scroll.
	             * @param  {AnimationOptions} animation
	             *         Whether and how to apply animation.
	             */
	            scroll: function(scrollBy, animation) {
	                var pages = this.pages,
	                    pageCount = pages.length,
	                    currentPage = this.currentPage + scrollBy,
	                    clipHeight = this.clipHeight,
	                    navOptions = this.options.navigation,
	                    pager = this.pager,
	                    padding = this.padding,
	                    scrollOffset;
	
	                // When resizing while looking at the last page
	                if (currentPage > pageCount) {
	                    currentPage = pageCount;
	                }
	
	                if (currentPage > 0) {
	
	                    if (animation !== undefined) {
	                        setAnimation(animation, this.chart);
	                    }
	
	                    this.nav.attr({
	                        translateX: padding,
	                        translateY: clipHeight + this.padding + 7 + this.titleHeight,
	                        visibility: 'visible'
	                    });
	                    this.up.attr({
	                        'class': currentPage === 1 ?
	                            'highcharts-legend-nav-inactive' : 'highcharts-legend-nav-active'
	                    });
	                    pager.attr({
	                        text: currentPage + '/' + pageCount
	                    });
	                    this.down.attr({
	                        'x': 18 + this.pager.getBBox().width, // adjust to text width
	                        'class': currentPage === pageCount ?
	                            'highcharts-legend-nav-inactive' : 'highcharts-legend-nav-active'
	                    });
	
	
	                    this.up
	                        .attr({
	                            fill: currentPage === 1 ?
	                                navOptions.inactiveColor : navOptions.activeColor
	                        })
	                        .css({
	                            cursor: currentPage === 1 ? 'default' : 'pointer'
	                        });
	                    this.down
	                        .attr({
	                            fill: currentPage === pageCount ?
	                                navOptions.inactiveColor : navOptions.activeColor
	                        })
	                        .css({
	                            cursor: currentPage === pageCount ? 'default' : 'pointer'
	                        });
	
	
	                    scrollOffset = -pages[currentPage - 1] + this.initialItemY;
	
	                    this.scrollGroup.animate({
	                        translateY: scrollOffset
	                    });
	
	                    this.currentPage = currentPage;
	                    this.positionCheckboxes(scrollOffset);
	                }
	
	            }
	
	        };
	
	        /*
	         * LegendSymbolMixin
	         */
	
	        H.LegendSymbolMixin = {
	
	            /**
	             * Get the series' symbol in the legend
	             *
	             * @param {Object} legend The legend object
	             * @param {Object} item The series (this) or point
	             */
	            drawRectangle: function(legend, item) {
	                var options = legend.options,
	                    symbolHeight = legend.symbolHeight,
	                    square = options.squareSymbol,
	                    symbolWidth = square ? symbolHeight : legend.symbolWidth;
	
	                item.legendSymbol = this.chart.renderer.rect(
	                        square ? (legend.symbolWidth - symbolHeight) / 2 : 0,
	                        legend.baseline - symbolHeight + 1, // #3988
	                        symbolWidth,
	                        symbolHeight,
	                        pick(legend.options.symbolRadius, symbolHeight / 2)
	                    )
	                    .addClass('highcharts-point')
	                    .attr({
	                        zIndex: 3
	                    }).add(item.legendGroup);
	
	            },
	
	            /**
	             * Get the series' symbol in the legend. This method should be overridable
	             * to create custom symbols through
	             * Highcharts.seriesTypes[type].prototype.drawLegendSymbols.
	             *
	             * @param {Object} legend The legend object
	             */
	            drawLineMarker: function(legend) {
	
	                var options = this.options,
	                    markerOptions = options.marker,
	                    radius,
	                    legendSymbol,
	                    symbolWidth = legend.symbolWidth,
	                    symbolHeight = legend.symbolHeight,
	                    generalRadius = symbolHeight / 2,
	                    renderer = this.chart.renderer,
	                    legendItemGroup = this.legendGroup,
	                    verticalCenter = legend.baseline -
	                    Math.round(legend.fontMetrics.b * 0.3),
	                    attr = {};
	
	                // Draw the line
	
	                attr = {
	                    'stroke-width': options.lineWidth || 0
	                };
	                if (options.dashStyle) {
	                    attr.dashstyle = options.dashStyle;
	                }
	
	
	                this.legendLine = renderer.path([
	                        'M',
	                        0,
	                        verticalCenter,
	                        'L',
	                        symbolWidth,
	                        verticalCenter
	                    ])
	                    .addClass('highcharts-graph')
	                    .attr(attr)
	                    .add(legendItemGroup);
	
	                // Draw the marker
	                if (markerOptions && markerOptions.enabled !== false) {
	
	                    // Do not allow the marker to be larger than the symbolHeight
	                    radius = Math.min(
	                        pick(markerOptions.radius, generalRadius),
	                        generalRadius
	                    );
	
	                    // Restrict symbol markers size
	                    if (this.symbol.indexOf('url') === 0) {
	                        markerOptions = merge(markerOptions, {
	                            width: symbolHeight,
	                            height: symbolHeight
	                        });
	                        radius = 0;
	                    }
	
	                    this.legendSymbol = legendSymbol = renderer.symbol(
	                            this.symbol,
	                            (symbolWidth / 2) - radius,
	                            verticalCenter - radius,
	                            2 * radius,
	                            2 * radius,
	                            markerOptions
	                        )
	                        .addClass('highcharts-point')
	                        .add(legendItemGroup);
	                    legendSymbol.isMarker = true;
	                }
	            }
	        };
	
	        // Workaround for #2030, horizontal legend items not displaying in IE11 Preview,
	        // and for #2580, a similar drawing flaw in Firefox 26.
	        // Explore if there's a general cause for this. The problem may be related
	        // to nested group elements, as the legend item texts are within 4 group
	        // elements.
	        if (/Trident\/7\.0/.test(win.navigator.userAgent) || isFirefox) {
	            wrap(Highcharts.Legend.prototype, 'positionItem', function(proceed, item) {
	                var legend = this,
	                    // If chart destroyed in sync, this is undefined (#2030)
	                    runPositionItem = function() {
	                        if (item._legendItemPos) {
	                            proceed.call(legend, item);
	                        }
	                    };
	
	                // Do it now, for export and to get checkbox placement
	                runPositionItem();
	
	                // Do it after to work around the core issue
	                setTimeout(runPositionItem);
	            });
	        }
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animate = H.animate,
	            animObject = H.animObject,
	            attr = H.attr,
	            doc = H.doc,
	            Axis = H.Axis, // @todo add as requirement
	            createElement = H.createElement,
	            defaultOptions = H.defaultOptions,
	            discardElement = H.discardElement,
	            charts = H.charts,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            find = H.find,
	            fireEvent = H.fireEvent,
	            getStyle = H.getStyle,
	            grep = H.grep,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            isString = H.isString,
	            Legend = H.Legend, // @todo add as requirement
	            marginNames = H.marginNames,
	            merge = H.merge,
	            objectEach = H.objectEach,
	            Pointer = H.Pointer, // @todo add as requirement
	            pick = H.pick,
	            pInt = H.pInt,
	            removeEvent = H.removeEvent,
	            seriesTypes = H.seriesTypes,
	            splat = H.splat,
	            svg = H.svg,
	            syncTimeout = H.syncTimeout,
	            win = H.win,
	            Renderer = H.Renderer;
	        /**
	         * The Chart class. The recommended constructor is {@link Highcharts#chart}.
	         * @class Highcharts.Chart
	         * @param  {String|HTMLDOMElement} renderTo
	         *         The DOM element to render to, or its id.
	         * @param  {Options} options
	         *         The chart options structure.
	         * @param  {Function} [callback]
	         *         Function to run when the chart has loaded and and all external images
	         *         are loaded. Defining a {@link
	         *         https://api.highcharts.com/highcharts/chart.events.load|chart.event.load}
	         *         handler is equivalent.
	         *
	         * @example
	         * var chart = Highcharts.chart('container', {
	         * 	   title: {
	         * 	   	   text: 'My chart'
	         * 	   },
	         * 	   series: [{
	         * 	       data: [1, 3, 2, 4]
	         * 	   }]
	         * })
	         */
	        var Chart = H.Chart = function() {
	            this.getArgs.apply(this, arguments);
	        };
	
	        /**
	         * Factory function for basic charts. 
	         *
	         * @function #chart
	         * @memberOf Highcharts
	         * @param  {String|HTMLDOMElement} renderTo - The DOM element to render to, or
	         * its id.
	         * @param  {Options} options - The chart options structure.
	         * @param  {Function} [callback] - Function to run when the chart has loaded and
	         * and all external images are loaded. Defining a {@link
	         * https://api.highcharts.com/highcharts/chart.events.load|chart.event.load}
	         * handler is equivalent.
	         * @return {Highcharts.Chart} - Returns the Chart object.
	         *
	         * @example
	         * // Render a chart in to div#container
	         * var chart = Highcharts.chart('container', {
	         *     title: {
	         *         text: 'My chart'
	         *     },
	         *     series: [{
	         *         data: [1, 3, 2, 4]
	         *     }]
	         * });
	         */
	        H.chart = function(a, b, c) {
	            return new Chart(a, b, c);
	        };
	
	        extend(Chart.prototype, /** @lends Highcharts.Chart.prototype */ {
	
	            // Hook for adding callbacks in modules
	            callbacks: [],
	
	            /**
	             * Handle the arguments passed to the constructor.
	             *
	             * @private
	             * @returns {Array} Arguments without renderTo
	             */
	            getArgs: function() {
	                var args = [].slice.call(arguments);
	
	                // Remove the optional first argument, renderTo, and
	                // set it on this.
	                if (isString(args[0]) || args[0].nodeName) {
	                    this.renderTo = args.shift();
	                }
	                this.init(args[0], args[1]);
	            },
	
	            /**
	             * Overridable function that initializes the chart. The constructor's
	             * arguments are passed on directly.
	             */
	            init: function(userOptions, callback) {
	
	                // Handle regular options
	                var options,
	                    type,
	                    seriesOptions = userOptions.series, // skip merging data points to increase performance
	                    userPlotOptions = userOptions.plotOptions || {};
	
	                userOptions.series = null;
	                options = merge(defaultOptions, userOptions); // do the merge
	
	                // Override (by copy of user options) or clear tooltip options
	                // in chart.options.plotOptions (#6218)
	                for (type in options.plotOptions) {
	                    options.plotOptions[type].tooltip = (
	                        userPlotOptions[type] &&
	                        merge(userPlotOptions[type].tooltip) // override by copy
	                    ) || undefined; // or clear
	                }
	                // User options have higher priority than default options (#6218).
	                // In case of exporting: path is changed
	                options.tooltip.userOptions = (userOptions.chart &&
	                        userOptions.chart.forExport && userOptions.tooltip.userOptions) ||
	                    userOptions.tooltip;
	
	                options.series = userOptions.series = seriesOptions; // set back the series data
	                this.userOptions = userOptions;
	
	                var optionsChart = options.chart;
	
	                var chartEvents = optionsChart.events;
	
	                this.margin = [];
	                this.spacing = [];
	
	                //this.runChartClick = chartEvents && !!chartEvents.click;
	                this.bounds = {
	                    h: {},
	                    v: {}
	                }; // Pixel data bounds for touch zoom
	
	                this.callback = callback;
	                this.isResizing = 0;
	
	                /**
	                 * The options structure for the chart. It contains members for the sub
	                 * elements like series, legend, tooltip etc.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name options
	                 * @type {Options}
	                 */
	                this.options = options;
	                /**
	                 * All the axes in the chart.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name axes
	                 * @see  Highcharts.Chart.xAxis
	                 * @see  Highcharts.Chart.yAxis
	                 * @type {Array.<Highcharts.Axis>}
	                 */
	                this.axes = [];
	
	                /**
	                 * All the current series in the chart.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name series
	                 * @type {Array.<Highcharts.Series>}
	                 */
	                this.series = [];
	
	                /**
	                 * The chart title. The title has an `update` method that allows
	                 * modifying the options directly or indirectly via `chart.update`.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name title
	                 * @type Object
	                 *
	                 * @sample highcharts/members/title-update/
	                 *         Updating titles
	                 */
	
	                /**
	                 * The chart subtitle. The subtitle has an `update` method that allows
	                 * modifying the options directly or indirectly via `chart.update`.
	                 *
	                 * @memberof Highcharts.Chart
	                 * @name subtitle
	                 * @type Object
	                 */
	
	
	
	                this.hasCartesianSeries = optionsChart.showAxes;
	                //this.axisOffset = undefined;
	                //this.inverted = undefined;
	                //this.loadingShown = undefined;
	                //this.container = undefined;
	                //this.chartWidth = undefined;
	                //this.chartHeight = undefined;
	                //this.marginRight = undefined;
	                //this.marginBottom = undefined;
	                //this.containerWidth = undefined;
	                //this.containerHeight = undefined;
	                //this.oldChartWidth = undefined;
	                //this.oldChartHeight = undefined;
	
	                //this.renderTo = undefined;
	
	                //this.spacingBox = undefined
	
	                //this.legend = undefined;
	
	                // Elements
	                //this.chartBackground = undefined;
	                //this.plotBackground = undefined;
	                //this.plotBGImage = undefined;
	                //this.plotBorder = undefined;
	                //this.loadingDiv = undefined;
	                //this.loadingSpan = undefined;
	
	                var chart = this;
	
	                // Add the chart to the global lookup
	                chart.index = charts.length;
	
	                charts.push(chart);
	                H.chartCount++;
	
	                // Chart event handlers
	                if (chartEvents) {
	                    objectEach(chartEvents, function(event, eventType) {
	                        addEvent(chart, eventType, event);
	                    });
	                }
	
	                /**
	                 * A collection of the X axes in the chart.
	                 * @type {Array.<Highcharts.Axis>}
	                 * @name xAxis
	                 * @memberOf Highcharts.Chart
	                 */
	                chart.xAxis = [];
	                /**
	                 * A collection of the Y axes in the chart.
	                 * @type {Array.<Highcharts.Axis>}
	                 * @name yAxis
	                 * @memberOf Highcharts.Chart
	                 */
	                chart.yAxis = [];
	
	                chart.pointCount = chart.colorCounter = chart.symbolCounter = 0;
	
	                chart.firstRender();
	            },
	
	            /**
	             * Internal function to unitialize an individual series.
	             *
	             * @private
	             */
	            initSeries: function(options) {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    type = options.type || optionsChart.type || optionsChart.defaultSeriesType,
	                    series,
	                    Constr = seriesTypes[type];
	
	                // No such series type
	                if (!Constr) {
	                    H.error(17, true);
	                }
	
	                series = new Constr();
	                series.init(this, options);
	                return series;
	            },
	
	            /**
	             * Order all series above a given index. When series are added and ordered
	             * by configuration, only the last series is handled (#248, #1123, #2456,
	             * #6112). This function is called on series initialization and destroy.
	             *
	             * @private
	             *
	             * @param  {number} fromIndex
	             *         If this is given, only the series above this index are handled.
	             */
	            orderSeries: function(fromIndex) {
	                var series = this.series,
	                    i = fromIndex || 0;
	                for (; i < series.length; i++) {
	                    if (series[i]) {
	                        series[i].index = i;
	                        series[i].name = series[i].name ||
	                            'Series ' + (series[i].index + 1);
	                    }
	                }
	            },
	
	            /**
	             * Check whether a given point is within the plot area.
	             *
	             * @param  {Number} plotX
	             *         Pixel x relative to the plot area.
	             * @param  {Number} plotY
	             *         Pixel y relative to the plot area.
	             * @param  {Boolean} inverted
	             *         Whether the chart is inverted.
	             *
	             * @return {Boolean}
	             *         Returns true if the given point is inside the plot area.
	             */
	            isInsidePlot: function(plotX, plotY, inverted) {
	                var x = inverted ? plotY : plotX,
	                    y = inverted ? plotX : plotY;
	
	                return x >= 0 &&
	                    x <= this.plotWidth &&
	                    y >= 0 &&
	                    y <= this.plotHeight;
	            },
	
	            /**
	             * Redraw the chart after changes have been done to the data, axis extremes
	             * chart size or chart elements. All methods for updating axes, series or
	             * points have a parameter for redrawing the chart. This is `true` by
	             * default. But in many cases you want to do more than one operation on the
	             * chart before redrawing, for example add a number of points. In those
	             * cases it is a waste of resources to redraw the chart for each new point
	             * added. So you add the points and call `chart.redraw()` after.
	             *
	             * @param  {AnimationOptions} animation
	             *         If or how to apply animation to the redraw.
	             */
	            redraw: function(animation) {
	                var chart = this,
	                    axes = chart.axes,
	                    series = chart.series,
	                    pointer = chart.pointer,
	                    legend = chart.legend,
	                    redrawLegend = chart.isDirtyLegend,
	                    hasStackedSeries,
	                    hasDirtyStacks,
	                    hasCartesianSeries = chart.hasCartesianSeries,
	                    isDirtyBox = chart.isDirtyBox,
	                    i,
	                    serie,
	                    renderer = chart.renderer,
	                    isHiddenChart = renderer.isHidden(),
	                    afterRedraw = [];
	
	                // Handle responsive rules, not only on resize (#6130)
	                if (chart.setResponsive) {
	                    chart.setResponsive(false);
	                }
	
	                H.setAnimation(animation, chart);
	
	                if (isHiddenChart) {
	                    chart.temporaryDisplay();
	                }
	
	                // Adjust title layout (reflow multiline text)
	                chart.layOutTitles();
	
	                // link stacked series
	                i = series.length;
	                while (i--) {
	                    serie = series[i];
	
	                    if (serie.options.stacking) {
	                        hasStackedSeries = true;
	
	                        if (serie.isDirty) {
	                            hasDirtyStacks = true;
	                            break;
	                        }
	                    }
	                }
	                if (hasDirtyStacks) { // mark others as dirty
	                    i = series.length;
	                    while (i--) {
	                        serie = series[i];
	                        if (serie.options.stacking) {
	                            serie.isDirty = true;
	                        }
	                    }
	                }
	
	                // Handle updated data in the series
	                each(series, function(serie) {
	                    if (serie.isDirty) {
	                        if (serie.options.legendType === 'point') {
	                            if (serie.updateTotals) {
	                                serie.updateTotals();
	                            }
	                            redrawLegend = true;
	                        }
	                    }
	                    if (serie.isDirtyData) {
	                        fireEvent(serie, 'updatedData');
	                    }
	                });
	
	                // handle added or removed series
	                if (redrawLegend && legend.options.enabled) { // series or pie points are added or removed
	                    // draw legend graphics
	                    legend.render();
	
	                    chart.isDirtyLegend = false;
	                }
	
	                // reset stacks
	                if (hasStackedSeries) {
	                    chart.getStacks();
	                }
	
	
	                if (hasCartesianSeries) {
	                    // set axes scales
	                    each(axes, function(axis) {
	                        axis.updateNames();
	                        axis.setScale();
	                    });
	                }
	
	                chart.getMargins(); // #3098
	
	                if (hasCartesianSeries) {
	                    // If one axis is dirty, all axes must be redrawn (#792, #2169)
	                    each(axes, function(axis) {
	                        if (axis.isDirty) {
	                            isDirtyBox = true;
	                        }
	                    });
	
	                    // redraw axes
	                    each(axes, function(axis) {
	
	                        // Fire 'afterSetExtremes' only if extremes are set
	                        var key = axis.min + ',' + axis.max;
	                        if (axis.extKey !== key) { // #821, #4452
	                            axis.extKey = key;
	                            afterRedraw.push(function() { // prevent a recursive call to chart.redraw() (#1119)
	                                fireEvent(axis, 'afterSetExtremes', extend(axis.eventArgs, axis.getExtremes())); // #747, #751
	                                delete axis.eventArgs;
	                            });
	                        }
	                        if (isDirtyBox || hasStackedSeries) {
	                            axis.redraw();
	                        }
	                    });
	                }
	
	                // the plot areas size has changed
	                if (isDirtyBox) {
	                    chart.drawChartBox();
	                }
	
	                // Fire an event before redrawing series, used by the boost module to
	                // clear previous series renderings.
	                fireEvent(chart, 'predraw');
	
	                // redraw affected series
	                each(series, function(serie) {
	                    if ((isDirtyBox || serie.isDirty) && serie.visible) {
	                        serie.redraw();
	                    }
	                    // Set it here, otherwise we will have unlimited 'updatedData' calls
	                    // for a hidden series after setData(). Fixes #6012
	                    serie.isDirtyData = false;
	                });
	
	                // move tooltip or reset
	                if (pointer) {
	                    pointer.reset(true);
	                }
	
	                // redraw if canvas
	                renderer.draw();
	
	                // Fire the events
	                fireEvent(chart, 'redraw');
	                fireEvent(chart, 'render');
	
	                if (isHiddenChart) {
	                    chart.temporaryDisplay(true);
	                }
	
	                // Fire callbacks that are put on hold until after the redraw
	                each(afterRedraw, function(callback) {
	                    callback.call();
	                });
	            },
	
	            /**
	             * Get an axis, series or point object by `id` as given in the configuration
	             * options. Returns `undefined` if no item is found.
	             * @param id {String} The id as given in the configuration options.
	             * @return {Highcharts.Axis|Highcharts.Series|Highcharts.Point|undefined}
	             *         The retrieved item.
	             * @sample highcharts/plotoptions/series-id/
	             *         Get series by id
	             */
	            get: function(id) {
	
	                var ret,
	                    series = this.series,
	                    i;
	
	                function itemById(item) {
	                    return item.id === id || (item.options && item.options.id === id);
	                }
	
	                ret =
	                    // Search axes
	                    find(this.axes, itemById) ||
	
	                    // Search series
	                    find(this.series, itemById);
	
	                // Search points
	                for (i = 0; !ret && i < series.length; i++) {
	                    ret = find(series[i].points || [], itemById);
	                }
	
	                return ret;
	            },
	
	            /**
	             * Create the Axis instances based on the config options.
	             *
	             * @private
	             */
	            getAxes: function() {
	                var chart = this,
	                    options = this.options,
	                    xAxisOptions = options.xAxis = splat(options.xAxis || {}),
	                    yAxisOptions = options.yAxis = splat(options.yAxis || {}),
	                    optionsArray;
	
	                // make sure the options are arrays and add some members
	                each(xAxisOptions, function(axis, i) {
	                    axis.index = i;
	                    axis.isX = true;
	                });
	
	                each(yAxisOptions, function(axis, i) {
	                    axis.index = i;
	                });
	
	                // concatenate all axis options into one array
	                optionsArray = xAxisOptions.concat(yAxisOptions);
	
	                each(optionsArray, function(axisOptions) {
	                    new Axis(chart, axisOptions); // eslint-disable-line no-new
	                });
	            },
	
	
	            /**
	             * Returns an array of all currently selected points in the chart. Points
	             * can be selected by clicking or programmatically by the {@link
	             * Highcharts.Point#select} function.
	             *
	             * @return {Array.<Highcharts.Point>}
	             *         The currently selected points.
	             *
	             * @sample highcharts/plotoptions/series-allowpointselect-line/
	             *         Get selected points
	             */
	            getSelectedPoints: function() {
	                var points = [];
	                each(this.series, function(serie) {
	                    // series.data - for points outside of viewed range (#6445)
	                    points = points.concat(grep(serie.data || [], function(point) {
	                        return point.selected;
	                    }));
	                });
	                return points;
	            },
	
	            /**
	             * Returns an array of all currently selected series in the chart. Series
	             * can be selected either programmatically by the {@link
	             * Highcharts.Series#select} function or by checking the checkbox next to
	             * the legend item if {@link
	             * https://api.highcharts.com/highcharts/plotOptions.series.showCheckbox|
	             * series.showCheckBox} is true.
	             * 
	             * @return {Array.<Highcharts.Series>}
	             *         The currently selected series.
	             *
	             * @sample highcharts/members/chart-getselectedseries/
	             *         Get selected series
	             */
	            getSelectedSeries: function() {
	                return grep(this.series, function(serie) {
	                    return serie.selected;
	                });
	            },
	
	            /**
	             * Set a new title or subtitle for the chart.
	             *
	             * @param  titleOptions {TitleOptions}
	             *         New title options. The title text itself is set by the
	             *         `titleOptions.text` property.
	             * @param  subtitleOptions {SubtitleOptions}
	             *         New subtitle options. The subtitle text itself is set by the
	             *         `subtitleOptions.text` property.
	             * @param  redraw {Boolean}
	             *         Whether to redraw the chart or wait for a later call to 
	             *         `chart.redraw()`.
	             *
	             * @sample highcharts/members/chart-settitle/ Set title text and styles
	             *
	             */
	            setTitle: function(titleOptions, subtitleOptions, redraw) {
	                var chart = this,
	                    options = chart.options,
	                    chartTitleOptions,
	                    chartSubtitleOptions;
	
	                chartTitleOptions = options.title = merge(
	
	                    // Default styles
	                    {
	                        style: {
	                            color: '#333333',
	                            fontSize: options.isStock ? '16px' : '18px' // #2944
	                        }
	                    },
	
	                    options.title,
	                    titleOptions
	                );
	                chartSubtitleOptions = options.subtitle = merge(
	
	                    // Default styles
	                    {
	                        style: {
	                            color: '#666666'
	                        }
	                    },
	
	                    options.subtitle,
	                    subtitleOptions
	                );
	
	                // add title and subtitle
	                each([
	                    ['title', titleOptions, chartTitleOptions],
	                    ['subtitle', subtitleOptions, chartSubtitleOptions]
	                ], function(arr, i) {
	                    var name = arr[0],
	                        title = chart[name],
	                        titleOptions = arr[1],
	                        chartTitleOptions = arr[2];
	
	                    if (title && titleOptions) {
	                        chart[name] = title = title.destroy(); // remove old
	                    }
	
	                    if (chartTitleOptions && chartTitleOptions.text && !title) {
	                        chart[name] = chart.renderer.text(
	                                chartTitleOptions.text,
	                                0,
	                                0,
	                                chartTitleOptions.useHTML
	                            )
	                            .attr({
	                                align: chartTitleOptions.align,
	                                'class': 'highcharts-' + name,
	                                zIndex: chartTitleOptions.zIndex || 4
	                            })
	                            .add();
	
	                        // Update methods, shortcut to Chart.setTitle
	                        chart[name].update = function(o) {
	                            chart.setTitle(!i && o, i && o);
	                        };
	
	
	                        // Presentational
	                        chart[name].css(chartTitleOptions.style);
	
	
	                    }
	                });
	                chart.layOutTitles(redraw);
	            },
	
	            /**
	             * Internal function to lay out the chart titles and cache the full offset
	             * height for use in `getMargins`. The result is stored in 
	             * `this.titleOffset`.
	             *
	             * @private
	             */
	            layOutTitles: function(redraw) {
	                var titleOffset = 0,
	                    requiresDirtyBox,
	                    renderer = this.renderer,
	                    spacingBox = this.spacingBox;
	
	                // Lay out the title and the subtitle respectively
	                each(['title', 'subtitle'], function(key) {
	                    var title = this[key],
	                        titleOptions = this.options[key],
	                        offset = key === 'title' ? -3 :
	                        // Floating subtitle (#6574)
	                        titleOptions.verticalAlign ? 0 : titleOffset + 2,
	                        titleSize;
	
	                    if (title) {
	
	                        titleSize = titleOptions.style.fontSize;
	
	                        titleSize = renderer.fontMetrics(titleSize, title).b;
	
	                        title
	                            .css({
	                                width: (titleOptions.width ||
	                                    spacingBox.width + titleOptions.widthAdjust) + 'px'
	                            })
	                            .align(extend({
	                                y: offset + titleSize
	                            }, titleOptions), false, 'spacingBox');
	
	                        if (!titleOptions.floating && !titleOptions.verticalAlign) {
	                            titleOffset = Math.ceil(
	                                titleOffset +
	                                // Skip the cache for HTML (#3481)
	                                title.getBBox(titleOptions.useHTML).height
	                            );
	                        }
	                    }
	                }, this);
	
	                requiresDirtyBox = this.titleOffset !== titleOffset;
	                this.titleOffset = titleOffset; // used in getMargins
	
	                if (!this.isDirtyBox && requiresDirtyBox) {
	                    this.isDirtyBox = requiresDirtyBox;
	                    // Redraw if necessary (#2719, #2744)
	                    if (this.hasRendered && pick(redraw, true) && this.isDirtyBox) {
	                        this.redraw();
	                    }
	                }
	            },
	
	            /**
	             * Internal function to get the chart width and height according to options
	             * and container size. Sets {@link Chart.chartWidth} and {@link
	             * Chart.chartHeight}.
	             */
	            getChartSize: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    widthOption = optionsChart.width,
	                    heightOption = optionsChart.height,
	                    renderTo = chart.renderTo;
	
	                // Get inner width and height
	                if (!defined(widthOption)) {
	                    chart.containerWidth = getStyle(renderTo, 'width');
	                }
	                if (!defined(heightOption)) {
	                    chart.containerHeight = getStyle(renderTo, 'height');
	                }
	
	                /**
	                 * The current pixel width of the chart.
	                 *
	                 * @name chartWidth
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.chartWidth = Math.max( // #1393
	                    0,
	                    widthOption || chart.containerWidth || 600 // #1460
	                );
	                /**
	                 * The current pixel height of the chart.
	                 *
	                 * @name chartHeight
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.chartHeight = Math.max(
	                    0,
	                    H.relativeLength(
	                        heightOption,
	                        chart.chartWidth
	                    ) || chart.containerHeight || 400
	                );
	            },
	
	            /**
	             * If the renderTo element has no offsetWidth, most likely one or more of
	             * its parents are hidden. Loop up the DOM tree to temporarily display the
	             * parents, then save the original display properties, and when the true
	             * size is retrieved, reset them. Used on first render and on redraws.
	             *
	             * @private
	             * 
	             * @param  {Boolean} revert
	             *         Revert to the saved original styles.
	             */
	            temporaryDisplay: function(revert) {
	                var node = this.renderTo,
	                    tempStyle;
	                if (!revert) {
	                    while (node && node.style) {
	
	                        // When rendering to a detached node, it needs to be temporarily
	                        // attached in order to read styling and bounding boxes (#5783).
	                        if (!doc.body.contains(node)) {
	                            node.hcOrigDetached = true;
	                            doc.body.appendChild(node);
	                        }
	                        if (
	                            getStyle(node, 'display', false) === 'none' ||
	                            node.hcOricDetached
	                        ) {
	                            node.hcOrigStyle = {
	                                display: node.style.display,
	                                height: node.style.height,
	                                overflow: node.style.overflow
	                            };
	                            tempStyle = {
	                                display: 'block',
	                                overflow: 'hidden'
	                            };
	                            if (node !== this.renderTo) {
	                                tempStyle.height = 0;
	                            }
	
	                            H.css(node, tempStyle);
	
	                            // If it still doesn't have an offset width after setting
	                            // display to block, it probably has an !important priority
	                            // #2631, 6803
	                            if (!node.offsetWidth) {
	                                node.style.setProperty('display', 'block', 'important');
	                            }
	                        }
	                        node = node.parentNode;
	
	                        if (node === doc.body) {
	                            break;
	                        }
	                    }
	                } else {
	                    while (node && node.style) {
	                        if (node.hcOrigStyle) {
	                            H.css(node, node.hcOrigStyle);
	                            delete node.hcOrigStyle;
	                        }
	                        if (node.hcOrigDetached) {
	                            doc.body.removeChild(node);
	                            node.hcOrigDetached = false;
	                        }
	                        node = node.parentNode;
	                    }
	                }
	            },
	
	            /**
	             * Set the {@link Chart.container|chart container's} class name, in
	             * addition to `highcharts-container`. 
	             */
	            setClassName: function(className) {
	                this.container.className = 'highcharts-container ' + (className || '');
	            },
	
	            /**
	             * Get the containing element, determine the size and create the inner
	             * container div to hold the chart.
	             *
	             * @private
	             */
	            getContainer: function() {
	                var chart = this,
	                    container,
	                    options = chart.options,
	                    optionsChart = options.chart,
	                    chartWidth,
	                    chartHeight,
	                    renderTo = chart.renderTo,
	                    indexAttrName = 'data-highcharts-chart',
	                    oldChartIndex,
	                    Ren,
	                    containerId = H.uniqueKey(),
	                    containerStyle,
	                    key;
	
	                if (!renderTo) {
	                    chart.renderTo = renderTo = optionsChart.renderTo;
	                }
	
	                if (isString(renderTo)) {
	                    chart.renderTo = renderTo = doc.getElementById(renderTo);
	                }
	
	                // Display an error if the renderTo is wrong
	                if (!renderTo) {
	                    H.error(13, true);
	                }
	
	                // If the container already holds a chart, destroy it. The check for
	                // hasRendered is there because web pages that are saved to disk from
	                // the browser, will preserve the data-highcharts-chart attribute and
	                // the SVG contents, but not an interactive chart. So in this case,
	                // charts[oldChartIndex] will point to the wrong chart if any (#2609).
	                oldChartIndex = pInt(attr(renderTo, indexAttrName));
	                if (
	                    isNumber(oldChartIndex) &&
	                    charts[oldChartIndex] &&
	                    charts[oldChartIndex].hasRendered
	                ) {
	                    charts[oldChartIndex].destroy();
	                }
	
	                // Make a reference to the chart from the div
	                attr(renderTo, indexAttrName, chart.index);
	
	                // remove previous chart
	                renderTo.innerHTML = '';
	
	                // If the container doesn't have an offsetWidth, it has or is a child of
	                // a node that has display:none. We need to temporarily move it out to a
	                // visible state to determine the size, else the legend and tooltips
	                // won't render properly. The skipClone option is used in sparklines as
	                // a micro optimization, saving about 1-2 ms each chart.
	                if (!optionsChart.skipClone && !renderTo.offsetWidth) {
	                    chart.temporaryDisplay();
	                }
	
	                // get the width and height
	                chart.getChartSize();
	                chartWidth = chart.chartWidth;
	                chartHeight = chart.chartHeight;
	
	                // Create the inner container
	
	                containerStyle = extend({
	                    position: 'relative',
	                    overflow: 'hidden', // needed for context menu (avoid scrollbars)
	                    // and content overflow in IE
	                    width: chartWidth + 'px',
	                    height: chartHeight + 'px',
	                    textAlign: 'left',
	                    lineHeight: 'normal', // #427
	                    zIndex: 0, // #1072
	                    '-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
	                }, optionsChart.style);
	
	
	                /**
	                 * The containing HTML element of the chart. The container is
	                 * dynamically inserted into the element given as the `renderTo`
	                 * parameterin the {@link Highcharts#chart} constructor.
	                 *
	                 * @memberOf Highcharts.Chart
	                 * @type {HTMLDOMElement}
	                 */
	                container = createElement(
	                    'div', {
	                        id: containerId
	                    },
	                    containerStyle,
	                    renderTo
	                );
	                chart.container = container;
	
	                // cache the cursor (#1650)
	                chart._cursor = container.style.cursor;
	
	                // Initialize the renderer
	                Ren = H[optionsChart.renderer] || Renderer;
	                /**
	                 * The renderer instance of the chart. Each chart instance has only one
	                 * associated renderer.
	                 * @type {SVGRenderer}
	                 * @name renderer
	                 * @memberOf Chart
	                 */
	                chart.renderer = new Ren(
	                    container,
	                    chartWidth,
	                    chartHeight,
	                    null,
	                    optionsChart.forExport,
	                    options.exporting && options.exporting.allowHTML
	                );
	
	
	                chart.setClassName(optionsChart.className);
	
	                chart.renderer.setStyle(optionsChart.style);
	
	
	                // Add a reference to the charts index
	                chart.renderer.chartIndex = chart.index;
	            },
	
	            /**
	             * Calculate margins by rendering axis labels in a preliminary position.
	             * Title, subtitle and legend have already been rendered at this stage, but
	             * will be moved into their final positions.
	             *
	             * @private
	             */
	            getMargins: function(skipAxes) {
	                var chart = this,
	                    spacing = chart.spacing,
	                    margin = chart.margin,
	                    titleOffset = chart.titleOffset;
	
	                chart.resetMargins();
	
	                // Adjust for title and subtitle
	                if (titleOffset && !defined(margin[0])) {
	                    chart.plotTop = Math.max(
	                        chart.plotTop,
	                        titleOffset + chart.options.title.margin + spacing[0]
	                    );
	                }
	
	                // Adjust for legend
	                if (chart.legend.display) {
	                    chart.legend.adjustMargins(margin, spacing);
	                }
	
	                // adjust for scroller
	                if (chart.extraMargin) {
	                    chart[chart.extraMargin.type] =
	                        (chart[chart.extraMargin.type] || 0) + chart.extraMargin.value;
	                }
	                if (chart.extraTopMargin) {
	                    chart.plotTop += chart.extraTopMargin;
	                }
	                if (!skipAxes) {
	                    this.getAxisMargins();
	                }
	            },
	
	            getAxisMargins: function() {
	
	                var chart = this,
	                    // [top, right, bottom, left]
	                    axisOffset = chart.axisOffset = [0, 0, 0, 0],
	                    margin = chart.margin;
	
	                // pre-render axes to get labels offset width
	                if (chart.hasCartesianSeries) {
	                    each(chart.axes, function(axis) {
	                        if (axis.visible) {
	                            axis.getOffset();
	                        }
	                    });
	                }
	
	                // Add the axis offsets
	                each(marginNames, function(m, side) {
	                    if (!defined(margin[side])) {
	                        chart[m] += axisOffset[side];
	                    }
	                });
	
	                chart.setChartSize();
	
	            },
	
	            /**
	             * Reflows the chart to its container. By default, the chart reflows
	             * automatically to its container following a `window.resize` event, as per
	             * the {@link https://api.highcharts/highcharts/chart.reflow|chart.reflow}
	             * option. However, there are no reliable events for div resize, so if the
	             * container is resized without a window resize event, this must be called
	             * explicitly.
	             *
	             * @param  {Object} e
	             *         Event arguments. Used primarily when the function is called
	             *         internally as a response to window resize.
	             *
	             * @sample highcharts/members/chart-reflow/
	             *         Resize div and reflow
	             * @sample highcharts/chart/events-container/
	             *         Pop up and reflow
	             */
	            reflow: function(e) {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    renderTo = chart.renderTo,
	                    hasUserSize = (
	                        defined(optionsChart.width) &&
	                        defined(optionsChart.height)
	                    ),
	                    width = optionsChart.width || getStyle(renderTo, 'width'),
	                    height = optionsChart.height || getStyle(renderTo, 'height'),
	                    target = e ? e.target : win;
	
	                // Width and height checks for display:none. Target is doc in IE8 and
	                // Opera, win in Firefox, Chrome and IE9.
	                if (!hasUserSize &&
	                    !chart.isPrinting &&
	                    width &&
	                    height &&
	                    (target === win || target === doc)
	                ) {
	                    if (
	                        width !== chart.containerWidth ||
	                        height !== chart.containerHeight
	                    ) {
	                        clearTimeout(chart.reflowTimeout);
	                        // When called from window.resize, e is set, else it's called
	                        // directly (#2224)
	                        chart.reflowTimeout = syncTimeout(function() {
	                            // Set size, it may have been destroyed in the meantime
	                            // (#1257)
	                            if (chart.container) {
	                                chart.setSize(undefined, undefined, false);
	                            }
	                        }, e ? 100 : 0);
	                    }
	                    chart.containerWidth = width;
	                    chart.containerHeight = height;
	                }
	            },
	
	            /**
	             * Add the event handlers necessary for auto resizing, depending on the 
	             * `chart.events.reflow` option.
	             *
	             * @private
	             */
	            initReflow: function() {
	                var chart = this,
	                    unbind;
	
	                unbind = addEvent(win, 'resize', function(e) {
	                    chart.reflow(e);
	                });
	                addEvent(chart, 'destroy', unbind);
	
	                // The following will add listeners to re-fit the chart before and after
	                // printing (#2284). However it only works in WebKit. Should have worked
	                // in Firefox, but not supported in IE.
	                /*
	                if (win.matchMedia) {
	                	win.matchMedia('print').addListener(function reflow() {
	                		chart.reflow();
	                	});
	                }
	                */
	            },
	
	            /**
	             * Resize the chart to a given width and height. In order to set the width
	             * only, the height argument may be skipped. To set the height only, pass
	             * `undefined for the width.
	             * @param  {Number|undefined|null} [width]
	             *         The new pixel width of the chart. Since v4.2.6, the argument can
	             *         be `undefined` in order to preserve the current value (when
	             *         setting height only), or `null` to adapt to the width of the
	             *         containing element.
	             * @param  {Number|undefined|null} [height]
	             *         The new pixel height of the chart. Since v4.2.6, the argument can
	             *         be `undefined` in order to preserve the current value, or `null`
	             *         in order to adapt to the height of the containing element.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether and how to apply animation.
	             *
	             * @sample highcharts/members/chart-setsize-button/
	             *         Test resizing from buttons
	             * @sample highcharts/members/chart-setsize-jquery-resizable/
	             *         Add a jQuery UI resizable
	             * @sample stock/members/chart-setsize/
	             *         Highstock with UI resizable
	             */
	            setSize: function(width, height, animation) {
	                var chart = this,
	                    renderer = chart.renderer,
	                    globalAnimation;
	
	                // Handle the isResizing counter
	                chart.isResizing += 1;
	
	                // set the animation for the current process
	                H.setAnimation(animation, chart);
	
	                chart.oldChartHeight = chart.chartHeight;
	                chart.oldChartWidth = chart.chartWidth;
	                if (width !== undefined) {
	                    chart.options.chart.width = width;
	                }
	                if (height !== undefined) {
	                    chart.options.chart.height = height;
	                }
	                chart.getChartSize();
	
	                // Resize the container with the global animation applied if enabled
	                // (#2503)
	
	                globalAnimation = renderer.globalAnimation;
	                (globalAnimation ? animate : css)(chart.container, {
	                    width: chart.chartWidth + 'px',
	                    height: chart.chartHeight + 'px'
	                }, globalAnimation);
	
	
	                chart.setChartSize(true);
	                renderer.setSize(chart.chartWidth, chart.chartHeight, animation);
	
	                // handle axes
	                each(chart.axes, function(axis) {
	                    axis.isDirty = true;
	                    axis.setScale();
	                });
	
	                chart.isDirtyLegend = true; // force legend redraw
	                chart.isDirtyBox = true; // force redraw of plot and chart border
	
	                chart.layOutTitles(); // #2857
	                chart.getMargins();
	
	                chart.redraw(animation);
	
	
	                chart.oldChartHeight = null;
	                fireEvent(chart, 'resize');
	
	                // Fire endResize and set isResizing back. If animation is disabled,
	                // fire without delay
	                syncTimeout(function() {
	                    if (chart) {
	                        fireEvent(chart, 'endResize', null, function() {
	                            chart.isResizing -= 1;
	                        });
	                    }
	                }, animObject(globalAnimation).duration);
	            },
	
	            /**
	             * Set the public chart properties. This is done before and after the
	             * pre-render to determine margin sizes.
	             *
	             * @private
	             */
	            setChartSize: function(skipAxes) {
	                var chart = this,
	                    inverted = chart.inverted,
	                    renderer = chart.renderer,
	                    chartWidth = chart.chartWidth,
	                    chartHeight = chart.chartHeight,
	                    optionsChart = chart.options.chart,
	                    spacing = chart.spacing,
	                    clipOffset = chart.clipOffset,
	                    clipX,
	                    clipY,
	                    plotLeft,
	                    plotTop,
	                    plotWidth,
	                    plotHeight,
	                    plotBorderWidth;
	
	                function clipOffsetSide(side) {
	                    var offset = clipOffset[side] || 0;
	                    return Math.max(plotBorderWidth || offset, offset) / 2;
	                }
	
	                /**
	                 * The current left position of the plot area in pixels.
	                 *
	                 * @name plotLeft
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotLeft = plotLeft = Math.round(chart.plotLeft);
	
	                /**
	                 * The current top position of the plot area in pixels.
	                 *
	                 * @name plotTop
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotTop = plotTop = Math.round(chart.plotTop);
	
	                /**
	                 * The current width of the plot area in pixels.
	                 *
	                 * @name plotWidth
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotWidth = plotWidth = Math.max(
	                    0,
	                    Math.round(chartWidth - plotLeft - chart.marginRight)
	                );
	
	                /**
	                 * The current height of the plot area in pixels.
	                 *
	                 * @name plotHeight
	                 * @memberOf Chart
	                 * @type {Number}
	                 */
	                chart.plotHeight = plotHeight = Math.max(
	                    0,
	                    Math.round(chartHeight - plotTop - chart.marginBottom)
	                );
	
	                chart.plotSizeX = inverted ? plotHeight : plotWidth;
	                chart.plotSizeY = inverted ? plotWidth : plotHeight;
	
	                chart.plotBorderWidth = optionsChart.plotBorderWidth || 0;
	
	                // Set boxes used for alignment
	                chart.spacingBox = renderer.spacingBox = {
	                    x: spacing[3],
	                    y: spacing[0],
	                    width: chartWidth - spacing[3] - spacing[1],
	                    height: chartHeight - spacing[0] - spacing[2]
	                };
	                chart.plotBox = renderer.plotBox = {
	                    x: plotLeft,
	                    y: plotTop,
	                    width: plotWidth,
	                    height: plotHeight
	                };
	
	                plotBorderWidth = 2 * Math.floor(chart.plotBorderWidth / 2);
	                clipX = Math.ceil(clipOffsetSide(3));
	                clipY = Math.ceil(clipOffsetSide(0));
	                chart.clipBox = {
	                    x: clipX,
	                    y: clipY,
	                    width: Math.floor(
	                        chart.plotSizeX -
	                        clipOffsetSide(1) -
	                        clipX
	                    ),
	                    height: Math.max(
	                        0,
	                        Math.floor(
	                            chart.plotSizeY -
	                            clipOffsetSide(2) -
	                            clipY
	                        )
	                    )
	                };
	
	                if (!skipAxes) {
	                    each(chart.axes, function(axis) {
	                        axis.setAxisSize();
	                        axis.setAxisTranslation();
	                    });
	                }
	            },
	
	            /**
	             * Initial margins before auto size margins are applied.
	             *
	             * @private
	             */
	            resetMargins: function() {
	                var chart = this,
	                    chartOptions = chart.options.chart;
	
	                // Create margin and spacing array
	                each(['margin', 'spacing'], function splashArrays(target) {
	                    var value = chartOptions[target],
	                        values = isObject(value) ? value : [value, value, value, value];
	
	                    each(['Top', 'Right', 'Bottom', 'Left'], function(sideName, side) {
	                        chart[target][side] = pick(
	                            chartOptions[target + sideName],
	                            values[side]
	                        );
	                    });
	                });
	
	                // Set margin names like chart.plotTop, chart.plotLeft,
	                // chart.marginRight, chart.marginBottom.
	                each(marginNames, function(m, side) {
	                    chart[m] = pick(chart.margin[side], chart.spacing[side]);
	                });
	                chart.axisOffset = [0, 0, 0, 0]; // top, right, bottom, left
	                chart.clipOffset = [];
	            },
	
	            /**
	             * Internal function to draw or redraw the borders and backgrounds for chart
	             * and plot area.
	             *
	             * @private
	             */
	            drawChartBox: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    renderer = chart.renderer,
	                    chartWidth = chart.chartWidth,
	                    chartHeight = chart.chartHeight,
	                    chartBackground = chart.chartBackground,
	                    plotBackground = chart.plotBackground,
	                    plotBorder = chart.plotBorder,
	                    chartBorderWidth,
	
	                    plotBGImage = chart.plotBGImage,
	                    chartBackgroundColor = optionsChart.backgroundColor,
	                    plotBackgroundColor = optionsChart.plotBackgroundColor,
	                    plotBackgroundImage = optionsChart.plotBackgroundImage,
	
	                    mgn,
	                    bgAttr,
	                    plotLeft = chart.plotLeft,
	                    plotTop = chart.plotTop,
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    plotBox = chart.plotBox,
	                    clipRect = chart.clipRect,
	                    clipBox = chart.clipBox,
	                    verb = 'animate';
	
	                // Chart area
	                if (!chartBackground) {
	                    chart.chartBackground = chartBackground = renderer.rect()
	                        .addClass('highcharts-background')
	                        .add();
	                    verb = 'attr';
	                }
	
	
	                // Presentational
	                chartBorderWidth = optionsChart.borderWidth || 0;
	                mgn = chartBorderWidth + (optionsChart.shadow ? 8 : 0);
	
	                bgAttr = {
	                    fill: chartBackgroundColor || 'none'
	                };
	
	                if (chartBorderWidth || chartBackground['stroke-width']) { // #980
	                    bgAttr.stroke = optionsChart.borderColor;
	                    bgAttr['stroke-width'] = chartBorderWidth;
	                }
	                chartBackground
	                    .attr(bgAttr)
	                    .shadow(optionsChart.shadow);
	
	                chartBackground[verb]({
	                    x: mgn / 2,
	                    y: mgn / 2,
	                    width: chartWidth - mgn - chartBorderWidth % 2,
	                    height: chartHeight - mgn - chartBorderWidth % 2,
	                    r: optionsChart.borderRadius
	                });
	
	                // Plot background
	                verb = 'animate';
	                if (!plotBackground) {
	                    verb = 'attr';
	                    chart.plotBackground = plotBackground = renderer.rect()
	                        .addClass('highcharts-plot-background')
	                        .add();
	                }
	                plotBackground[verb](plotBox);
	
	
	                // Presentational attributes for the background
	                plotBackground
	                    .attr({
	                        fill: plotBackgroundColor || 'none'
	                    })
	                    .shadow(optionsChart.plotShadow);
	
	                // Create the background image
	                if (plotBackgroundImage) {
	                    if (!plotBGImage) {
	                        chart.plotBGImage = renderer.image(
	                            plotBackgroundImage,
	                            plotLeft,
	                            plotTop,
	                            plotWidth,
	                            plotHeight
	                        ).add();
	                    } else {
	                        plotBGImage.animate(plotBox);
	                    }
	                }
	
	
	                // Plot clip
	                if (!clipRect) {
	                    chart.clipRect = renderer.clipRect(clipBox);
	                } else {
	                    clipRect.animate({
	                        width: clipBox.width,
	                        height: clipBox.height
	                    });
	                }
	
	                // Plot area border
	                verb = 'animate';
	                if (!plotBorder) {
	                    verb = 'attr';
	                    chart.plotBorder = plotBorder = renderer.rect()
	                        .addClass('highcharts-plot-border')
	                        .attr({
	                            zIndex: 1 // Above the grid
	                        })
	                        .add();
	                }
	
	
	                // Presentational
	                plotBorder.attr({
	                    stroke: optionsChart.plotBorderColor,
	                    'stroke-width': optionsChart.plotBorderWidth || 0,
	                    fill: 'none'
	                });
	
	
	                plotBorder[verb](plotBorder.crisp({
	                    x: plotLeft,
	                    y: plotTop,
	                    width: plotWidth,
	                    height: plotHeight
	                }, -plotBorder.strokeWidth())); //#3282 plotBorder should be negative;
	
	                // reset
	                chart.isDirtyBox = false;
	            },
	
	            /**
	             * Detect whether a certain chart property is needed based on inspecting its
	             * options and series. This mainly applies to the chart.inverted property,
	             * and in extensions to the chart.angular and chart.polar properties.
	             *
	             * @private
	             */
	            propFromSeries: function() {
	                var chart = this,
	                    optionsChart = chart.options.chart,
	                    klass,
	                    seriesOptions = chart.options.series,
	                    i,
	                    value;
	
	
	                each(['inverted', 'angular', 'polar'], function(key) {
	
	                    // The default series type's class
	                    klass = seriesTypes[optionsChart.type ||
	                        optionsChart.defaultSeriesType];
	
	                    // Get the value from available chart-wide properties
	                    value =
	                        optionsChart[key] || // It is set in the options
	                        (klass && klass.prototype[key]); // The default series class
	                    // requires it
	
	                    // 4. Check if any the chart's series require it
	                    i = seriesOptions && seriesOptions.length;
	                    while (!value && i--) {
	                        klass = seriesTypes[seriesOptions[i].type];
	                        if (klass && klass.prototype[key]) {
	                            value = true;
	                        }
	                    }
	
	                    // Set the chart property
	                    chart[key] = value;
	                });
	
	            },
	
	            /**
	             * Internal function to link two or more series together, based on the 
	             * `linkedTo` option. This is done from `Chart.render`, and after
	             * `Chart.addSeries` and `Series.remove`.
	             *
	             * @private
	             */
	            linkSeries: function() {
	                var chart = this,
	                    chartSeries = chart.series;
	
	                // Reset links
	                each(chartSeries, function(series) {
	                    series.linkedSeries.length = 0;
	                });
	
	                // Apply new links
	                each(chartSeries, function(series) {
	                    var linkedTo = series.options.linkedTo;
	                    if (isString(linkedTo)) {
	                        if (linkedTo === ':previous') {
	                            linkedTo = chart.series[series.index - 1];
	                        } else {
	                            linkedTo = chart.get(linkedTo);
	                        }
	                        // #3341 avoid mutual linking
	                        if (linkedTo && linkedTo.linkedParent !== series) {
	                            linkedTo.linkedSeries.push(series);
	                            series.linkedParent = linkedTo;
	                            series.visible = pick(
	                                series.options.visible,
	                                linkedTo.options.visible,
	                                series.visible
	                            ); // #3879
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Render series for the chart.
	             *
	             * @private
	             */
	            renderSeries: function() {
	                each(this.series, function(serie) {
	                    serie.translate();
	                    serie.render();
	                });
	            },
	
	            /**
	             * Render labels for the chart.
	             *
	             * @private
	             */
	            renderLabels: function() {
	                var chart = this,
	                    labels = chart.options.labels;
	                if (labels.items) {
	                    each(labels.items, function(label) {
	                        var style = extend(labels.style, label.style),
	                            x = pInt(style.left) + chart.plotLeft,
	                            y = pInt(style.top) + chart.plotTop + 12;
	
	                        // delete to prevent rewriting in IE
	                        delete style.left;
	                        delete style.top;
	
	                        chart.renderer.text(
	                                label.html,
	                                x,
	                                y
	                            )
	                            .attr({
	                                zIndex: 2
	                            })
	                            .css(style)
	                            .add();
	
	                    });
	                }
	            },
	
	            /**
	             * Render all graphics for the chart. Runs internally on initialization.
	             *
	             * @private
	             */
	            render: function() {
	                var chart = this,
	                    axes = chart.axes,
	                    renderer = chart.renderer,
	                    options = chart.options,
	                    tempWidth,
	                    tempHeight,
	                    redoHorizontal,
	                    redoVertical;
	
	                // Title
	                chart.setTitle();
	
	
	                // Legend
	                chart.legend = new Legend(chart, options.legend);
	
	                // Get stacks
	                if (chart.getStacks) {
	                    chart.getStacks();
	                }
	
	                // Get chart margins
	                chart.getMargins(true);
	                chart.setChartSize();
	
	                // Record preliminary dimensions for later comparison
	                tempWidth = chart.plotWidth;
	                tempHeight = chart.plotHeight = chart.plotHeight - 21; // 21 is the most common correction for X axis labels
	
	                // Get margins by pre-rendering axes
	                each(axes, function(axis) {
	                    axis.setScale();
	                });
	                chart.getAxisMargins();
	
	                // If the plot area size has changed significantly, calculate tick positions again
	                redoHorizontal = tempWidth / chart.plotWidth > 1.1;
	                redoVertical = tempHeight / chart.plotHeight > 1.05; // Height is more sensitive
	
	                if (redoHorizontal || redoVertical) {
	
	                    each(axes, function(axis) {
	                        if ((axis.horiz && redoHorizontal) || (!axis.horiz && redoVertical)) {
	                            axis.setTickInterval(true); // update to reflect the new margins
	                        }
	                    });
	                    chart.getMargins(); // second pass to check for new labels
	                }
	
	                // Draw the borders and backgrounds
	                chart.drawChartBox();
	
	
	                // Axes
	                if (chart.hasCartesianSeries) {
	                    each(axes, function(axis) {
	                        if (axis.visible) {
	                            axis.render();
	                        }
	                    });
	                }
	
	                // The series
	                if (!chart.seriesGroup) {
	                    chart.seriesGroup = renderer.g('series-group')
	                        .attr({
	                            zIndex: 3
	                        })
	                        .add();
	                }
	                chart.renderSeries();
	
	                // Labels
	                chart.renderLabels();
	
	                // Credits
	                chart.addCredits();
	
	                // Handle responsiveness
	                if (chart.setResponsive) {
	                    chart.setResponsive();
	                }
	
	                // Set flag
	                chart.hasRendered = true;
	
	            },
	
	            /**
	             * Set a new credits label for the chart.
	             *
	             * @param  {CreditOptions} options
	             *         A configuration object for the new credits.
	             * @sample highcharts/credits/credits-update/ Add and update credits
	             */
	            addCredits: function(credits) {
	                var chart = this;
	
	                credits = merge(true, this.options.credits, credits);
	                if (credits.enabled && !this.credits) {
	
	                    /**
	                     * The chart's credits label. The label has an `update` method that
	                     * allows setting new options as per the {@link
	                     * https://api.highcharts.com/highcharts/credits|
	                     * credits options set}.
	                     *
	                     * @memberof Highcharts.Chart
	                     * @name credits
	                     * @type {Highcharts.SVGElement}
	                     */
	                    this.credits = this.renderer.text(
	                            credits.text + (this.mapCredits || ''),
	                            0,
	                            0
	                        )
	                        .addClass('highcharts-credits')
	                        .on('click', function() {
	                            if (credits.href) {
	                                win.location.href = credits.href;
	                            }
	                        })
	                        .attr({
	                            align: credits.position.align,
	                            zIndex: 8
	                        })
	
	                        .css(credits.style)
	
	                        .add()
	                        .align(credits.position);
	
	                    // Dynamically update
	                    this.credits.update = function(options) {
	                        chart.credits = chart.credits.destroy();
	                        chart.addCredits(options);
	                    };
	                }
	            },
	
	            /**
	             * Remove the chart and purge memory. This method is called internally
	             * before adding a second chart into the same container, as well as on
	             * window unload to prevent leaks.
	             *
	             * @sample highcharts/members/chart-destroy/
	             *         Destroy the chart from a button
	             * @sample stock/members/chart-destroy/
	             *         Destroy with Highstock
	             */
	            destroy: function() {
	                var chart = this,
	                    axes = chart.axes,
	                    series = chart.series,
	                    container = chart.container,
	                    i,
	                    parentNode = container && container.parentNode;
	
	                // fire the chart.destoy event
	                fireEvent(chart, 'destroy');
	
	                // Delete the chart from charts lookup array
	                if (chart.renderer.forExport) {
	                    H.erase(charts, chart); // #6569
	                } else {
	                    charts[chart.index] = undefined;
	                }
	                H.chartCount--;
	                chart.renderTo.removeAttribute('data-highcharts-chart');
	
	                // remove events
	                removeEvent(chart);
	
	                // ==== Destroy collections:
	                // Destroy axes
	                i = axes.length;
	                while (i--) {
	                    axes[i] = axes[i].destroy();
	                }
	
	                // Destroy scroller & scroller series before destroying base series
	                if (this.scroller && this.scroller.destroy) {
	                    this.scroller.destroy();
	                }
	
	                // Destroy each series
	                i = series.length;
	                while (i--) {
	                    series[i] = series[i].destroy();
	                }
	
	                // ==== Destroy chart properties:
	                each([
	                    'title', 'subtitle', 'chartBackground', 'plotBackground',
	                    'plotBGImage', 'plotBorder', 'seriesGroup', 'clipRect', 'credits',
	                    'pointer', 'rangeSelector', 'legend', 'resetZoomButton', 'tooltip',
	                    'renderer'
	                ], function(name) {
	                    var prop = chart[name];
	
	                    if (prop && prop.destroy) {
	                        chart[name] = prop.destroy();
	                    }
	                });
	
	                // remove container and all SVG
	                if (container) { // can break in IE when destroyed before finished loading
	                    container.innerHTML = '';
	                    removeEvent(container);
	                    if (parentNode) {
	                        discardElement(container);
	                    }
	
	                }
	
	                // clean it all up
	                objectEach(chart, function(val, key) {
	                    delete chart[key];
	                });
	
	            },
	
	
	            /**
	             * VML namespaces can't be added until after complete. Listening
	             * for Perini's doScroll hack is not enough.
	             *
	             * @private
	             */
	            isReadyToRender: function() {
	                var chart = this;
	
	                // Note: win == win.top is required
	                if ((!svg && (win == win.top && doc.readyState !== 'complete'))) { // eslint-disable-line eqeqeq
	                    doc.attachEvent('onreadystatechange', function() {
	                        doc.detachEvent('onreadystatechange', chart.firstRender);
	                        if (doc.readyState === 'complete') {
	                            chart.firstRender();
	                        }
	                    });
	                    return false;
	                }
	                return true;
	            },
	
	            /**
	             * Prepare for first rendering after all data are loaded.
	             *
	             * @private
	             */
	            firstRender: function() {
	                var chart = this,
	                    options = chart.options;
	
	                // Check whether the chart is ready to render
	                if (!chart.isReadyToRender()) {
	                    return;
	                }
	
	                // Create the container
	                chart.getContainer();
	
	                // Run an early event after the container and renderer are established
	                fireEvent(chart, 'init');
	
	
	                chart.resetMargins();
	                chart.setChartSize();
	
	                // Set the common chart properties (mainly invert) from the given series
	                chart.propFromSeries();
	
	                // get axes
	                chart.getAxes();
	
	                // Initialize the series
	                each(options.series || [], function(serieOptions) {
	                    chart.initSeries(serieOptions);
	                });
	
	                chart.linkSeries();
	
	                // Run an event after axes and series are initialized, but before render. At this stage,
	                // the series data is indexed and cached in the xData and yData arrays, so we can access
	                // those before rendering. Used in Highstock.
	                fireEvent(chart, 'beforeRender');
	
	                // depends on inverted and on margins being set
	                if (Pointer) {
	
	                    /**
	                     * The Pointer that keeps track of mouse and touch interaction.
	                     *
	                     * @memberof Chart
	                     * @name pointer
	                     * @type Pointer
	                     */
	                    chart.pointer = new Pointer(chart, options);
	                }
	
	                chart.render();
	
	                // Fire the load event if there are no external images
	                if (!chart.renderer.imgCount && chart.onload) {
	                    chart.onload();
	                }
	
	                // If the chart was rendered outside the top container, put it back in (#3679)
	                chart.temporaryDisplay(true);
	
	            },
	
	            /** 
	             * Internal function that runs on chart load, async if any images are loaded
	             * in the chart. Runs the callbacks and triggers the `load` and `render`
	             * events.
	             *
	             * @private
	             */
	            onload: function() {
	
	                // Run callbacks
	                each([this.callback].concat(this.callbacks), function(fn) {
	                    if (fn && this.index !== undefined) { // Chart destroyed in its own callback (#3600)
	                        fn.apply(this, [this]);
	                    }
	                }, this);
	
	                fireEvent(this, 'load');
	                fireEvent(this, 'render');
	
	
	                // Set up auto resize, check for not destroyed (#6068)
	                if (defined(this.index) && this.options.chart.reflow !== false) {
	                    this.initReflow();
	                }
	
	                // Don't run again
	                this.onload = null;
	            }
	
	        }); // end Chart
	
	    }(Highcharts));
	    (function(Highcharts) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Point,
	            H = Highcharts,
	
	            each = H.each,
	            extend = H.extend,
	            erase = H.erase,
	            fireEvent = H.fireEvent,
	            format = H.format,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            pick = H.pick,
	            removeEvent = H.removeEvent;
	
	        /**
	         * The Point object. The point objects are generated from the `series.data` 
	         * configuration objects or raw numbers. They can be accessed from the
	         * `Series.points` array. Other ways to instaniate points are through {@link
	         * Highcharts.Series#addPoint} or {@link Highcharts.Series#setData}.
	         *
	         * @class
	         */
	
	        Highcharts.Point = Point = function() {};
	        Highcharts.Point.prototype = {
	
	            /**
	             * Initialize the point. Called internally based on the `series.data`
	             * option.
	             * @param  {Series} series
	             *         The series object containing this point.
	             * @param  {Number|Array|Object} options
	             *         The data in either number, array or object format.
	             * @param  {Number} x Optionally, the X value of the point.
	             * @return {Point} The Point instance.
	             */
	            init: function(series, options, x) {
	
	                var point = this,
	                    colors,
	                    colorCount = series.chart.options.chart.colorCount,
	                    colorIndex;
	
	                /**
	                 * The series object associated with the point.
	                 *
	                 * @name series
	                 * @memberof Highcharts.Point
	                 * @type Highcharts.Series
	                 */
	                point.series = series;
	
	
	                /**
	                 * The point's current color.
	                 * @name color
	                 * @memberof Highcharts.Point
	                 * @type {Color}
	                 */
	                point.color = series.color; // #3445
	
	                point.applyOptions(options, x);
	
	                if (series.options.colorByPoint) {
	
	                    colors = series.options.colors || series.chart.options.colors;
	                    point.color = point.color || colors[series.colorCounter];
	                    colorCount = colors.length;
	
	                    colorIndex = series.colorCounter;
	                    series.colorCounter++;
	                    // loop back to zero
	                    if (series.colorCounter === colorCount) {
	                        series.colorCounter = 0;
	                    }
	                } else {
	                    colorIndex = series.colorIndex;
	                }
	                point.colorIndex = pick(point.colorIndex, colorIndex);
	
	                series.chart.pointCount++;
	                return point;
	            },
	            /**
	             * Apply the options containing the x and y data and possible some extra
	             * properties. Called on point init or from point.update.
	             *
	             * @private
	             * @param {Object} options The point options as defined in series.data.
	             * @param {Number} x Optionally, the X value.
	             * @returns {Object} The Point instance.
	             */
	            applyOptions: function(options, x) {
	                var point = this,
	                    series = point.series,
	                    pointValKey = series.options.pointValKey || series.pointValKey;
	
	                options = Point.prototype.optionsToObject.call(this, options);
	
	                // copy options directly to point
	                extend(point, options);
	                point.options = point.options ? extend(point.options, options) : options;
	
	                // Since options are copied into the Point instance, some accidental options must be shielded (#5681)
	                if (options.group) {
	                    delete point.group;
	                }
	
	                // For higher dimension series types. For instance, for ranges, point.y is mapped to point.low.
	                if (pointValKey) {
	                    point.y = point[pointValKey];
	                }
	                point.isNull = pick(
	                    point.isValid && !point.isValid(),
	                    point.x === null || !isNumber(point.y, true)
	                ); // #3571, check for NaN
	
	                // The point is initially selected by options (#5777)
	                if (point.selected) {
	                    point.state = 'select';
	                }
	
	                // If no x is set by now, get auto incremented value. All points must have an
	                // x value, however the y value can be null to create a gap in the series
	                if ('name' in point && x === undefined && series.xAxis && series.xAxis.hasNames) {
	                    point.x = series.xAxis.nameToX(point);
	                }
	                if (point.x === undefined && series) {
	                    if (x === undefined) {
	                        point.x = series.autoIncrement(point);
	                    } else {
	                        point.x = x;
	                    }
	                }
	
	                return point;
	            },
	
	            /**
	             * Transform number or array configs into objects. Used internally to unify
	             * the different configuration formats for points. For example, a simple
	             * number `10` in a line series will be transformed to `{ y: 10 }`, and an
	             * array config like `[1, 10]` in a scatter series will be transformed to
	             * `{ x: 1, y: 10 }`.
	             *
	             * @param  {Number|Array|Object} options
	             *         The input options
	             * @return {Object} Transformed options.
	             */
	            optionsToObject: function(options) {
	                var ret = {},
	                    series = this.series,
	                    keys = series.options.keys,
	                    pointArrayMap = keys || series.pointArrayMap || ['y'],
	                    valueCount = pointArrayMap.length,
	                    firstItemType,
	                    i = 0,
	                    j = 0;
	
	                if (isNumber(options) || options === null) {
	                    ret[pointArrayMap[0]] = options;
	
	                } else if (isArray(options)) {
	                    // with leading x value
	                    if (!keys && options.length > valueCount) {
	                        firstItemType = typeof options[0];
	                        if (firstItemType === 'string') {
	                            ret.name = options[0];
	                        } else if (firstItemType === 'number') {
	                            ret.x = options[0];
	                        }
	                        i++;
	                    }
	                    while (j < valueCount) {
	                        if (!keys || options[i] !== undefined) { // Skip undefined positions for keys
	                            ret[pointArrayMap[j]] = options[i];
	                        }
	                        i++;
	                        j++;
	                    }
	                } else if (typeof options === 'object') {
	                    ret = options;
	
	                    // This is the fastest way to detect if there are individual point dataLabels that need
	                    // to be considered in drawDataLabels. These can only occur in object configs.
	                    if (options.dataLabels) {
	                        series._hasPointLabels = true;
	                    }
	
	                    // Same approach as above for markers
	                    if (options.marker) {
	                        series._hasPointMarkers = true;
	                    }
	                }
	                return ret;
	            },
	
	            /**
	             * Get the CSS class names for individual points. Used internally where the
	             * returned value is set on every point.
	             * 
	             * @returns {String} The class names.
	             */
	            getClassName: function() {
	                return 'highcharts-point' +
	                    (this.selected ? ' highcharts-point-select' : '') +
	                    (this.negative ? ' highcharts-negative' : '') +
	                    (this.isNull ? ' highcharts-null-point' : '') +
	                    (this.colorIndex !== undefined ? ' highcharts-color-' +
	                        this.colorIndex : '') +
	                    (this.options.className ? ' ' + this.options.className : '') +
	                    (this.zone && this.zone.className ? ' ' +
	                        this.zone.className.replace('highcharts-negative', '') : '');
	            },
	
	            /**
	             * In a series with `zones`, return the zone that the point belongs to.
	             *
	             * @return {Object}
	             *         The zone item.
	             */
	            getZone: function() {
	                var series = this.series,
	                    zones = series.zones,
	                    zoneAxis = series.zoneAxis || 'y',
	                    i = 0,
	                    zone;
	
	                zone = zones[i];
	                while (this[zoneAxis] >= zone.value) {
	                    zone = zones[++i];
	                }
	
	                if (zone && zone.color && !this.options.color) {
	                    this.color = zone.color;
	                }
	
	                return zone;
	            },
	
	            /**
	             * Destroy a point to clear memory. Its reference still stays in
	             * `series.data`.
	             *
	             * @private
	             */
	            destroy: function() {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    hoverPoints = chart.hoverPoints,
	                    prop;
	
	                chart.pointCount--;
	
	                if (hoverPoints) {
	                    point.setState();
	                    erase(hoverPoints, point);
	                    if (!hoverPoints.length) {
	                        chart.hoverPoints = null;
	                    }
	
	                }
	                if (point === chart.hoverPoint) {
	                    point.onMouseOut();
	                }
	
	                // remove all events
	                if (point.graphic || point.dataLabel) { // removeEvent and destroyElements are performance expensive
	                    removeEvent(point);
	                    point.destroyElements();
	                }
	
	                if (point.legendItem) { // pies have legend items
	                    chart.legend.destroyItem(point);
	                }
	
	                for (prop in point) {
	                    point[prop] = null;
	                }
	
	
	            },
	
	            /**
	             * Destroy SVG elements associated with the point.
	             *
	             * @private
	             */
	            destroyElements: function() {
	                var point = this,
	                    props = ['graphic', 'dataLabel', 'dataLabelUpper', 'connector', 'shadowGroup'],
	                    prop,
	                    i = 6;
	                while (i--) {
	                    prop = props[i];
	                    if (point[prop]) {
	                        point[prop] = point[prop].destroy();
	                    }
	                }
	            },
	
	            /**
	             * Return the configuration hash needed for the data label and tooltip
	             * formatters.
	             *
	             * @returns {Object}
	             *          Abstract object used in formatters and formats.
	             */
	            getLabelConfig: function() {
	                return {
	                    x: this.category,
	                    y: this.y,
	                    color: this.color,
	                    colorIndex: this.colorIndex,
	                    key: this.name || this.category,
	                    series: this.series,
	                    point: this,
	                    percentage: this.percentage,
	                    total: this.total || this.stackTotal
	                };
	            },
	
	            /**
	             * Extendable method for formatting each point's tooltip line.
	             *
	             * @param  {String} pointFormat
	             *         The point format.
	             * @return {String}
	             *         A string to be concatenated in to the common tooltip text.
	             */
	            tooltipFormatter: function(pointFormat) {
	
	                // Insert options for valueDecimals, valuePrefix, and valueSuffix
	                var series = this.series,
	                    seriesTooltipOptions = series.tooltipOptions,
	                    valueDecimals = pick(seriesTooltipOptions.valueDecimals, ''),
	                    valuePrefix = seriesTooltipOptions.valuePrefix || '',
	                    valueSuffix = seriesTooltipOptions.valueSuffix || '';
	
	                // Loop over the point array map and replace unformatted values with sprintf formatting markup
	                each(series.pointArrayMap || ['y'], function(key) {
	                    key = '{point.' + key; // without the closing bracket
	                    if (valuePrefix || valueSuffix) {
	                        pointFormat = pointFormat.replace(key + '}', valuePrefix + key + '}' + valueSuffix);
	                    }
	                    pointFormat = pointFormat.replace(key + '}', key + ':,.' + valueDecimals + 'f}');
	                });
	
	                return format(pointFormat, {
	                    point: this,
	                    series: this.series
	                });
	            },
	
	            /**
	             * Fire an event on the Point object.
	             *
	             * @private
	             * @param {String} eventType
	             * @param {Object} eventArgs Additional event arguments
	             * @param {Function} defaultFunction Default event handler
	             */
	            firePointEvent: function(eventType, eventArgs, defaultFunction) {
	                var point = this,
	                    series = this.series,
	                    seriesOptions = series.options;
	
	                // load event handlers on demand to save time on mouseover/out
	                if (seriesOptions.point.events[eventType] || (point.options && point.options.events && point.options.events[eventType])) {
	                    this.importEvents();
	                }
	
	                // add default handler if in selection mode
	                if (eventType === 'click' && seriesOptions.allowPointSelect) {
	                    defaultFunction = function(event) {
	                        // Control key is for Windows, meta (= Cmd key) for Mac, Shift for Opera
	                        if (point.select) { // Could be destroyed by prior event handlers (#2911)
	                            point.select(null, event.ctrlKey || event.metaKey || event.shiftKey);
	                        }
	                    };
	                }
	
	                fireEvent(this, eventType, eventArgs, defaultFunction);
	            },
	
	            /**
	             * For certain series types, like pie charts, where individual points can
	             * be shown or hidden. 
	             *
	             * @name visible
	             * @memberOf Highcharts.Point
	             * @type {Boolean}
	             */
	            visible: true
	        };
	
	        /**
	         * For categorized axes this property holds the category name for the 
	         * point. For other axes it holds the X value.
	         *
	         * @name category
	         * @memberOf Highcharts.Point
	         * @type {String|Number}
	         */
	
	        /**
	         * The percentage for points in a stacked series or pies.
	         *
	         * @name percentage
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The total of values in either a stack for stacked series, or a pie in a pie
	         * series.
	         *
	         * @name total
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The x value of the point.
	         *
	         * @name x
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	        /**
	         * The y value of the point.
	         *
	         * @name y
	         * @memberOf Highcharts.Point
	         * @type {Number}
	         */
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animObject = H.animObject,
	            arrayMax = H.arrayMax,
	            arrayMin = H.arrayMin,
	            correctFloat = H.correctFloat,
	            Date = H.Date,
	            defaultOptions = H.defaultOptions,
	            defaultPlotOptions = H.defaultPlotOptions,
	            defined = H.defined,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            grep = H.grep,
	            isArray = H.isArray,
	            isNumber = H.isNumber,
	            isString = H.isString,
	            LegendSymbolMixin = H.LegendSymbolMixin, // @todo add as a requirement
	            merge = H.merge,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Point = H.Point, // @todo  add as a requirement
	            removeEvent = H.removeEvent,
	            splat = H.splat,
	            SVGElement = H.SVGElement,
	            syncTimeout = H.syncTimeout,
	            win = H.win;
	
	        /**
	         * This is the base series prototype that all other series types inherit from.
	         * A new series is initialized either through the {@link https://api.highcharts.com/highcharts/series|
	         * series} option structure, or after the chart is initialized, through {@link
	         * Highcharts.Chart#addSeries}.
	         *
	         * The object can be accessed in a number of ways. All series and point event
	         * handlers give a reference to the `series` object. The chart object has a
	         * {@link Highcharts.Chart.series|series} property that is a collection of all
	         * the chart's series. The point objects and axis objects also have the same
	         * reference.
	         *
	         * Another way to reference the series programmatically is by `id`. Add an id
	         * in the series configuration options, and get the series object by {@link
	         * Highcharts.Chart#get}.
	         *
	         * Configuration options for the series are given in three levels. Options for
	         * all series in a chart are given in the {@link https://api.highcharts.com/highcharts/plotOptions.series|
	         * plotOptions.series} object. Then options for all series of a specific type
	         * are given in the plotOptions of that type, for example `plotOptions.line`.
	         * Next, options for one single series are given in the series array, or as
	         * arguements to `chart.addSeries`.
	         *
	         * The data in the series is stored in various arrays.
	         *
	         * - First, `series.options.data` contains all the original config options for
	         * each point whether added by options or methods like `series.addPoint`.
	         * - Next, `series.data` contains those values converted to points, but in case
	         * the series data length exceeds the `cropThreshold`, or if the data is grouped,
	         * `series.data` doesn't contain all the points. It only contains the points that
	         * have been created on demand.
	         * - Then there's `series.points` that contains all currently visible point
	         * objects. In case of cropping, the cropped-away points are not part of this
	         * array. The `series.points` array starts at `series.cropStart` compared to
	         * `series.data` and `series.options.data`. If however the series data is grouped,
	         * these can't be correlated one to one.
	         * - `series.xData` and `series.processedXData` contain clean x values, equivalent
	         * to `series.data` and `series.points`.
	         * - `series.yData` and `series.processedYData` contain clean y values, equivalent
	         * to `series.data` and `series.points`.
	         *
	         * @class Highcharts.Series
	         * @param  {Highcharts.Chart} chart
	         *         The chart instance.
	         * @param  {Options.plotOptions.series} options
	         *         The series options.
	         *
	         */
	
	        /**
	         * General options for all series types.
	         * @optionparent plotOptions.series
	         */
	        H.Series = H.seriesType('line', null, { // base series options
	
	            //cursor: 'default',
	            //dashStyle: null,
	            //linecap: 'round',
	
	
	
	            /**
	             * Pixel with of the graph line.
	             * 
	             * @type {Number}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the line stroke-width can be set with the
	             * `.highcharts-graph` class name.
	             * @sample {highcharts} highcharts/plotoptions/series-linewidth-general/ On all series
	             * @sample {highcharts} highcharts/plotoptions/series-linewidth-specific/ On one single series
	             * @default 2
	             * @product highcharts highstock
	             */
	            lineWidth: 2,
	            //shadow: false,
	
	
	            /**
	             * For some series, there is a limit that shuts down initial animation
	             * by default when the total number of points in the chart is too high.
	             * For example, for a column chart and its derivatives, animation doesn't
	             * run if there is more than 250 points totally. To disable this cap, set
	             * `animationLimit` to `Infinity`.
	             * 
	             * @type {Number}
	             * @apioption plotOptions.series.animationLimit
	             */
	
	            /**
	             * Allow this series' points to be selected by clicking on the graphic 
	             * (columns, point markers, pie slices, map areas etc).
	             *
	             * @see [Chart#getSelectedPoints](../class-reference/Highcharts.Chart#getSelectedPoints).
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-allowpointselect-line/
	             *         Line
	             * @sample {highcharts} highcharts/plotoptions/series-allowpointselect-column/
	             *         Column
	             * @sample {highcharts} highcharts/plotoptions/series-allowpointselect-pie/
	             *         Pie
	             * @sample {highmaps} maps/plotoptions/series-allowpointselect/
	             *         Map area
	             * @sample {highmaps} maps/plotoptions/mapbubble-allowpointselect/
	             *         Map bubble
	             * @default false
	             * @since 1.2.0
	             * @product highcharts highstock highmaps
	             */
	            allowPointSelect: false,
	
	
	
	            /**
	             * If true, a checkbox is displayed next to the legend item to allow
	             * selecting the series. The state of the checkbox is determined by
	             * the `selected` option.
	             *
	             * @productdesc {highmaps}
	             * Note that if a `colorAxis` is defined, the color axis is represented in
	             * the legend, not the series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-showcheckbox-true/
	             *         Show select box
	             * @default false
	             * @since 1.2.0
	             */
	            showCheckbox: false,
	
	
	
	            /**
	             * Enable or disable the initial animation when a series is displayed.
	             * The animation can also be set as a configuration object. Please
	             * note that this option only applies to the initial animation of the
	             * series itself. For other animations, see [chart.animation](#chart.
	             * animation) and the animation parameter under the API methods. The
	             * following properties are supported:
	             * 
	             * <dl>
	             * 
	             * <dt>duration</dt>
	             * 
	             * <dd>The duration of the animation in milliseconds.</dd>
	             * 
	             * <dt>easing</dt>
	             * 
	             * <dd>A string reference to an easing function set on the `Math` object.
	             * See [the easing demo](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/plotoptions/series-
	             * animation-easing/).</dd>
	             * 
	             * </dl>
	             * 
	             * Due to poor performance, animation is disabled in old IE browsers
	             * for several chart types.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-animation-disabled/
	             *         Animation disabled
	             * @sample {highcharts} highcharts/plotoptions/series-animation-slower/
	             *         Slower animation
	             * @sample {highcharts} highcharts/plotoptions/series-animation-easing/
	             *         Custom easing function
	             * @sample {highstock} stock/plotoptions/animation-slower/
	             *         Slower animation
	             * @sample {highstock} stock/plotoptions/animation-easing/
	             *         Custom easing function
	             * @sample {highmaps} maps/plotoptions/series-animation-true/
	             *         Animation enabled on map series
	             * @sample {highmaps} maps/plotoptions/mapbubble-animation-false/
	             *         Disabled on mapbubble series
	             * @default {highcharts} true
	             * @default {highstock} true
	             * @default {highmaps} false
	             */
	            animation: {
	
	
	                /**
	                 */
	                duration: 1000
	            },
	
	            /**
	             * A class name to apply to the series' graphical elements.
	             * 
	             * @type {String}
	             * @since 5.0.0
	             * @apioption plotOptions.series.className
	             */
	
	            /**
	             * The main color of the series. In line type series it applies to the
	             * line and the point markers unless otherwise specified. In bar type
	             * series it applies to the bars unless a color is specified per point.
	             * The default value is pulled from the `options.colors` array.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the color can be defined by the [colorIndex](#plotOptions.
	             * series.colorIndex) option. Also, the series color can be set with
	             * the `.highcharts-series`, `.highcharts-color-{n}`, `.highcharts-{type}-
	             * series` or `.highcharts-series-{n}` class, or individual classes
	             * given by the `className` option.
	             *
	             * @productdesc {highmaps}
	             * In maps, the series color is rarely used, as most choropleth maps use the
	             * color to denote the value of each point. The series color can however be
	             * used in a map with multiple series holding categorized data.
	             * 
	             * @type {Color}
	             * @sample {highcharts} highcharts/plotoptions/series-color-general/
	             *         General plot option
	             * @sample {highcharts} highcharts/plotoptions/series-color-specific/
	             *         One specific series
	             * @sample {highcharts} highcharts/plotoptions/series-color-area/
	             *         Area color
	             * @sample {highmaps} maps/demo/category-map/
	             *         Category map by multiple series
	             * @apioption plotOptions.series.color
	             */
	
	            /**
	             * [Styled mode](http://www.highcharts.com/docs/chart-design-and-style/style-
	             * by-css) only. A specific color index to use for the series, so its
	             * graphic representations are given the class name `highcharts-color-
	             * {n}`.
	             * 
	             * @type {Number}
	             * @since 5.0.0
	             * @apioption plotOptions.series.colorIndex
	             */
	
	
	            /**
	             * Whether to connect a graph line across null points, or render a gap
	             * between the two points on either side of the null.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-connectnulls-false/
	             *         False by default
	             * @sample {highcharts} highcharts/plotoptions/series-connectnulls-true/
	             *         True
	             * @product highcharts highstock
	             * @apioption plotOptions.series.connectNulls
	             */
	
	
	            /**
	             * You can set the cursor to "pointer" if you have click events attached
	             * to the series, to signal to the user that the points and lines can
	             * be clicked.
	             * 
	             * @validvalue [null, "default", "none", "help", "pointer", "crosshair"]
	             * @type {String}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the series cursor can be set with the same classes
	             * as listed under [series.color](#plotOptions.series.color).
	             * @sample {highcharts} highcharts/plotoptions/series-cursor-line/
	             *         On line graph
	             * @sample {highcharts} highcharts/plotoptions/series-cursor-column/
	             *         On columns
	             * @sample {highcharts} highcharts/plotoptions/series-cursor-scatter/
	             *         On scatter markers
	             * @sample {highstock} stock/plotoptions/cursor/
	             *         Pointer on a line graph
	             * @sample {highmaps} maps/plotoptions/series-allowpointselect/
	             *         Map area
	             * @sample {highmaps} maps/plotoptions/mapbubble-allowpointselect/
	             *         Map bubble
	             * @apioption plotOptions.series.cursor
	             */
	
	
	            /**
	             * A name for the dash style to use for the graph, or for some series types
	             * the outline of each shape. The value for the `dashStyle` include:
	             * 
	             * *   Solid
	             * *   ShortDash
	             * *   ShortDot
	             * *   ShortDashDot
	             * *   ShortDashDotDot
	             * *   Dot
	             * *   Dash
	             * *   LongDash
	             * *   DashDot
	             * *   LongDashDot
	             * *   LongDashDotDot
	             * 
	             * @validvalue ["Solid", "ShortDash", "ShortDot", "ShortDashDot",
	             *             "ShortDashDotDot", "Dot", "Dash" ,"LongDash", "DashDot",
	             *             "LongDashDot", "LongDashDotDot"]
	             * @type {String}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the [stroke dash-array](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-
	             * dashstyle/) can be set with the same classes as listed under [series.
	             * color](#plotOptions.series.color).
	             * @sample {highcharts} highcharts/plotoptions/series-dashstyle-all/
	             *         Possible values demonstrated
	             * @sample {highcharts} highcharts/plotoptions/series-dashstyle/
	             *         Chart suitable for printing in black and white
	             * @sample {highstock} highcharts/plotoptions/series-dashstyle-all/
	             *         Possible values demonstrated
	             * @sample {highmaps} highcharts/plotoptions/series-dashstyle-all/
	             *         Possible values demonstrated
	             * @sample {highmaps} maps/plotoptions/series-dashstyle/
	             *         Dotted borders on a map
	             * @default Solid
	             * @since 2.1
	             * @apioption plotOptions.series.dashStyle
	             */
	
	            /**
	             * Requires the Accessibility module.
	             * 
	             * A description of the series to add to the screen reader information
	             * about the series.
	             * 
	             * @type {String}
	             * @default undefined
	             * @since 5.0.0
	             * @apioption plotOptions.series.description
	             */
	
	
	
	
	
	            /**
	             * Enable or disable the mouse tracking for a specific series. This
	             * includes point tooltips and click events on graphs and points. For
	             * large datasets it improves performance.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-enablemousetracking-false/ No mouse tracking
	             * @sample {highmaps} maps/plotoptions/series-enablemousetracking-false/ No mouse tracking
	             * @default true
	             * @apioption plotOptions.series.enableMouseTracking
	             */
	
	            /**
	             * By default, series are exposed to screen readers as regions. By enabling
	             * this option, the series element itself will be exposed in the same
	             * way as the data points. This is useful if the series is not used
	             * as a grouping entity in the chart, but you still want to attach a
	             * description to the series.
	             * 
	             * Requires the Accessibility module.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/accessibility/art-grants/ Accessible data visualization
	             * @sample {highstock} highcharts/accessibility/art-grants/ Accessible data visualization
	             * @sample {highmaps} highcharts/accessibility/art-grants/ Accessible data visualization
	             * @default undefined
	             * @since 5.0.12
	             * @apioption plotOptions.series.exposeElementToA11y
	             */
	
	            /**
	             * Whether to use the Y extremes of the total chart width or only the
	             * zoomed area when zooming in on parts of the X axis. By default, the
	             * Y axis adjusts to the min and max of the visible data. Cartesian
	             * series only.
	             * 
	             * @type {Boolean}
	             * @default false
	             * @since 4.1.6
	             * @product highcharts highstock
	             * @apioption plotOptions.series.getExtremesFromAll
	             */
	
	            /**
	             * An array specifying which option maps to which key in the data point
	             * array. This makes it convenient to work with unstructured data arrays
	             * from different sources.
	             * 
	             * @type {Array<String>}
	             * @see [series.data](#series<line>.data)
	             * @sample {highcharts} highcharts/series/data-keys/ An extended data array with keys
	             * @sample {highstock} highcharts/series/data-keys/ An extended data array with keys
	             * @since 4.1.6
	             * @product highcharts highstock
	             * @apioption plotOptions.series.keys
	             */
	
	            /**
	             * The line cap used for line ends and line joins on the graph.
	             * 
	             * @validvalue ["round", "square"]
	             * @type {String}
	             * @default round
	             * @product highcharts highstock
	             * @apioption plotOptions.series.linecap
	             */
	
	            /**
	             * The [id](#series.id) of another series to link to. Additionally,
	             * the value can be ":previous" to link to the previous series. When
	             * two series are linked, only the first one appears in the legend.
	             * Toggling the visibility of this also toggles the linked series.
	             * 
	             * @type {String}
	             * @sample {highcharts} highcharts/demo/arearange-line/ Linked series
	             * @sample {highstock} highcharts/demo/arearange-line/ Linked series
	             * @since 3.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.linkedTo
	             */
	
	            /**
	             * The color for the parts of the graph or points that are below the
	             * [threshold](#plotOptions.series.threshold).
	             * 
	             * @type {Color}
	             * @see In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), a negative color is applied by setting this
	             * option to `true` combined with the `.highcharts-negative` class name
	             * ([view live demo](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-
	             * negative-color/)).
	             * @sample {highcharts} highcharts/plotoptions/series-negative-color/ Spline, area and column
	             * @sample {highcharts} highcharts/plotoptions/arearange-negativecolor/ Arearange
	             * @sample {highstock} highcharts/plotoptions/series-negative-color/ Spline, area and column
	             * @sample {highstock} highcharts/plotoptions/arearange-negativecolor/ Arearange
	             * @sample {highmaps} highcharts/plotoptions/series-negative-color/ Spline, area and column
	             * @sample {highmaps} highcharts/plotoptions/arearange-negativecolor/ Arearange
	             * @default null
	             * @since 3.0
	             * @apioption plotOptions.series.negativeColor
	             */
	
	            /**
	             * Same as [accessibility.pointDescriptionFormatter](#accessibility.
	             * pointDescriptionFormatter), but for an individual series. Overrides
	             * the chart wide configuration.
	             * 
	             * @type {Function}
	             * @since 5.0.12
	             * @apioption plotOptions.series.pointDescriptionFormatter
	             */
	
	            /**
	             * If no x values are given for the points in a series, `pointInterval`
	             * defines the interval of the x values. For example, if a series contains
	             * one value every decade starting from year 0, set `pointInterval` to
	             * 10. In true `datetime` axes, the `pointInterval` is set in milliseconds.
	             * 
	             * It can be also be combined with `pointIntervalUnit` to draw irregular
	             * time intervals.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/series-pointstart-datetime/
	             *         Datetime X axis
	             * @sample {highstock} stock/plotoptions/pointinterval-pointstart/
	             *         Using pointStart and pointInterval
	             * @default 1
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointInterval
	             */
	
	            /**
	             * On datetime series, this allows for setting the [pointInterval](#plotOptions.
	             * series.pointInterval) to irregular time units, `day`, `month` and
	             * `year`. A day is usually the same as 24 hours, but pointIntervalUnit
	             * also takes the DST crossover into consideration when dealing with
	             * local time. Combine this option with `pointInterval` to draw weeks,
	             *  quarters, 6 months, 10 years etc.
	             * 
	             * @validvalue [null, "day", "month", "year"]
	             * @type {String}
	             * @sample {highcharts} highcharts/plotoptions/series-pointintervalunit/ One point a month
	             * @sample {highstock} highcharts/plotoptions/series-pointintervalunit/ One point a month
	             * @since 4.1.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointIntervalUnit
	             */
	
	            /**
	             * Possible values: `null`, `"on"`, `"between"`.
	             * 
	             * In a column chart, when pointPlacement is `"on"`, the point will
	             * not create any padding of the X axis. In a polar column chart this
	             * means that the first column points directly north. If the pointPlacement
	             * is `"between"`, the columns will be laid out between ticks. This
	             * is useful for example for visualising an amount between two points
	             * in time or in a certain sector of a polar chart.
	             * 
	             * Since Highcharts 3.0.2, the point placement can also be numeric,
	             * where 0 is on the axis value, -0.5 is between this value and the
	             * previous, and 0.5 is between this value and the next. Unlike the
	             * textual options, numeric point placement options won't affect axis
	             * padding.
	             * 
	             * Note that pointPlacement needs a [pointRange](#plotOptions.series.
	             * pointRange) to work. For column series this is computed, but for
	             * line-type series it needs to be set.
	             * 
	             * Defaults to `null` in cartesian charts, `"between"` in polar charts.
	             * 
	             * @validvalue [null, "on", "between"]
	             * @type {String|Number}
	             * @see [xAxis.tickmarkPlacement](#xAxis.tickmarkPlacement)
	             * @sample {highcharts} highcharts/plotoptions/series-pointplacement-between/ Between in a column chart
	             * @sample {highcharts} highcharts/plotoptions/series-pointplacement-numeric/ Numeric placement for custom layout
	             * @sample {highstock} highcharts/plotoptions/series-pointplacement-between/ Between in a column chart
	             * @sample {highstock} highcharts/plotoptions/series-pointplacement-numeric/ Numeric placement for custom layout
	             * @default null
	             * @since 2.3.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointPlacement
	             */
	
	            /**
	             * If no x values are given for the points in a series, pointStart defines
	             * on what value to start. For example, if a series contains one yearly
	             * value starting from 1945, set pointStart to 1945.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/series-pointstart-linear/ Linear
	             * @sample {highcharts} highcharts/plotoptions/series-pointstart-datetime/ Datetime
	             * @sample {highstock} stock/plotoptions/pointinterval-pointstart/ Using pointStart and pointInterval
	             * @default 0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.pointStart
	             */
	
	            /**
	             * Whether to select the series initially. If `showCheckbox` is true,
	             * the checkbox next to the series name in the legend will be checked for a
	             * selected series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-selected/
	             *         One out of two series selected
	             * @default false
	             * @since 1.2.0
	             * @apioption plotOptions.series.selected
	             */
	
	            /**
	             * Whether to apply a drop shadow to the graph line. Since 2.3 the shadow
	             * can be an object configuration containing `color`, `offsetX`, `offsetY`,
	             *  `opacity` and `width`.
	             * 
	             * @type {Boolean|Object}
	             * @sample {highcharts} highcharts/plotoptions/series-shadow/ Shadow enabled
	             * @default false
	             * @apioption plotOptions.series.shadow
	             */
	
	            /**
	             * Whether to display this particular series or series type in the legend.
	             * The default value is `true` for standalone series, `false` for linked
	             * series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-showinlegend/ One series in the legend, one hidden
	             * @default true
	             * @apioption plotOptions.series.showInLegend
	             */
	
	            /**
	             * If set to `True`, the accessibility module will skip past the points
	             * in this series for keyboard navigation.
	             * 
	             * @type {Boolean}
	             * @since 5.0.12
	             * @apioption plotOptions.series.skipKeyboardNavigation
	             */
	
	            /**
	             * Whether to stack the values of each series on top of each other.
	             * Possible values are null to disable, "normal" to stack by value or
	             * "percent". When stacking is enabled, data must be sorted in ascending
	             * X order.
	             * 
	             * @validvalue [null, "normal", "percent"]
	             * @type {String}
	             * @see [yAxis.reversedStacks](#yAxis.reversedStacks)
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-line/ Line
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-column/ Column
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-bar/ Bar
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-area/ Area
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-line/ Line
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-column/ Column
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-bar/ Bar
	             * @sample {highcharts} highcharts/plotoptions/series-stacking-percent-area/ Area
	             * @sample {highstock} stock/plotoptions/stacking/ Area
	             * @default null
	             * @product highcharts highstock
	             * @apioption plotOptions.series.stacking
	             */
	
	            /**
	             * Whether to apply steps to the line. Possible values are `left`, `center`
	             * and `right`.
	             * 
	             * @validvalue [null, "left", "center", "right"]
	             * @type {String}
	             * @sample {highcharts} highcharts/plotoptions/line-step/ Different step line options
	             * @sample {highcharts} highcharts/plotoptions/area-step/ Stepped, stacked area
	             * @sample {highstock} stock/plotoptions/line-step/ Step line
	             * @default {highcharts} null
	             * @default {highstock} false
	             * @since 1.2.5
	             * @product highcharts highstock
	             * @apioption plotOptions.series.step
	             */
	
	            /**
	             * The threshold, also called zero level or base level. For line type
	             * series this is only used in conjunction with [negativeColor](#plotOptions.
	             * series.negativeColor).
	             * 
	             * @type {Number}
	             * @see [softThreshold](#plotOptions.series.softThreshold).
	             * @default 0
	             * @since 3.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.threshold
	             */
	
	            /**
	             * Set the initial visibility of the series.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-visible/ Two series, one hidden and one visible
	             * @sample {highstock} stock/plotoptions/series-visibility/ Hidden series
	             * @default true
	             * @apioption plotOptions.series.visible
	             */
	
	            /**
	             * Defines the Axis on which the zones are applied.
	             * 
	             * @type {String}
	             * @see [zones](#plotOption.series.zones)
	             * @sample {highcharts} highcharts/series/color-zones-zoneaxis-x/ Zones on the X-Axis
	             * @sample {highstock} highcharts/series/color-zones-zoneaxis-x/ Zones on the X-Axis
	             * @default y
	             * @since 4.1.0
	             * @product highcharts highstock
	             * @apioption plotOptions.series.zoneAxis
	             */
	
	            /**
	             * @product highcharts highstock highmaps
	             */
	            events: {},
	
	
	
	            /**
	             * Options for the point markers of line-like series. Properties like
	             * `fillColor`, `lineColor` and `lineWidth` define the visual appearance
	             * of the markers. Other series types, like column series, don't have
	             * markers, but have visual options on the series level instead.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the markers can be styled with the `.highcharts-
	             * point`, `.highcharts-point-hover` and `.highcharts-point-select`
	             * class names.
	             * 
	             * @product highcharts highstock
	             */
	            marker: {
	
	
	
	                /**
	                 * The width of the point marker's outline.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-marker-fillcolor/ 2px blue marker
	                 * @default 0
	                 * @product highcharts highstock
	                 */
	                lineWidth: 0,
	
	
	                /**
	                 * The color of the point marker's outline. When `null`, the series'
	                 * or point's color is used.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-marker-fillcolor/ Inherit from series color (null)
	                 * @default #ffffff
	                 * @product highcharts highstock
	                 */
	                lineColor: '#ffffff',
	                //fillColor: null,
	
	                //enabled: true,
	                //symbol: null,
	
	
	                /**
	                 * The radius of the point marker.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-marker-radius/ Bigger markers
	                 * @default 4
	                 * @product highcharts highstock
	                 */
	                radius: 4,
	
	
	                /**
	                 * @product highcharts highstock
	                 */
	                states: { // states for a single point
	
	
	
	                    /**
	                     * @product highcharts highstock
	                     */
	                    hover: {
	
	
	
	                        /**
	                         */
	                        animation: {
	
	
	                            /**
	                             */
	                            duration: 50
	                        },
	
	
	
	                        /**
	                         * Enable or disable the point marker.
	                         * 
	                         * @type {Boolean}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-hover-enabled/ Disabled hover state
	                         * @default true
	                         * @product highcharts highstock
	                         */
	                        enabled: true,
	
	
	
	                        /**
	                         * The number of pixels to increase the radius of the hovered point.
	                         * 
	                         * @type {Number}
	                         * @sample {highcharts} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels greater radius on hover
	                         * @sample {highstock} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels greater radius on hover
	                         * @default 2
	                         * @since 4.0.3
	                         * @product highcharts highstock
	                         */
	                        radiusPlus: 2,
	
	
	
	
	                        /**
	                         * The additional line width for a hovered point.
	                         * 
	                         * @type {Number}
	                         * @sample {highcharts} highcharts/plotoptions/series-states-hover-linewidthplus/ 2 pixels wider on hover
	                         * @sample {highstock} highcharts/plotoptions/series-states-hover-linewidthplus/ 2 pixels wider on hover
	                         * @default 1
	                         * @since 4.0.3
	                         * @product highcharts highstock
	                         */
	                        lineWidthPlus: 1
	
	                    },
	
	
	
	
	                    /**
	                     * The appearance of the point marker when selected. In order to
	                     * allow a point to be selected, set the `series.allowPointSelect`
	                     * option to true.
	                     * 
	                     * @product highcharts highstock
	                     */
	                    select: {
	
	
	
	                        /**
	                         * The fill color of the point marker.
	                         * 
	                         * @type {Color}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-select-fillcolor/ Solid red discs for selected points
	                         * @default null
	                         * @product highcharts highstock
	                         */
	                        fillColor: '#cccccc',
	
	
	
	                        /**
	                         * The color of the point marker's outline. When `null`, the series'
	                         * or point's color is used.
	                         * 
	                         * @type {Color}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-select-linecolor/ Red line color for selected points
	                         * @default #000000
	                         * @product highcharts highstock
	                         */
	                        lineColor: '#000000',
	
	
	
	                        /**
	                         * The width of the point marker's outline.
	                         * 
	                         * @type {Number}
	                         * @sample {highcharts} highcharts/plotoptions/series-marker-states-select-linewidth/ 3px line width for selected points
	                         * @default 0
	                         * @product highcharts highstock
	                         */
	                        lineWidth: 2
	                    }
	
	                }
	            },
	
	
	
	            /**
	             * Properties for each single point
	             * 
	             * @product highcharts highstock highmaps
	             */
	            point: {
	
	
	                /**
	                 * Events for each single point
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                events: {}
	            },
	
	
	
	            /**
	             * Options for the series data labels, appearing next to each data
	             * point.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the data labels can be styled wtih the `.highcharts-
	             * data-label-box` and `.highcharts-data-label` class names ([see example](http://jsfiddle.
	             * net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-
	             * datalabels)).
	             */
	            dataLabels: {
	
	
	                /**
	                 * The alignment of the data label compared to the point. If `right`,
	                 * the right side of the label should be touching the point. For
	                 * points with an extent, like columns, the alignments also dictates
	                 * how to align it inside the box, as given with the [inside](#plotOptions.
	                 * column.dataLabels.inside) option. Can be one of "left", "center"
	                 * or "right".
	                 * 
	                 * @validvalue ["left", "center", "right"]
	                 * @type {String}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-align-left/ Left aligned
	                 * @default center
	                 */
	                align: 'center',
	
	
	                /**
	                 * Whether to allow data labels to overlap. To make the labels less
	                 * sensitive for overlapping, the [dataLabels.padding](#plotOptions.
	                 * series.dataLabels.padding) can be set to 0.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-allowoverlap-false/ Don't allow overlap
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-allowoverlap-false/ Don't allow overlap
	                 * @sample {highmaps} highcharts/plotoptions/series-datalabels-allowoverlap-false/ Don't allow overlap
	                 * @default false
	                 * @since 4.1.0
	                 * @apioption plotOptions.series.dataLabels.allowOverlap
	                 */
	
	
	                /**
	                 * The border radius in pixels for the data label.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default 0
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.borderRadius
	                 */
	
	
	                /**
	                 * The border width in pixels for the data label.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default 0
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.borderWidth
	                 */
	
	                /**
	                 * A class name for the data label. Particularly in [styled mode](http://www.
	                 * highcharts.com/docs/chart-design-and-style/style-by-css), this can
	                 * be used to give each series' or point's data label unique styling.
	                 * In addition to this option, a default color class name is added
	                 * so that we can give the labels a [contrast text shadow](http://jsfiddle.
	                 * net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/data-
	                 * label-contrast/).
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/css/series-datalabels/ Styling by CSS
	                 * @sample {highstock} highcharts/css/series-datalabels/ Styling by CSS
	                 * @sample {highmaps} highcharts/css/series-datalabels/ Styling by CSS
	                 * @since 5.0.0
	                 * @apioption plotOptions.series.dataLabels.className
	                 */
	
	                /**
	                 * The text color for the data labels. Defaults to `null`. For certain series
	                 * types, like column or map, the data labels can be drawn inside the points.
	                 * In this case the data label will be drawn with maximum contrast by default.
	                 * Additionally, it will be given a `text-outline` style with the opposite
	                 * color, to further increase the contrast. This can be overridden by setting
	                 * the `text-outline` style to `none` in the `dataLabels.style` option.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-color/
	                 *         Red data labels
	                 * @sample {highmaps} maps/demo/color-axis/
	                 *         White data labels
	                 * @apioption plotOptions.series.dataLabels.color
	                 */
	
	                /**
	                 * Whether to hide data labels that are outside the plot area. By default,
	                 * the data label is moved inside the plot area according to the [overflow](#plotOptions.
	                 * series.dataLabels.overflow) option.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 2.3.3
	                 * @apioption plotOptions.series.dataLabels.crop
	                 */
	
	                /**
	                 * Whether to defer displaying the data labels until the initial series
	                 * animation has finished.
	                 * 
	                 * @type {Boolean}
	                 * @default true
	                 * @since 4.0
	                 * @product highcharts highstock
	                 * @apioption plotOptions.series.dataLabels.defer
	                 */
	
	                /**
	                 * Enable or disable the data labels.
	                 * 
	                 * @type {Boolean}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-enabled/ Data labels enabled
	                 * @sample {highmaps} maps/demo/color-axis/ Data labels enabled
	                 * @default false
	                 * @apioption plotOptions.series.dataLabels.enabled
	                 */
	
	                /**
	                 * A [format string](http://www.highcharts.com/docs/chart-concepts/labels-
	                 * and-string-formatting) for the data label. Available variables are
	                 * the same as for `formatter`.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-format/ Add a unit
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-format/ Add a unit
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-format/ Formatted value in the data label
	                 * @default {highcharts} {y}
	                 * @default {highstock} {y}
	                 * @default {highmaps} {point.value}
	                 * @since 3.0
	                 * @apioption plotOptions.series.dataLabels.format
	                 */
	
	                /**
	                 * Callback JavaScript function to format the data label. Note that
	                 * if a `format` is defined, the format takes precedence and the formatter
	                 * is ignored. Available data are:
	                 * 
	                 * <table>
	                 * 
	                 * <tbody>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.percentage`</td>
	                 * 
	                 * <td>Stacked series and pies only. The point's percentage of the
	                 * total.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.point`</td>
	                 * 
	                 * <td>The point object. The point name, if defined, is available
	                 * through `this.point.name`.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.series`:</td>
	                 * 
	                 * <td>The series object. The series name is available through `this.
	                 * series.name`.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.total`</td>
	                 * 
	                 * <td>Stacked series only. The total value at this point's x value.
	                 * </td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.x`:</td>
	                 * 
	                 * <td>The x value.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * <tr>
	                 * 
	                 * <td>`this.y`:</td>
	                 * 
	                 * <td>The y value.</td>
	                 * 
	                 * </tr>
	                 * 
	                 * </tbody>
	                 * 
	                 * </table>
	                 * 
	                 * @type {Function}
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-format/ Formatted value
	                 * @product highcharts highstock highmaps
	                 */
	                formatter: function() {
	                    return this.y === null ? '' : H.numberFormat(this.y, -1);
	                },
	
	
	
	                /**
	                 * Styles for the label. The default `color` setting is `"contrast"`,
	                 * which is a pseudo color that Highcharts picks up and applies the
	                 * maximum contrast to the underlying point item, for example the
	                 * bar in a bar chart. The `textOutline` is a pseudo property that
	                 * applies an outline of the given width with the given color, which
	                 * by default is the maximum contrast to the text. So a bright text
	                 * color will result in a black text outline for maximum readability
	                 * on a mixed background. In some cases, especially with grayscale
	                 * text, the text outline doesn't work well, in which cases it can
	                 * be disabled by setting it to `"none"`.
	                 * 
	                 * @type {CSSObject}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-style/
	                 *         Bold labels
	                 * @sample {highmaps} maps/demo/color-axis/ Bold labels
	                 * @default {"color": "contrast", "fontSize": "11px", "fontWeight": "bold", "textOutline": "1px contrast" }
	                 * @since 4.1.0
	                 */
	                style: {
	                    fontSize: '11px',
	                    fontWeight: 'bold',
	                    color: 'contrast',
	                    textOutline: '1px contrast'
	                },
	
	                /**
	                 * The background color or gradient for the data label. Defaults to
	                 * `undefined`.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-box/ Data labels box options
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.backgroundColor
	                 */
	
	                /**
	                 * The border color for the data label. Defaults to `undefined`.
	                 * 
	                 * @type {Color}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default undefined
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.borderColor
	                 */
	
	                /**
	                 * The shadow of the box. Works best with `borderWidth` or `backgroundColor`.
	                 * Since 2.3 the shadow can be an object configuration containing `color`,
	                 *  `offsetX`, `offsetY`, `opacity` and `width`.
	                 * 
	                 * @type {Boolean|Object}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default false
	                 * @since 2.2.1
	                 * @apioption plotOptions.series.dataLabels.shadow
	                 */
	
	
	                /**
	                 * For points with an extent, like columns or map areas, whether to align the data
	                 * label inside the box or to the actual value point. Defaults to `false`
	                 * in most cases, `true` in stacked columns.
	                 * 
	                 * @type {Boolean}
	                 * @since 3.0
	                 * @apioption plotOptions.series.dataLabels.inside
	                 */
	
	                /**
	                 * How to handle data labels that flow outside the plot area. The default
	                 * is `justify`, which aligns them inside the plot area. For columns
	                 * and bars, this means it will be moved inside the bar. To display
	                 * data labels outside the plot area, set `crop` to `false` and `overflow`
	                 * to `"none"`.
	                 * 
	                 * @validvalue ["justify", "none"]
	                 * @type {String}
	                 * @default justify
	                 * @since 3.0.6
	                 * @apioption plotOptions.series.dataLabels.overflow
	                 */
	
	                /**
	                 * Text rotation in degrees. Note that due to a more complex structure,
	                 * backgrounds, borders and padding will be lost on a rotated data
	                 * label.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-rotation/ Vertical labels
	                 * @default 0
	                 * @apioption plotOptions.series.dataLabels.rotation
	                 */
	
	                /**
	                 * The vertical alignment of a data label. Can be one of `top`, `middle`
	                 * or `bottom`. The default value depends on the data, for instance
	                 * in a column chart, the label is above positive values and below
	                 * negative values.
	                 * 
	                 * @validvalue ["top", "middle", "bottom"]
	                 * @type {String}
	                 * @since 2.3.3
	                 * @product highcharts highstock highmaps
	                 */
	                verticalAlign: 'bottom', // above singular point
	
	
	                /**
	                 * The x position offset of the label relative to the point.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-rotation/ Vertical and positioned
	                 * @default 0
	                 * @product highcharts highstock highmaps
	                 */
	                x: 0,
	
	
	                /**
	                 * The y position offset of the label relative to the point.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-rotation/ Vertical and positioned
	                 * @default -6
	                 * @product highcharts highstock highmaps
	                 */
	                y: 0,
	
	
	                /**
	                 * When either the `borderWidth` or the `backgroundColor` is set,
	                 * this is the padding within the box.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-box/ Data labels box options
	                 * @sample {highmaps} maps/plotoptions/series-datalabels-box/ Data labels box options
	                 * @default {highcharts} 5
	                 * @default {highstock} 5
	                 * @default {highmaps} 0
	                 * @since 2.2.1
	                 * @product highcharts highstock highmaps
	                 */
	                padding: 5
	
	                /**
	                 * The name of a symbol to use for the border around the label. Symbols
	                 * are predefined functions on the Renderer object.
	                 * 
	                 * @type {String}
	                 * @sample {highcharts} highcharts/plotoptions/series-datalabels-shape/ A callout for annotations
	                 * @sample {highstock} highcharts/plotoptions/series-datalabels-shape/ A callout for annotations
	                 * @sample {highmaps} highcharts/plotoptions/series-datalabels-shape/ A callout for annotations (Highcharts demo)
	                 * @default square
	                 * @since 4.1.2
	                 * @apioption plotOptions.series.dataLabels.shape
	                 */
	
	                /**
	                 * The Z index of the data labels. The default Z index puts it above
	                 * the series. Use a Z index of 2 to display it behind the series.
	                 * 
	                 * @type {Number}
	                 * @default 6
	                 * @since 2.3.5
	                 * @apioption plotOptions.series.dataLabels.zIndex
	                 */
	            },
	            // draw points outside the plot area when the number of points is less than
	            // this
	
	
	
	            /**
	             * When the series contains less points than the crop threshold, all
	             * points are drawn, even if the points fall outside the visible plot
	             * area at the current zoom. The advantage of drawing all points (including
	             * markers and columns), is that animation is performed on updates.
	             * On the other hand, when the series contains more points than the
	             * crop threshold, the series data is cropped to only contain points
	             * that fall within the plot area. The advantage of cropping away invisible
	             * points is to increase performance on large series.
	             * 
	             * @type {Number}
	             * @default 300
	             * @since 2.2
	             * @product highcharts highstock
	             */
	            cropThreshold: 300,
	
	
	
	            /**
	             * The width of each point on the x axis. For example in a column chart
	             * with one value each day, the pointRange would be 1 day (= 24 * 3600
	             * * 1000 milliseconds). This is normally computed automatically, but
	             * this option can be used to override the automatic value.
	             * 
	             * @type {Number}
	             * @default 0
	             * @product highstock
	             */
	            pointRange: 0,
	            //pointStart: 0,
	            //pointInterval: 1,
	            //showInLegend: null, // auto = false for linked series
	
	
	
	            /**
	             * When this is true, the series will not cause the Y axis to cross
	             * the zero plane (or [threshold](#plotOptions.series.threshold) option)
	             * unless the data actually crosses the plane.
	             * 
	             * For example, if `softThreshold` is `false`, a series of 0, 1, 2,
	             * 3 will make the Y axis show negative values according to the `minPadding`
	             * option. If `softThreshold` is `true`, the Y axis starts at 0.
	             * 
	             * @type {Boolean}
	             * @default true
	             * @since 4.1.9
	             * @product highcharts highstock
	             */
	            softThreshold: true,
	
	
	
	            /**
	             * A wrapper object for all the series options in specific states.
	             * 
	             * @type {plotOptions.series.states}
	             * @product highcharts highstock highmaps
	             */
	            states: { // states for the entire series
	
	
	                /**
	                 * Options for the hovered series
	                 * 
	                 * @product highcharts highstock highmaps
	                 */
	                hover: {
	                    //enabled: false,
	
	
	
	                    /**
	                     * Animation setting for hovering the graph in line-type series.
	                     * 
	                     * @type {Boolean|Object}
	                     * @default { "duration": 50 }
	                     * @since 5.0.8
	                     * @product highcharts
	                     */
	                    animation: {
	
	
	
	                        /**
	                         */
	                        duration: 50
	                    },
	
	
	
	                    /**
	                     * The additional line width for the graph of a hovered series.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels wider
	                     * @sample {highstock} highcharts/plotoptions/series-states-hover-linewidthplus/ 5 pixels wider
	                     * @default 1
	                     * @since 4.0.3
	                     * @product highcharts highstock
	                     */
	                    lineWidthPlus: 1,
	
	
	
	                    /**
	                     * In Highcharts 1.0, the appearance of all markers belonging to
	                     * the hovered series. For settings on the hover state of the individual
	                     * point, see [marker.states.hover](#plotOptions.series.marker.states.
	                     * hover).
	                     * 
	                     * @extends plotOptions.series.marker
	                     * @deprecated
	                     * @product highcharts highstock
	                     */
	                    marker: {
	                        // lineWidth: base + 1,
	                        // radius: base + 1
	                    },
	
	
	
	                    /**
	                     * Options for the halo appearing around the hovered point in line-
	                     * type series as well as outside the hovered slice in pie charts.
	                     * By default the halo is filled by the current point or series
	                     * color with an opacity of 0.25\. The halo can be disabled by setting
	                     * the `halo` option to `false`.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the halo is styled with the `.highcharts-
	                     * halo` class, with colors inherited from `.highcharts-color-{n}`.
	                     * 
	                     * @type {Object}
	                     * @sample {highcharts} highcharts/plotoptions/halo/ Halo options
	                     * @sample {highstock} highcharts/plotoptions/halo/ Halo options
	                     * @since 4.0
	                     * @product highcharts highstock
	                     */
	                    halo: {
	
	
	
	                        /**
	                         * The pixel size of the halo. For point markers this is the radius
	                         * of the halo. For pie slices it is the width of the halo outside
	                         * the slice. For bubbles it defaults to 5 and is the width of the
	                         * halo outside the bubble.
	                         * 
	                         * @type {Number}
	                         * @default 10
	                         * @since 4.0
	                         * @product highcharts highstock
	                         */
	                        size: 10,
	
	
	
	
	                        /**
	                         * Opacity for the halo unless a specific fill is overridden using
	                         * the `attributes` setting. Note that Highcharts is only able to
	                         * apply opacity to colors of hex or rgb(a) formats.
	                         * 
	                         * @type {Number}
	                         * @default 0.25
	                         * @since 4.0
	                         * @product highcharts highstock
	                         */
	                        opacity: 0.25
	
	                    }
	                },
	
	
	                /**
	                 * Specific options for point in selected states, after being selected
	                 * by [allowPointSelect](#plotOptions.series.allowPointSelect) or
	                 * programmatically.
	                 * 
	                 * @type {Object}
	                 * @extends plotOptions.series.states.hover
	                 * @excluding brightness
	                 * @sample {highmaps} maps/plotoptions/series-allowpointselect/ Allow point select demo
	                 * @product highmaps
	                 */
	                select: {
	
	
	
	                    /**
	                     */
	                    marker: {}
	                }
	            },
	
	
	
	            /**
	             * Sticky tracking of mouse events. When true, the `mouseOut` event
	             * on a series isn't triggered until the mouse moves over another series,
	             * or out of the plot area. When false, the `mouseOut` event on a
	             * series is triggered when the mouse leaves the area around the series'
	             * graph or markers. This also implies the tooltip when not shared. When
	             * `stickyTracking` is false and `tooltip.shared` is false, the tooltip will
	             * be hidden when moving the mouse between series. Defaults to true for line
	             * and area type series, but to false for columns, pies etc.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-stickytracking-true/
	             *         True by default
	             * @sample {highcharts} highcharts/plotoptions/series-stickytracking-false/
	             *         False
	             * @default {highcharts} true
	             * @default {highstock} true
	             * @default {highmaps} false
	             * @since 2.0
	             * @product highcharts highstock highmaps
	             */
	            stickyTracking: true,
	            //tooltip: {
	            //pointFormat: '<span style="color:{point.color}">\u25CF</span>' +
	            // '{series.name}: <b>{point.y}</b>'
	            //valueDecimals: null,
	            //xDateFormat: '%A, %b %e, %Y',
	            //valuePrefix: '',
	            //ySuffix: ''
	            //}
	
	
	
	            /**
	             * When a series contains a data array that is longer than this, only
	             * one dimensional arrays of numbers, or two dimensional arrays with
	             * x and y values are allowed. Also, only the first point is tested,
	             * and the rest are assumed to be the same format. This saves expensive
	             * data checking and indexing in long series. Set it to `0` disable.
	             * 
	             * @type {Number}
	             * @default 1000
	             * @since 2.2
	             * @product highcharts highstock
	             */
	            turboThreshold: 1000,
	            // zIndex: null
	
	
	
	            /**
	             * Determines whether the series should look for the nearest point
	             * in both dimensions or just the x-dimension when hovering the series.
	             * Defaults to `'xy'` for scatter series and `'x'` for most other
	             * series. If the data has duplicate x-values, it is recommended to
	             * set this to `'xy'` to allow hovering over all points.
	             * 
	             * Applies only to series types using nearest neighbor search (not
	             * direct hover) for tooltip.
	             * 
	             * @validvalue ['x', 'xy']
	             * @type {String}
	             * @sample {highcharts} highcharts/series/findnearestpointby/ Different hover behaviors
	             * @sample {highstock} highcharts/series/findnearestpointby/ Different hover behaviors
	             * @sample {highmaps} highcharts/series/findnearestpointby/ Different hover behaviors
	             * @since 5.0.10
	             * @product highcharts highstock highmaps
	             */
	            findNearestPointBy: 'x'
	
	        }, /** @lends Highcharts.Series.prototype */ {
	            isCartesian: true,
	            pointClass: Point,
	            sorted: true, // requires the data to be sorted
	            requireSorting: true,
	            directTouch: false,
	            axisTypes: ['xAxis', 'yAxis'],
	            colorCounter: 0,
	            // each point's x and y values are stored in this.xData and this.yData
	            parallelArrays: ['x', 'y'],
	            coll: 'series',
	            init: function(chart, options) {
	                var series = this,
	                    events,
	                    chartSeries = chart.series,
	                    lastSeries;
	
	                /**
	                 * Read only. The chart that the series belongs to.
	                 *
	                 * @name chart
	                 * @memberOf Series
	                 * @type {Chart}
	                 */
	                series.chart = chart;
	
	                /**
	                 * Read only. The series' type, like "line", "area", "column" etc. The
	                 * type in the series options anc can be altered using {@link
	                 * Series#update}.
	                 *
	                 * @name type
	                 * @memberOf Series
	                 * @type String
	                 */
	
	                /**
	                 * Read only. The series' current options. To update, use {@link
	                 * Series#update}.
	                 *
	                 * @name options
	                 * @memberOf Series
	                 * @type SeriesOptions
	                 */
	                series.options = options = series.setOptions(options);
	                series.linkedSeries = [];
	
	                // bind the axes
	                series.bindAxes();
	
	                // set some variables
	                extend(series, {
	                    /**
	                     * The series name as given in the options. Defaults to
	                     * "Series {n}".
	                     *
	                     * @name name
	                     * @memberOf Series
	                     * @type {String}
	                     */
	                    name: options.name,
	                    state: '',
	                    /**
	                     * Read only. The series' visibility state as set by {@link
	                     * Series#show}, {@link Series#hide}, or in the initial
	                     * configuration.
	                     *
	                     * @name visible
	                     * @memberOf Series
	                     * @type {Boolean}
	                     */
	                    visible: options.visible !== false, // true by default
	                    /**
	                     * Read only. The series' selected state as set by {@link
	                     * Highcharts.Series#select}.
	                     *
	                     * @name selected
	                     * @memberOf Series
	                     * @type {Boolean}
	                     */
	                    selected: options.selected === true // false by default
	                });
	
	                // register event listeners
	                events = options.events;
	
	                objectEach(events, function(event, eventType) {
	                    addEvent(series, eventType, event);
	                });
	                if (
	                    (events && events.click) ||
	                    (
	                        options.point &&
	                        options.point.events &&
	                        options.point.events.click
	                    ) ||
	                    options.allowPointSelect
	                ) {
	                    chart.runTrackerClick = true;
	                }
	
	                series.getColor();
	                series.getSymbol();
	
	                // Set the data
	                each(series.parallelArrays, function(key) {
	                    series[key + 'Data'] = [];
	                });
	                series.setData(options.data, false);
	
	                // Mark cartesian
	                if (series.isCartesian) {
	                    chart.hasCartesianSeries = true;
	                }
	
	                // Get the index and register the series in the chart. The index is one
	                // more than the current latest series index (#5960).
	                if (chartSeries.length) {
	                    lastSeries = chartSeries[chartSeries.length - 1];
	                }
	                series._i = pick(lastSeries && lastSeries._i, -1) + 1;
	
	                // Insert the series and re-order all series above the insertion point.
	                chart.orderSeries(this.insert(chartSeries));
	            },
	
	            /**
	             * Insert the series in a collection with other series, either the chart
	             * series or yAxis series, in the correct order according to the index
	             * option. Used internally when adding series.
	             *
	             * @private
	             * @param   {Array.<Series>} collection
	             *          A collection of series, like `chart.series` or `xAxis.series`.
	             * @returns {Number} The index of the series in the collection.
	             */
	            insert: function(collection) {
	                var indexOption = this.options.index,
	                    i;
	
	                // Insert by index option
	                if (isNumber(indexOption)) {
	                    i = collection.length;
	                    while (i--) {
	                        // Loop down until the interted element has higher index
	                        if (indexOption >=
	                            pick(collection[i].options.index, collection[i]._i)) {
	                            collection.splice(i + 1, 0, this);
	                            break;
	                        }
	                    }
	                    if (i === -1) {
	                        collection.unshift(this);
	                    }
	                    i = i + 1;
	
	                    // Or just push it to the end
	                } else {
	                    collection.push(this);
	                }
	                return pick(i, collection.length - 1);
	            },
	
	            /**
	             * Set the xAxis and yAxis properties of cartesian series, and register the
	             * series in the `axis.series` array.
	             *
	             * @private
	             */
	            bindAxes: function() {
	                var series = this,
	                    seriesOptions = series.options,
	                    chart = series.chart,
	                    axisOptions;
	
	                // repeat for xAxis and yAxis
	                each(series.axisTypes || [], function(AXIS) {
	
	                    // loop through the chart's axis objects
	                    each(chart[AXIS], function(axis) {
	                        axisOptions = axis.options;
	
	                        // apply if the series xAxis or yAxis option mathches the number
	                        // of the axis, or if undefined, use the first axis
	                        if (
	                            seriesOptions[AXIS] === axisOptions.index ||
	                            (
	                                seriesOptions[AXIS] !== undefined &&
	                                seriesOptions[AXIS] === axisOptions.id
	                            ) ||
	                            (
	                                seriesOptions[AXIS] === undefined &&
	                                axisOptions.index === 0
	                            )
	                        ) {
	
	                            // register this series in the axis.series lookup
	                            series.insert(axis.series);
	
	                            // set this series.xAxis or series.yAxis reference
	                            /**
	                             * Read only. The unique xAxis object associated with the
	                             * series.
	                             *
	                             * @name xAxis
	                             * @memberOf Series
	                             * @type Axis
	                             */
	                            /**
	                             * Read only. The unique yAxis object associated with the
	                             * series.
	                             *
	                             * @name yAxis
	                             * @memberOf Series
	                             * @type Axis
	                             */
	                            series[AXIS] = axis;
	
	                            // mark dirty for redraw
	                            axis.isDirty = true;
	                        }
	                    });
	
	                    // The series needs an X and an Y axis
	                    if (!series[AXIS] && series.optionalAxis !== AXIS) {
	                        H.error(18, true);
	                    }
	
	                });
	            },
	
	            /**
	             * For simple series types like line and column, the data values are held in
	             * arrays like xData and yData for quick lookup to find extremes and more.
	             * For multidimensional series like bubble and map, this can be extended
	             * with arrays like zData and valueData by adding to the
	             * `series.parallelArrays` array.
	             *
	             * @private
	             */
	            updateParallelArrays: function(point, i) {
	                var series = point.series,
	                    args = arguments,
	                    fn = isNumber(i) ?
	                    // Insert the value in the given position
	                    function(key) {
	                        var val = key === 'y' && series.toYData ?
	                            series.toYData(point) :
	                            point[key];
	                        series[key + 'Data'][i] = val;
	                    } :
	                    // Apply the method specified in i with the following arguments
	                    // as arguments
	                    function(key) {
	                        Array.prototype[i].apply(
	                            series[key + 'Data'],
	                            Array.prototype.slice.call(args, 2)
	                        );
	                    };
	
	                each(series.parallelArrays, fn);
	            },
	
	            /**
	             * Return an auto incremented x value based on the pointStart and
	             * pointInterval options. This is only used if an x value is not given for
	             * the point that calls autoIncrement.
	             *
	             * @private
	             */
	            autoIncrement: function() {
	
	                var options = this.options,
	                    xIncrement = this.xIncrement,
	                    date,
	                    pointInterval,
	                    pointIntervalUnit = options.pointIntervalUnit;
	
	                xIncrement = pick(xIncrement, options.pointStart, 0);
	
	                this.pointInterval = pointInterval = pick(
	                    this.pointInterval,
	                    options.pointInterval,
	                    1
	                );
	
	                // Added code for pointInterval strings
	                if (pointIntervalUnit) {
	                    date = new Date(xIncrement);
	
	                    if (pointIntervalUnit === 'day') {
	                        date = +date[Date.hcSetDate](
	                            date[Date.hcGetDate]() + pointInterval
	                        );
	                    } else if (pointIntervalUnit === 'month') {
	                        date = +date[Date.hcSetMonth](
	                            date[Date.hcGetMonth]() + pointInterval
	                        );
	                    } else if (pointIntervalUnit === 'year') {
	                        date = +date[Date.hcSetFullYear](
	                            date[Date.hcGetFullYear]() + pointInterval
	                        );
	                    }
	                    pointInterval = date - xIncrement;
	
	                }
	
	                this.xIncrement = xIncrement + pointInterval;
	                return xIncrement;
	            },
	
	            /**
	             * Set the series options by merging from the options tree. Called
	             * internally on initiating and updating series. This function will not
	             * redraw the series. For API usage, use {@link Series#update}.
	             * 
	             * @param  {Options.plotOptions.series} itemOptions
	             *         The series options.
	             */
	            setOptions: function(itemOptions) {
	                var chart = this.chart,
	                    chartOptions = chart.options,
	                    plotOptions = chartOptions.plotOptions,
	                    userOptions = chart.userOptions || {},
	                    userPlotOptions = userOptions.plotOptions || {},
	                    typeOptions = plotOptions[this.type],
	                    options,
	                    zones;
	
	                this.userOptions = itemOptions;
	
	                // General series options take precedence over type options because
	                // otherwise, default type options like column.animation would be
	                // overwritten by the general option. But issues have been raised here
	                // (#3881), and the solution may be to distinguish between default
	                // option and userOptions like in the tooltip below.
	                options = merge(
	                    typeOptions,
	                    plotOptions.series,
	                    itemOptions
	                );
	
	                // The tooltip options are merged between global and series specific
	                // options. Importance order asscendingly:
	                // globals: (1)tooltip, (2)plotOptions.series, (3)plotOptions[this.type]
	                // init userOptions with possible later updates: 4-6 like 1-3 and
	                // (7)this series options
	                this.tooltipOptions = merge(
	                    defaultOptions.tooltip, // 1
	                    defaultOptions.plotOptions.series &&
	                    defaultOptions.plotOptions.series.tooltip, // 2
	                    defaultOptions.plotOptions[this.type].tooltip, // 3
	                    chartOptions.tooltip.userOptions, // 4
	                    plotOptions.series && plotOptions.series.tooltip, // 5
	                    plotOptions[this.type].tooltip, // 6
	                    itemOptions.tooltip // 7
	                );
	
	                // When shared tooltip, stickyTracking is true by default,
	                // unless user says otherwise.
	                this.stickyTracking = pick(
	                    itemOptions.stickyTracking,
	                    userPlotOptions[this.type] &&
	                    userPlotOptions[this.type].stickyTracking,
	                    userPlotOptions.series && userPlotOptions.series.stickyTracking,
	                    (
	                        this.tooltipOptions.shared && !this.noSharedTooltip ?
	                        true :
	                        options.stickyTracking
	                    )
	                );
	
	                // Delete marker object if not allowed (#1125)
	                if (typeOptions.marker === null) {
	                    delete options.marker;
	                }
	
	                // Handle color zones
	                this.zoneAxis = options.zoneAxis;
	                zones = this.zones = (options.zones || []).slice();
	                if (
	                    (options.negativeColor || options.negativeFillColor) &&
	                    !options.zones
	                ) {
	                    zones.push({
	                        value: options[this.zoneAxis + 'Threshold'] ||
	                            options.threshold ||
	                            0,
	                        className: 'highcharts-negative',
	
	                        color: options.negativeColor,
	                        fillColor: options.negativeFillColor
	
	                    });
	                }
	                if (zones.length) { // Push one extra zone for the rest
	                    if (defined(zones[zones.length - 1].value)) {
	                        zones.push({
	
	                            color: this.color,
	                            fillColor: this.fillColor
	
	                        });
	                    }
	                }
	                return options;
	            },
	
	            getCyclic: function(prop, value, defaults) {
	                var i,
	                    chart = this.chart,
	                    userOptions = this.userOptions,
	                    indexName = prop + 'Index',
	                    counterName = prop + 'Counter',
	                    len = defaults ? defaults.length : pick(
	                        chart.options.chart[prop + 'Count'],
	                        chart[prop + 'Count']
	                    ),
	                    setting;
	
	                if (!value) {
	                    // Pick up either the colorIndex option, or the _colorIndex after
	                    // Series.update()
	                    setting = pick(
	                        userOptions[indexName],
	                        userOptions['_' + indexName]
	                    );
	                    if (defined(setting)) { // after Series.update()
	                        i = setting;
	                    } else {
	                        // #6138
	                        if (!chart.series.length) {
	                            chart[counterName] = 0;
	                        }
	                        userOptions['_' + indexName] = i = chart[counterName] % len;
	                        chart[counterName] += 1;
	                    }
	                    if (defaults) {
	                        value = defaults[i];
	                    }
	                }
	                // Set the colorIndex
	                if (i !== undefined) {
	                    this[indexName] = i;
	                }
	                this[prop] = value;
	            },
	
	            /**
	             * Get the series' color based on either the options or pulled from global
	             * options.
	             *
	             * @return  {Color} The series color.
	             */
	
	            getColor: function() {
	                if (this.options.colorByPoint) {
	                    // #4359, selected slice got series.color even when colorByPoint was
	                    // set.
	                    this.options.color = null;
	                } else {
	                    this.getCyclic(
	                        'color',
	                        this.options.color || defaultPlotOptions[this.type].color,
	                        this.chart.options.colors
	                    );
	                }
	            },
	
	            /**
	             * Get the series' symbol based on either the options or pulled from global
	             * options.
	             */
	            getSymbol: function() {
	                var seriesMarkerOption = this.options.marker;
	
	                this.getCyclic(
	                    'symbol',
	                    seriesMarkerOption.symbol,
	                    this.chart.options.symbols
	                );
	            },
	
	            drawLegendSymbol: LegendSymbolMixin.drawLineMarker,
	
	            /**
	             * Apply a new set of data to the series and optionally redraw it. The new
	             * data array is passed by reference (except in case of `updatePoints`), and
	             * may later be mutated when updating the chart data.
	             *
	             * Note the difference in behaviour when setting the same amount of points,
	             * or a different amount of points, as handled by the `updatePoints`
	             * parameter.
	             *
	             * @param  {SeriesDataOptions} data
	             *         Takes an array of data in the same format as described under
	             *         `series<type>data` for the given series type.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw} after.
	             * @param  {AnimationOptions} [animation]
	             *         When the updated data is the same length as the existing data,
	             *         points will be updated by default, and animation visualizes how
	             *         the points are changed. Set false to disable animation, or a
	             *         configuration object to set duration or easing.
	             * @param  {Boolean} [updatePoints=true]
	             *         When the updated data is the same length as the existing data,
	             *         points will be updated instead of replaced. This allows updating
	             *         with animation and performs better. In this case, the original
	             *         array is not passed by reference. Set false to prevent.
	             *
	             * @sample highcharts/members/series-setdata/
	             *         Set new data from a button
	             * @sample highcharts/members/series-setdata-pie/
	             *         Set data in a pie
	             * @sample stock/members/series-setdata/
	             *         Set new data in Highstock
	             * @sample maps/members/series-setdata/
	             *         Set new data in Highmaps
	             */
	            setData: function(data, redraw, animation, updatePoints) {
	                var series = this,
	                    oldData = series.points,
	                    oldDataLength = (oldData && oldData.length) || 0,
	                    dataLength,
	                    options = series.options,
	                    chart = series.chart,
	                    firstPoint = null,
	                    xAxis = series.xAxis,
	                    i,
	                    turboThreshold = options.turboThreshold,
	                    pt,
	                    xData = this.xData,
	                    yData = this.yData,
	                    pointArrayMap = series.pointArrayMap,
	                    valueCount = pointArrayMap && pointArrayMap.length;
	
	                data = data || [];
	                dataLength = data.length;
	                redraw = pick(redraw, true);
	
	                // If the point count is the same as is was, just run Point.update which
	                // is cheaper, allows animation, and keeps references to points.
	                if (
	                    updatePoints !== false &&
	                    dataLength &&
	                    oldDataLength === dataLength &&
	                    !series.cropped &&
	                    !series.hasGroupedData &&
	                    series.visible
	                ) {
	                    each(data, function(point, i) {
	                        // .update doesn't exist on a linked, hidden series (#3709)
	                        if (oldData[i].update && point !== options.data[i]) {
	                            oldData[i].update(point, false, null, false);
	                        }
	                    });
	
	                } else {
	
	                    // Reset properties
	                    series.xIncrement = null;
	
	                    series.colorCounter = 0; // for series with colorByPoint (#1547)
	
	                    // Update parallel arrays
	                    each(this.parallelArrays, function(key) {
	                        series[key + 'Data'].length = 0;
	                    });
	
	                    // In turbo mode, only one- or twodimensional arrays of numbers are
	                    // allowed. The first value is tested, and we assume that all the
	                    // rest are defined the same way. Although the 'for' loops are
	                    // similar, they are repeated inside each if-else conditional for
	                    // max performance.
	                    if (turboThreshold && dataLength > turboThreshold) {
	
	                        // find the first non-null point
	                        i = 0;
	                        while (firstPoint === null && i < dataLength) {
	                            firstPoint = data[i];
	                            i++;
	                        }
	
	
	                        if (isNumber(firstPoint)) { // assume all points are numbers
	                            for (i = 0; i < dataLength; i++) {
	                                xData[i] = this.autoIncrement();
	                                yData[i] = data[i];
	                            }
	
	                            // Assume all points are arrays when first point is
	                        } else if (isArray(firstPoint)) {
	                            if (valueCount) { // [x, low, high] or [x, o, h, l, c]
	                                for (i = 0; i < dataLength; i++) {
	                                    pt = data[i];
	                                    xData[i] = pt[0];
	                                    yData[i] = pt.slice(1, valueCount + 1);
	                                }
	                            } else { // [x, y]
	                                for (i = 0; i < dataLength; i++) {
	                                    pt = data[i];
	                                    xData[i] = pt[0];
	                                    yData[i] = pt[1];
	                                }
	                            }
	                        } else {
	                            // Highcharts expects configs to be numbers or arrays in
	                            // turbo mode
	                            H.error(12);
	                        }
	                    } else {
	                        for (i = 0; i < dataLength; i++) {
	                            if (data[i] !== undefined) { // stray commas in oldIE
	                                pt = {
	                                    series: series
	                                };
	                                series.pointClass.prototype.applyOptions.apply(
	                                    pt, [data[i]]
	                                );
	                                series.updateParallelArrays(pt, i);
	                            }
	                        }
	                    }
	
	                    // Forgetting to cast strings to numbers is a common caveat when
	                    // handling CSV or JSON
	                    if (isString(yData[0])) {
	                        H.error(14, true);
	                    }
	
	                    series.data = [];
	                    series.options.data = series.userOptions.data = data;
	
	                    // destroy old points
	                    i = oldDataLength;
	                    while (i--) {
	                        if (oldData[i] && oldData[i].destroy) {
	                            oldData[i].destroy();
	                        }
	                    }
	
	                    // reset minRange (#878)
	                    if (xAxis) {
	                        xAxis.minRange = xAxis.userMinRange;
	                    }
	
	                    // redraw
	                    series.isDirty = chart.isDirtyBox = true;
	                    series.isDirtyData = !!oldData;
	                    animation = false;
	                }
	
	                // Typically for pie series, points need to be processed and generated
	                // prior to rendering the legend
	                if (options.legendType === 'point') {
	                    this.processData();
	                    this.generatePoints();
	                }
	
	                if (redraw) {
	                    chart.redraw(animation);
	                }
	            },
	
	            /**
	             * Internal function to process the data by cropping away unused data points
	             * if the series is longer than the crop threshold. This saves computing
	             * time for large series. In Highstock, this function is extended to
	             * provide data grouping.
	             *
	             * @private
	             * @param  {Boolean} force
	             *         Force data grouping.
	             */
	            processData: function(force) {
	                var series = this,
	                    processedXData = series.xData, // copied during slice operation
	                    processedYData = series.yData,
	                    dataLength = processedXData.length,
	                    croppedData,
	                    cropStart = 0,
	                    cropped,
	                    distance,
	                    closestPointRange,
	                    xAxis = series.xAxis,
	                    i, // loop variable
	                    options = series.options,
	                    cropThreshold = options.cropThreshold,
	                    getExtremesFromAll =
	                    series.getExtremesFromAll ||
	                    options.getExtremesFromAll, // #4599
	                    isCartesian = series.isCartesian,
	                    xExtremes,
	                    val2lin = xAxis && xAxis.val2lin,
	                    isLog = xAxis && xAxis.isLog,
	                    min,
	                    max;
	
	                // If the series data or axes haven't changed, don't go through this.
	                // Return false to pass the message on to override methods like in data
	                // grouping.
	                if (
	                    isCartesian &&
	                    !series.isDirty &&
	                    !xAxis.isDirty &&
	                    !series.yAxis.isDirty &&
	                    !force
	                ) {
	                    return false;
	                }
	
	                if (xAxis) {
	                    xExtremes = xAxis.getExtremes(); // corrected for log axis (#3053)
	                    min = xExtremes.min;
	                    max = xExtremes.max;
	                }
	
	                // optionally filter out points outside the plot area
	                if (
	                    isCartesian &&
	                    series.sorted &&
	                    !getExtremesFromAll &&
	                    (!cropThreshold || dataLength > cropThreshold || series.forceCrop)
	                ) {
	
	                    // it's outside current extremes
	                    if (
	                        processedXData[dataLength - 1] < min ||
	                        processedXData[0] > max
	                    ) {
	                        processedXData = [];
	                        processedYData = [];
	
	                        // only crop if it's actually spilling out
	                    } else if (
	                        processedXData[0] < min ||
	                        processedXData[dataLength - 1] > max
	                    ) {
	                        croppedData = this.cropData(
	                            series.xData,
	                            series.yData,
	                            min,
	                            max
	                        );
	                        processedXData = croppedData.xData;
	                        processedYData = croppedData.yData;
	                        cropStart = croppedData.start;
	                        cropped = true;
	                    }
	                }
	
	
	                // Find the closest distance between processed points
	                i = processedXData.length || 1;
	                while (--i) {
	                    distance = isLog ?
	                        val2lin(processedXData[i]) - val2lin(processedXData[i - 1]) :
	                        processedXData[i] - processedXData[i - 1];
	
	                    if (
	                        distance > 0 &&
	                        (
	                            closestPointRange === undefined ||
	                            distance < closestPointRange
	                        )
	                    ) {
	                        closestPointRange = distance;
	
	                        // Unsorted data is not supported by the line tooltip, as well as
	                        // data grouping and navigation in Stock charts (#725) and width
	                        // calculation of columns (#1900)
	                    } else if (distance < 0 && series.requireSorting) {
	                        H.error(15);
	                    }
	                }
	
	                // Record the properties
	                series.cropped = cropped; // undefined or true
	                series.cropStart = cropStart;
	                series.processedXData = processedXData;
	                series.processedYData = processedYData;
	
	                series.closestPointRange = closestPointRange;
	
	            },
	
	            /**
	             * Iterate over xData and crop values between min and max. Returns object
	             * containing crop start/end cropped xData with corresponding part of yData,
	             * dataMin and dataMax within the cropped range.
	             *
	             * @private
	             */
	            cropData: function(xData, yData, min, max) {
	                var dataLength = xData.length,
	                    cropStart = 0,
	                    cropEnd = dataLength,
	                    // line-type series need one point outside
	                    cropShoulder = pick(this.cropShoulder, 1),
	                    i,
	                    j;
	
	                // iterate up to find slice start
	                for (i = 0; i < dataLength; i++) {
	                    if (xData[i] >= min) {
	                        cropStart = Math.max(0, i - cropShoulder);
	                        break;
	                    }
	                }
	
	                // proceed to find slice end
	                for (j = i; j < dataLength; j++) {
	                    if (xData[j] > max) {
	                        cropEnd = j + cropShoulder;
	                        break;
	                    }
	                }
	
	                return {
	                    xData: xData.slice(cropStart, cropEnd),
	                    yData: yData.slice(cropStart, cropEnd),
	                    start: cropStart,
	                    end: cropEnd
	                };
	            },
	
	
	            /**
	             * Generate the data point after the data has been processed by cropping
	             * away unused points and optionally grouped in Highcharts Stock.
	             *
	             * @private
	             */
	            generatePoints: function() {
	                var series = this,
	                    options = series.options,
	                    dataOptions = options.data,
	                    data = series.data,
	                    dataLength,
	                    processedXData = series.processedXData,
	                    processedYData = series.processedYData,
	                    PointClass = series.pointClass,
	                    processedDataLength = processedXData.length,
	                    cropStart = series.cropStart || 0,
	                    cursor,
	                    hasGroupedData = series.hasGroupedData,
	                    keys = options.keys,
	                    point,
	                    points = [],
	                    i;
	
	                if (!data && !hasGroupedData) {
	                    var arr = [];
	                    arr.length = dataOptions.length;
	                    data = series.data = arr;
	                }
	
	                if (keys && hasGroupedData) {
	                    // grouped data has already applied keys (#6590)
	                    series.options.keys = false;
	                }
	
	                for (i = 0; i < processedDataLength; i++) {
	                    cursor = cropStart + i;
	                    if (!hasGroupedData) {
	                        point = data[cursor];
	                        if (!point && dataOptions[cursor] !== undefined) { // #970
	                            data[cursor] = point = (new PointClass()).init(
	                                series,
	                                dataOptions[cursor],
	                                processedXData[i]
	                            );
	                        }
	                    } else {
	                        // splat the y data in case of ohlc data array
	                        point = (new PointClass()).init(
	                            series, [processedXData[i]].concat(splat(processedYData[i]))
	                        );
	
	                        /**
	                         * Highstock only. If a point object is created by data
	                         * grouping, it doesn't reflect actual points in the raw data.
	                         * In this case, the `dataGroup` property holds information
	                         * that points back to the raw data.
	                         *
	                         * - `dataGroup.start` is the index of the first raw data point
	                         * in the group.
	                         * - `dataGroup.length` is the amount of points in the group.
	                         *
	                         * @name dataGroup
	                         * @memberOf Point
	                         * @type {Object}
	                         *
	                         */
	                        point.dataGroup = series.groupMap[i];
	                    }
	                    if (point) { // #6279
	                        point.index = cursor; // For faster access in Point.update
	                        points[i] = point;
	                    }
	                }
	
	                // restore keys options (#6590)
	                series.options.keys = keys;
	
	                // Hide cropped-away points - this only runs when the number of points
	                // is above cropThreshold, or when swithching view from non-grouped
	                // data to grouped data (#637)
	                if (
	                    data &&
	                    (
	                        processedDataLength !== (dataLength = data.length) ||
	                        hasGroupedData
	                    )
	                ) {
	                    for (i = 0; i < dataLength; i++) {
	                        // when has grouped data, clear all points
	                        if (i === cropStart && !hasGroupedData) {
	                            i += processedDataLength;
	                        }
	                        if (data[i]) {
	                            data[i].destroyElements();
	                            data[i].plotX = undefined; // #1003
	                        }
	                    }
	                }
	
	                /**
	                 * Read only. An array containing the series' data point objects. To
	                 * modify the data, use {@link Highcharts.Series#setData} or {@link
	                 * Highcharts.Point#update}.
	                 *
	                 * @name data
	                 * @memberOf Highcharts.Series
	                 * @type {Array.<Highcharts.Point>}
	                 */
	                series.data = data;
	
	                /**
	                 * An array containing all currently visible point objects. In case of
	                 * cropping, the cropped-away points are not part of this array. The
	                 * `series.points` array starts at `series.cropStart` compared to
	                 * `series.data` and `series.options.data`. If however the series data
	                 * is grouped, these can't be correlated one to one. To
	                 * modify the data, use {@link Highcharts.Series#setData} or {@link
	                 * Highcharts.Point#update}.
	                 * @name point
	                 * @memberof Series
	                 * @type {Array.<Point>}
	                 */
	                series.points = points;
	            },
	
	            /**
	             * Calculate Y extremes for the visible data. The result is set as 
	             * `dataMin` and `dataMax` on the Series item.
	             *
	             * @param  {Array.<Number>} [yData]
	             *         The data to inspect. Defaults to the current data within the
	             *         visible range.
	             * 
	             */
	            getExtremes: function(yData) {
	                var xAxis = this.xAxis,
	                    yAxis = this.yAxis,
	                    xData = this.processedXData,
	                    yDataLength,
	                    activeYData = [],
	                    activeCounter = 0,
	                    // #2117, need to compensate for log X axis
	                    xExtremes = xAxis.getExtremes(),
	                    xMin = xExtremes.min,
	                    xMax = xExtremes.max,
	                    validValue,
	                    withinRange,
	                    x,
	                    y,
	                    i,
	                    j;
	
	                yData = yData || this.stackedYData || this.processedYData || [];
	                yDataLength = yData.length;
	
	                for (i = 0; i < yDataLength; i++) {
	
	                    x = xData[i];
	                    y = yData[i];
	
	                    // For points within the visible range, including the first point
	                    // outside the visible range, consider y extremes
	                    validValue =
	                        (isNumber(y, true) || isArray(y)) &&
	                        (!yAxis.positiveValuesOnly || (y.length || y > 0));
	                    withinRange =
	                        this.getExtremesFromAll ||
	                        this.options.getExtremesFromAll ||
	                        this.cropped ||
	                        ((xData[i] || x) >= xMin && (xData[i] || x) <= xMax);
	
	                    if (validValue && withinRange) {
	
	                        j = y.length;
	                        if (j) { // array, like ohlc or range data
	                            while (j--) {
	                                if (y[j] !== null) {
	                                    activeYData[activeCounter++] = y[j];
	                                }
	                            }
	                        } else {
	                            activeYData[activeCounter++] = y;
	                        }
	                    }
	                }
	
	                this.dataMin = arrayMin(activeYData);
	                this.dataMax = arrayMax(activeYData);
	            },
	
	            /**
	             * Translate data points from raw data values to chart specific positioning
	             * data needed later in the `drawPoints` and `drawGraph` functions. This
	             * function can be overridden in plugins and custom series type
	             * implementations.
	             */
	            translate: function() {
	                if (!this.processedXData) { // hidden series
	                    this.processData();
	                }
	                this.generatePoints();
	                var series = this,
	                    options = series.options,
	                    stacking = options.stacking,
	                    xAxis = series.xAxis,
	                    categories = xAxis.categories,
	                    yAxis = series.yAxis,
	                    points = series.points,
	                    dataLength = points.length,
	                    hasModifyValue = !!series.modifyValue,
	                    i,
	                    pointPlacement = options.pointPlacement,
	                    dynamicallyPlaced =
	                    pointPlacement === 'between' ||
	                    isNumber(pointPlacement),
	                    threshold = options.threshold,
	                    stackThreshold = options.startFromThreshold ? threshold : 0,
	                    plotX,
	                    plotY,
	                    lastPlotX,
	                    stackIndicator,
	                    closestPointRangePx = Number.MAX_VALUE;
	
	                // Point placement is relative to each series pointRange (#5889)
	                if (pointPlacement === 'between') {
	                    pointPlacement = 0.5;
	                }
	                if (isNumber(pointPlacement)) {
	                    pointPlacement *= pick(options.pointRange || xAxis.pointRange);
	                }
	
	                // Translate each point
	                for (i = 0; i < dataLength; i++) {
	                    var point = points[i],
	                        xValue = point.x,
	                        yValue = point.y,
	                        yBottom = point.low,
	                        stack = stacking && yAxis.stacks[(
	                            series.negStacks &&
	                            yValue < (stackThreshold ? 0 : threshold) ? '-' : ''
	                        ) + series.stackKey],
	                        pointStack,
	                        stackValues;
	
	                    // Discard disallowed y values for log axes (#3434)
	                    if (yAxis.positiveValuesOnly && yValue !== null && yValue <= 0) {
	                        point.isNull = true;
	                    }
	
	                    // Get the plotX translation
	                    point.plotX = plotX = correctFloat( // #5236
	                        Math.min(Math.max(-1e5, xAxis.translate(
	                            xValue,
	                            0,
	                            0,
	                            0,
	                            1,
	                            pointPlacement,
	                            this.type === 'flags'
	                        )), 1e5) // #3923
	                    );
	
	                    // Calculate the bottom y value for stacked series
	                    if (
	                        stacking &&
	                        series.visible &&
	                        !point.isNull &&
	                        stack &&
	                        stack[xValue]
	                    ) {
	                        stackIndicator = series.getStackIndicator(
	                            stackIndicator,
	                            xValue,
	                            series.index
	                        );
	                        pointStack = stack[xValue];
	                        stackValues = pointStack.points[stackIndicator.key];
	                        yBottom = stackValues[0];
	                        yValue = stackValues[1];
	
	                        if (
	                            yBottom === stackThreshold &&
	                            stackIndicator.key === stack[xValue].base
	                        ) {
	                            yBottom = pick(threshold, yAxis.min);
	                        }
	                        if (yAxis.positiveValuesOnly && yBottom <= 0) { // #1200, #1232
	                            yBottom = null;
	                        }
	
	                        point.total = point.stackTotal = pointStack.total;
	                        point.percentage =
	                            pointStack.total &&
	                            (point.y / pointStack.total * 100);
	                        point.stackY = yValue;
	
	                        // Place the stack label
	                        pointStack.setOffset(
	                            series.pointXOffset || 0,
	                            series.barW || 0
	                        );
	
	                    }
	
	                    // Set translated yBottom or remove it
	                    point.yBottom = defined(yBottom) ?
	                        yAxis.translate(yBottom, 0, 1, 0, 1) :
	                        null;
	
	                    // general hook, used for Highstock compare mode
	                    if (hasModifyValue) {
	                        yValue = series.modifyValue(yValue, point);
	                    }
	
	                    // Set the the plotY value, reset it for redraws
	                    point.plotY = plotY =
	                        (typeof yValue === 'number' && yValue !== Infinity) ?
	                        Math.min(Math.max(-1e5,
	                            yAxis.translate(yValue, 0, 1, 0, 1)), 1e5) : // #3201
	                        undefined;
	
	                    point.isInside =
	                        plotY !== undefined &&
	                        plotY >= 0 &&
	                        plotY <= yAxis.len && // #3519
	                        plotX >= 0 &&
	                        plotX <= xAxis.len;
	
	
	                    // Set client related positions for mouse tracking
	                    point.clientX = dynamicallyPlaced ?
	                        correctFloat(
	                            xAxis.translate(xValue, 0, 0, 0, 1, pointPlacement)
	                        ) :
	                        plotX; // #1514, #5383, #5518
	
	                    point.negative = point.y < (threshold || 0);
	
	                    // some API data
	                    point.category = categories && categories[point.x] !== undefined ?
	                        categories[point.x] : point.x;
	
	                    // Determine auto enabling of markers (#3635, #5099)
	                    if (!point.isNull) {
	                        if (lastPlotX !== undefined) {
	                            closestPointRangePx = Math.min(
	                                closestPointRangePx,
	                                Math.abs(plotX - lastPlotX)
	                            );
	                        }
	                        lastPlotX = plotX;
	                    }
	
	                    // Find point zone
	                    point.zone = this.zones.length && point.getZone();
	                }
	                series.closestPointRangePx = closestPointRangePx;
	            },
	
	            /**
	             * Return the series points with null points filtered out.
	             *
	             * @param  {Array.<Point>} [points]
	             *         The points to inspect, defaults to {@link Series.points}.
	             * @param  {Boolean} [insideOnly=false]
	             *         Whether to inspect only the points that are inside the visible
	             *         view.
	             *
	             * @return {Array.<Point>}
	             *         The valid points.
	             */
	            getValidPoints: function(points, insideOnly) {
	                var chart = this.chart;
	                // #3916, #5029, #5085
	                return grep(points || this.points || [], function isValidPoint(point) {
	                    if (insideOnly && !chart.isInsidePlot(
	                            point.plotX,
	                            point.plotY,
	                            chart.inverted
	                        )) {
	                        return false;
	                    }
	                    return !point.isNull;
	                });
	            },
	
	            /**
	             * Set the clipping for the series. For animated series it is called twice,
	             * first to initiate animating the clip then the second time without the
	             * animation to set the final clip.
	             *
	             * @private
	             */
	            setClip: function(animation) {
	                var chart = this.chart,
	                    options = this.options,
	                    renderer = chart.renderer,
	                    inverted = chart.inverted,
	                    seriesClipBox = this.clipBox,
	                    clipBox = seriesClipBox || chart.clipBox,
	                    sharedClipKey =
	                    this.sharedClipKey || [
	                        '_sharedClip',
	                        animation && animation.duration,
	                        animation && animation.easing,
	                        clipBox.height,
	                        options.xAxis,
	                        options.yAxis
	                    ].join(','), // #4526
	                    clipRect = chart[sharedClipKey],
	                    markerClipRect = chart[sharedClipKey + 'm'];
	
	                // If a clipping rectangle with the same properties is currently present
	                // in the chart, use that.
	                if (!clipRect) {
	
	                    // When animation is set, prepare the initial positions
	                    if (animation) {
	                        clipBox.width = 0;
	
	                        chart[sharedClipKey + 'm'] = markerClipRect = renderer.clipRect(-99, // include the width of the first marker
	                            inverted ? -chart.plotLeft : -chart.plotTop,
	                            99,
	                            inverted ? chart.chartWidth : chart.chartHeight
	                        );
	                    }
	                    chart[sharedClipKey] = clipRect = renderer.clipRect(clipBox);
	                    // Create hashmap for series indexes
	                    clipRect.count = {
	                        length: 0
	                    };
	
	                }
	                if (animation) {
	                    if (!clipRect.count[this.index]) {
	                        clipRect.count[this.index] = true;
	                        clipRect.count.length += 1;
	                    }
	                }
	
	                if (options.clip !== false) {
	                    this.group.clip(animation || seriesClipBox ? clipRect : chart.clipRect);
	                    this.markerGroup.clip(markerClipRect);
	                    this.sharedClipKey = sharedClipKey;
	                }
	
	                // Remove the shared clipping rectangle when all series are shown
	                if (!animation) {
	                    if (clipRect.count[this.index]) {
	                        delete clipRect.count[this.index];
	                        clipRect.count.length -= 1;
	                    }
	
	                    if (clipRect.count.length === 0 && sharedClipKey && chart[sharedClipKey]) {
	                        if (!seriesClipBox) {
	                            chart[sharedClipKey] = chart[sharedClipKey].destroy();
	                        }
	                        if (chart[sharedClipKey + 'm']) {
	                            chart[sharedClipKey + 'm'] = chart[sharedClipKey + 'm'].destroy();
	                        }
	                    }
	                }
	            },
	
	            /**
	             * Animate in the series. Called internally twice. First with the `init`
	             * parameter set to true, which sets up the initial state of the animation.
	             * Then when ready, it is called with the `init` parameter undefined, in 
	             * order to perform the actual animation. After the second run, the function
	             * is removed.
	             *
	             * @param  {Boolean} init
	             *         Initialize the animation.
	             */
	            animate: function(init) {
	                var series = this,
	                    chart = series.chart,
	                    clipRect,
	                    animation = animObject(series.options.animation),
	                    sharedClipKey;
	
	                // Initialize the animation. Set up the clipping rectangle.
	                if (init) {
	
	                    series.setClip(animation);
	
	                    // Run the animation
	                } else {
	                    sharedClipKey = this.sharedClipKey;
	                    clipRect = chart[sharedClipKey];
	                    if (clipRect) {
	                        clipRect.animate({
	                            width: chart.plotSizeX
	                        }, animation);
	                    }
	                    if (chart[sharedClipKey + 'm']) {
	                        chart[sharedClipKey + 'm'].animate({
	                            width: chart.plotSizeX + 99
	                        }, animation);
	                    }
	
	                    // Delete this function to allow it only once
	                    series.animate = null;
	
	                }
	            },
	
	            /**
	             * This runs after animation to land on the final plot clipping.
	             *
	             * @private
	             */
	            afterAnimate: function() {
	                this.setClip();
	                fireEvent(this, 'afterAnimate');
	                this.finishedAnimating = true;
	            },
	
	            /**
	             * Draw the markers for line-like series types, and columns or other
	             * graphical representation for {@link Point} objects for other series
	             * types. The resulting element is typically stored as {@link
	             * Point.graphic}, and is created on the first call and updated and moved on
	             * subsequent calls.
	             */
	            drawPoints: function() {
	                var series = this,
	                    points = series.points,
	                    chart = series.chart,
	                    plotY,
	                    i,
	                    point,
	                    symbol,
	                    graphic,
	                    options = series.options,
	                    seriesMarkerOptions = options.marker,
	                    pointMarkerOptions,
	                    hasPointMarker,
	                    enabled,
	                    isInside,
	                    markerGroup = series[series.specialGroup] || series.markerGroup,
	                    xAxis = series.xAxis,
	                    markerAttribs,
	                    globallyEnabled = pick(
	                        seriesMarkerOptions.enabled,
	                        xAxis.isRadial ? true : null,
	                        // Use larger or equal as radius is null in bubbles (#6321)
	                        series.closestPointRangePx >= 2 * seriesMarkerOptions.radius
	                    );
	
	                if (seriesMarkerOptions.enabled !== false || series._hasPointMarkers) {
	
	                    for (i = 0; i < points.length; i++) {
	                        point = points[i];
	                        plotY = point.plotY;
	                        graphic = point.graphic;
	                        pointMarkerOptions = point.marker || {};
	                        hasPointMarker = !!point.marker;
	                        enabled = (globallyEnabled && pointMarkerOptions.enabled === undefined) || pointMarkerOptions.enabled;
	                        isInside = point.isInside;
	
	                        // only draw the point if y is defined
	                        if (enabled && isNumber(plotY) && point.y !== null) {
	
	                            // Shortcuts
	                            symbol = pick(pointMarkerOptions.symbol, series.symbol);
	                            point.hasImage = symbol.indexOf('url') === 0;
	
	                            markerAttribs = series.markerAttribs(
	                                point,
	                                point.selected && 'select'
	                            );
	
	                            if (graphic) { // update
	                                graphic[isInside ? 'show' : 'hide'](true) // Since the marker group isn't clipped, each individual marker must be toggled
	                                    .animate(markerAttribs);
	                            } else if (isInside && (markerAttribs.width > 0 || point.hasImage)) {
	
	                                /**
	                                 * The graphic representation of the point. Typically
	                                 * this is a simple shape, like a `rect` for column
	                                 * charts or `path` for line markers, but for some 
	                                 * complex series types like boxplot or 3D charts, the
	                                 * graphic may be a `g` element containing other shapes.
	                                 * The graphic is generated the first time {@link
	                                 * Series#drawPoints} runs, and updated and moved on
	                                 * subsequent runs.
	                                 *
	                                 * @memberof Point
	                                 * @name graphic
	                                 * @type {SVGElement}
	                                 */
	                                point.graphic = graphic = chart.renderer.symbol(
	                                        symbol,
	                                        markerAttribs.x,
	                                        markerAttribs.y,
	                                        markerAttribs.width,
	                                        markerAttribs.height,
	                                        hasPointMarker ? pointMarkerOptions : seriesMarkerOptions
	                                    )
	                                    .add(markerGroup);
	                            }
	
	
	                            // Presentational attributes
	                            if (graphic) {
	                                graphic.attr(series.pointAttribs(point, point.selected && 'select'));
	                            }
	
	
	                            if (graphic) {
	                                graphic.addClass(point.getClassName(), true);
	                            }
	
	                        } else if (graphic) {
	                            point.graphic = graphic.destroy(); // #1269
	                        }
	                    }
	                }
	
	            },
	
	            /**
	             * Get non-presentational attributes for a point. Used internally for both
	             * styled mode and classic. Can be overridden for different series types.
	             *
	             * @see    Series#pointAttribs
	             *
	             * @param  {Point} point
	             *         The Point to inspect.
	             * @param  {String} [state]
	             *         The state, can be either `hover`, `select` or undefined.
	             *
	             * @return {SVGAttributes}
	             *         A hash containing those attributes that are not settable from
	             *         CSS.
	             */
	            markerAttribs: function(point, state) {
	                var seriesMarkerOptions = this.options.marker,
	                    seriesStateOptions,
	                    pointMarkerOptions = point.marker || {},
	                    pointStateOptions,
	                    radius = pick(
	                        pointMarkerOptions.radius,
	                        seriesMarkerOptions.radius
	                    ),
	                    attribs;
	
	                // Handle hover and select states
	                if (state) {
	                    seriesStateOptions = seriesMarkerOptions.states[state];
	                    pointStateOptions = pointMarkerOptions.states &&
	                        pointMarkerOptions.states[state];
	
	                    radius = pick(
	                        pointStateOptions && pointStateOptions.radius,
	                        seriesStateOptions && seriesStateOptions.radius,
	                        radius + (seriesStateOptions && seriesStateOptions.radiusPlus || 0)
	                    );
	                }
	
	                if (point.hasImage) {
	                    radius = 0; // and subsequently width and height is not set
	                }
	
	                attribs = {
	                    x: Math.floor(point.plotX) - radius, // Math.floor for #1843
	                    y: point.plotY - radius
	                };
	
	                if (radius) {
	                    attribs.width = attribs.height = 2 * radius;
	                }
	
	                return attribs;
	
	            },
	
	
	            /**
	             * Internal function to get presentational attributes for each point. Unlike
	             * {@link Series#markerAttribs}, this function should return those
	             * attributes that can also be set in CSS. In styled mode, `pointAttribs`
	             * won't be called.
	             *
	             * @param  {Point} point
	             *         The point instance to inspect.
	             * @param  {String} [state]
	             *         The point state, can be either `hover`, `select` or undefined for
	             *         normal state.
	             *
	             * @return {SVGAttributes}
	             *         The presentational attributes to be set on the point.
	             */
	            pointAttribs: function(point, state) {
	                var seriesMarkerOptions = this.options.marker,
	                    seriesStateOptions,
	                    pointOptions = point && point.options,
	                    pointMarkerOptions = (pointOptions && pointOptions.marker) || {},
	                    pointStateOptions,
	                    color = this.color,
	                    pointColorOption = pointOptions && pointOptions.color,
	                    pointColor = point && point.color,
	                    strokeWidth = pick(
	                        pointMarkerOptions.lineWidth,
	                        seriesMarkerOptions.lineWidth
	                    ),
	                    zoneColor = point && point.zone && point.zone.color,
	                    fill,
	                    stroke;
	
	                color = pointColorOption || zoneColor || pointColor || color;
	                fill = pointMarkerOptions.fillColor || seriesMarkerOptions.fillColor || color;
	                stroke = pointMarkerOptions.lineColor || seriesMarkerOptions.lineColor || color;
	
	                // Handle hover and select states
	                if (state) {
	                    seriesStateOptions = seriesMarkerOptions.states[state];
	                    pointStateOptions = (pointMarkerOptions.states && pointMarkerOptions.states[state]) || {};
	                    strokeWidth = pick(
	                        pointStateOptions.lineWidth,
	                        seriesStateOptions.lineWidth,
	                        strokeWidth + pick(
	                            pointStateOptions.lineWidthPlus,
	                            seriesStateOptions.lineWidthPlus,
	                            0
	                        )
	                    );
	                    fill = pointStateOptions.fillColor || seriesStateOptions.fillColor || fill;
	                    stroke = pointStateOptions.lineColor || seriesStateOptions.lineColor || stroke;
	                }
	
	                return {
	                    'stroke': stroke,
	                    'stroke-width': strokeWidth,
	                    'fill': fill
	                };
	            },
	
	            /**
	             * Clear DOM objects and free up memory.
	             *
	             * @private
	             */
	            destroy: function() {
	                var series = this,
	                    chart = series.chart,
	                    issue134 = /AppleWebKit\/533/.test(win.navigator.userAgent),
	                    destroy,
	                    i,
	                    data = series.data || [],
	                    point,
	                    axis;
	
	                // add event hook
	                fireEvent(series, 'destroy');
	
	                // remove all events
	                removeEvent(series);
	
	                // erase from axes
	                each(series.axisTypes || [], function(AXIS) {
	                    axis = series[AXIS];
	                    if (axis && axis.series) {
	                        erase(axis.series, series);
	                        axis.isDirty = axis.forceRedraw = true;
	                    }
	                });
	
	                // remove legend items
	                if (series.legendItem) {
	                    series.chart.legend.destroyItem(series);
	                }
	
	                // destroy all points with their elements
	                i = data.length;
	                while (i--) {
	                    point = data[i];
	                    if (point && point.destroy) {
	                        point.destroy();
	                    }
	                }
	                series.points = null;
	
	                // Clear the animation timeout if we are destroying the series during initial animation
	                clearTimeout(series.animationTimeout);
	
	                // Destroy all SVGElements associated to the series
	                objectEach(series, function(val, prop) {
	                    if (val instanceof SVGElement && !val.survive) { // Survive provides a hook for not destroying
	
	                        // issue 134 workaround
	                        destroy = issue134 && prop === 'group' ?
	                            'hide' :
	                            'destroy';
	
	                        val[destroy]();
	                    }
	                });
	
	                // remove from hoverSeries
	                if (chart.hoverSeries === series) {
	                    chart.hoverSeries = null;
	                }
	                erase(chart.series, series);
	                chart.orderSeries();
	
	                // clear all members
	                objectEach(series, function(val, prop) {
	                    delete series[prop];
	                });
	            },
	
	            /**
	             * Get the graph path.
	             *
	             * @private
	             */
	            getGraphPath: function(points, nullsAsZeroes, connectCliffs) {
	                var series = this,
	                    options = series.options,
	                    step = options.step,
	                    reversed,
	                    graphPath = [],
	                    xMap = [],
	                    gap;
	
	                points = points || series.points;
	
	                // Bottom of a stack is reversed
	                reversed = points.reversed;
	                if (reversed) {
	                    points.reverse();
	                }
	                // Reverse the steps (#5004)
	                step = {
	                    right: 1,
	                    center: 2
	                }[step] || (step && 3);
	                if (step && reversed) {
	                    step = 4 - step;
	                }
	
	                // Remove invalid points, especially in spline (#5015)
	                if (options.connectNulls && !nullsAsZeroes && !connectCliffs) {
	                    points = this.getValidPoints(points);
	                }
	
	                // Build the line
	                each(points, function(point, i) {
	
	                    var plotX = point.plotX,
	                        plotY = point.plotY,
	                        lastPoint = points[i - 1],
	                        pathToPoint; // the path to this point from the previous
	
	                    if ((point.leftCliff || (lastPoint && lastPoint.rightCliff)) && !connectCliffs) {
	                        gap = true; // ... and continue
	                    }
	
	                    // Line series, nullsAsZeroes is not handled
	                    if (point.isNull && !defined(nullsAsZeroes) && i > 0) {
	                        gap = !options.connectNulls;
	
	                        // Area series, nullsAsZeroes is set
	                    } else if (point.isNull && !nullsAsZeroes) {
	                        gap = true;
	
	                    } else {
	
	                        if (i === 0 || gap) {
	                            pathToPoint = ['M', point.plotX, point.plotY];
	
	                        } else if (series.getPointSpline) { // generate the spline as defined in the SplineSeries object
	
	                            pathToPoint = series.getPointSpline(points, point, i);
	
	                        } else if (step) {
	
	                            if (step === 1) { // right
	                                pathToPoint = [
	                                    'L',
	                                    lastPoint.plotX,
	                                    plotY
	                                ];
	
	                            } else if (step === 2) { // center
	                                pathToPoint = [
	                                    'L',
	                                    (lastPoint.plotX + plotX) / 2,
	                                    lastPoint.plotY,
	                                    'L',
	                                    (lastPoint.plotX + plotX) / 2,
	                                    plotY
	                                ];
	
	                            } else {
	                                pathToPoint = [
	                                    'L',
	                                    plotX,
	                                    lastPoint.plotY
	                                ];
	                            }
	                            pathToPoint.push('L', plotX, plotY);
	
	                        } else {
	                            // normal line to next point
	                            pathToPoint = [
	                                'L',
	                                plotX,
	                                plotY
	                            ];
	                        }
	
	                        // Prepare for animation. When step is enabled, there are two path nodes for each x value.
	                        xMap.push(point.x);
	                        if (step) {
	                            xMap.push(point.x);
	                        }
	
	                        graphPath.push.apply(graphPath, pathToPoint);
	                        gap = false;
	                    }
	                });
	
	                graphPath.xMap = xMap;
	                series.graphPath = graphPath;
	
	                return graphPath;
	
	            },
	
	            /**
	             * Draw the graph. Called internally when rendering line-like series types.
	             * The first time it generates the `series.graph` item and optionally other
	             * series-wide items like `series.area` for area charts. On subsequent calls
	             * these items are updated with new positions and attributes.
	             */
	            drawGraph: function() {
	                var series = this,
	                    options = this.options,
	                    graphPath = (this.gappedPath || this.getGraphPath).call(this),
	                    props = [
	                        [
	                            'graph',
	                            'highcharts-graph',
	
	                            options.lineColor || this.color,
	                            options.dashStyle
	
	                        ]
	                    ];
	
	                // Add the zone properties if any
	                each(this.zones, function(zone, i) {
	                    props.push([
	                        'zone-graph-' + i,
	                        'highcharts-graph highcharts-zone-graph-' + i + ' ' + (zone.className || ''),
	
	                        zone.color || series.color,
	                        zone.dashStyle || options.dashStyle
	
	                    ]);
	                });
	
	                // Draw the graph
	                each(props, function(prop, i) {
	                    var graphKey = prop[0],
	                        graph = series[graphKey],
	                        attribs;
	
	                    if (graph) {
	                        graph.endX = graphPath.xMap;
	                        graph.animate({
	                            d: graphPath
	                        });
	
	                    } else if (graphPath.length) { // #1487
	
	                        series[graphKey] = series.chart.renderer.path(graphPath)
	                            .addClass(prop[1])
	                            .attr({
	                                zIndex: 1
	                            }) // #1069
	                            .add(series.group);
	
	
	                        attribs = {
	                            'stroke': prop[2],
	                            'stroke-width': options.lineWidth,
	                            'fill': (series.fillGraph && series.color) || 'none' // Polygon series use filled graph
	                        };
	
	                        if (prop[3]) {
	                            attribs.dashstyle = prop[3];
	                        } else if (options.linecap !== 'square') {
	                            attribs['stroke-linecap'] = attribs['stroke-linejoin'] = 'round';
	                        }
	
	                        graph = series[graphKey]
	                            .attr(attribs)
	                            .shadow((i < 2) && options.shadow); // add shadow to normal series (0) or to first zone (1) #3932
	
	                    }
	
	                    // Helpers for animation
	                    if (graph) {
	                        graph.startX = graphPath.xMap;
	                        //graph.shiftUnit = options.step ? 2 : 1;
	                        graph.isArea = graphPath.isArea; // For arearange animation
	                    }
	                });
	            },
	
	            /**
	             * Clip the graphs into zones for colors and styling.
	             *
	             * @private
	             */
	            applyZones: function() {
	                var series = this,
	                    chart = this.chart,
	                    renderer = chart.renderer,
	                    zones = this.zones,
	                    translatedFrom,
	                    translatedTo,
	                    clips = this.clips || [],
	                    clipAttr,
	                    graph = this.graph,
	                    area = this.area,
	                    chartSizeMax = Math.max(chart.chartWidth, chart.chartHeight),
	                    axis = this[(this.zoneAxis || 'y') + 'Axis'],
	                    extremes,
	                    reversed,
	                    inverted = chart.inverted,
	                    horiz,
	                    pxRange,
	                    pxPosMin,
	                    pxPosMax,
	                    ignoreZones = false;
	
	                if (zones.length && (graph || area) && axis && axis.min !== undefined) {
	                    reversed = axis.reversed;
	                    horiz = axis.horiz;
	                    // The use of the Color Threshold assumes there are no gaps
	                    // so it is safe to hide the original graph and area
	                    if (graph) {
	                        graph.hide();
	                    }
	                    if (area) {
	                        area.hide();
	                    }
	
	                    // Create the clips
	                    extremes = axis.getExtremes();
	                    each(zones, function(threshold, i) {
	
	                        translatedFrom = reversed ?
	                            (horiz ? chart.plotWidth : 0) :
	                            (horiz ? 0 : axis.toPixels(extremes.min));
	                        translatedFrom = Math.min(Math.max(pick(translatedTo, translatedFrom), 0), chartSizeMax);
	                        translatedTo = Math.min(Math.max(Math.round(axis.toPixels(pick(threshold.value, extremes.max), true)), 0), chartSizeMax);
	
	                        if (ignoreZones) {
	                            translatedFrom = translatedTo = axis.toPixels(extremes.max);
	                        }
	
	                        pxRange = Math.abs(translatedFrom - translatedTo);
	                        pxPosMin = Math.min(translatedFrom, translatedTo);
	                        pxPosMax = Math.max(translatedFrom, translatedTo);
	                        if (axis.isXAxis) {
	                            clipAttr = {
	                                x: inverted ? pxPosMax : pxPosMin,
	                                y: 0,
	                                width: pxRange,
	                                height: chartSizeMax
	                            };
	                            if (!horiz) {
	                                clipAttr.x = chart.plotHeight - clipAttr.x;
	                            }
	                        } else {
	                            clipAttr = {
	                                x: 0,
	                                y: inverted ? pxPosMax : pxPosMin,
	                                width: chartSizeMax,
	                                height: pxRange
	                            };
	                            if (horiz) {
	                                clipAttr.y = chart.plotWidth - clipAttr.y;
	                            }
	                        }
	
	
	                        /// VML SUPPPORT
	                        if (inverted && renderer.isVML) {
	                            if (axis.isXAxis) {
	                                clipAttr = {
	                                    x: 0,
	                                    y: reversed ? pxPosMin : pxPosMax,
	                                    height: clipAttr.width,
	                                    width: chart.chartWidth
	                                };
	                            } else {
	                                clipAttr = {
	                                    x: clipAttr.y - chart.plotLeft - chart.spacingBox.x,
	                                    y: 0,
	                                    width: clipAttr.height,
	                                    height: chart.chartHeight
	                                };
	                            }
	                        }
	                        /// END OF VML SUPPORT
	
	
	                        if (clips[i]) {
	                            clips[i].animate(clipAttr);
	                        } else {
	                            clips[i] = renderer.clipRect(clipAttr);
	
	                            if (graph) {
	                                series['zone-graph-' + i].clip(clips[i]);
	                            }
	
	                            if (area) {
	                                series['zone-area-' + i].clip(clips[i]);
	                            }
	                        }
	                        // if this zone extends out of the axis, ignore the others
	                        ignoreZones = threshold.value > extremes.max;
	                    });
	                    this.clips = clips;
	                }
	            },
	
	            /**
	             * Initialize and perform group inversion on series.group and
	             * series.markerGroup.
	             *
	             * @private
	             */
	            invertGroups: function(inverted) {
	                var series = this,
	                    chart = series.chart,
	                    remover;
	
	                function setInvert() {
	                    each(['group', 'markerGroup'], function(groupName) {
	                        if (series[groupName]) {
	
	                            // VML/HTML needs explicit attributes for flipping
	                            if (chart.renderer.isVML) {
	                                series[groupName].attr({
	                                    width: series.yAxis.len,
	                                    height: series.xAxis.len
	                                });
	                            }
	
	                            series[groupName].width = series.yAxis.len;
	                            series[groupName].height = series.xAxis.len;
	                            series[groupName].invert(inverted);
	                        }
	                    });
	                }
	
	                // Pie, go away (#1736)
	                if (!series.xAxis) {
	                    return;
	                }
	
	                // A fixed size is needed for inversion to work
	                remover = addEvent(chart, 'resize', setInvert);
	                addEvent(series, 'destroy', remover);
	
	                // Do it now
	                setInvert(inverted); // do it now
	
	                // On subsequent render and redraw, just do setInvert without setting up events again
	                series.invertGroups = setInvert;
	            },
	
	            /**
	             * General abstraction for creating plot groups like series.group,
	             * series.dataLabelsGroup and series.markerGroup. On subsequent calls, the
	             * group will only be adjusted to the updated plot size.
	             *
	             * @private
	             */
	            plotGroup: function(prop, name, visibility, zIndex, parent) {
	                var group = this[prop],
	                    isNew = !group;
	
	                // Generate it on first call
	                if (isNew) {
	                    this[prop] = group = this.chart.renderer.g()
	                        .attr({
	                            zIndex: zIndex || 0.1 // IE8 and pointer logic use this
	                        })
	                        .add(parent);
	
	                }
	
	                // Add the class names, and replace existing ones as response to
	                // Series.update (#6660)
	                group.addClass(
	                    (
	                        'highcharts-' + name +
	                        ' highcharts-series-' + this.index +
	                        ' highcharts-' + this.type + '-series ' +
	                        'highcharts-color-' + this.colorIndex + ' ' +
	                        (this.options.className || '')
	                    ),
	                    true
	                );
	
	                // Place it on first and subsequent (redraw) calls
	                group.attr({
	                    visibility: visibility
	                })[isNew ? 'attr' : 'animate'](
	                    this.getPlotBox()
	                );
	                return group;
	            },
	
	            /**
	             * Get the translation and scale for the plot area of this series.
	             */
	            getPlotBox: function() {
	                var chart = this.chart,
	                    xAxis = this.xAxis,
	                    yAxis = this.yAxis;
	
	                // Swap axes for inverted (#2339)
	                if (chart.inverted) {
	                    xAxis = yAxis;
	                    yAxis = this.xAxis;
	                }
	                return {
	                    translateX: xAxis ? xAxis.left : chart.plotLeft,
	                    translateY: yAxis ? yAxis.top : chart.plotTop,
	                    scaleX: 1, // #1623
	                    scaleY: 1
	                };
	            },
	
	            /**
	             * Render the graph and markers. Called internally when first rendering and
	             * later when redrawing the chart. This function can be extended in plugins,
	             * but normally shouldn't be called directly.
	             */
	            render: function() {
	                var series = this,
	                    chart = series.chart,
	                    group,
	                    options = series.options,
	                    // Animation doesn't work in IE8 quirks when the group div is
	                    // hidden, and looks bad in other oldIE
	                    animDuration = (!!series.animate &&
	                        chart.renderer.isSVG &&
	                        animObject(options.animation).duration
	                    ),
	                    visibility = series.visible ? 'inherit' : 'hidden', // #2597
	                    zIndex = options.zIndex,
	                    hasRendered = series.hasRendered,
	                    chartSeriesGroup = chart.seriesGroup,
	                    inverted = chart.inverted;
	
	                // the group
	                group = series.plotGroup(
	                    'group',
	                    'series',
	                    visibility,
	                    zIndex,
	                    chartSeriesGroup
	                );
	
	                series.markerGroup = series.plotGroup(
	                    'markerGroup',
	                    'markers',
	                    visibility,
	                    zIndex,
	                    chartSeriesGroup
	                );
	
	                // initiate the animation
	                if (animDuration) {
	                    series.animate(true);
	                }
	
	                // SVGRenderer needs to know this before drawing elements (#1089, #1795)
	                group.inverted = series.isCartesian ? inverted : false;
	
	                // draw the graph if any
	                if (series.drawGraph) {
	                    series.drawGraph();
	                    series.applyZones();
	                }
	
	                /*		each(series.points, function (point) {
	                			if (point.redraw) {
	                				point.redraw();
	                			}
	                		});*/
	
	                // draw the data labels (inn pies they go before the points)
	                if (series.drawDataLabels) {
	                    series.drawDataLabels();
	                }
	
	                // draw the points
	                if (series.visible) {
	                    series.drawPoints();
	                }
	
	
	                // draw the mouse tracking area
	                if (
	                    series.drawTracker &&
	                    series.options.enableMouseTracking !== false
	                ) {
	                    series.drawTracker();
	                }
	
	                // Handle inverted series and tracker groups
	                series.invertGroups(inverted);
	
	                // Initial clipping, must be defined after inverting groups for VML.
	                // Applies to columns etc. (#3839).
	                if (options.clip !== false && !series.sharedClipKey && !hasRendered) {
	                    group.clip(chart.clipRect);
	                }
	
	                // Run the animation
	                if (animDuration) {
	                    series.animate();
	                }
	
	                // Call the afterAnimate function on animation complete (but don't
	                // overwrite the animation.complete option which should be available to
	                // the user).
	                if (!hasRendered) {
	                    series.animationTimeout = syncTimeout(function() {
	                        series.afterAnimate();
	                    }, animDuration);
	                }
	
	                series.isDirty = false; // means data is in accordance with what you see
	                // (See #322) series.isDirty = series.isDirtyData = false; // means
	                // data is in accordance with what you see
	                series.hasRendered = true;
	            },
	
	            /**
	             * Redraw the series. This function is called internally from `chart.redraw`
	             * and normally shouldn't be called directly.
	             *
	             * @private
	             */
	            redraw: function() {
	                var series = this,
	                    chart = series.chart,
	                    // cache it here as it is set to false in render, but used after
	                    wasDirty = series.isDirty || series.isDirtyData,
	                    group = series.group,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis;
	
	                // reposition on resize
	                if (group) {
	                    if (chart.inverted) {
	                        group.attr({
	                            width: chart.plotWidth,
	                            height: chart.plotHeight
	                        });
	                    }
	
	                    group.animate({
	                        translateX: pick(xAxis && xAxis.left, chart.plotLeft),
	                        translateY: pick(yAxis && yAxis.top, chart.plotTop)
	                    });
	                }
	
	                series.translate();
	                series.render();
	                if (wasDirty) { // #3868, #3945
	                    delete this.kdTree;
	                }
	            },
	
	            kdAxisArray: ['clientX', 'plotY'],
	
	            searchPoint: function(e, compareX) {
	                var series = this,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    inverted = series.chart.inverted;
	
	                return this.searchKDTree({
	                    clientX: inverted ?
	                        xAxis.len - e.chartY + xAxis.pos : e.chartX - xAxis.pos,
	                    plotY: inverted ?
	                        yAxis.len - e.chartX + yAxis.pos : e.chartY - yAxis.pos
	                }, compareX);
	            },
	
	            /**
	             * Build the k-d-tree that is used by mouse and touch interaction to get the
	             * closest point. Line-like series typically have a one-dimensional tree
	             * where points are searched along the X axis, while scatter-like series
	             * typically search in two dimensions, X and Y.
	             *
	             * @private
	             */
	            buildKDTree: function() {
	
	                // Prevent multiple k-d-trees from being built simultaneously (#6235)
	                this.buildingKdTree = true;
	
	                var series = this,
	                    dimensions = series.options.findNearestPointBy.indexOf('y') > -1 ?
	                    2 : 1;
	
	                // Internal function
	                function _kdtree(points, depth, dimensions) {
	                    var axis,
	                        median,
	                        length = points && points.length;
	
	                    if (length) {
	
	                        // alternate between the axis
	                        axis = series.kdAxisArray[depth % dimensions];
	
	                        // sort point array
	                        points.sort(function(a, b) {
	                            return a[axis] - b[axis];
	                        });
	
	                        median = Math.floor(length / 2);
	
	                        // build and return nod
	                        return {
	                            point: points[median],
	                            left: _kdtree(
	                                points.slice(0, median), depth + 1, dimensions
	                            ),
	                            right: _kdtree(
	                                points.slice(median + 1), depth + 1, dimensions
	                            )
	                        };
	
	                    }
	                }
	
	                // Start the recursive build process with a clone of the points array
	                // and null points filtered out (#3873)
	                function startRecursive() {
	                    series.kdTree = _kdtree(
	                        series.getValidPoints(
	                            null,
	                            // For line-type series restrict to plot area, but
	                            // column-type series not (#3916, #4511)
	                            !series.directTouch
	                        ),
	                        dimensions,
	                        dimensions
	                    );
	                    series.buildingKdTree = false;
	                }
	                delete series.kdTree;
	
	                // For testing tooltips, don't build async
	                syncTimeout(startRecursive, series.options.kdNow ? 0 : 1);
	            },
	
	            searchKDTree: function(point, compareX) {
	                var series = this,
	                    kdX = this.kdAxisArray[0],
	                    kdY = this.kdAxisArray[1],
	                    kdComparer = compareX ? 'distX' : 'dist',
	                    kdDimensions = series.options.findNearestPointBy.indexOf('y') > -1 ?
	                    2 : 1;
	
	                // Set the one and two dimensional distance on the point object
	                function setDistance(p1, p2) {
	                    var x = (defined(p1[kdX]) && defined(p2[kdX])) ?
	                        Math.pow(p1[kdX] - p2[kdX], 2) :
	                        null,
	                        y = (defined(p1[kdY]) && defined(p2[kdY])) ?
	                        Math.pow(p1[kdY] - p2[kdY], 2) :
	                        null,
	                        r = (x || 0) + (y || 0);
	
	                    p2.dist = defined(r) ? Math.sqrt(r) : Number.MAX_VALUE;
	                    p2.distX = defined(x) ? Math.sqrt(x) : Number.MAX_VALUE;
	                }
	
	                function _search(search, tree, depth, dimensions) {
	                    var point = tree.point,
	                        axis = series.kdAxisArray[depth % dimensions],
	                        tdist,
	                        sideA,
	                        sideB,
	                        ret = point,
	                        nPoint1,
	                        nPoint2;
	
	                    setDistance(search, point);
	
	                    // Pick side based on distance to splitting point
	                    tdist = search[axis] - point[axis];
	                    sideA = tdist < 0 ? 'left' : 'right';
	                    sideB = tdist < 0 ? 'right' : 'left';
	
	                    // End of tree
	                    if (tree[sideA]) {
	                        nPoint1 = _search(search, tree[sideA], depth + 1, dimensions);
	
	                        ret = (nPoint1[kdComparer] < ret[kdComparer] ? nPoint1 : point);
	                    }
	                    if (tree[sideB]) {
	                        // compare distance to current best to splitting point to decide
	                        // wether to check side B or not
	                        if (Math.sqrt(tdist * tdist) < ret[kdComparer]) {
	                            nPoint2 = _search(
	                                search,
	                                tree[sideB],
	                                depth + 1,
	                                dimensions
	                            );
	                            ret = nPoint2[kdComparer] < ret[kdComparer] ?
	                                nPoint2 :
	                                ret;
	                        }
	                    }
	
	                    return ret;
	                }
	
	                if (!this.kdTree && !this.buildingKdTree) {
	                    this.buildKDTree();
	                }
	
	                if (this.kdTree) {
	                    return _search(point, this.kdTree, kdDimensions, kdDimensions);
	                }
	            }
	
	        }); // end Series prototype
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Axis = H.Axis,
	            Chart = H.Chart,
	            correctFloat = H.correctFloat,
	            defined = H.defined,
	            destroyObjectProperties = H.destroyObjectProperties,
	            each = H.each,
	            format = H.format,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Series = H.Series;
	
	        /**
	         * The class for stacks. Each stack, on a specific X value and either negative
	         * or positive, has its own stack item.
	         *
	         * @class
	         */
	        H.StackItem = function(axis, options, isNegative, x, stackOption) {
	
	            var inverted = axis.chart.inverted;
	
	            this.axis = axis;
	
	            // Tells if the stack is negative
	            this.isNegative = isNegative;
	
	            // Save the options to be able to style the label
	            this.options = options;
	
	            // Save the x value to be able to position the label later
	            this.x = x;
	
	            // Initialize total value
	            this.total = null;
	
	            // This will keep each points' extremes stored by series.index and point 
	            // index
	            this.points = {};
	
	            // Save the stack option on the series configuration object, and whether to 
	            // treat it as percent
	            this.stack = stackOption;
	            this.leftCliff = 0;
	            this.rightCliff = 0;
	
	            // The align options and text align varies on whether the stack is negative 
	            // and if the chart is inverted or not.
	            // First test the user supplied value, then use the dynamic.
	            this.alignOptions = {
	                align: options.align ||
	                    (inverted ? (isNegative ? 'left' : 'right') : 'center'),
	                verticalAlign: options.verticalAlign ||
	                    (inverted ? 'middle' : (isNegative ? 'bottom' : 'top')),
	                y: pick(options.y, inverted ? 4 : (isNegative ? 14 : -6)),
	                x: pick(options.x, inverted ? (isNegative ? -6 : 6) : 0)
	            };
	
	            this.textAlign = options.textAlign ||
	                (inverted ? (isNegative ? 'right' : 'left') : 'center');
	        };
	
	        H.StackItem.prototype = {
	            destroy: function() {
	                destroyObjectProperties(this, this.axis);
	            },
	
	            /**
	             * Renders the stack total label and adds it to the stack label group.
	             */
	            render: function(group) {
	                var options = this.options,
	                    formatOption = options.format,
	                    str = formatOption ?
	                    format(formatOption, this) :
	                    options.formatter.call(this); // format the text in the label
	
	                // Change the text to reflect the new total and set visibility to hidden
	                // in case the serie is hidden
	                if (this.label) {
	                    this.label.attr({
	                        text: str,
	                        visibility: 'hidden'
	                    });
	                    // Create new label
	                } else {
	                    this.label =
	                        this.axis.chart.renderer.text(str, null, null, options.useHTML)
	                        .css(options.style)
	                        .attr({
	                            align: this.textAlign,
	                            rotation: options.rotation,
	                            visibility: 'hidden' // hidden until setOffset is called
	                        })
	                        .add(group); // add to the labels-group
	                }
	            },
	
	            /**
	             * Sets the offset that the stack has from the x value and repositions the
	             * label.
	             */
	            setOffset: function(xOffset, xWidth) {
	                var stackItem = this,
	                    axis = stackItem.axis,
	                    chart = axis.chart,
	                    // stack value translated mapped to chart coordinates
	                    y = axis.translate(
	                        axis.usePercentage ? 100 : stackItem.total,
	                        0,
	                        0,
	                        0,
	                        1
	                    ),
	                    yZero = axis.translate(0), // stack origin
	                    h = Math.abs(y - yZero), // stack height
	                    x = chart.xAxis[0].translate(stackItem.x) + xOffset, // stack x position
	                    stackBox = stackItem.getStackBox(chart, stackItem, x, y, xWidth, h),
	                    label = stackItem.label,
	                    alignAttr;
	
	                if (label) {
	                    // Align the label to the box
	                    label.align(stackItem.alignOptions, null, stackBox);
	
	                    // Set visibility (#678)
	                    alignAttr = label.alignAttr;
	                    label[
	                        stackItem.options.crop === false || chart.isInsidePlot(
	                            alignAttr.x,
	                            alignAttr.y
	                        ) ? 'show' : 'hide'](true);
	                }
	            },
	            getStackBox: function(chart, stackItem, x, y, xWidth, h) {
	                var reversed = stackItem.axis.reversed,
	                    inverted = chart.inverted,
	                    plotHeight = chart.plotHeight,
	                    neg = (stackItem.isNegative && !reversed) ||
	                    (!stackItem.isNegative && reversed); // #4056
	
	                return { // this is the box for the complete stack
	                    x: inverted ? (neg ? y : y - h) : x,
	                    y: inverted ?
	                        plotHeight - x - xWidth :
	                        (neg ?
	                            (plotHeight - y - h) :
	                            plotHeight - y
	                        ),
	                    width: inverted ? h : xWidth,
	                    height: inverted ? xWidth : h
	                };
	            }
	        };
	
	        /**
	         * Generate stacks for each series and calculate stacks total values
	         */
	        Chart.prototype.getStacks = function() {
	            var chart = this;
	
	            // reset stacks for each yAxis
	            each(chart.yAxis, function(axis) {
	                if (axis.stacks && axis.hasVisibleSeries) {
	                    axis.oldStacks = axis.stacks;
	                }
	            });
	
	            each(chart.series, function(series) {
	                if (series.options.stacking && (series.visible === true ||
	                        chart.options.chart.ignoreHiddenSeries === false)) {
	                    series.stackKey = series.type + pick(series.options.stack, '');
	                }
	            });
	        };
	
	
	        // Stacking methods defined on the Axis prototype
	
	        /**
	         * Build the stacks from top down
	         */
	        Axis.prototype.buildStacks = function() {
	            var axisSeries = this.series,
	                reversedStacks = pick(this.options.reversedStacks, true),
	                len = axisSeries.length,
	                i;
	            if (!this.isXAxis) {
	                this.usePercentage = false;
	                i = len;
	                while (i--) {
	                    axisSeries[reversedStacks ? i : len - i - 1].setStackedPoints();
	                }
	
	                // Loop up again to compute percent stack
	                if (this.usePercentage) {
	                    for (i = 0; i < len; i++) {
	                        axisSeries[i].setPercentStacks();
	                    }
	                }
	            }
	        };
	
	        Axis.prototype.renderStackTotals = function() {
	            var axis = this,
	                chart = axis.chart,
	                renderer = chart.renderer,
	                stacks = axis.stacks,
	                stackTotalGroup = axis.stackTotalGroup;
	
	            // Create a separate group for the stack total labels
	            if (!stackTotalGroup) {
	                axis.stackTotalGroup = stackTotalGroup =
	                    renderer.g('stack-labels')
	                    .attr({
	                        visibility: 'visible',
	                        zIndex: 6
	                    })
	                    .add();
	            }
	
	            // plotLeft/Top will change when y axis gets wider so we need to translate
	            // the stackTotalGroup at every render call. See bug #506 and #516
	            stackTotalGroup.translate(chart.plotLeft, chart.plotTop);
	
	            // Render each stack total
	            objectEach(stacks, function(type) {
	                objectEach(type, function(stack) {
	                    stack.render(stackTotalGroup);
	                });
	            });
	        };
	
	        /**
	         * Set all the stacks to initial states and destroy unused ones.
	         */
	        Axis.prototype.resetStacks = function() {
	            var axis = this,
	                stacks = axis.stacks;
	            if (!axis.isXAxis) {
	                objectEach(stacks, function(type) {
	                    objectEach(type, function(stack, key) {
	                        // Clean up memory after point deletion (#1044, #4320)
	                        if (stack.touched < axis.stacksTouched) {
	                            stack.destroy();
	                            delete type[key];
	
	                            // Reset stacks
	                        } else {
	                            stack.total = null;
	                            stack.cum = null;
	                        }
	                    });
	                });
	            }
	        };
	
	        Axis.prototype.cleanStacks = function() {
	            var stacks;
	
	            if (!this.isXAxis) {
	                if (this.oldStacks) {
	                    stacks = this.stacks = this.oldStacks;
	                }
	
	                // reset stacks
	                objectEach(stacks, function(type) {
	                    objectEach(type, function(stack) {
	                        stack.cum = stack.total;
	                    });
	                });
	            }
	        };
	
	
	        // Stacking methods defnied for Series prototype
	
	        /**
	         * Adds series' points value to corresponding stack
	         */
	        Series.prototype.setStackedPoints = function() {
	            if (!this.options.stacking || (this.visible !== true &&
	                    this.chart.options.chart.ignoreHiddenSeries !== false)) {
	                return;
	            }
	
	            var series = this,
	                xData = series.processedXData,
	                yData = series.processedYData,
	                stackedYData = [],
	                yDataLength = yData.length,
	                seriesOptions = series.options,
	                threshold = seriesOptions.threshold,
	                stackThreshold = seriesOptions.startFromThreshold ? threshold : 0,
	                stackOption = seriesOptions.stack,
	                stacking = seriesOptions.stacking,
	                stackKey = series.stackKey,
	                negKey = '-' + stackKey,
	                negStacks = series.negStacks,
	                yAxis = series.yAxis,
	                stacks = yAxis.stacks,
	                oldStacks = yAxis.oldStacks,
	                stackIndicator,
	                isNegative,
	                stack,
	                other,
	                key,
	                pointKey,
	                i,
	                x,
	                y;
	
	
	            yAxis.stacksTouched += 1;
	
	            // loop over the non-null y values and read them into a local array
	            for (i = 0; i < yDataLength; i++) {
	                x = xData[i];
	                y = yData[i];
	                stackIndicator = series.getStackIndicator(
	                    stackIndicator,
	                    x,
	                    series.index
	                );
	                pointKey = stackIndicator.key;
	                // Read stacked values into a stack based on the x value,
	                // the sign of y and the stack key. Stacking is also handled for null
	                // values (#739)
	                isNegative = negStacks && y < (stackThreshold ? 0 : threshold);
	                key = isNegative ? negKey : stackKey;
	
	                // Create empty object for this stack if it doesn't exist yet
	                if (!stacks[key]) {
	                    stacks[key] = {};
	                }
	
	                // Initialize StackItem for this x
	                if (!stacks[key][x]) {
	                    if (oldStacks[key] && oldStacks[key][x]) {
	                        stacks[key][x] = oldStacks[key][x];
	                        stacks[key][x].total = null;
	                    } else {
	                        stacks[key][x] = new H.StackItem(
	                            yAxis,
	                            yAxis.options.stackLabels,
	                            isNegative,
	                            x,
	                            stackOption
	                        );
	                    }
	                }
	
	                // If the StackItem doesn't exist, create it first
	                stack = stacks[key][x];
	                if (y !== null) {
	                    stack.points[pointKey] = stack.points[series.index] = [pick(stack.cum, stackThreshold)];
	
	                    // Record the base of the stack
	                    if (!defined(stack.cum)) {
	                        stack.base = pointKey;
	                    }
	                    stack.touched = yAxis.stacksTouched;
	
	
	                    // In area charts, if there are multiple points on the same X value,
	                    // let the area fill the full span of those points
	                    if (stackIndicator.index > 0 && series.singleStacks === false) {
	                        stack.points[pointKey][0] =
	                            stack.points[series.index + ',' + x + ',0'][0];
	                    }
	                }
	
	                // Add value to the stack total
	                if (stacking === 'percent') {
	
	                    // Percent stacked column, totals are the same for the positive and
	                    // negative stacks
	                    other = isNegative ? stackKey : negKey;
	                    if (negStacks && stacks[other] && stacks[other][x]) {
	                        other = stacks[other][x];
	                        stack.total = other.total =
	                            Math.max(other.total, stack.total) + Math.abs(y) || 0;
	
	                        // Percent stacked areas
	                    } else {
	                        stack.total = correctFloat(stack.total + (Math.abs(y) || 0));
	                    }
	                } else {
	                    stack.total = correctFloat(stack.total + (y || 0));
	                }
	
	                stack.cum = pick(stack.cum, stackThreshold) + (y || 0);
	
	                if (y !== null) {
	                    stack.points[pointKey].push(stack.cum);
	                    stackedYData[i] = stack.cum;
	                }
	
	            }
	
	            if (stacking === 'percent') {
	                yAxis.usePercentage = true;
	            }
	
	            this.stackedYData = stackedYData; // To be used in getExtremes
	
	            // Reset old stacks
	            yAxis.oldStacks = {};
	        };
	
	        /**
	         * Iterate over all stacks and compute the absolute values to percent
	         */
	        Series.prototype.setPercentStacks = function() {
	            var series = this,
	                stackKey = series.stackKey,
	                stacks = series.yAxis.stacks,
	                processedXData = series.processedXData,
	                stackIndicator;
	
	            each([stackKey, '-' + stackKey], function(key) {
	                var i = processedXData.length,
	                    x,
	                    stack,
	                    pointExtremes,
	                    totalFactor;
	
	                while (i--) {
	                    x = processedXData[i];
	                    stackIndicator = series.getStackIndicator(
	                        stackIndicator,
	                        x,
	                        series.index,
	                        key
	                    );
	                    stack = stacks[key] && stacks[key][x];
	                    pointExtremes = stack && stack.points[stackIndicator.key];
	                    if (pointExtremes) {
	                        totalFactor = stack.total ? 100 / stack.total : 0;
	                        // Y bottom value
	                        pointExtremes[0] = correctFloat(pointExtremes[0] * totalFactor);
	                        // Y value
	                        pointExtremes[1] = correctFloat(pointExtremes[1] * totalFactor);
	                        series.stackedYData[i] = pointExtremes[1];
	                    }
	                }
	            });
	        };
	
	        /**
	         * Get stack indicator, according to it's x-value, to determine points with the
	         * same x-value
	         */
	        Series.prototype.getStackIndicator = function(stackIndicator, x, index, key) {
	            // Update stack indicator, when:
	            // first point in a stack || x changed || stack type (negative vs positive)
	            // changed:
	            if (!defined(stackIndicator) || stackIndicator.x !== x ||
	                (key && stackIndicator.key !== key)) {
	                stackIndicator = {
	                    x: x,
	                    index: 0,
	                    key: key
	                };
	            } else {
	                stackIndicator.index++;
	            }
	
	            stackIndicator.key = [index, x, stackIndicator.index].join(',');
	
	            return stackIndicator;
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            animate = H.animate,
	            Axis = H.Axis,
	            Chart = H.Chart,
	            createElement = H.createElement,
	            css = H.css,
	            defined = H.defined,
	            each = H.each,
	            erase = H.erase,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            inArray = H.inArray,
	            isNumber = H.isNumber,
	            isObject = H.isObject,
	            isArray = H.isArray,
	            merge = H.merge,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            setAnimation = H.setAnimation,
	            splat = H.splat;
	
	        // Extend the Chart prototype for dynamic methods
	        extend(Chart.prototype, /** @lends Highcharts.Chart.prototype */ {
	
	            /**
	             * Add a series to the chart after render time. Note that this method should
	             * never be used when adding data synchronously at chart render time, as it
	             * adds expense to the calculations and rendering. When adding data at the
	             * same time as the chart is initialized, add the series as a configuration
	             * option instead. With multiple axes, the `offset` is dynamically adjusted.
	             *
	             * @param  {SeriesOptions} options
	             *         The config options for the series.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after adding.
	             * @param  {AnimationOptions} animation
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @return {Highcharts.Series}
	             *         The newly created series object.
	             *
	             * @sample highcharts/members/chart-addseries/
	             *         Add a series from a button
	             * @sample stock/members/chart-addseries/
	             *         Add a series in Highstock
	             */
	            addSeries: function(options, redraw, animation) {
	                var series,
	                    chart = this;
	
	                if (options) {
	                    redraw = pick(redraw, true); // defaults to true
	
	                    fireEvent(chart, 'addSeries', {
	                        options: options
	                    }, function() {
	                        series = chart.initSeries(options);
	
	                        chart.isDirtyLegend = true; // the series array is out of sync with the display
	                        chart.linkSeries();
	                        if (redraw) {
	                            chart.redraw(animation);
	                        }
	                    });
	                }
	
	                return series;
	            },
	
	            /**
	             * Add an axis to the chart after render time. Note that this method should
	             * never be used when adding data synchronously at chart render time, as it
	             * adds expense to the calculations and rendering. When adding data at the
	             * same time as the chart is initialized, add the axis as a configuration
	             * option instead.
	             * @param  {AxisOptions} options
	             *         The axis options.
	             * @param  {Boolean} [isX=false]
	             *         Whether it is an X axis or a value axis.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after adding.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether and how to apply animation in the redraw.
	             *
	             * @sample highcharts/members/chart-addaxis/ Add and remove axes
	             *
	             * @return {Axis}
	             *         The newly generated Axis object.
	             */
	            addAxis: function(options, isX, redraw, animation) {
	                var key = isX ? 'xAxis' : 'yAxis',
	                    chartOptions = this.options,
	                    userOptions = merge(options, {
	                        index: this[key].length,
	                        isX: isX
	                    }),
	                    axis;
	
	                axis = new Axis(this, userOptions);
	
	                // Push the new axis options to the chart options
	                chartOptions[key] = splat(chartOptions[key] || {});
	                chartOptions[key].push(userOptions);
	
	                if (pick(redraw, true)) {
	                    this.redraw(animation);
	                }
	
	                return axis;
	            },
	
	            /**
	             * Dim the chart and show a loading text or symbol. Options for the loading
	             * screen are defined in {@link
	             * https://api.highcharts.com/highcharts/loading|the loading options}.
	             * 
	             * @param  {String} str
	             *         An optional text to show in the loading label instead of the
	             *         default one. The default text is set in {@link
	             *         http://api.highcharts.com/highcharts/lang.loading|lang.loading}.
	             *
	             * @sample highcharts/members/chart-hideloading/
	             *         Show and hide loading from a button
	             * @sample highcharts/members/chart-showloading/
	             *         Apply different text labels
	             * @sample stock/members/chart-show-hide-loading/
	             *         Toggle loading in Highstock
	             */
	            showLoading: function(str) {
	                var chart = this,
	                    options = chart.options,
	                    loadingDiv = chart.loadingDiv,
	                    loadingOptions = options.loading,
	                    setLoadingSize = function() {
	                        if (loadingDiv) {
	                            css(loadingDiv, {
	                                left: chart.plotLeft + 'px',
	                                top: chart.plotTop + 'px',
	                                width: chart.plotWidth + 'px',
	                                height: chart.plotHeight + 'px'
	                            });
	                        }
	                    };
	
	                // create the layer at the first call
	                if (!loadingDiv) {
	                    chart.loadingDiv = loadingDiv = createElement('div', {
	                        className: 'highcharts-loading highcharts-loading-hidden'
	                    }, null, chart.container);
	
	                    chart.loadingSpan = createElement(
	                        'span', {
	                            className: 'highcharts-loading-inner'
	                        },
	                        null,
	                        loadingDiv
	                    );
	                    addEvent(chart, 'redraw', setLoadingSize); // #1080
	                }
	
	                loadingDiv.className = 'highcharts-loading';
	
	                // Update text
	                chart.loadingSpan.innerHTML = str || options.lang.loading;
	
	
	                // Update visuals
	                css(loadingDiv, extend(loadingOptions.style, {
	                    zIndex: 10
	                }));
	                css(chart.loadingSpan, loadingOptions.labelStyle);
	
	                // Show it
	                if (!chart.loadingShown) {
	                    css(loadingDiv, {
	                        opacity: 0,
	                        display: ''
	                    });
	                    animate(loadingDiv, {
	                        opacity: loadingOptions.style.opacity || 0.5
	                    }, {
	                        duration: loadingOptions.showDuration || 0
	                    });
	                }
	
	
	                chart.loadingShown = true;
	                setLoadingSize();
	            },
	
	            /**
	             * Hide the loading layer.
	             *
	             * @see    Highcharts.Chart#showLoading
	             * @sample highcharts/members/chart-hideloading/
	             *         Show and hide loading from a button
	             * @sample stock/members/chart-show-hide-loading/
	             *         Toggle loading in Highstock
	             */
	            hideLoading: function() {
	                var options = this.options,
	                    loadingDiv = this.loadingDiv;
	
	                if (loadingDiv) {
	                    loadingDiv.className = 'highcharts-loading highcharts-loading-hidden';
	
	                    animate(loadingDiv, {
	                        opacity: 0
	                    }, {
	                        duration: options.loading.hideDuration || 100,
	                        complete: function() {
	                            css(loadingDiv, {
	                                display: 'none'
	                            });
	                        }
	                    });
	
	                }
	                this.loadingShown = false;
	            },
	
	            /** 
	             * These properties cause isDirtyBox to be set to true when updating. Can be extended from plugins.
	             */
	            propsRequireDirtyBox: ['backgroundColor', 'borderColor', 'borderWidth', 'margin', 'marginTop', 'marginRight',
	                'marginBottom', 'marginLeft', 'spacing', 'spacingTop', 'spacingRight', 'spacingBottom', 'spacingLeft',
	                'borderRadius', 'plotBackgroundColor', 'plotBackgroundImage', 'plotBorderColor', 'plotBorderWidth',
	                'plotShadow', 'shadow'
	            ],
	
	            /** 
	             * These properties cause all series to be updated when updating. Can be
	             * extended from plugins.
	             */
	            propsRequireUpdateSeries: ['chart.inverted', 'chart.polar',
	                'chart.ignoreHiddenSeries', 'chart.type', 'colors', 'plotOptions',
	                'tooltip'
	            ],
	
	            /**
	             * A generic function to update any element of the chart. Elements can be
	             * enabled and disabled, moved, re-styled, re-formatted etc.
	             *
	             * A special case is configuration objects that take arrays, for example
	             * {@link https://api.highcharts.com/highcharts/xAxis|xAxis}, 
	             * {@link https://api.highcharts.com/highcharts/yAxis|yAxis} or 
	             * {@link https://api.highcharts.com/highcharts/series|series}. For these
	             * collections, an `id` option is used to map the new option set to an
	             * existing object. If an existing object of the same id is not found, the
	             * corresponding item is updated. So for example, running `chart.update`
	             * with a series item without an id, will cause the existing chart's series
	             * with the same index in the series array to be updated. When the
	             * `oneToOne` parameter is true, `chart.update` will also take care of
	             * adding and removing items from the collection. Read more under the
	             * parameter description below.
	             *
	             * See also the {@link https://api.highcharts.com/highcharts/responsive|
	             * responsive option set}. Switching between `responsive.rules` basically
	             * runs `chart.update` under the hood.
	             *
	             * @param  {Options} options
	             *         A configuration object for the new chart options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart.
	             * @param  {Boolean} [oneToOne=false]
	             *         When `true`, the `series`, `xAxis` and `yAxis` collections will
	             *         be updated one to one, and items will be either added or removed
	             *         to match the new updated options. For example, if the chart has
	             *         two series and we call `chart.update` with a configuration 
	             *         containing three series, one will be added. If we call
	             *         `chart.update` with one series, one will be removed. Setting an
	             *         empty `series` array will remove all series, but leaving out the
	             *         `series` property will leave all series untouched. If the series
	             *         have id's, the new series options will be matched by id, and the
	             *         remaining ones removed.
	             *
	             * @sample highcharts/members/chart-update/
	             *         Update chart geometry 
	             */
	            update: function(options, redraw, oneToOne) {
	                var chart = this,
	                    adders = {
	                        credits: 'addCredits',
	                        title: 'setTitle',
	                        subtitle: 'setSubtitle'
	                    },
	                    optionsChart = options.chart,
	                    updateAllAxes,
	                    updateAllSeries,
	                    newWidth,
	                    newHeight,
	                    itemsForRemoval = [];
	
	                // If the top-level chart option is present, some special updates are required		
	                if (optionsChart) {
	                    merge(true, chart.options.chart, optionsChart);
	
	                    // Setter function
	                    if ('className' in optionsChart) {
	                        chart.setClassName(optionsChart.className);
	                    }
	
	                    if ('inverted' in optionsChart || 'polar' in optionsChart) {
	                        // Parse options.chart.inverted and options.chart.polar together
	                        // with the available series.
	                        chart.propFromSeries();
	                        updateAllAxes = true;
	                    }
	
	                    if ('alignTicks' in optionsChart) { // #6452
	                        updateAllAxes = true;
	                    }
	
	                    objectEach(optionsChart, function(val, key) {
	                        if (inArray('chart.' + key, chart.propsRequireUpdateSeries) !== -1) {
	                            updateAllSeries = true;
	                        }
	                        // Only dirty box
	                        if (inArray(key, chart.propsRequireDirtyBox) !== -1) {
	                            chart.isDirtyBox = true;
	                        }
	                    });
	
	
	                    if ('style' in optionsChart) {
	                        chart.renderer.setStyle(optionsChart.style);
	                    }
	
	                }
	
	                // Moved up, because tooltip needs updated plotOptions (#6218)
	
	                if (options.colors) {
	                    this.options.colors = options.colors;
	                }
	
	
	                if (options.plotOptions) {
	                    merge(true, this.options.plotOptions, options.plotOptions);
	                }
	
	                // Some option stuctures correspond one-to-one to chart objects that
	                // have update methods, for example
	                // options.credits => chart.credits
	                // options.legend => chart.legend
	                // options.title => chart.title
	                // options.tooltip => chart.tooltip
	                // options.subtitle => chart.subtitle
	                // options.mapNavigation => chart.mapNavigation
	                // options.navigator => chart.navigator
	                // options.scrollbar => chart.scrollbar
	                objectEach(options, function(val, key) {
	                    if (chart[key] && typeof chart[key].update === 'function') {
	                        chart[key].update(val, false);
	
	                        // If a one-to-one object does not exist, look for an adder function
	                    } else if (typeof chart[adders[key]] === 'function') {
	                        chart[adders[key]](val);
	                    }
	
	                    if (
	                        key !== 'chart' &&
	                        inArray(key, chart.propsRequireUpdateSeries) !== -1
	                    ) {
	                        updateAllSeries = true;
	                    }
	                });
	
	                // Setters for collections. For axes and series, each item is referred
	                // by an id. If the id is not found, it defaults to the corresponding
	                // item in the collection, so setting one series without an id, will
	                // update the first series in the chart. Setting two series without
	                // an id will update the first and the second respectively (#6019)
	                // chart.update and responsive.
	                each([
	                    'xAxis',
	                    'yAxis',
	                    'zAxis',
	                    'series',
	                    'colorAxis',
	                    'pane'
	                ], function(coll) {
	                    if (options[coll]) {
	                        each(splat(options[coll]), function(newOptions, i) {
	                            var item = (
	                                defined(newOptions.id) &&
	                                chart.get(newOptions.id)
	                            ) || chart[coll][i];
	                            if (item && item.coll === coll) {
	                                item.update(newOptions, false);
	
	                                if (oneToOne) {
	                                    item.touched = true;
	                                }
	                            }
	
	                            // If oneToOne and no matching item is found, add one
	                            if (!item && oneToOne) {
	                                if (coll === 'series') {
	                                    chart.addSeries(newOptions, false)
	                                        .touched = true;
	                                } else if (coll === 'xAxis' || coll === 'yAxis') {
	                                    chart.addAxis(newOptions, coll === 'xAxis', false)
	                                        .touched = true;
	                                }
	                            }
	
	                        });
	
	                        // Add items for removal
	                        if (oneToOne) {
	                            each(chart[coll], function(item) {
	                                if (!item.touched) {
	                                    itemsForRemoval.push(item);
	                                } else {
	                                    delete item.touched;
	                                }
	                            });
	                        }
	
	
	                    }
	                });
	
	                each(itemsForRemoval, function(item) {
	                    item.remove(false);
	                });
	
	                if (updateAllAxes) {
	                    each(chart.axes, function(axis) {
	                        axis.update({}, false);
	                    });
	                }
	
	                // Certain options require the whole series structure to be thrown away
	                // and rebuilt
	                if (updateAllSeries) {
	                    each(chart.series, function(series) {
	                        series.update({}, false);
	                    });
	                }
	
	                // For loading, just update the options, do not redraw
	                if (options.loading) {
	                    merge(true, chart.options.loading, options.loading);
	                }
	
	                // Update size. Redraw is forced.
	                newWidth = optionsChart && optionsChart.width;
	                newHeight = optionsChart && optionsChart.height;
	                if ((isNumber(newWidth) && newWidth !== chart.chartWidth) ||
	                    (isNumber(newHeight) && newHeight !== chart.chartHeight)) {
	                    chart.setSize(newWidth, newHeight);
	                } else if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Shortcut to set the subtitle options. This can also be done from {@link
	             * Chart#update} or {@link Chart#setTitle}.
	             *
	             * @param  {SubtitleOptions} options
	             *         New subtitle options. The subtitle text itself is set by the
	             *         `options.text` property.
	             */
	            setSubtitle: function(options) {
	                this.setTitle(undefined, options);
	            }
	
	
	        });
	
	        // extend the Point prototype for dynamic methods
	        extend(Point.prototype, /** @lends Highcharts.Point.prototype */ {
	            /**
	             * Update point with new options (typically x/y data) and optionally redraw
	             * the series.
	             *
	             * @param  {Object} options
	             *         The point options. Point options are handled as described under
	             *         the `series<type>.data` item for each series type. For example
	             *         for a line series, if options is a single number, the point will
	             *         be given that number as the main y value. If it is an array, it
	             *         will be interpreted as x and y values respectively. If it is an
	             *         object, advanced options are applied. 
	             * @param  {Boolean} [redraw=true]
	             *          Whether to redraw the chart after the point is updated. If doing
	             *          more operations on the chart, it is best practice to set
	             *          `redraw` to false and call `chart.redraw()` after.
	             * @param  {AnimationOptions} [animation=true]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/members/point-update-column/
	             *         Update column value
	             * @sample highcharts/members/point-update-pie/
	             *         Update pie slice
	             * @sample maps/members/point-update/
	             *         Update map area value in Highmaps
	             */
	            update: function(options, redraw, animation, runEvent) {
	                var point = this,
	                    series = point.series,
	                    graphic = point.graphic,
	                    i,
	                    chart = series.chart,
	                    seriesOptions = series.options;
	
	                redraw = pick(redraw, true);
	
	                function update() {
	
	                    point.applyOptions(options);
	
	                    // Update visuals
	                    if (point.y === null && graphic) { // #4146
	                        point.graphic = graphic.destroy();
	                    }
	                    if (isObject(options, true)) {
	                        // Destroy so we can get new elements
	                        if (graphic && graphic.element) {
	                            // "null" is also a valid symbol
	                            if (options && options.marker && options.marker.symbol !== undefined) {
	                                point.graphic = graphic.destroy();
	                            }
	                        }
	                        if (options && options.dataLabels && point.dataLabel) { // #2468
	                            point.dataLabel = point.dataLabel.destroy();
	                        }
	                    }
	
	                    // record changes in the parallel arrays
	                    i = point.index;
	                    series.updateParallelArrays(point, i);
	
	                    // Record the options to options.data. If the old or the new config
	                    // is an object, use point options, otherwise use raw options
	                    // (#4701, #4916).
	                    seriesOptions.data[i] = (
	                            isObject(seriesOptions.data[i], true) ||
	                            isObject(options, true)
	                        ) ?
	                        point.options :
	                        options;
	
	                    // redraw
	                    series.isDirty = series.isDirtyData = true;
	                    if (!series.fixedBox && series.hasCartesianSeries) { // #1906, #2320
	                        chart.isDirtyBox = true;
	                    }
	
	                    if (seriesOptions.legendType === 'point') { // #1831, #1885
	                        chart.isDirtyLegend = true;
	                    }
	                    if (redraw) {
	                        chart.redraw(animation);
	                    }
	                }
	
	                // Fire the event with a default handler of doing the update
	                if (runEvent === false) { // When called from setData
	                    update();
	                } else {
	                    point.firePointEvent('update', {
	                        options: options
	                    }, update);
	                }
	            },
	
	            /**
	             * Remove a point and optionally redraw the series and if necessary the axes
	             * @param  {Boolean} redraw
	             *         Whether to redraw the chart or wait for an explicit call. When
	             *         doing more operations on the chart, for example running
	             *         `point.remove()` in a loop, it is best practice to set `redraw`
	             *         to false and call `chart.redraw()` after.         
	             * @param  {AnimationOptions} [animation=false]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/plotoptions/series-point-events-remove/
	             *         Remove point and confirm
	             * @sample highcharts/members/point-remove/
	             *         Remove pie slice
	             * @sample maps/members/point-remove/
	             *         Remove selected points in Highmaps
	             */
	            remove: function(redraw, animation) {
	                this.series.removePoint(inArray(this, this.series.data), redraw, animation);
	            }
	        });
	
	        // Extend the series prototype for dynamic methods
	        extend(Series.prototype, /** @lends Series.prototype */ {
	            /**
	             * Add a point to the series after render time. The point can be added at
	             * the end, or by giving it an X value, to the start or in the middle of the
	             * series.
	             * 
	             * @param  {Number|Array|Object} options
	             *         The point options. If options is a single number, a point with
	             *         that y value is appended to the series.If it is an array, it will
	             *         be interpreted as x and y values respectively. If it is an
	             *         object, advanced options as outlined under `series.data` are
	             *         applied.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the point is added. When adding
	             *         more than one point, it is highly recommended that the redraw
	             *         option be set to false, and instead {@link Chart#redraw}
	             *         is explicitly called after the adding of points is finished.
	             *         Otherwise, the chart will redraw after adding each point.
	             * @param  {Boolean} [shift=false]
	             *         If true, a point is shifted off the start of the series as one is
	             *         appended to the end.
	             * @param  {AnimationOptions} [animation]
	             *         Whether to apply animation, and optionally animation
	             *         configuration.
	             *
	             * @sample highcharts/members/series-addpoint-append/
	             *         Append point
	             * @sample highcharts/members/series-addpoint-append-and-shift/
	             *         Append and shift
	             * @sample highcharts/members/series-addpoint-x-and-y/
	             *         Both X and Y values given
	             * @sample highcharts/members/series-addpoint-pie/
	             *         Append pie slice
	             * @sample stock/members/series-addpoint/
	             *         Append 100 points in Highstock
	             * @sample stock/members/series-addpoint-shift/
	             *         Append and shift in Highstock
	             * @sample maps/members/series-addpoint/
	             *         Add a point in Highmaps
	             */
	            addPoint: function(options, redraw, shift, animation) {
	                var series = this,
	                    seriesOptions = series.options,
	                    data = series.data,
	                    chart = series.chart,
	                    xAxis = series.xAxis,
	                    names = xAxis && xAxis.hasNames && xAxis.names,
	                    dataOptions = seriesOptions.data,
	                    point,
	                    isInTheMiddle,
	                    xData = series.xData,
	                    i,
	                    x;
	
	                // Optional redraw, defaults to true
	                redraw = pick(redraw, true);
	
	                // Get options and push the point to xData, yData and series.options. In series.generatePoints
	                // the Point instance will be created on demand and pushed to the series.data array.
	                point = {
	                    series: series
	                };
	                series.pointClass.prototype.applyOptions.apply(point, [options]);
	                x = point.x;
	
	                // Get the insertion point
	                i = xData.length;
	                if (series.requireSorting && x < xData[i - 1]) {
	                    isInTheMiddle = true;
	                    while (i && xData[i - 1] > x) {
	                        i--;
	                    }
	                }
	
	                series.updateParallelArrays(point, 'splice', i, 0, 0); // insert undefined item
	                series.updateParallelArrays(point, i); // update it
	
	                if (names && point.name) {
	                    names[x] = point.name;
	                }
	                dataOptions.splice(i, 0, options);
	
	                if (isInTheMiddle) {
	                    series.data.splice(i, 0, null);
	                    series.processData();
	                }
	
	                // Generate points to be added to the legend (#1329)
	                if (seriesOptions.legendType === 'point') {
	                    series.generatePoints();
	                }
	
	                // Shift the first point off the parallel arrays
	                if (shift) {
	                    if (data[0] && data[0].remove) {
	                        data[0].remove(false);
	                    } else {
	                        data.shift();
	                        series.updateParallelArrays(point, 'shift');
	
	                        dataOptions.shift();
	                    }
	                }
	
	                // redraw
	                series.isDirty = true;
	                series.isDirtyData = true;
	
	                if (redraw) {
	                    chart.redraw(animation); // Animation is set anyway on redraw, #5665
	                }
	            },
	
	            /**
	             * Remove a point from the series. Unlike the {@link Highcharts.Point#remove}
	             * method, this can also be done on a point that is not instanciated because
	             * it is outside the view or subject to Highstock data grouping.
	             *
	             * @param  {Number} i
	             *         The index of the point in the {@link Highcharts.Series.data|data}
	             *         array.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the point is added. When 
	             *         removing more than one point, it is highly recommended that the
	             *         `redraw` option be set to `false`, and instead {@link
	             *         Highcharts.Chart#redraw} is explicitly called after the adding of
	             *         points is finished.
	             * @param  {AnimationOptions} [animation]
	             *         Whether and optionally how the series should be animated.
	             *
	             * @sample highcharts/members/series-removepoint/
	             *         Remove cropped point
	             */
	            removePoint: function(i, redraw, animation) {
	
	                var series = this,
	                    data = series.data,
	                    point = data[i],
	                    points = series.points,
	                    chart = series.chart,
	                    remove = function() {
	
	                        if (points && points.length === data.length) { // #4935
	                            points.splice(i, 1);
	                        }
	                        data.splice(i, 1);
	                        series.options.data.splice(i, 1);
	                        series.updateParallelArrays(point || {
	                            series: series
	                        }, 'splice', i, 1);
	
	                        if (point) {
	                            point.destroy();
	                        }
	
	                        // redraw
	                        series.isDirty = true;
	                        series.isDirtyData = true;
	                        if (redraw) {
	                            chart.redraw();
	                        }
	                    };
	
	                setAnimation(animation, chart);
	                redraw = pick(redraw, true);
	
	                // Fire the event with a default handler of removing the point
	                if (point) {
	                    point.firePointEvent('remove', null, remove);
	                } else {
	                    remove();
	                }
	            },
	
	            /**
	             * Remove a series and optionally redraw the chart.
	             *
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart or wait for an explicit call to
	             *         {@link Highcharts.Chart#redraw}.
	             * @param  {AnimationOptions} [animation]
	             *         Whether to apply animation, and optionally animation
	             *         configuration
	             * @param  {Boolean} [withEvent=true]
	             *         Used internally, whether to fire the series `remove` event.
	             *
	             * @sample highcharts/members/series-remove/
	             *         Remove first series from a button
	             */
	            remove: function(redraw, animation, withEvent) {
	                var series = this,
	                    chart = series.chart;
	
	                function remove() {
	
	                    // Destroy elements
	                    series.destroy();
	
	                    // Redraw
	                    chart.isDirtyLegend = chart.isDirtyBox = true;
	                    chart.linkSeries();
	
	                    if (pick(redraw, true)) {
	                        chart.redraw(animation);
	                    }
	                }
	
	                // Fire the event with a default handler of removing the point
	                if (withEvent !== false) {
	                    fireEvent(series, 'remove', null, remove);
	                } else {
	                    remove();
	                }
	            },
	
	            /**
	             * Update the series with a new set of options. For a clean and precise
	             * handling of new options, all methods and elements from the series are
	             * removed, and it is initiated from scratch. Therefore, this method is more
	             * performance expensive than some other utility methods like {@link
	             * Series#setData} or {@link Series#setVisible}.
	             *
	             * @param  {SeriesOptions} options
	             *         New options that will be merged with the series' existing
	             *         options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw} after.
	             *
	             * @sample highcharts/members/series-update/
	             *         Updating series options
	             * @sample maps/members/series-update/
	             *         Update series options in Highmaps
	             */
	            update: function(newOptions, redraw) {
	                var series = this,
	                    chart = series.chart,
	                    // must use user options when changing type because series.options
	                    // is merged in with type specific plotOptions
	                    oldOptions = series.userOptions,
	                    oldType = series.oldType || series.type,
	                    newType = newOptions.type || oldOptions.type || chart.options.chart.type,
	                    proto = seriesTypes[oldType].prototype,
	                    n,
	                    preserve = [
	                        'group',
	                        'markerGroup',
	                        'dataLabelsGroup',
	                        'navigatorSeries',
	                        'baseSeries'
	                    ],
	
	                    // Animation must be enabled when calling update before the initial
	                    // animation has first run. This happens when calling update
	                    // directly after chart initialization, or when applying responsive
	                    // rules (#6912).
	                    animation = series.finishedAnimating && {
	                        animation: false
	                    };
	
	                // Running Series.update to update the data only is an intuitive usage,
	                // so we want to make sure that when used like this, we run the
	                // cheaper setData function and allow animation instead of completely
	                // recreating the series instance.
	                if (Object.keys && Object.keys(newOptions).toString() === 'data') {
	                    return this.setData(newOptions.data, redraw);
	                }
	
	                // If we're changing type or zIndex, create new groups (#3380, #3404)
	                if ((newType && newType !== oldType) || newOptions.zIndex !== undefined) {
	                    preserve.length = 0;
	                }
	
	                // Make sure groups are not destroyed (#3094)
	                each(preserve, function(prop) {
	                    preserve[prop] = series[prop];
	                    delete series[prop];
	                });
	
	                // Do the merge, with some forced options
	                newOptions = merge(oldOptions, animation, {
	                    index: series.index,
	                    pointStart: series.xData[0] // when updating after addPoint
	                }, {
	                    data: series.options.data
	                }, newOptions);
	
	                // Destroy the series and delete all properties. Reinsert all methods
	                // and properties from the new type prototype (#2270, #3719)
	                series.remove(false, null, false);
	                for (n in proto) {
	                    series[n] = undefined;
	                }
	                extend(series, seriesTypes[newType || oldType].prototype);
	
	                // Re-register groups (#3094) and other preserved properties
	                each(preserve, function(prop) {
	                    series[prop] = preserve[prop];
	                });
	
	                series.init(chart, newOptions);
	                series.oldType = oldType;
	                chart.linkSeries(); // Links are lost in series.remove (#3028)
	                if (pick(redraw, true)) {
	                    chart.redraw(false);
	                }
	            }
	        });
	
	        // Extend the Axis.prototype for dynamic methods
	        extend(Axis.prototype, /** @lends Highcharts.Axis.prototype */ {
	
	            /**
	             * Update an axis object with a new set of options. The options are merged
	             * with the existing options, so only new or altered options need to be
	             * specified.
	             *
	             * @param  {Object} options
	             *         The new options that will be merged in with existing options on
	             *         the axis.
	             * @sample highcharts/members/axis-update/ Axis update demo
	             */
	            update: function(options, redraw) {
	                var chart = this.chart;
	
	                options = chart.options[this.coll][this.options.index] =
	                    merge(this.userOptions, options);
	
	                this.destroy(true);
	
	                this.init(chart, extend(options, {
	                    events: undefined
	                }));
	
	                chart.isDirtyBox = true;
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Remove the axis from the chart.
	             *
	             * @param {Boolean} [redraw=true] Whether to redraw the chart following the
	             * remove.
	             *
	             * @sample highcharts/members/chart-addaxis/ Add and remove axes
	             */
	            remove: function(redraw) {
	                var chart = this.chart,
	                    key = this.coll, // xAxis or yAxis
	                    axisSeries = this.series,
	                    i = axisSeries.length;
	
	                // Remove associated series (#2687)
	                while (i--) {
	                    if (axisSeries[i]) {
	                        axisSeries[i].remove(false);
	                    }
	                }
	
	                // Remove the axis
	                erase(chart.axes, this);
	                erase(chart[key], this);
	
	                if (isArray(chart.options[key])) {
	                    chart.options[key].splice(this.options.index, 1);
	                } else { // color axis, #6488
	                    delete chart.options[key];
	                }
	
	                each(chart[key], function(axis, i) { // Re-index, #1706
	                    axis.options.index = i;
	                });
	                this.destroy();
	                chart.isDirtyBox = true;
	
	                if (pick(redraw, true)) {
	                    chart.redraw();
	                }
	            },
	
	            /**
	             * Update the axis title by options after render time.
	             *
	             * @param  {TitleOptions} titleOptions
	             *         The additional title options.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after setting the title.
	             * @sample highcharts/members/axis-settitle/ Set a new Y axis title
	             */
	            setTitle: function(titleOptions, redraw) {
	                this.update({
	                    title: titleOptions
	                }, redraw);
	            },
	
	            /**
	             * Set new axis categories and optionally redraw.
	             * @param {Array.<String>} categories - The new categories.
	             * @param {Boolean} [redraw=true] - Whether to redraw the chart.
	             * @sample highcharts/members/axis-setcategories/ Set categories by click on
	             * a button
	             */
	            setCategories: function(categories, redraw) {
	                this.update({
	                    categories: categories
	                }, redraw);
	            }
	
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var color = H.color,
	            each = H.each,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            map = H.map,
	            pick = H.pick,
	            Series = H.Series,
	            seriesType = H.seriesType;
	
	        /**
	         * Area series type.
	         * @constructor seriesTypes.area
	         * @extends {Series}
	         */
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.area
	         */
	        seriesType('area', 'line', {
	
	            /**
	             * When this is true, the series will not cause the Y axis to cross
	             * the zero plane (or [threshold](#plotOptions.series.threshold) option)
	             * unless the data actually crosses the plane.
	             * 
	             * For example, if `softThreshold` is `false`, a series of 0, 1, 2,
	             * 3 will make the Y axis show negative values according to the `minPadding`
	             * option. If `softThreshold` is `true`, the Y axis starts at 0.
	             * 
	             * @type {Boolean}
	             * @default false
	             * @since 4.1.9
	             * @product highcharts highstock
	             */
	            softThreshold: false,
	
	            /**
	             * The Y axis value to serve as the base for the area, for distinguishing
	             * between values above and below a threshold. If `null`, the area
	             * behaves like a line series with fill between the graph and the Y
	             * axis minimum.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/area-threshold/ A threshold of 100
	             * @default 0
	             * @since 2.0
	             * @product highcharts highstock
	             */
	            threshold: 0
	            // trackByArea: false,
	            // lineColor: null, // overrides color, but lets fillColor be unaltered
	            // fillOpacity: 0.75,
	            // fillColor: null
	        }, /** @lends seriesTypes.area.prototype */ {
	            singleStacks: false,
	            /** 
	             * Return an array of stacked points, where null and missing points are replaced by 
	             * dummy points in order for gaps to be drawn correctly in stacks.
	             */
	            getStackPoints: function(points) {
	                var series = this,
	                    segment = [],
	                    keys = [],
	                    xAxis = this.xAxis,
	                    yAxis = this.yAxis,
	                    stack = yAxis.stacks[this.stackKey],
	                    pointMap = {},
	                    seriesIndex = series.index,
	                    yAxisSeries = yAxis.series,
	                    seriesLength = yAxisSeries.length,
	                    visibleSeries,
	                    upOrDown = pick(yAxis.options.reversedStacks, true) ? 1 : -1,
	                    i;
	
	
	                points = points || this.points;
	
	                if (this.options.stacking) {
	                    // Create a map where we can quickly look up the points by their X value.
	                    for (i = 0; i < points.length; i++) {
	                        pointMap[points[i].x] = points[i];
	                    }
	
	                    // Sort the keys (#1651)
	                    H.objectEach(stack, function(stackX, x) {
	                        if (stackX.total !== null) { // nulled after switching between grouping and not (#1651, #2336)
	                            keys.push(x);
	                        }
	                    });
	                    keys.sort(function(a, b) {
	                        return a - b;
	                    });
	
	                    visibleSeries = map(yAxisSeries, function() {
	                        return this.visible;
	                    });
	
	                    each(keys, function(x, idx) {
	                        var y = 0,
	                            stackPoint,
	                            stackedValues;
	
	                        if (pointMap[x] && !pointMap[x].isNull) {
	                            segment.push(pointMap[x]);
	
	                            // Find left and right cliff. -1 goes left, 1 goes right.
	                            each([-1, 1], function(direction) {
	                                var nullName = direction === 1 ? 'rightNull' : 'leftNull',
	                                    cliffName = direction === 1 ? 'rightCliff' : 'leftCliff',
	                                    cliff = 0,
	                                    otherStack = stack[keys[idx + direction]];
	
	                                // If there is a stack next to this one, to the left or to the right...
	                                if (otherStack) {
	                                    i = seriesIndex;
	                                    while (i >= 0 && i < seriesLength) { // Can go either up or down, depending on reversedStacks
	                                        stackPoint = otherStack.points[i];
	                                        if (!stackPoint) {
	                                            // If the next point in this series is missing, mark the point
	                                            // with point.leftNull or point.rightNull = true.
	                                            if (i === seriesIndex) {
	                                                pointMap[x][nullName] = true;
	
	                                                // If there are missing points in the next stack in any of the 
	                                                // series below this one, we need to substract the missing values
	                                                // and add a hiatus to the left or right.
	                                            } else if (visibleSeries[i]) {
	                                                stackedValues = stack[x].points[i];
	                                                if (stackedValues) {
	                                                    cliff -= stackedValues[1] - stackedValues[0];
	                                                }
	                                            }
	                                        }
	                                        // When reversedStacks is true, loop up, else loop down
	                                        i += upOrDown;
	                                    }
	                                }
	                                pointMap[x][cliffName] = cliff;
	                            });
	
	
	                            // There is no point for this X value in this series, so we 
	                            // insert a dummy point in order for the areas to be drawn
	                            // correctly.
	                        } else {
	
	                            // Loop down the stack to find the series below this one that has
	                            // a value (#1991)
	                            i = seriesIndex;
	                            while (i >= 0 && i < seriesLength) {
	                                stackPoint = stack[x].points[i];
	                                if (stackPoint) {
	                                    y = stackPoint[1];
	                                    break;
	                                }
	                                // When reversedStacks is true, loop up, else loop down
	                                i += upOrDown;
	                            }
	                            y = yAxis.translate(y, 0, 1, 0, 1); // #6272
	                            segment.push({
	                                isNull: true,
	                                plotX: xAxis.translate(x, 0, 0, 0, 1), // #6272
	                                x: x,
	                                plotY: y,
	                                yBottom: y
	                            });
	                        }
	                    });
	
	                }
	
	                return segment;
	            },
	
	            getGraphPath: function(points) {
	                var getGraphPath = Series.prototype.getGraphPath,
	                    graphPath,
	                    options = this.options,
	                    stacking = options.stacking,
	                    yAxis = this.yAxis,
	                    topPath,
	                    //topPoints = [],
	                    bottomPath,
	                    bottomPoints = [],
	                    graphPoints = [],
	                    seriesIndex = this.index,
	                    i,
	                    areaPath,
	                    plotX,
	                    stacks = yAxis.stacks[this.stackKey],
	                    threshold = options.threshold,
	                    translatedThreshold = yAxis.getThreshold(options.threshold),
	                    isNull,
	                    yBottom,
	                    connectNulls = options.connectNulls || stacking === 'percent',
	                    /**
	                     * To display null points in underlying stacked series, this series graph must be 
	                     * broken, and the area also fall down to fill the gap left by the null point. #2069
	                     */
	                    addDummyPoints = function(i, otherI, side) {
	                        var point = points[i],
	                            stackedValues = stacking && stacks[point.x].points[seriesIndex],
	                            nullVal = point[side + 'Null'] || 0,
	                            cliffVal = point[side + 'Cliff'] || 0,
	                            top,
	                            bottom,
	                            isNull = true;
	
	                        if (cliffVal || nullVal) {
	
	                            top = (nullVal ? stackedValues[0] : stackedValues[1]) + cliffVal;
	                            bottom = stackedValues[0] + cliffVal;
	                            isNull = !!nullVal;
	
	                        } else if (!stacking && points[otherI] && points[otherI].isNull) {
	                            top = bottom = threshold;
	                        }
	
	                        // Add to the top and bottom line of the area
	                        if (top !== undefined) {
	                            graphPoints.push({
	                                plotX: plotX,
	                                plotY: top === null ? translatedThreshold : yAxis.getThreshold(top),
	                                isNull: isNull,
	                                isCliff: true
	                            });
	                            bottomPoints.push({
	                                plotX: plotX,
	                                plotY: bottom === null ? translatedThreshold : yAxis.getThreshold(bottom),
	                                doCurve: false // #1041, gaps in areaspline areas
	                            });
	                        }
	                    };
	
	                // Find what points to use
	                points = points || this.points;
	
	                // Fill in missing points
	                if (stacking) {
	                    points = this.getStackPoints(points);
	                }
	
	                for (i = 0; i < points.length; i++) {
	                    isNull = points[i].isNull;
	                    plotX = pick(points[i].rectPlotX, points[i].plotX);
	                    yBottom = pick(points[i].yBottom, translatedThreshold);
	
	                    if (!isNull || connectNulls) {
	
	                        if (!connectNulls) {
	                            addDummyPoints(i, i - 1, 'left');
	                        }
	
	                        if (!(isNull && !stacking && connectNulls)) { // Skip null point when stacking is false and connectNulls true
	                            graphPoints.push(points[i]);
	                            bottomPoints.push({
	                                x: i,
	                                plotX: plotX,
	                                plotY: yBottom
	                            });
	                        }
	
	                        if (!connectNulls) {
	                            addDummyPoints(i, i + 1, 'right');
	                        }
	                    }
	                }
	
	                topPath = getGraphPath.call(this, graphPoints, true, true);
	
	                bottomPoints.reversed = true;
	                bottomPath = getGraphPath.call(this, bottomPoints, true, true);
	                if (bottomPath.length) {
	                    bottomPath[0] = 'L';
	                }
	
	                areaPath = topPath.concat(bottomPath);
	                graphPath = getGraphPath.call(this, graphPoints, false, connectNulls); // TODO: don't set leftCliff and rightCliff when connectNulls?
	
	                areaPath.xMap = topPath.xMap;
	                this.areaPath = areaPath;
	
	                return graphPath;
	            },
	
	            /**
	             * Draw the graph and the underlying area. This method calls the Series base
	             * function and adds the area. The areaPath is calculated in the getSegmentPath
	             * method called from Series.prototype.drawGraph.
	             */
	            drawGraph: function() {
	
	                // Define or reset areaPath
	                this.areaPath = [];
	
	                // Call the base method
	                Series.prototype.drawGraph.apply(this);
	
	                // Define local variables
	                var series = this,
	                    areaPath = this.areaPath,
	                    options = this.options,
	                    zones = this.zones,
	                    props = [
	                        [
	                            'area',
	                            'highcharts-area',
	
	                            this.color,
	                            options.fillColor
	
	                        ]
	                    ]; // area name, main color, fill color
	
	                each(zones, function(zone, i) {
	                    props.push([
	                        'zone-area-' + i,
	                        'highcharts-area highcharts-zone-area-' + i + ' ' + zone.className,
	
	                        zone.color || series.color,
	                        zone.fillColor || options.fillColor
	
	                    ]);
	                });
	
	                each(props, function(prop) {
	                    var areaKey = prop[0],
	                        area = series[areaKey];
	
	                    // Create or update the area
	                    if (area) { // update
	                        area.endX = areaPath.xMap;
	                        area.animate({
	                            d: areaPath
	                        });
	
	                    } else { // create
	                        area = series[areaKey] = series.chart.renderer.path(areaPath)
	                            .addClass(prop[1])
	                            .attr({
	
	                                fill: pick(
	                                    prop[3],
	                                    color(prop[2]).setOpacity(pick(options.fillOpacity, 0.75)).get()
	                                ),
	
	                                zIndex: 0 // #1069
	                            }).add(series.group);
	                        area.isArea = true;
	                    }
	                    area.startX = areaPath.xMap;
	                    area.shiftUnit = options.step ? 2 : 1;
	                });
	            },
	
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var pick = H.pick,
	            seriesType = H.seriesType;
	
	        /**
	         * Spline series type.
	         * @constructor seriesTypes.spline
	         * @extends {Series}
	         */
	        seriesType('spline', 'line', {}, /** @lends seriesTypes.spline.prototype */ {
	            /**
	             * Get the spline segment from a given point's previous neighbour to the given point
	             */
	            getPointSpline: function(points, point, i) {
	                var smoothing = 1.5, // 1 means control points midway between points, 2 means 1/3 from the point, 3 is 1/4 etc
	                    denom = smoothing + 1,
	                    plotX = point.plotX,
	                    plotY = point.plotY,
	                    lastPoint = points[i - 1],
	                    nextPoint = points[i + 1],
	                    leftContX,
	                    leftContY,
	                    rightContX,
	                    rightContY,
	                    ret;
	
	                function doCurve(otherPoint) {
	                    return otherPoint &&
	                        !otherPoint.isNull &&
	                        otherPoint.doCurve !== false &&
	                        !point.isCliff; // #6387, area splines next to null
	                }
	
	                // Find control points
	                if (doCurve(lastPoint) && doCurve(nextPoint)) {
	                    var lastX = lastPoint.plotX,
	                        lastY = lastPoint.plotY,
	                        nextX = nextPoint.plotX,
	                        nextY = nextPoint.plotY,
	                        correction = 0;
	
	                    leftContX = (smoothing * plotX + lastX) / denom;
	                    leftContY = (smoothing * plotY + lastY) / denom;
	                    rightContX = (smoothing * plotX + nextX) / denom;
	                    rightContY = (smoothing * plotY + nextY) / denom;
	
	                    // Have the two control points make a straight line through main point
	                    if (rightContX !== leftContX) { // #5016, division by zero
	                        correction = ((rightContY - leftContY) * (rightContX - plotX)) /
	                            (rightContX - leftContX) + plotY - rightContY;
	                    }
	
	                    leftContY += correction;
	                    rightContY += correction;
	
	                    // to prevent false extremes, check that control points are between
	                    // neighbouring points' y values
	                    if (leftContY > lastY && leftContY > plotY) {
	                        leftContY = Math.max(lastY, plotY);
	                        rightContY = 2 * plotY - leftContY; // mirror of left control point
	                    } else if (leftContY < lastY && leftContY < plotY) {
	                        leftContY = Math.min(lastY, plotY);
	                        rightContY = 2 * plotY - leftContY;
	                    }
	                    if (rightContY > nextY && rightContY > plotY) {
	                        rightContY = Math.max(nextY, plotY);
	                        leftContY = 2 * plotY - rightContY;
	                    } else if (rightContY < nextY && rightContY < plotY) {
	                        rightContY = Math.min(nextY, plotY);
	                        leftContY = 2 * plotY - rightContY;
	                    }
	
	                    // record for drawing in next point
	                    point.rightContX = rightContX;
	                    point.rightContY = rightContY;
	
	
	                }
	
	                // Visualize control points for debugging
	                /*
	                if (leftContX) {
	                	this.chart.renderer.circle(leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop, 2)
	                		.attr({
	                			stroke: 'red',
	                			'stroke-width': 2,
	                			fill: 'none',
	                			zIndex: 9
	                		})
	                		.add();
	                	this.chart.renderer.path(['M', leftContX + this.chart.plotLeft, leftContY + this.chart.plotTop,
	                		'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
	                		.attr({
	                			stroke: 'red',
	                			'stroke-width': 2,
	                			zIndex: 9
	                		})
	                		.add();
	                }
	                if (rightContX) {
	                	this.chart.renderer.circle(rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop, 2)
	                		.attr({
	                			stroke: 'green',
	                			'stroke-width': 2,
	                			fill: 'none',
	                			zIndex: 9
	                		})
	                		.add();
	                	this.chart.renderer.path(['M', rightContX + this.chart.plotLeft, rightContY + this.chart.plotTop,
	                		'L', plotX + this.chart.plotLeft, plotY + this.chart.plotTop])
	                		.attr({
	                			stroke: 'green',
	                			'stroke-width': 2,
	                			zIndex: 9
	                		})
	                		.add();
	                }
	                // */
	                ret = [
	                    'C',
	                    pick(lastPoint.rightContX, lastPoint.plotX),
	                    pick(lastPoint.rightContY, lastPoint.plotY),
	                    pick(leftContX, plotX),
	                    pick(leftContY, plotY),
	                    plotX,
	                    plotY
	                ];
	                lastPoint.rightContX = lastPoint.rightContY = null; // reset for updating series later
	                return ret;
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var areaProto = H.seriesTypes.area.prototype,
	            defaultPlotOptions = H.defaultPlotOptions,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            seriesType = H.seriesType;
	        /**
	         * AreaSplineSeries object
	         */
	        seriesType('areaspline', 'spline', defaultPlotOptions.area, {
	            getStackPoints: areaProto.getStackPoints,
	            getGraphPath: areaProto.getGraphPath,
	            drawGraph: areaProto.drawGraph,
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var animObject = H.animObject,
	            color = H.color,
	            each = H.each,
	            extend = H.extend,
	            isNumber = H.isNumber,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            svg = H.svg;
	        /**
	         * The column series type.
	         *
	         * @constructor seriesTypes.column
	         * @augments Series
	         */
	
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.column
	         * @excluding connectNulls,dashStyle,linecap,lineWidth,marker,connectEnds,step
	         */
	        seriesType('column', 'line', {
	
	            /**
	             * The corner radius of the border surrounding each column or bar.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-borderradius/ Rounded columns
	             * @default 0
	             * @product highcharts highstock
	             */
	            borderRadius: 0,
	            //colorByPoint: undefined,
	
	            /**
	             * When true, each column edge is rounded to its nearest pixel in order
	             * to render sharp on screen. In some cases, when there are a lot of
	             * densely packed columns, this leads to visible difference in column
	             * widths or distance between columns. In these cases, setting `crisp`
	             * to `false` may look better, even though each column is rendered
	             * blurry.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/column-crisp-false/ Crisp is false
	             * @default true
	             * @since 5.0.10
	             * @product highcharts highstock
	             */
	            crisp: true,
	
	            /**
	             * Padding between each value groups, in x axis units.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-grouppadding-default/ 0.2 by default
	             * @sample {highcharts} highcharts/plotoptions/column-grouppadding-none/ No group padding - all     columns are evenly spaced
	             * @default 0.2
	             * @product highcharts highstock
	             */
	            groupPadding: 0.2,
	            //grouping: true,
	
	            /**
	             */
	            marker: null, // point options are specified in the base options
	
	            /**
	             * Padding between each column or bar, in x axis units.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-pointpadding-default/ 0.1 by default
	             * @sample {highcharts} highcharts/plotoptions/column-pointpadding-025/ 0.25
	             * @sample {highcharts} highcharts/plotoptions/column-pointpadding-none/ 0 for tightly packed columns
	             * @default 0.1
	             * @product highcharts highstock
	             */
	            pointPadding: 0.1,
	            //pointWidth: null,
	
	            /**
	             * The minimal height for a column or width for a bar. By default,
	             * 0 values are not shown. To visualize a 0 (or close to zero) point,
	             * set the minimal point length to a pixel value like 3\. In stacked
	             * column charts, minPointLength might not be respected for tightly
	             * packed values.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-minpointlength/ Zero base value
	             * @sample {highcharts} highcharts/plotoptions/column-minpointlength-pos-and-neg/ Positive and negative close to zero values
	             * @default 0
	             * @product highcharts highstock
	             */
	            minPointLength: 0,
	
	            /**
	             * When the series contains less points than the crop threshold, all
	             * points are drawn, event if the points fall outside the visible plot
	             * area at the current zoom. The advantage of drawing all points (including
	             * markers and columns), is that animation is performed on updates.
	             * On the other hand, when the series contains more points than the
	             * crop threshold, the series data is cropped to only contain points
	             * that fall within the plot area. The advantage of cropping away invisible
	             * points is to increase performance on large series. .
	             * 
	             * @type {Number}
	             * @default 50
	             * @product highcharts highstock
	             */
	            cropThreshold: 50,
	
	            /**
	             * The X axis range that each point is valid for. This determines the
	             * width of the column. On a categorized axis, the range will be 1
	             * by default (one category unit). On linear and datetime axes, the
	             * range will be computed as the distance between the two closest data
	             * points.
	             *
	             * The default `null` means it is computed automatically, but this option
	             * can be used to override the automatic value.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/column-pointrange/
	             *         Set the point range to one day on a data set with one week
	             *         between the points
	             * @default null
	             * @since 2.3
	             * @product highcharts highstock
	             */
	            pointRange: null,
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.series.states.hover
	                 * @excluding lineWidth,lineWidthPlus,marker
	                 * @product highcharts highstock
	                 */
	                hover: {
	
	                    /**
	                     */
	                    halo: false,
	
	
	                    /**
	                     * How much to brighten the point on interaction. Requires the main
	                     * color to be defined in hex or rgb(a) format.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the hover brightening is by default replaced
	                     * with a fill-opacity set in the `.highcharts-point:hover` rule.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/plotoptions/column-states-hover-brightness/ Brighten by 0.5
	                     * @default 0.1
	                     * @product highcharts highstock
	                     */
	                    brightness: 0.1,
	
	                    /**
	                     */
	                    shadow: false
	
	                },
	
	
	                /**
	                 */
	                select: {
	
	                    /**
	                     */
	                    color: '#cccccc',
	
	                    /**
	                     */
	                    borderColor: '#000000',
	
	                    /**
	                     */
	                    shadow: false
	                }
	
	            },
	
	            /**
	             */
	            dataLabels: {
	
	                /**
	                 */
	                align: null, // auto
	
	                /**
	                 */
	                verticalAlign: null, // auto
	
	                /**
	                 */
	                y: null
	            },
	
	            /**
	             * When this is true, the series will not cause the Y axis to cross
	             * the zero plane (or [threshold](#plotOptions.series.threshold) option)
	             * unless the data actually crosses the plane.
	             * 
	             * For example, if `softThreshold` is `false`, a series of 0, 1, 2,
	             * 3 will make the Y axis show negative values according to the `minPadding`
	             * option. If `softThreshold` is `true`, the Y axis starts at 0.
	             * 
	             * @type {Boolean}
	             * @default {highcharts} true
	             * @default {highstock} false
	             * @since 4.1.9
	             * @product highcharts highstock
	             */
	            softThreshold: false,
	
	            /**
	             */
	            startFromThreshold: true, // false doesn't work well: http://jsfiddle.net/highcharts/hz8fopan/14/
	
	            /**
	             */
	            stickyTracking: false,
	
	            /**
	             */
	            tooltip: {
	
	                /**
	                 */
	                distance: 6
	            },
	
	            /**
	             * The Y axis value to serve as the base for the columns, for distinguishing
	             * between values above and below a threshold. If `null`, the columns
	             * extend from the padding Y axis minimum.
	             * 
	             * @type {Number}
	             * @default 0
	             * @since 2.0
	             * @product highcharts
	             */
	            threshold: 0,
	
	
	            /**
	             * The color of the border surrounding each column or bar.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the border stroke can be set with the `.highcharts-
	             * point` rule.
	             * 
	             * @type {Color}
	             * @sample {highcharts} highcharts/plotoptions/column-bordercolor/ Dark gray border
	             * @default #ffffff
	             * @product highcharts highstock
	             */
	            borderColor: '#ffffff'
	            // borderWidth: 1
	
	
	        }, /** @lends seriesTypes.column.prototype */ {
	            cropShoulder: 0,
	            directTouch: true, // When tooltip is not shared, this series (and derivatives) requires direct touch/hover. KD-tree does not apply.
	            trackerGroups: ['group', 'dataLabelsGroup'],
	            negStacks: true, // use separate negative stacks, unlike area stacks where a negative
	            // point is substracted from previous (#1910)
	
	            /**
	             * Initialize the series. Extends the basic Series.init method by
	             * marking other series of the same type as dirty.
	             *
	             * @function #init
	             * @memberOf seriesTypes.column
	             * 
	             */
	            init: function() {
	                Series.prototype.init.apply(this, arguments);
	
	                var series = this,
	                    chart = series.chart;
	
	                // if the series is added dynamically, force redraw of other
	                // series affected by a new column
	                if (chart.hasRendered) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.type === series.type) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	            },
	
	            /**
	             * Return the width and x offset of the columns adjusted for grouping, groupPadding, pointPadding,
	             * pointWidth etc.
	             */
	            getColumnMetrics: function() {
	
	                var series = this,
	                    options = series.options,
	                    xAxis = series.xAxis,
	                    yAxis = series.yAxis,
	                    reversedXAxis = xAxis.reversed,
	                    stackKey,
	                    stackGroups = {},
	                    columnCount = 0;
	
	                // Get the total number of column type series.
	                // This is called on every series. Consider moving this logic to a
	                // chart.orderStacks() function and call it on init, addSeries and removeSeries
	                if (options.grouping === false) {
	                    columnCount = 1;
	                } else {
	                    each(series.chart.series, function(otherSeries) {
	                        var otherOptions = otherSeries.options,
	                            otherYAxis = otherSeries.yAxis,
	                            columnIndex;
	                        if (
	                            otherSeries.type === series.type &&
	                            (
	                                otherSeries.visible ||
	                                !series.chart.options.chart.ignoreHiddenSeries
	                            ) &&
	                            yAxis.len === otherYAxis.len &&
	                            yAxis.pos === otherYAxis.pos
	                        ) { // #642, #2086
	                            if (otherOptions.stacking) {
	                                stackKey = otherSeries.stackKey;
	                                if (stackGroups[stackKey] === undefined) {
	                                    stackGroups[stackKey] = columnCount++;
	                                }
	                                columnIndex = stackGroups[stackKey];
	                            } else if (otherOptions.grouping !== false) { // #1162
	                                columnIndex = columnCount++;
	                            }
	                            otherSeries.columnIndex = columnIndex;
	                        }
	                    });
	                }
	
	                var categoryWidth = Math.min(
	                        Math.abs(xAxis.transA) * (xAxis.ordinalSlope || options.pointRange || xAxis.closestPointRange || xAxis.tickInterval || 1), // #2610
	                        xAxis.len // #1535
	                    ),
	                    groupPadding = categoryWidth * options.groupPadding,
	                    groupWidth = categoryWidth - 2 * groupPadding,
	                    pointOffsetWidth = groupWidth / (columnCount || 1),
	                    pointWidth = Math.min(
	                        options.maxPointWidth || xAxis.len,
	                        pick(options.pointWidth, pointOffsetWidth * (1 - 2 * options.pointPadding))
	                    ),
	                    pointPadding = (pointOffsetWidth - pointWidth) / 2,
	                    colIndex = (series.columnIndex || 0) + (reversedXAxis ? 1 : 0), // #1251, #3737
	                    pointXOffset = pointPadding + (groupPadding + colIndex *
	                        pointOffsetWidth - (categoryWidth / 2)) *
	                    (reversedXAxis ? -1 : 1);
	
	                // Save it for reading in linked series (Error bars particularly)
	                series.columnMetrics = {
	                    width: pointWidth,
	                    offset: pointXOffset
	                };
	                return series.columnMetrics;
	
	            },
	
	            /**
	             * Make the columns crisp. The edges are rounded to the nearest full pixel.
	             */
	            crispCol: function(x, y, w, h) {
	                var chart = this.chart,
	                    borderWidth = this.borderWidth,
	                    xCrisp = -(borderWidth % 2 ? 0.5 : 0),
	                    yCrisp = borderWidth % 2 ? 0.5 : 1,
	                    right,
	                    bottom,
	                    fromTop;
	
	                if (chart.inverted && chart.renderer.isVML) {
	                    yCrisp += 1;
	                }
	
	                // Horizontal. We need to first compute the exact right edge, then round it
	                // and compute the width from there.
	                if (this.options.crisp) {
	                    right = Math.round(x + w) + xCrisp;
	                    x = Math.round(x) + xCrisp;
	                    w = right - x;
	                }
	
	                // Vertical
	                bottom = Math.round(y + h) + yCrisp;
	                fromTop = Math.abs(y) <= 0.5 && bottom > 0.5; // #4504, #4656
	                y = Math.round(y) + yCrisp;
	                h = bottom - y;
	
	                // Top edges are exceptions
	                if (fromTop && h) { // #5146
	                    y -= 1;
	                    h += 1;
	                }
	
	                return {
	                    x: x,
	                    y: y,
	                    width: w,
	                    height: h
	                };
	            },
	
	            /**
	             * Translate each point to the plot area coordinate system and find shape positions
	             */
	            translate: function() {
	                var series = this,
	                    chart = series.chart,
	                    options = series.options,
	                    dense = series.dense = series.closestPointRange * series.xAxis.transA < 2,
	                    borderWidth = series.borderWidth = pick(
	                        options.borderWidth,
	                        dense ? 0 : 1 // #3635
	                    ),
	                    yAxis = series.yAxis,
	                    threshold = options.threshold,
	                    translatedThreshold = series.translatedThreshold = yAxis.getThreshold(threshold),
	                    minPointLength = pick(options.minPointLength, 5),
	                    metrics = series.getColumnMetrics(),
	                    pointWidth = metrics.width,
	                    seriesBarW = series.barW = Math.max(pointWidth, 1 + 2 * borderWidth), // postprocessed for border width
	                    pointXOffset = series.pointXOffset = metrics.offset;
	
	                if (chart.inverted) {
	                    translatedThreshold -= 0.5; // #3355
	                }
	
	                // When the pointPadding is 0, we want the columns to be packed tightly, so we allow individual
	                // columns to have individual sizes. When pointPadding is greater, we strive for equal-width
	                // columns (#2694).
	                if (options.pointPadding) {
	                    seriesBarW = Math.ceil(seriesBarW);
	                }
	
	                Series.prototype.translate.apply(series);
	
	                // Record the new values
	                each(series.points, function(point) {
	                    var yBottom = pick(point.yBottom, translatedThreshold),
	                        safeDistance = 999 + Math.abs(yBottom),
	                        plotY = Math.min(Math.max(-safeDistance, point.plotY), yAxis.len + safeDistance), // Don't draw too far outside plot area (#1303, #2241, #4264)
	                        barX = point.plotX + pointXOffset,
	                        barW = seriesBarW,
	                        barY = Math.min(plotY, yBottom),
	                        up,
	                        barH = Math.max(plotY, yBottom) - barY;
	
	                    // Handle options.minPointLength
	                    if (Math.abs(barH) < minPointLength) {
	                        if (minPointLength) {
	                            barH = minPointLength;
	                            up = (!yAxis.reversed && !point.negative) || (yAxis.reversed && point.negative);
	                            barY = Math.abs(barY - translatedThreshold) > minPointLength ? // stacked
	                                yBottom - minPointLength : // keep position
	                                translatedThreshold - (up ? minPointLength : 0); // #1485, #4051
	                        }
	                    }
	
	                    // Cache for access in polar
	                    point.barX = barX;
	                    point.pointWidth = pointWidth;
	
	                    // Fix the tooltip on center of grouped columns (#1216, #424, #3648)
	                    point.tooltipPos = chart.inverted ? [yAxis.len + yAxis.pos - chart.plotLeft - plotY, series.xAxis.len - barX - barW / 2, barH] : [barX + barW / 2, plotY + yAxis.pos - chart.plotTop, barH];
	
	                    // Register shape type and arguments to be used in drawPoints
	                    point.shapeType = 'rect';
	                    point.shapeArgs = series.crispCol.apply(
	                        series,
	                        point.isNull ?
	                        // #3169, drilldown from null must have a position to work from
	                        // #6585, dataLabel should be placed on xAxis, not floating in the middle of the chart
	                        [barX, translatedThreshold, barW, 0] : [barX, barY, barW, barH]
	                    );
	                });
	
	            },
	
	            getSymbol: noop,
	
	            /**
	             * Use a solid rectangle like the area series types
	             */
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
	
	            /**
	             * Columns have no graph
	             */
	            drawGraph: function() {
	                this.group[this.dense ? 'addClass' : 'removeClass']('highcharts-dense-data');
	            },
	
	
	            /**
	             * Get presentational attributes
	             */
	            pointAttribs: function(point, state) {
	                var options = this.options,
	                    stateOptions,
	                    ret,
	                    p2o = this.pointAttrToOptions || {},
	                    strokeOption = p2o.stroke || 'borderColor',
	                    strokeWidthOption = p2o['stroke-width'] || 'borderWidth',
	                    fill = (point && point.color) || this.color,
	                    stroke = point[strokeOption] || options[strokeOption] ||
	                    this.color || fill, // set to fill when borderColor null
	                    strokeWidth = point[strokeWidthOption] ||
	                    options[strokeWidthOption] || this[strokeWidthOption] || 0,
	                    dashstyle = options.dashStyle,
	                    zone,
	                    brightness;
	
	                // Handle zone colors
	                if (point && this.zones.length) {
	                    zone = point.getZone();
	                    fill = point.options.color || (zone && zone.color) || this.color; // When zones are present, don't use point.color (#4267). Changed order (#6527)
	                }
	
	                // Select or hover states
	                if (state) {
	                    stateOptions = merge(
	                        options.states[state],
	                        point.options.states && point.options.states[state] || {} // #6401
	                    );
	                    brightness = stateOptions.brightness;
	                    fill = stateOptions.color ||
	                        (brightness !== undefined && color(fill).brighten(stateOptions.brightness).get()) ||
	                        fill;
	                    stroke = stateOptions[strokeOption] || stroke;
	                    strokeWidth = stateOptions[strokeWidthOption] || strokeWidth;
	                    dashstyle = stateOptions.dashStyle || dashstyle;
	                }
	
	                ret = {
	                    'fill': fill,
	                    'stroke': stroke,
	                    'stroke-width': strokeWidth
	                };
	
	                if (dashstyle) {
	                    ret.dashstyle = dashstyle;
	                }
	
	                return ret;
	            },
	
	
	            /**
	             * Draw the columns. For bars, the series.group is rotated, so the same coordinates
	             * apply for columns and bars. This method is inherited by scatter series.
	             *
	             */
	            drawPoints: function() {
	                var series = this,
	                    chart = this.chart,
	                    options = series.options,
	                    renderer = chart.renderer,
	                    animationLimit = options.animationLimit || 250,
	                    shapeArgs;
	
	                // draw the columns
	                each(series.points, function(point) {
	                    var plotY = point.plotY,
	                        graphic = point.graphic;
	
	                    if (isNumber(plotY) && point.y !== null) {
	                        shapeArgs = point.shapeArgs;
	
	                        if (graphic) { // update
	                            graphic[chart.pointCount < animationLimit ? 'animate' : 'attr'](
	                                merge(shapeArgs)
	                            );
	
	                        } else {
	                            point.graphic = graphic = renderer[point.shapeType](shapeArgs)
	                                .add(point.group || series.group);
	                        }
	
	                        // Border radius is not stylable (#6900)
	                        if (options.borderRadius) {
	                            graphic.attr({
	                                r: options.borderRadius
	                            });
	                        }
	
	
	                        // Presentational
	                        graphic
	                            .attr(series.pointAttribs(point, point.selected && 'select'))
	                            .shadow(options.shadow, null, options.stacking && !options.borderRadius);
	
	
	                        graphic.addClass(point.getClassName(), true);
	
	
	                    } else if (graphic) {
	                        point.graphic = graphic.destroy(); // #1269
	                    }
	                });
	            },
	
	            /**
	             * Animate the column heights one by one from zero
	             * @param {Boolean} init Whether to initialize the animation or run it
	             */
	            animate: function(init) {
	                var series = this,
	                    yAxis = this.yAxis,
	                    options = series.options,
	                    inverted = this.chart.inverted,
	                    attr = {},
	                    translatedThreshold;
	
	                if (svg) { // VML is too slow anyway
	                    if (init) {
	                        attr.scaleY = 0.001;
	                        translatedThreshold = Math.min(yAxis.pos + yAxis.len, Math.max(yAxis.pos, yAxis.toPixels(options.threshold)));
	                        if (inverted) {
	                            attr.translateX = translatedThreshold - yAxis.len;
	                        } else {
	                            attr.translateY = translatedThreshold;
	                        }
	                        series.group.attr(attr);
	
	                    } else { // run the animation
	
	                        attr[inverted ? 'translateX' : 'translateY'] = yAxis.pos;
	                        series.group.animate(attr, extend(animObject(series.options.animation), {
	                            // Do the scale synchronously to ensure smooth updating (#5030)
	                            step: function(val, fx) {
	                                series.group.attr({
	                                    scaleY: Math.max(0.001, fx.pos) // #5250
	                                });
	                            }
	                        }));
	
	                        // delete this function to allow it only once
	                        series.animate = null;
	                    }
	                }
	            },
	
	            /**
	             * Remove this series from the chart
	             */
	            remove: function() {
	                var series = this,
	                    chart = series.chart;
	
	                // column and bar series affects other series of the same type
	                // as they are either stacked or grouped
	                if (chart.hasRendered) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.type === series.type) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	
	                Series.prototype.remove.apply(series, arguments);
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	
	        var seriesType = H.seriesType;
	
	        /**
	         * The Bar series class
	         */
	        seriesType('bar', 'column', null, {
	            /**
	             */
	            inverted: true
	        });
	        /**
	         * @extends {plotOptions.column}
	         * @optionparent plotOptions.bar
	         */
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Series = H.Series,
	            seriesType = H.seriesType;
	        /**
	         * The scatter series type
	         */
	
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.scatter
	         */
	        seriesType('scatter', 'line', {
	
	            /**
	             * The width of the line connecting the data points.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/scatter-linewidth-none/ 0 by default
	             * @sample {highcharts} highcharts/plotoptions/scatter-linewidth-1/ 1px
	             * @default 0
	             * @product highcharts highstock
	             */
	            lineWidth: 0,
	
	            /**
	             */
	            findNearestPointBy: 'xy',
	
	            /**
	             */
	            marker: {
	
	                /**
	                 */
	                enabled: true // Overrides auto-enabling in line series (#3647)
	            },
	
	            /**
	             * A configuration object for the tooltip rendering of each single
	             * series. Properties are inherited from <a class="internal">#tooltip</a>.
	             * Overridable properties are `headerFormat`, `pointFormat`, `yDecimals`,
	             * `xDateFormat`, `yPrefix` and `ySuffix`. Unlike other series, in
	             * a scatter plot the series.name by default shows in the headerFormat
	             * and point.x and point.y in the pointFormat.
	             * 
	             * @product highcharts highstock
	             */
	            tooltip: {
	
	                headerFormat: '<span style="color:{point.color}">\u25CF</span> ' +
	                    '<span style="font-size: 0.85em"> {series.name}</span><br/>',
	
	
	                /**
	                 */
	                pointFormat: 'x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>'
	            }
	
	            // Prototype members
	        }, {
	            sorted: false,
	            requireSorting: false,
	            noSharedTooltip: true,
	            trackerGroups: ['group', 'markerGroup', 'dataLabelsGroup'],
	            takeOrdinalPosition: false, // #2342
	            drawGraph: function() {
	                if (this.options.lineWidth) {
	                    Series.prototype.drawGraph.call(this);
	                }
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var pick = H.pick,
	            relativeLength = H.relativeLength;
	
	        H.CenteredSeriesMixin = {
	            /**
	             * Get the center of the pie based on the size and center options relative to the
	             * plot area. Borrowed by the polar and gauge series types.
	             */
	            getCenter: function() {
	
	                var options = this.options,
	                    chart = this.chart,
	                    slicingRoom = 2 * (options.slicedOffset || 0),
	                    handleSlicingRoom,
	                    plotWidth = chart.plotWidth - 2 * slicingRoom,
	                    plotHeight = chart.plotHeight - 2 * slicingRoom,
	                    centerOption = options.center,
	                    positions = [pick(centerOption[0], '50%'), pick(centerOption[1], '50%'), options.size || '100%', options.innerSize || 0],
	                    smallestSize = Math.min(plotWidth, plotHeight),
	                    i,
	                    value;
	
	                for (i = 0; i < 4; ++i) {
	                    value = positions[i];
	                    handleSlicingRoom = i < 2 || (i === 2 && /%$/.test(value));
	
	                    // i == 0: centerX, relative to width
	                    // i == 1: centerY, relative to height
	                    // i == 2: size, relative to smallestSize
	                    // i == 3: innerSize, relative to size
	                    positions[i] = relativeLength(value, [plotWidth, plotHeight, smallestSize, positions[2]][i]) +
	                        (handleSlicingRoom ? slicingRoom : 0);
	
	                }
	                // innerSize cannot be larger than size (#3632)
	                if (positions[3] > positions[2]) {
	                    positions[3] = positions[2];
	                }
	                return positions;
	            }
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            CenteredSeriesMixin = H.CenteredSeriesMixin,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            inArray = H.inArray,
	            LegendSymbolMixin = H.LegendSymbolMixin,
	            noop = H.noop,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesType = H.seriesType,
	            seriesTypes = H.seriesTypes,
	            setAnimation = H.setAnimation;
	
	        /**
	         * The pie series type.
	         *
	         * @constructor seriesTypes.pie
	         * @augments Series
	         */
	
	        /**
	         * @extends {plotOptions.line}
	         * @optionparent plotOptions.pie
	         */
	        seriesType('pie', 'line', {
	
	            /**
	             * The center of the pie chart relative to the plot area. Can be percentages
	             * or pixel values. The default behaviour (as of 3.0) is to center
	             * the pie so that all slices and data labels are within the plot area.
	             * As a consequence, the pie may actually jump around in a chart with
	             * dynamic values, as the data labels move. In that case, the center
	             * should be explicitly set, for example to `["50%", "50%"]`.
	             * 
	             * @type {Array<String|Number>}
	             * @sample {highcharts} highcharts/plotoptions/pie-center/ Centered at 100, 100
	             * @default [null, null]
	             * @product highcharts
	             */
	            center: [null, null],
	
	            /**
	             */
	            clip: false,
	
	            /**
	             */
	            colorByPoint: true, // always true for pies
	
	            /**
	             * @extends plotOptions.series.dataLabels
	             * @excluding align,allowOverlap,staggerLines,step
	             * @product highcharts
	             */
	            dataLabels: {
	                // align: null,
	                // connectorWidth: 1,
	                // connectorColor: point.color,
	                // connectorPadding: 5,
	
	                /**
	                 * The distance of the data label from the pie's edge. Negative numbers
	                 * put the data label on top of the pie slices. Connectors are only
	                 * shown for data labels outside the pie.
	                 * 
	                 * @type {Number}
	                 * @sample {highcharts} highcharts/plotoptions/pie-datalabels-distance/ Data labels on top of the pie
	                 * @default 30
	                 * @since 2.1
	                 * @product highcharts
	                 */
	                distance: 30,
	
	                /**
	                 * Enable or disable the data labels.
	                 * 
	                 * @type {Boolean}
	                 * @since 2.1
	                 * @product highcharts
	                 */
	                enabled: true,
	
	                /**
	                 */
	                formatter: function() { // #2945
	                    return this.point.isNull ? undefined : this.point.name;
	                },
	                // softConnector: true,
	
	                /**
	                 */
	                x: 0
	                // y: 0
	            },
	
	            /**
	             * Equivalent to [chart.ignoreHiddenSeries](#chart.ignoreHiddenSeries),
	             * this option tells whether the series shall be redrawn as if the
	             * hidden point were `null`.
	             * 
	             * The default value changed from `false` to `true` with Highcharts
	             * 3.0.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/pie-ignorehiddenpoint/ True, the hiddden point is ignored
	             * @default true
	             * @since 2.3.0
	             * @product highcharts
	             */
	            ignoreHiddenPoint: true,
	            //innerSize: 0,
	
	            /**
	             */
	            legendType: 'point',
	
	            /**
	             */
	            marker: null, // point options are specified in the base options
	
	            /**
	             * The diameter of the pie relative to the plot area. Can be a percentage
	             * or pixel value. Pixel values are given as integers. The default
	             * behaviour (as of 3.0) is to scale to the plot area and give room
	             * for data labels within the plot area. As a consequence, the size
	             * of the pie may vary when points are updated and data labels more
	             * around. In that case it is best to set a fixed value, for example
	             * `"75%"`.
	             * 
	             * @type {String|Number}
	             * @sample {highcharts} highcharts/plotoptions/pie-size/ Smaller pie
	             * @default  
	             * @product highcharts
	             */
	            size: null,
	
	            /**
	             * Whether to display this particular series or series type in the
	             * legend. Since 2.1, pies are not shown in the legend by default.
	             * 
	             * @type {Boolean}
	             * @sample {highcharts} highcharts/plotoptions/series-showinlegend/ One series in the legend, one hidden
	             * @product highcharts
	             */
	            showInLegend: false,
	
	            /**
	             * If a point is sliced, moved out from the center, how many pixels
	             * should it be moved?.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/pie-slicedoffset-20/ 20px offset
	             * @default 10
	             * @product highcharts
	             */
	            slicedOffset: 10,
	
	            /**
	             * Sticky tracking of mouse events. When true, the `mouseOut` event
	             * on a series isn't triggered until the mouse moves over another series,
	             * or out of the plot area. When false, the `mouseOut` event on a
	             * series is triggered when the mouse leaves the area around the series'
	             * graph or markers. This also implies the tooltip. When `stickyTracking`
	             * is false and `tooltip.shared` is false, the tooltip will be hidden
	             * when moving the mouse between series.
	             * 
	             * @type {Boolean}
	             * @default false
	             * @product highcharts
	             */
	            stickyTracking: false,
	
	            /**
	             */
	            tooltip: {
	
	                /**
	                 */
	                followPointer: true
	            },
	
	
	            /**
	             * The color of the border surrounding each slice. When `null`, the
	             * border takes the same color as the slice fill. This can be used
	             * together with a `borderWidth` to fill drawing gaps created by antialiazing
	             * artefacts in borderless pies.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the border stroke is given in the `.highcharts-
	             * point` class.
	             * 
	             * @type {Color}
	             * @sample {highcharts} highcharts/plotoptions/pie-bordercolor-black/ Black border
	             * @default #ffffff
	             * @product highcharts
	             */
	            borderColor: '#ffffff',
	
	            /**
	             * The width of the border surrounding each slice.
	             * 
	             * When setting the border width to 0, there may be small gaps between
	             * the slices due to SVG antialiasing artefacts. To work around this,
	             * keep the border width at 0.5 or 1, but set the `borderColor` to
	             * `null` instead.
	             * 
	             * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	             * style/style-by-css), the border stroke width is given in the `.highcharts-
	             * point` class.
	             * 
	             * @type {Number}
	             * @sample {highcharts} highcharts/plotoptions/pie-borderwidth/ 3px border
	             * @default 1
	             * @product highcharts
	             */
	            borderWidth: 1,
	
	            /**
	             */
	            states: {
	
	                /**
	                 * @extends plotOptions.series.states.hover
	                 * @product highcharts
	                 */
	                hover: {
	
	                    /**
	                     * How much to brighten the point on interaction. Requires the main
	                     * color to be defined in hex or rgb(a) format.
	                     * 
	                     * In [styled mode](http://www.highcharts.com/docs/chart-design-and-
	                     * style/style-by-css), the hover brightness is by default replaced
	                     * by a fill-opacity given in the `.highcharts-point-hover` class.
	                     * 
	                     * @type {Number}
	                     * @sample {highcharts} highcharts/plotoptions/pie-states-hover-brightness/ Brightened by 0.5
	                     * @default 0.1
	                     * @product highcharts
	                     */
	                    brightness: 0.1,
	
	                    /**
	                     */
	                    shadow: false
	                }
	            }
	
	
	        }, /** @lends seriesTypes.pie.prototype */ {
	            isCartesian: false,
	            requireSorting: false,
	            directTouch: true,
	            noSharedTooltip: true,
	            trackerGroups: ['group', 'dataLabelsGroup'],
	            axisTypes: [],
	            pointAttribs: seriesTypes.column.prototype.pointAttribs,
	            /**
	             * Animate the pies in
	             */
	            animate: function(init) {
	                var series = this,
	                    points = series.points,
	                    startAngleRad = series.startAngleRad;
	
	                if (!init) {
	                    each(points, function(point) {
	                        var graphic = point.graphic,
	                            args = point.shapeArgs;
	
	                        if (graphic) {
	                            // start values
	                            graphic.attr({
	                                r: point.startR || (series.center[3] / 2), // animate from inner radius (#779)
	                                start: startAngleRad,
	                                end: startAngleRad
	                            });
	
	                            // animate
	                            graphic.animate({
	                                r: args.r,
	                                start: args.start,
	                                end: args.end
	                            }, series.options.animation);
	                        }
	                    });
	
	                    // delete this function to allow it only once
	                    series.animate = null;
	                }
	            },
	
	            /**
	             * Recompute total chart sum and update percentages of points.
	             */
	            updateTotals: function() {
	                var i,
	                    total = 0,
	                    points = this.points,
	                    len = points.length,
	                    point,
	                    ignoreHiddenPoint = this.options.ignoreHiddenPoint;
	
	                // Get the total sum
	                for (i = 0; i < len; i++) {
	                    point = points[i];
	                    total += (ignoreHiddenPoint && !point.visible) ?
	                        0 :
	                        point.isNull ? 0 : point.y;
	                }
	                this.total = total;
	
	                // Set each point's properties
	                for (i = 0; i < len; i++) {
	                    point = points[i];
	                    point.percentage = (total > 0 && (point.visible || !ignoreHiddenPoint)) ? point.y / total * 100 : 0;
	                    point.total = total;
	                }
	            },
	
	            /**
	             * Extend the generatePoints method by adding total and percentage properties to each point
	             */
	            generatePoints: function() {
	                Series.prototype.generatePoints.call(this);
	                this.updateTotals();
	            },
	
	            /**
	             * Do translation for pie slices
	             */
	            translate: function(positions) {
	                this.generatePoints();
	
	                var series = this,
	                    cumulative = 0,
	                    precision = 1000, // issue #172
	                    options = series.options,
	                    slicedOffset = options.slicedOffset,
	                    connectorOffset = slicedOffset + (options.borderWidth || 0),
	                    finalConnectorOffset,
	                    start,
	                    end,
	                    angle,
	                    startAngle = options.startAngle || 0,
	                    startAngleRad = series.startAngleRad = Math.PI / 180 * (startAngle - 90),
	                    endAngleRad = series.endAngleRad = Math.PI / 180 * ((pick(options.endAngle, startAngle + 360)) - 90),
	                    circ = endAngleRad - startAngleRad, //2 * Math.PI,
	                    points = series.points,
	                    radiusX, // the x component of the radius vector for a given point
	                    radiusY,
	                    labelDistance = options.dataLabels.distance,
	                    ignoreHiddenPoint = options.ignoreHiddenPoint,
	                    i,
	                    len = points.length,
	                    point;
	
	                // Get positions - either an integer or a percentage string must be given.
	                // If positions are passed as a parameter, we're in a recursive loop for adjusting
	                // space for data labels.
	                if (!positions) {
	                    series.center = positions = series.getCenter();
	                }
	
	                // Utility for getting the x value from a given y, used for anticollision
	                // logic in data labels.
	                // Added point for using specific points' label distance.
	                series.getX = function(y, left, point) {
	                    angle = Math.asin(Math.min((y - positions[1]) / (positions[2] / 2 + point.labelDistance), 1));
	                    return positions[0] +
	                        (left ? -1 : 1) *
	                        (Math.cos(angle) * (positions[2] / 2 + point.labelDistance));
	                };
	
	                // Calculate the geometry for each point
	                for (i = 0; i < len; i++) {
	
	                    point = points[i];
	
	                    // Used for distance calculation for specific point.
	                    point.labelDistance = pick(
	                        point.options.dataLabels && point.options.dataLabels.distance,
	                        labelDistance
	                    );
	
	                    // Saved for later dataLabels distance calculation.
	                    series.maxLabelDistance = Math.max(series.maxLabelDistance || 0, point.labelDistance);
	
	                    // set start and end angle
	                    start = startAngleRad + (cumulative * circ);
	                    if (!ignoreHiddenPoint || point.visible) {
	                        cumulative += point.percentage / 100;
	                    }
	                    end = startAngleRad + (cumulative * circ);
	
	                    // set the shape
	                    point.shapeType = 'arc';
	                    point.shapeArgs = {
	                        x: positions[0],
	                        y: positions[1],
	                        r: positions[2] / 2,
	                        innerR: positions[3] / 2,
	                        start: Math.round(start * precision) / precision,
	                        end: Math.round(end * precision) / precision
	                    };
	
	                    // The angle must stay within -90 and 270 (#2645)
	                    angle = (end + start) / 2;
	                    if (angle > 1.5 * Math.PI) {
	                        angle -= 2 * Math.PI;
	                    } else if (angle < -Math.PI / 2) {
	                        angle += 2 * Math.PI;
	                    }
	
	                    // Center for the sliced out slice
	                    point.slicedTranslation = {
	                        translateX: Math.round(Math.cos(angle) * slicedOffset),
	                        translateY: Math.round(Math.sin(angle) * slicedOffset)
	                    };
	
	                    // set the anchor point for tooltips
	                    radiusX = Math.cos(angle) * positions[2] / 2;
	                    radiusY = Math.sin(angle) * positions[2] / 2;
	                    point.tooltipPos = [
	                        positions[0] + radiusX * 0.7,
	                        positions[1] + radiusY * 0.7
	                    ];
	
	                    point.half = angle < -Math.PI / 2 || angle > Math.PI / 2 ? 1 : 0;
	                    point.angle = angle;
	
	                    // Set the anchor point for data labels. Use point.labelDistance 
	                    // instead of labelDistance // #1174
	                    // finalConnectorOffset - not override connectorOffset value.
	                    finalConnectorOffset = Math.min(connectorOffset, point.labelDistance / 5); // #1678
	                    point.labelPos = [
	                        positions[0] + radiusX + Math.cos(angle) * point.labelDistance, // first break of connector
	                        positions[1] + radiusY + Math.sin(angle) * point.labelDistance, // a/a
	                        positions[0] + radiusX + Math.cos(angle) * finalConnectorOffset, // second break, right outside pie
	                        positions[1] + radiusY + Math.sin(angle) * finalConnectorOffset, // a/a
	                        positions[0] + radiusX, // landing point for connector
	                        positions[1] + radiusY, // a/a
	                        point.labelDistance < 0 ? // alignment
	                        'center' :
	                        point.half ? 'right' : 'left', // alignment
	                        angle // center angle
	                    ];
	
	                }
	            },
	
	            drawGraph: null,
	
	            /**
	             * Draw the data points
	             */
	            drawPoints: function() {
	                var series = this,
	                    chart = series.chart,
	                    renderer = chart.renderer,
	                    groupTranslation,
	                    //center,
	                    graphic,
	                    //group,
	                    pointAttr,
	                    shapeArgs;
	
	
	                var shadow = series.options.shadow;
	                if (shadow && !series.shadowGroup) {
	                    series.shadowGroup = renderer.g('shadow')
	                        .add(series.group);
	                }
	
	
	                // draw the slices
	                each(series.points, function(point) {
	                    if (!point.isNull) {
	                        graphic = point.graphic;
	                        shapeArgs = point.shapeArgs;
	
	
	                        // If the point is sliced, use special translation, else use
	                        // plot area traslation
	                        groupTranslation = point.getTranslate();
	
	
	                        // Put the shadow behind all points
	                        var shadowGroup = point.shadowGroup;
	                        if (shadow && !shadowGroup) {
	                            shadowGroup = point.shadowGroup = renderer.g('shadow')
	                                .add(series.shadowGroup);
	                        }
	
	                        if (shadowGroup) {
	                            shadowGroup.attr(groupTranslation);
	                        }
	                        pointAttr = series.pointAttribs(point, point.selected && 'select');
	
	
	                        // Draw the slice
	                        if (graphic) {
	                            graphic
	                                .setRadialReference(series.center)
	
	                                .attr(pointAttr)
	
	                                .animate(extend(shapeArgs, groupTranslation));
	                        } else {
	
	                            point.graphic = graphic = renderer[point.shapeType](shapeArgs)
	                                .setRadialReference(series.center)
	                                .attr(groupTranslation)
	                                .add(series.group);
	
	                            if (!point.visible) {
	                                graphic.attr({
	                                    visibility: 'hidden'
	                                });
	                            }
	
	
	                            graphic
	                                .attr(pointAttr)
	                                .attr({
	                                    'stroke-linejoin': 'round'
	                                })
	                                .shadow(shadow, shadowGroup);
	
	                        }
	
	                        graphic.addClass(point.getClassName());
	
	                    }
	                });
	
	            },
	
	
	            searchPoint: noop,
	
	            /**
	             * Utility for sorting data labels
	             */
	            sortByAngle: function(points, sign) {
	                points.sort(function(a, b) {
	                    return a.angle !== undefined && (b.angle - a.angle) * sign;
	                });
	            },
	
	            /**
	             * Use a simple symbol from LegendSymbolMixin
	             */
	            drawLegendSymbol: LegendSymbolMixin.drawRectangle,
	
	            /**
	             * Use the getCenter method from drawLegendSymbol
	             */
	            getCenter: CenteredSeriesMixin.getCenter,
	
	            /**
	             * Pies don't have point marker symbols
	             */
	            getSymbol: noop
	
	
	            /**
	             * @constructor seriesTypes.pie.prototype.pointClass
	             * @extends {Point}
	             */
	        }, /** @lends seriesTypes.pie.prototype.pointClass.prototype */ {
	            /**
	             * Initiate the pie slice
	             */
	            init: function() {
	
	                Point.prototype.init.apply(this, arguments);
	
	                var point = this,
	                    toggleSlice;
	
	                point.name = pick(point.name, 'Slice');
	
	                // add event listener for select
	                toggleSlice = function(e) {
	                    point.slice(e.type === 'select');
	                };
	                addEvent(point, 'select', toggleSlice);
	                addEvent(point, 'unselect', toggleSlice);
	
	                return point;
	            },
	
	            /**
	             * Negative points are not valid (#1530, #3623, #5322)
	             */
	            isValid: function() {
	                return H.isNumber(this.y, true) && this.y >= 0;
	            },
	
	            /**
	             * Toggle the visibility of the pie slice
	             * @param {Boolean} vis Whether to show the slice or not. If undefined, the
	             *    visibility is toggled
	             */
	            setVisible: function(vis, redraw) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    ignoreHiddenPoint = series.options.ignoreHiddenPoint;
	
	                redraw = pick(redraw, ignoreHiddenPoint);
	
	                if (vis !== point.visible) {
	
	                    // If called without an argument, toggle visibility
	                    point.visible = point.options.visible = vis = vis === undefined ? !point.visible : vis;
	                    series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
	                    // Show and hide associated elements. This is performed regardless of redraw or not,
	                    // because chart.redraw only handles full series.
	                    each(['graphic', 'dataLabel', 'connector', 'shadowGroup'], function(key) {
	                        if (point[key]) {
	                            point[key][vis ? 'show' : 'hide'](true);
	                        }
	                    });
	
	                    if (point.legendItem) {
	                        chart.legend.colorizeItem(point, vis);
	                    }
	
	                    // #4170, hide halo after hiding point
	                    if (!vis && point.state === 'hover') {
	                        point.setState('');
	                    }
	
	                    // Handle ignore hidden slices
	                    if (ignoreHiddenPoint) {
	                        series.isDirty = true;
	                    }
	
	                    if (redraw) {
	                        chart.redraw();
	                    }
	                }
	            },
	
	            /**
	             * Set or toggle whether the slice is cut out from the pie
	             * @param {Boolean} sliced When undefined, the slice state is toggled
	             * @param {Boolean} redraw Whether to redraw the chart. True by default.
	             */
	            slice: function(sliced, redraw, animation) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart;
	
	                setAnimation(animation, chart);
	
	                // redraw is true by default
	                redraw = pick(redraw, true);
	
	                // if called without an argument, toggle
	                point.sliced = point.options.sliced = sliced = defined(sliced) ? sliced : !point.sliced;
	                series.options.data[inArray(point, series.data)] = point.options; // update userOptions.data
	
	                point.graphic.animate(this.getTranslate());
	
	
	                if (point.shadowGroup) {
	                    point.shadowGroup.animate(this.getTranslate());
	                }
	
	            },
	
	            getTranslate: function() {
	                return this.sliced ? this.slicedTranslation : {
	                    translateX: 0,
	                    translateY: 0
	                };
	            },
	
	            haloPath: function(size) {
	                var shapeArgs = this.shapeArgs;
	
	                return this.sliced || !this.visible ? [] :
	                    this.series.chart.renderer.symbols.arc(
	                        shapeArgs.x,
	                        shapeArgs.y,
	                        shapeArgs.r + size,
	                        shapeArgs.r + size, {
	                            innerR: this.shapeArgs.r,
	                            start: shapeArgs.start,
	                            end: shapeArgs.end
	                        }
	                    );
	            }
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            arrayMax = H.arrayMax,
	            defined = H.defined,
	            each = H.each,
	            extend = H.extend,
	            format = H.format,
	            map = H.map,
	            merge = H.merge,
	            noop = H.noop,
	            pick = H.pick,
	            relativeLength = H.relativeLength,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            stableSort = H.stableSort;
	
	
	        /**
	         * Generatl distribution algorithm for distributing labels of differing size along a
	         * confined length in two dimensions. The algorithm takes an array of objects containing
	         * a size, a target and a rank. It will place the labels as close as possible to their 
	         * targets, skipping the lowest ranked labels if necessary.
	         */
	        H.distribute = function(boxes, len) {
	
	            var i,
	                overlapping = true,
	                origBoxes = boxes, // Original array will be altered with added .pos
	                restBoxes = [], // The outranked overshoot
	                box,
	                target,
	                total = 0;
	
	            function sortByTarget(a, b) {
	                return a.target - b.target;
	            }
	
	            // If the total size exceeds the len, remove those boxes with the lowest rank
	            i = boxes.length;
	            while (i--) {
	                total += boxes[i].size;
	            }
	
	            // Sort by rank, then slice away overshoot
	            if (total > len) {
	                stableSort(boxes, function(a, b) {
	                    return (b.rank || 0) - (a.rank || 0);
	                });
	                i = 0;
	                total = 0;
	                while (total <= len) {
	                    total += boxes[i].size;
	                    i++;
	                }
	                restBoxes = boxes.splice(i - 1, boxes.length);
	            }
	
	            // Order by target
	            stableSort(boxes, sortByTarget);
	
	
	            // So far we have been mutating the original array. Now
	            // create a copy with target arrays
	            boxes = map(boxes, function(box) {
	                return {
	                    size: box.size,
	                    targets: [box.target]
	                };
	            });
	
	            while (overlapping) {
	                // Initial positions: target centered in box
	                i = boxes.length;
	                while (i--) {
	                    box = boxes[i];
	                    // Composite box, average of targets
	                    target = (Math.min.apply(0, box.targets) + Math.max.apply(0, box.targets)) / 2;
	                    box.pos = Math.min(Math.max(0, target - box.size / 2), len - box.size);
	                }
	
	                // Detect overlap and join boxes
	                i = boxes.length;
	                overlapping = false;
	                while (i--) {
	                    if (i > 0 && boxes[i - 1].pos + boxes[i - 1].size > boxes[i].pos) { // Overlap
	                        boxes[i - 1].size += boxes[i].size; // Add this size to the previous box
	                        boxes[i - 1].targets = boxes[i - 1].targets.concat(boxes[i].targets);
	
	                        // Overlapping right, push left
	                        if (boxes[i - 1].pos + boxes[i - 1].size > len) {
	                            boxes[i - 1].pos = len - boxes[i - 1].size;
	                        }
	                        boxes.splice(i, 1); // Remove this item
	                        overlapping = true;
	                    }
	                }
	            }
	
	            // Now the composite boxes are placed, we need to put the original boxes within them
	            i = 0;
	            each(boxes, function(box) {
	                var posInCompositeBox = 0;
	                each(box.targets, function() {
	                    origBoxes[i].pos = box.pos + posInCompositeBox;
	                    posInCompositeBox += origBoxes[i].size;
	                    i++;
	                });
	            });
	
	            // Add the rest (hidden) boxes and sort by target
	            origBoxes.push.apply(origBoxes, restBoxes);
	            stableSort(origBoxes, sortByTarget);
	        };
	
	
	        /**
	         * Draw the data labels
	         */
	        Series.prototype.drawDataLabels = function() {
	            var series = this,
	                seriesOptions = series.options,
	                options = seriesOptions.dataLabels,
	                points = series.points,
	                pointOptions,
	                generalOptions,
	                hasRendered = series.hasRendered || 0,
	                str,
	                dataLabelsGroup,
	                defer = pick(options.defer, !!seriesOptions.animation),
	                renderer = series.chart.renderer;
	
	            if (options.enabled || series._hasPointLabels) {
	
	                // Process default alignment of data labels for columns
	                if (series.dlProcessOptions) {
	                    series.dlProcessOptions(options);
	                }
	
	                // Create a separate group for the data labels to avoid rotation
	                dataLabelsGroup = series.plotGroup(
	                    'dataLabelsGroup',
	                    'data-labels',
	                    defer && !hasRendered ? 'hidden' : 'visible', // #5133
	                    options.zIndex || 6
	                );
	
	                if (defer) {
	                    dataLabelsGroup.attr({
	                        opacity: +hasRendered
	                    }); // #3300
	                    if (!hasRendered) {
	                        addEvent(series, 'afterAnimate', function() {
	                            if (series.visible) { // #2597, #3023, #3024
	                                dataLabelsGroup.show(true);
	                            }
	                            dataLabelsGroup[seriesOptions.animation ? 'animate' : 'attr']({
	                                opacity: 1
	                            }, {
	                                duration: 200
	                            });
	                        });
	                    }
	                }
	
	                // Make the labels for each point
	                generalOptions = options;
	                each(points, function(point) {
	                    var enabled,
	                        dataLabel = point.dataLabel,
	                        labelConfig,
	                        attr,
	                        rotation,
	                        connector = point.connector,
	                        isNew = !dataLabel,
	                        style;
	                    // Determine if each data label is enabled
	                    // @note dataLabelAttribs (like pointAttribs) would eradicate
	                    // the need for dlOptions, and simplify the section below.
	                    pointOptions = point.dlOptions || (point.options && point.options.dataLabels); // dlOptions is used in treemaps
	                    enabled = pick(pointOptions && pointOptions.enabled, generalOptions.enabled) && point.y !== null; // #2282, #4641
	                    if (enabled) {
	                        // Create individual options structure that can be extended without
	                        // affecting others
	                        options = merge(generalOptions, pointOptions);
	                        labelConfig = point.getLabelConfig();
	                        str = options.format ?
	                            format(options.format, labelConfig) :
	                            options.formatter.call(labelConfig, options);
	                        style = options.style;
	                        rotation = options.rotation;
	
	                        // Determine the color
	                        style.color = pick(options.color, style.color, series.color, '#000000');
	                        // Get automated contrast color
	                        if (style.color === 'contrast') {
	                            point.contrastColor = renderer.getContrast(point.color || series.color);
	                            style.color = options.inside || pick(point.labelDistance, options.distance) < 0 ||
	                                !!seriesOptions.stacking ? point.contrastColor : '#000000';
	                        }
	                        if (seriesOptions.cursor) {
	                            style.cursor = seriesOptions.cursor;
	                        }
	
	
	                        attr = {
	                            //align: align,
	
	                            fill: options.backgroundColor,
	                            stroke: options.borderColor,
	                            'stroke-width': options.borderWidth,
	
	                            r: options.borderRadius || 0,
	                            rotation: rotation,
	                            padding: options.padding,
	                            zIndex: 1
	                        };
	
	                        // Remove unused attributes (#947)
	                        H.objectEach(attr, function(val, name) {
	                            if (val === undefined) {
	                                delete attr[name];
	                            }
	                        });
	                    }
	                    // If the point is outside the plot area, destroy it. #678, #820
	                    if (dataLabel && (!enabled || !defined(str))) {
	                        point.dataLabel = dataLabel = dataLabel.destroy();
	                        if (connector) {
	                            point.connector = connector.destroy();
	                        }
	                        // Individual labels are disabled if the are explicitly disabled
	                        // in the point options, or if they fall outside the plot area.
	                    } else if (enabled && defined(str)) {
	                        // create new label
	                        if (!dataLabel) {
	                            dataLabel = point.dataLabel = renderer[rotation ? 'text' : 'label']( // labels don't support rotation
	                                str,
	                                0, -9999,
	                                options.shape,
	                                null,
	                                null,
	                                options.useHTML,
	                                null,
	                                'data-label'
	                            );
	                            dataLabel.addClass(
	                                'highcharts-data-label-color-' + point.colorIndex +
	                                ' ' + (options.className || '') +
	                                (options.useHTML ? 'highcharts-tracker' : '') // #3398
	                            );
	                        } else {
	                            attr.text = str;
	                        }
	                        dataLabel.attr(attr);
	
	                        // Styles must be applied before add in order to read text bounding box
	                        dataLabel.css(style).shadow(options.shadow);
	
	
	                        if (!dataLabel.added) {
	                            dataLabel.add(dataLabelsGroup);
	                        }
	                        // Now the data label is created and placed at 0,0, so we need to align it
	                        series.alignDataLabel(point, dataLabel, options, null, isNew);
	                    }
	                });
	            }
	        };
	
	        /**
	         * Align each individual data label
	         */
	        Series.prototype.alignDataLabel = function(point, dataLabel, options, alignTo, isNew) {
	            var chart = this.chart,
	                inverted = chart.inverted,
	                plotX = pick(point.plotX, -9999),
	                plotY = pick(point.plotY, -9999),
	                bBox = dataLabel.getBBox(),
	                fontSize,
	                baseline,
	                rotation = options.rotation,
	                normRotation,
	                negRotation,
	                align = options.align,
	                rotCorr, // rotation correction
	                // Math.round for rounding errors (#2683), alignTo to allow column labels (#2700)
	                visible =
	                this.visible &&
	                (
	                    point.series.forceDL ||
	                    chart.isInsidePlot(plotX, Math.round(plotY), inverted) ||
	                    (
	                        alignTo && chart.isInsidePlot(
	                            plotX,
	                            inverted ? alignTo.x + 1 : alignTo.y + alignTo.height - 1,
	                            inverted
	                        )
	                    )
	                ),
	                alignAttr, // the final position;
	                justify = pick(options.overflow, 'justify') === 'justify';
	
	            if (visible) {
	
	
	                fontSize = options.style.fontSize;
	
	
	                baseline = chart.renderer.fontMetrics(fontSize, dataLabel).b;
	
	                // The alignment box is a singular point
	                alignTo = extend({
	                    x: inverted ? this.yAxis.len - plotY : plotX,
	                    y: Math.round(inverted ? this.xAxis.len - plotX : plotY),
	                    width: 0,
	                    height: 0
	                }, alignTo);
	
	                // Add the text size for alignment calculation
	                extend(options, {
	                    width: bBox.width,
	                    height: bBox.height
	                });
	
	                // Allow a hook for changing alignment in the last moment, then do the alignment
	                if (rotation) {
	                    justify = false; // Not supported for rotated text
	                    rotCorr = chart.renderer.rotCorr(baseline, rotation); // #3723
	                    alignAttr = {
	                        x: alignTo.x + options.x + alignTo.width / 2 + rotCorr.x,
	                        y: alignTo.y + options.y + {
	                            top: 0,
	                            middle: 0.5,
	                            bottom: 1
	                        }[options.verticalAlign] * alignTo.height
	                    };
	                    dataLabel[isNew ? 'attr' : 'animate'](alignAttr)
	                        .attr({ // #3003
	                            align: align
	                        });
	
	                    // Compensate for the rotated label sticking out on the sides
	                    normRotation = (rotation + 720) % 360;
	                    negRotation = normRotation > 180 && normRotation < 360;
	
	                    if (align === 'left') {
	                        alignAttr.y -= negRotation ? bBox.height : 0;
	                    } else if (align === 'center') {
	                        alignAttr.x -= bBox.width / 2;
	                        alignAttr.y -= bBox.height / 2;
	                    } else if (align === 'right') {
	                        alignAttr.x -= bBox.width;
	                        alignAttr.y -= negRotation ? 0 : bBox.height;
	                    }
	
	
	                } else {
	                    dataLabel.align(options, null, alignTo);
	                    alignAttr = dataLabel.alignAttr;
	                }
	
	                // Handle justify or crop
	                if (justify) {
	                    point.isLabelJustified = this.justifyDataLabel(
	                        dataLabel,
	                        options,
	                        alignAttr,
	                        bBox,
	                        alignTo,
	                        isNew
	                    );
	
	                    // Now check that the data label is within the plot area
	                } else if (pick(options.crop, true)) {
	                    visible = chart.isInsidePlot(alignAttr.x, alignAttr.y) && chart.isInsidePlot(alignAttr.x + bBox.width, alignAttr.y + bBox.height);
	                }
	
	                // When we're using a shape, make it possible with a connector or an arrow pointing to thie point
	                if (options.shape && !rotation) {
	                    dataLabel[isNew ? 'attr' : 'animate']({
	                        anchorX: inverted ? chart.plotWidth - point.plotY : point.plotX,
	                        anchorY: inverted ? chart.plotHeight - point.plotX : point.plotY
	                    });
	                }
	            }
	
	            // Show or hide based on the final aligned position
	            if (!visible) {
	                dataLabel.attr({
	                    y: -9999
	                });
	                dataLabel.placed = false; // don't animate back in
	            }
	
	        };
	
	        /**
	         * If data labels fall partly outside the plot area, align them back in, in a way that
	         * doesn't hide the point.
	         */
	        Series.prototype.justifyDataLabel = function(dataLabel, options, alignAttr, bBox, alignTo, isNew) {
	            var chart = this.chart,
	                align = options.align,
	                verticalAlign = options.verticalAlign,
	                off,
	                justified,
	                padding = dataLabel.box ? 0 : (dataLabel.padding || 0);
	
	            // Off left
	            off = alignAttr.x + padding;
	            if (off < 0) {
	                if (align === 'right') {
	                    options.align = 'left';
	                } else {
	                    options.x = -off;
	                }
	                justified = true;
	            }
	
	            // Off right
	            off = alignAttr.x + bBox.width - padding;
	            if (off > chart.plotWidth) {
	                if (align === 'left') {
	                    options.align = 'right';
	                } else {
	                    options.x = chart.plotWidth - off;
	                }
	                justified = true;
	            }
	
	            // Off top
	            off = alignAttr.y + padding;
	            if (off < 0) {
	                if (verticalAlign === 'bottom') {
	                    options.verticalAlign = 'top';
	                } else {
	                    options.y = -off;
	                }
	                justified = true;
	            }
	
	            // Off bottom
	            off = alignAttr.y + bBox.height - padding;
	            if (off > chart.plotHeight) {
	                if (verticalAlign === 'top') {
	                    options.verticalAlign = 'bottom';
	                } else {
	                    options.y = chart.plotHeight - off;
	                }
	                justified = true;
	            }
	
	            if (justified) {
	                dataLabel.placed = !isNew;
	                dataLabel.align(options, null, alignTo);
	            }
	
	            return justified;
	        };
	
	        /**
	         * Override the base drawDataLabels method by pie specific functionality
	         */
	        if (seriesTypes.pie) {
	            seriesTypes.pie.prototype.drawDataLabels = function() {
	                var series = this,
	                    data = series.data,
	                    point,
	                    chart = series.chart,
	                    options = series.options.dataLabels,
	                    connectorPadding = pick(options.connectorPadding, 10),
	                    connectorWidth = pick(options.connectorWidth, 1),
	                    plotWidth = chart.plotWidth,
	                    plotHeight = chart.plotHeight,
	                    connector,
	                    seriesCenter = series.center,
	                    radius = seriesCenter[2] / 2,
	                    centerY = seriesCenter[1],
	                    dataLabel,
	                    dataLabelWidth,
	                    labelPos,
	                    labelHeight,
	                    halves = [ // divide the points into right and left halves for anti collision
	                        [], // right
	                        [] // left
	                    ],
	                    x,
	                    y,
	                    visibility,
	                    j,
	                    overflow = [0, 0, 0, 0]; // top, right, bottom, left
	
	                // get out if not enabled
	                if (!series.visible || (!options.enabled && !series._hasPointLabels)) {
	                    return;
	                }
	
	                // Reset all labels that have been shortened
	                each(data, function(point) {
	                    if (point.dataLabel && point.visible && point.dataLabel.shortened) {
	                        point.dataLabel
	                            .attr({
	                                width: 'auto'
	                            }).css({
	                                width: 'auto',
	                                textOverflow: 'clip'
	                            });
	                        point.dataLabel.shortened = false;
	                    }
	                });
	
	
	                // run parent method
	                Series.prototype.drawDataLabels.apply(series);
	
	                each(data, function(point) {
	                    if (point.dataLabel && point.visible) { // #407, #2510
	
	                        // Arrange points for detection collision
	                        halves[point.half].push(point);
	
	                        // Reset positions (#4905)
	                        point.dataLabel._pos = null;
	                    }
	                });
	
	                /* Loop over the points in each half, starting from the top and bottom
	                 * of the pie to detect overlapping labels.
	                 */
	                each(halves, function(points, i) {
	
	                    var top,
	                        bottom,
	                        length = points.length,
	                        positions = [],
	                        naturalY,
	                        sideOverflow,
	                        positionsIndex, // Point index in positions array.
	                        size;
	
	                    if (!length) {
	                        return;
	                    }
	
	                    // Sort by angle
	                    series.sortByAngle(points, i - 0.5);
	                    // Only do anti-collision when we have dataLabels outside the pie 
	                    // and have connectors. (#856)
	                    if (series.maxLabelDistance > 0) {
	                        top = Math.max(
	                            0,
	                            centerY - radius - series.maxLabelDistance
	                        );
	                        bottom = Math.min(
	                            centerY + radius + series.maxLabelDistance,
	                            chart.plotHeight
	                        );
	                        each(points, function(point) {
	                            // check if specific points' label is outside the pie
	                            if (point.labelDistance > 0 && point.dataLabel) {
	                                // point.top depends on point.labelDistance value
	                                // Used for calculation of y value in getX method 
	                                point.top = Math.max(
	                                    0,
	                                    centerY - radius - point.labelDistance
	                                );
	                                point.bottom = Math.min(
	                                    centerY + radius + point.labelDistance,
	                                    chart.plotHeight
	                                );
	                                size = point.dataLabel.getBBox().height || 21;
	
	                                // point.positionsIndex is needed for getting index of 
	                                // parameter related to specific point inside positions 
	                                // array - not every point is in positions array.
	                                point.positionsIndex = positions.push({
	                                    target: point.labelPos[1] - point.top + size / 2,
	                                    size: size,
	                                    rank: point.y
	                                }) - 1;
	                            }
	                        });
	                        H.distribute(positions, bottom + size - top);
	                    }
	
	                    // Now the used slots are sorted, fill them up sequentially
	                    for (j = 0; j < length; j++) {
	
	                        point = points[j];
	                        positionsIndex = point.positionsIndex;
	                        labelPos = point.labelPos;
	                        dataLabel = point.dataLabel;
	                        visibility = point.visible === false ? 'hidden' : 'inherit';
	                        naturalY = labelPos[1];
	
	                        if (positions && defined(positions[positionsIndex])) {
	                            if (positions[positionsIndex].pos === undefined) {
	                                visibility = 'hidden';
	                            } else {
	                                labelHeight = positions[positionsIndex].size;
	                                y = point.top + positions[positionsIndex].pos;
	                            }
	
	                        } else {
	                            y = naturalY;
	                        }
	
	                        // It is needed to delete point.positionIndex for 
	                        // dynamically added points etc.
	
	                        delete point.positionIndex;
	
	                        // get the x - use the natural x position for labels near the 
	                        // top and bottom, to prevent the top and botton slice connectors 
	                        // from touching each other on either side
	                        if (options.justify) {
	                            x = seriesCenter[0] + (i ? -1 : 1) * (radius + point.labelDistance);
	                        } else {
	                            x = series.getX(y < point.top + 2 || y > point.bottom - 2 ? naturalY : y, i, point);
	                        }
	
	
	                        // Record the placement and visibility
	                        dataLabel._attr = {
	                            visibility: visibility,
	                            align: labelPos[6]
	                        };
	                        dataLabel._pos = {
	                            x: x + options.x +
	                                ({
	                                    left: connectorPadding,
	                                    right: -connectorPadding
	                                }[labelPos[6]] || 0),
	                            y: y + options.y - 10 // 10 is for the baseline (label vs text)
	                        };
	                        labelPos.x = x;
	                        labelPos.y = y;
	
	
	                        // Detect overflowing data labels
	                        if (pick(options.crop, true)) {
	                            dataLabelWidth = dataLabel.getBBox().width;
	
	                            sideOverflow = null;
	                            // Overflow left
	                            if (x - dataLabelWidth < connectorPadding) {
	                                sideOverflow = Math.round(
	                                    dataLabelWidth - x + connectorPadding
	                                );
	                                overflow[3] = Math.max(sideOverflow, overflow[3]);
	
	                                // Overflow right
	                            } else if (
	                                x + dataLabelWidth >
	                                plotWidth - connectorPadding
	                            ) {
	                                sideOverflow = Math.round(
	                                    x + dataLabelWidth - plotWidth + connectorPadding
	                                );
	                                overflow[1] = Math.max(sideOverflow, overflow[1]);
	                            }
	
	                            // Overflow top
	                            if (y - labelHeight / 2 < 0) {
	                                overflow[0] = Math.max(
	                                    Math.round(-y + labelHeight / 2),
	                                    overflow[0]
	                                );
	
	                                // Overflow left
	                            } else if (y + labelHeight / 2 > plotHeight) {
	                                overflow[2] = Math.max(
	                                    Math.round(y + labelHeight / 2 - plotHeight),
	                                    overflow[2]
	                                );
	                            }
	                            dataLabel.sideOverflow = sideOverflow;
	                        }
	                    } // for each point
	                }); // for each half
	
	                // Do not apply the final placement and draw the connectors until we have verified
	                // that labels are not spilling over.
	                if (arrayMax(overflow) === 0 || this.verifyDataLabelOverflow(overflow)) {
	
	                    // Place the labels in the final position
	                    this.placeDataLabels();
	
	                    // Draw the connectors
	                    if (connectorWidth) {
	                        each(this.points, function(point) {
	                            var isNew;
	
	                            connector = point.connector;
	                            dataLabel = point.dataLabel;
	
	                            if (
	                                dataLabel &&
	                                dataLabel._pos &&
	                                point.visible &&
	                                point.labelDistance > 0
	                            ) {
	                                visibility = dataLabel._attr.visibility;
	
	                                isNew = !connector;
	
	                                if (isNew) {
	                                    point.connector = connector = chart.renderer.path()
	                                        .addClass('highcharts-data-label-connector highcharts-color-' + point.colorIndex)
	                                        .add(series.dataLabelsGroup);
	
	
	                                    connector.attr({
	                                        'stroke-width': connectorWidth,
	                                        'stroke': options.connectorColor || point.color || '#666666'
	                                    });
	
	                                }
	                                connector[isNew ? 'attr' : 'animate']({
	                                    d: series.connectorPath(point.labelPos)
	                                });
	                                connector.attr('visibility', visibility);
	
	                            } else if (connector) {
	                                point.connector = connector.destroy();
	                            }
	                        });
	                    }
	                }
	            };
	
	            /**
	             * Extendable method for getting the path of the connector between the data label
	             * and the pie slice.
	             */
	            seriesTypes.pie.prototype.connectorPath = function(labelPos) {
	                var x = labelPos.x,
	                    y = labelPos.y;
	                return pick(this.options.dataLabels.softConnector, true) ? [
	                    'M',
	                    x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
	                    'C',
	                    x, y, // first break, next to the label
	                    2 * labelPos[2] - labelPos[4], 2 * labelPos[3] - labelPos[5],
	                    labelPos[2], labelPos[3], // second break
	                    'L',
	                    labelPos[4], labelPos[5] // base
	                ] : [
	                    'M',
	                    x + (labelPos[6] === 'left' ? 5 : -5), y, // end of the string at the label
	                    'L',
	                    labelPos[2], labelPos[3], // second break
	                    'L',
	                    labelPos[4], labelPos[5] // base
	                ];
	            };
	
	            /**
	             * Perform the final placement of the data labels after we have verified that they
	             * fall within the plot area.
	             */
	            seriesTypes.pie.prototype.placeDataLabels = function() {
	                each(this.points, function(point) {
	                    var dataLabel = point.dataLabel,
	                        _pos;
	                    if (dataLabel && point.visible) {
	                        _pos = dataLabel._pos;
	                        if (_pos) {
	
	                            // Shorten data labels with ellipsis if they still overflow
	                            // after the pie has reached minSize (#223).
	                            if (dataLabel.sideOverflow) {
	                                dataLabel._attr.width =
	                                    dataLabel.getBBox().width - dataLabel.sideOverflow;
	                                dataLabel.css({
	                                    width: dataLabel._attr.width + 'px',
	                                    textOverflow: 'ellipsis'
	                                });
	                                dataLabel.shortened = true;
	                            }
	
	                            dataLabel.attr(dataLabel._attr);
	                            dataLabel[dataLabel.moved ? 'animate' : 'attr'](_pos);
	                            dataLabel.moved = true;
	                        } else if (dataLabel) {
	                            dataLabel.attr({
	                                y: -9999
	                            });
	                        }
	                    }
	                }, this);
	            };
	
	            seriesTypes.pie.prototype.alignDataLabel = noop;
	
	            /**
	             * Verify whether the data labels are allowed to draw, or we should run more translation and data
	             * label positioning to keep them inside the plot area. Returns true when data labels are ready
	             * to draw.
	             */
	            seriesTypes.pie.prototype.verifyDataLabelOverflow = function(overflow) {
	
	                var center = this.center,
	                    options = this.options,
	                    centerOption = options.center,
	                    minSize = options.minSize || 80,
	                    newSize = minSize,
	                    // If a size is set, return true and don't try to shrink the pie
	                    // to fit the labels.
	                    ret = options.size !== null;
	
	                if (!ret) {
	                    // Handle horizontal size and center
	                    if (centerOption[0] !== null) { // Fixed center
	                        newSize = Math.max(center[2] -
	                            Math.max(overflow[1], overflow[3]), minSize);
	
	                    } else { // Auto center
	                        newSize = Math.max(
	                            // horizontal overflow
	                            center[2] - overflow[1] - overflow[3],
	                            minSize
	                        );
	                        // horizontal center
	                        center[0] += (overflow[3] - overflow[1]) / 2;
	                    }
	
	                    // Handle vertical size and center
	                    if (centerOption[1] !== null) { // Fixed center
	                        newSize = Math.max(Math.min(newSize, center[2] -
	                            Math.max(overflow[0], overflow[2])), minSize);
	
	                    } else { // Auto center
	                        newSize = Math.max(
	                            Math.min(
	                                newSize,
	                                // vertical overflow
	                                center[2] - overflow[0] - overflow[2]
	                            ),
	                            minSize
	                        );
	                        // vertical center
	                        center[1] += (overflow[0] - overflow[2]) / 2;
	                    }
	
	                    // If the size must be decreased, we need to run translate and
	                    // drawDataLabels again
	                    if (newSize < center[2]) {
	                        center[2] = newSize;
	                        center[3] = Math.min( // #3632
	                            relativeLength(options.innerSize || 0, newSize),
	                            newSize
	                        );
	                        this.translate(center);
	
	                        if (this.drawDataLabels) {
	                            this.drawDataLabels();
	                        }
	                        // Else, return true to indicate that the pie and its labels is
	                        // within the plot area
	                    } else {
	                        ret = true;
	                    }
	                }
	                return ret;
	            };
	        }
	
	        if (seriesTypes.column) {
	
	            /**
	             * Override the basic data label alignment by adjusting for the position of the column
	             */
	            seriesTypes.column.prototype.alignDataLabel = function(point, dataLabel, options, alignTo, isNew) {
	                var inverted = this.chart.inverted,
	                    series = point.series,
	                    dlBox = point.dlBox || point.shapeArgs, // data label box for alignment
	                    below = pick(point.below, point.plotY > pick(this.translatedThreshold, series.yAxis.len)), // point.below is used in range series
	                    inside = pick(options.inside, !!this.options.stacking), // draw it inside the box?
	                    overshoot;
	
	                // Align to the column itself, or the top of it
	                if (dlBox) { // Area range uses this method but not alignTo
	                    alignTo = merge(dlBox);
	
	                    if (alignTo.y < 0) {
	                        alignTo.height += alignTo.y;
	                        alignTo.y = 0;
	                    }
	                    overshoot = alignTo.y + alignTo.height - series.yAxis.len;
	                    if (overshoot > 0) {
	                        alignTo.height -= overshoot;
	                    }
	
	                    if (inverted) {
	                        alignTo = {
	                            x: series.yAxis.len - alignTo.y - alignTo.height,
	                            y: series.xAxis.len - alignTo.x - alignTo.width,
	                            width: alignTo.height,
	                            height: alignTo.width
	                        };
	                    }
	
	                    // Compute the alignment box
	                    if (!inside) {
	                        if (inverted) {
	                            alignTo.x += below ? 0 : alignTo.width;
	                            alignTo.width = 0;
	                        } else {
	                            alignTo.y += below ? alignTo.height : 0;
	                            alignTo.height = 0;
	                        }
	                    }
	                }
	
	
	                // When alignment is undefined (typically columns and bars), display the individual
	                // point below or above the point depending on the threshold
	                options.align = pick(
	                    options.align, !inverted || inside ? 'center' : below ? 'right' : 'left'
	                );
	                options.verticalAlign = pick(
	                    options.verticalAlign,
	                    inverted || inside ? 'middle' : below ? 'top' : 'bottom'
	                );
	
	                // Call the parent method
	                Series.prototype.alignDataLabel.call(this, point, dataLabel, options, alignTo, isNew);
	
	                // If label was justified and we have contrast, set it:
	                if (point.isLabelJustified && point.contrastColor) {
	                    point.dataLabel.css({
	                        color: point.contrastColor
	                    });
	                }
	            };
	        }
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2009-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        /**
	         * Highcharts module to hide overlapping data labels. This module is included in
	         * Highcharts.
	         */
	        var Chart = H.Chart,
	            each = H.each,
	            objectEach = H.objectEach,
	            pick = H.pick,
	            addEvent = H.addEvent;
	
	        // Collect potensial overlapping data labels. Stack labels probably don't need
	        // to be considered because they are usually accompanied by data labels that lie
	        // inside the columns.
	        Chart.prototype.callbacks.push(function(chart) {
	            function collectAndHide() {
	                var labels = [];
	
	                each(chart.yAxis || [], function(yAxis) {
	                    if (
	                        yAxis.options.stackLabels &&
	                        !yAxis.options.stackLabels.allowOverlap
	                    ) {
	                        objectEach(yAxis.stacks, function(stack) {
	                            objectEach(stack, function(stackItem) {
	                                labels.push(stackItem.label);
	                            });
	                        });
	                    }
	                });
	
	                each(chart.series || [], function(series) {
	                    var dlOptions = series.options.dataLabels,
	                        // Range series have two collections
	                        collections = series.dataLabelCollections || ['dataLabel'];
	
	                    if (
	                        (dlOptions.enabled || series._hasPointLabels) &&
	                        !dlOptions.allowOverlap &&
	                        series.visible
	                    ) { // #3866
	                        each(collections, function(coll) {
	                            each(series.points, function(point) {
	                                if (point[coll]) {
	                                    point[coll].labelrank = pick(
	                                        point.labelrank,
	                                        point.shapeArgs && point.shapeArgs.height
	                                    ); // #4118
	                                    labels.push(point[coll]);
	                                }
	                            });
	                        });
	                    }
	                });
	                chart.hideOverlappingLabels(labels);
	            }
	
	            // Do it now ...
	            collectAndHide();
	
	            // ... and after each chart redraw
	            addEvent(chart, 'redraw', collectAndHide);
	
	        });
	
	        /**
	         * Hide overlapping labels. Labels are moved and faded in and out on zoom to
	         * provide a smooth visual imression.
	         */
	        Chart.prototype.hideOverlappingLabels = function(labels) {
	
	            var len = labels.length,
	                label,
	                i,
	                j,
	                label1,
	                label2,
	                isIntersecting,
	                pos1,
	                pos2,
	                parent1,
	                parent2,
	                padding,
	                bBox,
	                intersectRect = function(x1, y1, w1, h1, x2, y2, w2, h2) {
	                    return !(
	                        x2 > x1 + w1 ||
	                        x2 + w2 < x1 ||
	                        y2 > y1 + h1 ||
	                        y2 + h2 < y1
	                    );
	                };
	
	            for (i = 0; i < len; i++) {
	                label = labels[i];
	                if (label) {
	
	                    // Mark with initial opacity
	                    label.oldOpacity = label.opacity;
	                    label.newOpacity = 1;
	
	                    // Get width and height if pure text nodes (stack labels)
	                    if (!label.width) {
	                        bBox = label.getBBox();
	                        label.width = bBox.width;
	                        label.height = bBox.height;
	                    }
	                }
	            }
	
	            // Prevent a situation in a gradually rising slope, that each label will
	            // hide the previous one because the previous one always has lower rank.
	            labels.sort(function(a, b) {
	                return (b.labelrank || 0) - (a.labelrank || 0);
	            });
	
	            // Detect overlapping labels
	            for (i = 0; i < len; i++) {
	                label1 = labels[i];
	
	                for (j = i + 1; j < len; ++j) {
	                    label2 = labels[j];
	                    if (
	                        label1 && label2 &&
	                        label1 !== label2 && // #6465, polar chart with connectEnds
	                        label1.placed && label2.placed &&
	                        label1.newOpacity !== 0 && label2.newOpacity !== 0
	                    ) {
	                        pos1 = label1.alignAttr;
	                        pos2 = label2.alignAttr;
	                        // Different panes have different positions
	                        parent1 = label1.parentGroup;
	                        parent2 = label2.parentGroup;
	                        // Substract the padding if no background or border (#4333)
	                        padding = 2 * (label1.box ? 0 : (label1.padding || 0));
	                        isIntersecting = intersectRect(
	                            pos1.x + parent1.translateX,
	                            pos1.y + parent1.translateY,
	                            label1.width - padding,
	                            label1.height - padding,
	                            pos2.x + parent2.translateX,
	                            pos2.y + parent2.translateY,
	                            label2.width - padding,
	                            label2.height - padding
	                        );
	
	                        if (isIntersecting) {
	                            (label1.labelrank < label2.labelrank ? label1 : label2)
	                            .newOpacity = 0;
	                        }
	                    }
	                }
	            }
	
	            // Hide or show
	            each(labels, function(label) {
	                var complete,
	                    newOpacity;
	
	                if (label) {
	                    newOpacity = label.newOpacity;
	
	                    if (label.oldOpacity !== newOpacity && label.placed) {
	
	                        // Make sure the label is completely hidden to avoid catching
	                        // clicks (#4362)
	                        if (newOpacity) {
	                            label.show(true);
	                        } else {
	                            complete = function() {
	                                label.hide();
	                            };
	                        }
	
	                        // Animate or set the opacity					
	                        label.alignAttr.opacity = newOpacity;
	                        label[label.isOld ? 'animate' : 'attr'](
	                            label.alignAttr,
	                            null,
	                            complete
	                        );
	
	                    }
	                    label.isOld = true;
	                }
	            });
	        };
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var addEvent = H.addEvent,
	            Chart = H.Chart,
	            createElement = H.createElement,
	            css = H.css,
	            defaultOptions = H.defaultOptions,
	            defaultPlotOptions = H.defaultPlotOptions,
	            each = H.each,
	            extend = H.extend,
	            fireEvent = H.fireEvent,
	            hasTouch = H.hasTouch,
	            inArray = H.inArray,
	            isObject = H.isObject,
	            Legend = H.Legend,
	            merge = H.merge,
	            pick = H.pick,
	            Point = H.Point,
	            Series = H.Series,
	            seriesTypes = H.seriesTypes,
	            svg = H.svg,
	            TrackerMixin;
	
	        /**
	         * TrackerMixin for points and graphs.
	         */
	        TrackerMixin = H.TrackerMixin = {
	
	            /**
	             * Draw the tracker for a point.
	             */
	            drawTrackerPoint: function() {
	                var series = this,
	                    chart = series.chart,
	                    pointer = chart.pointer,
	                    onMouseOver = function(e) {
	                        var point = pointer.getPointFromEvent(e);
	                        // undefined on graph in scatterchart
	                        if (point !== undefined) {
	                            pointer.isDirectTouch = true;
	                            point.onMouseOver(e);
	                        }
	                    };
	
	                // Add reference to the point
	                each(series.points, function(point) {
	                    if (point.graphic) {
	                        point.graphic.element.point = point;
	                    }
	                    if (point.dataLabel) {
	                        if (point.dataLabel.div) {
	                            point.dataLabel.div.point = point;
	                        } else {
	                            point.dataLabel.element.point = point;
	                        }
	                    }
	                });
	
	                // Add the event listeners, we need to do this only once
	                if (!series._hasTracking) {
	                    each(series.trackerGroups, function(key) {
	                        if (series[key]) { // we don't always have dataLabelsGroup
	                            series[key]
	                                .addClass('highcharts-tracker')
	                                .on('mouseover', onMouseOver)
	                                .on('mouseout', function(e) {
	                                    pointer.onTrackerMouseOut(e);
	                                });
	                            if (hasTouch) {
	                                series[key].on('touchstart', onMouseOver);
	                            }
	
	
	                            if (series.options.cursor) {
	                                series[key]
	                                    .css(css)
	                                    .css({
	                                        cursor: series.options.cursor
	                                    });
	                            }
	
	                        }
	                    });
	                    series._hasTracking = true;
	                }
	            },
	
	            /**
	             * Draw the tracker object that sits above all data labels and markers to
	             * track mouse events on the graph or points. For the line type charts
	             * the tracker uses the same graphPath, but with a greater stroke width
	             * for better control.
	             */
	            drawTrackerGraph: function() {
	                var series = this,
	                    options = series.options,
	                    trackByArea = options.trackByArea,
	                    trackerPath = [].concat(trackByArea ? series.areaPath : series.graphPath),
	                    trackerPathLength = trackerPath.length,
	                    chart = series.chart,
	                    pointer = chart.pointer,
	                    renderer = chart.renderer,
	                    snap = chart.options.tooltip.snap,
	                    tracker = series.tracker,
	                    i,
	                    onMouseOver = function() {
	                        if (chart.hoverSeries !== series) {
	                            series.onMouseOver();
	                        }
	                    },
	                    /*
	                     * Empirical lowest possible opacities for TRACKER_FILL for an element to stay invisible but clickable
	                     * IE6: 0.002
	                     * IE7: 0.002
	                     * IE8: 0.002
	                     * IE9: 0.00000000001 (unlimited)
	                     * IE10: 0.0001 (exporting only)
	                     * FF: 0.00000000001 (unlimited)
	                     * Chrome: 0.000001
	                     * Safari: 0.000001
	                     * Opera: 0.00000000001 (unlimited)
	                     */
	                    TRACKER_FILL = 'rgba(192,192,192,' + (svg ? 0.0001 : 0.002) + ')';
	
	                // Extend end points. A better way would be to use round linecaps,
	                // but those are not clickable in VML.
	                if (trackerPathLength && !trackByArea) {
	                    i = trackerPathLength + 1;
	                    while (i--) {
	                        if (trackerPath[i] === 'M') { // extend left side
	                            trackerPath.splice(i + 1, 0, trackerPath[i + 1] - snap, trackerPath[i + 2], 'L');
	                        }
	                        if ((i && trackerPath[i] === 'M') || i === trackerPathLength) { // extend right side
	                            trackerPath.splice(i, 0, 'L', trackerPath[i - 2] + snap, trackerPath[i - 1]);
	                        }
	                    }
	                }
	
	                // handle single points
	                /*for (i = 0; i < singlePoints.length; i++) {
	                	singlePoint = singlePoints[i];
	                	trackerPath.push(M, singlePoint.plotX - snap, singlePoint.plotY,
	                	L, singlePoint.plotX + snap, singlePoint.plotY);
	                }*/
	
	                // draw the tracker
	                if (tracker) {
	                    tracker.attr({
	                        d: trackerPath
	                    });
	                } else if (series.graph) { // create
	
	                    series.tracker = renderer.path(trackerPath)
	                        .attr({
	                            'stroke-linejoin': 'round', // #1225
	                            visibility: series.visible ? 'visible' : 'hidden',
	                            stroke: TRACKER_FILL,
	                            fill: trackByArea ? TRACKER_FILL : 'none',
	                            'stroke-width': series.graph.strokeWidth() + (trackByArea ? 0 : 2 * snap),
	                            zIndex: 2
	                        })
	                        .add(series.group);
	
	                    // The tracker is added to the series group, which is clipped, but is covered
	                    // by the marker group. So the marker group also needs to capture events.
	                    each([series.tracker, series.markerGroup], function(tracker) {
	                        tracker.addClass('highcharts-tracker')
	                            .on('mouseover', onMouseOver)
	                            .on('mouseout', function(e) {
	                                pointer.onTrackerMouseOut(e);
	                            });
	
	
	                        if (options.cursor) {
	                            tracker.css({
	                                cursor: options.cursor
	                            });
	                        }
	
	
	                        if (hasTouch) {
	                            tracker.on('touchstart', onMouseOver);
	                        }
	                    });
	                }
	            }
	        };
	        /* End TrackerMixin */
	
	
	        /**
	         * Add tracking event listener to the series group, so the point graphics
	         * themselves act as trackers
	         */
	
	        if (seriesTypes.column) {
	            seriesTypes.column.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        if (seriesTypes.pie) {
	            seriesTypes.pie.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        if (seriesTypes.scatter) {
	            seriesTypes.scatter.prototype.drawTracker = TrackerMixin.drawTrackerPoint;
	        }
	
	        /*
	         * Extend Legend for item events
	         */
	        extend(Legend.prototype, {
	
	            setItemEvents: function(item, legendItem, useHTML) {
	                var legend = this,
	                    boxWrapper = legend.chart.renderer.boxWrapper,
	                    activeClass = 'highcharts-legend-' + (item.series ? 'point' : 'series') + '-active';
	
	                // Set the events on the item group, or in case of useHTML, the item itself (#1249)
	                (useHTML ? legendItem : item.legendGroup).on('mouseover', function() {
	                        item.setState('hover');
	
	                        // A CSS class to dim or hide other than the hovered series
	                        boxWrapper.addClass(activeClass);
	
	
	                        legendItem.css(legend.options.itemHoverStyle);
	
	                    })
	                    .on('mouseout', function() {
	
	                        legendItem.css(merge(item.visible ? legend.itemStyle : legend.itemHiddenStyle));
	
	
	                        // A CSS class to dim or hide other than the hovered series
	                        boxWrapper.removeClass(activeClass);
	
	                        item.setState();
	                    })
	                    .on('click', function(event) {
	                        var strLegendItemClick = 'legendItemClick',
	                            fnLegendItemClick = function() {
	                                if (item.setVisible) {
	                                    item.setVisible();
	                                }
	                            };
	
	                        // Pass over the click/touch event. #4.
	                        event = {
	                            browserEvent: event
	                        };
	
	                        // click the name or symbol
	                        if (item.firePointEvent) { // point
	                            item.firePointEvent(strLegendItemClick, event, fnLegendItemClick);
	                        } else {
	                            fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
	                        }
	                    });
	            },
	
	            createCheckboxForItem: function(item) {
	                var legend = this;
	
	                item.checkbox = createElement('input', {
	                    type: 'checkbox',
	                    checked: item.selected,
	                    defaultChecked: item.selected // required by IE7
	                }, legend.options.itemCheckboxStyle, legend.chart.container);
	
	                addEvent(item.checkbox, 'click', function(event) {
	                    var target = event.target;
	                    fireEvent(
	                        item.series || item,
	                        'checkboxClick', { // #3712
	                            checked: target.checked,
	                            item: item
	                        },
	                        function() {
	                            item.select();
	                        }
	                    );
	                });
	            }
	        });
	
	
	
	        // Add pointer cursor to legend itemstyle in defaultOptions
	        defaultOptions.legend.itemStyle.cursor = 'pointer';
	
	
	
	        /*
	         * Extend the Chart object with interaction
	         */
	
	        extend(Chart.prototype, /** @lends Chart.prototype */ {
	            /**
	             * Display the zoom button.
	             *
	             * @private
	             */
	            showResetZoom: function() {
	                var chart = this,
	                    lang = defaultOptions.lang,
	                    btnOptions = chart.options.chart.resetZoomButton,
	                    theme = btnOptions.theme,
	                    states = theme.states,
	                    alignTo = btnOptions.relativeTo === 'chart' ? null : 'plotBox';
	
	                function zoomOut() {
	                    chart.zoomOut();
	                }
	
	                this.resetZoomButton = chart.renderer.button(lang.resetZoom, null, null, zoomOut, theme, states && states.hover)
	                    .attr({
	                        align: btnOptions.position.align,
	                        title: lang.resetZoomTitle
	                    })
	                    .addClass('highcharts-reset-zoom')
	                    .add()
	                    .align(btnOptions.position, false, alignTo);
	
	            },
	
	            /**
	             * Zoom out to 1:1.
	             *
	             * @private
	             */
	            zoomOut: function() {
	                var chart = this;
	                fireEvent(chart, 'selection', {
	                    resetSelection: true
	                }, function() {
	                    chart.zoom();
	                });
	            },
	
	            /**
	             * Zoom into a given portion of the chart given by axis coordinates.
	             * @param {Object} event
	             *
	             * @private
	             */
	            zoom: function(event) {
	                var chart = this,
	                    hasZoomed,
	                    pointer = chart.pointer,
	                    displayButton = false,
	                    resetZoomButton;
	
	                // If zoom is called with no arguments, reset the axes
	                if (!event || event.resetSelection) {
	                    each(chart.axes, function(axis) {
	                        hasZoomed = axis.zoom();
	                    });
	                    pointer.initiated = false; // #6804
	
	                } else { // else, zoom in on all axes
	                    each(event.xAxis.concat(event.yAxis), function(axisData) {
	                        var axis = axisData.axis,
	                            isXAxis = axis.isXAxis;
	
	                        // don't zoom more than minRange
	                        if (pointer[isXAxis ? 'zoomX' : 'zoomY']) {
	                            hasZoomed = axis.zoom(axisData.min, axisData.max);
	                            if (axis.displayBtn) {
	                                displayButton = true;
	                            }
	                        }
	                    });
	                }
	
	                // Show or hide the Reset zoom button
	                resetZoomButton = chart.resetZoomButton;
	                if (displayButton && !resetZoomButton) {
	                    chart.showResetZoom();
	                } else if (!displayButton && isObject(resetZoomButton)) {
	                    chart.resetZoomButton = resetZoomButton.destroy();
	                }
	
	
	                // Redraw
	                if (hasZoomed) {
	                    chart.redraw(
	                        pick(chart.options.chart.animation, event && event.animation, chart.pointCount < 100) // animation
	                    );
	                }
	            },
	
	            /**
	             * Pan the chart by dragging the mouse across the pane. This function is
	             * called on mouse move, and the distance to pan is computed from chartX
	             * compared to the first chartX position in the dragging operation.
	             *
	             * @private
	             */
	            pan: function(e, panning) {
	
	                var chart = this,
	                    hoverPoints = chart.hoverPoints,
	                    doRedraw;
	
	                // remove active points for shared tooltip
	                if (hoverPoints) {
	                    each(hoverPoints, function(point) {
	                        point.setState();
	                    });
	                }
	
	                each(panning === 'xy' ? [1, 0] : [1], function(isX) { // xy is used in maps
	                    var axis = chart[isX ? 'xAxis' : 'yAxis'][0],
	                        horiz = axis.horiz,
	                        mousePos = e[horiz ? 'chartX' : 'chartY'],
	                        mouseDown = horiz ? 'mouseDownX' : 'mouseDownY',
	                        startPos = chart[mouseDown],
	                        halfPointRange = (axis.pointRange || 0) / 2,
	                        extremes = axis.getExtremes(),
	                        panMin = axis.toValue(startPos - mousePos, true) +
	                        halfPointRange,
	                        panMax = axis.toValue(startPos + axis.len - mousePos, true) -
	                        halfPointRange,
	                        flipped = panMax < panMin,
	                        newMin = flipped ? panMax : panMin,
	                        newMax = flipped ? panMin : panMax,
	                        paddedMin = Math.min(
	                            extremes.dataMin,
	                            axis.toValue(
	                                axis.toPixels(extremes.min) - axis.minPixelPadding
	                            )
	                        ),
	                        paddedMax = Math.max(
	                            extremes.dataMax,
	                            axis.toValue(
	                                axis.toPixels(extremes.max) + axis.minPixelPadding
	                            )
	                        ),
	                        spill;
	
	                    // If the new range spills over, either to the min or max, adjust
	                    // the new range.
	                    spill = paddedMin - newMin;
	                    if (spill > 0) {
	                        newMax += spill;
	                        newMin = paddedMin;
	                    }
	                    spill = newMax - paddedMax;
	                    if (spill > 0) {
	                        newMax = paddedMax;
	                        newMin -= spill;
	                    }
	
	                    // Set new extremes if they are actually new
	                    if (axis.series.length && newMin !== extremes.min && newMax !== extremes.max) {
	                        axis.setExtremes(
	                            newMin,
	                            newMax,
	                            false,
	                            false, {
	                                trigger: 'pan'
	                            }
	                        );
	                        doRedraw = true;
	                    }
	
	                    chart[mouseDown] = mousePos; // set new reference for next run
	                });
	
	                if (doRedraw) {
	                    chart.redraw(false);
	                }
	                css(chart.container, {
	                    cursor: 'move'
	                });
	            }
	        });
	
	        /*
	         * Extend the Point object with interaction
	         */
	        extend(Point.prototype, /** @lends Highcharts.Point.prototype */ {
	            /**
	             * Toggle the selection status of a point.
	             * @param  {Boolean} [selected]
	             *         When `true`, the point is selected. When `false`, the point is
	             *         unselected. When `null` or `undefined`, the selection state is
	             *         toggled.
	             * @param  {Boolean} [accumulate=false]
	             *         When `true`, the selection is added to other selected points.
	             *         When `false`, other selected points are deselected. Internally in
	             *         Highcharts, when {@link http://api.highcharts.com/highcharts/plotOptions.series.allowPointSelect|allowPointSelect}
	             *         is `true`, selected points are accumulated on Control, Shift or
	             *         Cmd clicking the point.
	             *
	             * @see    Highcharts.Chart#getSelectedPoints
	             *
	             * @sample highcharts/members/point-select/
	             *         Select a point from a button
	             * @sample highcharts/chart/events-selection-points/
	             *         Select a range of points through a drag selection
	             * @sample maps/series/data-id/
	             *         Select a point in Highmaps
	             */
	            select: function(selected, accumulate) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart;
	
	                selected = pick(selected, !point.selected);
	
	                // fire the event with the default handler
	                point.firePointEvent(selected ? 'select' : 'unselect', {
	                    accumulate: accumulate
	                }, function() {
	
	                    /**
	                     * Whether the point is selected or not. 
	                     * @see Point#select
	                     * @see Chart#getSelectedPoints
	                     * @memberof Point
	                     * @name selected
	                     * @type {Boolean}
	                     */
	                    point.selected = point.options.selected = selected;
	                    series.options.data[inArray(point, series.data)] = point.options;
	
	                    point.setState(selected && 'select');
	
	                    // unselect all other points unless Ctrl or Cmd + click
	                    if (!accumulate) {
	                        each(chart.getSelectedPoints(), function(loopPoint) {
	                            if (loopPoint.selected && loopPoint !== point) {
	                                loopPoint.selected = loopPoint.options.selected = false;
	                                series.options.data[inArray(loopPoint, series.data)] = loopPoint.options;
	                                loopPoint.setState('');
	                                loopPoint.firePointEvent('unselect');
	                            }
	                        });
	                    }
	                });
	            },
	
	            /**
	             * Runs on mouse over the point. Called internally from mouse and touch
	             * events.
	             * 
	             * @param {Object} e The event arguments
	             */
	            onMouseOver: function(e) {
	                var point = this,
	                    series = point.series,
	                    chart = series.chart,
	                    pointer = chart.pointer;
	                e = e ?
	                    pointer.normalize(e) :
	                    // In cases where onMouseOver is called directly without an event
	                    pointer.getChartCoordinatesFromPoint(point, chart.inverted);
	                pointer.runPointActions(e, point);
	            },
	
	            /**
	             * Runs on mouse out from the point. Called internally from mouse and touch
	             * events.
	             */
	            onMouseOut: function() {
	                var point = this,
	                    chart = point.series.chart;
	                point.firePointEvent('mouseOut');
	                each(chart.hoverPoints || [], function(p) {
	                    p.setState();
	                });
	                chart.hoverPoints = chart.hoverPoint = null;
	            },
	
	            /**
	             * Import events from the series' and point's options. Only do it on
	             * demand, to save processing time on hovering.
	             *
	             * @private
	             */
	            importEvents: function() {
	                if (!this.hasImportedEvents) {
	                    var point = this,
	                        options = merge(point.series.options.point, point.options),
	                        events = options.events;
	
	                    point.events = events;
	
	                    H.objectEach(events, function(event, eventType) {
	                        addEvent(point, eventType, event);
	                    });
	                    this.hasImportedEvents = true;
	
	                }
	            },
	
	            /**
	             * Set the point's state.
	             * @param  {String} [state]
	             *         The new state, can be one of `''` (an empty string), `hover` or
	             *         `select`.
	             */
	            setState: function(state, move) {
	                var point = this,
	                    plotX = Math.floor(point.plotX), // #4586
	                    plotY = point.plotY,
	                    series = point.series,
	                    stateOptions = series.options.states[state] || {},
	                    markerOptions = defaultPlotOptions[series.type].marker &&
	                    series.options.marker,
	                    normalDisabled = markerOptions && markerOptions.enabled === false,
	                    markerStateOptions = (markerOptions && markerOptions.states &&
	                        markerOptions.states[state]) || {},
	                    stateDisabled = markerStateOptions.enabled === false,
	                    stateMarkerGraphic = series.stateMarkerGraphic,
	                    pointMarker = point.marker || {},
	                    chart = series.chart,
	                    halo = series.halo,
	                    haloOptions,
	                    markerAttribs,
	                    hasMarkers = markerOptions && series.markerAttribs,
	                    newSymbol;
	
	                state = state || ''; // empty string
	
	                if (
	                    // already has this state
	                    (state === point.state && !move) ||
	
	                    // selected points don't respond to hover
	                    (point.selected && state !== 'select') ||
	
	                    // series' state options is disabled
	                    (stateOptions.enabled === false) ||
	
	                    // general point marker's state options is disabled
	                    (state && (
	                        stateDisabled ||
	                        (normalDisabled && markerStateOptions.enabled === false)
	                    )) ||
	
	                    // individual point marker's state options is disabled
	                    (
	                        state &&
	                        pointMarker.states &&
	                        pointMarker.states[state] &&
	                        pointMarker.states[state].enabled === false
	                    ) // #1610
	
	                ) {
	                    return;
	                }
	
	                if (hasMarkers) {
	                    markerAttribs = series.markerAttribs(point, state);
	                }
	
	                // Apply hover styles to the existing point
	                if (point.graphic) {
	
	                    if (point.state) {
	                        point.graphic.removeClass('highcharts-point-' + point.state);
	                    }
	                    if (state) {
	                        point.graphic.addClass('highcharts-point-' + state);
	                    }
	
	                    /*attribs = radius ? { // new symbol attributes (#507, #612)
	                    	x: plotX - radius,
	                    	y: plotY - radius,
	                    	width: 2 * radius,
	                    	height: 2 * radius
	                    } : {};*/
	
	
	                    //attribs = merge(series.pointAttribs(point, state), attribs);
	                    point.graphic.animate(
	                        series.pointAttribs(point, state),
	                        pick(
	                            chart.options.chart.animation,
	                            stateOptions.animation
	                        )
	                    );
	
	
	                    if (markerAttribs) {
	                        point.graphic.animate(
	                            markerAttribs,
	                            pick(
	                                chart.options.chart.animation, // Turn off globally
	                                markerStateOptions.animation,
	                                markerOptions.animation
	                            )
	                        );
	                    }
	
	                    // Zooming in from a range with no markers to a range with markers
	                    if (stateMarkerGraphic) {
	                        stateMarkerGraphic.hide();
	                    }
	                } else {
	                    // if a graphic is not applied to each point in the normal state, create a shared
	                    // graphic for the hover state
	                    if (state && markerStateOptions) {
	                        newSymbol = pointMarker.symbol || series.symbol;
	
	                        // If the point has another symbol than the previous one, throw away the
	                        // state marker graphic and force a new one (#1459)
	                        if (stateMarkerGraphic && stateMarkerGraphic.currentSymbol !== newSymbol) {
	                            stateMarkerGraphic = stateMarkerGraphic.destroy();
	                        }
	
	                        // Add a new state marker graphic
	                        if (!stateMarkerGraphic) {
	                            if (newSymbol) {
	                                series.stateMarkerGraphic = stateMarkerGraphic = chart.renderer.symbol(
	                                        newSymbol,
	                                        markerAttribs.x,
	                                        markerAttribs.y,
	                                        markerAttribs.width,
	                                        markerAttribs.height
	                                    )
	                                    .add(series.markerGroup);
	                                stateMarkerGraphic.currentSymbol = newSymbol;
	                            }
	
	                            // Move the existing graphic
	                        } else {
	                            stateMarkerGraphic[move ? 'animate' : 'attr']({ // #1054
	                                x: markerAttribs.x,
	                                y: markerAttribs.y
	                            });
	                        }
	
	                        if (stateMarkerGraphic) {
	                            stateMarkerGraphic.attr(series.pointAttribs(point, state));
	                        }
	
	                    }
	
	                    if (stateMarkerGraphic) {
	                        stateMarkerGraphic[state && chart.isInsidePlot(plotX, plotY, chart.inverted) ? 'show' : 'hide'](); // #2450
	                        stateMarkerGraphic.element.point = point; // #4310
	                    }
	                }
	
	                // Show me your halo
	                haloOptions = stateOptions.halo;
	                if (haloOptions && haloOptions.size) {
	                    if (!halo) {
	                        series.halo = halo = chart.renderer.path()
	                            // #5818, #5903, #6705
	                            .add((point.graphic || stateMarkerGraphic).parentGroup);
	                    }
	                    halo[move ? 'animate' : 'attr']({
	                        d: point.haloPath(haloOptions.size)
	                    });
	                    halo.attr({
	                        'class': 'highcharts-halo highcharts-color-' +
	                            pick(point.colorIndex, series.colorIndex)
	                    });
	                    halo.point = point; // #6055
	
	
	                    halo.attr(extend({
	                        'fill': point.color || series.color,
	                        'fill-opacity': haloOptions.opacity,
	                        'zIndex': -1 // #4929, IE8 added halo above everything
	                    }, haloOptions.attributes));
	
	
	                } else if (halo && halo.point && halo.point.haloPath) {
	                    // Animate back to 0 on the current halo point (#6055)
	                    halo.animate({
	                        d: halo.point.haloPath(0)
	                    });
	                }
	
	                point.state = state;
	            },
	
	            /**
	             * Get the path definition for the halo, which is usually a shadow-like
	             * circle around the currently hovered point.
	             * @param  {Number} size
	             *         The radius of the circular halo.
	             * @return {Array} The path definition
	             */
	            haloPath: function(size) {
	                var series = this.series,
	                    chart = series.chart;
	
	                return chart.renderer.symbols.circle(
	                    Math.floor(this.plotX) - size,
	                    this.plotY - size,
	                    size * 2,
	                    size * 2
	                );
	            }
	        });
	
	        /*
	         * Extend the Series object with interaction
	         */
	
	        extend(Series.prototype, /** @lends Highcharts.Series.prototype */ {
	            /**
	             * Runs on mouse over the series graphical items.
	             */
	            onMouseOver: function() {
	                var series = this,
	                    chart = series.chart,
	                    hoverSeries = chart.hoverSeries;
	
	                // set normal state to previous series
	                if (hoverSeries && hoverSeries !== series) {
	                    hoverSeries.onMouseOut();
	                }
	
	                // trigger the event, but to save processing time,
	                // only if defined
	                if (series.options.events.mouseOver) {
	                    fireEvent(series, 'mouseOver');
	                }
	
	                // hover this
	                series.setState('hover');
	                chart.hoverSeries = series;
	            },
	
	            /**
	             * Runs on mouse out of the series graphical items.
	             */
	            onMouseOut: function() {
	                // trigger the event only if listeners exist
	                var series = this,
	                    options = series.options,
	                    chart = series.chart,
	                    tooltip = chart.tooltip,
	                    hoverPoint = chart.hoverPoint;
	
	                chart.hoverSeries = null; // #182, set to null before the mouseOut event fires
	
	                // trigger mouse out on the point, which must be in this series
	                if (hoverPoint) {
	                    hoverPoint.onMouseOut();
	                }
	
	                // fire the mouse out event
	                if (series && options.events.mouseOut) {
	                    fireEvent(series, 'mouseOut');
	                }
	
	
	                // hide the tooltip
	                if (tooltip && !series.stickyTracking && (!tooltip.shared || series.noSharedTooltip)) {
	                    tooltip.hide();
	                }
	
	                // set normal state
	                series.setState();
	            },
	
	            /**
	             * Set the state of the series. Called internally on mouse interaction and
	             * select operations, but it can also be called directly to visually
	             * highlight a series.
	             *
	             * @param  {String} [state]
	             *         Can be either `hover`, `select` or undefined to set to normal
	             *         state.
	             */
	            setState: function(state) {
	                var series = this,
	                    options = series.options,
	                    graph = series.graph,
	                    stateOptions = options.states,
	                    lineWidth = options.lineWidth,
	                    attribs,
	                    i = 0;
	
	                state = state || '';
	
	                if (series.state !== state) {
	
	                    // Toggle class names
	                    each([
	                        series.group,
	                        series.markerGroup,
	                        series.dataLabelsGroup
	                    ], function(group) {
	                        if (group) {
	                            // Old state
	                            if (series.state) {
	                                group.removeClass('highcharts-series-' + series.state);
	                            }
	                            // New state
	                            if (state) {
	                                group.addClass('highcharts-series-' + state);
	                            }
	                        }
	                    });
	
	                    series.state = state;
	
	
	
	                    if (stateOptions[state] && stateOptions[state].enabled === false) {
	                        return;
	                    }
	
	                    if (state) {
	                        lineWidth = stateOptions[state].lineWidth || lineWidth + (stateOptions[state].lineWidthPlus || 0); // #4035
	                    }
	
	                    if (graph && !graph.dashstyle) { // hover is turned off for dashed lines in VML
	                        attribs = {
	                            'stroke-width': lineWidth
	                        };
	
	                        // Animate the graph stroke-width. By default a quick animation
	                        // to hover, slower to un-hover.
	                        graph.animate(
	                            attribs,
	                            pick(
	                                series.chart.options.chart.animation,
	                                stateOptions[state] && stateOptions[state].animation
	                            )
	                        );
	                        while (series['zone-graph-' + i]) {
	                            series['zone-graph-' + i].attr(attribs);
	                            i = i + 1;
	                        }
	                    }
	
	                }
	            },
	
	            /**
	             * Show or hide the series.
	             *
	             * @param  {Boolean} [visible]
	             *         True to show the series, false to hide. If undefined, the
	             *         visibility is toggled.
	             * @param  {Boolean} [redraw=true]
	             *         Whether to redraw the chart after the series is altered. If doing
	             *         more operations on the chart, it is a good idea to set redraw to
	             *         false and call {@link Chart#redraw|chart.redraw()} after.
	             */
	            setVisible: function(vis, redraw) {
	                var series = this,
	                    chart = series.chart,
	                    legendItem = series.legendItem,
	                    showOrHide,
	                    ignoreHiddenSeries = chart.options.chart.ignoreHiddenSeries,
	                    oldVisibility = series.visible;
	
	                // if called without an argument, toggle visibility
	                series.visible = vis = series.options.visible = series.userOptions.visible = vis === undefined ? !oldVisibility : vis; // #5618
	                showOrHide = vis ? 'show' : 'hide';
	
	                // show or hide elements
	                each(['group', 'dataLabelsGroup', 'markerGroup', 'tracker', 'tt'], function(key) {
	                    if (series[key]) {
	                        series[key][showOrHide]();
	                    }
	                });
	
	
	                // hide tooltip (#1361)
	                if (chart.hoverSeries === series || (chart.hoverPoint && chart.hoverPoint.series) === series) {
	                    series.onMouseOut();
	                }
	
	
	                if (legendItem) {
	                    chart.legend.colorizeItem(series, vis);
	                }
	
	
	                // rescale or adapt to resized chart
	                series.isDirty = true;
	                // in a stack, all other series are affected
	                if (series.options.stacking) {
	                    each(chart.series, function(otherSeries) {
	                        if (otherSeries.options.stacking && otherSeries.visible) {
	                            otherSeries.isDirty = true;
	                        }
	                    });
	                }
	
	                // show or hide linked series
	                each(series.linkedSeries, function(otherSeries) {
	                    otherSeries.setVisible(vis, false);
	                });
	
	                if (ignoreHiddenSeries) {
	                    chart.isDirtyBox = true;
	                }
	                if (redraw !== false) {
	                    chart.redraw();
	                }
	
	                fireEvent(series, showOrHide);
	            },
	
	            /**
	             * Show the series if hidden.
	             *
	             * @sample highcharts/members/series-hide/
	             *         Toggle visibility from a button
	             */
	            show: function() {
	                this.setVisible(true);
	            },
	
	            /**
	             * Hide the series if visible. If the {@link
	             * https://api.highcharts.com/highcharts/chart.ignoreHiddenSeries|
	             * chart.ignoreHiddenSeries} option is true, the chart is redrawn without
	             * this series.
	             *
	             * @sample highcharts/members/series-hide/
	             *         Toggle visibility from a button
	             */
	            hide: function() {
	                this.setVisible(false);
	            },
	
	
	            /**
	             * Select or unselect the series. This means its {@link
	             * Highcharts.Series.selected|selected} property is set, the checkbox in the
	             * legend is toggled and when selected, the series is returned by the
	             * {@link Highcharts.Chart#getSelectedSeries} function.
	             *
	             * @param  {Boolean} [selected]
	             *         True to select the series, false to unselect. If	undefined, the
	             *         selection state is toggled.
	             *
	             * @sample highcharts/members/series-select/
	             *         Select a series from a button
	             */
	            select: function(selected) {
	                var series = this;
	
	                series.selected = selected = (selected === undefined) ?
	                    !series.selected :
	                    selected;
	
	                if (series.checkbox) {
	                    series.checkbox.checked = selected;
	                }
	
	                fireEvent(series, selected ? 'select' : 'unselect');
	            },
	
	            drawTracker: TrackerMixin.drawTrackerGraph
	        });
	
	    }(Highcharts));
	    (function(H) {
	        /**
	         * (c) 2010-2017 Torstein Honsi
	         *
	         * License: www.highcharts.com/license
	         */
	        var Chart = H.Chart,
	            each = H.each,
	            inArray = H.inArray,
	            isArray = H.isArray,
	            isObject = H.isObject,
	            pick = H.pick,
	            splat = H.splat;
	
	        /**
	         * Update the chart based on the current chart/document size and options for
	         * responsiveness.
	         */
	        Chart.prototype.setResponsive = function(redraw) {
	            var options = this.options.responsive,
	                ruleIds = [],
	                currentResponsive = this.currentResponsive,
	                currentRuleIds;
	
	            if (options && options.rules) {
	                each(options.rules, function(rule) {
	                    if (rule._id === undefined) {
	                        rule._id = H.uniqueKey();
	                    }
	
	                    this.matchResponsiveRule(rule, ruleIds, redraw);
	                }, this);
	            }
	
	            // Merge matching rules
	            var mergedOptions = H.merge.apply(0, H.map(ruleIds, function(ruleId) {
	                return H.find(options.rules, function(rule) {
	                    return rule._id === ruleId;
	                }).chartOptions;
	            }));
	
	            // Stringified key for the rules that currently apply.
	            ruleIds = ruleIds.toString() || undefined;
	            currentRuleIds = currentResponsive && currentResponsive.ruleIds;
	
	
	            // Changes in what rules apply
	            if (ruleIds !== currentRuleIds) {
	
	                // Undo previous rules. Before we apply a new set of rules, we need to
	                // roll back completely to base options (#6291).
	                if (currentResponsive) {
	                    this.update(currentResponsive.undoOptions, redraw);
	                }
	
	                if (ruleIds) {
	                    // Get undo-options for matching rules
	                    this.currentResponsive = {
	                        ruleIds: ruleIds,
	                        mergedOptions: mergedOptions,
	                        undoOptions: this.currentOptions(mergedOptions)
	                    };
	
	                    this.update(mergedOptions, redraw);
	
	                } else {
	                    this.currentResponsive = undefined;
	                }
	            }
	        };
	
	        /**
	         * Handle a single responsiveness rule
	         */
	        Chart.prototype.matchResponsiveRule = function(rule, matches) {
	            var condition = rule.condition,
	                fn = condition.callback || function() {
	                    return this.chartWidth <= pick(condition.maxWidth, Number.MAX_VALUE) &&
	                        this.chartHeight <= pick(condition.maxHeight, Number.MAX_VALUE) &&
	                        this.chartWidth >= pick(condition.minWidth, 0) &&
	                        this.chartHeight >= pick(condition.minHeight, 0);
	                };
	
	            if (fn.call(this)) {
	                matches.push(rule._id);
	            }
	
	        };
	
	        /**
	         * Get the current values for a given set of options. Used before we update
	         * the chart with a new responsiveness rule.
	         * TODO: Restore axis options (by id?)
	         */
	        Chart.prototype.currentOptions = function(options) {
	
	            var ret = {};
	
	            /**
	             * Recurse over a set of options and its current values,
	             * and store the current values in the ret object.
	             */
	            function getCurrent(options, curr, ret, depth) {
	                var i;
	                H.objectEach(options, function(val, key) {
	                    if (!depth && inArray(key, ['series', 'xAxis', 'yAxis']) > -1) {
	                        options[key] = splat(options[key]);
	
	                        ret[key] = [];
	
	                        // Iterate over collections like series, xAxis or yAxis and map
	                        // the items by index.
	                        for (i = 0; i < options[key].length; i++) {
	                            if (curr[key][i]) { // Item exists in current data (#6347)
	                                ret[key][i] = {};
	                                getCurrent(
	                                    val[i],
	                                    curr[key][i],
	                                    ret[key][i],
	                                    depth + 1
	                                );
	                            }
	                        }
	                    } else if (isObject(val)) {
	                        ret[key] = isArray(val) ? [] : {};
	                        getCurrent(val, curr[key] || {}, ret[key], depth + 1);
	                    } else {
	                        ret[key] = curr[key] || null;
	                    }
	                });
	            }
	
	            getCurrent(options, this.options, ret, 0);
	            return ret;
	        };
	
	    }(Highcharts));
	    return Highcharts
	}));


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	/*
	 Highstock JS v5.0.14 (2017-07-28)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(M,S){"object"===typeof module&&module.exports?module.exports=M.document?S(M):S:M.Highcharts=S(M)})("undefined"!==typeof window?window:this,function(M){M=function(){var a=window,D=a.document,B=a.navigator&&a.navigator.userAgent||"",G=D&&D.createElementNS&&!!D.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,E=/(edge|msie|trident)/i.test(B)&&!window.opera,r=!G,g=/Firefox/.test(B),p=g&&4>parseInt(B.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highstock",
	version:"5.0.14",deg2rad:2*Math.PI/360,doc:D,hasBidiBug:p,hasTouch:D&&void 0!==D.documentElement.ontouchstart,isMS:E,isWebKit:/AppleWebKit/.test(B),isFirefox:g,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(B),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,vml:r,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){var D=[],B=a.charts,G=a.doc,E=a.win;a.error=function(r,g){r=a.isNumber(r)?"Highcharts error #"+
	r+": www.highcharts.com/errors/"+r:r;if(g)throw Error(r);E.console&&console.log(r)};a.Fx=function(a,g,p){this.options=g;this.elem=a;this.prop=p};a.Fx.prototype={dSetter:function(){var a=this.paths[0],g=this.paths[1],p=[],t=this.now,v=a.length,u;if(1===t)p=this.toD;else if(v===g.length&&1>t)for(;v--;)u=parseFloat(a[v]),p[v]=isNaN(u)?a[v]:t*parseFloat(g[v]-u)+u;else p=g;this.elem.attr("d",p,null,!0)},update:function(){var a=this.elem,g=this.prop,p=this.now,t=this.options.step;if(this[g+"Setter"])this[g+
	"Setter"]();else a.attr?a.element&&a.attr(g,p,null,!0):a.style[g]=p+this.unit;t&&t.call(a,p,this)},run:function(a,g,p){var t=this,r=function(a){return r.stopped?!1:t.step(a)},u;this.startTime=+new Date;this.start=a;this.end=g;this.unit=p;this.now=this.start;this.pos=0;r.elem=this.elem;r.prop=this.prop;r()&&1===D.push(r)&&(r.timerId=setInterval(function(){for(u=0;u<D.length;u++)D[u]()||D.splice(u--,1);D.length||clearInterval(r.timerId)},13))},step:function(r){var g=+new Date,p,t=this.options,v=this.elem,
	u=t.complete,l=t.duration,e=t.curAnim;v.attr&&!v.element?r=!1:r||g>=l+this.startTime?(this.now=this.end,this.pos=1,this.update(),p=e[this.prop]=!0,a.objectEach(e,function(a){!0!==a&&(p=!1)}),p&&u&&u.call(v),r=!1):(this.pos=t.easing((g-this.startTime)/l),this.now=this.start+(this.end-this.start)*this.pos,this.update(),r=!0);return r},initPath:function(r,g,p){function t(a){var b,m;for(c=a.length;c--;)b="M"===a[c]||"L"===a[c],m=/[a-zA-Z]/.test(a[c+3]),b&&m&&a.splice(c+1,0,a[c+1],a[c+2],a[c+1],a[c+2])}
	function v(a,b){for(;a.length<x;){a[0]=b[x-a.length];var m=a.slice(0,d);[].splice.apply(a,[0,0].concat(m));q&&(m=a.slice(a.length-d),[].splice.apply(a,[a.length,0].concat(m)),c--)}a[0]="M"}function u(a,b){for(var m=(x-a.length)/d;0<m&&m--;)C=a.slice().splice(a.length/I-d,d*I),C[0]=b[x-d-m*d],f&&(C[d-6]=C[d-2],C[d-5]=C[d-1]),[].splice.apply(a,[a.length/I,0].concat(C)),q&&m--}g=g||"";var l,e=r.startX,k=r.endX,f=-1<g.indexOf("C"),d=f?7:3,x,C,c;g=g.split(" ");p=p.slice();var q=r.isArea,I=q?2:1,m;f&&(t(g),
	t(p));if(e&&k){for(c=0;c<e.length;c++)if(e[c]===k[0]){l=c;break}else if(e[0]===k[k.length-e.length+c]){l=c;m=!0;break}void 0===l&&(g=[])}g.length&&a.isNumber(l)&&(x=p.length+l*I*d,m?(v(g,p),u(p,g)):(v(p,g),u(g,p)));return[g,p]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.extend=function(a,g){var r;a||(a={});for(r in g)a[r]=g[r];return a};a.merge=function(){var r,g=arguments,p,t={},v=
	function(g,l){"object"!==typeof g&&(g={});a.objectEach(l,function(e,k){!a.isObject(e,!0)||a.isClass(e)||a.isDOMElement(e)?g[k]=l[k]:g[k]=v(g[k]||{},e)});return g};!0===g[0]&&(t=g[1],g=Array.prototype.slice.call(g,2));p=g.length;for(r=0;r<p;r++)t=v(t,g[r]);return t};a.pInt=function(a,g){return parseInt(a,g||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(r,
	g){return!!r&&"object"===typeof r&&(!g||!a.isArray(r))};a.isDOMElement=function(r){return a.isObject(r)&&"number"===typeof r.nodeType};a.isClass=function(r){var g=r&&r.constructor;return!(!a.isObject(r,!0)||a.isDOMElement(r)||!g||!g.name||"Object"===g.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=function(a,g){for(var r=a.length;r--;)if(a[r]===g){a.splice(r,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(r,g,p){var t;a.isString(g)?a.defined(p)?
	r.setAttribute(g,p):r&&r.getAttribute&&(t=r.getAttribute(g)):a.defined(g)&&a.isObject(g)&&a.objectEach(g,function(a,g){r.setAttribute(g,a)});return t};a.splat=function(r){return a.isArray(r)?r:[r]};a.syncTimeout=function(a,g,p){if(g)return setTimeout(a,g,p);a.call(0,p)};a.pick=function(){var a=arguments,g,p,t=a.length;for(g=0;g<t;g++)if(p=a[g],void 0!==p&&null!==p)return p};a.css=function(r,g){a.isMS&&!a.svg&&g&&void 0!==g.opacity&&(g.filter="alpha(opacity\x3d"+100*g.opacity+")");a.extend(r.style,
	g)};a.createElement=function(r,g,p,t,v){r=G.createElement(r);var u=a.css;g&&a.extend(r,g);v&&u(r,{padding:0,border:"none",margin:0});p&&u(r,p);t&&t.appendChild(r);return r};a.extendClass=function(r,g){var p=function(){};p.prototype=new r;a.extend(p.prototype,g);return p};a.pad=function(a,g,p){return Array((g||2)+1-String(a).length).join(p||0)+a};a.relativeLength=function(a,g,p){return/%$/.test(a)?g*parseFloat(a)/100+(p||0):parseFloat(a)};a.wrap=function(a,g,p){var t=a[g];a[g]=function(){var a=Array.prototype.slice.call(arguments),
	g=arguments,l=this;l.proceed=function(){t.apply(l,arguments.length?arguments:g)};a.unshift(t);a=p.apply(this,a);l.proceed=null;return a}};a.getTZOffset=function(r){var g=a.Date;return 6E4*(g.hcGetTimezoneOffset&&g.hcGetTimezoneOffset(r)||g.hcTimezoneOffset||0)};a.dateFormat=function(r,g,p){if(!a.defined(g)||isNaN(g))return a.defaultOptions.lang.invalidDate||"";r=a.pick(r,"%Y-%m-%d %H:%M:%S");var t=a.Date,v=new t(g-a.getTZOffset(g)),u=v[t.hcGetHours](),l=v[t.hcGetDay](),e=v[t.hcGetDate](),k=v[t.hcGetMonth](),
	f=v[t.hcGetFullYear](),d=a.defaultOptions.lang,x=d.weekdays,C=d.shortWeekdays,c=a.pad,t=a.extend({a:C?C[l]:x[l].substr(0,3),A:x[l],d:c(e),e:c(e,2," "),w:l,b:d.shortMonths[k],B:d.months[k],m:c(k+1),y:f.toString().substr(2,2),Y:f,H:c(u),k:u,I:c(u%12||12),l:u%12||12,M:c(v[t.hcGetMinutes]()),p:12>u?"AM":"PM",P:12>u?"am":"pm",S:c(v.getSeconds()),L:c(Math.round(g%1E3),3)},a.dateFormats);a.objectEach(t,function(a,f){for(;-1!==r.indexOf("%"+f);)r=r.replace("%"+f,"function"===typeof a?a(g):a)});return p?r.substr(0,
	1).toUpperCase()+r.substr(1):r};a.formatSingle=function(r,g){var p=/\.([0-9])/,t=a.defaultOptions.lang;/f$/.test(r)?(p=(p=r.match(p))?p[1]:-1,null!==g&&(g=a.numberFormat(g,p,t.decimalPoint,-1<r.indexOf(",")?t.thousandsSep:""))):g=a.dateFormat(r,g);return g};a.format=function(r,g){for(var p="{",t=!1,v,u,l,e,k=[],f;r;){p=r.indexOf(p);if(-1===p)break;v=r.slice(0,p);if(t){v=v.split(":");u=v.shift().split(".");e=u.length;f=g;for(l=0;l<e;l++)f=f[u[l]];v.length&&(f=a.formatSingle(v.join(":"),f));k.push(f)}else k.push(v);
	r=r.slice(p+1);p=(t=!t)?"}":"{"}k.push(r);return k.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(r,g,p,t,v){var u,l=r;p=a.pick(p,1);u=r/p;g||(g=v?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===t&&(1===p?g=a.grep(g,function(a){return 0===a%1}):.1>=p&&(g=[1/p])));for(t=0;t<g.length&&!(l=g[t],v&&l*p>=r||!v&&u<=(g[t]+(g[t+1]||g[t]))/2);t++);return l=a.correctFloat(l*p,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=
	function(a,g){var p=a.length,t,v;for(v=0;v<p;v++)a[v].safeI=v;a.sort(function(a,l){t=g(a,l);return 0===t?a.safeI-l.safeI:t});for(v=0;v<p;v++)delete a[v].safeI};a.arrayMin=function(a){for(var g=a.length,p=a[0];g--;)a[g]<p&&(p=a[g]);return p};a.arrayMax=function(a){for(var g=a.length,p=a[0];g--;)a[g]>p&&(p=a[g]);return p};a.destroyObjectProperties=function(r,g){a.objectEach(r,function(a,t){a&&a!==g&&a.destroy&&a.destroy();delete r[t]})};a.discardElement=function(r){var g=a.garbageBin;g||(g=a.createElement("div"));
	r&&g.appendChild(r);g.innerHTML=""};a.correctFloat=function(a,g){return parseFloat(a.toPrecision(g||14))};a.setAnimation=function(r,g){g.renderer.globalAnimation=a.pick(r,g.options.chart.animation,!0)};a.animObject=function(r){return a.isObject(r)?a.merge(r):{duration:r?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(r,g,p,t){r=+r||0;g=+g;var v=a.defaultOptions.lang,u=(r.toString().split(".")[1]||"").split("e")[0].length,
	l,e,k=r.toString().split("e");-1===g?g=Math.min(u,20):a.isNumber(g)||(g=2);e=(Math.abs(k[1]?k[0]:r)+Math.pow(10,-Math.max(g,u)-1)).toFixed(g);u=String(a.pInt(e));l=3<u.length?u.length%3:0;p=a.pick(p,v.decimalPoint);t=a.pick(t,v.thousandsSep);r=(0>r?"-":"")+(l?u.substr(0,l)+t:"");r+=u.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+t);g&&(r+=p+e.slice(-g));k[1]&&(r+="e"+k[1]);return r};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(r,g,p){if("width"===g)return Math.min(r.offsetWidth,
	r.scrollWidth)-a.getStyle(r,"padding-left")-a.getStyle(r,"padding-right");if("height"===g)return Math.min(r.offsetHeight,r.scrollHeight)-a.getStyle(r,"padding-top")-a.getStyle(r,"padding-bottom");if(r=E.getComputedStyle(r,void 0))r=r.getPropertyValue(g),a.pick(p,!0)&&(r=a.pInt(r));return r};a.inArray=function(a,g){return g.indexOf?g.indexOf(a):[].indexOf.call(g,a)};a.grep=function(a,g){return[].filter.call(a,g)};a.find=function(a,g){return[].find.call(a,g)};a.map=function(a,g){for(var p=[],t=0,v=
	a.length;t<v;t++)p[t]=g.call(a[t],a[t],t,a);return p};a.offset=function(a){var g=G.documentElement;a=a.getBoundingClientRect();return{top:a.top+(E.pageYOffset||g.scrollTop)-(g.clientTop||0),left:a.left+(E.pageXOffset||g.scrollLeft)-(g.clientLeft||0)}};a.stop=function(a,g){for(var p=D.length;p--;)D[p].elem!==a||g&&g!==D[p].prop||(D[p].stopped=!0)};a.each=function(a,g,p){return Array.prototype.forEach.call(a,g,p)};a.objectEach=function(a,g,p){for(var t in a)a.hasOwnProperty(t)&&g.call(p,a[t],t,a)};
	a.addEvent=function(r,g,p){function t(a){a.target=a.srcElement||E;p.call(r,a)}var v=r.hcEvents=r.hcEvents||{};r.addEventListener?r.addEventListener(g,p,!1):r.attachEvent&&(r.hcEventsIE||(r.hcEventsIE={}),p.hcGetKey||(p.hcGetKey=a.uniqueKey()),r.hcEventsIE[p.hcGetKey]=t,r.attachEvent("on"+g,t));v[g]||(v[g]=[]);v[g].push(p);return function(){a.removeEvent(r,g,p)}};a.removeEvent=function(r,g,p){function t(a,f){r.removeEventListener?r.removeEventListener(a,f,!1):r.attachEvent&&(f=r.hcEventsIE[f.hcGetKey],
	r.detachEvent("on"+a,f))}function v(){var e,f;r.nodeName&&(g?(e={},e[g]=!0):e=l,a.objectEach(e,function(a,e){if(l[e])for(f=l[e].length;f--;)t(e,l[e][f])}))}var u,l=r.hcEvents,e;l&&(g?(u=l[g]||[],p?(e=a.inArray(p,u),-1<e&&(u.splice(e,1),l[g]=u),t(g,p)):(v(),l[g]=[])):(v(),r.hcEvents={}))};a.fireEvent=function(r,g,p,t){var v;v=r.hcEvents;var u,l;p=p||{};if(G.createEvent&&(r.dispatchEvent||r.fireEvent))v=G.createEvent("Events"),v.initEvent(g,!0,!0),a.extend(v,p),r.dispatchEvent?r.dispatchEvent(v):r.fireEvent(g,
	v);else if(v)for(v=v[g]||[],u=v.length,p.target||a.extend(p,{preventDefault:function(){p.defaultPrevented=!0},target:r,type:g}),g=0;g<u;g++)(l=v[g])&&!1===l.call(r,p)&&p.preventDefault();t&&!p.defaultPrevented&&t(p)};a.animate=function(r,g,p){var t,v="",u,l,e;a.isObject(p)||(e=arguments,p={duration:e[2],easing:e[3],complete:e[4]});a.isNumber(p.duration)||(p.duration=400);p.easing="function"===typeof p.easing?p.easing:Math[p.easing]||Math.easeInOutSine;p.curAnim=a.merge(g);a.objectEach(g,function(e,
	f){a.stop(r,f);l=new a.Fx(r,p,f);u=null;"d"===f?(l.paths=l.initPath(r,r.d,g.d),l.toD=g.d,t=0,u=1):r.attr?t=r.attr(f):(t=parseFloat(a.getStyle(r,f))||0,"opacity"!==f&&(v="px"));u||(u=e);u&&u.match&&u.match("px")&&(u=u.replace(/px/g,""));l.run(t,u,v)})};a.seriesType=function(r,g,p,t,v){var u=a.getOptions(),l=a.seriesTypes;u.plotOptions[r]=a.merge(u.plotOptions[g],p);l[r]=a.extendClass(l[g]||function(){},t);l[r].prototype.type=r;v&&(l[r].prototype.pointClass=a.extendClass(a.Point,v));return l[r]};a.uniqueKey=
	function(){var a=Math.random().toString(36).substring(2,9),g=0;return function(){return"highcharts-"+a+"-"+g++}}();E.jQuery&&(E.jQuery.fn.highcharts=function(){var r=[].slice.call(arguments);if(this[0])return r[0]?(new (a[a.isString(r[0])?r.shift():"Chart"])(this[0],r[0],r[1]),this):B[a.attr(this[0],"data-highcharts-chart")]});G&&!G.defaultView&&(a.getStyle=function(r,g){var p={width:"clientWidth",height:"clientHeight"}[g];if(r.style[g])return a.pInt(r.style[g]);"opacity"===g&&(g="filter");if(p)return r.style.zoom=
	1,Math.max(r[p]-2*a.getStyle(r,"padding"),0);r=r.currentStyle[g.replace(/\-(\w)/g,function(a,g){return g.toUpperCase()})];"filter"===g&&(r=r.replace(/alpha\(opacity=([0-9]+)\)/,function(a,g){return g/100}));return""===r?1:a.pInt(r)});Array.prototype.forEach||(a.each=function(a,g,p){for(var t=0,v=a.length;t<v;t++)if(!1===g.call(p,a[t],t,a))return t});Array.prototype.indexOf||(a.inArray=function(a,g){var p,t=0;if(g)for(p=g.length;t<p;t++)if(g[t]===a)return t;return-1});Array.prototype.filter||(a.grep=
	function(a,g){for(var p=[],t=0,v=a.length;t<v;t++)g(a[t],t)&&p.push(a[t]);return p});Array.prototype.find||(a.find=function(a,g){var p,t=a.length;for(p=0;p<t;p++)if(g(a[p],p))return a[p]})})(M);(function(a){var D=a.each,B=a.isNumber,G=a.map,E=a.merge,r=a.pInt;a.Color=function(g){if(!(this instanceof a.Color))return new a.Color(g);this.init(g)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[r(a[1]),
	r(a[2]),r(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[r(a[1]),r(a[2]),r(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(g){var p,t,v,u;if((this.input=g=this.names[g&&g.toLowerCase?g.toLowerCase():""]||g)&&g.stops)this.stops=G(g.stops,function(l){return new a.Color(l[1])});else if(g&&"#"===g.charAt()&&(p=g.length,g=parseInt(g.substr(1),16),7===p?t=[(g&16711680)>>16,(g&65280)>>
	8,g&255,1]:4===p&&(t=[(g&3840)>>4|(g&3840)>>8,(g&240)>>4|g&240,(g&15)<<4|g&15,1])),!t)for(v=this.parsers.length;v--&&!t;)u=this.parsers[v],(p=u.regex.exec(g))&&(t=u.parse(p));this.rgba=t||[]},get:function(a){var g=this.input,t=this.rgba,v;this.stops?(v=E(g),v.stops=[].concat(v.stops),D(this.stops,function(g,l){v.stops[l]=[v.stops[l][0],g.get(a)]})):v=t&&B(t[0])?"rgb"===a||!a&&1===t[3]?"rgb("+t[0]+","+t[1]+","+t[2]+")":"a"===a?t[3]:"rgba("+t.join(",")+")":g;return v},brighten:function(a){var g,t=this.rgba;
	if(this.stops)D(this.stops,function(g){g.brighten(a)});else if(B(a)&&0!==a)for(g=0;3>g;g++)t[g]+=r(255*a),0>t[g]&&(t[g]=0),255<t[g]&&(t[g]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,p){var g,v;a.rgba.length?(g=this.rgba,a=a.rgba,v=1!==a[3]||1!==g[3],a=(v?"rgba(":"rgb(")+Math.round(a[0]+(g[0]-a[0])*(1-p))+","+Math.round(a[1]+(g[1]-a[1])*(1-p))+","+Math.round(a[2]+(g[2]-a[2])*(1-p))+(v?","+(a[3]+(g[3]-a[3])*(1-p)):"")+")"):a=a.input||"none";return a}};a.color=
	function(g){return new a.Color(g)}})(M);(function(a){var D,B,G=a.addEvent,E=a.animate,r=a.attr,g=a.charts,p=a.color,t=a.css,v=a.createElement,u=a.defined,l=a.deg2rad,e=a.destroyObjectProperties,k=a.doc,f=a.each,d=a.extend,x=a.erase,C=a.grep,c=a.hasTouch,q=a.inArray,I=a.isArray,m=a.isFirefox,J=a.isMS,b=a.isObject,z=a.isString,K=a.isWebKit,y=a.merge,A=a.noop,n=a.objectEach,H=a.pick,h=a.pInt,w=a.removeEvent,P=a.stop,L=a.svg,Q=a.SVG_NS,N=a.symbolSizes,O=a.win;D=a.SVGElement=function(){return this};d(D.prototype,
	{opacity:1,SVG_NS:Q,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,h){this.element="span"===h?v(h):k.createElementNS(this.SVG_NS,h);this.renderer=a},animate:function(F,h,b){h=a.animObject(H(h,this.renderer.globalAnimation,!0));0!==h.duration?(b&&(h.complete=b),E(this,F,h)):(this.attr(F,null,b),h.step&&h.step.call(this));return this},colorGradient:function(F,h,b){var w=this.renderer,
	m,d,c,e,k,L,R,z,q,A,H=[],x;F.radialGradient?d="radialGradient":F.linearGradient&&(d="linearGradient");d&&(c=F[d],k=w.gradients,R=F.stops,A=b.radialReference,I(c)&&(F[d]=c={x1:c[0],y1:c[1],x2:c[2],y2:c[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===d&&A&&!u(c.gradientUnits)&&(e=c,c=y(c,w.getRadialAttr(A,e),{gradientUnits:"userSpaceOnUse"})),n(c,function(a,F){"id"!==F&&H.push(F,a)}),n(R,function(a){H.push(a)}),H=H.join(","),k[H]?A=k[H].attr("id"):(c.id=A=a.uniqueKey(),k[H]=L=w.createElement(d).attr(c).add(w.defs),
	L.radAttr=e,L.stops=[],f(R,function(F){0===F[1].indexOf("rgba")?(m=a.color(F[1]),z=m.get("rgb"),q=m.get("a")):(z=F[1],q=1);F=w.createElement("stop").attr({offset:F[0],"stop-color":z,"stop-opacity":q}).add(L);L.stops.push(F)})),x="url("+w.url+"#"+A+")",b.setAttribute(h,x),b.gradient=H,F.toString=function(){return x})},applyTextOutline:function(F){var h=this.element,b,n,w,m,d;-1!==F.indexOf("contrast")&&(F=F.replace(/contrast/g,this.renderer.getContrast(h.style.fill)));F=F.split(" ");n=F[F.length-1];
	if((w=F[0])&&"none"!==w&&a.svg){this.fakeTS=!0;F=[].slice.call(h.getElementsByTagName("tspan"));this.ySetter=this.xSetter;w=w.replace(/(^[\d\.]+)(.*?)$/g,function(a,F,h){return 2*F+h});for(d=F.length;d--;)b=F[d],"highcharts-text-outline"===b.getAttribute("class")&&x(F,h.removeChild(b));m=h.firstChild;f(F,function(a,F){0===F&&(a.setAttribute("x",h.getAttribute("x")),F=h.getAttribute("y"),a.setAttribute("y",F||0),null===F&&h.setAttribute("y",0));a=a.cloneNode(1);r(a,{"class":"highcharts-text-outline",
	fill:n,stroke:n,"stroke-width":w,"stroke-linejoin":"round"});h.insertBefore(a,m)})}},attr:function(a,h,b,w){var F,m=this.element,d,f=this,c,y;"string"===typeof a&&void 0!==h&&(F=a,a={},a[F]=h);"string"===typeof a?f=(this[a+"Getter"]||this._defaultGetter).call(this,a,m):(n(a,function(F,h){c=!1;w||P(this,h);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(h)&&(d||(this.symbolAttr(a),d=!0),c=!0);!this.rotation||"x"!==h&&"y"!==h||(this.doTransform=!0);c||(y=this[h+"Setter"]||
	this._defaultSetter,y.call(this,F,h,m),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(h)&&this.updateShadows(h,F,y))},this),this.afterSetters());b&&b();return f},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,h,b){for(var F=this.shadows,w=F.length;w--;)b.call(F[w],"height"===a?Math.max(h-(F[w].cutHeight||0),0):"d"===a?this.d:h,a,F[w])},addClass:function(a,h){var F=this.attr("class")||"";-1===F.indexOf(a)&&
	(h||(a=(F+(F?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==q(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var h=this;f("x y r start end width height innerR anchorX anchorY".split(" "),function(F){h[F]=H(a[F],h[F])});h.attr({d:h.renderer.symbols[h.symbolName](h.x,h.y,h.width,h.height,h)})},clip:function(a){return this.attr("clip-path",a?"url("+
	this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,h){var F=this,b={},w;h=h||a.strokeWidth||0;w=Math.round(h)%2/2;a.x=Math.floor(a.x||F.x||0)+w;a.y=Math.floor(a.y||F.y||0)+w;a.width=Math.floor((a.width||F.width||0)-2*w);a.height=Math.floor((a.height||F.height||0)-2*w);u(a.strokeWidth)&&(a.strokeWidth=h);n(a,function(a,h){F[h]!==a&&(F[h]=b[h]=a)});return b},css:function(a){var F=this.styles,b={},w=this.element,m,c="",f,y=!F,e=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);
	F&&n(a,function(a,h){a!==F[h]&&(b[h]=a,y=!0)});y&&(F&&(a=d(F,b)),m=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===w.nodeName.toLowerCase()&&h(a.width),this.styles=a,m&&!L&&this.renderer.forExport&&delete a.width,J&&!L?t(this.element,a):(f=function(a,h){return"-"+h.toLowerCase()},n(a,function(a,h){-1===q(h,e)&&(c+=h.replace(/([A-Z])/g,f)+":"+a+";")}),c&&r(w,"style",c)),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));
	return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,h){var F=this,b=F.element;c&&"click"===a?(b.ontouchstart=function(a){F.touchEventFired=Date.now();a.preventDefault();h.call(b,a)},b.onclick=function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(F.touchEventFired||0))&&h.call(b,a)}):b["on"+a]=h;return this},setRadialReference:function(a){var h=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;h&&h.radAttr&&h.animate(this.renderer.getRadialAttr(a,
	h.radAttr));return this},translate:function(a,h){return this.attr({translateX:a,translateY:h})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,h=this.translateY||0,b=this.scaleX,w=this.scaleY,n=this.inverted,m=this.rotation,d=this.element;n&&(a+=this.width,h+=this.height);a=["translate("+a+","+h+")"];n?a.push("rotate(90) scale(-1,1)"):m&&a.push("rotate("+m+" "+(d.getAttribute("x")||0)+" "+(d.getAttribute("y")||0)+")");(u(b)||
	u(w))&&a.push("scale("+H(b,1)+" "+H(w,1)+")");a.length&&d.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,h,b){var F,w,n,m,d={};w=this.renderer;n=w.alignedObjects;var c,f;if(a){if(this.alignOptions=a,this.alignByTranslate=h,!b||z(b))this.alignTo=F=b||"renderer",x(n,this),n.push(this),b=null}else a=this.alignOptions,h=this.alignByTranslate,F=this.alignTo;b=H(b,w[F],w);F=a.align;w=a.verticalAlign;n=(b.x||0)+(a.x||
	0);m=(b.y||0)+(a.y||0);"right"===F?c=1:"center"===F&&(c=2);c&&(n+=(b.width-(a.width||0))/c);d[h?"translateX":"x"]=Math.round(n);"bottom"===w?f=1:"middle"===w&&(f=2);f&&(m+=(b.height-(a.height||0))/f);d[h?"translateY":"y"]=Math.round(m);this[this.placed?"animate":"attr"](d);this.placed=!0;this.alignAttr=d;return this},getBBox:function(a,h){var F,b=this.renderer,w,n=this.element,m=this.styles,c,y=this.textStr,e,k=b.cache,L=b.cacheKeys,z;h=H(h,this.rotation);w=h*l;c=m&&m.fontSize;void 0!==y&&(z=y.toString(),
	-1===z.indexOf("\x3c")&&(z=z.replace(/[0-9]/g,"0")),z+=["",h||0,c,m&&m.width,m&&m.textOverflow].join());z&&!a&&(F=k[z]);if(!F){if(n.namespaceURI===this.SVG_NS||b.forExport){try{(e=this.fakeTS&&function(a){f(n.querySelectorAll(".highcharts-text-outline"),function(h){h.style.display=a})})&&e("none"),F=n.getBBox?d({},n.getBBox()):{width:n.offsetWidth,height:n.offsetHeight},e&&e("")}catch(V){}if(!F||0>F.width)F={width:0,height:0}}else F=this.htmlGetBBox();b.isSVG&&(a=F.width,b=F.height,m&&"11px"===m.fontSize&&
	17===Math.round(b)&&(F.height=b=14),h&&(F.width=Math.abs(b*Math.sin(w))+Math.abs(a*Math.cos(w)),F.height=Math.abs(b*Math.cos(w))+Math.abs(a*Math.sin(w))));if(z&&0<F.height){for(;250<L.length;)delete k[L.shift()];k[z]||L.push(z);k[z]=F}}return F},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var h=this;h.animate({opacity:0},{duration:a||150,complete:function(){h.attr({y:-9999})}})},add:function(a){var h=
	this.renderer,F=this.element,b;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&h.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)b=this.zIndexSetter();b||(a?a.element:h.box).appendChild(F);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var h=a.parentNode;h&&h.removeChild(a)},destroy:function(){var a=this,h=a.element||{},b=a.renderer.isSVG&&"SPAN"===h.nodeName&&a.parentGroup,w=h.ownerSVGElement;h.onclick=h.onmouseout=h.onmouseover=h.onmousemove=
	h.point=null;P(a);a.clipPath&&w&&(f(w.querySelectorAll("[clip-path]"),function(h){-1<h.getAttribute("clip-path").indexOf(a.clipPath.element.id+")")&&h.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(w=0;w<a.stops.length;w++)a.stops[w]=a.stops[w].destroy();a.stops=null}a.safeRemoveChild(h);for(a.destroyShadows();b&&b.div&&0===b.div.childNodes.length;)h=b.parentGroup,a.safeRemoveChild(b.div),delete b.div,b=h;a.alignTo&&x(a.renderer.alignedObjects,a);n(a,function(h,b){delete a[b]});
	return null},shadow:function(a,h,b){var F=[],w,n,m=this.element,d,c,f,y;if(!a)this.destroyShadows();else if(!this.shadows){c=H(a.width,3);f=(a.opacity||.15)/c;y=this.parentInverted?"(-1,-1)":"("+H(a.offsetX,1)+", "+H(a.offsetY,1)+")";for(w=1;w<=c;w++)n=m.cloneNode(0),d=2*c+1-2*w,r(n,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":f*w,"stroke-width":d,transform:"translate"+y,fill:"none"}),b&&(r(n,"height",Math.max(r(n,"height")-d,0)),n.cutHeight=d),h?h.element.appendChild(n):m.parentNode.insertBefore(n,
	m),F.push(n);this.shadows=F}return this},destroyShadows:function(){f(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=H(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,h,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[h]!==
	a&&(b.setAttribute(h,a),this[h]=a)},dashstyleSetter:function(a){var b,w=this["stroke-width"];"inherit"===w&&(w=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=h(a[b])*w;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",
	{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,h,b){this[h]=a;b.setAttribute(h,a)},titleSetter:function(a){var h=this.element.getElementsByTagName("title")[0];h||(h=k.createElementNS(this.SVG_NS,"title"),this.element.appendChild(h));h.firstChild&&h.removeChild(h.firstChild);h.appendChild(k.createTextNode(String(H(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,
	h,b){"string"===typeof a?b.setAttribute(h,a):a&&this.colorGradient(a,h,b)},visibilitySetter:function(a,h,b){"inherit"===a?b.removeAttribute(h):this[h]!==a&&b.setAttribute(h,a);this[h]=a},zIndexSetter:function(a,b){var w=this.renderer,n=this.parentGroup,m=(n||w).element||w.box,F,d=this.element,c;F=this.added;var f;u(a)&&(d.zIndex=a,a=+a,this[b]===a&&(F=!1),this[b]=a);if(F){(a=this.zIndex)&&n&&(n.handleZ=!0);b=m.childNodes;for(f=0;f<b.length&&!c;f++)n=b[f],F=n.zIndex,n!==d&&(h(F)>a||!u(a)&&u(F)||0>
	a&&!u(F)&&m!==w.box)&&(m.insertBefore(d,n),c=!0);c||m.appendChild(d)}return c},_defaultSetter:function(a,h,b){b.setAttribute(h,a)}});D.prototype.yGetter=D.prototype.xGetter;D.prototype.translateXSetter=D.prototype.translateYSetter=D.prototype.rotationSetter=D.prototype.verticalAlignSetter=D.prototype.scaleXSetter=D.prototype.scaleYSetter=function(a,h){this[h]=a;this.doTransform=!0};D.prototype["stroke-widthSetter"]=D.prototype.strokeSetter=function(a,h,b){this[h]=a;this.stroke&&this["stroke-width"]?
	(D.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===h&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),this.hasStroke=!1)};B=a.SVGRenderer=function(){this.init.apply(this,arguments)};d(B.prototype,{Element:D,SVG_NS:Q,init:function(a,h,b,w,n,d){var F;w=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(w));F=w.element;a.appendChild(F);-1===a.innerHTML.indexOf("xmlns")&&
	r(F,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=F;this.boxWrapper=w;this.alignedObjects=[];this.url=(m||K)&&k.getElementsByTagName("base").length?O.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(k.createTextNode("Created with Highstock 5.0.14"));this.defs=this.createElement("defs").add();this.allowHTML=d;this.forExport=n;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=
	0;this.setSize(h,b,!1);var c;m&&a.getBoundingClientRect&&(h=function(){t(a,{left:0,top:0});c=a.getBoundingClientRect();t(a,{left:Math.ceil(c.left)-c.left+"px",top:Math.ceil(c.top)-c.top+"px"})},h(),this.unSubPixelFix=G(O,"resize",h))},getStyle:function(a){return this.style=d({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
	this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();e(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var h=new this.Element;h.init(this,a);return h},draw:A,getRadialAttr:function(a,h){return{cx:a[0]-a[2]/2+h.cx*a[2],cy:a[1]-a[2]/2+h.cy*a[2],r:h.r*a[2]}},getSpanWidth:function(a,h){var b=a.getBBox(!0).width;!L&&this.forExport&&(b=this.measureSpanWidth(h.firstChild.data,
	a.styles));return b},applyEllipsis:function(a,h,b,w){var n=a.rotation,m=b,c,d=0,F=b.length,f=function(a){h.removeChild(h.firstChild);a&&h.appendChild(k.createTextNode(a))},y;a.rotation=0;m=this.getSpanWidth(a,h);if(y=m>w){for(;d<=F;)c=Math.ceil((d+F)/2),m=b.substring(0,c)+"\u2026",f(m),m=this.getSpanWidth(a,h),d===F?d=F+1:m>w?F=c-1:d=c;0===F&&f("")}a.rotation=n;return y},buildText:function(a){var b=a.element,w=this,n=w.forExport,m=H(a.textStr,"").toString(),c=-1!==m.indexOf("\x3c"),d=b.childNodes,
	F,y,e,z,q=r(b,"x"),A=a.styles,x=a.textWidth,J=A&&A.lineHeight,l=A&&A.textOutline,P=A&&"ellipsis"===A.textOverflow,g=A&&"nowrap"===A.whiteSpace,K=A&&A.fontSize,I,v,p=d.length,A=x&&!a.added&&this.box,u=function(a){var n;n=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:K||w.style.fontSize||12;return J?h(J):w.fontMetrics(n,a.getAttribute("style")?a:b).h};I=[m,P,g,J,l,K,x].join();if(I!==a.textCache){for(a.textCache=I;p--;)b.removeChild(d[p]);c||l||P||x||-1!==m.indexOf(" ")?(F=/<.*class="([^"]+)".*>/,
	y=/<.*style="([^"]+)".*>/,e=/<.*href="([^"]+)".*>/,A&&A.appendChild(b),m=c?m.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[m],m=C(m,function(a){return""!==a}),f(m,function(h,m){var c,d=0;h=h.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");c=h.split("|||");f(c,function(h){if(""!==
	h||1===c.length){var f={},A=k.createElementNS(w.SVG_NS,"tspan"),H,J;F.test(h)&&(H=h.match(F)[1],r(A,"class",H));y.test(h)&&(J=h.match(y)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),r(A,"style",J));e.test(h)&&!n&&(r(A,"onclick",'location.href\x3d"'+h.match(e)[1]+'"'),t(A,{cursor:"pointer"}));h=(h.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==h){A.appendChild(k.createTextNode(h));d?f.dx=0:m&&null!==q&&(f.x=q);r(A,f);b.appendChild(A);!d&&v&&(!L&&n&&t(A,{display:"block"}),
	r(A,"dy",u(A)));if(x){f=h.replace(/([^\^])-/g,"$1- ").split(" ");H=1<c.length||m||1<f.length&&!g;var l=[],C,R=u(A),K=a.rotation;for(P&&(z=w.applyEllipsis(a,A,h,x));!P&&H&&(f.length||l.length);)a.rotation=0,C=w.getSpanWidth(a,A),h=C>x,void 0===z&&(z=h),h&&1!==f.length?(A.removeChild(A.firstChild),l.unshift(f.pop())):(f=l,l=[],f.length&&!g&&(A=k.createElementNS(Q,"tspan"),r(A,{dy:R,x:q}),J&&r(A,"style",J),b.appendChild(A)),C>x&&(x=C)),f.length&&A.appendChild(k.createTextNode(f.join(" ").replace(/- /g,
	"-")));a.rotation=K}d++}}});v=v||b.childNodes.length}),z&&a.attr("title",a.textStr),A&&A.removeChild(b),l&&a.applyTextOutline&&a.applyTextOutline(l)):b.appendChild(k.createTextNode(m.replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=p(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,h,b,w,n,m,c,f,e){var F=this.label(a,h,b,e,null,null,null,null,"button"),A=0;F.attr(y({padding:8,r:2},n));var k,z,L,q;n=y({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,
	style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},n);k=n.style;delete n.style;m=y(n,{fill:"#e6e6e6"},m);z=m.style;delete m.style;c=y(n,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},c);L=c.style;delete c.style;f=y(n,{style:{color:"#cccccc"}},f);q=f.style;delete f.style;G(F.element,J?"mouseover":"mouseenter",function(){3!==A&&F.setState(1)});G(F.element,J?"mouseout":"mouseleave",function(){3!==A&&F.setState(A)});F.setState=function(a){1!==a&&(F.state=A=a);F.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+
	["normal","hover","pressed","disabled"][a||0]);F.attr([n,m,c,f][a||0]).css([k,z,L,q][a||0])};F.attr(n).css(d({cursor:"default"},k));return F.on("click",function(a){3!==A&&w.call(F,a)})},crispLine:function(a,h){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-h%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+h%2/2);return a},path:function(a){var h={fill:"none"};I(a)?h.d=a:b(a)&&d(h,a);return this.createElement("path").attr(h)},circle:function(a,h,w){a=b(a)?a:{x:a,y:h,r:w};h=this.createElement("circle");h.xSetter=
	h.ySetter=function(a,h,b){b.setAttribute("c"+h,a)};return h.attr(a)},arc:function(a,h,w,n,m,c){b(a)?(n=a,h=n.y,w=n.r,a=n.x):n={innerR:n,start:m,end:c};a=this.symbol("arc",a,h,w,w,n);a.r=w;return a},rect:function(a,h,w,n,m,c){m=b(a)?a.r:m;var d=this.createElement("rect");a=b(a)?a:void 0===a?{}:{x:a,y:h,width:Math.max(w,0),height:Math.max(n,0)};void 0!==c&&(a.strokeWidth=c,a=d.crisp(a));a.fill="none";m&&(a.r=m);d.rSetter=function(a,h,b){r(b,{rx:a,ry:a})};return d.attr(a)},setSize:function(a,h,b){var w=
	this.alignedObjects,n=w.length;this.width=a;this.height=h;for(this.boxWrapper.animate({width:a,height:h},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:H(b,!0)?void 0:0});n--;)w[n].align()},g:function(a){var h=this.createElement("g");return a?h.attr({"class":"highcharts-"+a}):h},image:function(a,h,b,w,n){var m={preserveAspectRatio:"none"};1<arguments.length&&d(m,{x:h,y:b,width:w,height:n});m=this.createElement("image").attr(m);m.element.setAttributeNS?
	m.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):m.element.setAttribute("hc-svg-href",a);return m},symbol:function(a,h,b,w,n,m){var c=this,y,F=/^url\((.*?)\)$/,e=F.test(a),A=!e&&(this.symbols[a]?a:"circle"),z=A&&this.symbols[A],L=u(h)&&z&&z.call(this.symbols,Math.round(h),Math.round(b),w,n,m),q,x;z?(y=this.path(L),y.attr("fill","none"),d(y,{symbolName:A,x:h,y:b,width:w,height:n}),m&&d(y,m)):e&&(q=a.match(F)[1],y=this.image(q),y.imgwidth=H(N[q]&&N[q].width,m&&m.width),y.imgheight=
	H(N[q]&&N[q].height,m&&m.height),x=function(){y.attr({width:y.width,height:y.height})},f(["width","height"],function(a){y[a+"Setter"]=function(a,h){var b={},w=this["img"+h],n="width"===h?"translateX":"translateY";this[h]=a;u(w)&&(this.element&&this.element.setAttribute(h,w),this.alignByTranslate||(b[n]=((this[h]||0)-w)/2,this.attr(b)))}}),u(h)&&y.attr({x:h,y:b}),y.isImg=!0,u(y.imgwidth)&&u(y.imgheight)?x():(y.attr({width:0,height:0}),v("img",{onload:function(){var a=g[c.chartIndex];0===this.width&&
	(t(this,{position:"absolute",top:"-999em"}),k.body.appendChild(this));N[q]={width:this.width,height:this.height};y.imgwidth=this.width;y.imgheight=this.height;y.element&&x();this.parentNode&&this.parentNode.removeChild(this);c.imgCount--;if(!c.imgCount&&a&&a.onload)a.onload()},src:q}),this.imgCount++));return y},symbols:{circle:function(a,h,b,w){return this.arc(a+b/2,h+w/2,b/2,w/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,h,b,w){return["M",a,h,"L",a+b,h,a+b,h+w,a,h+w,"Z"]},triangle:function(a,
	h,b,w){return["M",a+b/2,h,"L",a+b,h+w,a,h+w,"Z"]},"triangle-down":function(a,h,b,w){return["M",a,h,"L",a+b,h,a+b/2,h+w,"Z"]},diamond:function(a,h,b,w){return["M",a+b/2,h,"L",a+b,h+w/2,a+b/2,h+w,a,h+w/2,"Z"]},arc:function(a,h,b,w,n){var m=n.start,c=n.r||b,d=n.r||w||b,f=n.end-.001;b=n.innerR;w=H(n.open,.001>Math.abs(n.end-n.start-2*Math.PI));var y=Math.cos(m),e=Math.sin(m),F=Math.cos(f),f=Math.sin(f);n=.001>n.end-m-Math.PI?0:1;c=["M",a+c*y,h+d*e,"A",c,d,0,n,1,a+c*F,h+d*f];u(b)&&c.push(w?"M":"L",a+b*
	F,h+b*f,"A",b,b,0,n,0,a+b*y,h+b*e);c.push(w?"":"Z");return c},callout:function(a,h,b,w,n){var m=Math.min(n&&n.r||0,b,w),c=m+6,d=n&&n.anchorX;n=n&&n.anchorY;var f;f=["M",a+m,h,"L",a+b-m,h,"C",a+b,h,a+b,h,a+b,h+m,"L",a+b,h+w-m,"C",a+b,h+w,a+b,h+w,a+b-m,h+w,"L",a+m,h+w,"C",a,h+w,a,h+w,a,h+w-m,"L",a,h+m,"C",a,h,a,h,a+m,h];d&&d>b?n>h+c&&n<h+w-c?f.splice(13,3,"L",a+b,n-6,a+b+6,n,a+b,n+6,a+b,h+w-m):f.splice(13,3,"L",a+b,w/2,d,n,a+b,w/2,a+b,h+w-m):d&&0>d?n>h+c&&n<h+w-c?f.splice(33,3,"L",a,n+6,a-6,n,a,n-6,
	a,h+m):f.splice(33,3,"L",a,w/2,d,n,a,w/2,a,h+m):n&&n>w&&d>a+c&&d<a+b-c?f.splice(23,3,"L",d+6,h+w,d,h+w+6,d-6,h+w,a+m,h+w):n&&0>n&&d>a+c&&d<a+b-c&&f.splice(3,3,"L",d-6,h,d,h-6,d+6,h,b-m,h);return f}},clipRect:function(h,b,w,n){var m=a.uniqueKey(),c=this.createElement("clipPath").attr({id:m}).add(this.defs);h=this.rect(h,b,w,n,0).add(c);h.id=m;h.clipPath=c;h.count=0;return h},text:function(a,h,b,w){var n=!L&&this.forExport,m={};if(w&&(this.allowHTML||!this.forExport))return this.html(a,h,b);m.x=Math.round(h||
	0);b&&(m.y=Math.round(b));if(a||0===a)m.text=a;a=this.createElement("text").attr(m);n&&a.css({position:"absolute"});w||(a.xSetter=function(a,h,b){var w=b.getElementsByTagName("tspan"),n,m=b.getAttribute(h),c;for(c=0;c<w.length;c++)n=w[c],n.getAttribute(h)===m&&n.setAttribute(h,a);b.setAttribute(h,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?h(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;
	b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,h,b){var w=a;h&&b&&(w=Math.max(w*Math.cos(h*l),4));return{x:-a/3*Math.sin(h*l),y:w}},label:function(h,b,n,m,c,e,A,k,z){var L=this,q=L.g("button"!==z&&"label"),H=q.text=L.text("",0,0,A).attr({zIndex:1}),x,F,J=0,l=3,C=0,P,g,K,I,t,Q={},v,p,r=/^url\((.*?)\)$/.test(m),R=r,N,U,T,O;z&&q.addClass("highcharts-"+z);R=r;N=function(){return(v||0)%2/2};U=function(){var a=H.element.style,h={};F=(void 0===P||void 0===g||t)&&u(H.textStr)&&
	H.getBBox();q.width=(P||F.width||0)+2*l+C;q.height=(g||F.height||0)+2*l;p=l+L.fontMetrics(a&&a.fontSize,H).b;R&&(x||(q.box=x=L.symbols[m]||r?L.symbol(m):L.rect(),x.addClass(("button"===z?"":"highcharts-label-box")+(z?" highcharts-"+z+"-box":"")),x.add(q),a=N(),h.x=a,h.y=(k?-p:0)+a),h.width=Math.round(q.width),h.height=Math.round(q.height),x.attr(d(h,Q)),Q={})};T=function(){var a=C+l,h;h=k?0:p;u(P)&&F&&("center"===t||"right"===t)&&(a+={center:.5,right:1}[t]*(P-F.width));if(a!==H.x||h!==H.y)H.attr("x",
	a),void 0!==h&&H.attr("y",h);H.x=a;H.y=h};O=function(a,h){x?x.attr(a,h):Q[a]=h};q.onAdd=function(){H.add(q);q.attr({text:h||0===h?h:"",x:b,y:n});x&&u(c)&&q.attr({anchorX:c,anchorY:e})};q.widthSetter=function(h){P=a.isNumber(h)?h:null};q.heightSetter=function(a){g=a};q["text-alignSetter"]=function(a){t=a};q.paddingSetter=function(a){u(a)&&a!==l&&(l=q.padding=a,T())};q.paddingLeftSetter=function(a){u(a)&&a!==C&&(C=a,T())};q.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==J&&(J=a,F&&q.attr({x:K}))};
	q.textSetter=function(a){void 0!==a&&H.textSetter(a);U();T()};q["stroke-widthSetter"]=function(a,h){a&&(R=!0);v=this["stroke-width"]=a;O(h,a)};q.strokeSetter=q.fillSetter=q.rSetter=function(a,h){"r"!==h&&("fill"===h&&a&&(R=!0),q[h]=a);O(h,a)};q.anchorXSetter=function(a,h){c=q.anchorX=a;O(h,Math.round(a)-N()-K)};q.anchorYSetter=function(a,h){e=q.anchorY=a;O(h,a-I)};q.xSetter=function(a){q.x=a;J&&(a-=J*((P||F.width)+2*l));K=Math.round(a);q.attr("translateX",K)};q.ySetter=function(a){I=q.y=Math.round(a);
	q.attr("translateY",I)};var B=q.css;return d(q,{css:function(a){if(a){var h={};a=y(a);f(q.textProps,function(b){void 0!==a[b]&&(h[b]=a[b],delete a[b])});H.css(h)}return B.call(q,a)},getBBox:function(){return{width:F.width+2*l,height:F.height+2*l,x:F.x-l,y:F.y-l}},shadow:function(a){a&&(U(),x&&x.shadow(a));return q},destroy:function(){w(q.element,"mouseenter");w(q.element,"mouseleave");H&&(H=H.destroy());x&&(x=x.destroy());D.prototype.destroy.call(q);q=L=U=T=O=null}})}});a.Renderer=B})(M);(function(a){var D=
	a.attr,B=a.createElement,G=a.css,E=a.defined,r=a.each,g=a.extend,p=a.isFirefox,t=a.isMS,v=a.isWebKit,u=a.pInt,l=a.SVGRenderer,e=a.win,k=a.wrap;g(a.SVGElement.prototype,{htmlCss:function(a){var d=this.element;if(d=a&&"SPAN"===d.tagName&&a.width)delete a.width,this.textWidth=d,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=g(this.styles,a);G(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position=
	"absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,d=this.element,e=this.translateX||0,k=this.translateY||0,c=this.x||0,q=this.y||0,l=this.textAlign||"left",m={left:0,center:.5,right:1}[l],J=this.styles;G(d,{marginLeft:e,marginTop:k});this.shadows&&r(this.shadows,function(a){G(a,{marginLeft:e+1,marginTop:k+1})});this.inverted&&r(d.childNodes,function(b){a.invertChild(b,d)});if("SPAN"===d.tagName){var b=
	this.rotation,z=u(this.textWidth),g=J&&J.whiteSpace,y=[b,l,d.innerHTML,this.textWidth,this.textAlign].join();y!==this.cTT&&(J=a.fontMetrics(d.style.fontSize).b,E(b)&&this.setSpanRotation(b,m,J),G(d,{width:"",whiteSpace:g||"nowrap"}),d.offsetWidth>z&&/[ \-]/.test(d.textContent||d.innerText)&&G(d,{width:z+"px",display:"block",whiteSpace:g||"normal"}),this.getSpanCorrection(d.offsetWidth,J,m,b,l));G(d,{left:c+(this.xCorr||0)+"px",top:q+(this.yCorr||0)+"px"});v&&(J=d.offsetHeight);this.cTT=y}}else this.alignOnAdd=
	!0},setSpanRotation:function(a,d,k){var f={},c=t?"-ms-transform":v?"-webkit-transform":p?"MozTransform":e.opera?"-o-transform":"";f[c]=f.transform="rotate("+a+"deg)";f[c+(p?"Origin":"-origin")]=f.transformOrigin=100*d+"% "+k+"px";G(this.element,f)},getSpanCorrection:function(a,d,e){this.xCorr=-a*e;this.yCorr=-d}});g(l.prototype,{html:function(a,d,e){var f=this.createElement("span"),c=f.element,q=f.renderer,x=q.isSVG,m=function(a,b){r(["opacity","visibility"],function(m){k(a,m+"Setter",function(a,
	m,c,n){a.call(this,m,c,n);b[c]=m})})};f.textSetter=function(a){a!==c.innerHTML&&delete this.bBox;c.innerHTML=this.textStr=a;f.htmlUpdateTransform()};x&&m(f,f.element.style);f.xSetter=f.ySetter=f.alignSetter=f.rotationSetter=function(a,b){"align"===b&&(b="textAlign");f[b]=a;f.htmlUpdateTransform()};f.attr({text:a,x:Math.round(d),y:Math.round(e)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});c.style.whiteSpace="nowrap";f.css=f.htmlCss;x&&(f.add=function(a){var b,
	d=q.box.parentNode,e=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)e.push(a),a=a.parentGroup;r(e.reverse(),function(a){var c,n=D(a.element,"class");n&&(n={className:n});b=a.div=a.div||B("div",n,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||d);c=b.style;g(a,{classSetter:function(a){this.element.setAttribute("class",a);b.className=a},on:function(){e[0].div&&f.on.apply({element:e[0].div},
	arguments);return a},translateXSetter:function(b,h){c.left=b+"px";a[h]=b;a.doTransform=!0},translateYSetter:function(b,h){c.top=b+"px";a[h]=b;a.doTransform=!0}});m(a,c)})}}else b=d;b.appendChild(c);f.added=!0;f.alignOnAdd&&f.htmlUpdateTransform();return f});return f}})})(M);(function(a){var D,B,G=a.createElement,E=a.css,r=a.defined,g=a.deg2rad,p=a.discardElement,t=a.doc,v=a.each,u=a.erase,l=a.extend;D=a.extendClass;var e=a.isArray,k=a.isNumber,f=a.isObject,d=a.merge;B=a.noop;var x=a.pick,C=a.pInt,
	c=a.SVGElement,q=a.SVGRenderer,I=a.win;a.svg||(B={docMode8:t&&8===t.documentMode,init:function(a,c){var b=["\x3c",c,' filled\x3d"f" stroked\x3d"f"'],m=["position: ","absolute",";"],d="div"===c;("shape"===c||d)&&m.push("left:0;top:0;width:1px;height:1px;");m.push("visibility: ",d?"hidden":"visible");b.push(' style\x3d"',m.join(""),'"/\x3e');c&&(b=d||"span"===c||"img"===c?b.join(""):a.prepVML(b),this.element=G(b));this.renderer=a},add:function(a){var m=this.renderer,b=this.element,c=m.box,d=a&&a.inverted,
	c=a?a.element||a:c;a&&(this.parentGroup=a);d&&m.invertChild(b,c);c.appendChild(b);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:c.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,c=Math.cos(a*g),b=Math.sin(a*g);E(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",c,", M12\x3d",-b,", M21\x3d",b,", M22\x3d",
	c,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,c,b,d,f){var m=d?Math.cos(d*g):1,e=d?Math.sin(d*g):0,n=x(this.elemHeight,this.element.offsetHeight),q;this.xCorr=0>m&&-a;this.yCorr=0>e&&-n;q=0>m*e;this.xCorr+=e*c*(q?1-b:b);this.yCorr-=m*c*(d?q?b:1-b:1);f&&"left"!==f&&(this.xCorr-=a*b*(0>m?-1:1),d&&(this.yCorr-=n*b*(0>e?-1:1)),E(this.element,{textAlign:f}))},pathToVML:function(a){for(var m=a.length,b=[];m--;)k(a[m])?b[m]=Math.round(10*a[m])-5:"Z"===a[m]?b[m]="x":
	(b[m]=a[m],!a.isArc||"wa"!==a[m]&&"at"!==a[m]||(b[m+5]===b[m+7]&&(b[m+7]+=a[m+7]>a[m+5]?1:-1),b[m+6]===b[m+8]&&(b[m+8]+=a[m+8]>a[m+6]?1:-1)));return b.join(" ")||"x"},clip:function(a){var m=this,b;a?(b=a.members,u(b,m),b.push(m),m.destroyClip=function(){u(b,m)},a=a.getCSS(m)):(m.destroyClip&&m.destroyClip(),a={clip:m.docMode8?"inherit":"rect(auto)"});return m.css(a)},css:c.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&p(a)},destroy:function(){this.destroyClip&&this.destroyClip();return c.prototype.destroy.apply(this)},
	on:function(a,c){this.element["on"+a]=function(){var a=I.event;a.target=a.srcElement;c(a)};return this},cutOffPath:function(a,c){var b;a=a.split(/[ ,]/);b=a.length;if(9===b||11===b)a[b-4]=a[b-2]=C(a[b-2])-10*c;return a.join(" ")},shadow:function(a,c,b){var m=[],d,f=this.element,e=this.renderer,n,q=f.style,h,w=f.path,k,L,l,J;w&&"string"!==typeof w.value&&(w="x");L=w;if(a){l=x(a.width,3);J=(a.opacity||.15)/l;for(d=1;3>=d;d++)k=2*l+1-2*d,b&&(L=this.cutOffPath(w.value,k+.5)),h=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',
	k,'" filled\x3d"false" path\x3d"',L,'" coordsize\x3d"10 10" style\x3d"',f.style.cssText,'" /\x3e'],n=G(e.prepVML(h),null,{left:C(q.left)+x(a.offsetX,1),top:C(q.top)+x(a.offsetY,1)}),b&&(n.cutOff=k+1),h=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',J*d,'"/\x3e'],G(e.prepVML(h),null,null,n),c?c.element.appendChild(n):f.parentNode.insertBefore(n,f),m.push(n);this.shadows=m}return this},updateShadows:B,setAttr:function(a,c){this.docMode8?this.element[a]=c:this.element.setAttribute(a,c)},
	classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,c,b){(b.getElementsByTagName("stroke")[0]||G(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,b))[c]=a||"solid";this[c]=a},dSetter:function(a,c,b){var m=this.shadows;a=a||[];this.d=a.join&&a.join(" ");b.path=a=this.pathToVML(a);if(m)for(b=m.length;b--;)m[b].path=m[b].cutOff?this.cutOffPath(a,m[b].cutOff):a;this.setAttr(c,a)},fillSetter:function(a,c,b){var m=b.nodeName;"SPAN"===m?b.style.color=a:"IMG"!==
	m&&(b.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,b,c,this)))},"fill-opacitySetter":function(a,c,b){G(this.renderer.prepVML(["\x3c",c.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,b)},opacitySetter:B,rotationSetter:function(a,c,b){b=b.style;this[c]=b[c]=a;b.left=-Math.round(Math.sin(a*g)+1)+"px";b.top=Math.round(Math.cos(a*g))+"px"},strokeSetter:function(a,c,b){this.setAttr("strokecolor",this.renderer.color(a,b,c,this))},"stroke-widthSetter":function(a,c,b){b.stroked=!!a;
	this[c]=a;k(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,c){this.setAttr(c,a)},visibilitySetter:function(a,c,b){"inherit"===a&&(a="visible");this.shadows&&v(this.shadows,function(b){b.style[c]=a});"DIV"===b.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(b.style[c]=a?"visible":"hidden"),c="top");b.style[c]=a},xSetter:function(a,c,b){this[c]=a;"x"===c?c="left":"y"===c&&(c="top");this.updateClipping?(this[c]=a,this.updateClipping()):b.style[c]=a},zIndexSetter:function(a,
	c,b){b.style[c]=a}},B["stroke-opacitySetter"]=B["fill-opacitySetter"],a.VMLElement=B=D(c,B),B.prototype.ySetter=B.prototype.widthSetter=B.prototype.heightSetter=B.prototype.xSetter,B={Element:B,isIE8:-1<I.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,c,b){var m,d;this.alignedObjects=[];m=this.createElement("div").css({position:"relative"});d=m.element;a.appendChild(m.element);this.isVML=!0;this.box=d;this.boxWrapper=m;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(c,
	b,!1);if(!t.namespaces.hcv){t.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{t.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(y){t.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,c,b,d){var m=this.createElement(),y=f(a);return l(m,{members:[],
	count:0,left:(y?a.x:a)+1,top:(y?a.y:c)+1,width:(y?a.width:b)-1,height:(y?a.height:d)-1,getCSS:function(a){var b=a.element,c=b.nodeName,h=a.inverted,w=this.top-("shape"===c?b.offsetTop:0),m=this.left,b=m+this.width,d=w+this.height,w={clip:"rect("+Math.round(h?m:w)+"px,"+Math.round(h?d:b)+"px,"+Math.round(h?b:d)+"px,"+Math.round(h?w:m)+"px)"};!h&&a.docMode8&&"DIV"===c&&l(w,{width:b+"px",height:d+"px"});return w},updateClipping:function(){v(m.members,function(a){a.element&&a.css(m.getCSS(a))})}})},color:function(c,
	d,b,f){var m=this,y,e=/^rgba/,n,q,h="none";c&&c.linearGradient?q="gradient":c&&c.radialGradient&&(q="pattern");if(q){var w,k,L=c.linearGradient||c.radialGradient,x,z,l,F,C,g="";c=c.stops;var J,t=[],I=function(){n=['\x3cfill colors\x3d"'+t.join(",")+'" opacity\x3d"',l,'" o:opacity2\x3d"',z,'" type\x3d"',q,'" ',g,'focus\x3d"100%" method\x3d"any" /\x3e'];G(m.prepVML(n),null,null,d)};x=c[0];J=c[c.length-1];0<x[0]&&c.unshift([0,x[1]]);1>J[0]&&c.push([1,J[1]]);v(c,function(h,b){e.test(h[1])?(y=a.color(h[1]),
	w=y.get("rgb"),k=y.get("a")):(w=h[1],k=1);t.push(100*h[0]+"% "+w);b?(l=k,F=w):(z=k,C=w)});if("fill"===b)if("gradient"===q)b=L.x1||L[0]||0,c=L.y1||L[1]||0,x=L.x2||L[2]||0,L=L.y2||L[3]||0,g='angle\x3d"'+(90-180*Math.atan((L-c)/(x-b))/Math.PI)+'"',I();else{var h=L.r,p=2*h,u=2*h,r=L.cx,B=L.cy,D=d.radialReference,E,h=function(){D&&(E=f.getBBox(),r+=(D[0]-E.x)/E.width-.5,B+=(D[1]-E.y)/E.height-.5,p*=D[2]/E.width,u*=D[2]/E.height);g='src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+p+","+
	u+'" origin\x3d"0.5,0.5" position\x3d"'+r+","+B+'" color2\x3d"'+C+'" ';I()};f.added?h():f.onAdd=h;h=F}else h=w}else e.test(c)&&"IMG"!==d.tagName?(y=a.color(c),f[b+"-opacitySetter"](y.get("a"),b,d),h=y.get("rgb")):(h=d.getElementsByTagName(b),h.length&&(h[0].opacity=1,h[0].type="solid"),h=c);return h},prepVML:function(a){var c=this.isIE8;a=a.join("");c?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):
	a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:q.prototype.html,path:function(a){var c={coordsize:"10 10"};e(a)?c.d=a:f(a)&&l(c,a);return this.createElement("shape").attr(c)},circle:function(a,c,b){var d=this.symbol("circle");f(a)&&(b=a.r,c=a.y,a=a.x);d.isCircle=!0;d.r=b;return d.attr({x:a,y:c})},g:function(a){var c;a&&(c={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(c)},
	image:function(a,c,b,d,f){var m=this.createElement("img").attr({src:a});1<arguments.length&&m.attr({x:c,y:b,width:d,height:f});return m},createElement:function(a){return"rect"===a?this.symbol(a):q.prototype.createElement.call(this,a)},invertChild:function(a,c){var b=this;c=c.style;var d="IMG"===a.tagName&&a.style;E(a,{flip:"x",left:C(c.width)-(d?C(d.top):1),top:C(c.height)-(d?C(d.left):1),rotation:-90});v(a.childNodes,function(c){b.invertChild(c,a)})},symbols:{arc:function(a,c,b,d,f){var m=f.start,
	e=f.end,n=f.r||b||d;b=f.innerR;d=Math.cos(m);var q=Math.sin(m),h=Math.cos(e),w=Math.sin(e);if(0===e-m)return["x"];m=["wa",a-n,c-n,a+n,c+n,a+n*d,c+n*q,a+n*h,c+n*w];f.open&&!b&&m.push("e","M",a,c);m.push("at",a-b,c-b,a+b,c+b,a+b*h,c+b*w,a+b*d,c+b*q,"x","e");m.isArc=!0;return m},circle:function(a,c,b,d,f){f&&r(f.r)&&(b=d=2*f.r);f&&f.isCircle&&(a-=b/2,c-=d/2);return["wa",a,c,a+b,c+d,a+b,c+d/2,a+b,c+d/2,"e"]},rect:function(a,c,b,d,f){return q.prototype.symbols[r(f)&&f.r?"callout":"square"].call(0,a,c,
	b,d,f)}}},a.VMLRenderer=D=function(){this.init.apply(this,arguments)},D.prototype=d(q.prototype,B),a.Renderer=D);q.prototype.measureSpanWidth=function(a,c){var b=t.createElement("span");a=t.createTextNode(a);b.appendChild(a);E(b,c);this.box.appendChild(b);c=b.offsetWidth;p(b);return c}})(M);(function(a){function D(){var g=a.defaultOptions.global,p=t.moment;if(g.timezone){if(p)return function(a){return-p.tz(a,g.timezone).utcOffset()};a.error(25)}return g.useUTC&&g.getTimezoneOffset}function B(){var g=
	a.defaultOptions.global,u,l=g.useUTC,e=l?"getUTC":"get",k=l?"setUTC":"set";a.Date=u=g.Date||t.Date;u.hcTimezoneOffset=l&&g.timezoneOffset;u.hcGetTimezoneOffset=D();u.hcMakeTime=function(a,d,e,k,c,q){var f;l?(f=u.UTC.apply(0,arguments),f+=r(f)):f=(new u(a,d,p(e,1),p(k,0),p(c,0),p(q,0))).getTime();return f};E("Minutes Hours Day Date Month FullYear".split(" "),function(a){u["hcGet"+a]=e+a});E("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),function(a){u["hcSet"+a]=k+a})}var G=a.color,
	E=a.each,r=a.getTZOffset,g=a.merge,p=a.pick,t=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
	decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.14/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",
	align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},
	shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",
	day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:G("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",
	whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(t){a.defaultOptions=g(!0,a.defaultOptions,t);B();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;B()})(M);(function(a){var D=a.correctFloat,B=a.defined,G=a.destroyObjectProperties,E=a.isNumber,
	r=a.merge,g=a.pick,p=a.deg2rad;a.Tick=function(a,g,p,l){this.axis=a;this.pos=g;this.type=p||"";this.isNewLabel=this.isNew=!0;p||l||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,p=a.options,u=a.chart,l=a.categories,e=a.names,k=this.pos,f=p.labels,d=a.tickPositions,x=k===d[0],C=k===d[d.length-1],e=l?g(l[k],e[k],k):k,l=this.label,d=d.info,c;a.isDatetimeAxis&&d&&(c=p.dateTimeLabelFormats[d.higherRanks[k]||d.unitName]);this.isFirst=x;this.isLast=C;p=a.labelFormatter.call({axis:a,
	chart:u,isFirst:x,isLast:C,dateTimeLabelFormat:c,value:a.isLog?D(a.lin2log(e)):e,pos:k});B(l)?l&&l.attr({text:p}):(this.labelLength=(this.label=l=B(p)&&f.enabled?u.renderer.text(p,0,0,f.useHTML).css(r(f.style)).add(a.labelGroup):null)&&l.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var t=this.axis,u=a.x,l=t.chart.chartWidth,e=t.chart.spacing,k=g(t.labelLeft,Math.min(t.pos,e[3])),e=g(t.labelRight,
	Math.max(t.pos+t.len,l-e[1])),f=this.label,d=this.rotation,x={left:0,center:.5,right:1}[t.labelAlign],C=f.getBBox().width,c=t.getSlotWidth(),q=c,I=1,m,J={};if(d)0>d&&u-x*C<k?m=Math.round(u/Math.cos(d*p)-k):0<d&&u+x*C>e&&(m=Math.round((l-u)/Math.cos(d*p)));else if(l=u+(1-x)*C,u-x*C<k?q=a.x+q*(1-x)-k:l>e&&(q=e-a.x+q*x,I=-1),q=Math.min(c,q),q<c&&"center"===t.labelAlign&&(a.x+=I*(c-q-x*(c-Math.min(C,q)))),C>q||t.autoRotation&&(f.styles||{}).width)m=q;m&&(J.width=m,(t.options.labels.style||{}).textOverflow||
	(J.textOverflow="ellipsis"),f.css(J))},getPosition:function(a,g,p,l){var e=this.axis,k=e.chart,f=l&&k.oldChartHeight||k.chartHeight;return{x:a?e.translate(g+p,null,null,l)+e.transB:e.left+e.offset+(e.opposite?(l&&k.oldChartWidth||k.chartWidth)-e.right-e.left:0),y:a?f-e.bottom+e.offset-(e.opposite?e.height:0):f-e.translate(g+p,null,null,l)-e.transB}},getLabelPosition:function(a,g,u,l,e,k,f,d){var x=this.axis,C=x.transA,c=x.reversed,q=x.staggerLines,t=x.tickRotCorr||{x:0,y:0},m=e.y;B(m)||(m=0===x.side?
	u.rotation?-8:-u.getBBox().height:2===x.side?t.y+8:Math.cos(u.rotation*p)*(t.y-u.getBBox(!1,0).height/2));a=a+e.x+t.x-(k&&l?k*C*(c?-1:1):0);g=g+m-(k&&!l?k*C*(c?1:-1):0);q&&(u=f/(d||1)%q,x.opposite&&(u=q-u-1),g+=x.labelOffset/q*u);return{x:a,y:Math.round(g)}},getMarkPath:function(a,g,p,l,e,k){return k.crispLine(["M",a,g,"L",a+(e?0:-p),g+(e?p:0)],l)},renderGridLine:function(a,g,p){var l=this.axis,e=l.options,k=this.gridLine,f={},d=this.pos,x=this.type,C=l.tickmarkOffset,c=l.chart.renderer,q=x?x+"Grid":
	"grid",I=e[q+"LineWidth"],m=e[q+"LineColor"],e=e[q+"LineDashStyle"];k||(f.stroke=m,f["stroke-width"]=I,e&&(f.dashstyle=e),x||(f.zIndex=1),a&&(f.opacity=0),this.gridLine=k=c.path().attr(f).addClass("highcharts-"+(x?x+"-":"")+"grid-line").add(l.gridGroup));if(!a&&k&&(a=l.getPlotLinePath(d+C,k.strokeWidth()*p,a,!0)))k[this.isNew?"attr":"animate"]({d:a,opacity:g})},renderMark:function(a,p,u){var l=this.axis,e=l.options,k=l.chart.renderer,f=this.type,d=f?f+"Tick":"tick",x=l.tickSize(d),C=this.mark,c=!C,
	q=a.x;a=a.y;var I=g(e[d+"Width"],!f&&l.isXAxis?1:0),e=e[d+"Color"];x&&(l.opposite&&(x[0]=-x[0]),c&&(this.mark=C=k.path().addClass("highcharts-"+(f?f+"-":"")+"tick").add(l.axisGroup),C.attr({stroke:e,"stroke-width":I})),C[c?"attr":"animate"]({d:this.getMarkPath(q,a,x[0],C.strokeWidth()*u,l.horiz,k),opacity:p}))},renderLabel:function(a,p,u,l){var e=this.axis,k=e.horiz,f=e.options,d=this.label,x=f.labels,C=x.step,c=e.tickmarkOffset,q=!0,I=a.x;a=a.y;d&&E(I)&&(d.xy=a=this.getLabelPosition(I,a,d,k,x,c,
	l,C),this.isFirst&&!this.isLast&&!g(f.showFirstLabel,1)||this.isLast&&!this.isFirst&&!g(f.showLastLabel,1)?q=!1:!k||e.isRadial||x.step||x.rotation||p||0===u||this.handleOverflow(a),C&&l%C&&(q=!1),q&&E(a.y)?(a.opacity=u,d[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(d.attr("y",-9999),this.isNewLabel=!0),this.isNew=!1)},render:function(a,p,u){var l=this.axis,e=l.horiz,k=this.getPosition(e,this.pos,l.tickmarkOffset,p),f=k.x,d=k.y,l=e&&f===l.pos+l.len||!e&&d===l.pos?-1:1;u=g(u,1);this.isActive=
	!0;this.renderGridLine(p,u,l);this.renderMark(k,u,l);this.renderLabel(k,p,u,a)},destroy:function(){G(this,this.axis)}}})(M);var S=function(a){var D=a.addEvent,B=a.animObject,G=a.arrayMax,E=a.arrayMin,r=a.color,g=a.correctFloat,p=a.defaultOptions,t=a.defined,v=a.deg2rad,u=a.destroyObjectProperties,l=a.each,e=a.extend,k=a.fireEvent,f=a.format,d=a.getMagnitude,x=a.grep,C=a.inArray,c=a.isArray,q=a.isNumber,I=a.isString,m=a.merge,J=a.normalizeTickInterval,b=a.objectEach,z=a.pick,K=a.removeEvent,y=a.splat,
	A=a.syncTimeout,n=a.Tick,H=function(){this.init.apply(this,arguments)};a.extend(H.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,
	tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},
	style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,c){var h=c.isX,w=this;w.chart=a;w.horiz=a.inverted&&!w.isZAxis?!h:h;w.isXAxis=h;w.coll=w.coll||(h?
	"xAxis":"yAxis");w.opposite=c.opposite;w.side=c.side||(w.horiz?w.opposite?0:2:w.opposite?1:3);w.setOptions(c);var n=this.options,d=n.type;w.labelFormatter=n.labels.formatter||w.defaultLabelFormatter;w.userOptions=c;w.minPixelPadding=0;w.reversed=n.reversed;w.visible=!1!==n.visible;w.zoomEnabled=!1!==n.zoomEnabled;w.hasNames="category"===d||!0===n.categories;w.categories=n.categories||w.hasNames;w.names=w.names||[];w.plotLinesAndBandsGroups={};w.isLog="logarithmic"===d;w.isDatetimeAxis="datetime"===
	d;w.positiveValuesOnly=w.isLog&&!w.allowNegativeLog;w.isLinked=t(n.linkedTo);w.ticks={};w.labelEdge=[];w.minorTicks={};w.plotLinesAndBands=[];w.alternateBands={};w.len=0;w.minRange=w.userMinRange=n.minRange||n.maxZoom;w.range=n.range;w.offset=n.offset||0;w.stacks={};w.oldStacks={};w.stacksTouched=0;w.max=null;w.min=null;w.crosshair=z(n.crosshair,y(a.options.tooltip.crosshairs)[h?0:1],!1);c=w.options.events;-1===C(w,a.axes)&&(h?a.axes.splice(a.xAxis.length,0,w):a.axes.push(w),a[w.coll].push(w));w.series=
	w.series||[];a.inverted&&!w.isZAxis&&h&&void 0===w.reversed&&(w.reversed=!0);b(c,function(a,h){D(w,h,a)});w.lin2log=n.linearToLogConverter||w.lin2log;w.isLog&&(w.val2lin=w.log2lin,w.lin2val=w.lin2log)},setOptions:function(a){this.options=m(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],m(p[this.coll],a))},defaultLabelFormatter:function(){var h=this.axis,
	b=this.value,c=h.categories,n=this.dateTimeLabelFormat,d=p.lang,m=d.numericSymbols,d=d.numericSymbolMagnitude||1E3,e=m&&m.length,y,q=h.options.labels.format,h=h.isLog?Math.abs(b):h.tickInterval;if(q)y=f(q,this);else if(c)y=b;else if(n)y=a.dateFormat(n,b);else if(e&&1E3<=h)for(;e--&&void 0===y;)c=Math.pow(d,e+1),h>=c&&0===10*b%c&&null!==m[e]&&0!==b&&(y=a.numberFormat(b/c,-1)+m[e]);void 0===y&&(y=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return y},getSeriesExtremes:function(){var a=
	this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();l(a.series,function(h){if(h.visible||!b.options.chart.ignoreHiddenSeries){var w=h.options,c=w.threshold,n;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=c&&(c=null);if(a.isXAxis)w=h.xData,w.length&&(h=E(w),q(h)||h instanceof Date||(w=x(w,function(a){return q(a)}),h=E(w)),a.dataMin=Math.min(z(a.dataMin,w[0]),h),a.dataMax=Math.max(z(a.dataMax,w[0]),G(w)));else if(h.getExtremes(),
	n=h.dataMax,h=h.dataMin,t(h)&&t(n)&&(a.dataMin=Math.min(z(a.dataMin,h),h),a.dataMax=Math.max(z(a.dataMax,n),n)),t(c)&&(a.threshold=c),!w.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,c,n,d,f){var h=this.linkedParent||this,w=1,m=0,y=n?h.oldTransA:h.transA;n=n?h.oldMin:h.min;var e=h.minPixelPadding;d=(h.isOrdinal||h.isBroken||h.isLog&&d)&&h.lin2val;y||(y=h.transA);c&&(w*=-1,m=h.len);h.reversed&&(w*=-1,m-=w*(h.sector||h.len));b?(a=(a*w+m-e)/y+n,d&&(a=h.lin2val(a))):
	(d&&(a=h.val2lin(a)),a=w*(a-n)*y+m+w*e+(q(f)?y*f:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,n,d){var h=this.chart,w=this.left,f=this.top,m,y,e=c&&h.oldChartHeight||h.chartHeight,k=c&&h.oldChartWidth||h.chartWidth,A;m=this.transB;var x=function(a,h,b){if(a<h||a>b)n?a=Math.min(Math.max(h,a),b):A=!0;return a};d=z(d,this.translate(a,
	null,null,c));a=c=Math.round(d+m);m=y=Math.round(e-d-m);q(d)?this.horiz?(m=f,y=e-this.bottom,a=c=x(a,w,w+this.width)):(a=w,c=k-this.right,m=y=x(m,f,f+this.height)):A=!0;return A&&!n?null:h.renderer.crispLine(["M",a,m,"L",c,y],b||1)},getLinearTickPositions:function(a,b,c){var h,w=g(Math.floor(b/a)*a);c=g(Math.ceil(c/a)*a);var n=[];if(this.single)return[b];for(b=w;b<=c;){n.push(b);b=g(b+a);if(b===h)break;h=b}return n},getMinorTickPositions:function(){var a=this,b=a.options,c=a.tickPositions,n=a.minorTickInterval,
	d=[],f=a.pointRangePadding||0,m=a.min-f,f=a.max+f,y=f-m;if(y&&y/n<a.len/3)if(a.isLog)l(this.paddedTicks,function(h,b,c){b&&d.push.apply(d,a.getLogTickPositions(n,c[b-1],c[b],!0))});else if(a.isDatetimeAxis&&"auto"===b.minorTickInterval)d=d.concat(a.getTimeTicks(a.normalizeTimeTickInterval(n),m,f,b.startOfWeek));else for(b=m+(c[0]-m)%n;b<=f&&b!==d[0];b+=n)d.push(b);0!==d.length&&a.trimTicks(d);return d},adjustForMinRange:function(){var a=this.options,b=this.min,c=this.max,n,d,f,m,y,e,q,k;this.isXAxis&&
	void 0===this.minRange&&!this.isLog&&(t(a.min)||t(a.max)?this.minRange=null:(l(this.series,function(a){e=a.xData;for(m=q=a.xIncrement?1:e.length-1;0<m;m--)if(y=e[m]-e[m-1],void 0===f||y<f)f=y}),this.minRange=Math.min(5*f,this.dataMax-this.dataMin)));c-b<this.minRange&&(d=this.dataMax-this.dataMin>=this.minRange,k=this.minRange,n=(k-c+b)/2,n=[b-n,z(a.min,b-n)],d&&(n[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=G(n),c=[b+k,z(a.max,b+k)],d&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),
	c=E(c),c-b<k&&(n[0]=c-k,n[1]=z(a.min,c-k),b=G(n)));this.min=b;this.max=c},getClosest:function(){var a;this.categories?a=1:l(this.series,function(h){var b=h.closestPointRange,c=h.visible||!h.chart.options.chart.ignoreHiddenSeries;!h.noSharedTooltip&&t(b)&&c&&(a=t(a)?Math.min(a,b):b)});return a},nameToX:function(a){var h=c(this.categories),b=h?this.categories:this.names,n=a.options.x,d;a.series.requireSorting=!1;t(n)||(n=!1===this.options.uniqueNames?a.series.autoIncrement():C(a.name,b));-1===n?h||
	(d=b.length):d=n;void 0!==d&&(this.names[d]=a.name);return d},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=this.userMinRange,l(this.series||[],function(h){h.xIncrement=null;if(!h.points||h.isDirtyData)h.processData(),h.generatePoints();l(h.points,function(b,c){var n;b.options&&(n=a.nameToX(b),void 0!==n&&n!==b.x&&(b.x=n,h.xData[c]=n))})}))},setAxisTranslation:function(a){var h=this,b=h.max-h.min,c=h.axisPointRange||0,n,d=0,f=0,m=h.linkedParent,y=!!h.categories,
	e=h.transA,q=h.isXAxis;if(q||y||c)n=h.getClosest(),m?(d=m.minPointOffset,f=m.pointRangePadding):l(h.series,function(a){var b=y?1:q?z(a.options.pointRange,n,0):h.axisPointRange||0;a=a.options.pointPlacement;c=Math.max(c,b);h.single||(d=Math.max(d,I(a)?0:b/2),f=Math.max(f,"on"===a?0:b))}),m=h.ordinalSlope&&n?h.ordinalSlope/n:1,h.minPointOffset=d*=m,h.pointRangePadding=f*=m,h.pointRange=Math.min(c,b),q&&(h.closestPointRange=n);a&&(h.oldTransA=e);h.translationSlope=h.transA=e=h.options.staticScale||h.len/
	(b+f||1);h.transB=h.horiz?h.left:h.bottom;h.minPixelPadding=e*d},minFromRange:function(){return this.max-this.range},setTickInterval:function(h){var b=this,c=b.chart,n=b.options,f=b.isLog,m=b.log2lin,y=b.isDatetimeAxis,e=b.isXAxis,A=b.isLinked,x=n.maxPadding,H=n.minPadding,C=n.tickInterval,p=n.tickPixelInterval,I=b.categories,K=b.threshold,u=b.softThreshold,r,v,B,D;y||I||A||this.getTickAmount();B=z(b.userMin,n.min);D=z(b.userMax,n.max);A?(b.linkedParent=c[b.coll][n.linkedTo],c=b.linkedParent.getExtremes(),
	b.min=z(c.min,c.dataMin),b.max=z(c.max,c.dataMax),n.type!==b.linkedParent.options.type&&a.error(11,1)):(!u&&t(K)&&(b.dataMin>=K?(r=K,H=0):b.dataMax<=K&&(v=K,x=0)),b.min=z(B,r,b.dataMin),b.max=z(D,v,b.dataMax));f&&(b.positiveValuesOnly&&!h&&0>=Math.min(b.min,z(b.dataMin,b.min))&&a.error(10,1),b.min=g(m(b.min),15),b.max=g(m(b.max),15));b.range&&t(b.max)&&(b.userMin=b.min=B=Math.max(b.dataMin,b.minFromRange()),b.userMax=D=b.max,b.range=null);k(b,"foundExtremes");b.beforePadding&&b.beforePadding();b.adjustForMinRange();
	!(I||b.axisPointRange||b.usePercentage||A)&&t(b.min)&&t(b.max)&&(m=b.max-b.min)&&(!t(B)&&H&&(b.min-=m*H),!t(D)&&x&&(b.max+=m*x));q(n.softMin)&&(b.min=Math.min(b.min,n.softMin));q(n.softMax)&&(b.max=Math.max(b.max,n.softMax));q(n.floor)&&(b.min=Math.max(b.min,n.floor));q(n.ceiling)&&(b.max=Math.min(b.max,n.ceiling));u&&t(b.dataMin)&&(K=K||0,!t(B)&&b.min<K&&b.dataMin>=K?b.min=K:!t(D)&&b.max>K&&b.dataMax<=K&&(b.max=K));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:A&&!C&&p===b.linkedParent.options.tickPixelInterval?
	C=b.linkedParent.tickInterval:z(C,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,I?1:(b.max-b.min)*p/Math.max(b.len,p));e&&!h&&l(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!C&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));h=z(n.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);
	!C&&b.tickInterval<h&&(b.tickInterval=h);y||f||C||(b.tickInterval=J(b.tickInterval,null,d(b.tickInterval),z(n.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,c=a.tickPositions,n=a.tickPositioner,d=a.startOnTick,f=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval=
	"auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.single=this.min===this.max&&t(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,
	this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,n&&(n=n.apply(this,[this.min,this.max])))&&(this.tickPositions=b=n);this.paddedTicks=b.slice(0);this.trimTicks(b,d,f);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),c||n||this.adjustTickAmount())},trimTicks:function(a,b,c){var h=a[0],n=a[a.length-1],d=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==h)this.min=h;else for(;this.min-d>a[0];)a.shift();if(c)this.max=n;else for(;this.max+d<a[a.length-
	1];)a.pop();0===a.length&&t(h)&&a.push((n+h)/2)}},alignToOthers:function(){var a={},b,c=this.options;!1===this.chart.options.chart.alignTicks||!1===c.alignTicks||this.isLog||l(this.chart[this.coll],function(h){var c=h.options,c=[h.horiz?c.left:c.top,c.width,c.height,c.pane].join();h.series.length&&(a[c]?b=!0:a[c]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,c=a.tickPixelInterval;!t(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=
	2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,n=this.finalTickAmt,d=b&&b.length;if(d<c){for(;b.length<c;)b.push(g(b[b.length-1]+a));this.transA*=(d-1)/(c-1);this.max=b[b.length-1]}else d>c&&(this.tickInterval*=2,this.setTickPositions());if(t(n)){for(a=c=b.length;a--;)(3===n&&1===a%2||2>=n&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,
	b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;l(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||
	(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,c,n,d){var h=this,f=h.chart;c=z(c,!0);l(h.series,function(a){delete a.kdTree});d=e(d,{min:a,max:b});k(h,"setExtremes",d,function(){h.userMin=a;h.userMax=b;h.eventArgs=d;c&&f.redraw(n)})},zoom:function(a,b){var h=this.dataMin,c=this.dataMax,n=this.options,d=Math.min(h,z(n.min,h)),n=Math.max(c,z(n.max,c));if(a!==this.min||b!==this.max)this.allowZoomOutside||(t(h)&&(a<d&&(a=
	d),a>n&&(a=n)),t(c)&&(b<d&&(b=d),b>n&&(b=n))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,c=this.options,n=c.offsets||[0,0,0,0],d=this.horiz,f=this.width=Math.round(a.relativeLength(z(c.width,b.plotWidth-n[3]+n[1]),b.plotWidth)),m=this.height=Math.round(a.relativeLength(z(c.height,b.plotHeight-n[0]+n[2]),b.plotHeight)),y=this.top=Math.round(a.relativeLength(z(c.top,b.plotTop+n[0]),b.plotHeight,b.plotTop)),
	c=this.left=Math.round(a.relativeLength(z(c.left,b.plotLeft+n[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-m-y;this.right=b.chartWidth-f-c;this.len=Math.max(d?f:m,0);this.pos=d?c:y},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?g(b(this.min)):this.min,max:a?g(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,h=this.lin2log,c=b?h(this.min):this.min,b=b?h(this.max):this.max;
	null===a?a=c:c>a?a=c:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(z(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,h=b[a+"Length"],c=z(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(c&&h)return"inside"===b[a+"Position"]&&(h=-h),[h,c]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,
	this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,c=this.tickInterval,n=c,d=this.len/(((this.categories?1:0)+this.max-this.min)/c),f,m=a.rotation,y=this.labelMetrics(),e,q=Number.MAX_VALUE,k,A=function(a){a/=d||1;a=1<a?Math.ceil(a):1;return a*c};b?(k=!a.staggerLines&&!a.step&&(t(m)?[m]:d<z(a.autoRotationLimit,80)&&a.autoRotation))&&l(k,function(a){var b;if(a===m||a&&-90<=a&&90>=a)e=A(Math.abs(y.h/Math.sin(v*a))),b=e+Math.abs(a/360),b<q&&(q=b,f=a,n=e)}):
	a.step||(n=A(y.h));this.autoRotation=k;this.labelRotation=z(f,m);return n},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,n=Math.max(this.tickPositions.length-(this.categories?0:1),1),d=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/n||!b&&(d&&d-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,c=this.tickPositions,n=this.ticks,d=this.options.labels,f=this.horiz,y=this.getSlotWidth(),e=Math.max(1,
	Math.round(y-2*(d.padding||5))),q={},k=this.labelMetrics(),A=d.style&&d.style.textOverflow,x,H=0,z,C;I(d.rotation)||(q.rotation=d.rotation||0);l(c,function(a){(a=n[a])&&a.labelLength>H&&(H=a.labelLength)});this.maxLabelLength=H;if(this.autoRotation)H>e&&H>k.h?q.rotation=this.labelRotation:this.labelRotation=0;else if(y&&(x={width:e+"px"},!A))for(x.textOverflow="clip",z=c.length;!f&&z--;)if(C=c[z],e=n[C].label)e.styles&&"ellipsis"===e.styles.textOverflow?e.css({textOverflow:"clip"}):n[C].labelLength>
	y&&e.css({width:y+"px"}),e.getBBox().height>this.len/c.length-(k.h-k.f)&&(e.specCss={textOverflow:"ellipsis"});q.rotation&&(x={width:(H>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},A||(x.textOverflow="ellipsis"));if(this.labelAlign=d.align||this.autoLabelAlign(this.labelRotation))q.align=this.labelAlign;l(c,function(a){var b=(a=n[a])&&a.label;b&&(b.attr(q),x&&b.css(m(x,b.specCss)),delete b.specCss,a.rotation=q.rotation)});this.tickRotCorr=b.rotCorr(k.b,this.labelRotation||0,0!==this.side)},
	hasData:function(){return this.hasVisibleSeries||t(this.min)&&t(this.max)&&!!this.tickPositions},addTitle:function(a){var b=this.chart.renderer,h=this.horiz,c=this.opposite,n=this.options.title,d;this.axisTitle||((d=n.textAlign)||(d=(h?{low:"left",middle:"center",high:"right"}:{low:c?"right":"left",middle:"center",high:c?"left":"right"})[n.align]),this.axisTitle=b.text(n.text,0,0,n.useHTML).attr({zIndex:7,rotation:n.rotation||0,align:d}).addClass("highcharts-axis-title").css(n.style).add(this.axisGroup),
	this.axisTitle.isNew=!0);n.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new n(this,a)},getOffset:function(){var a=this,c=a.chart,n=c.renderer,d=a.options,f=a.tickPositions,m=a.ticks,y=a.horiz,e=a.side,q=c.inverted&&!a.isZAxis?[1,0,3,2][e]:e,k,A,x=0,H,C=0,g=d.title,p=d.labels,I=0,J=c.axisOffset,c=c.clipOffset,K=[-1,1,1,-1][e],u=d.className,r=a.axisParent,v=this.tickSize("tick");
	k=a.hasData();a.showAxis=A=k||z(d.showEmpty,!0);a.staggerLines=a.horiz&&p.staggerLines;a.axisGroup||(a.gridGroup=n.g("grid").attr({zIndex:d.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(u||"")).add(r),a.axisGroup=n.g("axis").attr({zIndex:d.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(u||"")).add(r),a.labelGroup=n.g("axis-labels").attr({zIndex:p.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(u||"")).add(r));k||a.isLinked?(l(f,function(b,
	h){a.generateTick(b,h)}),a.renderUnsquish(),!1===p.reserveSpace||0!==e&&2!==e&&{1:"left",3:"right"}[e]!==a.labelAlign&&"center"!==a.labelAlign||l(f,function(a){I=Math.max(m[a].getLabelSize(),I)}),a.staggerLines&&(I*=a.staggerLines,a.labelOffset=I*(a.opposite?-1:1))):b(m,function(a,b){a.destroy();delete m[b]});g&&g.text&&!1!==g.enabled&&(a.addTitle(A),A&&!1!==g.reserveSpace&&(a.titleOffset=x=a.axisTitle.getBBox()[y?"height":"width"],H=g.offset,C=t(H)?0:z(g.margin,y?5:10)));a.renderLine();a.offset=
	K*z(d.offset,J[e]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};n=0===e?-a.labelMetrics().h:2===e?a.tickRotCorr.y:0;C=Math.abs(I)+C;I&&(C=C-n+K*(y?z(p.y,a.tickRotCorr.y+8*K):p.x));a.axisTitleMargin=z(H,C);J[e]=Math.max(J[e],a.axisTitleMargin+x+K*a.offset,C,k&&f.length&&v?v[0]+K*a.offset:0);f=2*Math.floor(a.axisLine.strokeWidth()/2);0<d.offset&&(f-=2*d.offset);c[q]=Math.max(c[q]||f,f)},getLinePath:function(a){var b=this.chart,h=this.opposite,c=this.offset,n=this.horiz,d=this.left+(h?this.width:0)+c,c=b.chartHeight-
	this.bottom-(h?this.height:0)+c;h&&(a*=-1);return b.renderer.crispLine(["M",n?this.left:d,n?c:this.top,"L",n?b.chartWidth-this.right:d,n?c:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,n=this.len,d=this.options.title,
	f=a?b:c,m=this.opposite,e=this.offset,y=d.x||0,q=d.y||0,k=this.axisTitle,A=this.chart.renderer.fontMetrics(d.style&&d.style.fontSize,k),k=Math.max(k.getBBox(null,0).height-A.h-1,0),n={low:f+(a?0:n),middle:f+n/2,high:f+(a?n:0)}[d.align],b=(a?c+this.height:b)+(a?1:-1)*(m?-1:1)*this.axisTitleMargin+[-k,k,A.f,-k][this.side];return{x:a?n+y:b+(m?this.width:0)+e+y,y:a?b+q-(m?this.height:0)+e:n+q}},renderMinorTick:function(a){var b=this.chart.hasRendered&&q(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new n(this,
	a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,h=this.ticks,d=this.chart.hasRendered&&q(this.oldMin);if(!c||a>=this.min&&a<=this.max)h[a]||(h[a]=new n(this,a)),d&&h[a].isNew&&h[a].render(b,!0,.1),h[a].render(b)},render:function(){var c=this,d=c.chart,f=c.options,m=c.isLog,e=c.lin2log,y=c.isLinked,k=c.tickPositions,x=c.axisTitle,H=c.ticks,z=c.minorTicks,C=c.alternateBands,g=f.stackLabels,p=f.alternateGridColor,I=c.tickmarkOffset,
	J=c.axisLine,K=c.showAxis,t=B(d.renderer.globalAnimation),u,r;c.labelEdge.length=0;c.overlap=!1;l([H,z,C],function(a){b(a,function(a){a.isActive=!1})});if(c.hasData()||y)c.minorTickInterval&&!c.categories&&l(c.getMinorTickPositions(),function(a){c.renderMinorTick(a)}),k.length&&(l(k,function(a,b){c.renderTick(a,b)}),I&&(0===c.min||c.single)&&(H[-1]||(H[-1]=new n(c,-1,null,!0)),H[-1].render(-1))),p&&l(k,function(b,h){r=void 0!==k[h+1]?k[h+1]+I:c.max-I;0===h%2&&b<c.max&&r<=c.max+(d.polar?-I:I)&&(C[b]||
	(C[b]=new a.PlotLineOrBand(c)),u=b+I,C[b].options={from:m?e(u):u,to:m?e(r):r,color:p},C[b].render(),C[b].isActive=!0)}),c._addedPlotLB||(l((f.plotLines||[]).concat(f.plotBands||[]),function(a){c.addPlotBandOrLine(a)}),c._addedPlotLB=!0);l([H,z,C],function(a){var c,h=[],n=t.duration;b(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,h.push(b))});A(function(){for(c=h.length;c--;)a[h[c]]&&!a[h[c]].isActive&&(a[h[c]].destroy(),delete a[h[c]])},a!==C&&d.hasRendered&&n?n:0)});J&&(J[J.isPlaced?
	"animate":"attr"]({d:this.getLinePath(J.strokeWidth())}),J.isPlaced=!0,J[K?"show":"hide"](!0));x&&K&&(f=c.getTitlePosition(),q(f.y)?(x[x.isNew?"attr":"animate"](f),x.isNew=!1):(x.attr("y",-9999),x.isNew=!0));g&&g.enabled&&c.renderStackTotals();c.isDirty=!1},redraw:function(){this.visible&&(this.render(),l(this.plotLinesAndBands,function(a){a.render()}));l(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var c=this,h=c.stacks,
	n=c.plotLinesAndBands,d;a||K(c);b(h,function(a,b){u(a);h[b]=null});l([c.ticks,c.minorTicks,c.alternateBands],function(a){u(a)});if(n)for(a=n.length;a--;)n[a].destroy();l("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){c[a]&&(c[a]=c[a].destroy())});for(d in c.plotLinesAndBandsGroups)c.plotLinesAndBandsGroups[d]=c.plotLinesAndBandsGroups[d].destroy();b(c,function(a,b){-1===C(b,c.keepProps)&&delete c[b]})},drawCrosshair:function(a,b){var c,h=this.crosshair,
	n=z(h.snap,!0),d,f=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(t(b)||!n)?(n?t(b)&&(d=this.isXAxis?b.plotX:this.len-b.plotY):d=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),t(d)&&(c=this.getPlotLinePath(b&&(this.isXAxis?b.x:z(b.stackY,b.y)),null,null,null,d)||null),t(c)?(b=this.categories&&!this.isRadial,f||(this.cross=f=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+h.className).attr({zIndex:z(h.zIndex,2)}).add(),
	f.attr({stroke:h.color||(b?r("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":z(h.width,1)}),h.dashStyle&&f.attr({dashstyle:h.dashStyle})),f.show().attr({d:c}),b&&!h.width&&f.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=H}(M);(function(a){var D=a.Axis,B=a.Date,G=a.dateFormat,E=a.defaultOptions,r=a.defined,g=a.each,p=a.extend,t=a.getMagnitude,v=a.getTZOffset,u=a.normalizeTickInterval,
	l=a.pick,e=a.timeUnits;D.prototype.getTimeTicks=function(a,f,d,x){var k=[],c={},q=E.global.useUTC,I,m=new B(f-Math.max(v(f),v(d))),J=B.hcMakeTime,b=a.unitRange,z=a.count,K,y;if(r(f)){m[B.hcSetMilliseconds](b>=e.second?0:z*Math.floor(m.getMilliseconds()/z));if(b>=e.second)m[B.hcSetSeconds](b>=e.minute?0:z*Math.floor(m.getSeconds()/z));if(b>=e.minute)m[B.hcSetMinutes](b>=e.hour?0:z*Math.floor(m[B.hcGetMinutes]()/z));if(b>=e.hour)m[B.hcSetHours](b>=e.day?0:z*Math.floor(m[B.hcGetHours]()/z));if(b>=e.day)m[B.hcSetDate](b>=
	e.month?1:z*Math.floor(m[B.hcGetDate]()/z));b>=e.month&&(m[B.hcSetMonth](b>=e.year?0:z*Math.floor(m[B.hcGetMonth]()/z)),I=m[B.hcGetFullYear]());if(b>=e.year)m[B.hcSetFullYear](I-I%z);if(b===e.week)m[B.hcSetDate](m[B.hcGetDate]()-m[B.hcGetDay]()+l(x,1));I=m[B.hcGetFullYear]();x=m[B.hcGetMonth]();var A=m[B.hcGetDate](),n=m[B.hcGetHours]();if(B.hcTimezoneOffset||B.hcGetTimezoneOffset)y=(!q||!!B.hcGetTimezoneOffset)&&(d-f>4*e.month||v(f)!==v(d)),m=m.getTime(),K=v(m),m=new B(m+K);q=m.getTime();for(f=1;q<
	d;)k.push(q),q=b===e.year?J(I+f*z,0):b===e.month?J(I,x+f*z):!y||b!==e.day&&b!==e.week?y&&b===e.hour?J(I,x,A,n+f*z,0,0,K)-K:q+b*z:J(I,x,A+f*z*(b===e.day?1:7)),f++;k.push(q);b<=e.hour&&1E4>k.length&&g(k,function(a){0===a%18E5&&"000000000"===G("%H%M%S%L",a)&&(c[a]="day")})}k.info=p(a,{higherRanks:c,totalRange:b*z});return k};D.prototype.normalizeTimeTickInterval=function(a,f){var d=f||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,
	2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];f=d[d.length-1];var k=e[f[0]],l=f[1],c;for(c=0;c<d.length&&!(f=d[c],k=e[f[0]],l=f[1],d[c+1]&&a<=(k*l[l.length-1]+e[d[c+1][0]])/2);c++);k===e.year&&a<5*k&&(l=[1,2,5]);a=u(a/k,l,"year"===f[0]?Math.max(t(a/k),1):1);return{unitRange:k,count:a,unitName:f[0]}}})(M);(function(a){var D=a.Axis,B=a.getMagnitude,G=a.map,E=a.normalizeTickInterval,r=a.pick;D.prototype.getLogTickPositions=function(a,p,t,v){var g=this.options,l=this.len,
	e=this.lin2log,k=this.log2lin,f=[];v||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),f=this.getLinearTickPositions(a,p,t);else if(.08<=a)for(var l=Math.floor(p),d,x,C,c,q,g=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];l<t+1&&!q;l++)for(x=g.length,d=0;d<x&&!q;d++)C=k(e(l)*g[d]),C>p&&(!v||c<=t)&&void 0!==c&&f.push(c),c>t&&(q=!0),c=C;else p=e(p),t=e(t),a=g[v?"minorTickInterval":"tickInterval"],a=r("auto"===a?null:a,this._minorAutoInterval,g.tickPixelInterval/(v?5:1)*(t-p)/((v?l/this.tickPositions.length:
	l)||1)),a=E(a,null,B(a)),f=G(this.getLinearTickPositions(a,p,t),k),v||(this._minorAutoInterval=a/5);v||(this.tickInterval=a);return f};D.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};D.prototype.lin2log=function(a){return Math.pow(10,a)}})(M);(function(a,D){var B=a.arrayMax,G=a.arrayMin,E=a.defined,r=a.destroyObjectProperties,g=a.each,p=a.erase,t=a.merge,v=a.pick;a.PlotLineOrBand=function(a,l){this.axis=a;l&&(this.options=l,this.id=l.id)};a.PlotLineOrBand.prototype={render:function(){var g=
	this,l=g.axis,e=l.horiz,k=g.options,f=k.label,d=g.label,x=k.to,C=k.from,c=k.value,q=E(C)&&E(x),p=E(c),m=g.svgElem,J=!m,b=[],z=k.color,K=v(k.zIndex,0),y=k.events,b={"class":"highcharts-plot-"+(q?"band ":"line ")+(k.className||"")},A={},n=l.chart.renderer,H=q?"bands":"lines",h=l.log2lin;l.isLog&&(C=h(C),x=h(x),c=h(c));p?(b={stroke:z,"stroke-width":k.width},k.dashStyle&&(b.dashstyle=k.dashStyle)):q&&(z&&(b.fill=z),k.borderWidth&&(b.stroke=k.borderColor,b["stroke-width"]=k.borderWidth));A.zIndex=K;H+=
	"-"+K;(z=l.plotLinesAndBandsGroups[H])||(l.plotLinesAndBandsGroups[H]=z=n.g("plot-"+H).attr(A).add());J&&(g.svgElem=m=n.path().attr(b).add(z));if(p)b=l.getPlotLinePath(c,m.strokeWidth());else if(q)b=l.getPlotBandPath(C,x,k);else return;J&&b&&b.length?(m.attr({d:b}),y&&a.objectEach(y,function(a,b){m.on(b,function(a){y[b].apply(g,[a])})})):m&&(b?(m.show(),m.animate({d:b})):(m.hide(),d&&(g.label=d=d.destroy())));f&&E(f.text)&&b&&b.length&&0<l.width&&0<l.height&&!b.flat?(f=t({align:e&&q&&"center",x:e?
	!q&&4:10,verticalAlign:!e&&q&&"middle",y:e?q?16:10:q?6:-4,rotation:e&&!q&&90},f),this.renderLabel(f,b,q,K)):d&&d.hide();return g},renderLabel:function(a,l,e,k){var f=this.label,d=this.axis.chart.renderer;f||(f={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(e?"band":"line")+"-label "+(a.className||"")},f.zIndex=k,this.label=f=d.text(a.text,0,0,a.useHTML).attr(f).add(),f.css(a.style));k=[l[1],l[4],e?l[6]:l[1]];l=[l[2],l[5],e?l[7]:l[2]];e=G(k);d=G(l);f.align(a,!1,{x:e,y:d,
	width:B(k)-e,height:B(l)-d});f.show()},destroy:function(){p(this.axis.plotLinesAndBands,this);delete this.axis;r(this)}};a.extend(D.prototype,{getPlotBandPath:function(a,l){var e=this.getPlotLinePath(l,null,null,!0),k=this.getPlotLinePath(a,null,null,!0),f=this.horiz,d=1;a=a<this.min&&l<this.min||a>this.max&&l>this.max;k&&e?(a&&(k.flat=k.toString()===e.toString(),d=0),k.push(f&&e[4]===k[4]?e[4]+d:e[4],f||e[5]!==k[5]?e[5]:e[5]+d,f&&e[1]===k[1]?e[1]+d:e[1],f||e[2]!==k[2]?e[2]:e[2]+d)):k=null;return k},
	addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(g,l){var e=(new a.PlotLineOrBand(this,g)).render(),k=this.userOptions;e&&(l&&(k[l]=k[l]||[],k[l].push(g)),this.plotLinesAndBands.push(e));return e},removePlotBandOrLine:function(a){for(var l=this.plotLinesAndBands,e=this.options,k=this.userOptions,f=l.length;f--;)l[f].id===a&&l[f].destroy();g([e.plotLines||[],k.plotLines||[],e.plotBands||
	[],k.plotBands||[]],function(d){for(f=d.length;f--;)d[f].id===a&&p(d,d[f])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(M,S);(function(a){var D=a.dateFormat,B=a.each,G=a.extend,E=a.format,r=a.isNumber,g=a.map,p=a.merge,t=a.pick,v=a.splat,u=a.syncTimeout,l=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,k){this.chart=a;this.options=k;this.crosshairs=[];this.now={x:0,y:0};
	this.isHidden=!0;this.split=k.split&&!a.inverted;this.shared=k.shared||this.split},cleanSplit:function(a){B(this.chart.series,function(e){var f=e&&e.tt;f&&(!f.isActive||a?e.tt=f.destroy():f.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,k=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,k.shape||"callout",null,null,k.useHTML,null,"tooltip").attr({padding:k.padding,r:k.borderRadius}),this.label.attr({fill:k.backgroundColor,"stroke-width":k.borderWidth}).css(k.style).shadow(k.shadow)),
	this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();p(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,p(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,k,f,d){var e=this,l=e.now,c=!1!==e.options.animation&&!e.isHidden&&(1<Math.abs(a-l.x)||1<Math.abs(k-
	l.y)),q=e.followPointer||1<e.len;G(l,{x:c?(2*l.x+a)/3:a,y:c?(l.y+k)/2:k,anchorX:q?void 0:c?(2*l.anchorX+f)/3:f,anchorY:q?void 0:c?(l.anchorY+d)/2:d});e.getLabel().attr(l);c&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(a,k,f,d)},32))},hide:function(a){var e=this;clearTimeout(this.hideTimer);a=t(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=u(function(){e.getLabel()[a?"fadeOut":"hide"]();e.isHidden=!0},a))},getAnchor:function(a,k){var f,d=this.chart,
	e=d.inverted,l=d.plotTop,c=d.plotLeft,q=0,p=0,m,J;a=v(a);f=a[0].tooltipPos;this.followPointer&&k&&(void 0===k.chartX&&(k=d.pointer.normalize(k)),f=[k.chartX-d.plotLeft,k.chartY-l]);f||(B(a,function(a){m=a.series.yAxis;J=a.series.xAxis;q+=a.plotX+(!e&&J?J.left-c:0);p+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&m?m.top-l:0)}),q/=a.length,p/=a.length,f=[e?d.plotWidth-p:q,this.shared&&!e&&1<a.length&&k?k.chartY-l:e?d.plotHeight-q:p]);return g(f,Math.round)},getPosition:function(a,k,f){var d=this.chart,
	e=this.distance,l={},c=f.h||0,q,g=["y",d.chartHeight,k,f.plotY+d.plotTop,d.plotTop,d.plotTop+d.plotHeight],m=["x",d.chartWidth,a,f.plotX+d.plotLeft,d.plotLeft,d.plotLeft+d.plotWidth],p=!this.followPointer&&t(f.ttBelow,!d.inverted===!!f.negative),b=function(a,b,d,h,f,m){var n=d<h-e,y=h+e+d<b,q=h-e-d;h+=e;if(p&&y)l[a]=h;else if(!p&&n)l[a]=q;else if(n)l[a]=Math.min(m-d,0>q-c?q:q-c);else if(y)l[a]=Math.max(f,h+c+d>b?h:h+c);else return!1},z=function(a,b,c,h){var n;h<e||h>b-e?n=!1:l[a]=h<c/2?1:h>b-c/2?
	b-c-2:h-c/2;return n},K=function(a){var b=g;g=m;m=b;q=a},y=function(){!1!==b.apply(0,g)?!1!==z.apply(0,m)||q||(K(!0),y()):q?l.x=l.y=0:(K(!0),y())};(d.inverted||1<this.len)&&K();y();return l},defaultFormatter:function(a){var e=this.points||v(this),f;f=[a.tooltipFooterHeaderFormatter(e[0])];f=f.concat(a.bodyFormatter(e));f.push(a.tooltipFooterHeaderFormatter(e[0],!0));return f},refresh:function(a,k){var f,d=this.options,e,l=a,c,q={},g=[];f=d.formatter||this.defaultFormatter;var q=this.shared,m;d.enabled&&
	(clearTimeout(this.hideTimer),this.followPointer=v(l)[0].series.tooltipOptions.followPointer,c=this.getAnchor(l,k),k=c[0],e=c[1],!q||l.series&&l.series.noSharedTooltip?q=l.getLabelConfig():(B(l,function(a){a.setState("hover");g.push(a.getLabelConfig())}),q={x:l[0].category,y:l[0].y},q.points=g,l=l[0]),this.len=g.length,q=f.call(q,this),m=l.series,this.distance=t(m.tooltipOptions.distance,16),!1===q?this.hide():(f=this.getLabel(),this.isHidden&&f.attr({opacity:1}).show(),this.split?this.renderSplit(q,
	a):(d.style.width||f.css({width:this.chart.spacingBox.width}),f.attr({text:q&&q.join?q.join(""):q}),f.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+t(l.colorIndex,m.colorIndex)),f.attr({stroke:d.borderColor||l.color||m.color||"#666666"}),this.updatePosition({plotX:k,plotY:e,negative:l.negative,ttBelow:l.ttBelow,h:c[2]||0})),this.isHidden=!1))},renderSplit:function(e,k){var f=this,d=[],l=this.chart,g=l.renderer,c=!0,q=this.options,p=0,m=this.getLabel();B(e.slice(0,k.length+1),
	function(a,b){if(!1!==a){b=k[b-1]||{isHeader:!0,plotX:k[0].plotX};var e=b.series||f,x=e.tt,y=b.series||{},A="highcharts-color-"+t(b.colorIndex,y.colorIndex,"none");x||(e.tt=x=g.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+A).attr({padding:q.padding,r:q.borderRadius,fill:q.backgroundColor,stroke:q.borderColor||b.color||y.color||"#333333","stroke-width":q.borderWidth}).add(m));x.isActive=!0;x.attr({text:a});x.css(q.style).shadow(q.shadow);a=x.getBBox();y=a.width+x.strokeWidth();
	b.isHeader?(p=a.height,y=Math.max(0,Math.min(b.plotX+l.plotLeft-y/2,l.chartWidth-y))):y=b.plotX+l.plotLeft-t(q.distance,16)-y;0>y&&(c=!1);a=(b.series&&b.series.yAxis&&b.series.yAxis.pos)+(b.plotY||0);a-=l.plotTop;d.push({target:b.isHeader?l.plotHeight+p:a,rank:b.isHeader?1:0,size:e.tt.getBBox().height+1,point:b,x:y,tt:x})}});this.cleanSplit();a.distribute(d,l.plotHeight+p);B(d,function(a){var b=a.point,d=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:c||b.isHeader?a.x:b.plotX+
	l.plotLeft+t(q.distance,16),y:a.pos+l.plotTop,anchorX:b.isHeader?b.plotX+l.plotLeft:b.plotX+d.xAxis.pos,anchorY:b.isHeader?a.pos+l.plotTop-15:b.plotY+d.yAxis.pos})})},updatePosition:function(a){var e=this.chart,f=this.getLabel(),f=(this.options.positioner||this.getPosition).call(this,f.width,f.height,a);this.move(Math.round(f.x),Math.round(f.y||0),a.plotX+e.plotLeft,a.plotY+e.plotTop)},getDateFormat:function(a,k,f,d){var e=D("%m-%d %H:%M:%S.%L",k),g,c,q={millisecond:15,second:12,minute:9,hour:6,day:3},
	p="millisecond";for(c in l){if(a===l.week&&+D("%w",k)===f&&"00:00:00.000"===e.substr(6)){c="week";break}if(l[c]>a){c=p;break}if(q[c]&&e.substr(q[c])!=="01-01 00:00:00.000".substr(q[c]))break;"week"!==c&&(p=c)}c&&(g=d[c]);return g},getXDateFormat:function(a,k,f){k=k.dateTimeLabelFormats;var d=f&&f.closestPointRange;return(d?this.getDateFormat(d,a.x,f.options.startOfWeek,k):k.day)||k.year},tooltipFooterHeaderFormatter:function(a,k){var f=k?"footer":"header";k=a.series;var d=k.tooltipOptions,e=d.xDateFormat,
	l=k.xAxis,c=l&&"datetime"===l.options.type&&r(a.key),f=d[f+"Format"];c&&!e&&(e=this.getXDateFormat(a,d,l));c&&e&&(f=f.replace("{point.key}","{point.key:"+e+"}"));return E(f,{point:a,series:k})},bodyFormatter:function(a){return g(a,function(a){var f=a.series.tooltipOptions;return(f.pointFormatter||a.point.tooltipFormatter).call(a.point,f.pointFormat)})}}})(M);(function(a){var D=a.addEvent,B=a.attr,G=a.charts,E=a.color,r=a.css,g=a.defined,p=a.each,t=a.extend,v=a.find,u=a.fireEvent,l=a.isObject,e=a.offset,
	k=a.pick,f=a.removeEvent,d=a.splat,x=a.Tooltip,C=a.win;a.Pointer=function(a,d){this.init(a,d)};a.Pointer.prototype={init:function(a,d){this.options=d;this.chart=a;this.runChartClick=d.chart.events&&!!d.chart.events.click;this.pinchDown=[];this.lastValidTouch={};x&&(a.tooltip=new x(a,d.tooltip),this.followTouchMove=k(d.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var c=this.chart,d=c.options.chart,f=d.zoomType||"",c=c.inverted;/touch/.test(a.type)&&(f=k(d.pinchType,f));
	this.zoomX=a=/x/.test(f);this.zoomY=f=/y/.test(f);this.zoomHor=a&&!c||f&&c;this.zoomVert=f&&!c||a&&c;this.hasZoom=a||f},normalize:function(a,d){var c,f;a=a||C.event;a.target||(a.target=a.srcElement);f=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;d||(this.chartPosition=d=e(this.chart.container));void 0===f.pageX?(c=Math.max(a.x,a.clientX-d.left),d=a.y):(c=f.pageX-d.left,d=f.pageY-d.top);return t(a,{chartX:Math.round(c),chartY:Math.round(d)})},getCoordinates:function(a){var c=
	{xAxis:[],yAxis:[]};p(this.chart.axes,function(d){c[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return c},findNearestKDPoint:function(a,d,f){var c;p(a,function(a){var b=!(a.noSharedTooltip&&d)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(f,b);if((b=l(a,!0))&&!(b=!l(c,!0)))var b=c.distX-a.distX,m=c.dist-a.dist,e=(a.series.group&&a.series.group.zIndex)-(c.series.group&&c.series.group.zIndex),b=0<(0!==b&&d?b:0!==m?m:0!==e?e:c.series.index>
	a.series.index?-1:1);b&&(c=a)});return c},getPointFromEvent:function(a){a=a.target;for(var c;a&&!c;)c=a.point,a=a.parentNode;return c},getChartCoordinatesFromPoint:function(a,d){var c=a.series,f=c.xAxis,c=c.yAxis;if(f&&c)return d?{chartX:f.len+f.pos-a.clientX,chartY:c.len+c.pos-a.plotY}:{chartX:a.clientX+f.pos,chartY:a.plotY+c.pos}},getHoverData:function(c,d,f,m,e,b){var q,x=[];m=!(!m||!c);var y=d&&!d.stickyTracking?[d]:a.grep(f,function(a){return a.visible&&!(!e&&a.directTouch)&&k(a.options.enableMouseTracking,
	!0)&&a.stickyTracking});d=(q=m?c:this.findNearestKDPoint(y,e,b))&&q.series;q&&(e&&!d.noSharedTooltip?(y=a.grep(f,function(a){return a.visible&&!(!e&&a.directTouch)&&k(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),p(y,function(a){a=v(a.points,function(a){return a.x===q.x});l(a)&&!a.isNull&&x.push(a)})):x.push(q));return{hoverPoint:q,hoverSeries:d,hoverPoints:x}},runPointActions:function(c,d){var f=this.chart,m=f.tooltip,e=m?m.shared:!1,b=d||f.hoverPoint,q=b&&b.series||f.hoverSeries,q=this.getHoverData(b,
	q,f.series,!!d||q&&q.directTouch&&this.isDirectTouch,e,c),l,b=q.hoverPoint;l=q.hoverPoints;d=(q=q.hoverSeries)&&q.tooltipOptions.followPointer;e=e&&q&&!q.noSharedTooltip;if(b&&(b!==f.hoverPoint||m&&m.isHidden)){p(f.hoverPoints||[],function(b){-1===a.inArray(b,l)&&b.setState()});p(l||[],function(a){a.setState("hover")});if(f.hoverSeries!==q)q.onMouseOver();f.hoverPoint&&f.hoverPoint.firePointEvent("mouseOut");b.firePointEvent("mouseOver");f.hoverPoints=l;f.hoverPoint=b;m&&m.refresh(e?l:b,c)}else d&&
	m&&!m.isHidden&&(b=m.getAnchor([{}],c),m.updatePosition({plotX:b[0],plotY:b[1]}));this.unDocMouseMove||(this.unDocMouseMove=D(f.container.ownerDocument,"mousemove",function(b){var c=G[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));p(f.axes,function(b){var d=k(b.crosshair.snap,!0),n=d?a.find(l,function(a){return a.series[b.coll]===b}):void 0;n||!d?b.drawCrosshair(c,n):b.hideCrosshair()})},reset:function(a,f){var c=this.chart,m=c.hoverSeries,e=c.hoverPoint,b=c.hoverPoints,q=c.tooltip,k=
	q&&q.shared?b:e;a&&k&&p(d(k),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)q&&k&&(q.refresh(k),e&&(e.setState(e.state,!0),p(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();b&&p(b,function(a){a.setState()});if(m)m.onMouseOut();q&&q.hide(f);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());p(c.axes,function(a){a.hideCrosshair()});this.hoverX=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,d){var c=this.chart,f;p(c.series,
	function(m){f=a||m.getPlotBox();m.xAxis&&m.xAxis.zoomEnabled&&m.group&&(m.group.attr(f),m.markerGroup&&(m.markerGroup.attr(f),m.markerGroup.clip(d?c.clipRect:null)),m.dataLabelsGroup&&m.dataLabelsGroup.attr(f))});c.clipRect.attr(d||c.clipBox)},dragStart:function(a){var c=this.chart;c.mouseIsDown=a.type;c.cancelClick=!1;c.mouseDownX=this.mouseDownX=a.chartX;c.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var c=this.chart,d=c.options.chart,f=a.chartX,e=a.chartY,b=this.zoomHor,k=this.zoomVert,
	l=c.plotLeft,y=c.plotTop,A=c.plotWidth,n=c.plotHeight,x,h=this.selectionMarker,w=this.mouseDownX,g=this.mouseDownY,C=d.panKey&&a[d.panKey+"Key"];h&&h.touch||(f<l?f=l:f>l+A&&(f=l+A),e<y?e=y:e>y+n&&(e=y+n),this.hasDragged=Math.sqrt(Math.pow(w-f,2)+Math.pow(g-e,2)),10<this.hasDragged&&(x=c.isInsidePlot(w-l,g-y),c.hasCartesianSeries&&(this.zoomX||this.zoomY)&&x&&!C&&!h&&(this.selectionMarker=h=c.renderer.rect(l,y,b?1:A,k?1:n,0).attr({fill:d.selectionMarkerFill||E("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",
	zIndex:7}).add()),h&&b&&(f-=w,h.attr({width:Math.abs(f),x:(0<f?0:f)+w})),h&&k&&(f=e-g,h.attr({height:Math.abs(f),y:(0<f?0:f)+g})),x&&!h&&d.panning&&c.pan(a,d.panning)))},drop:function(a){var c=this,d=this.chart,f=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},b=this.selectionMarker,k=b.attr?b.attr("x"):b.x,l=b.attr?b.attr("y"):b.y,y=b.attr?b.attr("width"):b.width,A=b.attr?b.attr("height"):b.height,n;if(this.hasDragged||f)p(d.axes,function(b){if(b.zoomEnabled&&g(b.min)&&
	(f||c[{xAxis:"zoomX",yAxis:"zoomY"}[b.coll]])){var h=b.horiz,d="touchend"===a.type?b.minPixelPadding:0,m=b.toValue((h?k:l)+d),h=b.toValue((h?k+y:l+A)-d);e[b.coll].push({axis:b,min:Math.min(m,h),max:Math.max(m,h)});n=!0}}),n&&u(d,"selection",e,function(a){d.zoom(t(a,f?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();f&&this.scaleGroups()}d&&(r(d.container,{cursor:d._cursor}),d.cancelClick=10<this.hasDragged,d.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=
	[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(c){G[a.hoverChartIndex]&&G[a.hoverChartIndex].pointer.drop(c)},onDocumentMouseMove:function(a){var c=this.chart,d=this.chartPosition;a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop)||this.reset()},onContainerMouseLeave:function(c){var d=G[a.hoverChartIndex];d&&(c.relatedTarget||
	c.toElement)&&(d.pointer.reset(),d.pointer.chartPosition=null)},onContainerMouseMove:function(c){var d=this.chart;g(a.hoverChartIndex)&&G[a.hoverChartIndex]&&G[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=d.index);c=this.normalize(c);c.returnValue=!1;"mousedown"===d.mouseIsDown&&this.drag(c);!this.inClass(c.target,"highcharts-tracker")&&!d.isInsidePlot(c.chartX-d.plotLeft,c.chartY-d.plotTop)||d.openMenu||this.runPointActions(c)},inClass:function(a,d){for(var c;a;){if(c=B(a,"class")){if(-1!==
	c.indexOf(d))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var c=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!c||!a||c.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+c.index)&&this.inClass(a,"highcharts-tracker")))c.onMouseOut()},onContainerClick:function(a){var c=this.chart,d=c.hoverPoint,f=c.plotLeft,e=c.plotTop;a=this.normalize(a);c.cancelClick||(d&&this.inClass(a.target,
	"highcharts-tracker")?(u(d.series,"click",t(a,{point:d})),c.hoverPoint&&d.firePointEvent("click",a)):(t(a,this.getCoordinates(a)),c.isInsidePlot(a.chartX-f,a.chartY-e)&&u(c,"click",a)))},setDOMEvents:function(){var c=this,d=c.chart.container,f=d.ownerDocument;d.onmousedown=function(a){c.onContainerMouseDown(a)};d.onmousemove=function(a){c.onContainerMouseMove(a)};d.onclick=function(a){c.onContainerClick(a)};D(d,"mouseleave",c.onContainerMouseLeave);1===a.chartCount&&D(f,"mouseup",c.onDocumentMouseUp);
	a.hasTouch&&(d.ontouchstart=function(a){c.onContainerTouchStart(a)},d.ontouchmove=function(a){c.onContainerTouchMove(a)},1===a.chartCount&&D(f,"touchend",c.onDocumentTouchEnd))},destroy:function(){var c=this,d=this.chart.container.ownerDocument;c.unDocMouseMove&&c.unDocMouseMove();f(c.chart.container,"mouseleave",c.onContainerMouseLeave);a.chartCount||(f(d,"mouseup",c.onDocumentMouseUp),a.hasTouch&&f(d,"touchend",c.onDocumentTouchEnd));clearInterval(c.tooltipTimeout);a.objectEach(c,function(a,d){c[d]=
	null})}}})(M);(function(a){var D=a.charts,B=a.each,G=a.extend,E=a.map,r=a.noop,g=a.pick;G(a.Pointer.prototype,{pinchTranslate:function(a,g,r,u,l,e){this.zoomHor&&this.pinchTranslateDirection(!0,a,g,r,u,l,e);this.zoomVert&&this.pinchTranslateDirection(!1,a,g,r,u,l,e)},pinchTranslateDirection:function(a,g,r,u,l,e,k,f){var d=this.chart,x=a?"x":"y",C=a?"X":"Y",c="chart"+C,q=a?"width":"height",p=d["plot"+(a?"Left":"Top")],m,t,b=f||1,z=d.inverted,K=d.bounds[a?"h":"v"],y=1===g.length,A=g[0][c],n=r[0][c],
	H=!y&&g[1][c],h=!y&&r[1][c],w;r=function(){!y&&20<Math.abs(A-H)&&(b=f||Math.abs(n-h)/Math.abs(A-H));t=(p-n)/b+A;m=d["plot"+(a?"Width":"Height")]/b};r();g=t;g<K.min?(g=K.min,w=!0):g+m>K.max&&(g=K.max-m,w=!0);w?(n-=.8*(n-k[x][0]),y||(h-=.8*(h-k[x][1])),r()):k[x]=[n,h];z||(e[x]=t-p,e[q]=m);e=z?1/b:b;l[q]=m;l[x]=g;u[z?a?"scaleY":"scaleX":"scale"+C]=b;u["translate"+C]=e*p+(n-e*A)},pinch:function(a){var p=this,v=p.chart,u=p.pinchDown,l=a.touches,e=l.length,k=p.lastValidTouch,f=p.hasZoom,d=p.selectionMarker,
	x={},C=1===e&&(p.inClass(a.target,"highcharts-tracker")&&v.runTrackerClick||p.runChartClick),c={};1<e&&(p.initiated=!0);f&&p.initiated&&!C&&a.preventDefault();E(l,function(a){return p.normalize(a)});"touchstart"===a.type?(B(l,function(a,c){u[c]={chartX:a.chartX,chartY:a.chartY}}),k.x=[u[0].chartX,u[1]&&u[1].chartX],k.y=[u[0].chartY,u[1]&&u[1].chartY],B(v.axes,function(a){if(a.zoomEnabled){var c=v.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,f=a.toPixels(g(a.options.min,a.dataMin)),b=a.toPixels(g(a.options.max,
	a.dataMax)),e=Math.max(f,b);c.min=Math.min(a.pos,Math.min(f,b)-d);c.max=Math.max(a.pos+a.len,e+d)}}),p.res=!0):p.followTouchMove&&1===e?this.runPointActions(p.normalize(a)):u.length&&(d||(p.selectionMarker=d=G({destroy:r,touch:!0},v.plotBox)),p.pinchTranslate(u,l,x,d,c,k),p.hasPinched=f,p.scaleGroups(x,c),p.res&&(p.res=!1,this.reset(!1,0)))},touch:function(p,t){var r=this.chart,u,l;if(r.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=r.index;1===p.touches.length?
	(p=this.normalize(p),(l=r.isInsidePlot(p.chartX-r.plotLeft,p.chartY-r.plotTop))&&!r.openMenu?(t&&this.runPointActions(p),"touchmove"===p.type&&(t=this.pinchDown,u=t[0]?4<=Math.sqrt(Math.pow(t[0].chartX-p.chartX,2)+Math.pow(t[0].chartY-p.chartY,2)):!1),g(u,!0)&&this.pinch(p)):t&&this.reset()):2===p.touches.length&&this.pinch(p)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(g){D[a.hoverChartIndex]&&
	D[a.hoverChartIndex].pointer.drop(g)}})})(M);(function(a){var D=a.addEvent,B=a.charts,G=a.css,E=a.doc,r=a.extend,g=a.noop,p=a.Pointer,t=a.removeEvent,v=a.win,u=a.wrap;if(!a.hasTouch&&(v.PointerEvent||v.MSPointerEvent)){var l={},e=!!v.PointerEvent,k=function(){var d=[];d.item=function(a){return this[a]};a.objectEach(l,function(a){d.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return d},f=function(d,f,e,c){"touch"!==d.pointerType&&d.pointerType!==d.MSPOINTER_TYPE_TOUCH||!B[a.hoverChartIndex]||
	(c(d),c=B[a.hoverChartIndex].pointer,c[f]({type:e,target:d.currentTarget,preventDefault:g,touches:k()}))};r(p.prototype,{onContainerPointerDown:function(a){f(a,"onContainerTouchStart","touchstart",function(a){l[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){f(a,"onContainerTouchMove","touchmove",function(a){l[a.pointerId]={pageX:a.pageX,pageY:a.pageY};l[a.pointerId].target||(l[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){f(a,
	"onDocumentTouchEnd","touchend",function(a){delete l[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,e?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,e?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(E,e?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});u(p.prototype,"init",function(a,f,e){a.call(this,f,e);this.hasZoom&&G(f.container,{"-ms-touch-action":"none","touch-action":"none"})});u(p.prototype,"setDOMEvents",function(a){a.apply(this);
	(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(D)});u(p.prototype,"destroy",function(a){this.batchMSEvents(t);a.call(this)})}})(M);(function(a){var D=a.addEvent,B=a.css,G=a.discardElement,E=a.defined,r=a.each,g=a.isFirefox,p=a.marginNames,t=a.merge,v=a.pick,u=a.setAnimation,l=a.stableSort,e=a.win,k=a.wrap;a.Legend=function(a,d){this.init(a,d)};a.Legend.prototype={init:function(a,d){this.chart=a;this.setOptions(d);d.enabled&&(this.render(),D(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},
	setOptions:function(a){var d=v(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=t(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=d;this.initialItemY=d-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=v(a.symbolWidth,16);this.pages=[]},update:function(a,d){var f=this.chart;this.setOptions(t(!0,this.options,a));this.destroy();f.isDirtyLegend=f.isDirtyBox=!0;v(d,!0)&&f.redraw()},colorizeItem:function(a,d){a.legendGroup[d?"removeClass":
	"addClass"]("highcharts-legend-item-hidden");var f=this.options,e=a.legendItem,c=a.legendLine,k=a.legendSymbol,l=this.itemHiddenStyle.color,f=d?f.itemStyle.color:l,m=d?a.color||l:l,g=a.options&&a.options.marker,b={fill:m};e&&e.css({fill:f,color:f});c&&c.attr({stroke:m});k&&(g&&k.isMarker&&(b=a.pointAttribs(),d||(b.stroke=b.fill=l)),k.attr(b))},positionItem:function(a){var d=this.options,f=d.symbolPadding,d=!d.rtl,e=a._legendItemPos,c=e[0],e=e[1],k=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(d?
	c:this.legendWidth-c-2*f-4,e);k&&(k.x=c,k.y=e)},destroyItem:function(a){var d=a.checkbox;r(["legendItem","legendLine","legendSymbol","legendGroup"],function(d){a[d]&&(a[d]=a[d].destroy())});d&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}r(this.getAllItems(),function(d){r(["legendItem","legendGroup"],a,d)});r("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(a){var d=this.group&&this.group.alignAttr,
	f,e=this.clipHeight||this.legendHeight,c=this.titleHeight;d&&(f=d.translateY,r(this.allItems,function(k){var l=k.checkbox,m;l&&(m=f+c+l.y+(a||0)+3,B(l,{left:d.translateX+k.checkboxOffset+l.x-20+"px",top:m+"px",display:m>f-6&&m<f+e-6?"":"none"}))}))},renderTitle:function(){var a=this.options,d=this.padding,e=a.title,k=0;e.text&&(this.title||(this.title=this.chart.renderer.label(e.text,d-3,d-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(e.style).add(this.group)),a=this.title.getBBox(),
	k=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:k}));this.titleHeight=k},setText:function(f){var d=this.options;f.legendItem.attr({text:d.labelFormat?a.format(d.labelFormat,f):d.labelFormatter.call(f)})},renderItem:function(a){var d=this.chart,f=d.renderer,e=this.options,c="horizontal"===e.layout,k=this.symbolWidth,l=e.symbolPadding,m=this.itemStyle,g=this.itemHiddenStyle,b=this.padding,z=c?v(e.itemDistance,20):0,p=!e.rtl,y=e.width,A=e.itemMarginBottom||0,n=this.itemMarginTop,
	H=a.legendItem,h=!a.series,w=!h&&a.series.drawLegendSymbol?a.series:a,r=w.options,L=this.createCheckboxForItem&&r&&r.showCheckbox,r=k+l+z+(L?20:0),u=e.useHTML,N=a.options.className;H||(a.legendGroup=f.g("legend-item").addClass("highcharts-"+w.type+"-series highcharts-color-"+a.colorIndex+(N?" "+N:"")+(h?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=H=f.text("",p?k+l:-l,this.baseline||0,u).css(t(a.visible?m:g)).attr({align:p?"left":"right",zIndex:2}).add(a.legendGroup),
	this.baseline||(k=m.fontSize,this.fontMetrics=f.fontMetrics(k,H),this.baseline=this.fontMetrics.f+3+n,H.attr("y",this.baseline)),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,w.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,H,u),L&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);m.width||H.css({width:(e.itemWidth||e.width||d.spacingBox.width)-r});this.setText(a);f=H.getBBox();m=a.checkboxOffset=e.itemWidth||a.legendItemWidth||f.width+r;this.itemHeight=f=Math.round(a.legendItemHeight||
	f.height||this.symbolHeight);c&&this.itemX-b+m>(y||d.spacingBox.width-2*b-e.x)&&(this.itemX=b,this.itemY+=n+this.lastLineHeight+A,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,m);this.lastItemY=n+this.itemY+A;this.lastLineHeight=Math.max(f,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];c?this.itemX+=m:(this.itemY+=n+f+A,this.lastLineHeight=f);this.offsetWidth=y||Math.max((c?this.itemX-b-(a.checkbox?0:z):m)+b,this.offsetWidth)},getAllItems:function(){var a=[];r(this.chart.series,
	function(d){var f=d&&d.options;d&&v(f.showInLegend,E(f.linkedTo)?!1:void 0,!0)&&(a=a.concat(d.legendItems||("point"===f.legendType?d.data:d)))});return a},adjustMargins:function(a,d){var f=this.chart,e=this.options,c=e.align.charAt(0)+e.verticalAlign.charAt(0)+e.layout.charAt(0);e.floating||r([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(k,l){k.test(c)&&!E(a[l])&&(f[p[l]]=Math.max(f[p[l]],f.legend[(l+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][l]*e[l%2?"x":"y"]+v(e.margin,
	12)+d[l]))})},render:function(){var a=this,d=a.chart,e=d.renderer,k=a.group,c,q,g,m,p=a.box,b=a.options,z=a.padding;a.itemX=z;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;k||(a.group=k=e.g("legend").attr({zIndex:7}).add(),a.contentGroup=e.g().attr({zIndex:1}).add(k),a.scrollGroup=e.g().add(a.contentGroup));a.renderTitle();c=a.getAllItems();l(c,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});b.reversed&&c.reverse();a.allItems=c;a.display=q=
	!!c.length;a.lastLineHeight=0;r(c,function(b){a.renderItem(b)});g=(b.width||a.offsetWidth)+z;m=a.lastItemY+a.lastLineHeight+a.titleHeight;m=a.handleOverflow(m);m+=z;p||(a.box=p=e.rect().addClass("highcharts-legend-box").attr({r:b.borderRadius}).add(k),p.isNew=!0);p.attr({stroke:b.borderColor,"stroke-width":b.borderWidth||0,fill:b.backgroundColor||"none"}).shadow(b.shadow);0<g&&0<m&&(p[p.isNew?"attr":"animate"](p.crisp({x:0,y:0,width:g,height:m},p.strokeWidth())),p.isNew=!1);p[q?"show":"hide"]();a.legendWidth=
	g;a.legendHeight=m;r(c,function(b){a.positionItem(b)});q&&k.align(t(b,{width:g,height:m}),!0,"spacingBox");d.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var d=this,f=this.chart,e=f.renderer,c=this.options,k=c.y,l=this.padding,f=f.spacingBox.height+("top"===c.verticalAlign?-k:k)-l,k=c.maxHeight,m,g=this.clipRect,b=c.navigation,z=v(b.animation,!0),p=b.arrowSize||12,y=this.nav,A=this.pages,n,H=this.allItems,h=function(a){"number"===typeof a?g.attr({height:a}):g&&(d.clipRect=g.destroy(),
	d.contentGroup.clip());d.contentGroup.div&&(d.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")};"horizontal"!==c.layout||"middle"===c.verticalAlign||c.floating||(f/=2);k&&(f=Math.min(f,k));A.length=0;a>f&&!1!==b.enabled?(this.clipHeight=m=Math.max(f-20-this.titleHeight-l,0),this.currentPage=v(this.currentPage,1),this.fullHeight=a,r(H,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var d=A.length;if(!d||c-A[d-1]>m&&(n||c)!==A[d-1])A.push(n||
	c),d++;b===H.length-1&&c+a-A[d-1]>m&&A.push(c);c!==n&&(n=c)}),g||(g=d.clipRect=e.clipRect(0,l,9999,0),d.contentGroup.clip(g)),h(m),y||(this.nav=y=e.g().attr({zIndex:1}).add(this.group),this.up=e.symbol("triangle",0,0,p,p).on("click",function(){d.scroll(-1,z)}).add(y),this.pager=e.text("",15,10).addClass("highcharts-legend-navigation").css(b.style).add(y),this.down=e.symbol("triangle-down",0,0,p,p).on("click",function(){d.scroll(1,z)}).add(y)),d.scroll(0),a=f):y&&(h(),this.nav=y.destroy(),this.scrollGroup.attr({translateY:1}),
	this.clipHeight=0);return a},scroll:function(a,d){var f=this.pages,e=f.length;a=this.currentPage+a;var c=this.clipHeight,k=this.options.navigation,l=this.pager,m=this.padding;a>e&&(a=e);0<a&&(void 0!==d&&u(d,this.chart),this.nav.attr({translateX:m,translateY:c+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),l.attr({text:a+"/"+e}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===e?"highcharts-legend-nav-inactive":
	"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?k.inactiveColor:k.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===e?k.inactiveColor:k.activeColor}).css({cursor:a===e?"default":"pointer"}),d=-f[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:d}),this.currentPage=a,this.positionCheckboxes(d))}};a.LegendSymbolMixin={drawRectangle:function(a,d){var f=a.symbolHeight,e=a.options.squareSymbol;d.legendSymbol=this.chart.renderer.rect(e?(a.symbolWidth-f)/
	2:0,a.baseline-f+1,e?f:a.symbolWidth,f,v(a.options.symbolRadius,f/2)).addClass("highcharts-point").attr({zIndex:3}).add(d.legendGroup)},drawLineMarker:function(a){var d=this.options,f=d.marker,e=a.symbolWidth,c=a.symbolHeight,k=c/2,l=this.chart.renderer,m=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var g;g={"stroke-width":d.lineWidth||0};d.dashStyle&&(g.dashstyle=d.dashStyle);this.legendLine=l.path(["M",0,a,"L",e,a]).addClass("highcharts-graph").attr(g).add(m);f&&!1!==f.enabled&&
	(d=Math.min(v(f.radius,k),k),0===this.symbol.indexOf("url")&&(f=t(f,{width:c,height:c}),d=0),this.legendSymbol=f=l.symbol(this.symbol,e/2-d,a-d,2*d,2*d,f).addClass("highcharts-point").add(m),f.isMarker=!0)}};(/Trident\/7\.0/.test(e.navigator.userAgent)||g)&&k(a.Legend.prototype,"positionItem",function(a,d){var f=this,e=function(){d._legendItemPos&&a.call(f,d)};e();setTimeout(e)})})(M);(function(a){var D=a.addEvent,B=a.animate,G=a.animObject,E=a.attr,r=a.doc,g=a.Axis,p=a.createElement,t=a.defaultOptions,
	v=a.discardElement,u=a.charts,l=a.css,e=a.defined,k=a.each,f=a.extend,d=a.find,x=a.fireEvent,C=a.getStyle,c=a.grep,q=a.isNumber,I=a.isObject,m=a.isString,J=a.Legend,b=a.marginNames,z=a.merge,K=a.objectEach,y=a.Pointer,A=a.pick,n=a.pInt,H=a.removeEvent,h=a.seriesTypes,w=a.splat,P=a.svg,L=a.syncTimeout,Q=a.win,N=a.Renderer,O=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new O(a,b,c)};f(O.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);
	if(m(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var d,h,n=b.series,f=b.plotOptions||{};b.series=null;d=z(t,b);for(h in d.plotOptions)d.plotOptions[h].tooltip=f[h]&&z(f[h].tooltip)||void 0;d.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;d.series=b.series=n;this.userOptions=b;b=d.chart;h=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=d;this.axes=[];this.series=
	[];this.hasCartesianSeries=b.showAxes;var e=this;e.index=u.length;u.push(e);a.chartCount++;h&&K(h,function(a,b){D(e,b,a)});e.xAxis=[];e.yAxis=[];e.pointCount=e.colorCounter=e.symbolCounter=0;e.firstRender()},initSeries:function(b){var c=this.options.chart;(c=h[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,
	b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var c=this.axes,d=this.series,h=this.pointer,n=this.legend,e=this.isDirtyLegend,m,y,l=this.hasCartesianSeries,w=this.isDirtyBox,A,q=this.renderer,g=q.isHidden(),H=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);g&&this.temporaryDisplay();this.layOutTitles();for(b=d.length;b--;)if(A=d[b],A.options.stacking&&(m=!0,A.isDirty)){y=!0;break}if(y)for(b=d.length;b--;)A=d[b],A.options.stacking&&
	(A.isDirty=!0);k(d,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),e=!0);a.isDirtyData&&x(a,"updatedData")});e&&n.options.enabled&&(n.render(),this.isDirtyLegend=!1);m&&this.getStacks();l&&k(c,function(a){a.updateNames();a.setScale()});this.getMargins();l&&(k(c,function(a){a.isDirty&&(w=!0)}),k(c,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,H.push(function(){x(a,"afterSetExtremes",f(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(w||m)&&
	a.redraw()}));w&&this.drawChartBox();x(this,"predraw");k(d,function(a){(w||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});h&&h.reset(!0);q.draw();x(this,"redraw");x(this,"render");g&&this.temporaryDisplay(!0);k(H,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,h=this.series,n;c=d(this.axes,b)||d(this.series,b);for(n=0;!c&&n<h.length;n++)c=d(h[n].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=w(b.xAxis||
	{}),b=b.yAxis=w(b.yAxis||{});k(c,function(a,b){a.index=b;a.isX=!0});k(b,function(a,b){a.index=b});c=c.concat(b);k(c,function(b){new g(a,b)})},getSelectedPoints:function(){var a=[];k(this.series,function(b){a=a.concat(c(b.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return c(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var d=this,h=d.options,n;n=h.title=z({style:{color:"#333333",fontSize:h.isStock?"16px":"18px"}},h.title,a);h=h.subtitle=
	z({style:{color:"#666666"}},h.subtitle,b);k([["title",a,n],["subtitle",b,h]],function(a,b){var c=a[0],h=d[c],n=a[1];a=a[2];h&&n&&(d[c]=h=h.destroy());a&&a.text&&!h&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},layOutTitles:function(a){var b=0,c,d=this.renderer,h=this.spacingBox;k(["title","subtitle"],function(a){var c=this[a],n=this.options[a];
	a="title"===a?-3:n.verticalAlign?0:b+2;var e;c&&(e=n.style.fontSize,e=d.fontMetrics(e,c).b,c.css({width:(n.width||h.width+n.widthAdjust)+"px"}).align(f({y:a+e},n),!1,"spacingBox"),n.floating||n.verticalAlign||(b=Math.ceil(b+c.getBBox(n.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=c,this.hasRendered&&A(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,c=b.width,b=b.height,d=this.renderTo;e(c)||(this.containerWidth=
	C(d,"width"));e(b)||(this.containerHeight=C(d,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||this.containerHeight||400)},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(r.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){r.body.contains(c)||(c.hcOrigDetached=!0,r.body.appendChild(c));
	if("none"===C(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===r.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,d=c.chart,h,e;b=this.renderTo;var y=a.uniqueKey(),k;b||
	(this.renderTo=b=d.renderTo);m(b)&&(this.renderTo=b=r.getElementById(b));b||a.error(13,!0);h=n(E(b,"data-highcharts-chart"));q(h)&&u[h]&&u[h].hasRendered&&u[h].destroy();E(b,"data-highcharts-chart",this.index);b.innerHTML="";d.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();h=this.chartWidth;e=this.chartHeight;k=f({position:"relative",overflow:"hidden",width:h+"px",height:e+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},d.style);
	this.container=b=p("div",{id:y},k,b);this._cursor=b.style.cursor;this.renderer=new (a[d.renderer]||N)(b,h,e,null,d.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(d.className);this.renderer.setStyle(d.style);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,d=this.titleOffset;this.resetMargins();d&&!e(c[0])&&(this.plotTop=Math.max(this.plotTop,d+this.options.title.margin+b[0]));this.legend.display&&this.legend.adjustMargins(c,b);this.extraMargin&&
	(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,c=a.axisOffset=[0,0,0,0],d=a.margin;a.hasCartesianSeries&&k(a.axes,function(a){a.visible&&a.getOffset()});k(b,function(b,h){e(d[h])||(a[b]+=c[h])});a.setChartSize()},reflow:function(a){var b=this,c=b.options.chart,d=b.renderTo,h=e(c.width)&&e(c.height),n=c.width||C(d,"width"),c=c.height||C(d,"height"),
	d=a?a.target:Q;if(!h&&!b.isPrinting&&n&&c&&(d===Q||d===r)){if(n!==b.containerWidth||c!==b.containerHeight)clearTimeout(b.reflowTimeout),b.reflowTimeout=L(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=n;b.containerHeight=c}},initReflow:function(){var a=this,b;b=D(Q,"resize",function(b){a.reflow(b)});D(a,"destroy",b)},setSize:function(b,c,d){var h=this,n=h.renderer;h.isResizing+=1;a.setAnimation(d,h);h.oldChartHeight=h.chartHeight;h.oldChartWidth=h.chartWidth;void 0!==
	b&&(h.options.chart.width=b);void 0!==c&&(h.options.chart.height=c);h.getChartSize();b=n.globalAnimation;(b?B:l)(h.container,{width:h.chartWidth+"px",height:h.chartHeight+"px"},b);h.setChartSize(!0);n.setSize(h.chartWidth,h.chartHeight,d);k(h.axes,function(a){a.isDirty=!0;a.setScale()});h.isDirtyLegend=!0;h.isDirtyBox=!0;h.layOutTitles();h.getMargins();h.redraw(d);h.oldChartHeight=null;x(h,"resize");L(function(){h&&x(h,"endResize",null,function(){--h.isResizing})},G(b).duration)},setChartSize:function(a){function b(a){a=
	m[a]||0;return Math.max(q||a,a)/2}var c=this.inverted,h=this.renderer,d=this.chartWidth,n=this.chartHeight,e=this.options.chart,f=this.spacing,m=this.clipOffset,y,l,w,A,q;this.plotLeft=y=Math.round(this.plotLeft);this.plotTop=l=Math.round(this.plotTop);this.plotWidth=w=Math.max(0,Math.round(d-y-this.marginRight));this.plotHeight=A=Math.max(0,Math.round(n-l-this.marginBottom));this.plotSizeX=c?A:w;this.plotSizeY=c?w:A;this.plotBorderWidth=e.plotBorderWidth||0;this.spacingBox=h.spacingBox={x:f[3],y:f[0],
	width:d-f[3]-f[1],height:n-f[0]-f[2]};this.plotBox=h.plotBox={x:y,y:l,width:w,height:A};q=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(b(3));h=Math.ceil(b(0));this.clipBox={x:c,y:h,width:Math.floor(this.plotSizeX-b(1)-c),height:Math.max(0,Math.floor(this.plotSizeY-b(2)-h))};a||k(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,c=a.options.chart;k(["margin","spacing"],function(b){var h=c[b],d=I(h)?h:[h,h,h,h];k(["Top","Right","Bottom","Left"],function(h,
	n){a[b][n]=A(c[b+h],d[n])})});k(b,function(b,c){a[b]=A(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,h=this.chartHeight,d=this.chartBackground,n=this.plotBackground,e=this.plotBorder,f,m=this.plotBGImage,y=a.backgroundColor,k=a.plotBackgroundColor,l=a.plotBackgroundImage,w,A=this.plotLeft,q=this.plotTop,g=this.plotWidth,H=this.plotHeight,z=this.plotBox,p=this.clipRect,x=this.clipBox,C="animate";
	d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),C="attr");f=a.borderWidth||0;w=f+(a.shadow?8:0);y={fill:y||"none"};if(f||d["stroke-width"])y.stroke=a.borderColor,y["stroke-width"]=f;d.attr(y).shadow(a.shadow);d[C]({x:w/2,y:w/2,width:c-w-f%2,height:h-w-f%2,r:a.borderRadius});C="animate";n||(C="attr",this.plotBackground=n=b.rect().addClass("highcharts-plot-background").add());n[C](z);n.attr({fill:k||"none"}).shadow(a.plotShadow);l&&(m?m.animate(z):this.plotBGImage=b.image(l,
	A,q,g,H).add());p?p.animate({width:x.width,height:x.height}):this.clipRect=b.clipRect(x);C="animate";e||(C="attr",this.plotBorder=e=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());e.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});e[C](e.crisp({x:A,y:q,width:g,height:H},-e.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,n,e;k(["inverted","angular","polar"],function(f){c=h[b.type||b.defaultSeriesType];
	e=b[f]||c&&c.prototype[f];for(n=d&&d.length;!e&&n--;)(c=h[d[n].type])&&c.prototype[f]&&(e=!0);a[f]=e})},linkSeries:function(){var a=this,b=a.series;k(b,function(a){a.linkedSeries.length=0});k(b,function(b){var c=b.options.linkedTo;m(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=A(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){k(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=
	this,b=a.options.labels;b.items&&k(b.items,function(c){var h=f(b.style,c.style),d=n(h.left)+a.plotLeft,e=n(h.top)+a.plotTop+12;delete h.left;delete h.top;a.renderer.text(c.html,d,e).attr({zIndex:2}).css(h).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,h,d,n;this.setTitle();this.legend=new J(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;h=this.plotHeight-=21;k(a,function(a){a.setScale()});this.getAxisMargins();d=
	1.1<c/this.plotWidth;n=1.05<h/this.plotHeight;if(d||n)k(a,function(a){(a.horiz&&d||!a.horiz&&n)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&k(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=z(!0,this.options.credits,a);a.enabled&&!this.credits&&
	(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(Q.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,h=b.series,d=b.container,n,e=d&&d.parentNode;x(b,"destroy");b.renderer.forExport?a.erase(u,b):u[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");
	H(b);for(n=c.length;n--;)c[n]=c[n].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(n=h.length;n--;)h[n]=h[n].destroy();k("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});d&&(d.innerHTML="",H(d),e&&v(d));K(b,function(a,c){delete b[c]})},isReadyToRender:function(){var a=this;return P||Q!=Q.top||
	"complete"===r.readyState?!0:(r.attachEvent("onreadystatechange",function(){r.detachEvent("onreadystatechange",a.firstRender);"complete"===r.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();x(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();k(b.series||[],function(b){a.initSeries(b)});a.linkSeries();x(a,"beforeRender");y&&(a.pointer=new y(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();
	a.temporaryDisplay(!0)}},onload:function(){k([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);x(this,"load");x(this,"render");e(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}})})(M);(function(a){var D,B=a.each,G=a.extend,E=a.erase,r=a.fireEvent,g=a.format,p=a.isArray,t=a.isNumber,v=a.pick,u=a.removeEvent;a.Point=D=function(){};a.Point.prototype={init:function(a,e,k){this.series=a;this.color=a.color;this.applyOptions(e,
	k);a.options.colorByPoint?(e=a.options.colors||a.chart.options.colors,this.color=this.color||e[a.colorCounter],e=e.length,k=a.colorCounter,a.colorCounter++,a.colorCounter===e&&(a.colorCounter=0)):k=a.colorIndex;this.colorIndex=v(this.colorIndex,k);a.chart.pointCount++;return this},applyOptions:function(a,e){var k=this.series,f=k.options.pointValKey||k.pointValKey;a=D.prototype.optionsToObject.call(this,a);G(this,a);this.options=this.options?G(this.options,a):a;a.group&&delete this.group;f&&(this.y=
	this[f]);this.isNull=v(this.isValid&&!this.isValid(),null===this.x||!t(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===e&&k.xAxis&&k.xAxis.hasNames&&(this.x=k.xAxis.nameToX(this));void 0===this.x&&k&&(this.x=void 0===e?k.autoIncrement(this):e);return this},optionsToObject:function(a){var e={},k=this.series,f=k.options.keys,d=f||k.pointArrayMap||["y"],l=d.length,g=0,c=0;if(t(a)||null===a)e[d[0]]=a;else if(p(a))for(!f&&a.length>l&&(k=typeof a[0],"string"===k?e.name=a[0]:"number"===
	k&&(e.x=a[0]),g++);c<l;)f&&void 0===a[g]||(e[d[c]]=a[g]),g++,c++;else"object"===typeof a&&(e=a,a.dataLabels&&(k._hasPointLabels=!0),a.marker&&(k._hasPointMarkers=!0));return e},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?
	" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,e=a.zones,a=a.zoneAxis||"y",k=0,f;for(f=e[k];this[a]>=f.value;)f=e[++k];f&&f.color&&!this.options.color&&(this.color=f.color);return f},destroy:function(){var a=this.series.chart,e=a.hoverPoints,k;a.pointCount--;e&&(this.setState(),E(e,this),e.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)u(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);
	for(k in this)this[k]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],e,k=6;k--;)e=a[k],this[e]&&(this[e]=this[e].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var e=this.series,k=e.tooltipOptions,f=v(k.valueDecimals,""),
	d=k.valuePrefix||"",l=k.valueSuffix||"";B(e.pointArrayMap||["y"],function(e){e="{point."+e;if(d||l)a=a.replace(e+"}",d+e+"}"+l);a=a.replace(e+"}",e+":,."+f+"f}")});return g(a,{point:this,series:this.series})},firePointEvent:function(a,e,k){var f=this,d=this.series.options;(d.point.events[a]||f.options&&f.options.events&&f.options.events[a])&&this.importEvents();"click"===a&&d.allowPointSelect&&(k=function(a){f.select&&f.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});r(this,a,e,k)},visible:!0}})(M);
	(function(a){var D=a.addEvent,B=a.animObject,G=a.arrayMax,E=a.arrayMin,r=a.correctFloat,g=a.Date,p=a.defaultOptions,t=a.defaultPlotOptions,v=a.defined,u=a.each,l=a.erase,e=a.extend,k=a.fireEvent,f=a.grep,d=a.isArray,x=a.isNumber,C=a.isString,c=a.merge,q=a.objectEach,I=a.pick,m=a.removeEvent,J=a.splat,b=a.SVGElement,z=a.syncTimeout,K=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,
	states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},
	halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,d,h=a.series,f;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();e(c,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});d=b.events;q(d,function(a,b){D(c,b,a)});if(d&&
	d.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();u(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);h.length&&(f=h[h.length-1]);c._i=I(f&&f._i,-1)+1;a.orderSeries(this.insert(h))},insert:function(a){var b=this.options.index,c;if(x(b)){for(c=a.length;c--;)if(b>=I(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return I(c,
	a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;u(b.axisTypes||[],function(h){u(d[h],function(a){e=a.options;if(c[h]===e.index||void 0!==c[h]&&c[h]===e.id||void 0===c[h]&&0===e.index)b.insert(a.series),b[h]=a,a.isDirty=!0});b[h]||b.optionalAxis===h||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,h=x(b)?function(h){var d="y"===h&&c.toYData?c.toYData(a):a[h];c[h+"Data"][b]=d}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,
	2))};u(c.parallelArrays,h)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,b=I(b,a.pointStart,0);this.pointInterval=c=I(this.pointInterval,a.pointInterval,1);d&&(a=new g(b),"day"===d?a=+a[g.hcSetDate](a[g.hcGetDate]()+c):"month"===d?a=+a[g.hcSetMonth](a[g.hcGetMonth]()+c):"year"===d&&(a=+a[g.hcSetFullYear](a[g.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,d=b.options,e=d.plotOptions,h=(b.userOptions||{}).plotOptions||
	{},f=e[this.type];this.userOptions=a;b=c(f,e.series,a);this.tooltipOptions=c(p.tooltip,p.plotOptions.series&&p.plotOptions.series.tooltip,p.plotOptions[this.type].tooltip,d.tooltip.userOptions,e.series&&e.series.tooltip,e[this.type].tooltip,a.tooltip);this.stickyTracking=I(a.stickyTracking,h[this.type]&&h[this.type].stickyTracking,h.series&&h.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===f.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=
	(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&v(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return b},getCyclic:function(a,b,c){var d,h=this.chart,n=this.userOptions,e=a+"Index",f=a+"Counter",m=c?c.length:I(h.options.chart[a+"Count"],h[a+"Count"]);b||(d=I(n[e],n["_"+e]),v(d)||(h.series.length||
	(h[f]=0),n["_"+e]=d=h[f]%m,h[f]+=1),c&&(b=c[d]));void 0!==d&&(this[e]=d);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||t[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(b,c,n,e){var h=this,f=h.points,m=f&&f.length||0,k,y=h.options,l=h.chart,q=null,g=h.xAxis,
	A=y.turboThreshold,H=this.xData,z=this.yData,p=(k=h.pointArrayMap)&&k.length;b=b||[];k=b.length;c=I(c,!0);if(!1!==e&&k&&m===k&&!h.cropped&&!h.hasGroupedData&&h.visible)u(b,function(a,b){f[b].update&&a!==y.data[b]&&f[b].update(a,!1,null,!1)});else{h.xIncrement=null;h.colorCounter=0;u(this.parallelArrays,function(a){h[a+"Data"].length=0});if(A&&k>A){for(n=0;null===q&&n<k;)q=b[n],n++;if(x(q))for(n=0;n<k;n++)H[n]=this.autoIncrement(),z[n]=b[n];else if(d(q))if(p)for(n=0;n<k;n++)q=b[n],H[n]=q[0],z[n]=q.slice(1,
	p+1);else for(n=0;n<k;n++)q=b[n],H[n]=q[0],z[n]=q[1];else a.error(12)}else for(n=0;n<k;n++)void 0!==b[n]&&(q={series:h},h.pointClass.prototype.applyOptions.apply(q,[b[n]]),h.updateParallelArrays(q,n));C(z[0])&&a.error(14,!0);h.data=[];h.options.data=h.userOptions.data=b;for(n=m;n--;)f[n]&&f[n].destroy&&f[n].destroy();g&&(g.minRange=g.userMinRange);h.isDirty=l.isDirtyBox=!0;h.isDirtyData=!!f;n=!1}"point"===y.legendType&&(this.processData(),this.generatePoints());c&&l.redraw(n)},processData:function(b){var c=
	this.xData,d=this.yData,e=c.length,h;h=0;var f,m,k=this.xAxis,y,l=this.options;y=l.cropThreshold;var q=this.getExtremesFromAll||l.getExtremesFromAll,g=this.isCartesian,l=k&&k.val2lin,z=k&&k.isLog,p,x;if(g&&!this.isDirty&&!k.isDirty&&!this.yAxis.isDirty&&!b)return!1;k&&(b=k.getExtremes(),p=b.min,x=b.max);if(g&&this.sorted&&!q&&(!y||e>y||this.forceCrop))if(c[e-1]<p||c[0]>x)c=[],d=[];else if(c[0]<p||c[e-1]>x)h=this.cropData(this.xData,this.yData,p,x),c=h.xData,d=h.yData,h=h.start,f=!0;for(y=c.length||
	1;--y;)e=z?l(c[y])-l(c[y-1]):c[y]-c[y-1],0<e&&(void 0===m||e<m)?m=e:0>e&&this.requireSorting&&a.error(15);this.cropped=f;this.cropStart=h;this.processedXData=c;this.processedYData=d;this.closestPointRange=m},cropData:function(a,b,c,d){var h=a.length,n=0,e=h,f=I(this.cropShoulder,1),m;for(m=0;m<h;m++)if(a[m]>=c){n=Math.max(0,m-f);break}for(c=m;c<h;c++)if(a[c]>d){e=c+f;break}return{xData:a.slice(n,e),yData:b.slice(n,e),start:n,end:e}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,
	d,h=this.processedXData,e=this.processedYData,f=this.pointClass,m=h.length,k=this.cropStart||0,l,q=this.hasGroupedData,a=a.keys,g,z=[],p;c||q||(c=[],c.length=b.length,c=this.data=c);a&&q&&(this.options.keys=!1);for(p=0;p<m;p++)l=k+p,q?(g=(new f).init(this,[h[p]].concat(J(e[p]))),g.dataGroup=this.groupMap[p]):(g=c[l])||void 0===b[l]||(c[l]=g=(new f).init(this,b[l],h[p])),g&&(g.index=l,z[p]=g);this.options.keys=a;if(c&&(m!==(d=c.length)||q))for(p=0;p<d;p++)p!==k||q||(p+=m),c[p]&&(c[p].destroyElements(),
	c[p].plotX=void 0);this.data=c;this.points=z},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,e,h=[],f=0;e=this.xAxis.getExtremes();var m=e.min,k=e.max,y,l,q,g;a=a||this.stackedYData||this.processedYData||[];e=a.length;for(g=0;g<e;g++)if(l=c[g],q=a[g],y=(x(q,!0)||d(q))&&(!b.positiveValuesOnly||q.length||0<q),l=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[g]||l)>=m&&(c[g]||l)<=k,y&&l)if(y=q.length)for(;y--;)null!==q[y]&&(h[f++]=q[y]);else h[f++]=q;this.dataMin=
	E(h);this.dataMax=G(h)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,d=c.categories,h=this.yAxis,e=this.points,f=e.length,m=!!this.modifyValue,k=a.pointPlacement,l="between"===k||x(k),q=a.threshold,g=a.startFromThreshold?q:0,z,p,C,t,K=Number.MAX_VALUE;"between"===k&&(k=.5);x(k)&&(k*=I(a.pointRange||c.pointRange));for(a=0;a<f;a++){var u=e[a],J=u.x,B=u.y;p=u.low;var D=b&&h.stacks[(this.negStacks&&B<(g?0:q)?"-":"")+this.stackKey],
	E;h.positiveValuesOnly&&null!==B&&0>=B&&(u.isNull=!0);u.plotX=z=r(Math.min(Math.max(-1E5,c.translate(J,0,0,0,1,k,"flags"===this.type)),1E5));b&&this.visible&&!u.isNull&&D&&D[J]&&(t=this.getStackIndicator(t,J,this.index),E=D[J],B=E.points[t.key],p=B[0],B=B[1],p===g&&t.key===D[J].base&&(p=I(q,h.min)),h.positiveValuesOnly&&0>=p&&(p=null),u.total=u.stackTotal=E.total,u.percentage=E.total&&u.y/E.total*100,u.stackY=B,E.setOffset(this.pointXOffset||0,this.barW||0));u.yBottom=v(p)?h.translate(p,0,1,0,1):
	null;m&&(B=this.modifyValue(B,u));u.plotY=p="number"===typeof B&&Infinity!==B?Math.min(Math.max(-1E5,h.translate(B,0,1,0,1)),1E5):void 0;u.isInside=void 0!==p&&0<=p&&p<=h.len&&0<=z&&z<=c.len;u.clientX=l?r(c.translate(J,0,0,0,1,k)):z;u.negative=u.y<(q||0);u.category=d&&void 0!==d[u.x]?d[u.x]:u.x;u.isNull||(void 0!==C&&(K=Math.min(K,Math.abs(z-C))),C=z);u.zone=this.zones.length&&u.getZone()}this.closestPointRangePx=K},getValidPoints:function(a,b){var c=this.chart;return f(a||this.points||[],function(a){return b&&
	!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,h=b.inverted,e=this.clipBox,f=e||b.clipBox,m=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),k=b[m],l=b[m+"m"];k||(a&&(f.width=0,b[m+"m"]=l=d.clipRect(-99,h?-b.plotLeft:-b.plotTop,99,h?b.chartWidth:b.chartHeight)),b[m]=k=d.clipRect(f),k.count={length:0});a&&!k.count[this.index]&&(k.count[this.index]=!0,k.count.length+=1);!1!==c.clip&&
	(this.group.clip(a||e?k:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=m);a||(k.count[this.index]&&(delete k.count[this.index],--k.count.length),0===k.count.length&&m&&b[m]&&(e||(b[m]=b[m].destroy()),b[m+"m"]&&(b[m+"m"]=b[m+"m"].destroy())))},animate:function(a){var b=this.chart,c=B(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();
	k(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,h,e,f=this.options.marker,m,k,l,q,g=this[this.specialGroup]||this.markerGroup,z=I(f.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*f.radius);if(!1!==f.enabled||this._hasPointMarkers)for(d=0;d<a.length;d++)h=a[d],c=h.plotY,e=h.graphic,m=h.marker||{},k=!!h.marker,l=z&&void 0===m.enabled||m.enabled,q=h.isInside,l&&x(c)&&null!==h.y?(c=I(m.symbol,this.symbol),h.hasImage=0===c.indexOf("url"),
	l=this.markerAttribs(h,h.selected&&"select"),e?e[q?"show":"hide"](!0).animate(l):q&&(0<l.width||h.hasImage)&&(h.graphic=e=b.renderer.symbol(c,l.x,l.y,l.width,l.height,k?m:f).add(g)),e&&e.attr(this.pointAttribs(h,h.selected&&"select")),e&&e.addClass(h.getClassName(),!0)):e&&(h.graphic=e.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},h=I(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],h=I(b&&b.radius,c&&c.radius,h+(c&&c.radiusPlus||0)));a.hasImage&&(h=
	0);a={x:Math.floor(a.plotX)-h,y:a.plotY-h};h&&(a.width=a.height=2*h);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,h=d&&d.marker||{},e=this.color,f=d&&d.color,m=a&&a.color,d=I(h.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;e=f||a||m||e;a=h.fillColor||c.fillColor||e;e=h.lineColor||c.lineColor||e;b&&(c=c.states[b],b=h.states&&h.states[b]||{},d=I(b.lineWidth,c.lineWidth,d+I(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,e=b.lineColor||c.lineColor||
	e);return{stroke:e,"stroke-width":d,fill:a}},destroy:function(){var a=this,c=a.chart,d=/AppleWebKit\/533/.test(K.navigator.userAgent),e,h,f=a.data||[],g,z;k(a,"destroy");m(a);u(a.axisTypes||[],function(b){(z=a[b])&&z.series&&(l(z.series,a),z.isDirty=z.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(h=f.length;h--;)(g=f[h])&&g.destroy&&g.destroy();a.points=null;clearTimeout(a.animationTimeout);q(a,function(a,c){a instanceof b&&!a.survive&&(e=d&&"group"===c?"hide":"destroy",a[e]())});
	c.hoverSeries===a&&(c.hoverSeries=null);l(c.series,a);c.orderSeries();q(a,function(b,c){delete a[c]})},getGraphPath:function(a,b,c){var d=this,h=d.options,n=h.step,e,f=[],m=[],k;a=a||d.points;(e=a.reversed)&&a.reverse();(n={right:1,center:2}[n]||n&&3)&&e&&(n=4-n);!h.connectNulls||b||c||(a=this.getValidPoints(a));u(a,function(e,l){var q=e.plotX,g=e.plotY,y=a[l-1];(e.leftCliff||y&&y.rightCliff)&&!c&&(k=!0);e.isNull&&!v(b)&&0<l?k=!h.connectNulls:e.isNull&&!b?k=!0:(0===l||k?l=["M",e.plotX,e.plotY]:d.getPointSpline?
	l=d.getPointSpline(a,e,l):n?(l=1===n?["L",y.plotX,g]:2===n?["L",(y.plotX+q)/2,y.plotY,"L",(y.plotX+q)/2,g]:["L",q,y.plotY],l.push("L",q,g)):l=["L",q,g],m.push(e.x),n&&m.push(e.x),f.push.apply(f,l),k=!1)});f.xMap=m;return d.graphPath=f},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];u(this.zones,function(c,e){d.push(["zone-graph-"+e,"highcharts-graph highcharts-zone-graph-"+e+" "+
	(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});u(d,function(d,e){var h=d[0],n=a[h];n?(n.endX=c.xMap,n.animate({d:c})):c.length&&(a[h]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),n={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?n.dashstyle=d[3]:"square"!==b.linecap&&(n["stroke-linecap"]=n["stroke-linejoin"]="round"),n=a[h].attr(n).shadow(2>e&&b.shadow));n&&(n.startX=c.xMap,n.isArea=c.isArea)})},applyZones:function(){var a=
	this,b=this.chart,c=b.renderer,d=this.zones,h,e,f=this.clips||[],m,k=this.graph,l=this.area,q=Math.max(b.chartWidth,b.chartHeight),g=this[(this.zoneAxis||"y")+"Axis"],z,p,x=b.inverted,C,t,r,K,v=!1;d.length&&(k||l)&&g&&void 0!==g.min&&(p=g.reversed,C=g.horiz,k&&k.hide(),l&&l.hide(),z=g.getExtremes(),u(d,function(d,n){h=p?C?b.plotWidth:0:C?0:g.toPixels(z.min);h=Math.min(Math.max(I(e,h),0),q);e=Math.min(Math.max(Math.round(g.toPixels(I(d.value,z.max),!0)),0),q);v&&(h=e=g.toPixels(z.max));t=Math.abs(h-
	e);r=Math.min(h,e);K=Math.max(h,e);g.isXAxis?(m={x:x?K:r,y:0,width:t,height:q},C||(m.x=b.plotHeight-m.x)):(m={x:0,y:x?K:r,width:q,height:t},C&&(m.y=b.plotWidth-m.y));x&&c.isVML&&(m=g.isXAxis?{x:0,y:p?r:K,height:m.width,width:b.chartWidth}:{x:m.y-b.plotLeft-b.spacingBox.x,y:0,width:m.height,height:b.chartHeight});f[n]?f[n].animate(m):(f[n]=c.clipRect(m),k&&a["zone-graph-"+n].clip(f[n]),l&&a["zone-area-"+n].clip(f[n]));v=d.value>z.max}),this.clips=f)},invertGroups:function(a){function b(){u(["group",
	"markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,h;c.xAxis&&(h=D(d,"resize",b),D(c,"destroy",h),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,h){var e=this[a],n=!e;n&&(this[a]=e=this.chart.renderer.g().attr({zIndex:d||.1}).add(h));e.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+
	" "+(this.options.className||""),!0);e.attr({visibility:c})[n?"attr":"animate"](this.getPlotBox());return e},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,h=!!a.animate&&b.renderer.isSVG&&B(d.animation).duration,e=a.visible?"inherit":"hidden",f=d.zIndex,m=a.hasRendered,k=b.seriesGroup,l=b.inverted;c=a.plotGroup("group",
	"series",e,f,k);a.markerGroup=a.plotGroup("markerGroup","markers",e,f,k);h&&a.animate(!0);c.inverted=a.isCartesian?l:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(l);!1===d.clip||a.sharedClipKey||m||c.clip(b.clipRect);h&&a.animate();m||(a.animationTimeout=z(function(){a.afterAnimate()},h));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,
	b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,h=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:I(d&&d.left,a.plotLeft),translateY:I(h&&h.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,h=this.chart.inverted;return this.searchKDTree({clientX:h?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:h?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},
	buildKDTree:function(){function a(c,d,e){var h,n;if(n=c&&c.length)return h=b.kdAxisArray[d%e],c.sort(function(a,b){return a[h]-b[h]}),n=Math.floor(n/2),{point:c[n],left:a(c.slice(0,n),d+1,e),right:a(c.slice(n+1),d+1,e)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;z(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,n,m){var k=b.point,l=d.kdAxisArray[n%
	m],q,g,z=k;g=v(a[h])&&v(k[h])?Math.pow(a[h]-k[h],2):null;q=v(a[e])&&v(k[e])?Math.pow(a[e]-k[e],2):null;q=(g||0)+(q||0);k.dist=v(q)?Math.sqrt(q):Number.MAX_VALUE;k.distX=v(g)?Math.sqrt(g):Number.MAX_VALUE;l=a[l]-k[l];q=0>l?"left":"right";g=0>l?"right":"left";b[q]&&(q=c(a,b[q],n+1,m),z=q[f]<z[f]?q:k);b[g]&&Math.sqrt(l*l)<z[f]&&(a=c(a,b[g],n+1,m),z=a[f]<z[f]?a:z);return z}var d=this,h=this.kdAxisArray[0],e=this.kdAxisArray[1],f=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||
	this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(M);(function(a){var D=a.Axis,B=a.Chart,G=a.correctFloat,E=a.defined,r=a.destroyObjectProperties,g=a.each,p=a.format,t=a.objectEach,v=a.pick,u=a.Series;a.StackItem=function(a,e,k,f,d){var l=a.chart.inverted;this.axis=a;this.isNegative=k;this.options=e;this.x=f;this.total=null;this.points={};this.stack=d;this.rightCliff=this.leftCliff=0;this.alignOptions={align:e.align||(l?k?"left":"right":"center"),verticalAlign:e.verticalAlign||
	(l?"middle":k?"bottom":"top"),y:v(e.y,l?4:k?14:-6),x:v(e.x,l?k?-6:6:0)};this.textAlign=e.textAlign||(l?k?"right":"left":"center")};a.StackItem.prototype={destroy:function(){r(this,this.axis)},render:function(a){var e=this.options,k=e.format,k=k?p(k,this):e.formatter.call(this);this.label?this.label.attr({text:k,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(k,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,
	e){var k=this.axis,f=k.chart,d=k.translate(k.usePercentage?100:this.total,0,0,0,1),k=k.translate(0),k=Math.abs(d-k);a=f.xAxis[0].translate(this.x)+a;d=this.getStackBox(f,this,a,d,e,k);if(e=this.label)e.align(this.alignOptions,null,d),d=e.alignAttr,e[!1===this.options.crop||f.isInsidePlot(d.x,d.y)?"show":"hide"](!0)},getStackBox:function(a,e,k,f,d,g){var l=e.axis.reversed,c=a.inverted;a=a.plotHeight;e=e.isNegative&&!l||!e.isNegative&&l;return{x:c?e?f:f-g:k,y:c?a-k-d:e?a-f-g:a-f,width:c?g:d,height:c?
	d:g}}};B.prototype.getStacks=function(){var a=this;g(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});g(a.series,function(e){!e.options.stacking||!0!==e.visible&&!1!==a.options.chart.ignoreHiddenSeries||(e.stackKey=e.type+v(e.options.stack,""))})};D.prototype.buildStacks=function(){var a=this.series,e=v(this.options.reversedStacks,!0),k=a.length,f;if(!this.isXAxis){this.usePercentage=!1;for(f=k;f--;)a[e?f:k-f-1].setStackedPoints();if(this.usePercentage)for(f=0;f<k;f++)a[f].setPercentStacks()}};
	D.prototype.renderStackTotals=function(){var a=this.chart,e=a.renderer,k=this.stacks,f=this.stackTotalGroup;f||(this.stackTotalGroup=f=e.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());f.translate(a.plotLeft,a.plotTop);t(k,function(a){t(a,function(a){a.render(f)})})};D.prototype.resetStacks=function(){var a=this,e=a.stacks;a.isXAxis||t(e,function(e){t(e,function(f,d){f.touched<a.stacksTouched?(f.destroy(),delete e[d]):(f.total=null,f.cum=null)})})};D.prototype.cleanStacks=function(){var a;
	this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),t(a,function(a){t(a,function(a){a.cum=a.total})}))};u.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var l=this.processedXData,e=this.processedYData,k=[],f=e.length,d=this.options,g=d.threshold,p=d.startFromThreshold?g:0,c=d.stack,d=d.stacking,q=this.stackKey,r="-"+q,m=this.negStacks,t=this.yAxis,b=t.stacks,z=t.oldStacks,K,y,A,n,H,h,w;t.stacksTouched+=
	1;for(H=0;H<f;H++)h=l[H],w=e[H],K=this.getStackIndicator(K,h,this.index),n=K.key,A=(y=m&&w<(p?0:g))?r:q,b[A]||(b[A]={}),b[A][h]||(z[A]&&z[A][h]?(b[A][h]=z[A][h],b[A][h].total=null):b[A][h]=new a.StackItem(t,t.options.stackLabels,y,h,c)),A=b[A][h],null!==w&&(A.points[n]=A.points[this.index]=[v(A.cum,p)],E(A.cum)||(A.base=n),A.touched=t.stacksTouched,0<K.index&&!1===this.singleStacks&&(A.points[n][0]=A.points[this.index+","+h+",0"][0])),"percent"===d?(y=y?q:r,m&&b[y]&&b[y][h]?(y=b[y][h],A.total=y.total=
	Math.max(y.total,A.total)+Math.abs(w)||0):A.total=G(A.total+(Math.abs(w)||0))):A.total=G(A.total+(w||0)),A.cum=v(A.cum,p)+(w||0),null!==w&&(A.points[n].push(A.cum),k[H]=A.cum);"percent"===d&&(t.usePercentage=!0);this.stackedYData=k;t.oldStacks={}}};u.prototype.setPercentStacks=function(){var a=this,e=a.stackKey,k=a.yAxis.stacks,f=a.processedXData,d;g([e,"-"+e],function(e){for(var l=f.length,c,q;l--;)if(c=f[l],d=a.getStackIndicator(d,c,a.index,e),c=(q=k[e]&&k[e][c])&&q.points[d.key])q=q.total?100/
	q.total:0,c[0]=G(c[0]*q),c[1]=G(c[1]*q),a.stackedYData[l]=c[1]})};u.prototype.getStackIndicator=function(a,e,k,f){!E(a)||a.x!==e||f&&a.key!==f?a={x:e,index:0,key:f}:a.index++;a.key=[k,e,a.index].join();return a}})(M);(function(a){var D=a.addEvent,B=a.animate,G=a.Axis,E=a.createElement,r=a.css,g=a.defined,p=a.each,t=a.erase,v=a.extend,u=a.fireEvent,l=a.inArray,e=a.isNumber,k=a.isObject,f=a.isArray,d=a.merge,x=a.objectEach,C=a.pick,c=a.Point,q=a.Series,I=a.seriesTypes,m=a.setAnimation,J=a.splat;v(a.Chart.prototype,
	{addSeries:function(a,c,d){var b,e=this;a&&(c=C(c,!0),u(e,"addSeries",{options:a},function(){b=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();c&&e.redraw(d)}));return b},addAxis:function(a,c,e,f){var b=c?"xAxis":"yAxis",n=this.options;a=d(a,{index:this[b].length,isX:c});c=new G(this,a);n[b]=J(n[b]||{});n[b].push(a);C(e,!0)&&this.redraw(f);return c},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=c.loading,n=function(){d&&r(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+
	"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=E("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=E("span",{className:"highcharts-loading-inner"},null,d),D(b,"redraw",n));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;r(d,v(e.style,{zIndex:10}));r(b.loadingSpan,e.labelStyle);b.loadingShown||(r(d,{opacity:0,display:""}),B(d,{opacity:e.style.opacity||.5},{duration:e.showDuration||0}));b.loadingShown=!0;n()},hideLoading:function(){var a=
	this.options,c=this.loadingDiv;c&&(c.className="highcharts-loading highcharts-loading-hidden",B(c,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){r(c,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "),update:function(a,c,f){var b=this,m={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},n=a.chart,k,h,q=[];if(n){d(!0,b.options.chart,n);"className"in n&&b.setClassName(n.className);if("inverted"in n||"polar"in n)b.propFromSeries(),k=!0;"alignTicks"in n&&(k=!0);x(n,function(a,c){-1!==l("chart."+c,b.propsRequireUpdateSeries)&&(h=!0);-1!==l(c,b.propsRequireDirtyBox)&&
	(b.isDirtyBox=!0)});"style"in n&&b.renderer.setStyle(n.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&d(!0,this.options.plotOptions,a.plotOptions);x(a,function(a,c){if(b[c]&&"function"===typeof b[c].update)b[c].update(a,!1);else if("function"===typeof b[m[c]])b[m[c]](a);"chart"!==c&&-1!==l(c,b.propsRequireUpdateSeries)&&(h=!0)});p("xAxis yAxis zAxis series colorAxis pane".split(" "),function(c){a[c]&&(p(J(a[c]),function(a,d){(d=g(a.id)&&b.get(a.id)||b[c][d])&&d.coll===c&&(d.update(a,
	!1),f&&(d.touched=!0));if(!d&&f)if("series"===c)b.addSeries(a,!1).touched=!0;else if("xAxis"===c||"yAxis"===c)b.addAxis(a,"xAxis"===c,!1).touched=!0}),f&&p(b[c],function(a){a.touched?delete a.touched:q.push(a)}))});p(q,function(a){a.remove(!1)});k&&p(b.axes,function(a){a.update({},!1)});h&&p(b.series,function(a){a.update({},!1)});a.loading&&d(!0,b.options.loading,a.loading);k=n&&n.width;n=n&&n.height;e(k)&&k!==b.chartWidth||e(n)&&n!==b.chartHeight?b.setSize(k,n):C(c,!0)&&b.redraw()},setSubtitle:function(a){this.setTitle(void 0,
	a)}});v(c.prototype,{update:function(a,c,d,e){function b(){n.applyOptions(a);null===n.y&&h&&(n.graphic=h.destroy());k(a,!0)&&(h&&h.element&&a&&a.marker&&void 0!==a.marker.symbol&&(n.graphic=h.destroy()),a&&a.dataLabels&&n.dataLabel&&(n.dataLabel=n.dataLabel.destroy()));m=n.index;f.updateParallelArrays(n,m);q.data[m]=k(q.data[m],!0)||k(a,!0)?n.options:a;f.isDirty=f.isDirtyData=!0;!f.fixedBox&&f.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===q.legendType&&(l.isDirtyLegend=!0);c&&l.redraw(d)}var n=
	this,f=n.series,h=n.graphic,m,l=f.chart,q=f.options;c=C(c,!0);!1===e?b():n.firePointEvent("update",{options:a},b)},remove:function(a,c){this.series.removePoint(l(this,this.series.data),a,c)}});v(q.prototype,{addPoint:function(a,c,d,e){var b=this.options,n=this.data,f=this.chart,h=this.xAxis,h=h&&h.hasNames&&h.names,m=b.data,k,l,q=this.xData,g,p;c=C(c,!0);k={series:this};this.pointClass.prototype.applyOptions.apply(k,[a]);p=k.x;g=q.length;if(this.requireSorting&&p<q[g-1])for(l=!0;g&&q[g-1]>p;)g--;
	this.updateParallelArrays(k,"splice",g,0,0);this.updateParallelArrays(k,g);h&&k.name&&(h[p]=k.name);m.splice(g,0,a);l&&(this.data.splice(g,0,null),this.processData());"point"===b.legendType&&this.generatePoints();d&&(n[0]&&n[0].remove?n[0].remove(!1):(n.shift(),this.updateParallelArrays(k,"shift"),m.shift()));this.isDirtyData=this.isDirty=!0;c&&f.redraw(e)},removePoint:function(a,c,d){var b=this,e=b.data,n=e[a],f=b.points,h=b.chart,k=function(){f&&f.length===e.length&&f.splice(a,1);e.splice(a,1);
	b.options.data.splice(a,1);b.updateParallelArrays(n||{series:b},"splice",a,1);n&&n.destroy();b.isDirty=!0;b.isDirtyData=!0;c&&h.redraw()};m(d,h);c=C(c,!0);n?n.firePointEvent("remove",null,k):k()},remove:function(a,c,d){function b(){e.destroy();f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();C(a,!0)&&f.redraw(c)}var e=this,f=e.chart;!1!==d?u(e,"remove",null,b):b()},update:function(a,c){var b=this,e=b.chart,f=b.userOptions,n=b.oldType||b.type,m=a.type||f.type||e.options.chart.type,h=I[n].prototype,k,
	l=["group","markerGroup","dataLabelsGroup","navigatorSeries","baseSeries"],q=b.finishedAnimating&&{animation:!1};if(Object.keys&&"data"===Object.keys(a).toString())return this.setData(a.data,c);if(m&&m!==n||void 0!==a.zIndex)l.length=0;p(l,function(a){l[a]=b[a];delete b[a]});a=d(f,q,{index:b.index,pointStart:b.xData[0]},{data:b.options.data},a);b.remove(!1,null,!1);for(k in h)b[k]=void 0;v(b,I[m||n].prototype);p(l,function(a){b[a]=l[a]});b.init(e,a);b.oldType=n;e.linkSeries();C(c,!0)&&e.redraw(!1)}});
	v(G.prototype,{update:function(a,c){var b=this.chart;a=b.options[this.coll][this.options.index]=d(this.userOptions,a);this.destroy(!0);this.init(b,v(a,{events:void 0}));b.isDirtyBox=!0;C(c,!0)&&b.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,d=this.series,e=d.length;e--;)d[e]&&d[e].remove(!1);t(b.axes,this);t(b[c],this);f(b.options[c])?b.options[c].splice(this.options.index,1):delete b.options[c];p(b[c],function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;C(a,!0)&&b.redraw()},
	setTitle:function(a,c){this.update({title:a},c)},setCategories:function(a,c){this.update({categories:a},c)}})})(M);(function(a){var D=a.color,B=a.each,G=a.map,E=a.pick,r=a.Series,g=a.seriesType;g("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(g){var p=[],r=[],u=this.xAxis,l=this.yAxis,e=l.stacks[this.stackKey],k={},f=this.index,d=l.series,x=d.length,C,c=E(l.options.reversedStacks,!0)?1:-1,q;g=g||this.points;if(this.options.stacking){for(q=0;q<g.length;q++)k[g[q].x]=
	g[q];a.objectEach(e,function(a,c){null!==a.total&&r.push(c)});r.sort(function(a,c){return a-c});C=G(d,function(){return this.visible});B(r,function(a,d){var m=0,b,g;if(k[a]&&!k[a].isNull)p.push(k[a]),B([-1,1],function(m){var l=1===m?"rightNull":"leftNull",p=0,n=e[r[d+m]];if(n)for(q=f;0<=q&&q<x;)b=n.points[q],b||(q===f?k[a][l]=!0:C[q]&&(g=e[a].points[q])&&(p-=g[1]-g[0])),q+=c;k[a][1===m?"rightCliff":"leftCliff"]=p});else{for(q=f;0<=q&&q<x;){if(b=e[a].points[q]){m=b[1];break}q+=c}m=l.translate(m,0,
	1,0,1);p.push({isNull:!0,plotX:u.translate(a,0,0,0,1),x:a,plotY:m,yBottom:m})}})}return p},getGraphPath:function(a){var g=r.prototype.getGraphPath,p=this.options,u=p.stacking,l=this.yAxis,e,k,f=[],d=[],x=this.index,C,c=l.stacks[this.stackKey],q=p.threshold,I=l.getThreshold(p.threshold),m,p=p.connectNulls||"percent"===u,J=function(b,e,m){var k=a[b];b=u&&c[k.x].points[x];var g=k[m+"Null"]||0;m=k[m+"Cliff"]||0;var n,p,k=!0;m||g?(n=(g?b[0]:b[1])+m,p=b[0]+m,k=!!g):!u&&a[e]&&a[e].isNull&&(n=p=q);void 0!==
	n&&(d.push({plotX:C,plotY:null===n?I:l.getThreshold(n),isNull:k,isCliff:!0}),f.push({plotX:C,plotY:null===p?I:l.getThreshold(p),doCurve:!1}))};a=a||this.points;u&&(a=this.getStackPoints(a));for(e=0;e<a.length;e++)if(k=a[e].isNull,C=E(a[e].rectPlotX,a[e].plotX),m=E(a[e].yBottom,I),!k||p)p||J(e,e-1,"left"),k&&!u&&p||(d.push(a[e]),f.push({x:e,plotX:C,plotY:m})),p||J(e,e+1,"right");e=g.call(this,d,!0,!0);f.reversed=!0;k=g.call(this,f,!0,!0);k.length&&(k[0]="L");k=e.concat(k);g=g.call(this,d,!1,p);k.xMap=
	e.xMap;this.areaPath=k;return g},drawGraph:function(){this.areaPath=[];r.prototype.drawGraph.apply(this);var a=this,g=this.areaPath,v=this.options,u=[["area","highcharts-area",this.color,v.fillColor]];B(this.zones,function(l,e){u.push(["zone-area-"+e,"highcharts-area highcharts-zone-area-"+e+" "+l.className,l.color||a.color,l.fillColor||v.fillColor])});B(u,function(l){var e=l[0],k=a[e];k?(k.endX=g.xMap,k.animate({d:g})):(k=a[e]=a.chart.renderer.path(g).addClass(l[1]).attr({fill:E(l[3],D(l[2]).setOpacity(E(v.fillOpacity,
	.75)).get()),zIndex:0}).add(a.group),k.isArea=!0);k.startX=g.xMap;k.shiftUnit=v.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(M);(function(a){var D=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,G,E){var r=G.plotX,g=G.plotY,p=a[E-1];E=a[E+1];var t,v,u,l;if(p&&!p.isNull&&!1!==p.doCurve&&!G.isCliff&&E&&!E.isNull&&!1!==E.doCurve&&!G.isCliff){a=p.plotY;u=E.plotX;E=E.plotY;var e=0;t=(1.5*r+p.plotX)/2.5;v=(1.5*g+a)/2.5;u=(1.5*r+u)/2.5;l=(1.5*g+E)/2.5;u!==t&&(e=
	(l-v)*(u-r)/(u-t)+g-l);v+=e;l+=e;v>a&&v>g?(v=Math.max(a,g),l=2*g-v):v<a&&v<g&&(v=Math.min(a,g),l=2*g-v);l>E&&l>g?(l=Math.max(E,g),v=2*g-l):l<E&&l<g&&(l=Math.min(E,g),v=2*g-l);G.rightContX=u;G.rightContY=l}G=["C",D(p.rightContX,p.plotX),D(p.rightContY,p.plotY),D(t,r),D(v,g),r,g];p.rightContX=p.rightContY=null;return G}})})(M);(function(a){var D=a.seriesTypes.area.prototype,B=a.seriesType;B("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:D.getStackPoints,getGraphPath:D.getGraphPath,
	drawGraph:D.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(M);(function(a){var D=a.animObject,B=a.color,G=a.each,E=a.extend,r=a.isNumber,g=a.merge,p=a.pick,t=a.Series,v=a.seriesType,u=a.svg;v("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},
	softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){t.prototype.init.apply(this,arguments);var a=this,e=a.chart;e.hasRendered&&G(e.series,function(e){e.type===a.type&&(e.isDirty=!0)})},getColumnMetrics:function(){var a=this,e=a.options,k=a.xAxis,f=a.yAxis,d=k.reversed,g,C={},c=0;!1===e.grouping?c=1:G(a.chart.series,function(d){var b=d.options,
	e=d.yAxis,m;d.type!==a.type||!d.visible&&a.chart.options.chart.ignoreHiddenSeries||f.len!==e.len||f.pos!==e.pos||(b.stacking?(g=d.stackKey,void 0===C[g]&&(C[g]=c++),m=C[g]):!1!==b.grouping&&(m=c++),d.columnIndex=m)});var q=Math.min(Math.abs(k.transA)*(k.ordinalSlope||e.pointRange||k.closestPointRange||k.tickInterval||1),k.len),r=q*e.groupPadding,m=(q-2*r)/(c||1),e=Math.min(e.maxPointWidth||k.len,p(e.pointWidth,m*(1-2*e.pointPadding)));a.columnMetrics={width:e,offset:(m-e)/2+(r+((a.columnIndex||0)+
	(d?1:0))*m-q/2)*(d?-1:1)};return a.columnMetrics},crispCol:function(a,e,k,f){var d=this.chart,g=this.borderWidth,l=-(g%2?.5:0),g=g%2?.5:1;d.inverted&&d.renderer.isVML&&(g+=1);this.options.crisp&&(k=Math.round(a+k)+l,a=Math.round(a)+l,k-=a);f=Math.round(e+f)+g;l=.5>=Math.abs(e)&&.5<f;e=Math.round(e)+g;f-=e;l&&f&&(--e,f+=1);return{x:a,y:e,width:k,height:f}},translate:function(){var a=this,e=a.chart,k=a.options,f=a.dense=2>a.closestPointRange*a.xAxis.transA,f=a.borderWidth=p(k.borderWidth,f?0:1),d=a.yAxis,
	g=a.translatedThreshold=d.getThreshold(k.threshold),C=p(k.minPointLength,5),c=a.getColumnMetrics(),q=c.width,r=a.barW=Math.max(q,1+2*f),m=a.pointXOffset=c.offset;e.inverted&&(g-=.5);k.pointPadding&&(r=Math.ceil(r));t.prototype.translate.apply(a);G(a.points,function(c){var b=p(c.yBottom,g),f=999+Math.abs(b),f=Math.min(Math.max(-f,c.plotY),d.len+f),k=c.plotX+m,l=r,x=Math.min(f,b),n,H=Math.max(f,b)-x;Math.abs(H)<C&&C&&(H=C,n=!d.reversed&&!c.negative||d.reversed&&c.negative,x=Math.abs(x-g)>C?b-C:g-(n?
	C:0));c.barX=k;c.pointWidth=q;c.tooltipPos=e.inverted?[d.len+d.pos-e.plotLeft-f,a.xAxis.len-k-l/2,H]:[k+l/2,f+d.pos-e.plotTop,H];c.shapeType="rect";c.shapeArgs=a.crispCol.apply(a,c.isNull?[k,g,l,0]:[k,x,l,H])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,e){var k=this.options,f,d=this.pointAttrToOptions||{};f=d.stroke||"borderColor";var l=d["stroke-width"]||
	"borderWidth",p=a&&a.color||this.color,c=a[f]||k[f]||this.color||p,q=a[l]||k[l]||this[l]||0,d=k.dashStyle;a&&this.zones.length&&(p=a.getZone(),p=a.options.color||p&&p.color||this.color);e&&(a=g(k.states[e],a.options.states&&a.options.states[e]||{}),e=a.brightness,p=a.color||void 0!==e&&B(p).brighten(a.brightness).get()||p,c=a[f]||c,q=a[l]||q,d=a.dashStyle||d);f={fill:p,stroke:c,"stroke-width":q};d&&(f.dashstyle=d);return f},drawPoints:function(){var a=this,e=this.chart,k=a.options,f=e.renderer,d=
	k.animationLimit||250,p;G(a.points,function(l){var c=l.graphic;if(r(l.plotY)&&null!==l.y){p=l.shapeArgs;if(c)c[e.pointCount<d?"animate":"attr"](g(p));else l.graphic=c=f[l.shapeType](p).add(l.group||a.group);k.borderRadius&&c.attr({r:k.borderRadius});c.attr(a.pointAttribs(l,l.selected&&"select")).shadow(k.shadow,null,k.stacking&&!k.borderRadius);c.addClass(l.getClassName(),!0)}else c&&(l.graphic=c.destroy())})},animate:function(a){var e=this,k=this.yAxis,f=e.options,d=this.chart.inverted,g={};u&&(a?
	(g.scaleY=.001,a=Math.min(k.pos+k.len,Math.max(k.pos,k.toPixels(f.threshold))),d?g.translateX=a-k.len:g.translateY=a,e.group.attr(g)):(g[d?"translateX":"translateY"]=k.pos,e.group.animate(g,E(D(e.options.animation),{step:function(a,c){e.group.attr({scaleY:Math.max(.001,c.pos)})}})),e.animate=null))},remove:function(){var a=this,e=a.chart;e.hasRendered&&G(e.series,function(e){e.type===a.type&&(e.isDirty=!0)});t.prototype.remove.apply(a,arguments)}})})(M);(function(a){a=a.seriesType;a("bar","column",
	null,{inverted:!0})})(M);(function(a){var D=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],
	takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&D.prototype.drawGraph.call(this)}})})(M);(function(a){var D=a.pick,B=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,E=this.chart,r=2*(a.slicedOffset||0),g=E.plotWidth-2*r,E=E.plotHeight-2*r,p=a.center,p=[D(p[0],"50%"),D(p[1],"50%"),a.size||"100%",a.innerSize||0],t=Math.min(g,E),v,u;for(v=0;4>v;++v)u=p[v],a=2>v||2===v&&/%$/.test(u),p[v]=B(u,[g,E,t,p[2]][v])+(a?r:0);p[3]>p[2]&&(p[3]=p[2]);return p}}})(M);
	(function(a){var D=a.addEvent,B=a.defined,G=a.each,E=a.extend,r=a.inArray,g=a.noop,p=a.pick,t=a.Point,v=a.Series,u=a.seriesType,l=a.setAnimation;u("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,
	shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var e=this,f=e.points,d=e.startAngleRad;a||(G(f,function(a){var f=a.graphic,c=a.shapeArgs;f&&(f.attr({r:a.startR||e.center[3]/2,start:d,end:d}),f.animate({r:c.r,start:c.start,end:c.end},e.options.animation))}),e.animate=null)},updateTotals:function(){var a,k=0,f=this.points,d=f.length,g,
	l=this.options.ignoreHiddenPoint;for(a=0;a<d;a++)g=f[a],k+=l&&!g.visible?0:g.isNull?0:g.y;this.total=k;for(a=0;a<d;a++)g=f[a],g.percentage=0<k&&(g.visible||!l)?g.y/k*100:0,g.total=k},generatePoints:function(){v.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var e=0,f=this.options,d=f.slicedOffset,g=d+(f.borderWidth||0),l,c,q,r=f.startAngle||0,m=this.startAngleRad=Math.PI/180*(r-90),r=(this.endAngleRad=Math.PI/180*(p(f.endAngle,r+360)-90))-m,t=
	this.points,b,z=f.dataLabels.distance,f=f.ignoreHiddenPoint,u,y=t.length,A;a||(this.center=a=this.getCenter());this.getX=function(b,c,d){q=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(q)*(a[2]/2+d.labelDistance)};for(u=0;u<y;u++){A=t[u];A.labelDistance=p(A.options.dataLabels&&A.options.dataLabels.distance,z);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,A.labelDistance);l=m+e*r;if(!f||A.visible)e+=A.percentage/100;c=m+e*r;A.shapeType="arc";A.shapeArgs=
	{x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*l)/1E3,end:Math.round(1E3*c)/1E3};q=(c+l)/2;q>1.5*Math.PI?q-=2*Math.PI:q<-Math.PI/2&&(q+=2*Math.PI);A.slicedTranslation={translateX:Math.round(Math.cos(q)*d),translateY:Math.round(Math.sin(q)*d)};c=Math.cos(q)*a[2]/2;b=Math.sin(q)*a[2]/2;A.tooltipPos=[a[0]+.7*c,a[1]+.7*b];A.half=q<-Math.PI/2||q>Math.PI/2?1:0;A.angle=q;l=Math.min(g,A.labelDistance/5);A.labelPos=[a[0]+c+Math.cos(q)*A.labelDistance,a[1]+b+Math.sin(q)*A.labelDistance,a[0]+c+Math.cos(q)*
	l,a[1]+b+Math.sin(q)*l,a[0]+c,a[1]+b,0>A.labelDistance?"center":A.half?"right":"left",q]}},drawGraph:null,drawPoints:function(){var a=this,k=a.chart.renderer,f,d,g,l,c=a.options.shadow;c&&!a.shadowGroup&&(a.shadowGroup=k.g("shadow").add(a.group));G(a.points,function(e){if(!e.isNull){d=e.graphic;l=e.shapeArgs;f=e.getTranslate();var q=e.shadowGroup;c&&!q&&(q=e.shadowGroup=k.g("shadow").add(a.shadowGroup));q&&q.attr(f);g=a.pointAttribs(e,e.selected&&"select");d?d.setRadialReference(a.center).attr(g).animate(E(l,
	f)):(e.graphic=d=k[e.shapeType](l).setRadialReference(a.center).attr(f).add(a.group),e.visible||d.attr({visibility:"hidden"}),d.attr(g).attr({"stroke-linejoin":"round"}).shadow(c,q));d.addClass(e.getClassName())}})},searchPoint:g,sortByAngle:function(a,k){a.sort(function(a,d){return void 0!==a.angle&&(d.angle-a.angle)*k})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:g},{init:function(){t.prototype.init.apply(this,arguments);var a=this,k;a.name=
	p(a.name,"Slice");k=function(e){a.slice("select"===e.type)};D(a,"select",k);D(a,"unselect",k);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,k){var e=this,d=e.series,g=d.chart,l=d.options.ignoreHiddenPoint;k=p(k,l);a!==e.visible&&(e.visible=e.options.visible=a=void 0===a?!e.visible:a,d.options.data[r(e,d.data)]=e.options,G(["graphic","dataLabel","connector","shadowGroup"],function(c){if(e[c])e[c][a?"show":"hide"](!0)}),e.legendItem&&g.legend.colorizeItem(e,
	a),a||"hover"!==e.state||e.setState(""),l&&(d.isDirty=!0),k&&g.redraw())},slice:function(a,k,f){var d=this.series;l(f,d.chart);p(k,!0);this.sliced=this.options.sliced=B(a)?a:!this.sliced;d.options.data[r(this,d.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var e=this.shapeArgs;return this.sliced||!this.visible?
	[]:this.series.chart.renderer.symbols.arc(e.x,e.y,e.r+a,e.r+a,{innerR:this.shapeArgs.r,start:e.start,end:e.end})}})})(M);(function(a){var D=a.addEvent,B=a.arrayMax,G=a.defined,E=a.each,r=a.extend,g=a.format,p=a.map,t=a.merge,v=a.noop,u=a.pick,l=a.relativeLength,e=a.Series,k=a.seriesTypes,f=a.stableSort;a.distribute=function(a,e){function d(a,c){return a.target-c.target}var c,k=!0,g=a,m=[],l;l=0;for(c=a.length;c--;)l+=a[c].size;if(l>e){f(a,function(a,c){return(c.rank||0)-(a.rank||0)});for(l=c=0;l<=
	e;)l+=a[c].size,c++;m=a.splice(c-1,a.length)}f(a,d);for(a=p(a,function(a){return{size:a.size,targets:[a.target]}});k;){for(c=a.length;c--;)k=a[c],l=(Math.min.apply(0,k.targets)+Math.max.apply(0,k.targets))/2,k.pos=Math.min(Math.max(0,l-k.size/2),e-k.size);c=a.length;for(k=!1;c--;)0<c&&a[c-1].pos+a[c-1].size>a[c].pos&&(a[c-1].size+=a[c].size,a[c-1].targets=a[c-1].targets.concat(a[c].targets),a[c-1].pos+a[c-1].size>e&&(a[c-1].pos=e-a[c-1].size),a.splice(c,1),k=!0)}c=0;E(a,function(a){var b=0;E(a.targets,
	function(){g[c].pos=a.pos+b;b+=g[c].size;c++})});g.push.apply(g,m);f(g,d)};e.prototype.drawDataLabels=function(){var d=this,e=d.options,f=e.dataLabels,c=d.points,k,l,m=d.hasRendered||0,p,b,z=u(f.defer,!!e.animation),r=d.chart.renderer;if(f.enabled||d._hasPointLabels)d.dlProcessOptions&&d.dlProcessOptions(f),b=d.plotGroup("dataLabelsGroup","data-labels",z&&!m?"hidden":"visible",f.zIndex||6),z&&(b.attr({opacity:+m}),m||D(d,"afterAnimate",function(){d.visible&&b.show(!0);b[e.animation?"animate":"attr"]({opacity:1},
	{duration:200})})),l=f,E(c,function(c){var m,n=c.dataLabel,q,h,w=c.connector,z=!n,y;k=c.dlOptions||c.options&&c.options.dataLabels;if(m=u(k&&k.enabled,l.enabled)&&null!==c.y)f=t(l,k),q=c.getLabelConfig(),p=f.format?g(f.format,q):f.formatter.call(q,f),y=f.style,q=f.rotation,y.color=u(f.color,y.color,d.color,"#000000"),"contrast"===y.color&&(c.contrastColor=r.getContrast(c.color||d.color),y.color=f.inside||0>u(c.labelDistance,f.distance)||e.stacking?c.contrastColor:"#000000"),e.cursor&&(y.cursor=e.cursor),
	h={fill:f.backgroundColor,stroke:f.borderColor,"stroke-width":f.borderWidth,r:f.borderRadius||0,rotation:q,padding:f.padding,zIndex:1},a.objectEach(h,function(a,b){void 0===a&&delete h[b]});!n||m&&G(p)?m&&G(p)&&(n?h.text=p:(n=c.dataLabel=r[q?"text":"label"](p,0,-9999,f.shape,null,null,f.useHTML,null,"data-label"),n.addClass("highcharts-data-label-color-"+c.colorIndex+" "+(f.className||"")+(f.useHTML?"highcharts-tracker":""))),n.attr(h),n.css(y).shadow(f.shadow),n.added||n.add(b),d.alignDataLabel(c,
	n,f,null,z)):(c.dataLabel=n=n.destroy(),w&&(c.connector=w.destroy()))})};e.prototype.alignDataLabel=function(a,e,f,c,k){var d=this.chart,m=d.inverted,g=u(a.plotX,-9999),b=u(a.plotY,-9999),l=e.getBBox(),q,p=f.rotation,x=f.align,n=this.visible&&(a.series.forceDL||d.isInsidePlot(g,Math.round(b),m)||c&&d.isInsidePlot(g,m?c.x+1:c.y+c.height-1,m)),H="justify"===u(f.overflow,"justify");if(n&&(q=f.style.fontSize,q=d.renderer.fontMetrics(q,e).b,c=r({x:m?this.yAxis.len-b:g,y:Math.round(m?this.xAxis.len-g:b),
	width:0,height:0},c),r(f,{width:l.width,height:l.height}),p?(H=!1,g=d.renderer.rotCorr(q,p),g={x:c.x+f.x+c.width/2+g.x,y:c.y+f.y+{top:0,middle:.5,bottom:1}[f.verticalAlign]*c.height},e[k?"attr":"animate"](g).attr({align:x}),b=(p+720)%360,b=180<b&&360>b,"left"===x?g.y-=b?l.height:0:"center"===x?(g.x-=l.width/2,g.y-=l.height/2):"right"===x&&(g.x-=l.width,g.y-=b?0:l.height)):(e.align(f,null,c),g=e.alignAttr),H?a.isLabelJustified=this.justifyDataLabel(e,f,g,l,c,k):u(f.crop,!0)&&(n=d.isInsidePlot(g.x,
	g.y)&&d.isInsidePlot(g.x+l.width,g.y+l.height)),f.shape&&!p))e[k?"attr":"animate"]({anchorX:m?d.plotWidth-a.plotY:a.plotX,anchorY:m?d.plotHeight-a.plotX:a.plotY});n||(e.attr({y:-9999}),e.placed=!1)};e.prototype.justifyDataLabel=function(a,e,f,c,k,g){var d=this.chart,l=e.align,b=e.verticalAlign,q,p,y=a.box?0:a.padding||0;q=f.x+y;0>q&&("right"===l?e.align="left":e.x=-q,p=!0);q=f.x+c.width-y;q>d.plotWidth&&("left"===l?e.align="right":e.x=d.plotWidth-q,p=!0);q=f.y+y;0>q&&("bottom"===b?e.verticalAlign=
	"top":e.y=-q,p=!0);q=f.y+c.height-y;q>d.plotHeight&&("top"===b?e.verticalAlign="bottom":e.y=d.plotHeight-q,p=!0);p&&(a.placed=!g,a.align(e,null,k));return p};k.pie&&(k.pie.prototype.drawDataLabels=function(){var d=this,f=d.data,k,c=d.chart,g=d.options.dataLabels,l=u(g.connectorPadding,10),m=u(g.connectorWidth,1),p=c.plotWidth,b=c.plotHeight,z,r=d.center,y=r[2]/2,t=r[1],n,H,h,w,v=[[],[]],L,D,N,O,F=[0,0,0,0];d.visible&&(g.enabled||d._hasPointLabels)&&(E(f,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&
	(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),e.prototype.drawDataLabels.apply(d),E(f,function(a){a.dataLabel&&a.visible&&(v[a.half].push(a),a.dataLabel._pos=null)}),E(v,function(e,f){var m,q,z=e.length,x=[],A;if(z)for(d.sortByAngle(e,f-.5),0<d.maxLabelDistance&&(m=Math.max(0,t-y-d.maxLabelDistance),q=Math.min(t+y+d.maxLabelDistance,c.plotHeight),E(e,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,t-y-a.labelDistance),a.bottom=
	Math.min(t+y+a.labelDistance,c.plotHeight),A=a.dataLabel.getBBox().height||21,a.positionsIndex=x.push({target:a.labelPos[1]-a.top+A/2,size:A,rank:a.y})-1)}),a.distribute(x,q+A-m)),O=0;O<z;O++)k=e[O],q=k.positionsIndex,h=k.labelPos,n=k.dataLabel,N=!1===k.visible?"hidden":"inherit",m=h[1],x&&G(x[q])?void 0===x[q].pos?N="hidden":(w=x[q].size,D=k.top+x[q].pos):D=m,delete k.positionIndex,L=g.justify?r[0]+(f?-1:1)*(y+k.labelDistance):d.getX(D<k.top+2||D>k.bottom-2?m:D,f,k),n._attr={visibility:N,align:h[6]},
	n._pos={x:L+g.x+({left:l,right:-l}[h[6]]||0),y:D+g.y-10},h.x=L,h.y=D,u(g.crop,!0)&&(H=n.getBBox().width,m=null,L-H<l?(m=Math.round(H-L+l),F[3]=Math.max(m,F[3])):L+H>p-l&&(m=Math.round(L+H-p+l),F[1]=Math.max(m,F[1])),0>D-w/2?F[0]=Math.max(Math.round(-D+w/2),F[0]):D+w/2>b&&(F[2]=Math.max(Math.round(D+w/2-b),F[2])),n.sideOverflow=m)}),0===B(F)||this.verifyDataLabelOverflow(F))&&(this.placeDataLabels(),m&&E(this.points,function(a){var b;z=a.connector;if((n=a.dataLabel)&&n._pos&&a.visible&&0<a.labelDistance){N=
	n._attr.visibility;if(b=!z)a.connector=z=c.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(d.dataLabelsGroup),z.attr({"stroke-width":m,stroke:g.connectorColor||a.color||"#666666"});z[b?"attr":"animate"]({d:d.connectorPath(a.labelPos)});z.attr("visibility",N)}else z&&(a.connector=z.destroy())}))},k.pie.prototype.connectorPath=function(a){var d=a.x,e=a.y;return u(this.options.dataLabels.softConnector,!0)?["M",d+("left"===a[6]?5:-5),e,"C",d,e,2*a[2]-a[4],
	2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",d+("left"===a[6]?5:-5),e,"L",a[2],a[3],"L",a[4],a[5]]},k.pie.prototype.placeDataLabels=function(){E(this.points,function(a){var d=a.dataLabel;d&&a.visible&&((a=d._pos)?(d.sideOverflow&&(d._attr.width=d.getBBox().width-d.sideOverflow,d.css({width:d._attr.width+"px",textOverflow:"ellipsis"}),d.shortened=!0),d.attr(d._attr),d[d.moved?"animate":"attr"](a),d.moved=!0):d&&d.attr({y:-9999}))},this)},k.pie.prototype.alignDataLabel=v,k.pie.prototype.verifyDataLabelOverflow=
	function(a){var d=this.center,e=this.options,c=e.center,f=e.minSize||80,k,m=null!==e.size;m||(null!==c[0]?k=Math.max(d[2]-Math.max(a[1],a[3]),f):(k=Math.max(d[2]-a[1]-a[3],f),d[0]+=(a[3]-a[1])/2),null!==c[1]?k=Math.max(Math.min(k,d[2]-Math.max(a[0],a[2])),f):(k=Math.max(Math.min(k,d[2]-a[0]-a[2]),f),d[1]+=(a[0]-a[2])/2),k<d[2]?(d[2]=k,d[3]=Math.min(l(e.innerSize||0,k),k),this.translate(d),this.drawDataLabels&&this.drawDataLabels()):m=!0);return m});k.column&&(k.column.prototype.alignDataLabel=function(a,
	f,k,c,g){var d=this.chart.inverted,m=a.series,l=a.dlBox||a.shapeArgs,b=u(a.below,a.plotY>u(this.translatedThreshold,m.yAxis.len)),q=u(k.inside,!!this.options.stacking);l&&(c=t(l),0>c.y&&(c.height+=c.y,c.y=0),l=c.y+c.height-m.yAxis.len,0<l&&(c.height-=l),d&&(c={x:m.yAxis.len-c.y-c.height,y:m.xAxis.len-c.x-c.width,width:c.height,height:c.width}),q||(d?(c.x+=b?0:c.width,c.width=0):(c.y+=b?c.height:0,c.height=0)));k.align=u(k.align,!d||q?"center":b?"right":"left");k.verticalAlign=u(k.verticalAlign,d||
	q?"middle":b?"top":"bottom");e.prototype.alignDataLabel.call(this,a,f,k,c,g);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(M);(function(a){var D=a.Chart,B=a.each,G=a.objectEach,E=a.pick,r=a.addEvent;D.prototype.callbacks.push(function(a){function g(){var g=[];B(a.yAxis||[],function(a){a.options.stackLabels&&!a.options.stackLabels.allowOverlap&&G(a.stacks,function(a){G(a,function(a){g.push(a.label)})})});B(a.series||[],function(a){var p=a.options.dataLabels,l=a.dataLabelCollections||
	["dataLabel"];(p.enabled||a._hasPointLabels)&&!p.allowOverlap&&a.visible&&B(l,function(e){B(a.points,function(a){a[e]&&(a[e].labelrank=E(a.labelrank,a.shapeArgs&&a.shapeArgs.height),g.push(a[e]))})})});a.hideOverlappingLabels(g)}g();r(a,"redraw",g)});D.prototype.hideOverlappingLabels=function(a){var g=a.length,r,v,u,l,e,k,f,d,x,C=function(a,d,e,f,k,b,g,l){return!(k>a+e||k+g<a||b>d+f||b+l<d)};for(v=0;v<g;v++)if(r=a[v])r.oldOpacity=r.opacity,r.newOpacity=1,r.width||(u=r.getBBox(),r.width=u.width,r.height=
	u.height);a.sort(function(a,d){return(d.labelrank||0)-(a.labelrank||0)});for(v=0;v<g;v++)for(u=a[v],r=v+1;r<g;++r)if(l=a[r],u&&l&&u!==l&&u.placed&&l.placed&&0!==u.newOpacity&&0!==l.newOpacity&&(e=u.alignAttr,k=l.alignAttr,f=u.parentGroup,d=l.parentGroup,x=2*(u.box?0:u.padding||0),e=C(e.x+f.translateX,e.y+f.translateY,u.width-x,u.height-x,k.x+d.translateX,k.y+d.translateY,l.width-x,l.height-x)))(u.labelrank<l.labelrank?u:l).newOpacity=0;B(a,function(a){var c,d;a&&(d=a.newOpacity,a.oldOpacity!==d&&
	a.placed&&(d?a.show(!0):c=function(){a.hide()},a.alignAttr.opacity=d,a[a.isOld?"animate":"attr"](a.alignAttr,null,c)),a.isOld=!0)})}})(M);(function(a){var D=a.addEvent,B=a.Chart,G=a.createElement,E=a.css,r=a.defaultOptions,g=a.defaultPlotOptions,p=a.each,t=a.extend,v=a.fireEvent,u=a.hasTouch,l=a.inArray,e=a.isObject,k=a.Legend,f=a.merge,d=a.pick,x=a.Point,C=a.Series,c=a.seriesTypes,q=a.svg,I;I=a.TrackerMixin={drawTrackerPoint:function(){var a=this,c=a.chart.pointer,b=function(a){var b=c.getPointFromEvent(a);
	void 0!==b&&(c.isDirectTouch=!0,b.onMouseOver(a))};p(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(p(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",b).on("mouseout",function(a){c.onTrackerMouseOut(a)});if(u)a[d].on("touchstart",b);a.options.cursor&&a[d].css(E).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=
	this,c=a.options,b=c.trackByArea,d=[].concat(b?a.areaPath:a.graphPath),e=d.length,f=a.chart,k=f.pointer,n=f.renderer,g=f.options.tooltip.snap,h=a.tracker,l,r=function(){if(f.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+(q?.0001:.002)+")";if(e&&!b)for(l=e+1;l--;)"M"===d[l]&&d.splice(l+1,0,d[l+1]-g,d[l+2],"L"),(l&&"M"===d[l]||l===e)&&d.splice(l,0,"L",d[l-2]+g,d[l-1]);h?h.attr({d:d}):a.graph&&(a.tracker=n.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:t,
	fill:b?t:"none","stroke-width":a.graph.strokeWidth()+(b?0:2*g),zIndex:2}).add(a.group),p([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",r).on("mouseout",function(a){k.onTrackerMouseOut(a)});c.cursor&&a.css({cursor:c.cursor});if(u)a.on("touchstart",r)}))}};c.column&&(c.column.prototype.drawTracker=I.drawTrackerPoint);c.pie&&(c.pie.prototype.drawTracker=I.drawTrackerPoint);c.scatter&&(c.scatter.prototype.drawTracker=I.drawTrackerPoint);t(k.prototype,{setItemEvents:function(a,
	c,b){var d=this,e=d.chart.renderer.boxWrapper,k="highcharts-legend-"+(a.series?"point":"series")+"-active";(b?c:a.legendGroup).on("mouseover",function(){a.setState("hover");e.addClass(k);c.css(d.options.itemHoverStyle)}).on("mouseout",function(){c.css(f(a.visible?d.itemStyle:d.itemHiddenStyle));e.removeClass(k);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):v(a,"legendItemClick",b,c)})},
	createCheckboxForItem:function(a){a.checkbox=G("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);D(a.checkbox,"click",function(c){v(a.series||a,"checkboxClick",{checked:c.target.checked,item:a},function(){a.select()})})}});r.legend.itemStyle.cursor="pointer";t(B.prototype,{showResetZoom:function(){var a=this,c=r.lang,b=a.options.chart.resetZoomButton,d=b.theme,e=d.states,f="chart"===b.relativeTo?null:"plotBox";this.resetZoomButton=
	a.renderer.button(c.resetZoom,null,null,function(){a.zoomOut()},d,e&&e.hover).attr({align:b.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(b.position,!1,f)},zoomOut:function(){var a=this;v(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var c,b=this.pointer,f=!1,k;!a||a.resetSelection?(p(this.axes,function(a){c=a.zoom()}),b.initiated=!1):p(a.xAxis.concat(a.yAxis),function(a){var d=a.axis;b[d.isXAxis?"zoomX":"zoomY"]&&(c=d.zoom(a.min,
	a.max),d.displayBtn&&(f=!0))});k=this.resetZoomButton;f&&!k?this.showResetZoom():!f&&e(k)&&(this.resetZoomButton=k.destroy());c&&this.redraw(d(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,c){var b=this,d=b.hoverPoints,e;d&&p(d,function(a){a.setState()});p("xy"===c?[1,0]:[1],function(c){c=b[c?"xAxis":"yAxis"][0];var d=c.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",k=b[d],h=(c.pointRange||0)/2,m=c.getExtremes(),g=c.toValue(k-f,!0)+h,h=c.toValue(k+
	c.len-f,!0)-h,l=h<g,k=l?h:g,g=l?g:h,h=Math.min(m.dataMin,c.toValue(c.toPixels(m.min)-c.minPixelPadding)),l=Math.max(m.dataMax,c.toValue(c.toPixels(m.max)+c.minPixelPadding)),q;q=h-k;0<q&&(g+=q,k=h);q=g-l;0<q&&(g=l,k-=q);c.series.length&&k!==m.min&&g!==m.max&&(c.setExtremes(k,g,!1,!1,{trigger:"pan"}),e=!0);b[d]=f});e&&b.redraw(!1);E(b.container,{cursor:"move"})}});t(x.prototype,{select:function(a,c){var b=this,e=b.series,f=e.chart;a=d(a,!b.selected);b.firePointEvent(a?"select":"unselect",{accumulate:c},
	function(){b.selected=b.options.selected=a;e.options.data[l(b,e.data)]=b.options;b.setState(a&&"select");c||p(f.getSelectedPoints(),function(a){a.selected&&a!==b&&(a.selected=a.options.selected=!1,e.options.data[l(a,e.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var c=this.series.chart,b=c.pointer;a=a?b.normalize(a):b.getChartCoordinatesFromPoint(this,c.inverted);b.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");
	p(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var c=this,d=f(c.series.options.point,c.options).events;c.events=d;a.objectEach(d,function(a,d){D(c,d,a)});this.hasImportedEvents=!0}},setState:function(a,c){var b=Math.floor(this.plotX),e=this.plotY,f=this.series,k=f.options.states[a]||{},m=g[f.type].marker&&f.options.marker,n=m&&!1===m.enabled,l=m&&m.states&&m.states[a]||{},h=!1===l.enabled,q=f.stateMarkerGraphic,p=
	this.marker||{},r=f.chart,u=f.halo,x,v=m&&f.markerAttribs;a=a||"";if(!(a===this.state&&!c||this.selected&&"select"!==a||!1===k.enabled||a&&(h||n&&!1===l.enabled)||a&&p.states&&p.states[a]&&!1===p.states[a].enabled)){v&&(x=f.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(f.pointAttribs(this,a),d(r.options.chart.animation,k.animation)),x&&this.graphic.animate(x,d(r.options.chart.animation,
	l.animation,m.animation)),q&&q.hide();else{if(a&&l){m=p.symbol||f.symbol;q&&q.currentSymbol!==m&&(q=q.destroy());if(q)q[c?"animate":"attr"]({x:x.x,y:x.y});else m&&(f.stateMarkerGraphic=q=r.renderer.symbol(m,x.x,x.y,x.width,x.height).add(f.markerGroup),q.currentSymbol=m);q&&q.attr(f.pointAttribs(this,a))}q&&(q[a&&r.isInsidePlot(b,e,r.inverted)?"show":"hide"](),q.element.point=this)}(b=k.halo)&&b.size?(u||(f.halo=u=r.renderer.path().add((this.graphic||q).parentGroup)),u[c?"animate":"attr"]({d:this.haloPath(b.size)}),
	u.attr({"class":"highcharts-halo highcharts-color-"+d(this.colorIndex,f.colorIndex)}),u.point=this,u.attr(t({fill:this.color||f.color,"fill-opacity":b.opacity,zIndex:-1},b.attributes))):u&&u.point&&u.point.haloPath&&u.animate({d:u.point.haloPath(0)});this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});t(C.prototype,{onMouseOver:function(){var a=this.chart,c=a.hoverSeries;if(c&&c!==this)c.onMouseOut();this.options.events.mouseOver&&
	v(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,c=this.chart,b=c.tooltip,d=c.hoverPoint;c.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&v(this,"mouseOut");!b||this.stickyTracking||b.shared&&!this.noSharedTooltip||b.hide();this.setState()},setState:function(a){var c=this,b=c.options,e=c.graph,f=b.states,k=b.lineWidth,b=0;a=a||"";if(c.state!==a&&(p([c.group,c.markerGroup,c.dataLabelsGroup],function(b){b&&(c.state&&b.removeClass("highcharts-series-"+
	c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!f[a]||!1!==f[a].enabled)&&(a&&(k=f[a].lineWidth||k+(f[a].lineWidthPlus||0)),e&&!e.dashstyle))for(k={"stroke-width":k},e.animate(k,d(c.chart.options.chart.animation,f[a]&&f[a].animation));c["zone-graph-"+b];)c["zone-graph-"+b].attr(k),b+=1},setVisible:function(a,c){var b=this,d=b.chart,e=b.legendItem,f,k=d.options.chart.ignoreHiddenSeries,n=b.visible;f=(b.visible=a=b.options.visible=b.userOptions.visible=void 0===a?!n:a)?"show":"hide";p(["group",
	"dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(b[a])b[a][f]()});if(d.hoverSeries===b||(d.hoverPoint&&d.hoverPoint.series)===b)b.onMouseOut();e&&d.legend.colorizeItem(b,a);b.isDirty=!0;b.options.stacking&&p(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});p(b.linkedSeries,function(b){b.setVisible(a,!1)});k&&(d.isDirtyBox=!0);!1!==c&&d.redraw();v(b,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===
	a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);v(this,a?"select":"unselect")},drawTracker:I.drawTrackerGraph})})(M);(function(a){var D=a.Chart,B=a.each,G=a.inArray,E=a.isArray,r=a.isObject,g=a.pick,p=a.splat;D.prototype.setResponsive=function(g){var p=this.options.responsive,r=[],l=this.currentResponsive;p&&p.rules&&B(p.rules,function(e){void 0===e._id&&(e._id=a.uniqueKey());this.matchResponsiveRule(e,r,g)},this);var e=a.merge.apply(0,a.map(r,function(e){return a.find(p.rules,function(a){return a._id===
	e}).chartOptions})),r=r.toString()||void 0;r!==(l&&l.ruleIds)&&(l&&this.update(l.undoOptions,g),r?(this.currentResponsive={ruleIds:r,mergedOptions:e,undoOptions:this.currentOptions(e)},this.update(e,g)):this.currentResponsive=void 0)};D.prototype.matchResponsiveRule=function(a,p){var r=a.condition;(r.callback||function(){return this.chartWidth<=g(r.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=g(r.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=g(r.minWidth,0)&&this.chartHeight>=g(r.minHeight,0)}).call(this)&&
	p.push(a._id)};D.prototype.currentOptions=function(g){function t(g,e,k,f){var d;a.objectEach(g,function(a,l){if(!f&&-1<G(l,["series","xAxis","yAxis"]))for(g[l]=p(g[l]),k[l]=[],d=0;d<g[l].length;d++)e[l][d]&&(k[l][d]={},t(a[d],e[l][d],k[l][d],f+1));else r(a)?(k[l]=E(a)?[]:{},t(a,e[l]||{},k[l],f+1)):k[l]=e[l]||null})}var u={};t(g,this.options,u,0);return u}})(M);(function(a){var D=a.addEvent,B=a.Axis,G=a.Chart,E=a.css,r=a.dateFormat,g=a.defined,p=a.each,t=a.extend,v=a.noop,u=a.timeUnits,l=a.wrap;l(a.Series.prototype,
	"init",function(a){var e;a.apply(this,Array.prototype.slice.call(arguments,1));(e=this.xAxis)&&e.options.ordinal&&D(this,"updatedData",function(){delete e.ordinalIndex})});l(B.prototype,"getTimeTicks",function(a,k,f,d,l,p,c,q){var e=0,m,t,b={},z,x,y,A=[],n=-Number.MAX_VALUE,H=this.options.tickPixelInterval;if(!this.options.ordinal&&!this.options.breaks||!p||3>p.length||void 0===f)return a.call(this,k,f,d,l);x=p.length;for(m=0;m<x;m++){y=m&&p[m-1]>d;p[m]<f&&(e=m);if(m===x-1||p[m+1]-p[m]>5*c||y){if(p[m]>
	n){for(t=a.call(this,k,p[e],p[m],l);t.length&&t[0]<=n;)t.shift();t.length&&(n=t[t.length-1]);A=A.concat(t)}e=m+1}if(y)break}a=t.info;if(q&&a.unitRange<=u.hour){m=A.length-1;for(e=1;e<m;e++)r("%d",A[e])!==r("%d",A[e-1])&&(b[A[e]]="day",z=!0);z&&(b[A[0]]="day");a.higherRanks=b}A.info=a;if(q&&g(H)){q=a=A.length;m=[];var h;for(z=[];q--;)e=this.translate(A[q]),h&&(z[q]=h-e),m[q]=h=e;z.sort();z=z[Math.floor(z.length/2)];z<.6*H&&(z=null);q=A[a-1]>d?a-1:a;for(h=void 0;q--;)e=m[q],d=Math.abs(h-e),h&&d<.8*
	H&&(null===z||d<.8*z)?(b[A[q]]&&!b[A[q+1]]?(d=q+1,h=e):d=q,A.splice(d,1)):h=e}return A});t(B.prototype,{beforeSetTickPositions:function(){var a,k=[],f=!1,d,g=this.getExtremes(),l=g.min,c=g.max,q,r=this.isXAxis&&!!this.options.breaks,g=this.options.ordinal,m=this.chart.options.chart.ignoreHiddenSeries;if(g||r){p(this.series,function(c,b){if(!(m&&!1===c.visible||!1===c.takeOrdinalPosition&&!r)&&(k=k.concat(c.processedXData),a=k.length,k.sort(function(a,b){return a-b}),a))for(b=a-1;b--;)k[b]===k[b+1]&&
	k.splice(b,1)});a=k.length;if(2<a){d=k[1]-k[0];for(q=a-1;q--&&!f;)k[q+1]-k[q]!==d&&(f=!0);!this.options.keepOrdinalPadding&&(k[0]-l>d||c-k[k.length-1]>d)&&(f=!0)}f?(this.ordinalPositions=k,d=this.ordinal2lin(Math.max(l,k[0]),!0),q=Math.max(this.ordinal2lin(Math.min(c,k[k.length-1]),!0),1),this.ordinalSlope=c=(c-l)/(q-d),this.ordinalOffset=l-d*c):this.ordinalPositions=this.ordinalSlope=this.ordinalOffset=void 0}this.isOrdinal=g&&f;this.groupIntervalFactor=null},val2lin:function(a,k){var e=this.ordinalPositions;
	if(e){var d=e.length,g,l;for(g=d;g--;)if(e[g]===a){l=g;break}for(g=d-1;g--;)if(a>e[g]||0===g){a=(a-e[g])/(e[g+1]-e[g]);l=g+a;break}k=k?l:this.ordinalSlope*(l||0)+this.ordinalOffset}else k=a;return k},lin2val:function(a,k){var e=this.ordinalPositions;if(e){var d=this.ordinalSlope,g=this.ordinalOffset,l=e.length-1,c;if(k)0>a?a=e[0]:a>l?a=e[l]:(l=Math.floor(a),c=a-l);else for(;l--;)if(k=d*l+g,a>=k){d=d*(l+1)+g;c=(a-k)/(d-k);break}return void 0!==c&&void 0!==e[l]?e[l]+(c?c*(e[l+1]-e[l]):0):a}return a},
	getExtendedPositions:function(){var a=this.chart,k=this.series[0].currentDataGrouping,f=this.ordinalIndex,d=k?k.count+k.unitName:"raw",g=this.getExtremes(),l,c;f||(f=this.ordinalIndex={});f[d]||(l={series:[],chart:a,getExtremes:function(){return{min:g.dataMin,max:g.dataMax}},options:{ordinal:!0},val2lin:B.prototype.val2lin,ordinal2lin:B.prototype.ordinal2lin},p(this.series,function(d){c={xAxis:l,xData:d.xData,chart:a,destroyGroupedData:v};c.options={dataGrouping:k?{enabled:!0,forced:!0,approximation:"open",
	units:[[k.unitName,[k.count]]]}:{enabled:!1}};d.processData.apply(c);l.series.push(c)}),this.beforeSetTickPositions.apply(l),f[d]=l.ordinalPositions);return f[d]},getGroupIntervalFactor:function(a,k,f){var d;f=f.processedXData;var e=f.length,g=[];d=this.groupIntervalFactor;if(!d){for(d=0;d<e-1;d++)g[d]=f[d+1]-f[d];g.sort(function(a,d){return a-d});g=g[Math.floor(e/2)];a=Math.max(a,f[0]);k=Math.min(k,f[e-1]);this.groupIntervalFactor=d=e*g/(k-a)}return d},postProcessTickInterval:function(a){var e=this.ordinalSlope;
	return e?this.options.breaks?this.closestPointRange:a/(e/this.closestPointRange):a}});B.prototype.ordinal2lin=B.prototype.val2lin;l(G.prototype,"pan",function(a,k){var e=this.xAxis[0],d=k.chartX,g=!1;if(e.options.ordinal&&e.series.length){var l=this.mouseDownX,c=e.getExtremes(),q=c.dataMax,r=c.min,m=c.max,t=this.hoverPoints,b=e.closestPointRange,l=(l-d)/(e.translationSlope*(e.ordinalSlope||b)),z={ordinalPositions:e.getExtendedPositions()},b=e.lin2val,u=e.val2lin,y;z.ordinalPositions?1<Math.abs(l)&&
	(t&&p(t,function(a){a.setState()}),0>l?(t=z,y=e.ordinalPositions?e:z):(t=e.ordinalPositions?e:z,y=z),z=y.ordinalPositions,q>z[z.length-1]&&z.push(q),this.fixedRange=m-r,l=e.toFixedRange(null,null,b.apply(t,[u.apply(t,[r,!0])+l,!0]),b.apply(y,[u.apply(y,[m,!0])+l,!0])),l.min>=Math.min(c.dataMin,r)&&l.max<=Math.max(q,m)&&e.setExtremes(l.min,l.max,!0,!1,{trigger:"pan"}),this.mouseDownX=d,E(this.container,{cursor:"move"})):g=!0}else g=!0;g&&a.apply(this,Array.prototype.slice.call(arguments,1))})})(M);
	(function(a){function D(){return Array.prototype.slice.call(arguments,1)}function B(a){a.apply(this);this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,G(this.pointArrayMap,["y"]))}var G=a.pick,E=a.wrap,r=a.each,g=a.extend,p=a.isArray,t=a.fireEvent,v=a.Axis,u=a.Series;g(v.prototype,{isInBreak:function(a,e){var k=a.repeat||Infinity,f=a.from,d=a.to-a.from;e=e>=f?(e-f)%k:k-(f-e)%k;return a.inclusive?e<=d:e<d&&0!==e},isInAnyBreak:function(a,e){var k=this.options.breaks,f=k&&k.length,d,g,l;if(f){for(;f--;)this.isInBreak(k[f],
	a)&&(d=!0,g||(g=G(k[f].showPoints,this.isXAxis?!1:!0)));l=d&&e?d&&!g:d}return l}});E(v.prototype,"setTickPositions",function(a){a.apply(this,Array.prototype.slice.call(arguments,1));if(this.options.breaks){var e=this.tickPositions,k=this.tickPositions.info,f=[],d;for(d=0;d<e.length;d++)this.isInAnyBreak(e[d])||f.push(e[d]);this.tickPositions=f;this.tickPositions.info=k}});E(v.prototype,"init",function(a,e,k){var f=this;k.breaks&&k.breaks.length&&(k.ordinal=!1);a.call(this,e,k);a=this.options.breaks;
	f.isBroken=p(a)&&!!a.length;f.isBroken&&(f.val2lin=function(a){var d=a,e,c;for(c=0;c<f.breakArray.length;c++)if(e=f.breakArray[c],e.to<=a)d-=e.len;else if(e.from>=a)break;else if(f.isInBreak(e,a)){d-=a-e.from;break}return d},f.lin2val=function(a){var d,e;for(e=0;e<f.breakArray.length&&!(d=f.breakArray[e],d.from>=a);e++)d.to<a?a+=d.len:f.isInBreak(d,a)&&(a+=d.len);return a},f.setExtremes=function(a,e,f,c,k){for(;this.isInAnyBreak(a);)a-=this.closestPointRange;for(;this.isInAnyBreak(e);)e-=this.closestPointRange;
	v.prototype.setExtremes.call(this,a,e,f,c,k)},f.setAxisTranslation=function(a){v.prototype.setAxisTranslation.call(this,a);a=f.options.breaks;var d=[],e=[],c=0,k,g,l=f.userMin||f.min,p=f.userMax||f.max,b=G(f.pointRangePadding,0),z,u;r(a,function(a){g=a.repeat||Infinity;f.isInBreak(a,l)&&(l+=a.to%g-l%g);f.isInBreak(a,p)&&(p-=p%g-a.from%g)});r(a,function(a){z=a.from;for(g=a.repeat||Infinity;z-g>l;)z-=g;for(;z<l;)z+=g;for(u=z;u<p;u+=g)d.push({value:u,move:"in"}),d.push({value:u+(a.to-a.from),move:"out",
	size:a.breakSize})});d.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?0:1):a.value-b.value});k=0;z=l;r(d,function(a){k+="in"===a.move?1:-1;1===k&&"in"===a.move&&(z=a.value);0===k&&(e.push({from:z,to:a.value,len:a.value-z-(a.size||0)}),c+=a.value-z-(a.size||0))});f.breakArray=e;f.unitLength=p-l-c+b;t(f,"afterBreaks");f.options.staticScale?f.transA=f.options.staticScale:f.unitLength&&(f.transA*=(p-f.min+b)/f.unitLength);b&&(f.minPixelPadding=f.transA*f.minPointOffset);
	f.min=l;f.max=p})});E(u.prototype,"generatePoints",function(a){a.apply(this,D(arguments));var e=this.xAxis,k=this.yAxis,f=this.points,d,g=f.length,l=this.options.connectNulls,c;if(e&&k&&(e.options.breaks||k.options.breaks))for(;g--;)d=f[g],c=null===d.y&&!1===l,c||!e.isInAnyBreak(d.x,!0)&&!k.isInAnyBreak(d.y,!0)||(f.splice(g,1),this.data[g]&&this.data[g].destroyElements())});a.Series.prototype.drawBreaks=function(a,e){var k=this,f=k.points,d,g,l,c;a&&r(e,function(e){d=a.breakArray||[];g=a.isXAxis?
	a.min:G(k.options.threshold,a.min);r(f,function(f){c=G(f["stack"+e.toUpperCase()],f[e]);r(d,function(d){l=!1;if(g<d.from&&c>d.to||g>d.from&&c<d.from)l="pointBreak";else if(g<d.from&&c>d.from&&c<d.to||g>d.from&&c>d.to&&c<d.from)l="pointInBreak";l&&t(a,l,{point:f,brk:d})})})})};a.Series.prototype.gappedPath=function(){var g=this.options.gapSize,e=this.points.slice(),k=e.length-1,f=this.yAxis,d;if(g&&0<k)for("value"!==this.options.gapUnit&&(g*=this.closestPointRange);k--;)e[k+1].x-e[k].x>g&&(d=(e[k].x+
	e[k+1].x)/2,e.splice(k+1,0,{isNull:!0,x:d}),this.options.stacking&&(d=f.stacks[this.stackKey][d]=new a.StackItem(f,f.options.stackLabels,!1,d,this.stack),d.total=0));return this.getGraphPath(e)};E(a.seriesTypes.column.prototype,"drawPoints",B);E(a.Series.prototype,"drawPoints",B)})(M);(function(a){var D=a.arrayMax,B=a.arrayMin,G=a.Axis,E=a.defaultPlotOptions,r=a.defined,g=a.each,p=a.extend,t=a.format,v=a.isNumber,u=a.merge,l=a.pick,e=a.Point,k=a.Tooltip,f=a.wrap,d=a.Series.prototype,x=d.processData,
	C=d.generatePoints,c=d.destroy,q={approximation:"average",groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %b %e, %H:%M:%S.%L","%A, %b %e, %H:%M:%S.%L","-%H:%M:%S.%L"],second:["%A, %b %e, %H:%M:%S","%A, %b %e, %H:%M:%S","-%H:%M:%S"],minute:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],hour:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],day:["%A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],week:["Week from %A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],month:["%B %Y","%B","-%B %Y"],year:["%Y",
	"%Y","-%Y"]}},I={line:{},spline:{},area:{},areaspline:{},column:{approximation:"sum",groupPixelWidth:10},arearange:{approximation:"range"},areasplinerange:{approximation:"range"},columnrange:{approximation:"range",groupPixelWidth:10},candlestick:{approximation:"ohlc",groupPixelWidth:10},ohlc:{approximation:"ohlc",groupPixelWidth:5}},m=a.defaultDataGroupingUnits=[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",
	[1]],["week",[1]],["month",[1,3,6]],["year",null]],J={sum:function(a){var b=a.length,c;if(!b&&a.hasNulls)c=null;else if(b)for(c=0;b--;)c+=a[b];return c},average:function(a){var b=a.length;a=J.sum(a);v(a)&&b&&(a/=b);return a},averages:function(){var a=[];g(arguments,function(b){a.push(J.average(b))});return a},open:function(a){return a.length?a[0]:a.hasNulls?null:void 0},high:function(a){return a.length?D(a):a.hasNulls?null:void 0},low:function(a){return a.length?B(a):a.hasNulls?null:void 0},close:function(a){return a.length?
	a[a.length-1]:a.hasNulls?null:void 0},ohlc:function(a,c,d,e){a=J.open(a);c=J.high(c);d=J.low(d);e=J.close(e);if(v(a)||v(c)||v(d)||v(e))return[a,c,d,e]},range:function(a,c){a=J.low(a);c=J.high(c);if(v(a)||v(c))return[a,c];if(null===a&&null===c)return null}};d.groupData=function(a,c,d,e){var b=this.data,f=this.options.data,k=[],h=[],l=[],m=a.length,p,r,t=!!c,u=[];e="function"===typeof e?e:J[e]||I[this.type]&&J[I[this.type].approximation]||J[q.approximation];var z=this.pointArrayMap,y=z&&z.length,x=
	0;r=0;var C,K;y?g(z,function(){u.push([])}):u.push([]);C=y||1;for(K=0;K<=m&&!(a[K]>=d[0]);K++);for(K;K<=m;K++){for(;void 0!==d[x+1]&&a[K]>=d[x+1]||K===m;){p=d[x];this.dataGroupInfo={start:r,length:u[0].length};r=e.apply(this,u);void 0!==r&&(k.push(p),h.push(r),l.push(this.dataGroupInfo));r=K;for(p=0;p<C;p++)u[p].length=0,u[p].hasNulls=!1;x+=1;if(K===m)break}if(K===m)break;if(z){p=this.cropStart+K;var B=b&&b[p]||this.pointClass.prototype.applyOptions.apply({series:this},[f[p]]),D;for(p=0;p<y;p++)D=
	B[z[p]],v(D)?u[p].push(D):null===D&&(u[p].hasNulls=!0)}else p=t?c[K]:null,v(p)?u[0].push(p):null===p&&(u[0].hasNulls=!0)}return[k,h,l]};d.processData=function(){var a=this.chart,c=this.options.dataGrouping,e=!1!==this.allowDG&&c&&l(c.enabled,a.options.isStock),f=this.visible||!a.options.chart.ignoreHiddenSeries,k;this.forceCrop=e;this.groupPixelWidth=null;this.hasProcessed=!0;if(!1!==x.apply(this,arguments)&&e){this.destroyGroupedData();var n=this.processedXData,g=this.processedYData,h=a.plotSizeX,
	a=this.xAxis,q=a.options.ordinal,p=this.groupPixelWidth=a.getGroupPixelWidth&&a.getGroupPixelWidth();if(p){this.isDirty=k=!0;this.points=null;var t=a.getExtremes(),e=t.min,t=t.max,q=q&&a.getGroupIntervalFactor(e,t,this)||1,h=p*(t-e)/h*q,p=a.getTimeTicks(a.normalizeTimeTickInterval(h,c.units||m),Math.min(e,n[0]),Math.max(t,n[n.length-1]),a.options.startOfWeek,n,this.closestPointRange),n=d.groupData.apply(this,[n,g,p,c.approximation]),g=n[0],q=n[1];if(c.smoothed){c=g.length-1;for(g[c]=Math.min(g[c],
	t);c--&&0<c;)g[c]+=h/2;g[0]=Math.max(g[0],e)}this.currentDataGrouping=p.info;this.closestPointRange=p.info.totalRange;this.groupMap=n[2];r(g[0])&&g[0]<a.dataMin&&f&&(a.min===a.dataMin&&(a.min=g[0]),a.dataMin=g[0]);this.processedXData=g;this.processedYData=q}else this.currentDataGrouping=this.groupMap=null;this.hasGroupedData=k}};d.destroyGroupedData=function(){var a=this.groupedData;g(a||[],function(b,c){b&&(a[c]=b.destroy?b.destroy():null)});this.groupedData=null};d.generatePoints=function(){C.apply(this);
	this.destroyGroupedData();this.groupedData=this.hasGroupedData?this.points:null};f(e.prototype,"update",function(b){this.dataGroup?a.error(24):b.apply(this,[].slice.call(arguments,1))});f(k.prototype,"tooltipFooterHeaderFormatter",function(b,c,d){var e=c.series,f=e.tooltipOptions,n=e.options.dataGrouping,k=f.xDateFormat,h,g=e.xAxis,l=a.dateFormat;return g&&"datetime"===g.options.type&&n&&v(c.key)?(b=e.currentDataGrouping,n=n.dateTimeLabelFormats,b?(g=n[b.unitName],1===b.count?k=g[0]:(k=g[1],h=g[2])):
	!k&&n&&(k=this.getXDateFormat(c,f,g)),k=l(k,c.key),h&&(k+=l(h,c.key+b.totalRange-1)),t(f[(d?"footer":"header")+"Format"],{point:p(c.point,{key:k}),series:e})):b.call(this,c,d)});d.destroy=function(){for(var a=this.groupedData||[],d=a.length;d--;)a[d]&&a[d].destroy();c.apply(this)};f(d,"setOptions",function(a,c){a=a.call(this,c);var b=this.type,d=this.chart.options.plotOptions,e=E[b].dataGrouping;I[b]&&(e||(e=u(q,I[b])),a.dataGrouping=u(e,d.series&&d.series.dataGrouping,d[b].dataGrouping,c.dataGrouping));
	this.chart.options.isStock&&(this.requireSorting=!0);return a});f(G.prototype,"setScale",function(a){a.call(this);g(this.series,function(a){a.hasProcessed=!1})});G.prototype.getGroupPixelWidth=function(){var a=this.series,c=a.length,d,e=0,f=!1,n;for(d=c;d--;)(n=a[d].options.dataGrouping)&&(e=Math.max(e,n.groupPixelWidth));for(d=c;d--;)(n=a[d].options.dataGrouping)&&a[d].hasProcessed&&(c=(a[d].processedXData||a[d].data).length,a[d].groupPixelWidth||c>this.chart.plotSizeX/e||c&&n.forced)&&(f=!0);return f?
	e:0};G.prototype.setDataGrouping=function(a,c){var b;c=l(c,!0);a||(a={forced:!1,units:null});if(this instanceof G)for(b=this.series.length;b--;)this.series[b].update({dataGrouping:a},!1);else g(this.chart.options.series,function(b){b.dataGrouping=a},!1);c&&this.chart.redraw()}})(M);(function(a){var D=a.each,B=a.Point,G=a.seriesType,E=a.seriesTypes;G("ohlc","column",{lineWidth:1,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eOpen: {point.open}\x3cbr/\x3eHigh: {point.high}\x3cbr/\x3eLow: {point.low}\x3cbr/\x3eClose: {point.close}\x3cbr/\x3e'},
	threshold:null,states:{hover:{lineWidth:3}},stickyTracking:!0},{directTouch:!1,pointArrayMap:["open","high","low","close"],toYData:function(a){return[a.open,a.high,a.low,a.close]},pointValKey:"close",pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},pointAttribs:function(a,g){g=E.column.prototype.pointAttribs.call(this,a,g);var p=this.options;delete g.fill;!a.options.color&&p.upColor&&a.open<a.close&&(g.stroke=p.upColor);return g},translate:function(){var a=this,g=a.yAxis,p=!!a.modifyValue,
	t=["plotOpen","plotHigh","plotLow","plotClose","yBottom"];E.column.prototype.translate.apply(a);D(a.points,function(r){D([r.open,r.high,r.low,r.close,r.low],function(u,l){null!==u&&(p&&(u=a.modifyValue(u)),r[t[l]]=g.toPixels(u,!0))});r.tooltipPos[1]=r.plotHigh+g.pos-a.chart.plotTop})},drawPoints:function(){var a=this,g=a.chart;D(a.points,function(p){var r,v,u,l,e=p.graphic,k,f=!e;void 0!==p.plotY&&(e||(p.graphic=e=g.renderer.path().add(a.group)),e.attr(a.pointAttribs(p,p.selected&&"select")),v=e.strokeWidth()%
	2/2,k=Math.round(p.plotX)-v,u=Math.round(p.shapeArgs.width/2),l=["M",k,Math.round(p.yBottom),"L",k,Math.round(p.plotHigh)],null!==p.open&&(r=Math.round(p.plotOpen)+v,l.push("M",k,r,"L",k-u,r)),null!==p.close&&(r=Math.round(p.plotClose)+v,l.push("M",k,r,"L",k+u,r)),e[f?"attr":"animate"]({d:l}).addClass(p.getClassName(),!0))})},animate:null},{getClassName:function(){return B.prototype.getClassName.call(this)+(this.open<this.close?" highcharts-point-up":" highcharts-point-down")}})})(M);(function(a){var D=
	a.defaultPlotOptions,B=a.each,G=a.merge,E=a.seriesType,r=a.seriesTypes;E("candlestick","ohlc",G(D.column,{states:{hover:{lineWidth:2}},tooltip:D.ohlc.tooltip,threshold:null,lineColor:"#000000",lineWidth:1,upColor:"#ffffff",stickyTracking:!0}),{pointAttribs:function(a,p){var g=r.column.prototype.pointAttribs.call(this,a,p),v=this.options,u=a.open<a.close,l=v.lineColor||this.color;g["stroke-width"]=v.lineWidth;g.fill=a.options.color||(u?v.upColor||this.color:this.color);g.stroke=a.lineColor||(u?v.upLineColor||
	l:l);p&&(a=v.states[p],g.fill=a.color||g.fill,g.stroke=a.lineColor||g.stroke,g["stroke-width"]=a.lineWidth||g["stroke-width"]);return g},drawPoints:function(){var a=this,p=a.chart;B(a.points,function(g){var r=g.graphic,u,l,e,k,f,d,t,C=!r;void 0!==g.plotY&&(r||(g.graphic=r=p.renderer.path().add(a.group)),r.attr(a.pointAttribs(g,g.selected&&"select")).shadow(a.options.shadow),f=r.strokeWidth()%2/2,d=Math.round(g.plotX)-f,u=g.plotOpen,l=g.plotClose,e=Math.min(u,l),u=Math.max(u,l),t=Math.round(g.shapeArgs.width/
	2),l=Math.round(e)!==Math.round(g.plotHigh),k=u!==g.yBottom,e=Math.round(e)+f,u=Math.round(u)+f,f=[],f.push("M",d-t,u,"L",d-t,e,"L",d+t,e,"L",d+t,u,"Z","M",d,e,"L",d,l?Math.round(g.plotHigh):e,"M",d,u,"L",d,k?Math.round(g.yBottom):u),r[C?"attr":"animate"]({d:f}).addClass(g.getClassName(),!0))})}})})(M);(function(a){var D=a.addEvent,B=a.each,G=a.merge,E=a.noop,r=a.Renderer,g=a.seriesType,p=a.seriesTypes,t=a.TrackerMixin,v=a.VMLRenderer,u=a.SVGRenderer.prototype.symbols,l=a.stableSort;g("flags","column",
	{pointRange:0,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}\x3cbr/\x3e"},threshold:null,y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd6eb"}},style:{fontSize:"11px",fontWeight:"bold"}},{sorted:!1,noSharedTooltip:!0,allowDG:!1,takeOrdinalPosition:!1,trackerGroups:["markerGroup"],forceCrop:!0,init:a.Series.prototype.init,pointAttribs:function(a,k){var e=this.options,d=a&&a.color||this.color,g=e.lineColor,l=a&&a.lineWidth;
	a=a&&a.fillColor||e.fillColor;k&&(a=e.states[k].fillColor,g=e.states[k].lineColor,l=e.states[k].lineWidth);return{fill:a||d,stroke:g||d,"stroke-width":l||e.lineWidth||0}},translate:function(){p.column.prototype.translate.apply(this);var a=this.options,k=this.chart,f=this.points,d=f.length-1,g,r,c=a.onSeries;g=c&&k.get(c);var a=a.onKey||"y",c=g&&g.options.step,q=g&&g.points,t=q&&q.length,m=this.xAxis,u=this.yAxis,b=m.getExtremes(),z=0,v,y,A;if(g&&g.visible&&t)for(z=(g.pointXOffset||0)+(g.barW||0)/
	2,g=g.currentDataGrouping,y=q[t-1].x+(g?g.totalRange:0),l(f,function(a,b){return a.x-b.x}),a="plot"+a[0].toUpperCase()+a.substr(1);t--&&f[d]&&!(g=f[d],v=q[t],v.x<=g.x&&void 0!==v[a]&&(g.x<=y&&(g.plotY=v[a],v.x<g.x&&!c&&(A=q[t+1])&&void 0!==A[a]&&(g.plotY+=(g.x-v.x)/(A.x-v.x)*(A[a]-v[a]))),d--,t++,0>d)););B(f,function(a,c){var d;void 0===a.plotY&&(a.x>=b.min&&a.x<=b.max?a.plotY=k.chartHeight-m.bottom-(m.opposite?m.height:0)+m.offset-u.top:a.shapeArgs={});a.plotX+=z;(r=f[c-1])&&r.plotX===a.plotX&&(void 0===
	r.stackIndex&&(r.stackIndex=0),d=r.stackIndex+1);a.stackIndex=d})},drawPoints:function(){var e=this.points,g=this.chart,f=g.renderer,d,l,p=this.options,c=p.y,q,r,m,t,b,u,v,y=this.yAxis;for(r=e.length;r--;)m=e[r],v=m.plotX>this.xAxis.len,d=m.plotX,t=m.stackIndex,q=m.options.shape||p.shape,l=m.plotY,void 0!==l&&(l=m.plotY+c-(void 0!==t&&t*p.stackDistance)),b=t?void 0:m.plotX,u=t?void 0:m.plotY,t=m.graphic,void 0!==l&&0<=d&&!v?(t||(t=m.graphic=f.label("",null,null,q,null,null,p.useHTML).attr(this.pointAttribs(m)).css(G(p.style,
	m.style)).attr({align:"flag"===q?"left":"center",width:p.width,height:p.height,"text-align":p.textAlign}).addClass("highcharts-point").add(this.markerGroup),m.graphic.div&&(m.graphic.div.point=m),t.shadow(p.shadow)),0<d&&(d-=t.strokeWidth()%2),t.attr({text:m.options.title||p.title||"A",x:d,y:l,anchorX:b,anchorY:u}),m.tooltipPos=g.inverted?[y.len+y.pos-g.plotLeft-l,this.xAxis.len-d]:[d,l+y.pos-g.plotTop]):t&&(m.graphic=t.destroy());p.useHTML&&a.wrap(this.markerGroup,"on",function(b){return a.SVGElement.prototype.on.apply(b.apply(this,
	[].slice.call(arguments,1)),[].slice.call(arguments,1))})},drawTracker:function(){var a=this.points;t.drawTrackerPoint.apply(this);B(a,function(e){var f=e.graphic;f&&D(f.element,"mouseover",function(){0<e.stackIndex&&!e.raised&&(e._y=f.y,f.attr({y:e._y-8}),e.raised=!0);B(a,function(a){a!==e&&a.raised&&a.graphic&&(a.graphic.attr({y:a._y}),a.raised=!1)})})})},animate:E,buildKDTree:E,setClip:E});u.flag=function(a,g,f,d,l){return["M",l&&l.anchorX||a,l&&l.anchorY||g,"L",a,g+d,a,g,a+f,g,a+f,g+d,a,g+d,"Z"]};
	B(["circle","square"],function(a){u[a+"pin"]=function(e,f,d,g,l){var c=l&&l.anchorX;l=l&&l.anchorY;"circle"===a&&g>d&&(e-=Math.round((g-d)/2),d=g);e=u[a](e,f,d,g);c&&l&&e.push("M",c,f>l?f:f+g,"L",c,l);return e}});r===v&&B(["flag","circlepin","squarepin"],function(a){v.prototype.symbols[a]=u[a]})})(M);(function(a){function D(a,d,e){this.init(a,d,e)}var B=a.addEvent,G=a.Axis,E=a.correctFloat,r=a.defaultOptions,g=a.defined,p=a.destroyObjectProperties,t=a.each,v=a.fireEvent,u=a.hasTouch,l=a.isTouchDevice,
	e=a.merge,k=a.pick,f=a.removeEvent,d=a.wrap,x,C={height:l?20:14,barBorderRadius:0,buttonBorderRadius:0,liveRedraw:a.svg&&!l,margin:10,minWidth:6,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:1,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"#333333",trackBackgroundColor:"#f2f2f2",trackBorderColor:"#f2f2f2",trackBorderWidth:1};r.scrollbar=e(!0,C,r.scrollbar);a.swapXY=x=function(a,d){var c=
	a.length,e;if(d)for(d=0;d<c;d+=3)e=a[d+1],a[d+1]=a[d+2],a[d+2]=e;return a};D.prototype={init:function(a,d,f){this.scrollbarButtons=[];this.renderer=a;this.userOptions=d;this.options=e(C,d);this.chart=f;this.size=k(this.options.size,this.options.height);d.enabled&&(this.render(),this.initEvents(),this.addEvents())},render:function(){var a=this.renderer,d=this.options,e=this.size,f;this.group=f=a.g("scrollbar").attr({zIndex:d.zIndex,translateY:-99999}).add();this.track=a.rect().addClass("highcharts-scrollbar-track").attr({x:0,
	r:d.trackBorderRadius||0,height:e,width:e}).add(f);this.track.attr({fill:d.trackBackgroundColor,stroke:d.trackBorderColor,"stroke-width":d.trackBorderWidth});this.trackBorderWidth=this.track.strokeWidth();this.track.attr({y:-this.trackBorderWidth%2/2});this.scrollbarGroup=a.g().add(f);this.scrollbar=a.rect().addClass("highcharts-scrollbar-thumb").attr({height:e,width:e,r:d.barBorderRadius||0}).add(this.scrollbarGroup);this.scrollbarRifles=a.path(x(["M",-3,e/4,"L",-3,2*e/3,"M",0,e/4,"L",0,2*e/3,"M",
	3,e/4,"L",3,2*e/3],d.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);this.scrollbar.attr({fill:d.barBackgroundColor,stroke:d.barBorderColor,"stroke-width":d.barBorderWidth});this.scrollbarRifles.attr({stroke:d.rifleColor,"stroke-width":1});this.scrollbarStrokeWidth=this.scrollbar.strokeWidth();this.scrollbarGroup.translate(-this.scrollbarStrokeWidth%2/2,-this.scrollbarStrokeWidth%2/2);this.drawScrollbarButton(0);this.drawScrollbarButton(1)},position:function(a,d,e,f){var c=
	this.options.vertical,b=0,g=this.rendered?"animate":"attr";this.x=a;this.y=d+this.trackBorderWidth;this.width=e;this.xOffset=this.height=f;this.yOffset=b;c?(this.width=this.yOffset=e=b=this.size,this.xOffset=d=0,this.barWidth=f-2*e,this.x=a+=this.options.margin):(this.height=this.xOffset=f=d=this.size,this.barWidth=e-2*f,this.y+=this.options.margin);this.group[g]({translateX:a,translateY:this.y});this.track[g]({width:e,height:f});this.scrollbarButtons[1][g]({translateX:c?0:e-d,translateY:c?f-b:0})},
	drawScrollbarButton:function(a){var c=this.renderer,d=this.scrollbarButtons,e=this.options,f=this.size,b;b=c.g().add(this.group);d.push(b);b=c.rect().addClass("highcharts-scrollbar-button").add(b);b.attr({stroke:e.buttonBorderColor,"stroke-width":e.buttonBorderWidth,fill:e.buttonBackgroundColor});b.attr(b.crisp({x:-.5,y:-.5,width:f+1,height:f+1,r:e.buttonBorderRadius},b.strokeWidth()));b=c.path(x(["M",f/2+(a?-1:1),f/2-3,"L",f/2+(a?-1:1),f/2+3,"L",f/2+(a?2:-2),f/2],e.vertical)).addClass("highcharts-scrollbar-arrow").add(d[a]);
	b.attr({fill:e.buttonArrowColor})},setRange:function(a,d){var c=this.options,e=c.vertical,f=c.minWidth,b=this.barWidth,k,l,p=this.rendered&&!this.hasDragged?"animate":"attr";g(b)&&(a=Math.max(a,0),k=Math.ceil(b*a),this.calculatedWidth=l=E(b*Math.min(d,1)-k),l<f&&(k=(b-f+l)*a,l=f),f=Math.floor(k+this.xOffset+this.yOffset),b=l/2-.5,this.from=a,this.to=d,e?(this.scrollbarGroup[p]({translateY:f}),this.scrollbar[p]({height:l}),this.scrollbarRifles[p]({translateY:b}),this.scrollbarTop=f,this.scrollbarLeft=
	0):(this.scrollbarGroup[p]({translateX:f}),this.scrollbar[p]({width:l}),this.scrollbarRifles[p]({translateX:b}),this.scrollbarLeft=f,this.scrollbarTop=0),12>=l?this.scrollbarRifles.hide():this.scrollbarRifles.show(!0),!1===c.showFull&&(0>=a&&1<=d?this.group.hide():this.group.show()),this.rendered=!0)},initEvents:function(){var a=this;a.mouseMoveHandler=function(c){var d=a.chart.pointer.normalize(c),e=a.options.vertical?"chartY":"chartX",f=a.initPositions;!a.grabbedCenter||c.touches&&0===c.touches[0][e]||
	(d=a.cursorToScrollbarPosition(d)[e],e=a[e],e=d-e,a.hasDragged=!0,a.updatePosition(f[0]+e,f[1]+e),a.hasDragged&&v(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:c.type,DOMEvent:c}))};a.mouseUpHandler=function(c){a.hasDragged&&v(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:c.type,DOMEvent:c});a.grabbedCenter=a.hasDragged=a.chartX=a.chartY=null};a.mouseDownHandler=function(c){c=a.chart.pointer.normalize(c);c=a.cursorToScrollbarPosition(c);a.chartX=c.chartX;a.chartY=c.chartY;
	a.initPositions=[a.from,a.to];a.grabbedCenter=!0};a.buttonToMinClick=function(c){var d=E(a.to-a.from)*a.options.step;a.updatePosition(E(a.from-d),E(a.to-d));v(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:c})};a.buttonToMaxClick=function(c){var d=(a.to-a.from)*a.options.step;a.updatePosition(a.from+d,a.to+d);v(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:c})};a.trackClick=function(c){var d=a.chart.pointer.normalize(c),e=a.to-a.from,f=a.y+a.scrollbarTop,b=a.x+a.scrollbarLeft;
	a.options.vertical&&d.chartY>f||!a.options.vertical&&d.chartX>b?a.updatePosition(a.from+e,a.to+e):a.updatePosition(a.from-e,a.to-e);v(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:c})}},cursorToScrollbarPosition:function(a){var c=this.options,c=c.minWidth>this.calculatedWidth?c.minWidth:0;return{chartX:(a.chartX-this.x-this.xOffset)/(this.barWidth-c),chartY:(a.chartY-this.y-this.yOffset)/(this.barWidth-c)}},updatePosition:function(a,d){1<d&&(a=E(1-E(d-a)),d=1);0>a&&(d=E(d-a),a=0);
	this.from=a;this.to=d},update:function(a){this.destroy();this.init(this.chart.renderer,e(!0,this.options,a),this.chart)},addEvents:function(){var a=this.options.inverted?[1,0]:[0,1],d=this.scrollbarButtons,e=this.scrollbarGroup.element,f=this.mouseDownHandler,g=this.mouseMoveHandler,b=this.mouseUpHandler,a=[[d[a[0]].element,"click",this.buttonToMinClick],[d[a[1]].element,"click",this.buttonToMaxClick],[this.track.element,"click",this.trackClick],[e,"mousedown",f],[e.ownerDocument,"mousemove",g],[e.ownerDocument,
	"mouseup",b]];u&&a.push([e,"touchstart",f],[e.ownerDocument,"touchmove",g],[e.ownerDocument,"touchend",b]);t(a,function(a){B.apply(null,a)});this._events=a},removeEvents:function(){t(this._events,function(a){f.apply(null,a)});this._events.length=0},destroy:function(){var a=this.chart.scroller;this.removeEvents();t(["track","scrollbarRifles","scrollbar","scrollbarGroup","group"],function(a){this[a]&&this[a].destroy&&(this[a]=this[a].destroy())},this);a&&this===a.scrollbar&&(a.scrollbar=null,p(a.scrollbarButtons))}};
	d(G.prototype,"init",function(a){var c=this;a.apply(c,Array.prototype.slice.call(arguments,1));c.options.scrollbar&&c.options.scrollbar.enabled&&(c.options.scrollbar.vertical=!c.horiz,c.options.startOnTick=c.options.endOnTick=!1,c.scrollbar=new D(c.chart.renderer,c.options.scrollbar,c.chart),B(c.scrollbar,"changed",function(a){var d=Math.min(k(c.options.min,c.min),c.min,c.dataMin),e=Math.max(k(c.options.max,c.max),c.max,c.dataMax)-d,b;c.horiz&&!c.reversed||!c.horiz&&c.reversed?(b=d+e*this.to,d+=e*
	this.from):(b=d+e*(1-this.from),d+=e*(1-this.to));c.setExtremes(d,b,!0,!1,a)}))});d(G.prototype,"render",function(a){var c=Math.min(k(this.options.min,this.min),this.min,k(this.dataMin,this.min)),d=Math.max(k(this.options.max,this.max),this.max,k(this.dataMax,this.max)),e=this.scrollbar,f=this.titleOffset||0;a.apply(this,Array.prototype.slice.call(arguments,1));if(e){this.horiz?(e.position(this.left,this.top+this.height+2+this.chart.scrollbarsOffsets[1]+(this.opposite?0:f+this.axisTitleMargin+this.offset),
	this.width,this.height),f=1):(e.position(this.left+this.width+2+this.chart.scrollbarsOffsets[0]+(this.opposite?f+this.axisTitleMargin+this.offset:0),this.top,this.width,this.height),f=0);if(!this.opposite&&!this.horiz||this.opposite&&this.horiz)this.chart.scrollbarsOffsets[f]+=this.scrollbar.size+this.scrollbar.options.margin;isNaN(c)||isNaN(d)||!g(this.min)||!g(this.max)?e.setRange(0,0):(f=(this.min-c)/(d-c),c=(this.max-c)/(d-c),this.horiz&&!this.reversed||!this.horiz&&this.reversed?e.setRange(f,
	c):e.setRange(1-c,1-f))}});d(G.prototype,"getOffset",function(a){var c=this.horiz?2:1,d=this.scrollbar;a.apply(this,Array.prototype.slice.call(arguments,1));d&&(this.chart.scrollbarsOffsets=[0,0],this.chart.axisOffset[c]+=d.size+d.options.margin)});d(G.prototype,"destroy",function(a){this.scrollbar&&(this.scrollbar=this.scrollbar.destroy());a.apply(this,Array.prototype.slice.call(arguments,1))});a.Scrollbar=D})(M);(function(a){function D(a){this.init(a)}var B=a.addEvent,G=a.Axis,E=a.Chart,r=a.color,
	g=a.defaultOptions,p=a.defined,t=a.destroyObjectProperties,v=a.each,u=a.erase,l=a.error,e=a.extend,k=a.grep,f=a.hasTouch,d=a.isArray,x=a.isNumber,C=a.isObject,c=a.merge,q=a.pick,I=a.removeEvent,m=a.Scrollbar,J=a.Series,b=a.seriesTypes,z=a.wrap,K=a.swapXY,y=[].concat(a.defaultDataGroupingUnits),A=function(a){var b=k(arguments,x);if(b.length)return Math[a].apply(0,b)};y[4]=["day",[1,2,3,4]];y[5]=["week",[1,2,3]];b=void 0===b.areaspline?"line":"areaspline";e(g,{navigator:{height:40,margin:25,maskInside:!0,
	handles:{backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:r("#6685c2").setOpacity(.3).get(),outlineColor:"#cccccc",outlineWidth:1,series:{type:b,color:"#335cad",fillOpacity:.05,lineWidth:1,compare:null,dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,smoothed:!0,units:y},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},pointRange:0,shadow:!1,threshold:null},xAxis:{className:"highcharts-navigator-xaxis",
	tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",style:{color:"#999999"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}});D.prototype={drawHandle:function(a,b,c,d){this.handles[b][d](c?{translateX:Math.round(this.left+this.height/2-8),translateY:Math.round(this.top+parseInt(a,
	10)+.5)}:{translateX:Math.round(this.left+parseInt(a,10)),translateY:Math.round(this.top+this.height/2-8)})},getHandlePath:function(a){return K(["M",-4.5,.5,"L",3.5,.5,"L",3.5,15.5,"L",-4.5,15.5,"L",-4.5,.5,"M",-1.5,4,"L",-1.5,12,"M",.5,4,"L",.5,12],a)},drawOutline:function(a,b,c,d){var e=this.navigatorOptions.maskInside,h=this.outline.strokeWidth(),f=h/2,h=h%2/2,g=this.outlineHeight,n=this.scrollbarHeight,k=this.size,l=this.left-n,m=this.top;c?(l-=f,c=m+b+h,b=m+a+h,a=["M",l+g,m-n-h,"L",l+g,c,"L",
	l,c,"L",l,b,"L",l+g,b,"L",l+g,m+k+n].concat(e?["M",l+g,c-f,"L",l+g,b+f]:[])):(a+=l+n-h,b+=l+n-h,m+=f,a=["M",l,m,"L",a,m,"L",a,m+g,"L",b,m+g,"L",b,m,"L",l+k+2*n,m].concat(e?["M",a-f,m,"L",b+f,m]:[]));this.outline[d]({d:a})},drawMasks:function(a,b,c,d){var e=this.left,h=this.top,f=this.height,g,n,k,l;c?(k=[e,e,e],l=[h,h+a,h+b],n=[f,f,f],g=[a,b-a,this.size-b]):(k=[e,e+a,e+b],l=[h,h,h],n=[a,b-a,this.size-b],g=[f,f,f]);v(this.shades,function(a,b){a[d]({x:k[b],y:l[b],width:n[b],height:g[b]})})},renderElements:function(){var a=
	this,b=a.navigatorOptions,c=b.maskInside,d=a.chart,e=d.inverted,f=d.renderer,g;a.navigatorGroup=g=f.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();var k={cursor:e?"ns-resize":"ew-resize"};v([!c,c,!c],function(c,d){a.shades[d]=f.rect().addClass("highcharts-navigator-mask"+(1===d?"-inside":"-outside")).attr({fill:c?b.maskFill:"rgba(0,0,0,0)"}).css(1===d&&k).add(g)});a.outline=f.path().addClass("highcharts-navigator-outline").attr({"stroke-width":b.outlineWidth,stroke:b.outlineColor}).add(g);
	v([0,1],function(c){a.handles[c]=f.path(a.getHandlePath(e)).attr({zIndex:7-c}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][c]).add(g);var d=b.handles;a.handles[c].attr({fill:d.backgroundColor,stroke:d.borderColor,"stroke-width":1}).css(k)})},update:function(a){v(this.series||[],function(a){a.baseSeries&&delete a.baseSeries.navigatorSeries});this.destroy();c(!0,this.chart.options.navigator,this.options,a);this.init(this.chart)},render:function(a,b,c,d){var e=
	this.chart,h,f,g=this.scrollbarHeight,n,k=this.xAxis;h=k.fake?e.xAxis[0]:k;var l=this.navigatorEnabled,m,r=this.rendered;f=e.inverted;var w=e.xAxis[0].minRange;if(!this.hasDragged||p(c)){if(!x(a)||!x(b))if(r)c=0,d=k.width;else return;this.left=q(k.left,e.plotLeft+g+(f?e.plotWidth:0));this.size=m=n=q(k.len,(f?e.plotHeight:e.plotWidth)-2*g);e=f?g:n+2*g;c=q(c,k.toPixels(a,!0));d=q(d,k.toPixels(b,!0));x(c)&&Infinity!==Math.abs(c)||(c=0,d=e);a=k.toValue(c,!0);b=k.toValue(d,!0);if(Math.abs(b-a)<w)if(this.grabbedLeft)c=
	k.toPixels(b-w,!0);else if(this.grabbedRight)d=k.toPixels(a+w,!0);else return;this.zoomedMax=Math.min(Math.max(c,d,0),m);this.zoomedMin=Math.min(Math.max(this.fixedWidth?this.zoomedMax-this.fixedWidth:Math.min(c,d),0),m);this.range=this.zoomedMax-this.zoomedMin;m=Math.round(this.zoomedMax);c=Math.round(this.zoomedMin);l&&(this.navigatorGroup.attr({visibility:"visible"}),r=r&&!this.hasDragged?"animate":"attr",this.drawMasks(c,m,f,r),this.drawOutline(c,m,f,r),this.drawHandle(c,0,f,r),this.drawHandle(m,
	1,f,r));this.scrollbar&&(f?(f=this.top-g,h=this.left-g+(l||!h.opposite?0:(h.titleOffset||0)+h.axisTitleMargin),g=n+2*g):(f=this.top+(l?this.height:-g),h=this.left-g),this.scrollbar.position(h,f,e,g),this.scrollbar.setRange(this.zoomedMin/n,this.zoomedMax/n));this.rendered=!0}},addMouseEvents:function(){var a=this,b=a.chart,c=b.container,d=[],e,g;a.mouseMoveHandler=e=function(b){a.onMouseMove(b)};a.mouseUpHandler=g=function(b){a.onMouseUp(b)};d=a.getPartsEvents("mousedown");d.push(B(c,"mousemove",
	e),B(c.ownerDocument,"mouseup",g));f&&(d.push(B(c,"touchmove",e),B(c.ownerDocument,"touchend",g)),d.concat(a.getPartsEvents("touchstart")));a.eventsToUnbind=d;a.series&&a.series[0]&&d.push(B(a.series[0].xAxis,"foundExtremes",function(){b.navigator.modifyNavigatorAxisExtremes()}))},getPartsEvents:function(a){var b=this,c=[];v(["shades","handles"],function(d){v(b[d],function(e,f){c.push(B(e.element,a,function(a){b[d+"Mousedown"](a,f)}))})});return c},shadesMousedown:function(a,b){a=this.chart.pointer.normalize(a);
	var c=this.chart,d=this.xAxis,e=this.zoomedMin,f=this.left,g=this.size,k=this.range,n=a.chartX,l;c.inverted&&(n=a.chartY,f=this.top);1===b?(this.grabbedCenter=n,this.fixedWidth=k,this.dragOffset=n-e):(a=n-f-k/2,0===b?a=Math.max(0,a):2===b&&a+k>=g&&(a=g-k,l=this.getUnionExtremes().dataMax),a!==e&&(this.fixedWidth=k,b=d.toFixedRange(a,a+k,null,l),c.xAxis[0].setExtremes(Math.min(b.min,b.max),Math.max(b.min,b.max),!0,null,{trigger:"navigator"})))},handlesMousedown:function(a,b){this.chart.pointer.normalize(a);
	a=this.chart;var c=a.xAxis[0],d=a.inverted&&!c.reversed||!a.inverted&&c.reversed;0===b?(this.grabbedLeft=!0,this.otherHandlePos=this.zoomedMax,this.fixedExtreme=d?c.min:c.max):(this.grabbedRight=!0,this.otherHandlePos=this.zoomedMin,this.fixedExtreme=d?c.max:c.min);a.fixedRange=null},onMouseMove:function(a){var b=this,c=b.chart,d=b.left,e=b.navigatorSize,f=b.range,g=b.dragOffset,k=c.inverted;a.touches&&0===a.touches[0].pageX||(a=c.pointer.normalize(a),c=a.chartX,k&&(d=b.top,c=a.chartY),b.grabbedLeft?
	(b.hasDragged=!0,b.render(0,0,c-d,b.otherHandlePos)):b.grabbedRight?(b.hasDragged=!0,b.render(0,0,b.otherHandlePos,c-d)):b.grabbedCenter&&(b.hasDragged=!0,c<g?c=g:c>e+g-f&&(c=e+g-f),b.render(0,0,c-g,c-g+f)),b.hasDragged&&b.scrollbar&&b.scrollbar.options.liveRedraw&&(a.DOMType=a.type,setTimeout(function(){b.onMouseUp(a)},0)))},onMouseUp:function(a){var b=this.chart,c=this.xAxis,d=this.scrollbar,e,f,g=a.DOMEvent||a;(!this.hasDragged||d&&d.hasDragged)&&"scrollbar"!==a.trigger||(this.zoomedMin===this.otherHandlePos?
	e=this.fixedExtreme:this.zoomedMax===this.otherHandlePos&&(f=this.fixedExtreme),this.zoomedMax===this.size&&(f=this.getUnionExtremes().dataMax),c=c.toFixedRange(this.zoomedMin,this.zoomedMax,e,f),p(c.min)&&b.xAxis[0].setExtremes(Math.min(c.min,c.max),Math.max(c.min,c.max),!0,this.hasDragged?!1:null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:g}));"mousemove"!==a.DOMType&&(this.grabbedLeft=this.grabbedRight=this.grabbedCenter=this.fixedWidth=this.fixedExtreme=this.otherHandlePos=this.hasDragged=
	this.dragOffset=null)},removeEvents:function(){this.eventsToUnbind&&(v(this.eventsToUnbind,function(a){a()}),this.eventsToUnbind=void 0);this.removeBaseSeriesEvents()},removeBaseSeriesEvents:function(){var a=this.baseSeries||[];this.navigatorEnabled&&a[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&v(a,function(a){I(a,"updatedData",this.updatedDataHandler)},this),a[0].xAxis&&I(a[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes))},init:function(a){var b=a.options,d=b.navigator,e=d.enabled,
	f=b.scrollbar,g=f.enabled,b=e?d.height:0,k=g?f.height:0;this.handles=[];this.shades=[];this.chart=a;this.setBaseSeries();this.height=b;this.scrollbarHeight=k;this.scrollbarEnabled=g;this.navigatorEnabled=e;this.navigatorOptions=d;this.scrollbarOptions=f;this.outlineHeight=b+k;this.opposite=q(d.opposite,!e&&a.inverted);var n=this,f=n.baseSeries,g=a.xAxis.length,l=a.yAxis.length,p=f&&f[0]&&f[0].xAxis||a.xAxis[0];a.extraMargin={type:n.opposite?"plotTop":"marginBottom",value:(e||!a.inverted?n.outlineHeight:
	0)+d.margin};a.inverted&&(a.extraMargin.type=n.opposite?"marginRight":"plotLeft");a.isDirtyBox=!0;n.navigatorEnabled?(n.xAxis=new G(a,c({breaks:p.options.breaks,ordinal:p.options.ordinal},d.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",isX:!0,type:"datetime",index:g,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},a.inverted?{offsets:[k,0,-k,0],width:b}:{offsets:[0,-k,0,k],height:b})),n.yAxis=new G(a,c(d.yAxis,{id:"navigator-y-axis",alignTicks:!1,
	offset:0,index:l,zoomEnabled:!1},a.inverted?{width:b}:{height:b})),f||d.series.data?n.updateNavigatorSeries():0===a.series.length&&z(a,"redraw",function(b,c){0<a.series.length&&!n.series&&(n.setBaseSeries(),a.redraw=b);b.call(a,c)}),n.renderElements(),n.addMouseEvents()):n.xAxis={translate:function(b,c){var d=a.xAxis[0],e=d.getExtremes(),f=d.len-2*k,h=A("min",d.options.min,e.dataMin),d=A("max",d.options.max,e.dataMax)-h;return c?b*d/f+h:f*(b-h)/d},toPixels:function(a){return this.translate(a)},toValue:function(a){return this.translate(a,
	!0)},toFixedRange:G.prototype.toFixedRange,fake:!0};a.options.scrollbar.enabled&&(a.scrollbar=n.scrollbar=new m(a.renderer,c(a.options.scrollbar,{margin:n.navigatorEnabled?0:10,vertical:a.inverted}),a),B(n.scrollbar,"changed",function(b){var c=n.size,d=c*this.to,c=c*this.from;n.hasDragged=n.scrollbar.hasDragged;n.render(0,0,c,d);(a.options.scrollbar.liveRedraw||"mousemove"!==b.DOMType)&&setTimeout(function(){n.onMouseUp(b)})}));n.addBaseSeriesEvents();n.addChartEvents()},getUnionExtremes:function(a){var b=
	this.chart.xAxis[0],c=this.xAxis,d=c.options,e=b.options,f;a&&null===b.dataMin||(f={dataMin:q(d&&d.min,A("min",e.min,b.dataMin,c.dataMin,c.min)),dataMax:q(d&&d.max,A("max",e.max,b.dataMax,c.dataMax,c.max))});return f},setBaseSeries:function(a){var b=this.chart,c=this.baseSeries=[];a=a||b.options&&b.options.navigator.baseSeries||0;v(b.series||[],function(b,d){b.options.isInternal||!b.options.showInNavigator&&(d!==a&&b.options.id!==a||!1===b.options.showInNavigator)||c.push(b)});this.xAxis&&!this.xAxis.fake&&
	this.updateNavigatorSeries()},updateNavigatorSeries:function(){var b=this,e=b.chart,f=b.baseSeries,g,k,l=b.navigatorOptions.series,m,p={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:!1,isInternal:!0,visible:!0},q=b.series=a.grep(b.series||[],function(c){var d=c.baseSeries;return 0>a.inArray(d,f)?(d&&(I(d,"updatedData",b.updatedDataHandler),delete d.navigatorSeries),c.destroy(),!1):!0});f&&f.length&&
	v(f,function(a,f){var h=a.navigatorSeries,n=d(l)?{}:l;h&&!1===b.navigatorOptions.adaptToUpdatedData||(p.name="Navigator "+(f+1),g=a.options||{},m=g.navigatorOptions||{},k=c(g,p,n,m),f=m.data||n.data,b.hasNavigatorData=b.hasNavigatorData||!!f,k.data=f||g.data&&g.data.slice(0),h?h.update(k):(a.navigatorSeries=e.initSeries(k),a.navigatorSeries.baseSeries=a,q.push(a.navigatorSeries)))});if(l.data&&(!f||!f.length)||d(l))b.hasNavigatorData=!1,l=a.splat(l),v(l,function(a,d){k=c({color:e.series[d]&&!e.series[d].options.isInternal&&
	e.series[d].color||e.options.colors[d]||e.options.colors[0]},a,p);k.data=a.data;k.data&&(b.hasNavigatorData=!0,q.push(e.initSeries(k)))});this.addBaseSeriesEvents()},addBaseSeriesEvents:function(){var a=this,b=a.baseSeries||[];b[0]&&b[0].xAxis&&B(b[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes);v(b,function(b){B(b,"show",function(){this.navigatorSeries&&this.navigatorSeries.show()});B(b,"hide",function(){this.navigatorSeries&&this.navigatorSeries.hide()});!1!==this.navigatorOptions.adaptToUpdatedData&&
	b.xAxis&&B(b,"updatedData",this.updatedDataHandler);B(b,"remove",function(){this.navigatorSeries&&(u(a.series,this.navigatorSeries),this.navigatorSeries.remove(!1),delete this.navigatorSeries)})},this)},modifyNavigatorAxisExtremes:function(){var a=this.xAxis,b;a.getExtremes&&(!(b=this.getUnionExtremes(!0))||b.dataMin===a.min&&b.dataMax===a.max||(a.min=b.dataMin,a.max=b.dataMax))},modifyBaseAxisExtremes:function(){var a=this.chart.navigator,b=this.getExtremes(),c=b.dataMin,d=b.dataMax,b=b.max-b.min,
	e=a.stickToMin,f=a.stickToMax,g,k,l=a.series&&a.series[0],m=!!this.setExtremes;this.eventArgs&&"rangeSelectorButton"===this.eventArgs.trigger||(e&&(k=c,g=k+b),f&&(g=d,e||(k=Math.max(g-b,l&&l.xData?l.xData[0]:-Number.MAX_VALUE))),m&&(e||f)&&x(k)&&(this.min=this.userMin=k,this.max=this.userMax=g));a.stickToMin=a.stickToMax=null},updatedDataHandler:function(){var a=this.chart.navigator,b=this.navigatorSeries;a.stickToMax=Math.round(a.zoomedMax)>=Math.round(a.size);a.stickToMin=x(this.xAxis.min)&&this.xAxis.min<=
	this.xData[0]&&(!this.chart.fixedRange||!a.stickToMax);b&&!a.hasNavigatorData&&(b.options.pointStart=this.xData[0],b.setData(this.options.data,!1,null,!1))},addChartEvents:function(){B(this.chart,"redraw",function(){var a=this.navigator,b=a&&(a.baseSeries&&a.baseSeries[0]&&a.baseSeries[0].xAxis||a.scrollbar&&this.xAxis[0]);b&&a.render(b.min,b.max)})},destroy:function(){this.removeEvents();this.xAxis&&(u(this.chart.xAxis,this.xAxis),u(this.chart.axes,this.xAxis));this.yAxis&&(u(this.chart.yAxis,this.yAxis),
	u(this.chart.axes,this.yAxis));v(this.series||[],function(a){a.destroy&&a.destroy()});v("series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" "),function(a){this[a]&&this[a].destroy&&this[a].destroy();this[a]=null},this);v([this.handles],function(a){t(a)},this)}};a.Navigator=D;z(G.prototype,"zoom",function(a,b,c){var d=this.chart,e=d.options,f=e.chart.zoomType,h=e.navigator,e=e.rangeSelector,g;this.isXAxis&&(h&&h.enabled||e&&e.enabled)&&
	("x"===f?d.resetZoomButton="blocked":"y"===f?g=!1:"xy"===f&&(d=this.previousZoom,p(b)?this.previousZoom=[this.min,this.max]:d&&(b=d[0],c=d[1],delete this.previousZoom)));return void 0!==g?g:a.call(this,b,c)});z(E.prototype,"init",function(a,b,c){B(this,"beforeRender",function(){var a=this.options;if(a.navigator.enabled||a.scrollbar.enabled)this.scroller=this.navigator=new D(this)});a.call(this,b,c)});z(E.prototype,"setChartSize",function(a){var b=this.legend,c=this.navigator,d,e,f,g;a.apply(this,
	[].slice.call(arguments,1));c&&(e=b.options,f=c.xAxis,g=c.yAxis,d=c.scrollbarHeight,this.inverted?(c.left=c.opposite?this.chartWidth-d-c.height:this.spacing[3]+d,c.top=this.plotTop+d):(c.left=this.plotLeft+d,c.top=c.navigatorOptions.top||this.chartHeight-c.height-d-this.spacing[2]-("bottom"===e.verticalAlign&&e.enabled&&!e.floating?b.legendHeight+q(e.margin,10):0)),f&&g&&(this.inverted?f.options.left=g.options.left=c.left:f.options.top=g.options.top=c.top,f.setAxisSize(),g.setAxisSize()))});z(J.prototype,
	"addPoint",function(a,b,c,d,e){var f=this.options.turboThreshold;f&&this.xData.length>f&&C(b,!0)&&this.chart.navigator&&l(20,!0);a.call(this,b,c,d,e)});z(E.prototype,"addSeries",function(a,b,c,d){a=a.call(this,b,!1,d);this.navigator&&this.navigator.setBaseSeries();q(c,!0)&&this.redraw();return a});z(J.prototype,"update",function(a,b,c){a.call(this,b,!1);this.chart.navigator&&!this.options.isInternal&&this.chart.navigator.setBaseSeries();q(c,!0)&&this.chart.redraw()});E.prototype.callbacks.push(function(a){var b=
	a.navigator;b&&(a=a.xAxis[0].getExtremes(),b.render(a.min,a.max))})})(M);(function(a){function D(a){this.init(a)}var B=a.addEvent,G=a.Axis,E=a.Chart,r=a.css,g=a.createElement,p=a.dateFormat,t=a.defaultOptions,v=t.global.useUTC,u=a.defined,l=a.destroyObjectProperties,e=a.discardElement,k=a.each,f=a.extend,d=a.fireEvent,x=a.Date,C=a.isNumber,c=a.merge,q=a.pick,I=a.pInt,m=a.splat,J=a.wrap;f(t,{rangeSelector:{buttonTheme:{"stroke-width":0,width:28,height:18,padding:2,zIndex:7},height:35,inputPosition:{align:"right"},
	labelStyle:{color:"#666666"}}});t.lang=c(t.lang,{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"From",rangeSelectorTo:"To"});D.prototype={clickButton:function(a,c){var b=this,d=b.chart,e=b.buttonOptions[a],f=d.xAxis[0],g=d.scroller&&d.scroller.getUnionExtremes()||f||{},h=g.dataMin,l=g.dataMax,p,r=f&&Math.round(Math.min(f.max,q(l,f.max))),t=e.type,u,g=e._range,z,x,D,E=e.dataGrouping;if(null!==h&&null!==l){d.fixedRange=g;E&&(this.forcedDataGrouping=!0,G.prototype.setDataGrouping.call(f||{chart:this.chart},
	E,!1));if("month"===t||"year"===t)f?(t={range:e,max:r,dataMin:h,dataMax:l},p=f.minFromRange.call(t),C(t.newMax)&&(r=t.newMax)):g=e;else if(g)p=Math.max(r-g,h),r=Math.min(p+g,l);else if("ytd"===t)if(f)void 0===l&&(h=Number.MAX_VALUE,l=Number.MIN_VALUE,k(d.series,function(a){a=a.xData;h=Math.min(a[0],h);l=Math.max(a[a.length-1],l)}),c=!1),r=b.getYTDExtremes(l,h,v),p=z=r.min,r=r.max;else{B(d,"beforeRender",function(){b.clickButton(a)});return}else"all"===t&&f&&(p=h,r=l);b.setSelected(a);f?f.setExtremes(p,
	r,q(c,1),null,{trigger:"rangeSelectorButton",rangeSelectorButton:e}):(u=m(d.options.xAxis)[0],D=u.range,u.range=g,x=u.min,u.min=z,B(d,"load",function(){u.range=D;u.min=x}))}},setSelected:function(a){this.selected=this.options.selected=a},defaultButtons:[{type:"month",count:1,text:"1m"},{type:"month",count:3,text:"3m"},{type:"month",count:6,text:"6m"},{type:"ytd",text:"YTD"},{type:"year",count:1,text:"1y"},{type:"all",text:"All"}],init:function(a){var b=this,c=a.options.rangeSelector,e=c.buttons||
	[].concat(b.defaultButtons),f=c.selected,g=function(){var a=b.minInput,c=b.maxInput;a&&a.blur&&d(a,"blur");c&&c.blur&&d(c,"blur")};b.chart=a;b.options=c;b.buttons=[];a.extraTopMargin=c.height;b.buttonOptions=e;this.unMouseDown=B(a.container,"mousedown",g);this.unResize=B(a,"resize",g);k(e,b.computeButtonRange);void 0!==f&&e[f]&&this.clickButton(f,!1);B(a,"load",function(){B(a.xAxis[0],"setExtremes",function(c){this.max-this.min!==a.fixedRange&&"rangeSelectorButton"!==c.trigger&&"updatedData"!==c.trigger&&
	b.forcedDataGrouping&&this.setDataGrouping(!1,!1)})})},updateButtonStates:function(){var a=this.chart,c=a.xAxis[0],d=Math.round(c.max-c.min),e=!c.hasVisibleSeries,a=a.scroller&&a.scroller.getUnionExtremes()||c,f=a.dataMin,g=a.dataMax,a=this.getYTDExtremes(g,f,v),l=a.min,h=a.max,m=this.selected,p=C(m),q=this.options.allButtonsEnabled,r=this.buttons;k(this.buttonOptions,function(a,b){var k=a._range,n=a.type,t=a.count||1;a=r[b];var u=0;b=b===m;var w=k>g-f,y=k<c.minRange,v=!1,A=!1,k=k===d;("month"===
	n||"year"===n)&&d>=864E5*{month:28,year:365}[n]*t&&d<=864E5*{month:31,year:366}[n]*t?k=!0:"ytd"===n?(k=h-l===d,v=!b):"all"===n&&(k=c.max-c.min>=g-f,A=!b&&p&&k);n=!q&&(w||y||A||e);k=b&&k||k&&!p&&!v;n?u=3:k&&(p=!0,u=2);a.state!==u&&a.setState(u)})},computeButtonRange:function(a){var b=a.type,c=a.count||1,d={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5};if(d[b])a._range=d[b]*c;else if("month"===b||"year"===b)a._range=864E5*{month:30,year:365}[b]*c},setInputValue:function(a,c){var b=
	this.chart.options.rangeSelector,d=this[a+"Input"];u(c)&&(d.previousValue=d.HCTime,d.HCTime=c);d.value=p(b.inputEditDateFormat||"%Y-%m-%d",d.HCTime);this[a+"DateBox"].attr({text:p(b.inputDateFormat||"%b %e, %Y",d.HCTime)})},showInput:function(a){var b=this.inputGroup,c=this[a+"DateBox"];r(this[a+"Input"],{left:b.translateX+c.x+"px",top:b.translateY+"px",width:c.width-2+"px",height:c.height-2+"px",border:"2px solid silver"})},hideInput:function(a){r(this[a+"Input"],{border:0,width:"1px",height:"1px"});
	this.setInputValue(a)},drawInput:function(a){function b(){var a=q.value,b=(m.inputDateParser||Date.parse)(a),c=e.xAxis[0],f=e.scroller&&e.scroller.xAxis?e.scroller.xAxis:c,h=f.dataMin,f=f.dataMax;b!==q.previousValue&&(q.previousValue=b,C(b)||(b=a.split("-"),b=Date.UTC(I(b[0]),I(b[1])-1,I(b[2]))),C(b)&&(v||(b+=6E4*(new Date).getTimezoneOffset()),p?b>d.maxInput.HCTime?b=void 0:b<h&&(b=h):b<d.minInput.HCTime?b=void 0:b>f&&(b=f),void 0!==b&&c.setExtremes(p?b:c.min,p?c.max:b,void 0,void 0,{trigger:"rangeSelectorInput"})))}
	var d=this,e=d.chart,k=e.renderer.style||{},l=e.renderer,m=e.options.rangeSelector,h=d.div,p="min"===a,q,u,x=this.inputGroup;this[a+"Label"]=u=l.label(t.lang[p?"rangeSelectorFrom":"rangeSelectorTo"],this.inputGroup.offset).addClass("highcharts-range-label").attr({padding:2}).add(x);x.offset+=u.width+5;this[a+"DateBox"]=l=l.label("",x.offset).addClass("highcharts-range-input").attr({padding:2,width:m.inputBoxWidth||90,height:m.inputBoxHeight||17,stroke:m.inputBoxBorderColor||"#cccccc","stroke-width":1,
	"text-align":"center"}).on("click",function(){d.showInput(a);d[a+"Input"].focus()}).add(x);x.offset+=l.width+(p?10:0);this[a+"Input"]=q=g("input",{name:a,className:"highcharts-range-selector",type:"text"},{top:e.plotTop+"px"},h);u.css(c(k,m.labelStyle));l.css(c({color:"#333333"},k,m.inputStyle));r(q,f({position:"absolute",border:0,width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:k.fontSize,fontFamily:k.fontFamily,left:"-9em"},m.inputStyle));q.onfocus=function(){d.showInput(a)};q.onblur=
	function(){d.hideInput(a)};q.onchange=b;q.onkeypress=function(a){13===a.keyCode&&b()}},getPosition:function(){var a=this.chart,c=a.options.rangeSelector,a=q((c.buttonPosition||{}).y,a.plotTop-a.axisOffset[0]-c.height);return{buttonTop:a,inputTop:a-10}},getYTDExtremes:function(a,c,d){var b=new x(a),e=b[x.hcGetFullYear]();d=d?x.UTC(e,0,1):+new x(e,0,1);c=Math.max(c||0,d);b=b.getTime();return{max:Math.min(a||b,b),min:c}},render:function(a,c){var b=this,d=b.chart,e=d.renderer,l=d.container,m=d.options,
	h=m.exporting&&!1!==m.exporting.enabled&&m.navigation&&m.navigation.buttonOptions,p=m.rangeSelector,r=b.buttons,m=t.lang,v=b.div,v=b.inputGroup,z=p.buttonTheme,x=p.buttonPosition||{},B=p.inputEnabled,F=z&&z.states,C=d.plotLeft,D,E=this.getPosition(),G=b.group,I=b.rendered;!1!==p.enabled&&(I||(b.group=G=e.g("range-selector-buttons").add(),b.zoomText=e.text(m.rangeSelectorZoom,q(x.x,C),15).css(p.labelStyle).add(G),D=q(x.x,C)+b.zoomText.getBBox().width+5,k(b.buttonOptions,function(a,c){r[c]=e.button(a.text,
	D,0,function(){b.clickButton(c);b.isActive=!0},z,F&&F.hover,F&&F.select,F&&F.disabled).attr({"text-align":"center"}).add(G);D+=r[c].width+q(p.buttonSpacing,5)}),!1!==B&&(b.div=v=g("div",null,{position:"relative",height:0,zIndex:1}),l.parentNode.insertBefore(v,l),b.inputGroup=v=e.g("input-group").add(),v.offset=0,b.drawInput("min"),b.drawInput("max"))),b.updateButtonStates(),G[I?"animate":"attr"]({translateY:E.buttonTop}),!1!==B&&(v.align(f({y:E.inputTop,width:v.offset,x:h&&E.inputTop<(h.y||0)+h.height-
	d.spacing[0]?-40:0},p.inputPosition),!0,d.spacingBox),u(B)||(d=G.getBBox(),v[v.alignAttr.translateX<d.x+d.width+10?"hide":"show"]()),b.setInputValue("min",a),b.setInputValue("max",c)),b.rendered=!0)},update:function(a){var b=this.chart;c(!0,b.options.rangeSelector,a);this.destroy();this.init(b)},destroy:function(){var b=this,c=b.minInput,d=b.maxInput;b.unMouseDown();b.unResize();l(b.buttons);c&&(c.onfocus=c.onblur=c.onchange=null);d&&(d.onfocus=d.onblur=d.onchange=null);a.objectEach(b,function(a,
	c){a&&"chart"!==c&&(a.destroy?a.destroy():a.nodeType&&e(this[c]));a!==D.prototype[c]&&(b[c]=null)},this)}};G.prototype.toFixedRange=function(a,c,d,e){var b=this.chart&&this.chart.fixedRange;a=q(d,this.translate(a,!0,!this.horiz));c=q(e,this.translate(c,!0,!this.horiz));d=b&&(c-a)/b;.7<d&&1.3>d&&(e?a=c-b:c=a+b);C(a)||(a=c=void 0);return{min:a,max:c}};G.prototype.minFromRange=function(){var a=this.range,c={month:"Month",year:"FullYear"}[a.type],d,e=this.max,f,g,k=function(a,b){var d=new Date(a),e=d["get"+
	c]();d["set"+c](e+b);e===d["get"+c]()&&d.setDate(0);return d.getTime()-a};C(a)?(d=e-a,g=a):(d=e+k(e,-a.count),this.chart&&(this.chart.fixedRange=e-d));f=q(this.dataMin,Number.MIN_VALUE);C(d)||(d=f);d<=f&&(d=f,void 0===g&&(g=k(d,a.count)),this.newMax=Math.min(d+g,this.dataMax));C(e)||(d=void 0);return d};J(E.prototype,"init",function(a,c,d){B(this,"init",function(){this.options.rangeSelector.enabled&&(this.rangeSelector=new D(this))});a.call(this,c,d)});E.prototype.callbacks.push(function(a){function b(){c=
	a.xAxis[0].getExtremes();C(c.min)&&d.render(c.min,c.max)}var c,d=a.rangeSelector,e,f;d&&(f=B(a.xAxis[0],"afterSetExtremes",function(a){d.render(a.min,a.max)}),e=B(a,"redraw",b),b());B(a,"destroy",function(){d&&(e(),f())})});a.RangeSelector=D})(M);(function(a){var D=a.arrayMax,B=a.arrayMin,G=a.Axis,E=a.Chart,r=a.defined,g=a.each,p=a.extend,t=a.format,v=a.grep,u=a.inArray,l=a.isNumber,e=a.isString,k=a.map,f=a.merge,d=a.pick,x=a.Point,C=a.Renderer,c=a.Series,q=a.splat,I=a.SVGRenderer,m=a.VMLRenderer,
	J=a.wrap,b=c.prototype,z=b.init,K=b.processData,y=x.prototype.tooltipFormatter;a.StockChart=a.stockChart=function(b,c,g){var h=e(b)||b.nodeName,l=arguments[h?1:0],n=l.series,m=a.getOptions(),p,r=d(l.navigator&&l.navigator.enabled,m.navigator.enabled,!0),t=r?{startOnTick:!1,endOnTick:!1}:null,u={marker:{enabled:!1,radius:2}},v={shadow:!1,borderWidth:0};l.xAxis=k(q(l.xAxis||{}),function(a){return f({minPadding:0,maxPadding:0,ordinal:!0,title:{text:null},labels:{overflow:"justify"},showLastLabel:!0},
	m.xAxis,a,{type:"datetime",categories:null},t)});l.yAxis=k(q(l.yAxis||{}),function(a){p=d(a.opposite,!0);return f({labels:{y:-2},opposite:p,showLastLabel:!1,title:{text:null}},m.yAxis,a)});l.series=null;l=f({chart:{panning:!0,pinchType:"x"},navigator:{enabled:r},scrollbar:{enabled:d(m.scrollbar.enabled,!0)},rangeSelector:{enabled:d(m.rangeSelector.enabled,!0)},title:{text:null},tooltip:{shared:!0,crosshairs:!0},legend:{enabled:!1},plotOptions:{line:u,spline:u,area:u,areaspline:u,arearange:u,areasplinerange:u,
	column:v,columnrange:v,candlestick:v,ohlc:v}},l,{isStock:!0});l.series=n;return h?new E(b,l,g):new E(l,c)};J(G.prototype,"autoLabelAlign",function(a){var b=this.chart,c=this.options,b=b._labelPanes=b._labelPanes||{},d=this.options.labels;return this.chart.options.isStock&&"yAxis"===this.coll&&(c=c.top+","+c.height,!b[c]&&d.enabled)?(15===d.x&&(d.x=0),void 0===d.align&&(d.align="right"),b[c]=this,"right"):a.apply(this,[].slice.call(arguments,1))});J(G.prototype,"destroy",function(a){var b=this.chart,
	c=this.options&&this.options.top+","+this.options.height;c&&b._labelPanes&&b._labelPanes[c]===this&&delete b._labelPanes[c];return a.apply(this,Array.prototype.slice.call(arguments,1))});J(G.prototype,"getPlotLinePath",function(b,c,f,h,m,p){var n=this,q=this.isLinked&&!this.series?this.linkedParent.series:this.series,t=n.chart,v=t.renderer,w=n.left,y=n.top,x,A,z,B,C=[],D=[],E,H;if("xAxis"!==n.coll&&"yAxis"!==n.coll)return b.apply(this,[].slice.call(arguments,1));D=function(a){var b="xAxis"===a?"yAxis":
	"xAxis";a=n.options[b];return l(a)?[t[b][a]]:e(a)?[t.get(a)]:k(q,function(a){return a[b]})}(n.coll);g(n.isXAxis?t.yAxis:t.xAxis,function(a){if(r(a.options.id)?-1===a.options.id.indexOf("navigator"):1){var b=a.isXAxis?"yAxis":"xAxis",b=r(a.options[b])?t[b][a.options[b]]:t[b][0];n===b&&D.push(a)}});E=D.length?[]:[n.isXAxis?t.yAxis[0]:t.xAxis[0]];g(D,function(b){-1!==u(b,E)||a.find(E,function(a){return a.pos===b.pos&&a.len&&b.len})||E.push(b)});H=d(p,n.translate(c,null,null,h));l(H)&&(n.horiz?g(E,function(a){var b;
	A=a.pos;B=A+a.len;x=z=Math.round(H+n.transB);if(x<w||x>w+n.width)m?x=z=Math.min(Math.max(w,x),w+n.width):b=!0;b||C.push("M",x,A,"L",z,B)}):g(E,function(a){var b;x=a.pos;z=x+a.len;A=B=Math.round(y+n.height-H);if(A<y||A>y+n.height)m?A=B=Math.min(Math.max(y,A),n.top+n.height):b=!0;b||C.push("M",x,A,"L",z,B)}));return 0<C.length?v.crispPolyLine(C,f||1):null});G.prototype.getPlotBandPath=function(a,b){b=this.getPlotLinePath(b,null,null,!0);a=this.getPlotLinePath(a,null,null,!0);var c=[],d;if(a&&b)if(a.toString()===
	b.toString())c=a,c.flat=!0;else for(d=0;d<a.length;d+=6)c.push("M",a[d+1],a[d+2],"L",a[d+4],a[d+5],b[d+4],b[d+5],b[d+1],b[d+2],"z");else c=null;return c};I.prototype.crispPolyLine=function(a,b){var c;for(c=0;c<a.length;c+=6)a[c+1]===a[c+4]&&(a[c+1]=a[c+4]=Math.round(a[c+1])-b%2/2),a[c+2]===a[c+5]&&(a[c+2]=a[c+5]=Math.round(a[c+2])+b%2/2);return a};C===m&&(m.prototype.crispPolyLine=I.prototype.crispPolyLine);J(G.prototype,"hideCrosshair",function(a,b){a.call(this,b);this.crossLabel&&(this.crossLabel=
	this.crossLabel.hide())});J(G.prototype,"drawCrosshair",function(a,b,c){var e,f;a.call(this,b,c);if(r(this.crosshair.label)&&this.crosshair.label.enabled&&this.cross){a=this.chart;var g=this.options.crosshair.label,k=this.horiz;e=this.opposite;f=this.left;var l=this.top,m=this.crossLabel,n,q=g.format,u="",v="inside"===this.options.tickPosition,x=!1!==this.crosshair.snap,y=0;b||(b=this.cross&&this.cross.e);n=k?"center":e?"right"===this.labelAlign?"right":"left":"left"===this.labelAlign?"left":"center";
	m||(m=this.crossLabel=a.renderer.label(null,null,null,g.shape||"callout").addClass("highcharts-crosshair-label"+(this.series[0]&&" highcharts-color-"+this.series[0].colorIndex)).attr({align:g.align||n,padding:d(g.padding,8),r:d(g.borderRadius,3),zIndex:2}).add(this.labelGroup),m.attr({fill:g.backgroundColor||this.series[0]&&this.series[0].color||"#666666",stroke:g.borderColor||"","stroke-width":g.borderWidth||0}).css(p({color:"#ffffff",fontWeight:"normal",fontSize:"11px",textAlign:"center"},g.style)));
	k?(n=x?c.plotX+f:b.chartX,l+=e?0:this.height):(n=e?this.width+f:0,l=x?c.plotY+l:b.chartY);q||g.formatter||(this.isDatetimeAxis&&(u="%b %d, %Y"),q="{value"+(u?":"+u:"")+"}");b=x?c[this.isXAxis?"x":"y"]:this.toValue(k?b.chartX:b.chartY);m.attr({text:q?t(q,{value:b}):g.formatter.call(this,b),x:n,y:l,visibility:"visible"});b=m.getBBox();if(k){if(v&&!e||!v&&e)l=m.y-b.height}else l=m.y-b.height/2;k?(e=f-b.x,f=f+this.width-b.x):(e="left"===this.labelAlign?f:0,f="right"===this.labelAlign?f+this.width:a.chartWidth);
	m.translateX<e&&(y=e-m.translateX);m.translateX+b.width>=f&&(y=-(m.translateX+b.width-f));m.attr({x:n+y,y:l,anchorX:k?n:this.opposite?0:a.chartWidth,anchorY:k?this.opposite?a.chartHeight:0:l+b.height/2})}});b.init=function(){z.apply(this,arguments);this.setCompare(this.options.compare)};b.setCompare=function(a){this.modifyValue="value"===a||"percent"===a?function(b,c){var d=this.compareValue;if(void 0!==b&&void 0!==d)return b="value"===a?b-d:b/d*100-(100===this.options.compareBase?0:100),c&&(c.change=
	b),b}:null;this.userOptions.compare=a;this.chart.hasRendered&&(this.isDirty=!0)};b.processData=function(){var a,b=-1,c,d,e,f;K.apply(this,arguments);if(this.xAxis&&this.processedYData)for(c=this.processedXData,d=this.processedYData,e=d.length,this.pointArrayMap&&(b=u("close",this.pointArrayMap),-1===b&&(b=u(this.pointValKey||"y",this.pointArrayMap))),a=0;a<e-1;a++)if(f=d[a]&&-1<b?d[a][b]:d[a],l(f)&&c[a+1]>=this.xAxis.min&&0!==f){this.compareValue=f;break}};J(b,"getExtremes",function(a){var b;a.apply(this,
	[].slice.call(arguments,1));this.modifyValue&&(b=[this.modifyValue(this.dataMin),this.modifyValue(this.dataMax)],this.dataMin=B(b),this.dataMax=D(b))});G.prototype.setCompare=function(a,b){this.isXAxis||(g(this.series,function(b){b.setCompare(a)}),d(b,!0)&&this.chart.redraw())};x.prototype.tooltipFormatter=function(b){b=b.replace("{point.change}",(0<this.change?"+":"")+a.numberFormat(this.change,d(this.series.tooltipOptions.changeDecimals,2)));return y.apply(this,[b])};J(c.prototype,"render",function(a){this.chart.is3d&&
	this.chart.is3d()||this.chart.polar||!this.xAxis||this.xAxis.isRadial||(!this.clipBox&&this.animate?(this.clipBox=f(this.chart.clipBox),this.clipBox.width=this.xAxis.len,this.clipBox.height=this.yAxis.len):this.chart[this.sharedClipKey]?this.chart[this.sharedClipKey].attr({width:this.xAxis.len,height:this.yAxis.len}):this.clipBox&&(this.clipBox.width=this.xAxis.len,this.clipBox.height=this.yAxis.len));a.call(this)});J(E.prototype,"getSelectedPoints",function(a){var b=a.call(this);g(this.series,function(a){a.hasGroupedData&&
	(b=b.concat(v(a.points||[],function(a){return a.selected})))});return b});J(E.prototype,"update",function(a,b){"scrollbar"in b&&this.navigator&&(f(!0,this.options.scrollbar,b.scrollbar),this.navigator.update({},!1),delete b.scrollbar);return a.apply(this,Array.prototype.slice.call(arguments,1))})})(M);return M});


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on
	 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number,
	 *  else `false`.
	 * @example
	 *
	 * _.isFinite(3);
	 * // => true
	 *
	 * _.isFinite(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 *
	 * _.isFinite('3');
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 18,
		"./af.js": 18,
		"./ar": 25,
		"./ar-dz": 19,
		"./ar-dz.js": 19,
		"./ar-kw": 20,
		"./ar-kw.js": 20,
		"./ar-ly": 21,
		"./ar-ly.js": 21,
		"./ar-ma": 22,
		"./ar-ma.js": 22,
		"./ar-sa": 23,
		"./ar-sa.js": 23,
		"./ar-tn": 24,
		"./ar-tn.js": 24,
		"./ar.js": 25,
		"./az": 26,
		"./az.js": 26,
		"./be": 27,
		"./be.js": 27,
		"./bg": 28,
		"./bg.js": 28,
		"./bn": 29,
		"./bn.js": 29,
		"./bo": 30,
		"./bo.js": 30,
		"./br": 31,
		"./br.js": 31,
		"./bs": 32,
		"./bs.js": 32,
		"./ca": 33,
		"./ca.js": 33,
		"./cs": 34,
		"./cs.js": 34,
		"./cv": 35,
		"./cv.js": 35,
		"./cy": 36,
		"./cy.js": 36,
		"./da": 37,
		"./da.js": 37,
		"./de": 40,
		"./de-at": 38,
		"./de-at.js": 38,
		"./de-ch": 39,
		"./de-ch.js": 39,
		"./de.js": 40,
		"./dv": 41,
		"./dv.js": 41,
		"./el": 42,
		"./el.js": 42,
		"./en-au": 43,
		"./en-au.js": 43,
		"./en-ca": 44,
		"./en-ca.js": 44,
		"./en-gb": 45,
		"./en-gb.js": 45,
		"./en-ie": 46,
		"./en-ie.js": 46,
		"./en-nz": 47,
		"./en-nz.js": 47,
		"./eo": 48,
		"./eo.js": 48,
		"./es": 50,
		"./es-do": 49,
		"./es-do.js": 49,
		"./es.js": 50,
		"./et": 51,
		"./et.js": 51,
		"./eu": 52,
		"./eu.js": 52,
		"./fa": 53,
		"./fa.js": 53,
		"./fi": 54,
		"./fi.js": 54,
		"./fo": 55,
		"./fo.js": 55,
		"./fr": 58,
		"./fr-ca": 56,
		"./fr-ca.js": 56,
		"./fr-ch": 57,
		"./fr-ch.js": 57,
		"./fr.js": 58,
		"./fy": 59,
		"./fy.js": 59,
		"./gd": 60,
		"./gd.js": 60,
		"./gl": 61,
		"./gl.js": 61,
		"./gom-latn": 62,
		"./gom-latn.js": 62,
		"./he": 63,
		"./he.js": 63,
		"./hi": 64,
		"./hi.js": 64,
		"./hr": 65,
		"./hr.js": 65,
		"./hu": 66,
		"./hu.js": 66,
		"./hy-am": 67,
		"./hy-am.js": 67,
		"./id": 68,
		"./id.js": 68,
		"./is": 69,
		"./is.js": 69,
		"./it": 70,
		"./it.js": 70,
		"./ja": 71,
		"./ja.js": 71,
		"./jv": 72,
		"./jv.js": 72,
		"./ka": 73,
		"./ka.js": 73,
		"./kk": 74,
		"./kk.js": 74,
		"./km": 75,
		"./km.js": 75,
		"./kn": 76,
		"./kn.js": 76,
		"./ko": 77,
		"./ko.js": 77,
		"./ky": 78,
		"./ky.js": 78,
		"./lb": 79,
		"./lb.js": 79,
		"./lo": 80,
		"./lo.js": 80,
		"./lt": 81,
		"./lt.js": 81,
		"./lv": 82,
		"./lv.js": 82,
		"./me": 83,
		"./me.js": 83,
		"./mi": 84,
		"./mi.js": 84,
		"./mk": 85,
		"./mk.js": 85,
		"./ml": 86,
		"./ml.js": 86,
		"./mr": 87,
		"./mr.js": 87,
		"./ms": 89,
		"./ms-my": 88,
		"./ms-my.js": 88,
		"./ms.js": 89,
		"./my": 90,
		"./my.js": 90,
		"./nb": 91,
		"./nb.js": 91,
		"./ne": 92,
		"./ne.js": 92,
		"./nl": 94,
		"./nl-be": 93,
		"./nl-be.js": 93,
		"./nl.js": 94,
		"./nn": 95,
		"./nn.js": 95,
		"./pa-in": 96,
		"./pa-in.js": 96,
		"./pl": 97,
		"./pl.js": 97,
		"./pt": 99,
		"./pt-br": 98,
		"./pt-br.js": 98,
		"./pt.js": 99,
		"./ro": 100,
		"./ro.js": 100,
		"./ru": 101,
		"./ru.js": 101,
		"./sd": 102,
		"./sd.js": 102,
		"./se": 103,
		"./se.js": 103,
		"./si": 104,
		"./si.js": 104,
		"./sk": 105,
		"./sk.js": 105,
		"./sl": 106,
		"./sl.js": 106,
		"./sq": 107,
		"./sq.js": 107,
		"./sr": 109,
		"./sr-cyrl": 108,
		"./sr-cyrl.js": 108,
		"./sr.js": 109,
		"./ss": 110,
		"./ss.js": 110,
		"./sv": 111,
		"./sv.js": 111,
		"./sw": 112,
		"./sw.js": 112,
		"./ta": 113,
		"./ta.js": 113,
		"./te": 114,
		"./te.js": 114,
		"./tet": 115,
		"./tet.js": 115,
		"./th": 116,
		"./th.js": 116,
		"./tl-ph": 117,
		"./tl-ph.js": 117,
		"./tlh": 118,
		"./tlh.js": 118,
		"./tr": 119,
		"./tr.js": 119,
		"./tzl": 120,
		"./tzl.js": 120,
		"./tzm": 122,
		"./tzm-latn": 121,
		"./tzm-latn.js": 121,
		"./tzm.js": 122,
		"./uk": 123,
		"./uk.js": 123,
		"./ur": 124,
		"./ur.js": 124,
		"./uz": 126,
		"./uz-latn": 125,
		"./uz-latn.js": 125,
		"./uz.js": 126,
		"./vi": 127,
		"./vi.js": 127,
		"./x-pseudo": 128,
		"./x-pseudo.js": 128,
		"./yo": 129,
		"./yo.js": 129,
		"./zh-cn": 130,
		"./zh-cn.js": 130,
		"./zh-hk": 131,
		"./zh-hk.js": 131,
		"./zh-tw": 132,
		"./zh-tw.js": 132
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 168;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
	O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
	function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
	function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
	ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
	d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
	var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
	Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// custom-data-chart-wsj-0.8.28.min.js